(function() {
  'use strict';

  angular.module('projects', [
    'core',
    'charts'
  ]);
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "PROJECT_TYPES", "STATEMENTS"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider, PROJECT_TYPES, STATEMENTS) {
    $stateProvider
      .state('project.documents.statements', {
        url: '/statements?pageSize&sortOrder&sortModel&keyword&statementId&status&source',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/documents/statements/statements.html',
            controller: 'StatementsController as $ctrl'
          }
        },
        data: {
          projectType: PROJECT_TYPES.FORENSIC
        },
        resolve: {
          statements: ["$stateParams", "Statements", function($stateParams, Statements) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            // Set Default sort params
            if(!$stateParamsClone.status) {
              $stateParamsClone.status = 'all-files';
            }
            if( !$stateParamsClone.source ) {
              $stateParamsClone.source = STATEMENTS.SOURCE.BANK_PDF;
            }
            if(!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'createdAt';
              $stateParamsClone.sortOrder = 'desc';
            }
            var params = {projectId: $stateParamsClone.projectId, downloadUrl: true, $limit: 5000};
            params.source = $stateParamsClone.source;
            if($stateParamsClone.status !== 'all-files') {
              params.status = $stateParamsClone.status;
            }
            return Statements.findAll(params, {bypassCache: true});
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  StatementsController.$inject = ["$state", "STATEMENTS", "statements", "Statements"];
  angular
    .module('projects')
    .controller('StatementsController', StatementsController);

  function StatementsController(
    $state,
    STATEMENTS,
    statements,
    Statements) {
    var vm = this;
    vm.statements = statements;
    vm.title = STATEMENTS.SOURCE_DESCRIPTION[$state.params.source];
    vm.statusInfo = Statements.getMetadata().statusInfo;
    vm.projectType = $state.current.data.projectType;
  }
})();

(function() {
  'use strict';

  Statements.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('projects')
    .factory('Statements', Statements);

  function Statements(DS, DSHttpAdapter) {
    var metadata;
    var statements = DS.defineResource({
      name: 'statements',
      endpoint: 'statements',
      idAttribute: 'id',
      // TODO once JSData can handle metadata remove this
      cacheResponse: false,
      deserialize: function(config, res) {
        if(res.data.metadata) {
          metadata = res.data.metadata;
        }
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    statements.getMetadata = function() {
      return metadata;
    };

    statements.extractStatements = function(data, params) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/statement/extraction',
        data,
        { params: params }
      );
    };

    statements.removeMultipleStatements = function(statementIds, projectId) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/statements/batch',
        { statementIds: statementIds },
        { params: { projectId: projectId} }
      );
    };

    return statements;
  }
})();

(function() {
  'use strict';

  StatementsListTableController.$inject = ["$scope", "$filter", "$state", "$stateParams", "tableUtils", "Statements", "Authorization", "Documents", "$mdDialog", "toastr", "Projects", "PROJECT_TYPES", "STATEMENTS", "CHECK_ITEMS", "RBAC"];
  angular
    .module('projects')
    .component('statementsListTable', {
      templateUrl: 'app/projects/project/documents/statements/statements-list.html',
      bindings: {
        statements: '<',
        statusInfo: '<',
        type: '@'
      },
      controller: StatementsListTableController
    });

  function StatementsListTableController(
    $scope,
    $filter,
    $state,
    $stateParams,
    tableUtils,
    Statements,
    Authorization,
    Documents,
    $mdDialog,
    toastr,
    Projects,
    PROJECT_TYPES,
    STATEMENTS,
    CHECK_ITEMS,
    RBAC) {

    var vm = this;
    var GRID_ID = 'grid-statements';
    var GRID_VERSION = 3;
    vm.selectedStatements = [];
    vm.selectAll = selectAll;
    vm.exportToCsv = exportToCsv;
    vm.toFileTab = toFileTab;
    vm.toItemTab = toItemTab;
    vm.deleteStatements = deleteStatements;

    var exportParams = {
      fileName: _getExportName(),
      columnKeys: ['id', 'document.fileName', 'status',  'description', 'document.createdAt', 'document.size', 'pages', 'metrics.loadedTransactions', 'processedDate', 'document.uploadUser'],
      processCellCallback: exportCSVFormatCells
    };

    this.$onInit = function() {
      vm.hasPermissions = Authorization.hasProjectAccess(vm.type, $state.params.projectId, [RBAC.ROLES.ENGAGEMENT_OWNER, RBAC.ROLES.ENGAGEMENT_USER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
      vm.status = $state.params.status;
      vm.source = $state.params.source;
      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.columnDefs = [
        {
          headerName: 'Select',
          field: 'selected',
          checkboxSelection: function(params) {
            return params.data.status === STATEMENTS.STATUS.REJECTED || params.data.status === STATEMENTS.STATUS.UPLOADED;
          },
          width: 70,
          pinned: 'left',
          hide: vm.status === STATEMENTS.STATUS.EXTRACTING || !vm.hasPermissions,
          suppressColumnsToolPanel: vm.status === STATEMENTS.STATUS.EXTRACTING || !vm.hasPermissions,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 200,
          hide: true,
        },
        {
          headerName: 'Filename',
          field: 'document.fileName',
          comparator: filenameComparator,
          width: 400,
          cellRenderer: function(params) {
            return '<a class="file-name" target="_blank" href="' + params.data.downloadUrl + '">' + $filter('filenameDisplay')(params.value) + '</a>';
          }
        },
        {
          headerName: 'Status',
          field: 'status',
          width: 100,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('statementStatusDisplay')(params.value);
          }
        },
        {
          headerName: 'Notes',
          field: 'description',
          width: 400
        },
        {
          headerName: 'Upload Date',
          field: 'document.createdAt',
          width: 200,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('dateTimeFilter')(params.value);
          }
        },
        {
          headerName: 'Size',
          field: 'document.size',
          width: 100,
          comparator: sizeComparator,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('fileSizeDisplay')(params.value);
          }
        },
        {
          headerName: 'Source',
          field: 'source',
          width: 200,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('statementSourceDisplay')(params.value);
          }
        },
        {
          headerName: 'Pages',
          field: 'pages',
          width: 100,
          comparator: sizeComparator,
          valueFormatter: function(params) {
            return $filter('number')(params.value);
          }
        },
        {
          headerName: 'Txn Qty',
          field: 'metrics.loadedTransactions',
          width: 100,
          valueFormatter: function(params) {
            return $filter('number')(params.value);
          }
        },
        {
          headerName: 'Completed Processing Date',
          field: 'processedDate',
          width: 250,
          valueFormatter: function(params) {
            if(!params.value) {
              return '';
            }
            return $filter('dateTimeFilter')(params.value);
          }
        },
        {
          headerName: 'Upload User',
          field: 'document.uploadUser',
          width: 250,
        },
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        rowSelection: 'multiple',
        defaultColDef: tableUtils.getDefaultColDefs(),
        getMainMenuItems: tableUtils.getMainMenuItems,
        rowData: vm.statements,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        onRowSelected: _toggleRowSelected,
        suppressRowClickSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        groupUseEntireRow: true,
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange
      };
    };

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID, GRID_VERSION);
      if(!tableUtils.getGridState(GRID_ID, GRID_VERSION)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID, GRID_VERSION);
    }

    function filenameComparator(file1, file2) {
      if(!file1) {
        return -1;
      }
      if(!file2) {
        return 1;
      }
      var formatted1 = $filter('filenameDisplay')(file1).toLowerCase();
      var formatted2 = $filter('filenameDisplay')(file2).toLowerCase();
      return formatted1 > formatted2 ? 1 : -1;
    }

    function sizeComparator(size1, size2) {
      if(!size1 || isNaN(size1)) {
        return -1;
      }
      if(!size2 || isNaN(size2)) {
        return 1;
      }
      return size1 - size2;
    }

    function selectAll() {
      var selectedRows = vm.gridOptions.api.getSelectedRows();
      if (selectedRows.length) {
        vm.gridOptions.api.deselectAll();
      } else {
        vm.gridOptions.api.forEachNodeAfterFilter(function(node) {
          if(node.data.status === STATEMENTS.STATUS.REJECTED) {
            node.setSelected(true);
          }
        });
      }
    }

    function exportToCsv() {
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'document.fileName') {
          return $filter('filenameDisplay')(params.value);
        } else if (params.column.colId === 'document.createdAt' || params.column.colId === 'processedDate') {
          return $filter('dateTimeFilter')(params.value);
        } else if (params.column.colId === 'document.size') {
          return $filter('fileSizeDisplay')(params.value);
        } else if (params.column.colId === 'status') {
          return $filter('statementStatusDisplay')(params.value);
        } else {
          return params.value;
        }
      } else {
        return params.value;
      }
    }

    function deleteStatements() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/documents/statements/delete-statements-dialog.html',
        controller: 'DeleteStatementsController',
        locals: {
          selectedStatements: vm.selectedStatements
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success(shouldReload) {
        if(shouldReload) {
          vm.reloadData();
        } else if (vm.gridOptions.api) {
          vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        }
      });
    }

    function _toggleRowSelected() {
      vm.selectedStatements = vm.gridOptions.api.getSelectedRows();
      $scope.$applyAsync();
    }

    function toFileTab(status) {
      if(vm.status === status) {
        return;
      }
      $state.go($state.current, { status: status, source: vm.source }, {reload: true});
    }

    function toItemTab(status) {
      if(vm.status === status) {
        return;
      }
      if(vm.source === STATEMENTS.SOURCE.CHECKS_PDF) {
        var state = _getCheckItemState();
        $state.go(state, {status: status});
      } else {
        $state.go(_getPeriodState(), {status: status, source: vm.source});
      }
    }

    function _getPeriodState() {
      var state = 'project.account-periods';
      if(vm.type === PROJECT_TYPES.AUDIT) {
        state = 'engagement.account-periods';
      }
      return state;
    }

    function _getCheckItemState() {
      var state = 'project.check-items';
      if(vm.type === PROJECT_TYPES.AUDIT) {
        state = 'engagement.check-items';
      }
      return state;
    }

    function _getExportName() {
      var project = Projects.get($state.params.projectId);
      var name = '';
      if(project) {
        name = project.name;
      }
      return name + '_Statements_' + moment().format('MMYYYY') + '.csv';
    }
  }
})();

(function() {
  'use strict';

  angular.module('categorization', [
    'core'
  ]);
})();

(function() {
  'use strict';

  LoadStatement.$inject = ["$mdDialog", "$state", "Documents", "STATEMENTS", "Authorization", "RBAC"];
  angular
    .module('categorization')
    .component('loadStatement', {
      templateUrl: 'app/projects/project/documents/statements/load-statement.html',
      bindings: {
        source: '@',
        type: '@',
        onSave: '&'
      },
      controller: LoadStatement
    });

  function LoadStatement(
    $mdDialog,
    $state,
    Documents,
    STATEMENTS,
    Authorization,
    RBAC) {

    var vm = this;
    vm.load = load;

    this.$onInit = function() {
      vm.hasPermissions = Authorization.hasProjectAccess(vm.type, $state.params.projectId, [RBAC.ROLES.ENGAGEMENT_OWNER, RBAC.ROLES.ENGAGEMENT_USER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
    };

    function load() {
      Documents.getUploadParameters($state.params.projectId).then(
        function Success(response) {
          _openUploadDialog(response.data);
        })
        .catch(function Failure(response) {
          _failure(response.data.message);
        });
    }

    function _openUploadDialog(uploadParameters) {
      var templateUrl = 'app/projects/project/documents/statements/add-statements.html';
      var controller = 'AddStatementsController';

      var locals = {
        uploadParameters: uploadParameters,
        source: vm.source,
        type: vm.type
      };

      if(vm.source === STATEMENTS.SOURCE.TXN_CSV) {
        templateUrl = 'app/projects/project/documents/statements/add-csv-statement.html';
        controller = 'AddCsvStatementController';
      }
      if(vm.source === STATEMENTS.SOURCE.CHECKS_PDF) {
        templateUrl = 'app/projects/project/documents/statements/add-check-files.html';
        controller = 'AddCheckFilesController';
      }

      $mdDialog.show({
        templateUrl: templateUrl,
        controller: controller,
        controllerAs: '$ctrl',
        bindToController: true,
        locals: locals
      });
    }

    function _failure(messageText) {
      $mdDialog.show({
        templateUrl: 'app/core/utils/alert-dialog/alert-dialog.html',
        controller: 'AlertDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          message: messageText
        }
      });
    }
  }
})();

(function() {
  'use strict';

  DeleteStatementsController.$inject = ["$mdDialog", "$state", "$timeout", "$stateParams", "Statements"];
  angular
    .module('projects')
    .controller('DeleteStatementsController', DeleteStatementsController);

  function DeleteStatementsController(
    $mdDialog,
    $state,
    $timeout,
    $stateParams,
    Statements) {
    var vm = this;
    vm.cancel = $mdDialog.cancel;
    vm.deleteStatements = deleteStatements;

    this.$onInit = function() {
      setDescriptionCounter();
    };

    function setDescriptionCounter() {
      var statementsCounter = (vm.selectedStatements) ? vm.selectedStatements.length : 0;
      vm.descriptionCounter = (statementsCounter === 1) ? '1 statement' : statementsCounter + ' statements';
    }

    function deleteStatements() {
      var statementIds = _.map(vm.selectedStatements, function (statement) {
        return statement.id;
      });

      Statements.removeMultipleStatements(statementIds, $stateParams.projectId).then(
        function Success() {
          $mdDialog.hide();
          $state.reload();
        }
      ).catch(
        function Failure() {
          $mdDialog.show({
            templateUrl: 'app/core/utils/alert-dialog/alert-dialog.html',
            controller: 'AlertDialogController',
            controllerAs: '$ctrl',
            bindToController: true,
            locals: {
              message: 'There was an error deleting the statement(s), please contact a system admin...'
            }
          });
        }
      );
    }
  }
})();

(function() {
  'use strict';

  AddStatementsController.$inject = ["$state", "$stateParams", "$mdDialog", "$timeout", "toastr", "ACCOUNTS", "PROJECT_TYPES", "STATEMENTS", "ACCOUNT_PERIODS", "DOCUMENT_TYPES", "Statements", "Documents", "Accounts", "Authorization", "Upload", "uploadParameters", "type", "source"];
  angular
    .module('projects')
    .controller('AddStatementsController', AddStatementsController);

  function AddStatementsController(
    $state,
    $stateParams,
    $mdDialog,
    $timeout,
    toastr,
    ACCOUNTS,
    PROJECT_TYPES,
    STATEMENTS,
    ACCOUNT_PERIODS,
    DOCUMENT_TYPES,
    Statements,
    Documents,
    Accounts,
    Authorization,
    Upload,
    uploadParameters,
    type,
    source) {
    var vm = this;

    vm.excludeAccounts = [ACCOUNTS.TYPE.ERP, ACCOUNTS.TYPE.SAVINGS, ACCOUNTS.TYPE.CHECKING, ACCOUNTS.TYPE.CREDIT_CARD];
    vm.accountsLoaded = false;
    vm.uploadFiles = uploadFiles;
    vm.isUploading = isUploading;
    vm.statementsPending = statementsPending;
    vm.cancelUpload = cancelUpload;
    vm.abortUpload = abortUpload;
    vm.getFileErrorMessage = getFileErrorMessage;
    vm.extractStatements = extractStatements;
    vm.selectedAccountId = null;
    vm.accounts = [];
    vm.files = [];
    vm.errorFiles = [];
    vm.uploadedStatements = [];

    activate();

    function activate() {
      vm.type = type;
      vm.source = source;
      vm.isBrokerageMortgage = source === STATEMENTS.SOURCE.BROKERAGE_LOAN_PDF;
      Accounts.findAll({ projectId: $stateParams.projectId, exclude: vm.excludeAccounts, enabled: true }, {bypassCache: true}).then(
        function Success(response) {
          vm.accounts = response;
          vm.accountsLoaded = true;
        })
        .catch(
          function Failure() {
            toastr.error('Error fetching Accounts');
          }
        );
      vm.files = [];
      vm.errorFiles = [];
      vm.acceptPattern = 'application/pdf';
      vm.ngUploadPattern = '.pdf';
      vm.maxSize = '100MB';
      vm.info = 'Select up to 100 pdf statement files. Max size 100MB per file.';
    }

    function isUploading() {
      return Upload.isUploadInProgress();
    }

    function statementsPending() {
      return vm.files.length !== vm.uploadedStatements.length;
    }

    function uploadFiles(files, errorFiles) {
      vm.files = files;
      vm.errorFiles = errorFiles;
      angular.forEach(files, function(file) {
        //Users may upload multiple files with the same name, need to differentiate them when associated with different DB entities.
        var randKey = Math.floor(Math.random() * 10000);
        const uploadData = {
          key: uploadParameters.folder + '/' + randKey + '/' + file.name,
          acl: 'private',
          policy: uploadParameters.policy,
          'x-amz-algorithm': uploadParameters['x-amz-algorithm'],
          'x-amz-credential': uploadParameters['x-amz-credential'],
          'x-amz-date': uploadParameters['x-amz-date'],
          'x-amz-signature': uploadParameters.signature,
          'x-amz-security-token': uploadParameters['x-amz-security-token'],
          "Content-Type": file.type != '' ? file.type : 'application/octet-stream',
          filename: file.name,
          file: file
        };
        if (!uploadParameters['x-amz-security-token']) {
          delete uploadData['x-amz-security-token'];
        }

        file.upload = Upload.upload({
          url: uploadParameters.url,
          method: 'POST',
          data: uploadData
        });

        file.upload.then(function (response) {
          _saveDocumentData(file, response.config.data.key);
        }, function (response) {
          if (response.status > 0) {
            _failure(file, response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      });
    }

    function _saveDocumentData(file, filename) {
      vm.newDocument = {};
      vm.newDocument.fileName = filename;
      vm.newDocument.size = file.size;
      vm.newDocument.projectId = $stateParams.projectId;
      vm.newDocument.uploadDate = moment().toISOString();
      vm.newDocument.uploadUser = Authorization.getUserProfile().email;
      vm.newDocument.type = DOCUMENT_TYPES.STATEMENT.type;
      vm.newDocument.mimeType = file.type;
      Documents.create(vm.newDocument, {params:{nb:1}}).then(
        function Success(response) {
          _createStatement(response.id, file);
        })
        .catch(function Failure() {
          _failure(file, 'The statement failed to upload, please contact a system admin...');
        });
    }

    function _createStatement(docId, file) {
      var newStatement = {
        documentId: docId,
        source: vm.source,
      };
      Statements.create(newStatement, {params:{nb:1}}).then(
        function Success(response) {
          vm.uploadedStatements.push(response.id);
          _success(file, 'The statement has been successfully saved!');
        })
        .catch(function Failure() {
          _failure(file, 'The statement failed to upload, please contact a system admin...');
        });
    }

    function _success(file, messageText) {
      file.successMessage = messageText;
    }

    function _failure(file, messageText) {
      file.errorMessage = messageText;
      file.progress = 0;
      vm.errorFiles.push(file);
    }

    function abortUpload() {
      angular.forEach(vm.files, function(file) {
        if(file.upload) {
          file.upload.abort();
        }
      });
    }

    function getFileErrorMessage(file) {
      var message = file.name;
      if(file.errorMessage) {
        return message + ' Error: ' + file.errorMessage;
      } else if (file.$error === 'pattern') {
        return message + ' Error: file extension not accepted';
      } else if (file.$error === 'maxSize') {
        return message + ' Error: file exceeds maximum allowed size';
      } else {
        return message + ' Error';
      }
    }

    function cancelUpload() {
      if(vm.uploadedStatements.length > 0) {
        Statements.removeMultipleStatements(vm.uploadedStatements, $stateParams.projectId).then( function success() {
          $mdDialog.cancel();
        }).catch( function fail() {
          toastr.error('Error cancelling documents');
          $mdDialog.cancel();
        });
      } else {
        $mdDialog.cancel();
      }
    }

    function extractStatements() {
      var params = {
        projectId: $stateParams.projectId,
        flow: STATEMENTS.SOURCE_FLOW[vm.source],
        nb: true
      };
      var body = {
        statementIds: vm.uploadedStatements,
        accountId: vm.selectedAccountId
      };

      Statements.extractStatements(body, params).then(
        function Success() {
          var msg = vm.isBrokerageMortgage ? 'Statement uploaded successfully' : 'The statements should be returned in 48h or less';
          toastr.success(msg);
          $timeout( function(){
            var route;
            if(vm.selectedAccountId) {
              route = vm.type === PROJECT_TYPES.AUDIT ? 'engagement.account-periods' : 'project.account-periods';
              $state.go(route, { source: vm.source, status: ACCOUNT_PERIODS.STATUS.UNRECONCILED }, {reload: true});
            } else {
              route = vm.type === PROJECT_TYPES.AUDIT ? 'engagement.statements' : 'project.documents.statements';
              $state.go(route, { source: vm.source, status: STATEMENTS.STATUS.EXTRACTING }, {reload: true});
            }
          }, 3000);
          $mdDialog.hide();
          
        }).catch(
        function Failure() {
          toastr.error('There was an error extracting the statements, please contact a system admin...');
          $mdDialog.hide();
          $state.go($state.current, { source: STATEMENTS.SOURCE.BANK_PDF, status: STATEMENTS.STATUS.REJECTED }, {reload: true});
        }
      );
    }
  }
})();

(function() {
  'use strict';

  AddCsvStatementController.$inject = ["$state", "$stateParams", "$mdDialog", "$timeout", "toastr", "ENV", "ACCOUNTS", "PROJECT_TYPES", "STATEMENTS", "DOCUMENT_TYPES", "Statements", "Documents", "Accounts", "Authorization", "Upload", "uploadParameters", "type"];
  angular
    .module('projects')
    .controller('AddCsvStatementController', AddCsvStatementController);

  function AddCsvStatementController(
    $state,
    $stateParams,
    $mdDialog,
    $timeout,
    toastr,
    ENV,
    ACCOUNTS,
    PROJECT_TYPES,
    STATEMENTS,
    DOCUMENT_TYPES,
    Statements,
    Documents,
    Accounts,
    Authorization,
    Upload,
    uploadParameters,
    type) {
    var vm = this;

    vm.excludeAccounts = [ACCOUNTS.TYPE.ERP];
    vm.accountsLoaded = false;
    vm.validPeriodData = validPeriodData;
    vm.uploadFiles = uploadFiles;
    vm.isUploading = isUploading;
    vm.cancelUpload = cancelUpload;
    vm.abortUpload = abortUpload;
    vm.getFileErrorMessage = getFileErrorMessage;
    vm.extractStatements = extractStatements;
    
    vm.selectedAccountId = null;
    vm.startDate = null;
    vm.endDate = null;
    vm.startBalance = null;
    vm.endBalance = null;

    vm.accounts = [];
    vm.files = [];
    vm.errorFiles = [];
    vm.uploadedStatements = [];

    activate();

    function activate() {
      vm.type = type;
      vm.helpLink = ENV.csvTemplateHelpLink;
      Accounts.findAll({ projectId: $stateParams.projectId, exclude: vm.excludeAccounts, enabled: true }, {bypassCache: true}).then(
        function Success(response) {
          vm.accounts = response;
          vm.accountsLoaded = true;
        })
        .catch(
          function Failure() {
            toastr.error('Error fetching Accounts');
          }
        );
      vm.files = [];
      vm.errorFiles = [];
      vm.acceptPattern = 'text/csv';
      vm.ngUploadPattern = '.csv';
      vm.maxSize = '100MB';
    }

    function isUploading() {
      return Upload.isUploadInProgress();
    }

    function uploadFiles(files, errorFiles) {
      vm.files = files;
      vm.errorFiles = errorFiles;
      angular.forEach(files, function(file) {
        //Users may upload multiple files with the same name, need to differentiate them when associated with different DB entities.
        var randKey = Math.floor(Math.random() * 10000);
        const uploadData = {
          key: uploadParameters.folder + '/' + randKey + '/' + file.name,
          acl: 'private',
          policy: uploadParameters.policy,
          'x-amz-algorithm': uploadParameters['x-amz-algorithm'],
          'x-amz-credential': uploadParameters['x-amz-credential'],
          'x-amz-date': uploadParameters['x-amz-date'],
          'x-amz-signature': uploadParameters.signature,
          'x-amz-security-token': uploadParameters['x-amz-security-token'],
          "Content-Type": file.type != '' ? file.type : 'application/octet-stream',
          filename: file.name,
          file: file
        };
        if (!uploadParameters['x-amz-security-token']) {
          delete uploadData['x-amz-security-token'];
        }

        file.upload = Upload.upload({
          url: uploadParameters.url,
          method: 'POST',
          data: uploadData,
        });

        file.upload.then(function (response) {
          _saveDocumentData(file, response.config.data.key);
        }, function (response) {
          if (response.status > 0) {
            _failure(file, response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      });
    }

    function _saveDocumentData(file, filename) {
      vm.newDocument = {};
      vm.newDocument.fileName = filename;
      vm.newDocument.size = file.size;
      vm.newDocument.projectId = $stateParams.projectId;
      vm.newDocument.uploadDate = moment().toISOString();
      vm.newDocument.uploadUser = Authorization.getUserProfile().email;
      vm.newDocument.type = DOCUMENT_TYPES.STATEMENT.type;
      vm.newDocument.mimeType = file.type;
      Documents.create(vm.newDocument, {params:{nb:1}}).then(
        function Success(response) {
          _createStatement(response.id, file);
        })
        .catch(function Failure() {
          _failure(file, 'The statement failed to upload, please contact a system admin...');
        });
    }

    function _createStatement(docId, file) {
      var newStatement = {
        documentId: docId,
        source: STATEMENTS.SOURCE.TXN_CSV,
        pages: 1
      };
      Statements.create(newStatement, {params:{nb:1}}).then(
        function Success(response) {
          vm.uploadedStatements.push(response.id);
          _success(file, 'The statement has been successfully saved!');
        })
        .catch(function Failure() {
          _failure(file, 'The statement failed to upload, please contact a system admin...');
        });
    }

    function _success(file, messageText) {
      file.successMessage = messageText;
    }

    function _failure(file, messageText) {
      file.errorMessage = messageText;
      file.progress = 0;
      vm.errorFiles.push(file);
    }

    function abortUpload() {
      angular.forEach(vm.files, function(file) {
        if(file.upload) {
          file.upload.abort();
        }
      });
    }

    function validPeriodData() {
      return (vm.uploadedStatements.length === 1) && vm.startBalance && vm.endBalance && !isNaN(vm.startBalance) && !isNaN(vm.endBalance)
        && vm.selectedAccountId && vm.startDate && vm.endDate && moment(vm.startDate).isBefore(moment(vm.endDate), 'days')
        && moment(vm.startDate).isAfter('1970-01-01') && moment(vm.endDate).isBefore('2050-01-01');
    }

    function getFileErrorMessage(file) {
      var message = file.name;
      if(file.errorMessage) {
        return message + ' Error: ' + file.errorMessage;
      } else if (file.$error === 'pattern') {
        return message + ' Error: file extension not accepted';
      } else if (file.$error === 'maxSize') {
        return message + ' Error: file exceeds maximum allowed size';
      } else {
        return message + ' Error';
      }
    }

    function cancelUpload() {
      if(vm.uploadedStatements.length > 0) {
        Statements.removeMultipleStatements(vm.uploadedStatements, $stateParams.projectId).then( function success() {
          $mdDialog.cancel();
        }).catch( function fail() {
          toastr.error('Error cancelling documents');
          $mdDialog.cancel();
        });
      } else {
        $mdDialog.cancel();
      }
    }

    function extractStatements() {
      if(!vm.selectedAccountId) {
        return;
      }

      var params = {
        projectId: $stateParams.projectId,
        flow: STATEMENTS.SOURCE_FLOW[STATEMENTS.SOURCE.TXN_CSV],
        nb: true
      };
      var body = {
        statementIds: vm.uploadedStatements,
        accountId: vm.selectedAccountId,
        startDate: vm.startDate,
        endDate: vm.endDate,
        startBalance: vm.startBalance,
        endBalance: vm.endBalance
      };
      
      Statements.extractStatements(body, params).then(
        function Success() {
          toastr.success('Statement uploaded successfully');
          $timeout( function(){
            var route = vm.type === PROJECT_TYPES.AUDIT ? 'engagement.statements' : 'project.documents.statements';
            $state.go(route, { source: STATEMENTS.SOURCE.TXN_CSV, status: STATEMENTS.STATUS.EXTRACTING }, {reload: true});
          }, 2000);
          $mdDialog.hide();
        }).catch(
        function Failure() {
          toastr.error('There was an error extracting the statement, please contact a system admin...');
          $mdDialog.hide();
          $state.go($state.current, { source: STATEMENTS.SOURCE.TXN_CSV, status: STATEMENTS.STATUS.REJECTED }, {reload: true});
        }
      );
    }
  }
})();

(function() {
  'use strict';

  AddCheckFilesController.$inject = ["$state", "$stateParams", "$mdDialog", "$timeout", "toastr", "ENV", "PROJECT_TYPES", "STATEMENTS", "DOCUMENT_TYPES", "Statements", "Documents", "Authorization", "Upload", "uploadParameters", "type"];
  angular
    .module('projects')
    .controller('AddCheckFilesController', AddCheckFilesController);

  function AddCheckFilesController(
    $state,
    $stateParams,
    $mdDialog,
    $timeout,
    toastr,
    ENV,
    PROJECT_TYPES,
    STATEMENTS,
    DOCUMENT_TYPES,
    Statements,
    Documents,
    Authorization,
    Upload,
    uploadParameters,
    type) {
    var vm = this;

    vm.uploadFiles = uploadFiles;
    vm.isUploading = isUploading;
    vm.cancelUpload = cancelUpload;
    vm.abortUpload = abortUpload;
    vm.getFileErrorMessage = getFileErrorMessage;
    vm.extractCheckFiles = extractCheckFiles;
    vm.checkFilesPending = checkFilesPending;
    
    vm.files = [];
    vm.errorFiles = [];
    vm.uploadedCheckFiles = [];

    activate();

    function activate() {
      vm.type = type;
      vm.files = [];
      vm.errorFiles = [];
      vm.acceptPattern = 'application/pdf';
      vm.ngUploadPattern = '.pdf';
      vm.maxSize = '500MB';
    }

    function isUploading() {
      return Upload.isUploadInProgress();
    }

    function checkFilesPending() {
      return vm.files.length !== vm.uploadedCheckFiles.length;
    }

    function uploadFiles(files, errorFiles) {
      vm.files = files;
      vm.errorFiles = errorFiles;
      angular.forEach(files, function(file) {
        //Users may upload multiple files with the same name, need to differentiate them when associated with different DB entities.
        var randKey = Math.floor(Math.random() * 10000);
        const uploadData = {
          key: uploadParameters.folder + '/' + randKey + '/' + file.name,
          acl: 'private',
          policy: uploadParameters.policy,
          'x-amz-algorithm': uploadParameters['x-amz-algorithm'],
          'x-amz-credential': uploadParameters['x-amz-credential'],
          'x-amz-date': uploadParameters['x-amz-date'],
          'x-amz-signature': uploadParameters.signature,
          'x-amz-security-token': uploadParameters['x-amz-security-token'],
          "Content-Type": file.type != '' ? file.type : 'application/octet-stream',
          filename: file.name,
          file: file
        };
        if (!uploadParameters['x-amz-security-token']) {
          delete uploadData['x-amz-security-token'];
        }

        file.upload = Upload.upload({
          url: uploadParameters.url,
          method: 'POST',
          data: uploadData
        });

        file.upload.then(function (response) {
          _saveDocumentData(file, response.config.data.key);
        }, function (response) {
          if (response.status > 0) {
            _failure(file, response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      });
    }

    function _saveDocumentData(file, filename) {
      vm.newDocument = {};
      vm.newDocument.fileName = filename;
      vm.newDocument.size = file.size;
      vm.newDocument.projectId = $stateParams.projectId;
      vm.newDocument.uploadDate = moment().toISOString();
      vm.newDocument.uploadUser = Authorization.getUserProfile().email;
      vm.newDocument.type = DOCUMENT_TYPES.STATEMENT.type;
      vm.newDocument.mimeType = file.type;
      Documents.create(vm.newDocument, {params:{nb:1}}).then(
        function Success(response) {
          _createStatement(response.id, file);
        })
        .catch(function Failure() {
          _failure(file, 'The checks file failed to upload, please contact a system admin...');
        });
    }

    function _createStatement(docId, file) {
      var newStatement = {
        documentId: docId,
        source: STATEMENTS.SOURCE.CHECKS_PDF
      };
      Statements.create(newStatement, {params:{nb:1}}).then(
        function Success(response) {
          vm.uploadedCheckFiles.push(response.id);
          _success(file, 'The checks file has been successfully saved!');
        })
        .catch(function Failure() {
          _failure(file, 'The checks file failed to upload, please contact a system admin...');
        });
    }

    function _success(file, messageText) {
      file.successMessage = messageText;
    }

    function _failure(file, messageText) {
      file.errorMessage = messageText;
      file.progress = 0;
      vm.errorFiles.push(file);
    }

    function abortUpload() {
      angular.forEach(vm.files, function(file) {
        if(file.upload) {
          file.upload.abort();
        }
      });
    }

    function getFileErrorMessage(file) {
      var message = file.name;
      if(file.errorMessage) {
        return message + ' Error: ' + file.errorMessage;
      } else if (file.$error === 'pattern') {
        return message + ' Error: file extension not accepted';
      } else if (file.$error === 'maxSize') {
        return message + ' Error: file exceeds maximum allowed size';
      } else {
        return message + ' Error';
      }
    }

    function cancelUpload() {
      if(vm.uploadedCheckFiles.length > 0) {
        Statements.removeMultipleStatements(vm.uploadedCheckFiles, $stateParams.projectId).then( function success() {
          $mdDialog.cancel();
        }).catch( function fail() {
          toastr.error('Error cancelling documents');
          $mdDialog.cancel();
        });
      } else {
        $mdDialog.cancel();
      }
    }

    function extractCheckFiles() {
      var params = {
        projectId: $stateParams.projectId,
        flow: STATEMENTS.SOURCE_FLOW[STATEMENTS.SOURCE.CHECKS_PDF]
      };
      var body = {
        statementIds: vm.uploadedCheckFiles
      };
      Statements.extractStatements(body, params).then(
        function Success() {
          toastr.success('Check files uploaded successfully');
          $timeout( function(){
            var route;
            route = vm.type === PROJECT_TYPES.AUDIT ? 'engagement.statements' : 'project.documents.statements';
            $state.go(route, { source: STATEMENTS.SOURCE.CHECKS_PDF, status: STATEMENTS.STATUS.EXTRACTING }, {reload: true});
          }, 3000);
          $mdDialog.hide();
          
        }).catch(
        function Failure() {
          toastr.error('There was an error extracting the check files, please contact a system admin...');
          $mdDialog.hide();
          $state.go($state.current, { source: STATEMENTS.SOURCE.CHECKS_PDF, status: STATEMENTS.STATUS.REJECTED }, {reload: true});
        }
      );
    }
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('project.transactionDetail', {
        url: '/transactions/:transactionId',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/transactions/transaction-detail.html',
            controller: 'TransactionDetailController as $ctrl'
          }
        },
        resolve: {
          transaction: ["$stateParams", "Transactions", function($stateParams, Transactions) {
            return Transactions.find($stateParams.transactionId);
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  transactionUtils.$inject = ["$filter", "TRANSACTION_TYPES", "PROJECT_TYPES", "ACCOUNTS", "CHECK_ITEMS", "Transactions"];
  angular
    .module('projects')
    .factory('transactionUtils', transactionUtils);

  function transactionUtils(
    $filter,
    TRANSACTION_TYPES,
    PROJECT_TYPES,
    ACCOUNTS,
    CHECK_ITEMS,
    Transactions) {
    return {
      getFloorDate: getFloorDate,
      getCeilDate: getCeilDate,
      getFloorBalance: getFloorBalance,
      getCeilBalance: getCeilBalance,
      getLabelForCategory: getLabelForCategory,
      getCustomFieldValue: getCustomFieldValue,
      getFilterParams: getFilterParams,
      formatFilterParams: formatFilterParams,
      getFilterData: getFilterData,
      getDefaultTxnColumns: getDefaultTxnColumns,
      getCategoryColumns: getCategoryColumns,
      getSupDocColumn: getSupDocColumn,
      getCategoryLabels: getCategoryLabels,
      getCustomFieldColumns: getCustomFieldColumns,
      formatTxnRows: formatTxnRows,
      formatTxnCheckItemRows : formatTxnCheckItemRows
    };

    function getFloorDate(transactions) {
      var startDates = _.map(transactions, function(transaction) {
        return moment(transaction.date);
      });
      return _.min(startDates).toDate();
    }

    function getCeilDate(transactions) {
      var startDates = _.map(transactions, function(transaction) {
        return moment(transaction.date);
      });
      return _.max(startDates).toDate();
    }

    function getFloorBalance(transactions) {
      var amounts = _.map(transactions, 'balance');
      return _.min(amounts);
    }

    function getCeilBalance(transactions) {
      var amounts = _.map(transactions, 'balance');
      return _.max(amounts);
    }

    function getLabelForCategory(transactionLabels, defaultLabel) {
      // Find applied label for category.  Should only ever return 1 or no labels
      var appliedLabel = _.find(transactionLabels, { categoryId: defaultLabel.categoryId });
      // If no label has been applied, display default label for category
      return appliedLabel ? appliedLabel.name : defaultLabel.name;
    }

    function getCustomFieldValue(transactionCustomFields, customFieldId) {
      var field = _.find(transactionCustomFields, { id: customFieldId });
      return field ? field.value : '';
    }

    function getCategoryLabels(transactionLabels) {
      return transactionLabels.map(function(label) {
        return label.name;
      });
    }

    function getFilterParams(stateParams) {
      return {
        startDate: stateParams.startDate,
        endDate: stateParams.endDate,
        minStartDate: stateParams.minStartDate,
        maxStartDate: stateParams.maxEndDate,
        dateGroup: stateParams.dateGroup,
        transRangeLow: stateParams.transRangeLow,
        transRangeHigh: stateParams.transRangeHigh,
        transRangeAbs: stateParams.transRangeAbs,
        entities: stateParams.entities && stateParams.entities.length ? stateParams.entities : undefined,
        accounts: stateParams.accounts && stateParams.accounts.length ? stateParams.accounts : stateParams.accountId,
        accountType: stateParams.accountType,
        bankAccountTypes: stateParams.bankAccountTypes && stateParams.bankAccountTypes.length ? stateParams.bankAccountTypes : undefined,
        sourceType: stateParams.sourceType,
        cjOnly: stateParams.cjOnly,
        reconciled: stateParams.reconciled,
        unmatched: stateParams.unmatched,
        categories: stateParams.categories && stateParams.categories.length ? stateParams.categories : undefined,
        categoriesEnabled: stateParams.categoriesEnabled,
        entitiesEnabled: stateParams.entitiesEnabled,
        keywordField: stateParams.keywordField,
        keyword: stateParams.keyword,
        customField: stateParams.customField,
        customFieldLabel: stateParams.customFieldLabel,
        projectId: stateParams.projectId,
        flow: stateParams.flow
      };
    }

    function formatFilterParams(params) {
      var filterParams = {
        'endDate': params.endDate,
        'startDate': params.startDate,
        'minStartDate': params.minStartDate,
        'maxStartDate': params.maxEndDate,
        'dateGroup': params.dateGroup,
        'transRangeLow': params.transRangeLow,
        'transRangeHigh': params.transRangeHigh,
        'transRangeAbs': params.transRangeAbs,
        'entities': params.entities,
        'accounts': params.accounts || params.accountId,
        'accountType': params.accountType,
        'bankAccountTypes': params.bankAccountTypes,
        'sourceType': params.sourceType,
        'cjOnly': params.cjOnly,
        'reconciled': params.reconciled,
        'unmatched': params.unmatched,
        'categories': params.categories,
        'categoriesEnabled': params.categoriesEnabled,
        'entitiesEnabled': params.entitiesEnabled,
        'keyword': params.keyword,
        'keywordField': params.keywordField,
        'customField': params.customField,
        'customFieldLabel': params.customFieldLabel,
        'projectId': params.projectId,
        'flow': params.flow,
        'statementId': params.statementId,
        'accountPeriodId': params.accountPeriodId,
        'transactionIds': params.transactionIds,
        'enabledAccounts': params.enabledAccounts
      };
      if (filterParams.categories !== undefined) {
        if (Array.isArray(filterParams.categories) && filterParams.categories.length === 0) {
          delete filterParams.categories;
        } else if (typeof filterParams.categories === 'string' || filterParams.categories instanceof String) {
          // Sometimes a single selection comes through as a string instead of an array. Convert it to a single entry array
          filterParams.categories = [filterParams.categories];
        }
      }

      if (filterParams.entities !== undefined) {
        if (Array.isArray(filterParams.entities) && filterParams.entities.length === 0) {
          delete filterParams.entities;
        } else if (typeof filterParams.entities === 'string' || filterParams.entities instanceof String) {
          // Sometimes a single selection comes through as a string instead of an array. Convert it to a single entry array
          filterParams.entities = [filterParams.entities];
        }
      }

      if (filterParams.accounts !== undefined) {
        if (Array.isArray(filterParams.accounts) && filterParams.accounts.length === 0) {
          delete filterParams.accounts;
        } else if (typeof filterParams.accounts === 'string' || filterParams.accounts instanceof String) {
          // Sometimes a single selection comes through as a string instead of an array. Convert it to a single entry array
          filterParams.accounts = [filterParams.accounts];
        }
      }
 
      if (filterParams.bankAccountTypes !== undefined) {
        if (Array.isArray(filterParams.bankAccountTypes) && filterParams.bankAccountTypes.length === 0) {
          delete filterParams.bankAccountTypes;
        } else if (typeof filterParams.bankAccountTypes === 'string' || filterParams.bankAccountTypes instanceof String) {
          // Sometimes a single selection comes through as a string instead of an array. Convert it to a single entry array
          filterParams.bankAccountTypes = [filterParams.bankAccountTypes];
        }
      }
      
      return filterParams;
    }

    function getFilterData(stateParams) {
      return {
        startDate: stateParams.startDate ? moment(stateParams.startDate).toDate() : null,
        endDate: stateParams.endDate ? moment(stateParams.endDate).toDate() : null,
        minStartDate: stateParams.minStartDate || moment(Transactions.getMetadata().transDateFloor).toDate(),
        maxEndDate: stateParams.maxEndDate || moment(Transactions.getMetadata().transDateCeil).toDate(),
        dateGroup: stateParams.dateGroup,
        transRangeLow: parseFloat(stateParams.transRangeLow),
        transRangeHigh: parseFloat(stateParams.transRangeHigh),
        transRangeAbs: stateParams.transRangeAbs === 'true' ? true : false,
        transRangeFloor: Math.floor(Transactions.getMetadata().transRangeFloor),
        transRangeCeil: Math.ceil(Transactions.getMetadata().transRangeCeil),
        entities: stateParams.entities ? _.concat(stateParams.entities) : [],
        accounts: stateParams.accounts ? _.concat(stateParams.accounts) : [],
        accountType: stateParams.accountType,
        bankAccountTypes: stateParams.bankAccountTypes ? _.concat(stateParams.bankAccountTypes) : [],
        sourceType: stateParams.sourceType,
        cjOnly: stateParams.cjOnly,
        reconciled: stateParams.reconciled,
        unmatched: stateParams.unmatched === 'true' ? true : false,
        categories: stateParams.categories ? _.concat(stateParams.categories) : [],
        categoriesEnabled: stateParams.categoriesEnabled !== 'false',
        entitiesEnabled: stateParams.entitiesEnabled === 'true' ? true : false,
        keyword: stateParams.keyword,
        keywordField: stateParams.keywordField,
        customField: stateParams.customField,
        customFieldLabel: stateParams.customFieldLabel,
        flow: stateParams.flow,
        transactionIds: stateParams.transactionIds
      };
    }

    function getDefaultTxnColumns($state, project) {
      const normalizePayor = !(project && project.options && project.options.normalizePayor === false);
      const normalizePayee = !(project && project.options && project.options.normalizePayee === false);
      return [
        {
          headerName: 'ID',
          field: 'id',
          minWidth: 100,
          hide: true,
          valueFormatter: function(params) {
            if(!params.value || params.value.startsWith('agg_') || params.value.endsWith('empty')) {
              return '';
            }
            return params.value;
          },
        },
        {
          headerName: 'Date',
          field: 'date',
          minWidth: 100,
          width: 100,
          valueFormatter: function(params) {
            if(!params.data || params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION) {
              return '';
            }
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'STMT AMT',
          field: 'amount',
          cellClass: ['grid-amount'],
          minWidth: 80,
          width: 100,
          cellRenderer: function(params) {
            if(!params.data || params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION) {
              return '';
            }
            var amount = params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION ? params.value : ''; //rather than zero default, set empty string so the currencyDisplayFilter can format correctly
            var checkItem = params.data.checkItem;
            if(checkItem && checkItem.type === CHECK_ITEMS.TYPE.DEPOSIT && params.data.frontImage) {
              amount = params.value;
              return '<span check-image-preview-popover front="' + params.data.frontImage + '" back="' + params.data.backImage + '">' + $filter('currencyDisplayFilter')(amount, params.data.account.currency) + '</span>';
            }
            return $filter('currencyDisplayFilter')(amount, params.data.account.currency);
          }
        },
        {
          headerName: 'Item AMT',
          sortable: false,
          field: 'checkItem.amount',
          cellClass: ['grid-amount'],
          minWidth: 80,
          width: 100,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            if(params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION) {
              return $filter('currencyDisplayFilter')(params.value, params.data.account.currency);
            }

            var amount = params.value;
            var checkItem = params.data.checkItem;
            if(checkItem) {
              if(checkItem.type === CHECK_ITEMS.TYPE.DEPOSIT) {
                //amount = 0;
                amount = ''; //rather than a zero default, set empty string so currenctDisplayFilter can format correctly
                return $filter('currencyDisplayFilter')(amount, params.data.account.currency);
              }
              if (checkItem.type === CHECK_ITEMS.TYPE.FRONT && params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
                amount = amount * -1;
              }
            }
            if (params.data.frontImage) {
              return '<span check-image-preview-popover front="' + params.data.frontImage + '" back="' + params.data.backImage + '">' + $filter('currencyDisplayFilter')(amount, params.data.account.currency) + '</span>';
            }
            return $filter('currencyDisplayFilter')(amount, params.data.account.currency);
          }
        },
        {
          headerName: 'CUR',
          field: 'account.currency',
          minWidth: 80,
          width: 100,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            return params.value.toUpperCase();
          }
        },
        {
          headerName: 'TXN Type',
          field: 'type',
          width: 150,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            if(params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION) {
              return CHECK_ITEMS.MATCHED_TYPE.AGGREGATION;
            }
            if(params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM) {
              return CHECK_ITEMS.MATCHED_TYPE.ITEM;
            }
            return $filter('transactionTypeDisplay')(params.value);
          }
        },
        {
          headerName: 'Check #',
          field: 'checkNo',
          width: 100
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 200
        },
        {
          headerName: 'Name',
          field: 'name',
          width: 100
        },
        {
          headerName: 'Memo',
          field: 'memo',
          width: 100
        },
        {
          headerName: 'Item Type',
          sortable: false,
          field: 'checkItem.type',
          width: 100,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            switch( params.data.rowType ) {
            case TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION:
              if(params.data.checkItem && params.data.checkItem.type === CHECK_ITEMS.TYPE.FRONT) {
                return CHECK_ITEMS.MATCHED_TYPE.OUTGOING;
              } else {
                return $filter('checkItemTypeDisplay')(params.value);
              }
            case TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM:
              if(params.data.checkItem && params.data.checkItem.type === CHECK_ITEMS.TYPE.FRONT) {
                return CHECK_ITEMS.MATCHED_TYPE.INCOMING;
              } else {
                return $filter('checkItemTypeDisplay')(params.value);
              }
            case TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION:
              return CHECK_ITEMS.MATCHED_TYPE.AGGREGATION;
            }
          }
        },
        {
          headerName: 'Item Date',
          field: 'checkItem.date',
          sortable: false,
          minWidth: 100,
          width: 100,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Item #',
          field: 'checkItem.checkNumber',
          width: 80,
          sortable: false,
        },
        {
          headerName: 'Item Name',
          field: 'checkItem.name',
          sortable: false,
          minWidth: 100,
          width: 100,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            if(params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM) {
              return params.data.checkItem.payor;
            } else if ( params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION && params.data.checkItem ) {
              return params.data.checkItem.payee;
            }
            return params.value;
          }
        },
        {
          headerName: 'Item Payee',
          field: 'checkItem.payee',
          sortable: false,
          minWidth: 100,
          width: 100,
          valueGetter: function(params) {
            if(!params.data || !params.data.checkItem) {
              return '';
            }
            var payee = params.data.checkItem.payee;
            if(normalizePayee) {
              if( (params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM || params.data.checkItem.type === CHECK_ITEMS.TYPE.DEPOSIT)
                && params.data.account && params.data.account.entity ) {
                payee = params.data.account.entity.name;
              }
            }
            return payee;
          },
        },
        {
          headerName: 'Item Payor',
          field: 'checkItem.payor',
          sortable: false,
          minWidth: 100,
          width: 100,
          valueGetter: function(params) {
            if(!params.data || !params.data.checkItem) {
              return '';
            }
            var payor = params.data.checkItem.payor;
            if(normalizePayor) {
              if(params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION
                && params.data.checkItem.type !== CHECK_ITEMS.TYPE.DEPOSIT && params.data.account && params.data.account.entity ) {
                payor = params.data.account.entity.name;
              }
            }
            return payor;
          },
        },
        {
          headerName: 'Item Memo',
          field: 'checkItem.memo',
          sortable: false,
          minWidth: 100,
          width: 100
        },
        {
          headerName: 'Bank Name',
          field: 'account.bank',
          width: 100,
          valueFormatter: function(params) {
            if(!params.data || params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION) {
              return '';
            }
            return params.value;
          }
        },
        {
          headerName: 'Acct #',
          field: 'account.number',
          width: 100,
          valueFormatter: function(params) {
            if(!params.data || params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION) {
              return '';
            }
            return params.value;
          }
        },
        {
          headerName: 'Acct Type',
          field: 'account.type',
          width: 100,
          valueFormatter: function(params) {
            if(!params.data || params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION) {
              return '';
            }
            return $filter('accountTypeDisplay')(params.value);
          }
        },
        {
          headerName: 'Acct Name',
          field: 'account.name',
          width: 100,
          cellRenderer: function(params) {
            if(!params.data || params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION) {
              return '';
            }
            if(params.data.account.type === ACCOUNTS.TYPE.ERP) {
              return params.value;
            }
            if(params.value) {
              return '<a href="#">' + params.value + '</a>';
            }
          },
          onCellClicked: function(params) {
            if(params.value && params.data.rowType !== TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION) {
              var route = project.type === PROJECT_TYPES.FORENSIC ? 'project.account-period-reconcile' : 'engagement.account-period-reconcile';
              $state.go(route, {accountPeriodId: params.data.accountPeriodId});
            }
          }
        },
        {
          headerName: 'Filename',
          sortable: false,
          field: 'fileName',
          width: 100,
          cellRenderer: function(params) {
            if(!params.data || params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION) {
              return '';
            }
            if(params.value) {
              return $filter('filenameDisplay')(params.value);
            } else {
              return 'Bank API';
            }
          }
        },
        {
          headerName: 'Page',
          field: 'page',
          width: 60,
          cellStyle: {textAlign: "center"},
          cellRenderer: function(params) {
            if( !params.data || params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION ) {
              return '';
            }
            if(params.value === null) {
              return 0;
            } else if(params.data) {
              var pageNumber = parseInt(params.value) + 1;   //Backend statement pages index is zero based.
              if(params.data.fileUrl) {
                var link = params.data.fileUrl;
                link = link + '#page=' + pageNumber;
                return '<a target="_blank" href="' + link + '">' + pageNumber + '</a>';
              } else {
                return pageNumber;
              }
            }
          }
        }
      ];
    }

    function getCategoryColumns(categories) {
      var categoryColumns = [];
      _.forEach(categories, function(category) {
        categoryColumns.push({
          headerName: category.name,
          hide: category.transactions === 0, //V8F-2327: Only show columns for categories that are used by transactions
          colId: 'category' + '.' + category.id, //sortModel
          valueGetter: function(params) {
            if(!params.data || (params.data.rowType !== TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION && params.data.rowType !== TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM)) {
              return '';
            }
            /* 
             * dave_g: removing this code after chris & tod changed their minds...
             *
            if(params.data.checkItem && params.data.checkItem.categoryLabels.length > 0 ) { //bias towards displaying the check item categoryLabel rather than the txn categoryLabel
              var ret = getLabelForCategory(params.data.checkItem.categoryLabels, _.find(category.categoryLabels, 'isDefault'));
              if (params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
                ret += " *";
              }
              return ret;
            } else {
              return getLabelForCategory(params.data.categoryLabels, _.find(category.categoryLabels, 'isDefault'));
            }
            */

            return getLabelForCategory(params.data.categoryLabels, _.find(category.categoryLabels, 'isDefault'));
          },
        });
      });
      return categoryColumns;
    }

    function getCustomFieldColumns(customFields) {
      var customFieldColumns = [];
      _.forEach(customFields, function(customField) {
        customFieldColumns.push({
          headerName: customField.name,
          hide: customField.transactions === 0, //V8F-2327: Only show columns for custom fields that are used by transactions
          colId: 'customField' + '.' + customField.id, //sortModel
          valueGetter: function(params) {
            if(!params.data || (params.data.rowType !== TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION && params.data.rowType !== TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM)) {
              return '';
            }
            /* 
             * dave_g: removing this code after chris & tod changed their minds...
             *
            if(params.data.checkItem && params.data.checkItem.customFields.length > 0 ) { //bias towards displaying the check item customFields rather than the txn customFields
              var ret = getCustomFieldValue(params.data.checkItem.customFields, customField.id);
              if (params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
                ret += " *";
              }
              return ret;
            } else {
              return getCustomFieldValue(params.data.customFields, customField.id);
            }
            */

            return getCustomFieldValue(params.data.customFields, customField.id);
          },
        });
      });
      return customFieldColumns;
    }

    function getSupDocColumn(dialogFunction) {
      return {
        headerName: 'Sup Docs',
        field: 'documents',
        resizable: false,
        suppressMovable: true,
        sortable: false,
        cellClass: 'links',
        width: 100,
        cellRenderer: function(params) {
          if(!params.data || params.data.rowType !== TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
            return '';
          }
          if(params.value === null || params.value.length === 0) {
            return '<md-icon class="material-icons icon-primary">cloud_upload</md-icon>';
          } else {
            return '<supporting-document-preview documents="data.documents"></supporting-document-preview>';
          }
        },
        onCellClicked: function(params) {
          dialogFunction(params.data);
        }
      };
    }


    function formatTxnRows(transactions) {
      if(!transactions) {
        return [];
      }
      var rows = transactions.map(function(tx) {
        //We only want tree groups for transactions that are associated to a deposit slip check item
        var row = {
          group: tx.checkItem && tx.checkItem.children.length > 0 && tx.checkItem.type === CHECK_ITEMS.TYPE.DEPOSIT,
          rowType: TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION,
          id: tx.id,
          date: tx.date,
          amount: tx.amount,
          type: tx.type,
          checkNo: tx.checkNo,
          description: tx.description,
          name: tx.name,
          memo: tx.memo,
          page: tx.page,
          account: tx.account,
          accountPeriodId: tx.accountPeriodId,
          fileName: tx.statement ? tx.statement.fileName : null,
          fileUrl: tx.statement ? tx.statement.downloadUrl : null,
          categoryLabels: tx.categoryLabels,
          customFields: tx.customFields,
          checkItem: tx.checkItem,
          documents: tx.documents
        };
        if(tx.checkItem) {
          tx.checkItem.top = true;
          if(tx.checkItem.type === CHECK_ITEMS.TYPE.DEPOSIT) {
            row.frontImage = tx.checkItem.imageUrl;
          } else if (tx.checkItem.type === CHECK_ITEMS.TYPE.FRONT || tx.checkItem.type === CHECK_ITEMS.TYPE.TRANSFER) {
            row.frontImage = tx.checkItem.imageUrl;
            row.backImage = tx.checkItem.children && tx.checkItem.children.length > 0 ? tx.checkItem.children[0].imageUrl : null;
          }
        }
        return row;
      });
      return rows;
    }

    function formatTxnCheckItemRows(transaction) {
      if(!transaction || !transaction.checkItem || transaction.checkItem.type !== CHECK_ITEMS.TYPE.DEPOSIT) {
        return [];
      }
      var rows = [];
      var itemTotal = 0;
      transaction.checkItem.children.forEach( function(item) {

        //mimicking a transaction rather than full check item. Goofy.
        var row = {
          group: false,
          rowType: TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM,
          type: TRANSACTION_TYPES.TYPE.CHECK,
          id: item.id,
          amount: item.amount,
          accountPeriodId: transaction.accountPeriodId,
          date: transaction.date,
          memo: item.memo,
          checkNo: item.checkNumber,
          account: transaction.account,
          checkItem: item,
          categoryLabels: item.categoryLabels ? item.categoryLabels : [],
          customFields: item.customFields ? item.customFields : [],
          documents: []
        };
        
        item.top = false;
        if(item.sourcePage && item.sourcePage.statement && item.sourcePage.statement.document) {
          row.page = item.sourcePage.number;
          row.fileName = item.sourcePage.statement.document.fileName;
          row.fileUrl = item.sourcePage.statement.document.fileUrl;
        }

        if (item.type === CHECK_ITEMS.TYPE.FRONT || item.type === CHECK_ITEMS.TYPE.TRANSFER) {
          row.frontImage = item.imageUrl;
          row.backImage = item.children && item.children.length > 0 ? item.children[0].imageUrl : null;
        }

        itemTotal += item.amount;
        rows.push(row);
      });

      rows.sort(function(a,b) {
        return b.checkItem.amount - a.checkItem.amount;
      });

      if(rows.length > 0) { //add aggregation row.
        var aggreationRow = {
          group: false,
          rowType: TRANSACTION_TYPES.GRID_ROW_TYPE.AGGREGATION,
          id: 'agg_' + transaction.id,
          account: transaction.account,
          checkItem: {
            amount: itemTotal
          }
        };
        rows.push(aggreationRow);
      }
      return rows;
    }
  }
})();

(function() {
  'use strict';

  Transactions.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('projects')
    .factory('Transactions', Transactions);

  function Transactions(DS, DSHttpAdapter) {
    var metadata;
    var transactions = DS.defineResource({
      name: 'transactions',
      endpoint: '/transactions',
      idAttribute: 'id',
      // TODO once JSData can handle metadata remove this
      cacheResponse: false,
      deserialize: function(config, res) {
        if(res.data.metadata) {
          metadata = res.data.metadata;
        }
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    transactions.getMetadata = function() {
      return metadata;
    };

    transactions.fullUpdate = function(transactionId, transactionData) {
      return DSHttpAdapter.PUT(
        DSHttpAdapter.defaults.basePath + '/transactions/' + transactionId,
        transactionData,
        { params: { updateCustomFields: true, updateCategories: true} }
      );
    };

    transactions.moveTransactions = function(projectId, accountPeriodId, transactionIds) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/transactions/batch',
        { transactionIds: transactionIds },
        { params: {projectId: projectId, action: 'assign', accountPeriodId: accountPeriodId} }
      );
    };

    transactions.deleteTransactions = function(projectId, accountPeriodId, transactionIds) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/transactions/batch',
        { transactionIds: transactionIds },
        { params: {projectId: projectId, action: 'delete', accountPeriodId: accountPeriodId} }
      );
    };

    transactions.match = function(projectId, transactionIds) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/transaction/match',
        { transactionIds: transactionIds },
        { params: {projectId: projectId} }
      );
    };

    transactions.updateCategories = function(projectId, transactionIds, categoryLabelId) {
      // Using POST instead of GET due to large request data
      // Goes against JS Data so creating specific HTTP request
      if (transactionIds.length === 0) {
        return Promise.resolve();
      }
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/transaction/categories',
        { transactionIds: transactionIds, categoryLabelId: categoryLabelId},
        { params: {projectId: projectId} }
      );
    };

    transactions.updateCustomFields = function(projectId, transactionIds, customFieldId, value) {
      // Using POST instead of GET due to large request data
      // Goes against JS Data so creating specific HTTP request
      if (transactionIds.length === 0) {
        return Promise.resolve();
      }
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/transaction/custom-fields',
        { transactionIds: transactionIds, value: value},
        { params: {projectId: projectId, customFieldId: customFieldId} }
      );
    };

    transactions.getSupportingDocuments = function(projectId, transactionId) {
      return DSHttpAdapter.GET(
        DSHttpAdapter.defaults.basePath + '/transaction/documents',
        { params: {projectId: projectId, transactionId: transactionId} }
      ).then(function (res) {
        return res.data.data;
      });
    };

    transactions.addSupportingDocuments = function(projectId, transactionId, documentIds) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/transaction/documents',
        { documentIds: documentIds },
        { params: {projectId: projectId, action: 'add', transactionId: transactionId } }
      );
    };

    transactions.removeSupportingDocuments = function(projectId, transactionId, documentIds) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/transaction/documents',
        { documentIds: documentIds },
        { params: {projectId: projectId, action: 'remove', transactionId: transactionId } }
      );
    };

    // this is a hack using POST instead of GET to find all transactions to avoid query size
    // limits
    transactions.findAllPOST = function(params) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/transactions-filter',
        params,
        {}
      ).then(function (res) {
        if(res.data.metadata) {
          metadata = res.data.metadata;
        }
        return res.data.data;
      });
    };
    return transactions;
  }
})();

(function() {
  'use strict';

  TransactionListTableController.$inject = ["$state", "$stateParams", "$timeout", "$filter", "$mdDialog", "tableUtils", "TRANSACTION_TYPES", "CHECK_ITEMS", "Projects", "Transactions", "Categories", "CustomFields", "transactionUtils"];
  angular
    .module('projects')
    .component('transactionListTable', {
      templateUrl: 'app/projects/project/transactions/transaction-list-table.html',
      bindings: {
        transactions: '<'
      },
      controller: TransactionListTableController
    });

  function TransactionListTableController(
    $state,
    $stateParams,
    $timeout,
    $filter,
    $mdDialog,
    tableUtils,
    TRANSACTION_TYPES,
    CHECK_ITEMS,
    Projects,
    Transactions,
    Categories,
    CustomFields,
    transactionUtils) {

    var vm = this;
    var GRID_ID = 'grid-transactions';
    vm.reloadData = reloadData;
    vm.project = Projects.get($state.params.projectId);

    this.$onInit = function() {
      vm.categories = Categories.filterByProject($state.params.projectId);
      vm.customFields = CustomFields.filterByProject($state.params.projectId);
      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.actionColumns = [
        {
          headerName: 'View',
          width: 55,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          pinned: 'left',
          cellClass: 'links',
          cellRenderer: function(params) {
            if(params.data && params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
              return '<md-icon class="material-icons icon-primary">visibility</md-icon>';
            }
          },
          onCellClicked: function(params) {
            if(params.data && params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
              $state.go('project.transactionDetail', { transactionId: params.data.id });
            }
          }
        }
      ];

      var allColumnDefs = vm.actionColumns
        .concat(transactionUtils.getDefaultTxnColumns($state, vm.project))
        .concat(transactionUtils.getCategoryColumns(vm.categories))
        .concat(transactionUtils.getCustomFieldColumns(vm.customFields));

      tableUtils.setColumnSort(vm.pagination, allColumnDefs);

      vm.gridOptions = {
        columnDefs: allColumnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        cacheBlockSize: vm.pagination.pageSize,
        angularCompileRows: true,
        treeData: true,
        animateRows: true,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onSortChanged: vm.reloadData,
        paginationPageSize: vm.pagination.pageSize,
        getMainMenuItems: tableUtils.getMainMenuItems,
        rowModelType: 'serverSide',
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange,
        autoGroupColumnDef: {
          suppressMovable: true,
          pinned: 'left',
          width: 50,
          headerName: '',
          sortable: false,
          cellRendererParams: {
            innerRenderer: function() { return ''; }
          }
        },
        isServerSideGroup: function(dataItem) {
          return dataItem.group;
        },
        getServerSideGroupKey: function(dataItem) {
          return dataItem.id;
        }
      };
    };

    function reloadData() {
      var sortModel = vm.gridOptions.api.getSortModel();
      if(sortModel.length) {
        vm.pagination.sortModel = sortModel[0].colId;
        vm.pagination.sortOrder = sortModel[0].sort;
      } else {
        vm.pagination.sortModel = 'date';
        vm.pagination.sortOrder = 'asc';
      }
      vm.pagination.skipCount = 0;
      $state.go($state.current, vm.pagination);
    }

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID);
      vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      if(!tableUtils.getGridState(GRID_ID)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID);
    }


    function _createDatasource() {
      return {
        getRows: function(params) {
          var rows = [];
          if(params.request.groupKeys.length === 0 ) { //Loading more root nodes, need to go to backend
            if(params.request.startRow === 0 && vm.transactions) { //We already have the first page provided by the route...
              rows = transactionUtils.formatTxnRows(vm.transactions);
              params.successCallback(rows, Transactions.getMetadata().transCountFilter);
            } else {
              if(!$stateParams.sortModel) {
                vm.pagination.sortModel = 'date';
                vm.pagination.sortOrder = 'asc';
              }

              vm.pagination.skipCount = params.request.startRow;
              var transactionParams = angular.extend({downloadUrl: true, includeCheckItems: CHECK_ITEMS.STATUS.RECONCILED},
                transactionUtils.formatFilterParams($stateParams), tableUtils.formatPagingParams(vm.pagination, true));
              Transactions.findAllPOST(transactionParams).then(
                function Success(data) {
                  params.successCallback(transactionUtils.formatTxnRows(data), Transactions.getMetadata().transCountFilter);
                }
              );
            }
          } else {  //Expanding child nodes, already supplied by the backend....
            var txn = params.parentNode.data;
            if(txn) {
              rows = transactionUtils.formatTxnCheckItemRows(txn);
            }
            params.successCallback(rows, rows.length);
          }
        }
      };
    }
  }
})();

(function() {
  'use strict';

  TransactionFilterController.$inject = ["$stateParams", "$mdDialog", "Transactions", "RECONCILIATIONS", "ACCOUNTS"];
  angular
    .module('projects')
    .component('transactionFilter', {
      templateUrl: 'app/projects/project/transactions/transaction-filter.html',
      controller: TransactionFilterController,
      bindings: {
        isCashFlow: '@',
        isReconcile: '@',
        filterData: '=',
        entities: '=',
        accounts: '=',
        categories: '=',
        customFields: '=',
        applyFilter: '&',
        groupingEnabled: '=',
        sourceTypeEnabled: '=',
        reconciliation: '=',
        isReadOnly: '=',
        type: '@'
      }
    });

  function TransactionFilterController(
    $stateParams,
    $mdDialog,
    Transactions,
    RECONCILIATIONS,
    ACCOUNTS) {
    var vm = this;
    vm.toggleEntities = toggleEntities;
    vm.toggleFilter = toggleFilter;
    vm.isFilterSelected = isFilterSelected;
    vm.selectUnselectAll = selectUnselectAll;
    vm.checkSelectAll = checkSelectAll;
    vm.toggleAccounts = toggleAccounts;
    vm.toggleBankAccountTypes = toggleBankAccountTypes;
    vm.toggleCategories = toggleCategories;
    vm.toggleCustomFields = toggleCustomFields;
    vm.toggleKeywordNameOnly = toggleKeywordNameOnly;
    vm.clearFilter = clearFilter;
    vm.clearCategories = clearCategories;
    vm.downloadImage = downloadImage;
    vm.filter = filter;
    vm.openCreateAdjustmentDialog = openCreateAdjustmentDialog;
    vm.selectedAccountCount = 0;
    vm.projectId = $stateParams.projectId;
    this.$onInit = function() {
      vm.availableCategories = [];
      vm.transactionMetadata = Transactions.getMetadata();
      vm.bankAccountTypes = [ACCOUNTS.TYPE.BROKERAGE, ACCOUNTS.TYPE.CHECKING, ACCOUNTS.TYPE.CREDIT_CARD, ACCOUNTS.TYPE.MORTGAGE, ACCOUNTS.TYPE.SAVINGS];
      _setERPAccountsMap();
      _setEntityFilterMap();

      if(vm.filterData.entitiesEnabled) {
        vm.filterData.accounts = [];
      } else {
        vm.filterData.entities = [];
      }
      if(vm.isReconcile) {
        vm.canSaveAdjustment = $stateParams.sourceType !== 'bank' && $stateParams.sourceType !== 'all' && RECONCILIATIONS.STATUS.RECONCILED !== vm.reconciliation.status;
      }

      if(vm.categories) {
        vm.categories.forEach( function(c) {
          var cat = {id: c.id, name: c.name, categoryLabels: []};
          c.categoryLabels.forEach( function (l) {
            if(l.isDefault || l.transactions > 0) {
              cat.categoryLabels.push({id: l.id, name: l.name});
            }
          });
          cat.categoryLabels = _.sortBy(cat.categoryLabels, ['name']);
          vm.availableCategories.push(cat);
        });
        vm.availableCategories = _.sortBy(vm.availableCategories, ['name']);
      }
      vm.accounts = _.sortBy(vm.accounts, ['name']);
      vm.entities = _.sortBy(vm.entities, ['name']);
      if(vm.filterData.customFieldLabel) {
        toggleCustomFields();
      }
      _setSelectedCategory();
    };

    function selectUnselectAll(type) {
      if(!vm[type]) {
        return;
      }
      if(checkSelectAll(type)) { //Unselect
        vm.filterData[type] = [];
      } else { //Add all
        if(type === 'categories' && vm.selectedCategory) {
          vm.filterData[type] = vm.selectedCategory.categoryLabels.map(function(i) { return i.id;});
        } else {
          vm.filterData[type] = vm[type].map(function(i) { return i.id;});
        }
      }
    }

    function checkSelectAll(type) {
      if(vm[type] && vm.filterData[type]) {
        if(type === 'categories' && vm.selectedCategory) {
          return vm.selectedCategory.categoryLabels.length === vm.filterData[type].length;
        } else {
          return vm[type].length === vm.filterData[type].length;
        }
      }
      return false;
    }

    function toggleFilter(type, id) {
      var index = vm.filterData[type].indexOf(id);
      if(index > -1) {
        vm.filterData[type].splice(index, 1);
      } else {
        vm.filterData[type].push(id);
      }
    }

    function isFilterSelected(type, id) {
      // TODO remove this once id's are strings
      id = id.toString();
      return _.includes(vm.filterData[type], id);
    }

    function toggleAccounts() {
      vm.showAccounts = !vm.showAccounts;
    }

    function toggleBankAccountTypes() {
      vm.showBankAccountTypes = !vm.showBankAccountTypes;
    }

    function toggleEntities() {
      vm.showEntities = !vm.showEntities;
    }

    function toggleCategories() {
      vm.showCategories = !vm.showCategories;
    }

    function toggleCustomFields() {
      vm.showCustomFields = !vm.showCustomFields;
    }

    function toggleKeywordNameOnly() {
      vm.filterData.keywordField = vm.filterData.keywordField === 'name' ? '' : 'name';
    }

    function clearFilter() {
      vm.filterData.categories = undefined;
      vm.filterData.customField = null;
      vm.filterData.customFieldLabel = null;
      vm.filterData.accounts = [];
      vm.filterData.bankAccountTypes = [];
      vm.filterData.entities = [];
      vm.filterData.unmatched = false;
      vm.filterData.keyword = '';
      vm.filterData.keywordField = '';
      vm.filterData.transRangeLow = null;
      vm.filterData.transRangeHigh = null;
      vm.filterData.reconciled = false;
      vm.filterData.transactionIds = "";
      vm.filterData.flow = null;
      vm.isReadOnly = false;
      vm.filterData.entitiesEnabled = false;
      if(!vm.isReconcile) {
        vm.filterData.startDate = null;
        vm.filterData.endDate = null;
      } else {
        vm.filterData.startDate = moment(vm.filterData.minStartDate).toDate();
        vm.filterData.endDate = moment(vm.filterData.maxEndDate).toDate();
        vm.startDateError = false;
        vm.endDateError = false;
      }
      if(vm.type === 'audit') {
        vm.filterData.sourceType = 'erp';
      } else {
        vm.filterData.sourceType = 'bank';
      }
      _setSelectedCategory();
    }

    function clearCategories() {
      vm.filterData.categories = [];
    }

    function filter() {
      if(!_validDates()){
        return;
      }
      //Set entities filter if applicable.
      if(vm.filterData.entitiesEnabled) {
        vm.filterData.accounts = [];
        _.forEach(vm.filterData.entities, function(e) {
          vm.filterData.accounts = vm.filterData.accounts.concat(vm.entityAccountMap[e]);
        });
      }
      if(vm.type === 'audit') {
        var erpAccounts = [];
        _.forEach(vm.filterData.accounts, function(a) {
          var erpId = vm.bankToErpMap[a];
          if(erpId) {
            erpAccounts.push(erpId);
          }
        });
        vm.filterData.accounts = vm.filterData.accounts.concat(erpAccounts);
      }
      if(!vm.filterData.transRangeLow || isNaN(vm.filterData.transRangeLow)) {
        delete vm.filterData.transRangeLow;
      }
      if(!vm.filterData.transRangeHigh || isNaN(vm.filterData.transRangeHigh)) {
        delete vm.filterData.transRangeHigh;
      }
      vm.applyFilter();
    }

    function openCreateAdjustmentDialog() {
      $mdDialog.show({
        templateUrl: 'app/projects/engagement/adjustments/create-adjustment-dialog.html',
        controller: 'CreateAdjustmentController',
        locals: {
          filters: vm.filterData
        },
        controllerAs: '$ctrl',
        bindToController: true
      });
    }

    function downloadImage() {
      var viz = document.getElementsByClassName('cashflow-viz');
      var watermarks = document.getElementsByClassName('cashflow-viz-watermark');
      var $viz = $(viz);
      var $force_graph = $viz.find('#force-graph');
      var $svgs = $viz.find('svg');
      if( $svgs.length === 1 && $force_graph.length === 1) {
        _.forEach(watermarks, function(i) {
          $(i).addClass('show');
        });
        var svg = $svgs[0];
        var force_graph = $force_graph[0];
        canvas = document.getElementById("force-graph-canvas");
        canvas.setAttribute('width', force_graph.offsetWidth);
        canvas.setAttribute('height', force_graph.offsetHeight);

        var img = new Image();
        var canvas = document.querySelector('canvas');
        svg.setAttribute('font-family', 'Helvetica');

        //convert SVG into a XML string
        var xml = new XMLSerializer().serializeToString(svg);
        // make it base64
        var svg64 = btoa(xml);
        var b64Start = 'data:image/svg+xml;base64,';
        // prepend a "header"
        var image64 = b64Start + svg64;
        // set it as the source of the img element
        img.src = image64;

        img.onload = function(){
          canvas.getContext('2d').drawImage(img, 0, 0);
          //hide the SVG element
          $(svg).hide();
          $(canvas).show();
          html2canvas(viz[0]).then( function (c) {
            var a = document.createElement('a');
            // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
            a.href = c.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
            a.download = 'cashflow-viz.jpg';
            force_graph.appendChild(a);
            a.click();
            $(canvas).hide();
            $(svg).show();
            a.remove();
            _.forEach(watermarks, function(i) {
              $(i).removeClass('show');
            });
          });
        };
      }
    }

    function _validDates() {
      if(!vm.isReconcile) {
        return true;
      }
      var result = true;
      if(!moment(vm.filterData.startDate).isBetween(vm.filterData.minStartDate, vm.filterData.maxEndDate, 'day', '[]')) {
        vm.startDateError = true;
        result = false;
      }
      if(!moment(vm.filterData.endDate).isBetween(vm.filterData.minStartDate, vm.filterData.maxEndDate, 'day', '[]')) {
        vm.endDateError = true;
        result = false;
      }
      return result;
    }

    function _setERPAccountsMap() {
      //Don't show duplicate linked bank-erp accounts
      if(vm.type === 'audit') {
        vm.bankToErpMap = {};
        _.forEach(vm.accounts, function(a) {
          if(a.type !== ACCOUNTS.TYPE.ERP) {
            var erpAccount = _.find(vm.accounts, function(erp) {
              return erp.name === a.name && erp.type === ACCOUNTS.TYPE.ERP;
            });
            if(erpAccount) {
              vm.bankToErpMap[a.id] = erpAccount.id;
            }
          }
        });

        vm.accounts = _.filter(vm.accounts, function(a) {
          return(a.name === 'Undeposited Funds' || a.type !== ACCOUNTS.TYPE.ERP) && a.enabled === true;
        });

        vm.filterData.accounts = _.filter(vm.filterData.accounts, function(a) {
          return vm.bankToErpMap[a];
        });
      }
    }

    function _setSelectedCategory() {
      // First time in set default categories correctly
      if (vm.filterData.categories === undefined) {
        vm.filterData.categories = [];
        if (vm.categories && vm.categories.length > 0) {
          vm.categories[0].categoryLabels.forEach( function(l) {
            if (l.isDefault || l.transactions > 0) {
              vm.filterData.categories.push(l.id);
            }
          });
        }
      }

      if( vm.filterData.categories.length) {
        vm.selectedCategory = _.find(vm.availableCategories, function(category) {
          return _.find(category.categoryLabels, { id: vm.filterData.categories[0] });
        });
      }
    }

    function _setEntityFilterMap() {
      vm.entityAccountMap = {};
      vm.entities = [];
      _.forEach(vm.accounts, function(a) {
        if(vm.entityAccountMap[a.entity.id]) {
          vm.entityAccountMap[a.entity.id].push(a.id);
        } else {
          vm.entityAccountMap[a.entity.id] = [a.id];
          vm.entities.push(a.entity);
        }
      });
    }
  }
})();

(function() {
  'use strict';

  TransactionDocumentsController.$inject = ["$mdDialog", "$state", "$stateParams", "$timeout", "$scope", "toastr", "dateUtils", "Documents", "DOCUMENT_TYPES", "BROWSER_IMAGE_TYPES", "Transactions", "transaction"];
  angular
    .module('projects')
    .controller('TransactionDocumentsController', TransactionDocumentsController);

  function TransactionDocumentsController(
    $mdDialog,
    $state,
    $stateParams,
    $timeout,
    $scope,
    toastr,
    dateUtils,
    Documents,
    DOCUMENT_TYPES,
    BROWSER_IMAGE_TYPES,
    Transactions,
    transaction) {

    var vm = this;

    vm.canPreviewImage = canPreviewImage;
    vm.transaction = transaction;
    vm.openDocumentUpload = openDocumentUpload;
    vm.downloadDocument = downloadDocument;
    vm.removeDocuments = removeDocuments;
    vm.close = close;

    vm.error = false;
    vm.documents = [];

    activate();

    function activate() {
      loadDocuments();
    }

    function loadDocuments() {
      Transactions.getSupportingDocuments($stateParams.projectId, vm.transaction.id)
        .then( function Success(response) {
          vm.documents = response;
        })
        .catch(function Failure() {
          toastr.error('Failed to fetch transaction supporting documents');
          vm.error = true;
        });
    }

    function openDocumentUpload(documentType) {
      vm.documentType = documentType;
      Documents.getUploadParameters($state.params.projectId)
        .then(function Success(response) {
          $mdDialog.show({
            templateUrl: 'app/projects/project/documents/add-document.html',
            controller: 'AddDocumentController',
            controllerAs: '$ctrl',
            bindToController: true,
            multiple: true,
            locals: {
              documentType: DOCUMENT_TYPES.TX_SUP_DOC.type,
              accountId: vm.transaction.account.id,
              transactionId: vm.transaction.id,
              uploadParameters: response.data
            },
            onRemoving: function() {
              loadDocuments();
            }
          });
        })
        .catch(function Failure(response) {
          toastr.error(response.data.message);
        });
    }

    function removeDocuments() {
      var deleteDocIds = [];
      _.forEach(vm.documents, function(d) {
        if(d.selected) {
          deleteDocIds.push(d.id);
        }
      });
      if(deleteDocIds.length > 0) {
        Transactions.removeSupportingDocuments($stateParams.projectId, vm.transaction.id, deleteDocIds)
          .then( function Success() {
            vm.isConfirmRemove = false;
            toastr.success('Supporting documents deleted');
            loadDocuments();
            $state.reload();
          })
          .catch(function Failure() {
            toastr.error('An error ocurred.');
          });
      }
    }

    function close() {
      if(vm.isConfirmRemove) {
        vm.isConfirmRemove = !vm.isConfirmRemove;
      } else {
        $mdDialog.cancel();
      }
    }

    function downloadDocument(url){
      window.open(url);
    }

    function canPreviewImage(mimeType) {
      return BROWSER_IMAGE_TYPES.indexOf(mimeType) >= 0;
    }

  }
})();

(function() {
  'use strict';

  TransactionDetailController.$inject = ["$window", "transaction"];
  angular
    .module('projects')
    .controller('TransactionDetailController', TransactionDetailController);

  function TransactionDetailController(
    $window,
    transaction) {
    var vm = this;
    vm.transaction = transaction;
    vm.goBack = goBack;

    function goBack() {
      $window.history.back();
    }

  }
})();

(function() {
  'use strict';

  EditTransactionController.$inject = ["toastr", "$mdDialog", "$state", "$timeout", "$scope", "$document", "TRANSACTION_TYPES", "CHECK_ITEMS", "Transactions", "CheckItems", "Authorization", "RBAC", "categories", "customFields", "gridApi", "index"];
  angular
    .module('projects')
    .controller('EditTransactionController', EditTransactionController);

  function EditTransactionController(
    toastr,
    $mdDialog,
    $state,
    $timeout,
    $scope,
    $document,
    TRANSACTION_TYPES,
    CHECK_ITEMS,
    Transactions,
    CheckItems,
    Authorization,
    RBAC,
    categories,
    customFields,
    gridApi,
    index) {

    var vm = this;

    vm.types = _getValidTypes();
    vm.gridApi = gridApi;
    vm.categories = categories;
    vm.customFields = customFields;
    vm.availableLabels = {};
    vm.nodeVizCategories = {};
    vm.nodeFields = {};
    vm.saving = false;
    vm.index = index;

    vm.details = false;

    vm.isTransaction = false;

    vm.node = null;
    vm.prevNode = null;
    vm.nextNode = false;

    vm.toggleDetails = toggleDetails;
    vm.goNext = goNext;
    vm.goPrevious = goPrevious;
    vm.closeEditTransaction = closeEditTransaction;
    vm.updateTransaction = updateTransaction;

    activate();

    function activate() {      
      vm.categories.forEach(function (c) {
        vm.availableLabels[c.id] = c.categoryLabels;
      });
      _initNavigation();
      document.addEventListener("keydown", _keyBinds);
      $timeout(function (){ angular.element('#txn_description_edit').focus().select(); }, 800);
    }

    function closeEditTransaction() {
      document.removeEventListener("keydown", _keyBinds);
      $mdDialog.cancel();
    }

    function toggleDetails() {
      vm.details = !vm.details;
      $scope.$applyAsync();
    }

    function goNext() {
      if(!vm.nextNode) {
        return;
      }
      //dave_g:: can't do this now, we need to find the next valid node, not simply the next one
      //vm.index++;
      vm.index = vm.nextNode.rowIndex;
      _initNavigation();
    }

    function goPrevious() {
      if(!vm.prevNode) {
        return;
      }
      //dave_g:: can't do this now, we need to find the next valid node, not simply the previous one
      //vm.index--;
      vm.index = vm.prevNode.rowIndex;
      _initNavigation();
    }

    function _getNextValidNode( index ) {
      var nextnode = null;
      for ( var i = ++index; i < 1000 + index; i++ ) {
        nextnode = vm.gridApi.getDisplayedRowAtIndex( i );
        if ( nextnode && nextnode.data && nextnode.data.rowType && nextnode.data.rowType != "aggregation" ) {
          return nextnode;
        }
      }
      return nextnode;
    }

    function _getPrevValidNode( index ) {
      var prevnode = null;
      for ( var i = --index;  i >= 0; i-- ) {
        prevnode = vm.gridApi.getDisplayedRowAtIndex( i );
        if ( prevnode && prevnode.data && prevnode.data.rowType && prevnode.data.rowType != "aggregation" ) {
          return prevnode;
        }
      }
      return prevnode;
    }

    function _initNavigation() {
      
      vm.node = vm.gridApi.getDisplayedRowAtIndex(vm.index);
      if ( vm.node && vm.node.data && vm.node.data.rowType && vm.node.data.rowType == "aggregation" ) {
        //console.log("error: current node is a aggregation node", vm.node);
        vm.node = null;
        return;
      }

      vm.isTransaction = false;
      if ( vm.node.data.rowType == TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION ) {
        vm.isTransaction = true;
      }

      //dave_g: we do not want to display rows that are "Totals" rows (sums of all the items above it)
      //Rows that are not txns or checks are not selectable, so rather than slim down the entire list
      //I am just looking ahead or behind to skip over the rows that are ones we are interested in
      //vm.prevNode = vm.gridApi.getDisplayedRowAtIndex( vm.index );
      //vm.nextNode = vm.gridApi.getDisplayedRowAtIndex( vm.index );
      
      vm.prevNode = _getPrevValidNode( vm.index );
      vm.nextNode = _getNextValidNode( vm.index );

      if(vm.node) {
        var label;
        var customField;
        vm.editTransaction = angular.copy(vm.node.data);

        //fix up the data container to handle both transactions as well as check items
        if ( vm.editTransaction.rowType == "check" ) {
          vm.editTransaction.payor = vm.editTransaction.checkItem.payor;
          vm.editTransaction.payee = vm.editTransaction.checkItem.payee;
          vm.editTransaction.memo = vm.editTransaction.checkItem.memo;
          vm.editTransaction.date = vm.editTransaction.checkItem.date;
        }

        if(vm.categories) {
          vm.categories.forEach(function (c) {
            vm.nodeVizCategories[c.id] = {};
            label = vm.editTransaction.categoryLabels.find( function(l) { return l.categoryId === c.id; });
            if(label) {
              vm.nodeVizCategories[c.id] = label;
            } else {
              vm.nodeVizCategories[c.id] = c.categoryLabels.find( function(l) { return l.isDefault === true; } );
            }
          });
        }

        if(vm.customFields) {
          vm.customFields.forEach(function (f) {
            vm.nodeFields[f.id] = { id: f.id, name: f.name, value: ''};
            customField = vm.editTransaction.customFields.find( function(i) { return i.id === f.id; });
            if(customField) {
              vm.nodeFields[f.id].value = customField.value;
            }
          });
        }
      }
      $scope.$applyAsync();
      $timeout(function (){ angular.element('#txn_description_edit').focus().select(); }, 800);
    }

    function _keyBinds(e) {
      if(e.metaKey || e.ctrlKey) {
        switch(e.key) {
        case 'ArrowUp':
          e.preventDefault();
          vm.details && toggleDetails();
          break;
        case 'ArrowDown':
          e.preventDefault();
          !vm.details && toggleDetails();
          break;
        case 'ArrowRight':
          e.preventDefault();
          goNext();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          goPrevious();
          break;
        }
      } else if (e.key === 'Escape') {
        closeEditTransaction();
      }
    }

    function _getValidTypes() {
      var types = [];
      Object.keys(TRANSACTION_TYPES.TYPE_DESCRIPTION).forEach(function (k) {
        if(k !== TRANSACTION_TYPES.TYPE.INTERNAL_TRANSFER) {
          types.push(k);
        }
      });
      return types;
    }

    function updateTransaction() {
      vm.saving = true;
      
      var categoryLabels = [];
      var customFields = [];
      Object.keys(vm.nodeVizCategories).forEach( function(k) {
        var label = vm.nodeVizCategories[k];
        if(!label.isDefault) {
          categoryLabels.push(label);
        }
      });
      Object.keys(vm.nodeFields).forEach( function(k) {
        var field = vm.nodeFields[k];
        if(field.value !== '') {
          customFields.push(field);
        }
      });

      if ( vm.editTransaction.rowType == TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION ) {
        vm.editTransaction.categoryLabels = categoryLabels;
        vm.editTransaction.customFields = customFields;
        Transactions.fullUpdate(vm.editTransaction.id, vm.editTransaction)
          .then(function Success() {
            vm.node.setData(vm.editTransaction);  //only update the table if we successfully set the backend
            vm.saving = false;
          });
      } else if ( vm.editTransaction.rowType == TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM) {
        //for checkItems, pass vis/custom categories only
        vm.editTransaction.checkItem.categoryLabels = categoryLabels;
        vm.editTransaction.checkItem.customFields = customFields;
        
        //setting this so I can force the row to update the display
        vm.editTransaction.customFields = customFields;
        vm.editTransaction.categoryLabels = categoryLabels;

        //note that I am actually sending down a checkItem, not the editTransaction parent object
        CheckItems.fullUpdate(vm.editTransaction.checkItem.id, vm.editTransaction.checkItem)
          .then(function Success() {
            vm.node.setData(vm.editTransaction); //only update the table if we successfully set the backend
            vm.saving = false;
          });
      } else {
        //we should throw an exception here since we can't tell what type we are working with
        toastr.error('Error updating transaction due to unknown row type. Please notify Valid8 Support.');
        vm.saving = false;
      }
    }

  }
})();

(function() {
  'use strict';

  Reports.$inject = ["DS", "REPORTS"];
  angular
    .module('projects')
    .factory('Reports', Reports);

  function Reports(DS, REPORTS) {
    var LOADING_STATUSES = [
      REPORTS.STATUS.STARTED,
      REPORTS.STATUS.ASSEMBLING
    ];
    var metadata;
    var reports = DS.defineResource({
      name: 'reports',
      endpoint: 'reports',
      idAttribute: 'id',
      // TODO once JSData can handle metadata remove this
      cacheResponse: false,
      deserialize: function(config, res) {
        metadata = res.data.metadata;
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    reports.getMetadata = function() {
      return metadata;
    };

    reports.isLoading = function(status) {
      return status ? LOADING_STATUSES.indexOf(status) >= 0 : false;
    };

    return reports;
  }
})();

(function() {
  'use strict';

  ReportListTableController.$inject = ["$state", "$mdDialog", "$filter", "tableUtils", "Reports", "Authorization", "REPORTS"];
  angular
    .module('projects')
    .component('reportListTable', {
      templateUrl: 'app/projects/project/reports/report-list-table.html',
      bindings: {
        reports: '<',
        accounts: '<',
        entities: '<'
      },
      controller: ReportListTableController
    });

  function ReportListTableController(
    $state,
    $mdDialog,
    $filter,
    tableUtils,
    Reports,
    Authorization,
    REPORTS) {

    var vm = this;
    var GRID_ID = 'grid-reports';
    var GRID_VERSION = 2;
    vm.reloadData = reloadData;

    this.$onInit = function() {
      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.columnDefs = [
        {
          headerName: 'Download',
          width: 80,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          cellClass: 'links icons',
          cellRenderer: function(params) {
            if(!params.data || !params.data.downloadUrl) {
              return '<md-icon class="material-icons icon-primary icon-disabled">get_app</md-icon>';
            }
            return '<a class="file-name" target="_blank" href="' + params.data.downloadUrl + '"><md-icon class="material-icons icon-primary">get_app</md-icon></a>';
          }
        },
        {
          headerName: 'Delete',
          width: 60,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          hide: !Authorization.isV8Admin(),
          suppressColumnsToolPanel: !Authorization.isV8Admin(),
          cellClass: 'links icons',
          cellRenderer: function() {
            return '<md-icon class="material-icons icon-primary">delete</md-icon>';
          },
          onCellClicked: function(params) {
            return _deleteReport(params.data);
          }
        },
        {
          headerName: 'Status',
          field: 'status',
          width:80,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            return '<report-status-sync status="data.status" report-id="data.id" reload="$ctrl.reloadData()"></report-status-sync>';
          },
          getQuickFilterText: function(params) {
            return REPORTS.STATUS_DESCRIPTION[params.value];
          }
        },
        {
          headerName: 'Name',
          field: 'name',
          width: 250
        },
        {
          headerName: 'Type',
          field: 'type',
          width: 80,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return REPORTS.TYPE_DESCRIPTION[params.value];
          }
        },
        {
          headerName: 'Filters',
          field: 'data',
          sortable: false,
          width: 250,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            return _formatFilters(params.value);
          },
          onCellClicked: function(params) {
            _openFiltersDialog(params.value);
          }
        },
        {
          headerName: 'Created',
          field: 'createdAt',
          width: 120,
          valueFormatter: function(params) {
            return $filter('dateTimeFilter')(params.value);
          }
        },
        {
          headerName: 'Created By',
          field: 'requestUser',
          width: 120,
        },
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        rowData: vm.reports,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        getMainMenuItems: tableUtils.getMainMenuItems,
        angularCompileRows: true,
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange
      };
    };

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID, GRID_VERSION);
      if(!tableUtils.getGridState(GRID_ID, GRID_VERSION)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID, GRID_VERSION);
    }

    function reloadData() {
      $state.reload();
    }

    function _formatFilters(filters) {
      var result = '<md-icon class="material-icons icon-primary icon-hover">poll</md-icon>';
      if(filters.query) {
        var query = filters.query;
        if(query.startDate && query.endDate) {
          result += 'Date Range: (' + $filter('dateDisplay')(query.startDate) + ' - ' + $filter('dateDisplay')(query.endDate) + '),';
        } else {
          result += 'Date Range: (all),';
        }
        if(query.accounts && query.entitiesEnabled === 'false') {
          var filteredAccounts = _.isArray(query.accounts) ? query.accounts : [query.accounts];
          result += ' Accounts: ' + filteredAccounts.length + ' of ' + vm.accounts.length + ',';
        } else {
          result += ' Accounts: (all),';
        }
        if(query.entities && query.entitiesEnabled === 'true') {
          var filteredEntities = _.isArray(query.entities) ? query.entities : [query.entities];
          result += ' Entities: ' + filteredEntities.length + ' of ' + vm.entities.length;
        } else {
          result += ' Entities: (all)';
        }
      }
      return result;
    }

    function _openFiltersDialog(filters) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/reports/report-filters-dialog.html',
        controller: 'ReportFiltersController',
        locals: {
          filters: filters,
          accounts: vm.accounts,
          entities: vm.entities
        },
        controllerAs: '$ctrl',
        bindToController: true
      });
    }

    function _deleteReport(report) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/reports/delete-report-dialog.html',
        controller: 'DeleteReportController',
        locals: {
          report: report
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success() {
        if (vm.gridOptions.api) {
          vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        }
      });
    }
  }
})();

(function() {
  'use strict';

  ReportFiltersController.$inject = ["$mdDialog", "$state", "$scope", "$filter", "toastr", "accounts", "entities", "filters"];
  angular
    .module('projects')
    .controller('ReportFiltersController', ReportFiltersController);

  function ReportFiltersController(
    $mdDialog,
    $state,
    $scope,
    $filter,
    toastr,
    accounts,
    entities,
    filters) {

    var vm = this;
    vm.filters = filters;
    vm.close = close;

    vm.dates = null;
    vm.filteredAccounts = [];
    vm.filteredEntities = [];
  
    this.$onInit = function() {
      if(vm.filters && vm.filters.query) {
        var query = vm.filters.query;
        if(query.startDate && query.endDate) {
          vm.dates = 'Date Range: (' + $filter('dateDisplay')(query.startDate) + ' - ' + $filter('dateDisplay')(query.endDate) + ')';
        } else {
          vm.dates = 'Date Range: (all)';
        }
        if(query.entities && query.entitiesEnabled === 'true') {
          var filteredEntIds = _.isArray(query.entities) ? query.entities : [query.entities];
          var entityMap = {};
          _.forEach(vm.entities, function(e) {
            entityMap[e.id] = e;
          });
          _.forEach(filteredEntIds, function(i) {
            vm.filteredEntities.push(entityMap[i]);
          });
        }

        if(query.accounts && query.entitiesEnabled === 'false') {
          var filteredAccIds = _.isArray(query.accounts) ? query.accounts : [query.accounts];
          var accountMap = {};
          _.forEach(vm.accounts, function(a) {
            accountMap[a.id] = a;
          });
          _.forEach(filteredAccIds, function(i) {
            vm.filteredAccounts.push(accountMap[i]);
          });
        }
        vm.transactionMin = query.transRangeLow || '(all)';
        vm.transactionMax = query.transRangeHigh || '(all)';
        vm.transactionAbs = query.transRangeAbs || 'false';
        vm.transactionFlow = query.flow || '(all)';
      }
    };

    function close() {
      $mdDialog.cancel();
    }
  }
})();

(function() {
  'use strict';

  DeleteReportController.$inject = ["$mdDialog", "$state", "toastr", "$stateParams", "Reports"];
  angular
    .module('projects')
    .controller('DeleteReportController', DeleteReportController);

  function DeleteReportController(
    $mdDialog,
    $state,
    toastr,
    $stateParams,
    Reports) {
    var vm = this;
    vm.cancel = $mdDialog.cancel;
    vm.deleteReport = deleteReport;

    function deleteReport() {
      var reportName = (vm.report.name) ? vm.report.name : 'Workpaper';
      Reports.destroy(vm.report.id)
        .then(function Success() {
          toastr.success(reportName + ' has been successfully deleted.');
          $mdDialog.hide();
          $state.reload();
        }).catch(
          function Failure() {
            $mdDialog.show({
              templateUrl: 'app/core/utils/alert-dialog/alert-dialog.html',
              controller: 'AlertDialogController',
              controllerAs: '$ctrl',
              bindToController: true,
              locals: {
                message: 'There was an error deleting the file, please try again...'
              }
            });
          }
        );
    }
  }
})();

(function() {
  'use strict';

  angular.module('matching', [
    'core'
  ]);
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "MATCH_TYPES"];
  angular
    .module('matching')
    .config(routerConfig);

  function routerConfig($stateProvider, MATCH_TYPES) {
    $stateProvider
      .state('project.matching', {
        url: '/matching?type&status&quality',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/matching/matching.html',
            controller: 'MatchingController as $ctrl'
          }
        },
        params: {
          type: MATCH_TYPES.INT_TRANS,
        },
        resolve: {
          matchJobs: ["$stateParams", "MatchJobs", "MATCH_JOB_STATUS", function($stateParams, MatchJobs, MATCH_JOB_STATUS) {
            var params = {
              projectId: $stateParams.projectId,
              matchTypeName: $stateParams.type,
              status: [MATCH_JOB_STATUS.STARTED, MATCH_JOB_STATUS.RUNNING, MATCH_JOB_STATUS.IMPORTING]
            };
            return MatchJobs.findAll(params, {bypassCache: true});
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  MatchingController.$inject = ["matchJobs"];
  angular
    .module('projects')
    .controller('MatchingController', MatchingController);

  function MatchingController(matchJobs) {
    var vm = this;
    vm.matchJobs = matchJobs;
  }
})();

(function() {
  'use strict';

  MatchingTableController.$inject = ["$filter", "$scope", "$state", "$stateParams", "tableUtils", "Authorization", "RBAC", "PROJECT_TYPES", "Matches", "Categories", "MATCH_STATUSES", "MATCH_TYPES", "MATCH_QUALITIES", "$mdDialog", "toastr"];
  angular
    .module('matching')
    .component('matchingTable', {
      templateUrl: 'app/projects/project/matching/matching-table.html',
      bindings: {
        matches: '<',
        matchJobs: '<'
      },
      controller: MatchingTableController
    });

  function MatchingTableController(
    $filter,
    $scope,
    $state,
    $stateParams,
    tableUtils,
    Authorization,
    RBAC,
    PROJECT_TYPES,
    Matches,
    Categories,
    MATCH_STATUSES,
    MATCH_TYPES,
    MATCH_QUALITIES,
    $mdDialog,
    toastr) {
    var vm = this;
    var GRID_ID = 'grid-matches';
    var GRID_VERSION = 2;
    vm.setType = setType;
    vm.setStatus = setStatus;
    vm.reloadData = reloadData;
    vm.confirmMatches = confirmMatches;
    vm.isCustomerAdminOrEngagementOwner = isCustomerAdminOrEngagementOwner;
    vm.setApprovePage = setApprovePage;
    vm.setRejectPage = setRejectPage;
    vm.setApproveAll = setApproveAll;
    vm.findNewMatches = findNewMatches;
    vm.resetMatches = resetMatches;
    vm.approveMatches = [];
    vm.rejectMatches = [];
    vm.matchesData = [];
    vm.approvePage = false;
    vm.rejectPage = false;
    vm.findingMatches = false;

    this.$onInit = function() {
      vm.categories = Categories.filterByProject($state.params.projectId);
      if(vm.matchJobs.length > 0) {
        vm.findingMatches = true;
      }
      setActiveFilters();

      vm.pagination = tableUtils.getPagingParams($state.params);

      vm.columnDefs = [
        {
          headerName: 'ID',
          width: 55,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          pinned: 'left',
          cellClass: 'icons',
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            var infoMatchId = '';
            if (params.data && params.data.matchIndex >= 0){
              infoMatchId = '<span>' + (params.data.matchIndex + 1) + '</span>';
            }
            return infoMatchId;
          }
        },
        {
          headerName: 'Amount',
          width: 100,
          field: 'amount',
          cellClass: ['grid-amount'],
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('currencyDisplayFilter')(params.value, params.data.account.currency);
          }
        },
        {
          headerName: 'Date',
          width: 100,
          field: 'date',
          cellStyle: {textAlign: "center"},
          sortable: false,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('dateDisplay')(params.value);
          }
        },
        { headerName: 'Description', field: 'description', width: 250, sortable: false },
        { headerName: 'Name', field: 'name', width: 150 },
        { headerName: 'Memo', field: 'memo', width: 150 },
        { headerName: 'Account', field: 'account.number', width: 150, sortable: false },
        { headerName: 'Acct Name', field: 'account.name', width: 250, sortable: false },
        {
          headerName: 'Acct Type',
          field: 'account.type',
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('accountTypeDisplay')(params.value);
          },
          width: 150
        },
        { headerName: 'Institution', field: 'account.bank', width: 150, sortable: false },
        { headerName: 'Entity', field: 'account.entity.name', width: 250, sortable: false },
        {
          headerName: 'Page',
          field: 'page',
          width: 60,
          cellStyle: {textAlign: "center"},
          cellRenderer: function(params) {
            if( !params.data ) {
              return '';
            }
            if(params.value === null) {
              return 0;
            } else if(params.data) {
              var pageNumber = parseInt(params.value) + 1;   //Backend statement pages index is zero based.
              if(params.data.downloadUrl) {
                var link = params.data.downloadUrl;
                link = link + '#page=' + pageNumber;
                return '<a target="_blank" href="' + link + '">' + pageNumber + '</a>';
              } else {
                return pageNumber;
              }
            }
          }
        },
        {
          headerName: 'Match',
          width: 70,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          cellClass: 'match-icons',
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            var dataIcons = '';
            if (params.data && params.data.matchIndex >= 0) {
              if (vm.status === MATCH_STATUSES.REJECTED) {
                dataIcons = '<md-icon id="Check' + params.data.matchId + '" class="material-icons icon-primary check left-margin" data-action-type="check">check_circle</md-icon>';
              }
              else if (vm.status === MATCH_STATUSES.CONFIRMED) {
                dataIcons = '<md-icon id="Denied' + params.data.matchId + '" class="material-icons icon-primary denied left-margin" data-action-type="denied">not_interested</md-icon>';
              }
              else {
                dataIcons = '<md-icon id="Check' + params.data.matchId + '" class="material-icons icon-primary check" data-action-type="check">check_circle</md-icon>' +
                  '<md-icon id="Denied' + params.data.matchId + '" class="material-icons icon-primary denied" data-action-type="denied">not_interested</md-icon>';
              }
            }
            return dataIcons;
          },
          onCellClicked: function(e) {
            if (e.event.target !== undefined) {
              var data = e.data,
                matchId = data.matchId,
                checkIdIcon = '#Check' + data.matchId,
                deniedIdIcon = '#Denied' + data.matchId,
                actionType = e.event.target.getAttribute("data-action-type");

              switch (actionType) {
              case "check":
                $(e.event.target).toggleClass("checked");
                $(deniedIdIcon).removeClass("checked");
                if ($(e.event.target).hasClass("checked")){
                  vm.approveMatches.push(matchId);
                  vm.rejectMatches = vm.rejectMatches.filter(function(item) {
                    return item !== matchId;
                  });
                }
                else {
                  vm.approveMatches = vm.approveMatches.filter(function(item) {
                    return item !== matchId;
                  });
                }
                break;

              case "denied":
                $(e.event.target).toggleClass("checked");
                $(checkIdIcon).removeClass("checked");
                if ($(e.event.target).hasClass("checked")){
                  vm.rejectMatches.push(matchId);
                  vm.approveMatches = vm.approveMatches.filter(function(item) {
                    return item !== matchId;
                  });
                }
                else {
                  vm.rejectMatches = vm.rejectMatches.filter(function(item) {
                    return item !== matchId;
                  });
                }
                break;
              }
            }
            return $(e.event.target);
          }
        },
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        rowSelection: 'multiple',
        cacheBlockSize: vm.pagination.pageSize * 2,  //Rows in this grid is 2x amount of matches...
        rowModelType: 'serverSide',
        getMainMenuItems: tableUtils.getMainMenuItems,
        suppressRowClickSelection: true,
        onSortChanged: vm.reloadData,
        rowClassRules: {
          'gray-row': 'data && data.group % 2 !== 0'
        },
        onBodyScroll: function() {
          vm.approveMatches.forEach( function(matchId) {
            var checkIdIcon = '#Check' + matchId;
            $(checkIdIcon).addClass("checked");
          });
          vm.rejectMatches.forEach( function(matchId) {
            var deniedIdIcon = '#Denied' + matchId;
            $(deniedIdIcon).addClass("checked");
          });
        },
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange
      };
    };

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID, GRID_VERSION);
      vm.gridOptions.api.setServerSideDatasource(_createDataSource());
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID, GRID_VERSION);
    }

    function isCustomerAdminOrEngagementOwner() {
      // This controller is only ever used for investigations currently
      return Authorization.isV8Admin() || Authorization.hasRole(RBAC.ROLES.CUSTOMER_ADMIN) || 
        Authorization.hasProjectAccess(PROJECT_TYPES.FORENSIC, $state.params.projectId, [], [RBAC.ROLES.ENGAGEMENT_OWNER]);
    }

    function setActiveFilters() {
      var type = ($state.params.type) ? $state.params.type : MATCH_TYPES.INT_TRANS,
        typeClass = '.' + type,
        status = ($state.params.status) ? $state.params.status : MATCH_STATUSES.CONFIRMED,
        statusClass = '.' + status,
        quality = ($state.params.quality) ? $state.params.quality : MATCH_QUALITIES.ALL,
        qualityClass = '.' + quality;

      vm.type = type;
      vm.status = status;
      vm.quality = quality;

      $('.types-menu').find(typeClass).addClass('active-tab');
      $('.status-menu').find(statusClass).addClass('active').parent().addClass('active ' + status);
      $('.filters').find(qualityClass).addClass('active');
    }

    function setType(type) {
      $state.go('project.matching', { type: type, status : MATCH_STATUSES.FOUND, quality: MATCH_QUALITIES.ALL});
    }

    function setStatus(status) {
      $state.go('project.matching', { status: status, quality: MATCH_QUALITIES.ALL });
    }

    function reloadData(opts) {
      if(opts && opts.pageSize) {
        vm.pagination.pageSize = opts.pageSize;
        vm.gridOptions.paginationPageSize = opts.pageSize;
        vm.gridOptions.api.setServerSideDatasource(_createDataSource());
      }
      var sortModel = vm.gridOptions.api.getSortModel();
      if(sortModel.length) {
        vm.pagination.sortModel = sortModel[0].colId;
        vm.pagination.sortOrder = sortModel[0].sort;
      } else {
        vm.pagination.sortModel = null;
        vm.pagination.sortOrder = null;
      }

      vm.pagination.skipCount = 0;
      $state.go($state.current, vm.pagination, { notify: false });
      vm.gridOptions.api.setServerSideDatasource(_createDataSource());
    }

    function _createDataSource() {
      return {
        getRows: function(params) {
          var matchingParams;
          // Load resolved matches for initial call
          if(vm.matches) {
            matchingParams = angular.extend({
              projectId: $state.params.projectId,
              type: vm.type,
              downloadUrl: true,
              status: vm.status,
              quality: (vm.quality !== MATCH_QUALITIES.ALL) ? vm.quality : ''
            }, tableUtils.formatPagingParams(vm.pagination));

            Matches.findAll(matchingParams).then(
              function Success(data) {
                vm.statusInfo = Matches.getMetadata();
                vm.isConfirmMatch = data.length;
                vm.matchesData = data;
                var rowData = [];
                data.forEach( function(nodeData) {
                  nodeData.transactions.forEach( function(transaction) {
                    rowData.push(transaction);
                  });
                });

                params.successCallback(rowData, Matches.getMetadata().total * 2); //#of matches * 2 = transactions (rows)
              }
            );
          } else {
            // Fire api call for paging
            // Work around until ag grid pagination api is revised
            vm.pagination.skipCount = params.request.startRow / 2; //rows represent transactions, /2 are matches
            matchingParams = angular.extend({
              projectId: $state.params.projectId,
              type: vm.type,
              downloadUrl: true,
              status: vm.status,
              quality: (vm.quality !== MATCH_QUALITIES.ALL) ? vm.quality : ''
            }, tableUtils.formatPagingParams(vm.pagination));

            Matches.findAll(matchingParams).then(
              function Success(data) {
                vm.statusInfo = Matches.getMetadata();
                vm.isConfirmMatch = data.length;
                vm.matchesData = data;
                var rowData = [];
                data.forEach( function(matchData, index) {
                  var matchId = matchData.id,
                    matchIndex = index;
                  matchData.transactions.forEach( function(transaction, index) {
                    if (index === 0) {
                      transaction.matchId = matchId;
                      transaction.matchIndex = matchIndex + vm.pagination.skipCount;
                    }
                    transaction.group = matchIndex;
                    rowData.push(transaction);
                  });
                });
                params.successCallback(rowData, Matches.getMetadata().total * 2); //#of matches * 2 = transactions (rows)
              }
            );
          }
        }
      };
    }

    function confirmMatches() {
      var data = {
        confirmed: vm.approveMatches,
        rejected: vm.rejectMatches
      };

      Matches.updateMatches($stateParams.projectId, data).then(
        function Success() {
          vm.approveAll = vm.rejectAll = false;
          vm.reloadData();
        }
      );
    }

    function setApprovePage() {
      vm.approveMatches = [];
      vm.rejectMatches = [];
      vm.approveAll = !vm.approveAll;

      if (vm.approveAll) {
        vm.rejectAll = false;
        vm.matchesData.forEach( function(matchData) {
          var matchId = matchData.id,
            checkIdIcon = '#Check' + matchId;
          $(checkIdIcon).addClass("checked");
          vm.approveMatches.push(matchId);
        });
      } else {
        $('.check').removeClass("checked");
      }
      $('.denied').removeClass("checked");
    }

    function setRejectPage() {
      vm.approveMatches = [];
      vm.rejectMatches = [];
      vm.rejectAll = !vm.rejectAll;

      if (vm.rejectAll) {
        vm.approveAll = false;
        vm.matchesData.forEach( function(matchData) {
          var matchId = matchData.id,
            deniedIdIcon = '#Denied' + matchId;
          $(deniedIdIcon).addClass("checked");
          vm.rejectMatches.push(matchId);
        });
      } else {
        $('.denied').removeClass("checked");
      }
      $('.check').removeClass("checked");
    }

    function setApproveAll() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/matching/approve-all-dialog.html',
        controller: 'ApproveAllController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          foundInfo: vm.statusInfo[ MATCH_STATUSES.FOUND],
          matchType: vm.type
        }
      }).then(function Success() {
        $state.go('project.matching', { status: MATCH_STATUSES.CONFIRMED, quality: MATCH_QUALITIES.ALL });
      });
    }

    function resetMatches() {
      if(!isCustomerAdminOrEngagementOwner()) {
        return;
      }
      if(!confirm('By confirming this action, all internal transfer matches will be removed.')) {
        return;
      }

      Matches.resetMatches($state.params.projectId, vm.type).then(
        function Success() {
          toastr.success('Matches removed');
          vm.reloadData();
        }
      );
    }

    function findNewMatches() {
      Matches.findMatches($state.params.projectId, vm.type).then(
        function Success() {
          vm.findingMatches = true;
          toastr.success('The system is looking for new matches, please check back in a few minutes...');
          vm.reloadData();
        }
      );
    }
  }
})();

(function() {
  'use strict';

  Matches.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('projects')
    .factory('Matches', Matches);

  function Matches(DS, DSHttpAdapter) {
    var metadata;
    var matches = DS.defineResource({
      name: 'matches',
      endpoint: 'matches',
      idAttribute: 'id',
      cacheResponse: false,
      deserialize: function(config, res) {
        if(res.data.metadata) {
          metadata = res.data.metadata;
        }
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });
    //NOTE: Matches cannot be created from the UI. The Create (POST) method will launch a find matches job in the backend.

    matches.getMetadata = function() {
      return metadata;
    };

    matches.updateMatches = function(projectId, data) {
      return DSHttpAdapter.HTTP({
        method: 'POST',
        url: DSHttpAdapter.defaults.basePath + '/matches/batch',
        data: data,
        params:{ projectId: projectId, action: 'update' }
      });
    };

    matches.resetMatches = function(projectId, type) {
      return DSHttpAdapter.HTTP({
        method: 'POST',
        url: DSHttpAdapter.defaults.basePath + '/matches/batch',
        data: { matchType: type },
        params: { projectId: projectId, action: 'reset' }
      });
    };

    matches.findMatches = function(projectId, type) {
      return DSHttpAdapter.HTTP({
        method: 'POST',
        url: DSHttpAdapter.defaults.basePath + '/matches',
        params: { projectId: projectId, matchType: type },
        data: {}
      });
    };

    return matches;
  }
})();

(function() {
  'use strict';

  MatchTypes.$inject = ["DS"];
  angular
    .module('projects')
    .factory('MatchTypes', MatchTypes);

  function MatchTypes(DS) {
    var matchTypes = DS.defineResource({
      name: 'matchTypes',
      endpoint: 'matchTypes',
      idAttribute: 'id',
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    return matchTypes;
  }
})();

(function() {
  'use strict';

  MatchJobs.$inject = ["DS"];
  angular
    .module('projects')
    .factory('MatchJobs', MatchJobs);

  function MatchJobs(DS) {
    var metadata;
    var matches = DS.defineResource({
      name: 'matchJobs',
      endpoint: 'match-jobs',
      idAttribute: 'id',
      cacheResponse: false,
      deserialize: function(config, res) {
        metadata = res.data.metadata;
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    matches.getMetadata = function() {
      return metadata;
    };

    return matches;
  }
})();

(function() {
  'use-strict';

  ApproveAllController.$inject = ["$mdDialog", "$state", "$stateParams", "foundInfo", "matchType", "Matches", "MATCH_QUALITIES"];
  angular
    .module('projects')
    .controller('ApproveAllController', ApproveAllController);

  function ApproveAllController(
    $mdDialog,
    $state,
    $stateParams,
    foundInfo,
    matchType,
    Matches,
    MATCH_QUALITIES) {
    var vm = this;
    vm.foundInfo = foundInfo;
    vm.matchType = matchType;
    vm.cancel = $mdDialog.cancel;
    vm.approveAll = approveAll;
    vm.toggleQualities = toggleQualities;
    vm.selectedQualities = [];
    vm.qualities = [
      {
        label: 'Very Likely',
        description: MATCH_QUALITIES.VERY_LIKELY,
        counter: foundInfo[MATCH_QUALITIES.VERY_LIKELY]
      },
      {
        label: 'Probable',
        description: MATCH_QUALITIES.PROBABLE,
        counter: foundInfo[MATCH_QUALITIES.PROBABLE]
      },
      {
        label: 'Possible',
        description: MATCH_QUALITIES.POSSIBLE,
        counter: foundInfo[MATCH_QUALITIES.POSSIBLE]
      }
    ];

    function toggleQualities(quality) {
      var index = vm.selectedQualities.indexOf(quality);

      if(index > -1) {
        vm.selectedQualities.splice(index, 1);
      } else {
        vm.selectedQualities.push(quality);
      }
    }

    function approveAll() {
      $mdDialog.hide(true);
      $state.reload();
      var data = {
        matchType: vm.matchType,
        matchQuality: vm.selectedQualities
      };

      Matches.updateMatches($stateParams.projectId, data).then(
        function Success() {
          $mdDialog.hide(true);
          $state.reload();
        }
      );
    }
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('project.flows', {
        // TODO: this route
        url: '/flow?startDate&endDate&dateGroup&transRangeLow&transRangeHigh&transRangeAbs&entities&entitiesEnabled&unmatched&accounts&bankAccountTypes&categories&categoriesEnabled&keyword&keywordField&flow&pageSize&sortOrder&sortModel&customField&customFieldLabel',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/flows/flows.html',
            controller: 'FlowsController as $ctrl'
          }
        },
        params: {
          sourceType: 'bank',
          sortModel: 'date',
          sortOrder: 'asc',
          transRangeAbs: 'true',
        },
        resolve: {
          forceData: ["$stateParams", "ForceGraphs", "transactionUtils", "Categories", function($stateParams, ForceGraphs, transactionUtils, Categories) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            if(!$stateParamsClone.categories) {
              return Categories.findAllByProject($stateParamsClone.projectId).then(function(categories){
                if(categories && categories.length > 0) {
                  var filteredLabels = [];
                  categories[0].categoryLabels.forEach( function (l) {
                    if(l.isDefault || l.transactions > 0) {
                      filteredLabels.push(l.id);
                    }
                  });
                  $stateParamsClone.categories = filteredLabels;
                }
                $stateParamsClone.sourceType = 'bank';  //Force graph only works with bank transactions.
                var params = transactionUtils.formatFilterParams($stateParamsClone);
                return ForceGraphs.findAllPOST(params);
              });
            } else {
              return ForceGraphs.findAllPOST(transactionUtils.formatFilterParams($stateParams));
            }
          }],
          sankeyData: ["$stateParams", "SankeyGraphs", "transactionUtils", "Categories", function($stateParams, SankeyGraphs, transactionUtils, Categories) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            if(!$stateParamsClone.categories) {
              return Categories.findAllByProject($stateParamsClone.projectId).then(function(categories){
                if(categories && categories.length > 0) {
                  var filteredLabels = [];
                  categories[0].categoryLabels.forEach( function (l) {
                    if(l.isDefault || l.transactions > 0) {
                      filteredLabels.push(l.id);
                    }
                  });
                  $stateParamsClone.categories = filteredLabels;
                }
                //  $stateParamsClone.sourceType = 'bank';  //Force graph only works with bank transactions.
                var params = transactionUtils.formatFilterParams($stateParams);
                return SankeyGraphs.findAllPOST(params);
              });
            } else {
              return SankeyGraphs.findAllPOST(transactionUtils.formatFilterParams($stateParams));
            }
          }],
          categories: ["$stateParams", "Categories", function($stateParams, Categories) {
            return Categories.findAllByProject($stateParams.projectId);
          }],
          customFields: ["$stateParams", "CustomFields", function($stateParams, CustomFields) {
            return CustomFields.findAllByProject($stateParams.projectId);
          }],
          accounts: ["$stateParams", "Accounts", function($stateParams, Accounts) {
            return Accounts.findAllByProject($stateParams.projectId);
          }],
          transactions: ["$stateParams", "Transactions", "transactionUtils", "tableUtils", "CHECK_ITEMS", function($stateParams, Transactions, transactionUtils, tableUtils, CHECK_ITEMS) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            // Set Default sort params
            if(!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'date';
              $stateParamsClone.sortOrder = 'asc';
            }
            $stateParamsClone.sourceType = 'bank';  //Force graph only works with bank transactions.
            if(!$stateParamsClone.transRangeAbs) {
              $stateParamsClone.transRangeAbs = 'true';
            }
            var pagingParams = tableUtils.formatPagingParams($stateParams, true);
            var params = angular.extend({ downloadUrl: true, includeCheckItems: CHECK_ITEMS.STATUS.RECONCILED}, transactionUtils.formatFilterParams($stateParamsClone), pagingParams);
            return Transactions.findAllPOST(params);
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  FlowsController.$inject = ["$scope", "$state", "$mdDialog", "ENV", "Accounts", "blockUI", "forceData", "sankeyData", "CustomFields", "transactions", "Transactions", "transactionUtils", "Categories", "Projects", "dateUtils"];
  angular
    .module('projects')
    .controller('FlowsController', FlowsController);

  function FlowsController(
    $scope,
    $state,
    $mdDialog,
    ENV,
    Accounts,
    blockUI,
    forceData,
    sankeyData,
    CustomFields,
    transactions,
    Transactions,
    transactionUtils,
    Categories,
    Projects,
    dateUtils) {
    var vm = this;
    vm.forceData = forceData;
    vm.sankeyEnabled = ENV.featureFlags.sankey;
    vm.sankeyData = sankeyData;
    vm.transactions = transactions;
    vm.filterGraphData = filterGraphData;
    vm.selectNode = selectNode;
    vm.brushRange = brushRange;
    // TODO: appropriate action to open playback screen
    vm.openFlowsPlayback = openFlowsPlayback;
    vm.refresh = refresh;
    vm.graphIsSankey = false;
    vm.switchGraphType = switchGraphType;
    vm.graphIsGroup = false;
    vm.switchGraphGroupType = switchGraphGroupType;


    activate();

    function activate() {
      vm.transMetadata = Transactions.getMetadata();
      vm.categories = Categories.filterByProject($state.params.projectId);
      vm.customFields = CustomFields.filterByProject($state.params.projectId);
      vm.accounts = Accounts.filterByProject($state.params.projectId);
      vm.project = Projects.get($state.params.projectId);
      vm.filterData = transactionUtils.getFilterData($state.params);
      if ($state.params.categories === undefined) {
        // This will tell the downstream code to set the appropriate default category filter
        vm.filterData.categories = undefined;
      }
      _setFlowInformationLabels();
    }

    function _setFlowInformationLabels() {
      vm.dateRangeStart = moment(Transactions.getMetadata()['transDateFloor']).format('MMM Qo, YYYY');
      vm.dateRangeEnd = moment(Transactions.getMetadata()['transDateCeil']).format('MMM Qo, YYYY');
      vm.rangeStart = Transactions.getMetadata()['transRangeFloor'];
      vm.rangeEnd = Transactions.getMetadata()['transRangeCeil'];
      // TODO: get categories
      vm.evalCategories = angular.copy(vm.categories.length);
    }

    function switchGraphType() {
      vm.graphIsSankey = !vm.graphIsSankey;
    }

    function switchGraphGroupType() {
      vm.graphIsGroup = !vm.graphIsGroup;
    }


    function openFlowsPlayback() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/flows/flows-playback-dialog.html',
        controller: 'ForcePlaybackDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          forceData: vm.forceData,
          filterData: vm.filterData
        }
      });
    }

    function filterGraphData() {
      var params = dateUtils.formatUrlDates(angular.copy(vm.filterData));
      if(!params.transRangeLow) {
        delete $state.params.transRangeLow;
      }
      if(!params.transRangeHigh) {
        delete $state.params.transRangeHigh;
      }
      params.projectId = $state.params.projectId;
      $state.go('project.flows', params, {inherit: false});
    }

    function selectNode(node) {
      if(!_.isEqual(vm.selectedNode, node)) {
        blockUI.start();
        $scope.$apply();
        vm.selectedNode = node;
      }
    }

    function brushRange(range) {
      vm.filterData.startDate = range[0];
      vm.filterData.endDate = range[1];
      $scope.$apply();
    }

    function refresh() {
      $state.reload();
    }

  }
})();

(function() {
  'use strict';

  FlowsTransactionsTableController.$inject = ["$filter", "$state", "$stateParams", "$mdDialog", "blockUI", "tableUtils", "Transactions", "transactionUtils", "CHECK_ITEMS", "MATCH_STATUSES", "MATCH_TYPES"];
  angular
    .module('projects')
    .component('flowsTransactionsTable', {
      templateUrl: 'app/projects/project/flows/flows-transactions-table.html',
      bindings: {
        transactions: '<',
        selectedNode: '<',
        categories: '<',
        customFields: '<',
        project: '<',
        refresh: '&'
      },
      controller: FlowsTransactionsTableController
    });

  function FlowsTransactionsTableController(
    $filter,
    $state,
    $stateParams,
    $mdDialog,
    blockUI,
    tableUtils,
    Transactions,
    transactionUtils,
    CHECK_ITEMS,
    MATCH_STATUSES,
    MATCH_TYPES) {
    var vm = this;
    var GRID_ID = 'grid-cash-flow-transactions';
    vm.reloadData = reloadData;

    this.$onChanges = function(changes) {
      if(vm.gridOptions && changes.selectedNode) {
        vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      }
    };

    this.$onInit = function() {
      vm.pagination = tableUtils.getPagingParams($state.params);
      var allColumnDefs = transactionUtils.getDefaultTxnColumns($state, vm.project)
        .concat(transactionUtils.getCategoryColumns(vm.categories))
        .concat(transactionUtils.getCustomFieldColumns(vm.customFields));

      tableUtils.setColumnSort(vm.pagination, allColumnDefs);

      vm.gridOptions = {
        cacheBlockSize: vm.pagination.pageSize,
        columnDefs: allColumnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        treeData: true,
        angularCompileRows: true,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onSortChanged: vm.reloadData,
        getMainMenuItems: tableUtils.getMainMenuItems,
        rowModelType: 'serverSide',
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange,
        autoGroupColumnDef: {
          suppressMovable: true,
          pinned: 'left',
          width: 50,
          headerName: '',
          sortable: false,
          cellRendererParams: {
            innerRenderer: function() { return ''; }
          }
        },
        isServerSideGroup: function(dataItem) {
          return dataItem.group;
        },
        getServerSideGroupKey: function(dataItem) {
          return dataItem.id;
        }
      };
    };

    function reloadData() {
      var sortModel = vm.gridOptions.api.getSortModel();
      if(sortModel.length) {
        vm.pagination.sortModel = sortModel[0].colId;
        vm.pagination.sortOrder = sortModel[0].sort;
      } else {
        vm.pagination.sortModel = 'date';
        vm.pagination.sortOrder = 'asc';
      }
      vm.pagination.skipCount = 0;
      $state.go('project.flows', vm.pagination, { notify: false });
    }

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID);
      vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      if(!tableUtils.getGridState(GRID_ID)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID);
    }

    function _createDatasource() {
      return {
        getRows: function(params) {
          var rows = [];
          if(params.request.groupKeys.length === 0 ) { //Loading more root nodes, need to go to backend
            if(params.request.startRow === 0 && vm.transactions) { //We already have the first page provided by the route...
              rows = transactionUtils.formatTxnRows(vm.transactions);
              params.successCallback(rows, Transactions.getMetadata().transCountFilter);
              vm.transactions = false;
            } else {
              if(!$stateParams.sortModel) {
                vm.pagination.sortModel = 'date';
                vm.pagination.sortOrder = 'asc';
              }              
              vm.pagination.skipCount = params.request.startRow;
 
              var transactionParams = angular.extend({downloadUrl: true, includeCheckItems: CHECK_ITEMS.STATUS.RECONCILED},
                transactionUtils.formatFilterParams($stateParams), tableUtils.formatPagingParams(vm.pagination, true));
              transactionParams.sourceType = 'bank';

              if(vm.selectedNode) {
                if(vm.selectedNode.link) {
                  _setLinkTransactionParams(transactionParams);
                } else {
                  _setNodeTransactionParams(transactionParams);
                }
              }

              Transactions.findAllPOST(transactionParams).then(
                function Success(data) {
                  params.successCallback(transactionUtils.formatTxnRows(data), Transactions.getMetadata().transCountFilter);
                  blockUI.stop();
                }
              );
            }
          } else {  //Expanding child nodes, already supplied by the backend....
            var txn = params.parentNode.data;
            if(txn) {
              rows = transactionUtils.formatTxnCheckItemRows(txn);
            }
            params.successCallback(rows, rows.length);
          }
        }
      };
    }

    function _setNodeTransactionParams(transactionParams) {
      if(vm.selectedNode.type === 'account' || vm.selectedNode.type === 'entity') {
        transactionParams['accounts'] = vm.selectedNode.accountIds;
        if(vm.selectedNode.type === 'account') {
          transactionParams['match'] =  MATCH_TYPES.INT_TRANS;
        }
      } else {
        transactionParams.catNodeType = vm.selectedNode.type;
        if(vm.selectedNode.categoryLabelId === 'defaultSource' || vm.selectedNode.categoryLabelId === 'defaultUse') {
          transactionParams.withoutCategories = true;
        } else {
          transactionParams['categories'] = [vm.selectedNode.categoryLabelId];
        }
      }
    }

    function _setLinkTransactionParams(transactionParams) {
      if(  (vm.selectedNode.sourceType === 'account' || vm.selectedNode.sourceType === 'entity')
        && (vm.selectedNode.targetType === 'account' || vm.selectedNode.targetType === 'entity') ) { //Internal transfer arrow
        transactionParams['match'] =  MATCH_TYPES.INT_TRANS;
        transactionParams['sourceAccounts'] = vm.selectedNode.sourceIds;
        transactionParams['targetAccounts'] = vm.selectedNode.targetIds;
        transactionParams['categories'] = null;
        delete transactionParams['accounts'];
        delete transactionParams['entities'];
      } else if(vm.selectedNode.sourceType === 'account' || vm.selectedNode.sourceType === 'entity') {
        transactionParams['accounts'] = vm.selectedNode.sourceIds;
        //Target must be a category.
        transactionParams.catNodeType = 'use';
        var targetIds = vm.selectedNode.targetIds;
        if(targetIds[0] === 'defaultUse') {
          transactionParams.withoutCategories = true;
        } else {
          transactionParams['categories'] = targetIds;
        }
      } else if (vm.selectedNode.targetType === 'account' || vm.selectedNode.targetType === 'entity') {
        transactionParams['accounts'] = vm.selectedNode.targetIds;
        //Source must be a category
        transactionParams.catNodeType = 'source';
        var sourceIds = vm.selectedNode.sourceIds;
        if(sourceIds[0] === 'defaultSource') {
          transactionParams.withoutCategories = true;
        } else {
          transactionParams['categories'] = sourceIds;
        }
      }
    }
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "PROJECT_TYPES"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider, PROJECT_TYPES) {
    $stateProvider
      .state('project.files', {
        url: '/files',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/files/files.html',
            controller: 'FilesController as $ctrl'
          }
        },
        data: {
          projectType: PROJECT_TYPES.FORENSIC
        },
        resolve: {
          reports: ["$stateParams", "tableUtils", "Reports", "REPORTS", function($stateParams, tableUtils, Reports, REPORTS) {
            var p = {
              sortModel: 'createdAt',
              sortOrder: 'desc',
              pageSize: 1000
            };
            var pagingParams = tableUtils.formatPagingParams(p);
            var params = angular.extend({projectId: $stateParams.projectId, type: [REPORTS.TYPE.TRANSACTIONS, REPORTS.TYPE.TRANSACTIONS_DETAIL, REPORTS.TYPE.BALANCES, REPORTS.TYPE.DATEGAP, REPORTS.TYPE.DATA_EXPORT]}, pagingParams);
            return Reports.findAll(params, {bypassCache: true});
          }],
          bulkRevisions: ["$stateParams", "tableUtils", "BulkRevisions", "BULK_REVISIONS", function($stateParams, tableUtils, BulkRevisions, BULK_REVISIONS) {
            var p = {
              sortModel: 'createdAt',
              sortOrder: 'desc',
              pageSize: 1000
            };
            var pagingParams = tableUtils.formatPagingParams(p);
            var params = angular.extend({projectId: $stateParams.projectId, type: BULK_REVISIONS.TYPE.TRANSACTIONS, downloadUrl: true}, pagingParams);
            return BulkRevisions.findAll(params, {bypassCache: true});
          }],
          accounts: ["$stateParams", "Accounts", function($stateParams, Accounts) {
            return Accounts.findAllByProject($stateParams.projectId);
          }],
          entities: ["$stateParams", "Entities", function($stateParams, Entities) {
            return Entities.findAllByProject($stateParams.projectId);
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  FilesController.$inject = ["$state", "PROJECT_TYPES", "RBAC", "Authorization", "bulkRevisions", "reports", "accounts", "entities"];
  angular
    .module('projects')
    .controller('FilesController', FilesController);

  function FilesController(
    $state,
    PROJECT_TYPES,
    RBAC,
    Authorization,
    bulkRevisions,
    reports,
    accounts,
    entities) {
    var vm = this;
    vm.reports = reports;
    vm.bulkRevisions = bulkRevisions;
    vm.accounts = accounts;
    vm.entities = entities;
    vm.showRevisions = (Authorization.isV8Admin() || Authorization.hasRole(RBAC.ROLES.CUSTOMER_ADMIN) || Authorization.hasRole(RBAC.ROLES.ENGAGEMENT_OWNER, $state.params.projectId)) &&
      ($state.current.data.projectType === PROJECT_TYPES.FORENSIC);
  }
})();

(function() {
  'use strict';

  Entities.$inject = ["DS"];
  angular
    .module('projects')
    .factory('Entities', Entities);

  function Entities(DS) {
    var entities = DS.defineResource({
      name: 'entities',
      endpoint: 'entities',
      idAttribute: 'id',
      cacheResponse: false,
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    entities.filterByProject = function(id) {
      return entities.filter({where: {projectId: id}});
    };

    entities.findAllByProject = function(id) {
      return entities.findAll({ projectId: id });
    };

    entities.getEntityName = function(entityId) {
      entityId = entityId ? entityId : '';
      var entity = entities.get(entityId);
      return entity ? entity.name : '';
    };

    return entities;
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('project.documents', {
        url: '/documents',
        abstract: true
      });
  }
})();

(function() {
  'use strict';

  Documents.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('projects')
    .factory('Documents', Documents);

  function Documents(DS, DSHttpAdapter) {
    var metadata;
    var documents = DS.defineResource({
      name: 'documents',
      endpoint: 'documents',
      idAttribute: 'id',
      // TODO once JSData can handle metadata remove this
      cacheResponse: false,
      deserialize: function(config, res) {
        if(res.data.metadata) {
          metadata = res.data.metadata;
        }
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    documents.getMetadata = function() {
      return metadata;
    };

    documents.getUploadParameters = function(projectId) {
      return DSHttpAdapter.HTTP({
        method: 'POST',
        url: DSHttpAdapter.defaults.basePath + '/document/upload',
        params: {projectId: projectId},
        data: {}
      });
    };

    documents.getDownloadLink = function(documentId) {
      return DSHttpAdapter.HTTP({
        method: 'GET',
        url: DSHttpAdapter.defaults.basePath + '/document/upload/' + documentId
      });
    };

    return documents;
  }
})();

(function() {
  'use strict';

  AddDocumentController.$inject = ["$state", "$stateParams", "$mdDialog", "Documents", "Transactions", "Authorization", "documentType", "accountId", "transactionId", "Upload", "uploadParameters", "DOCUMENT_TYPES"];
  angular
    .module('projects')
    .controller('AddDocumentController', AddDocumentController);

  function AddDocumentController(
    $state,
    $stateParams,
    $mdDialog,
    Documents,
    Transactions,
    Authorization,
    documentType,
    accountId,
    transactionId,
    Upload,
    uploadParameters,
    DOCUMENT_TYPES) {
    var vm = this;
    vm.uploadFiles = uploadFiles;
    vm.isUploading = isUploading;
    vm.closeUploadDialog = closeUploadDialog;
    vm.abortUpload = abortUpload;
    vm.getFileErrorMessage = getFileErrorMessage;
    vm.documentType = documentType;

    vm.files = [];
    vm.errorFiles = [];

    activate();

    function activate() {
      vm.files = [];
      vm.errorFiles = [];
      vm.isSupportingDocument = false;
      switch(vm.documentType) {
      case DOCUMENT_TYPES.TX_SUP_DOC.type:
        vm.addDocumentTitle = 'Add supporting documentation';
        vm.acceptPattern = '';
        vm.ngUploadPattern = '';
        vm.maxSize = '1000MB';
        vm.info = 'Select files';
        vm.type = DOCUMENT_TYPES.TX_SUP_DOC.type;
        break;
      default:
        vm.isSupportingDocument = true;
        vm.addDocumentTitle = 'Add Support Documents';
        vm.acceptPattern = '';
        vm.ngUploadPattern = '';
        vm.maxSize = '1000MB';
        vm.info = 'Select up to 100 files. Max size 1GB per file.';
        vm.type = DOCUMENT_TYPES.OTHER.type;
        break;
      }
    }

    function isUploading() {
      return Upload.isUploadInProgress();
    }

    function uploadFiles(files, errorFiles) {
      vm.files = files;
      vm.errorFiles = errorFiles;
      angular.forEach(files, function(file) {
        //Users may upload multiple files with the same name, need to differentiate them when associated with different DB entities.
        var randKey = Math.floor(Math.random() * 10000);
        const uploadData = {
          key: uploadParameters.folder + '/' + randKey + '/' + file.name,
          acl: 'private',
          policy: uploadParameters.policy,
          'x-amz-algorithm': uploadParameters['x-amz-algorithm'],
          'x-amz-credential': uploadParameters['x-amz-credential'],
          'x-amz-date': uploadParameters['x-amz-date'],
          'x-amz-signature': uploadParameters.signature,
          'x-amz-security-token': uploadParameters['x-amz-security-token'],
          "Content-Type": file.type != '' ? file.type : 'application/octet-stream',
          filename: file.name,
          file: file
        };
        if (!uploadParameters['x-amz-security-token']) {
          delete uploadData['x-amz-security-token'];
        }
        file.upload = Upload.upload({
          url: uploadParameters.url,
          method: 'POST',
          data: uploadData
        });

        file.upload.then(function (response) {
          _saveDocumentData(file, response.config.data.key);
        }, function (response) {
          if (response.status > 0) {
            _failure(file, response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      });
    }

    function _saveDocumentData(file, filename) {
      vm.newDocument = {};
      vm.newDocument.fileName = filename;
      vm.newDocument.size = file.size;
      vm.newDocument.projectId = $stateParams.projectId;
      vm.newDocument.accountId = accountId;
      vm.newDocument.uploadDate = moment().toISOString();
      vm.newDocument.uploadUser = Authorization.getUserProfile().email;
      vm.newDocument.type = vm.type;
      vm.newDocument.mimeType = file.type;
      Documents.create(vm.newDocument, {params:{nb:1}}).then(
        function Success(response) {
          switch(vm.type) {
          case DOCUMENT_TYPES.TX_SUP_DOC.type:
            _associateTransaction(response.id, file);
            break;
          default:
            _success(file, 'The file has been successfully saved!');
            break;
          }
        })
        .catch(function Failure() {
          _failure(file, 'The document could not be added, please contact a system admin...');
        });
    }

    function _associateTransaction(docId, file) {
      Transactions.addSupportingDocuments($stateParams.projectId, transactionId, [docId]).then(
        function Success() {
          _success(file, 'Supporting document saved!');
        })
        .catch(function Failure() {
          _failure(file, 'Supporting document could not be added, please contact a system admin...');
        });
    }

    function _success(file, messageText) {
      file.successMessage = messageText;
    }

    function _failure(file, messageText) {
      file.errorMessage = messageText;
    }

    function abortUpload() {
      angular.forEach(vm.files, function(file) {
        if(file.upload) {
          file.upload.abort();
        }
      });
    }

    function getFileErrorMessage(file) {
      var message = file.name;
      if(file.errorMessage) {
        return message + ' Error: ' + file.errorMessage;
      } else if (file.$error === 'pattern') {
        return message + ' Error: file extension not accepted';
      } else if (file.$error === 'maxSize') {
        return message + ' Error: file exceeds maximum allowed size';
      } else {
        return message + ' Error';
      }
    }

    function closeUploadDialog() {
      $mdDialog.cancel();
      $state.reload();
    }
  }
})();

(function() {
  'use strict';

  CustomFields.$inject = ["DS"];
  angular
    .module('projects')
    .factory('CustomFields', CustomFields);

  function CustomFields(DS) {
    var customFields = DS.defineResource({
      name: 'customFields',
      endpoint: 'custom-fields',
      idAttribute: 'id',
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    customFields.findAllByProject = function(id) {
      return customFields.findAll({ projectId: id, '$sort[index]': 1 }, {bypassCache: true});
    };

    customFields.filterByProject = function(id) {
      return customFields.filter({ projectId: id });
    };

    return customFields;
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "PROJECT_TYPES", "CHECK_ITEMS"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider, PROJECT_TYPES, CHECK_ITEMS) {
    $stateProvider
      .state('project.check-items', {
        url: '/check-items?status&pageSize&sortOrder&sortModel',
        params: {
          state: {
            type: 'string',
            value: 'unmatched',
            squash: false,
          },
        },
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/check-items/check-items.html',
            controller: 'CheckItemsController as $ctrl'
          }
        },
        data: {
          projectType: PROJECT_TYPES.FORENSIC
        },
        resolve: {
          checkItems: ["$stateParams", "CheckItems", function($stateParams, CheckItems) {
            if ($stateParams.status === CHECK_ITEMS.STATUS.UNMATCHED) {
              return null;
            }
            var params = angular.extend({projectId: $stateParams.projectId, status: $stateParams.status, parentId: 'null', $limit: 1});
            return CheckItems.findAllPOST(params, {bypassCache: true});
          }],
          customFields: ["$stateParams", "CustomFields", function($stateParams, CustomFields) {
            return CustomFields.findAllByProject($stateParams.projectId);
          }],
          categories: ["$stateParams", "Categories", function($stateParams, Categories) {
            return Categories.findAllByProject($stateParams.projectId);
          }],
        }
      })
      .state('project.check-item-reconcile', {
        url: '/check-item-reconcile/:checkItemId?pageSize&sortOrder&sortModel',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/check-items/check-item-reconcile.html',
            controller: 'CheckItemReconcileController as $ctrl'
          }
        },
        data: {
          projectType: PROJECT_TYPES.FORENSIC
        },
        resolve: {
          checkItem: ["$stateParams", "CheckItems", function($stateParams, CheckItems) {
            return CheckItems.find($stateParams.checkItemId, {params: {downloadUrl:true, children: true, navigation: true}});
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  CheckItems.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('projects')
    .factory('CheckItems', CheckItems);

  function CheckItems(DS, DSHttpAdapter) {
    var metadata;
    var checkItems = DS.defineResource({
      name: 'checkItems',
      endpoint: 'check-items',
      idAttribute: 'id',
      // TODO once JSData can handle metadata remove this
      cacheResponse: false,
      deserialize: function(config, res) {
        if(res.data.metadata) {
          metadata = res.data.metadata;
        }
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    checkItems.getMetadata = function() {
      return metadata;
    };

    // fullUpdate updates the check and its associated custom fields/categories
    checkItems.fullUpdate = function(checkItemId, checkItemData) {
      return DSHttpAdapter.PUT(
        DSHttpAdapter.defaults.basePath + '/check-items/' + checkItemId,
        checkItemData,
        { params: { updateCustomFields: true, updateCategories: true} }
      );
    };

    checkItems.batchUpdate = function(projectId, checkItemIds, action) {
      var params = {
        projectId: projectId,
        action: action
      };
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/check-items/batch',
        { checkItemIds: checkItemIds },
        { params: params }
      );
    };

    checkItems.statementPeriodCheck = function(projectId) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/check-items/statement-check',
        {},
        { params: {projectId: projectId} }
      );
    };

    checkItems.associate = function(projectId, depositId, checkItemIds) {
      var params = {
        projectId: projectId
      };
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/check-items/associate',
        { depositId, checkItemIds, action: "associate" },
        { params: params }
      );
    };

    checkItems.disassociate = function(projectId, checkItemIds) {
      var params = {
        projectId: projectId
      };
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/check-items/associate',
        { checkItemIds, action: "disassociate" },
        { params: params }
      );
    };


    checkItems.match = function(projectId, checkItemId, transactionId) {
      var params = {
        projectId: projectId
      };
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/check-items/match',
        { checkItemId, transactionId },
        { params: params }
      );
    };

    checkItems.updateCategories = function(projectId, checkItemIds, categoryLabelId) {
      // Using POST instead of GET due to large request data
      // Goes against JS Data so creating specific HTTP request
      if (checkItemIds.length === 0) {
        return Promise.resolve();
      }
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/check-items/categories',
        { checkItemIds: checkItemIds, categoryLabelId: categoryLabelId},
        { params: {projectId: projectId} }
      );
    };

    checkItems.updateCustomFields = function(projectId, checkItemIds, customFieldId, value) {
      // Using POST instead of GET due to large request data
      // Goes against JS Data so creating specific HTTP request
      if (checkItemIds.length === 0) {
        return Promise.resolve();
      }
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/check-items/custom-fields',
        { checkItemIds: checkItemIds, value: value},
        { params: {projectId: projectId, customFieldId: customFieldId} }
      );
    };

    // this is a hack using POST instead of GET to find all transactions to avoid query size
    // limits
    checkItems.findAllPOST = function(params) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/check-items-filter',
        params,
        {}
      ).then(function (res) {
        if(res.data.metadata) {
          metadata = res.data.metadata;
        }
        return res.data.data;
      });
    };
    return checkItems;
  }
})();

(function() {
  'use strict';

  CheckItemsController.$inject = ["$state", "Categories", "CustomFields", "STATEMENTS"];
  angular
    .module('projects')
    .controller('CheckItemsController', CheckItemsController);

  function CheckItemsController(
    $state,
    Categories,
    CustomFields,
    STATEMENTS) {
    var vm = this;
    vm.title = STATEMENTS.SOURCE_DESCRIPTION[STATEMENTS.SOURCE.CHECKS_PDF];
    vm.projectType = $state.current.data.projectType;

    activate();

    function activate() {
      vm.categories = Categories.filterByProject($state.params.projectId);
      vm.customFields = CustomFields.filterByProject($state.params.projectId);
    }
  }
})();

(function() {
  'use strict';

  CheckItemsListTableController.$inject = ["$scope", "$templateRequest", "$compile", "$filter", "$state", "$stateParams", "ENV", "tableUtils", "toastr", "dateUtils", "transactionUtils", "Accounts", "Categories", "CheckItems", "Transactions", "Authorization", "Documents", "Projects", "ACCOUNTS", "PROJECT_TYPES", "TRANSACTION_TYPES", "STATEMENTS", "RBAC", "CHECK_ITEMS"];
  angular
    .module('projects')
    .component('checkItemsListTable', {
      templateUrl: 'app/projects/project/check-items/check-items-list.html',
      bindings: {
        type: '@',
        matchJobs: '<',
        categories: '<',
        customFields: '<'
      },
      controller: CheckItemsListTableController
    })
    .controller('CheckItemsListTableController', CheckItemsListTableController);

  function CheckItemsListTableController(
    $scope,
    $templateRequest,
    $compile,
    $filter,
    $state,
    $stateParams,
    ENV,
    tableUtils,
    toastr,
    dateUtils,
    transactionUtils,
    Accounts,
    Categories,
    CheckItems,
    Transactions,
    Authorization,
    Documents,
    Projects,
    ACCOUNTS,
    PROJECT_TYPES,
    TRANSACTION_TYPES,
    STATEMENTS,
    RBAC,
    CHECK_ITEMS) {
    var DEFAULT_CHECK_PAGE_SIZE = ENV.defaultCheckPageSize || 100;
    var vm = this;
    var GRID_VERSION = 7;
    vm.reloadData = reloadData;
    vm.toFileTab = toFileTab;
    vm.toItemTab = toItemTab;
    vm.selectedCheckItems = [];
    vm.selectAll = selectAll;
    vm.gridOptions = {};
    vm.project = Projects.get($state.params.projectId);
    vm.status = $state.params.status;

    vm.onCategoryUpdate = onCategoryUpdate;
    vm.itemsUpdated = itemsUpdated;
    vm.expandCollapse = expandCollapse;
    vm.expand = false;
    vm.source = STATEMENTS.SOURCE.CHECKS_PDF;
    vm.accountsLoaded = false;
    vm.accounts = {};
    vm.accountNumbersMap = {};

    //copied from <other> controller for now
    vm.checkEditData = {};
    vm.checkEditData.itemChildren = [];
    vm.checkEditData.childrenTotal = 0;
    vm.checkEditData.displayedImageUrl = false; //this is a single instance, needs to become an array so we can draw multiple check editors inline
    vm.checkEditData.canEdit = true;

    //I am setting a handful of pointers on the <this> so I can reference it in shared code
    vm.rowGroupsLoaded = [];
    vm.CheckItems = CheckItems;
    vm.prepareForCheckItemEdit = prepareForCheckItemEdit;
    vm.$scope = $scope;
    vm.$templateRequest = $templateRequest;
    vm.$compile = $compile;

    vm.toggleImage = toggleImage;
    vm.submitSaveCheckItem = submitSaveCheckItem;
    vm.selectEditCheckItem = selectEditCheckItem;
    
    vm.exportToCsv = exportToCsv;

    vm.stopPropagation = stopPropagation;

    this.$onInit = function() {
      this.checkeditor = CreateCheckItemInlineEditor(this);
      this.checkeditor.init();
      this.checkeditor.trackRowGroupsLoaded();
      this.renderInlineCheckEditor = this.checkeditor.renderInlineCheckEditor;

      vm.hasPermissions = Authorization.hasProjectAccess(vm.type, $state.params.projectId, [RBAC.ROLES.ENGAGEMENT_OWNER, RBAC.ROLES.ENGAGEMENT_USER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
      vm.status = $state.params.status;
      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.pagination.pageSize = DEFAULT_CHECK_PAGE_SIZE;
      if (vm.status === CHECK_ITEMS.STATUS.RECONCILED) {
        vm.actionColumns = [
          {
            headerName: 'Select',
            field: 'in-edit',
            pinned: 'left',
            checkboxSelection: function(params) {
              return params.data && 
              ( params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION  || params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM ) &&
              ( vm.status === CHECK_ITEMS.STATUS.RECONCILED || vm.status === CHECK_ITEMS.STATUS.UNRECONCILED);
            },
            width: 70,
            suppressMovable: true,
            resizable: false,
            sortable: false,
            suppressSizeToFit: true,
            suppressMenu: true,
            hide: !vm.hasPermissions,
            suppressColumnsToolPanel: true
          },
        ];
        vm.columnDefs = vm.actionColumns.concat(transactionUtils.getDefaultTxnColumns($state, vm.project))
          .concat(transactionUtils.getCategoryColumns(vm.categories))
          .concat(transactionUtils.getCustomFieldColumns(vm.customFields));
      } else {
        vm.columnDefs = [
          {
            headerName: 'Select',
            field: 'in-edit',
            //pinned: 'left', //pinned rows dont seem to allow colSpan directives
            checkboxSelection: function(params) {
              // On the unmatched screen, allow child check fronts to be selected to allow manual disassociation
              return params.data && 
              (params.data.top || ((vm.status === CHECK_ITEMS.STATUS.UNMATCHED || vm.status === CHECK_ITEMS.STATUS.UNRECONCILED) && params.data.type === CHECK_ITEMS.TYPE.FRONT));
            },
            width: 70,
            suppressMovable: true,
            resizable: false,
            sortable: false,
            suppressSizeToFit: true,
            suppressMenu: true,
            hide: !vm.hasPermissions,
            suppressColumnsToolPanel: true,
            cellRenderer: this.checkeditor.targetCellRenderer,
            colSpan: this.checkeditor.colSpan
          },
          {
            headerName: 'Match',
            colId: 'match',
            width: 55,
            resizable: false,
            suppressMovable: true,
            sortable: false,
            suppressSizeToFit: true,
            suppressMenu: true,
            //pinned: 'left', //anything pinned shows to first (to the left). We want match after the select checkbox...
            hide: !(vm.hasPermissions && vm.status === CHECK_ITEMS.STATUS.UNMATCHED),
            suppressColumnsToolPanel: !(vm.hasPermissions && vm.status === CHECK_ITEMS.STATUS.UNMATCHED),
            cellRenderer: function(params) {
              if(params && params.data && params.data.id && params.data.type === 'transaction') {
                return '<img class="png-icon" src="assets/images/match.png" style="width: 32px; height: 32px; cursor: pointer;">';
              }
            },
            onCellClicked: function(params) {
              if(params && params.data && params.data.id && params.data.type === 'transaction') {
                CheckItems.match($state.params.projectId, params.data.checkId, params.data.id).then(
                  function Success() {
                    toastr.success('Check item matched to transaction successfully');
                    $state.reload();
                  }
                ).catch(
                  function Failure() {
                  // maybe we failed due to stale data?
                    toastr.error('Failed to match check item to transaction');
                    $state.reload();
                  }
                );
              }
            },
          },
          {
            headerName: "ID",
            field: 'id',
            width: 200,
            hide: true,
            valueFormatter: function(params) {
              if(!params.value || params.value.endsWith('empty')) {
                return '';
              }
              return params.value;
            }
          },
          {
            headerName: 'Item Date',
            field: 'date',
            width: 100,
            valueFormatter: function(params) {
              if(!params.data) {
                return '';
              }
              return $filter('dateDisplay')(params.value);
            }
          },
          {
            headerName: 'Stmt Date',
            sortable: false,
            field: 'statementDate',
            width: 100,
            valueFormatter: function(params) {
              if(!params.data) {
                return '';
              }
              return $filter('dateDisplay')(params.value);
            },
          },
          {
            headerName: 'Item AMT',
            field: 'amount',
            cellClass: ['grid-amount'],
            width: 100,
            cellRenderer: function(params) {
              if(!params.data) {
                return '';
              }
              if(params.data.front || params.data.back) {
                return '<span check-image-preview-popover front="{{data.front}}" back="{{data.back}}">' + $filter('currencyDisplayFilter')(params.value) + '</span>';
              } else {
                return $filter('currencyDisplayFilter')(params.value);
              }
            },
          },
          {
            headerName: 'Stmt AMT',
            field: 'statementAmount',
            cellClass: ['grid-amount'],
            width: 100,
            cellRenderer: function(params) {
              if(!params.data) {
                return '';
              }
              return $filter('currencyDisplayFilter')(params.value);
            },
          },
          {
            headerName: 'Missing Stmt',
            field: 'possiblyMissingStatement',
            width: 150,
            resizable: false,
            suppressMovable: true,
            sortable: true,
            suppressSizeToFit: true,
            suppressMenu: false,
            hide: vm.status !== CHECK_ITEMS.STATUS.UNMATCHED,
            suppressColumnsToolPanel: vm.status !== CHECK_ITEMS.STATUS.UNMATCHED,
            cellRenderer: function(params) {
              if (params.data && params.data.top) {
                if (params.data.possiblyMissingStatement === true) {
                  return '<md-icon class="material-icons"><md-tooltip>Statement data may be missing for this time period</md-tooltip>close</md-icon>';
                }
              }
            },
          },
          {
            headerName: 'Type',
            field: 'type',
            width: 100,
            valueFormatter: function(params) {
              if(!params.data) {
                return '';
              }
              return $filter('checkItemTypeDisplay')(params.value);
            }
          },
          {
            headerName: 'Item #',
            field: 'checkNumber',
            width: 80
          },
          {
            headerName: 'Item Payee',
            field: 'payee',
            width: 100
          },
          {
            headerName: 'Item Payor',
            field: 'payor',
            width: 100
          },
          {
            headerName: 'Item Memo',
            field: 'memo',
            width: 300
          },
          {
            headerName: 'Stmt Description',
            field: 'statementDescription',
            width: 300,
            sortable: false,
          },
          {
            headerName: 'Acct #',
            field: 'accountNumber',
            width: 100
          },
          {
            headerName: 'File Name',
            field: 'fileName',
            sortable: false,
            width: 200,
            cellRenderer: function(params) {
              if(!params.data) {
                return '';
              }
              if(params.value) {
                return $filter('filenameDisplay')(params.value);
              } else {
                return '';
              }
            },
          },
          {
            headerName: 'Page',
            sortable: false,
            width: 100,
            field: 'page',
            cellRenderer: function(params) {
              if(params.value === null) {
                return 0;
              } else if(params.data) {
                // Hack to remove page numbers for rows that don't display them
                if (params.value && params.value === -1) {
                  return '';
                }
                var pageNumber = parseInt(params.value) + 1;   //Check Engine source page index is zero based.
                if(pageNumber > 0 && params.data.fileUrl) {
                  var link = params.data.fileUrl;
                  link = link + '#page=' + pageNumber;
                  return '<a target="_blank" href="' + link + '"  onclick="event.stopPropagation();">' + pageNumber + '</a>';
                } else {
                  return pageNumber;
                }
              }
            }
          }
        ];
        if (vm.status === CHECK_ITEMS.STATUS.UNRECONCILED) {
          vm.columnDefs.push({
            headerName: 'Txn Page',
            sortable: false,
            width: 100,
            field: 'txnPage',
            cellRenderer: function(params) {
              if(params.value === null) {
                return 0;
              } else if(params.data) {
                // Hack to remove page numbers for rows that don't display them
                if (params.value && params.value === -1 || params.value === undefined) {
                  return '';
                }
                var pageNumber = parseInt(params.value) + 1;   //Check Engine source page index is zero based.
                if(pageNumber > 0 && params.data.txnFileUrl) {
                  var link = params.data.txnFileUrl;
                  link = link + '#page=' + pageNumber;
                  return '<a target="_blank" href="' + link + '" onclick="event.stopPropagation();">' + pageNumber + '</a>';
                } else {
                  return pageNumber;
                }
              }
            }
          });
        }
        vm.columnDefs = vm.columnDefs.concat(transactionUtils.getCategoryColumns(vm.categories))
          .concat(transactionUtils.getCustomFieldColumns(vm.customFields));
      }
      tableUtils.setColumnSort(vm.pagination, vm.columnDefs);
      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        rowModelType: 'serverSide',
        rowSelection: 'multiple',
        // go look at createDataSource for why I'm doing this silliness
        cacheBlockSize: (vm.status === CHECK_ITEMS.STATUS.UNRECONCILED) ? vm.pagination.pageSize * 2 : vm.pagination.pageSize,
        treeData: true,
        animateRows: true,
        defaultColDef: tableUtils.getDefaultColDefs(),
        getMainMenuItems: tableUtils.getMainMenuItems,
        rowBuffer: 150,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onRowSelected: _toggleSelectCheckItem,
        angularCompileRows: true,
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange,
        onVirtualRowRemoved: onVirtualRowRemoved,
        purgeClosedRowNodes: true,
        suppressRowClickSelection: true,
        onSortChanged: vm.reloadData,
        onRowGroupOpened: this.checkeditor.onRowGroupOpened,
        onRowDoubleClicked: function(){}, //this at least keeps the rowClick from double rendering
        onRowClicked: this.checkeditor.rowClicked,
        getRowHeight: this.checkeditor.getRowHeight,
        autoGroupColumnDef: {
          suppressMovable: true,
          pinned: 'left',
          width: 50,
          headerName: '',
          sortable: false,
          cellRendererParams: {
            innerRenderer: function() { return ''; }
          }
        },
        isServerSideGroup: function(dataItem) {
          return dataItem.group;
        },
        getServerSideGroupKey: function(dataItem) {
          return dataItem.id;
        },
        getRowClass: function(params) {
          if (vm.status === CHECK_ITEMS.STATUS.UNMATCHED && params.data && !params.data.top) {
            if (params.data.type === 'transaction') {
              var style = 'ag-row-special-childitem';
              if (params.data.lastTxnRow === true) {
                style += ' ag-row-last-special-childitem';
              }
              if (params.data.firstTxnRow === true) {
                style += ' ag-row-first-special-childitem';
              }
              return style;
            } else {
              return 'ag-row-childitem';
            }
          }
        },
        getRowNodeId: data => data.id,
      };
    };

    function getGRIDID() {
      if (vm.status === CHECK_ITEMS.STATUS.UNMATCHED) {
        return 'grid-check-items-unmatched';
      }  else if (vm.status === CHECK_ITEMS.STATUS.UNRECONCILED) {
        return 'grid-check-items-unreconciled';
      }  else if (vm.status === CHECK_ITEMS.STATUS.RECONCILED) {
        return 'grid-check-items-reconciled';
      } else {
        return 'grid-check-items-green-chile';
      }
    }

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, getGRIDID(), GRID_VERSION);
      vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      if(!tableUtils.getGridState(getGRIDID(), GRID_VERSION)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function onCategoryUpdate() {
      vm.categories = Categories.findAllByProject($state.params.projectId);
    }

    function itemsUpdated(refreshRequired) {
      selectAll();
      if (refreshRequired) {
        $state.reload();
      } else {
        vm.gridOptions.api.refreshView();
      }
    }

    function selectAll() {
      // Adapted from tableUtils.selectUnselectAll()
      if (!vm.gridOptions) {
        return;
      }
      var selectedRows = vm.gridOptions.api.getSelectedRows();
      if (selectedRows.length) {
        vm.gridOptions.api.deselectAll();
        return;
      }
      var counter = 0;
      vm.gridOptions.api.forEachNode(function(node) {
        if (node.data && (node.data.top || (node.data.checkItem && node.data.checkItem.top))) {
          counter++;
          if (counter <= DEFAULT_CHECK_PAGE_SIZE) {
            node.setSelected(true);
          }
        }
      });
      if (counter > DEFAULT_CHECK_PAGE_SIZE) {
        alert(`"Select All" applied to the maximum of ${DEFAULT_CHECK_PAGE_SIZE} rows`);
      }
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, getGRIDID(), GRID_VERSION);
    }

    function onVirtualRowRemoved(event) {
      if (event.data && event.node && event.node.expanded && event.data.id.includes('-empty')) {
        // collapse rows as they go off screen - cleans up the check editor
        event.node.parent.setExpanded(false);
        
      }
    }

    function expandCollapse(){
      vm.expand = !vm.expand;
      vm.gridOptions.api.forEachNode(function(node) {
        if (node.level === 0 && node.group && node.id && !node.id.includes('-empty')){
          node.setExpanded(true);
        }
      });
      
      if(vm.expand === false){
        $state.reload();
      }
      
    }

    function toFileTab(status) {
      if(vm.status === status) {
        return;
      }
      $state.go(_getCheckFilesState(), {status: status, source: vm.source});
    }

    function toItemTab(status) {
      if(vm.status === status) {
        return;
      }
      $state.go(_getCheckTransactionsState(), {status: status}, {reload: true});
    }

    function reloadData() {
      var sortModel = vm.gridOptions.api.getSortModel();
      if(sortModel.length) {
        vm.pagination.sortModel = sortModel[0].colId;
        vm.pagination.sortOrder = sortModel[0].sort;
      }
      vm.pagination.skipCount = 0;
      vm.pagination.pageSize = DEFAULT_CHECK_PAGE_SIZE;
      vm.checkItems = null;
      $state.go($state.current, vm.pagination);
    }

    function _toggleSelectCheckItem() {
      //style stuff
      if (vm.status === CHECK_ITEMS.STATUS.UNMATCHED || vm.status === CHECK_ITEMS.STATUS.UNRECONCILED) {
        vm.selectedCheckItems = vm.gridOptions.api.getSelectedRows();
      } else {
        vm.selectedCheckItems = vm.gridOptions.api.getSelectedRows().map(function (r) { return r.checkItem; });
      }
      $scope.$applyAsync();
    }

    //This data source is a combination of client side data and server pagination. For check items, for each page we get all the children objects.
    //So there is no need to go to the backend for each tree node expansion.  However we will need to go and fetch more check items as we scroll down
    //the top level rows.
    function _createDatasource() {
      // check-items view
      if (vm.status !== CHECK_ITEMS.STATUS.RECONCILED) {
        return {
          getRows: function(params) {
            var rows = [];
            if(params.request.groupKeys.length === 0 ) { //Loading more top nodes, need to go to backend
              if(!$stateParams.sortModel) {
                vm.pagination.sortModel = 'date';
                vm.pagination.sortOrder = 'asc';
              }
              vm.pagination.pageSize = DEFAULT_CHECK_PAGE_SIZE;
              // Why are we dividing this in two? That's because on the UNRECONCILED page we use some "virtual rows"
              // to draw the checkitem editor. These virtual rows need to be accounted for when we're telling ag-grid
              // to draw rows, so we double up the number of rows we tell it to draw and but then we must halve the
              // startRow when making requests for more rows.
              vm.pagination.skipCount = (vm.status === CHECK_ITEMS.STATUS.UNRECONCILED ? params.request.startRow / 2 : params.request.startRow);
              var itemParams = angular.extend({projectId: $state.params.projectId, children: true, downloadUrl: true, parentId: 'null'},
                tableUtils.formatPagingParams(vm.pagination, true));
              if($state.params.status && $state.params.status !== 'all') {
                itemParams.status = $stateParams.status;
              }
              itemParams.type = [CHECK_ITEMS.TYPE.DEPOSIT, CHECK_ITEMS.TYPE.FRONT, CHECK_ITEMS.TYPE.TRANSFER];
              CheckItems.findAllPOST(itemParams).then(
                function Success(checks) {
                  var displayRows = CheckItems.getMetadata().total;
                  vm.statusInfo = CheckItems.getMetadata().statusInfo;
                  if (vm.status == CHECK_ITEMS.STATUS.UNRECONCILED) {
                    displayRows = (CheckItems.getMetadata().total * 2);
                    var transactionParams = angular.extend({downloadUrl: true, sourceType: 'bank', includeCheckItems: true, checkItemStatus: vm.status},
                      transactionUtils.formatFilterParams($state.params));
                    if (!vm.transactions) {
                      Transactions.findAllPOST(transactionParams).then(
                        function Success(txns) {
                          vm.transactions = txns;
                          for (var i = 0; i < checks.length; i++) {
                            for (var ii = 0; ii < txns.length; ii++) {
                              if (checks[i].id == txns[ii].checkItemId) {
                                checks[i].Transaction = txns[ii];
                                vm.rowGroupsLoaded.push(checks[i]); //I don't need a full event callback; just keep tabs on what was loaded
                                break;
                              }
                            }
                          }
                          rows = _formatTopRow(checks);
                          params.successCallback(rows, displayRows);
                        });
                    } else {
                      for (var i = 0; i < checks.length; i++) {
                        for (var ii = 0; ii < vm.transactions.length; ii++) {
                          if (checks[i].id == vm.transactions[ii].checkItemId) {
                            checks[i].Transaction = vm.transactions[ii];
                            vm.rowGroupsLoaded.push(checks[i]); //I don't need a full event callback; just keep tabs on what was loaded
                            break;
                          }
                        }
                      }
                      rows = _formatTopRow(checks);
                      params.successCallback(rows, displayRows);
                    }
                  } else {
                    //when we are on unmatched, we need to know the number of top level rows as displayRows and can't simply look at deposit slips to infer
                    //this is because we only open the row on the > click and do not immediately display the contents of the item in the tray
                    //displayRows = CheckItems.getMetadata().total;
                    params.successCallback(_formatTopRow(checks), displayRows);
                  }
                }
              );
            } else {  //Expanding child nodes, already supplied by the backend....
              var parentNode = params.parentNode.data;
              if(parentNode) {
                if (vm.status === CHECK_ITEMS.STATUS.UNMATCHED) {
                  _loadAccounts().then(
                    function Success(accounts) {
                    // Set Default sort params
                      var fetchParams = {projectId: $state.params.projectId, sortModel: 'date', sortOrder: 'asc', transRangeAbs: true, transRangeLow: parentNode.amount, transRangeHigh: parentNode.amount};
                      if (parentNode.accountNumber) {
                        var lastFour = parentNode.accountNumber.slice(-4);
                        var matchingAccounts = accounts[lastFour];
                        if (matchingAccounts && matchingAccounts.length > 0) {
                          fetchParams.accounts = matchingAccounts;
                        }
                      }
                      if (parentNode.date) {
                        var momentDate = moment(parentNode.date);
                        if (momentDate.isValid()) {
                          fetchParams.startDate = momentDate.subtract(1, 'months').format('YYYY-MM-DD');
                        }
                      }
                      var pagingParams = tableUtils.formatPagingParams(fetchParams, true);
                      fetchParams = angular.extend({downloadUrl: true, includeDocs: true, withoutCheckItems: true}, transactionUtils.formatFilterParams(fetchParams), pagingParams);
                      Transactions.findAllPOST(fetchParams, {bypassCache: true}).then(
                        function Success(response) {
                          rows = _formatChildrenRows(parentNode, response);
                          params.successCallback(rows, rows.length);
                          vm.checkeditor.emit([parentNode]);
                        }
                      );
                    }
                  );
                  return;
                } else {
                  rows = _formatChildrenRows(parentNode);
                }
              }
              params.successCallback(rows, rows.length);
            }
          }
        };
      } else {
        // Check-transactions views, (Ready Page)
        return {
          getRows: function(params) {
            var rows = [];
            if(params.request.groupKeys.length === 0 ) { //Loading more root nodes, need to go to backend
              if(params.request.startRow === 0 && vm.transactions) { //We already have the first page provided by the route...
                rows = transactionUtils.formatTxnRows(vm.transactions);
                params.successCallback(rows, Transactions.getMetadata().transCountFilter);
              } else {
                if(!$stateParams.sortModel) {
                  vm.pagination.sortModel = 'date';
                  vm.pagination.sortOrder = 'asc';
                }
                vm.pagination.pageSize = DEFAULT_CHECK_PAGE_SIZE;
                params.checkItemStatus = [CHECK_ITEMS.STATUS.RECONCILED];
                vm.pagination.skipCount = params.request.startRow;
                var transactionParams = angular.extend({downloadUrl: true, sourceType: 'bank', includeCheckItems: true, checkItemStatus: params.checkItemStatus},
                  transactionUtils.formatFilterParams($state.params), tableUtils.formatPagingParams(vm.pagination, true));
                Transactions.findAllPOST(transactionParams).then(
                  function Success(data) {
                    params.successCallback(transactionUtils.formatTxnRows(data), Transactions.getMetadata().transCountFilter); //top level rows
                  }
                );
                vm.statusInfo = CheckItems.getMetadata().statusInfo;
              }
            } else {  //Expanding child nodes, already supplied by the backend....
              var txn = params.parentNode.data;
              if(txn) {
                rows = transactionUtils.formatTxnCheckItemRows(txn); //child rows
              }
              params.successCallback(rows, rows.length);
            }
          }
        };
      }
    }

    //check-items row helpers:
    //I need to know about <this> item, as well as the <parent> item
    function _returnBlankRow(item, parentItem) {
      return  {
        top: false,
        group: false,
        id: vm.checkeditor.fetchTargetRowId(item.id),
        type: "",
        checkNumber: "",
        payee: "",
        payor: "",
        memo: "",
        amount: item.amount, //so we can sort and still keep the blank line associated to the parent check item
        date: "",
        statementDate: "",
        statementAmount: null,
        accountNumber: "",
        children: "",
        page: -1,
        parentId: parentItem.id
      };
    }

    function _returnHiddenVirtualRow() {
      return  {
        top: false,
        group: false,
        id: "-empty",
        type: "",
        checkNumber: "",
        payee: "",
        payor: "",
        memo: "",
        amount: null,
        date: "",
        statementDate: "",
        statementAmount: null,
        accountNumber: "",
        children: "",
        page: -1,
        parentId: "",
      };
    }

    function _formatTopRow(checkItems) {
      if(!checkItems) {
        return [];
      }

      var rows = [];
      _.each(checkItems, function(d) {
        var row = {
          top: true,
          group: (vm.status === CHECK_ITEMS.STATUS.UNMATCHED || (d.children && d.children.length > 0 && d.type === CHECK_ITEMS.TYPE.DEPOSIT)),
          id: d.id,
          rowType: TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM,
          type: d.type,
          checkNumber: d.checkNumber,
          payee: d.payee,
          payor: d.payor,
          memo: d.memo,
          amount: d.amount,
          date: d.date,
          statementDate:"",
          statemementAmount:null,
          statementDescription:"",
          accountNumber: d.accountNumber,
          children: d.children,
          possiblyMissingStatement: d.possiblyMissingStatement,
          parentId: d.id, //I am intentionally setting parentId to my id to allow code to be symetrical ^ there
          categoryLabels: d.categoryLabels,
          customFields: d.customFields,
        };
        if(d.type === CHECK_ITEMS.TYPE.DEPOSIT) {
          row.front = d.imageUrl;
        } else if (d.type === CHECK_ITEMS.TYPE.FRONT || d.type === CHECK_ITEMS.TYPE.TRANSFER) {
          row.front = d.imageUrl;
          row.back = d.children && d.children.length > 0 ? d.children[0].imageUrl : null;
        }
        if(d.sourcePage) {
          row.page = d.sourcePage.number;
          if(d.sourcePage.statement && d.sourcePage.statement.document) {
            row.fileName = d.sourcePage.statement.document.fileName;
            row.fileUrl = d.sourcePage.statement.document.fileUrl;
          }
        }
        if (row.type !== CHECK_ITEMS.TYPE.DEPOSIT) {
          row.children = [];
        }
        if ( d.Transaction ) {
          row.statementDate = d.Transaction.date;
          row.statementAmount = d.Transaction.amount;
          row.statementDescription = d.Transaction.description;
          row.txnPage = d.Transaction.page;
          row.txnFileUrl = d.Transaction.statement ? d.Transaction.statement.downloadUrl : null;
        }
        rows.push(row);

        if (!row.group) {
          rows.push(_returnBlankRow(d, d));
        } else if (vm.status === CHECK_ITEMS.STATUS.UNRECONCILED) {
          rows.push(_returnHiddenVirtualRow());
        }
      });

      /*
       * can't map if I want to push a blank row based on group boolean...
       *
      var rows = checkItems.map(function(d) {
        var row = {
          top: true,
          group: (vm.status === CHECK_ITEMS.STATUS.UNMATCHED || (d.children && d.children.length > 0 && d.type === CHECK_ITEMS.TYPE.DEPOSIT)),
          id: d.id,
          type: d.type,
          checkNumber: d.checkNumber,
          payee: d.payee,
          payor: d.payor,
          memo: d.memo,
          amount: d.amount,
          date: d.date,
          statementDate:"",
          statementDescription:"",
          accountNumber: d.accountNumber,
          children: d.children,
          parentId: d.id //I am intentionally setting parentId to my id to allow code to be symetrical ^ there
        };
        if(d.type === CHECK_ITEMS.TYPE.DEPOSIT) {
          row.front = d.imageUrl;
        } else if (d.type === CHECK_ITEMS.TYPE.FRONT || d.type === CHECK_ITEMS.TYPE.TRANSFER) {
          row.front = d.imageUrl;
          row.back = d.children && d.children.length > 0 ? d.children[0].imageUrl : null;
        }
        if(d.sourcePage) {
          row.page = d.sourcePage.number;
          if(d.sourcePage.statement && d.sourcePage.statement.document) {
            row.fileName = d.sourcePage.statement.document.fileName;
            row.fileUrl = d.sourcePage.statement.document.fileUrl;
          }
        }
        if (row.type !== CHECK_ITEMS.TYPE.DEPOSIT) {
          row.children = [];
        }
        if ( d.Transaction ) {
            row.statementDate = d.Transaction.date;
            row.statementDescription = d.Transaction.description;
        }
        return row;
      });
      */

      return rows;
    }

    function _formatChildrenRows(checkItem, transactions = null) {
      var rows = [];

      //parent item blank row
      rows.push(_returnBlankRow(checkItem, checkItem));

      if(checkItem && checkItem.children && checkItem.children.length) {
        checkItem.children.forEach( function(item) {
          var row = {
            top: false,
            rowType: TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM,
            group: false,
            id: item.id,
            type: item.type,
            checkNumber: item.checkNumber,
            payee: item.payee,
            payor: item.payor,
            memo: item.memo,
            amount: item.amount,
            date: item.date,
            statementDate: "",
            statementAmount: null,
            accountNumber: item.accountNumber,
            children: item.children,
            parentId: checkItem.id,
            categoryLabels: item.categoryLabels,
            customFields: item.customFields,
          };

          if(item.sourcePage && item.sourcePage.statement && item.sourcePage.statement.document) {
            row.page = item.sourcePage.number;
            row.fileName = item.sourcePage.statement.document.fileName;
            row.fileUrl = item.sourcePage.statement.document.fileUrl;
          }

          if (item.type === CHECK_ITEMS.TYPE.FRONT || item.type === CHECK_ITEMS.TYPE.TRANSFER) {
            row.front = item.imageUrl;
            row.back = item.children && item.children.length > 0 ? item.children[0].imageUrl : null;
          }
          rows.push(row);

          //this is a render row for <this> check item
          rows.push(_returnBlankRow(item, checkItem));
        });

        rows.sort(function(a,b) {
          return b.amount - a.amount;
        });
      }

      var firstTxnRow = rows.length;
      if (transactions !== null) {
        transactions.forEach( function(txn) {
          var txnRow = {
            // Can't seem to find a way to get the parent's data from ag-grid, so just dump it into
            // this object for easier matching
            checkId: checkItem.id,
            group: false,
            id: txn.id,
            type: "transaction",
            checkNumber: "",
            payee: "",
            payor: "",
            statementDescription: txn.description,
            amount: null,
            statementDate: txn.date,
            statementAmount: txn.amount,
            date: null,
            accountNumber: "",
            children: [],
            page: txn.page,
            fileUrl: txn.statement ? txn.statement.downloadUrl : null,
            parentId: checkItem.id,
            firstTxnRow: false,
            lastTxnRow: false,
            rowType: TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION,
            categoryLabels: txn.categoryLabels,
            customFields: txn.customFields
          };
          if (vm.accounts[txn.accountId]) {
            txnRow.accountNumber = vm.accounts[txn.accountId].name;
          }
          rows.push(txnRow);
        });
        if (rows.length > firstTxnRow) {
          rows[firstTxnRow].firstTxnRow = true;
          rows[rows.length - 1].lastTxnRow = true;
        }
      }
      return rows;
    }

    function _getCheckFilesState() {
      var state = 'project.documents.statements';
      if(vm.type === PROJECT_TYPES.AUDIT) {
        state = 'engagement.statements';
      }
      return state;
    }

    function _getCheckTransactionsState() {
      var state = 'project.check-items';
      if(vm.type === PROJECT_TYPES.AUDIT) {
        state = 'engagement.check-items';
      }
      return state;
    }

    //called frm the shared inline check editor code now
    function prepareForCheckItemEdit(checkItem) {
      vm.statusInfo = checkItem.statusInfo;
      vm.type = $state.current.data.projectType;
      vm.checkEditData.topCheckItem = checkItem;
      if(vm.checkEditData.topCheckItem.type === CHECK_ITEMS.TYPE.DEPOSIT && vm.checkEditData.topCheckItem.children) {
        vm.checkEditData.topCheckItem.children.forEach(function (i) {
          if(i.type === CHECK_ITEMS.TYPE.FRONT) {
            vm.checkEditData.itemChildren.push(i);
          }
        });
      }
      selectEditCheckItem(vm.checkEditData.topCheckItem);
    }

    function selectEditCheckItem(item) {
      vm.checkEditData.currentItem = item;
      vm.checkEditData.canEdit = vm.checkEditData.currentItem.status === CHECK_ITEMS.STATUS.UNMATCHED || vm.checkEditData.currentItem.status === CHECK_ITEMS.STATUS.UNRECONCILED;
      vm.checkEditData.canEditAmount = vm.checkEditData.canEdit && item.type !== CHECK_ITEMS.TYPE.DEPOSIT;

      vm.checkEditData.editCheckItem = angular.copy(item);
      dateUtils.formatDates(vm.checkEditData.editCheckItem);

      vm.checkEditData.frontImageUrl = vm.checkEditData.editCheckItem.imageUrl;
      vm.checkEditData.backImageUrl = null;
      if (vm.checkEditData.editCheckItem.type === CHECK_ITEMS.TYPE.FRONT || vm.checkEditData.editCheckItem.type === CHECK_ITEMS.TYPE.TRANSFER) {
        vm.checkEditData.backImageUrl = vm.checkEditData.editCheckItem.children && vm.checkEditData.editCheckItem.children.length > 0 ? vm.checkEditData.editCheckItem.children[0].imageUrl : null;
      }
      vm.checkEditData.displayedImageUrlType = 'front';
      vm.checkEditData.displayedImageUrl = vm.checkEditData.frontImageUrl;
    }

    function submitSaveCheckItem(checkEditData) {

      //console.log("checkEditData.editCheckItem: saving::", checkEditData.editCheckItem);

      //manually setting itemDate to be that of the date as set via the UI
      checkEditData.editCheckItem.itemDate = checkEditData.editCheckItem.date;
      var editedCopy = angular.copy(checkEditData.editCheckItem);
      // Slim down the request for the server. Deposit slips with large numbers of children can
      // exceed the 100kb body limit the backend currently enforces, resulting in update failures
      // cf: V8F-3639
      if (editedCopy.children) {
        delete editedCopy.children;
      }
      if (editedCopy.sourcePage) {
        delete editedCopy.sourcePage;
      }
      if (editedCopy.statusInfo) {
        delete editedCopy.statusInfo;
      }

      CheckItems.update(checkEditData.editCheckItem.id, editedCopy)
        .then(function success() {
          toastr.success('Item updated');

          var item = angular.copy(checkEditData.editCheckItem);
          //console.log("item that was saved:", item );

          //update the grid display with the new data
          var node = vm.gridOptions.api.getRowNode(item.id);
          if ( node && node.data ) {
            var datacopy = angular.copy(node.data);
            //note that I am only changing specific items as modifiable in the UI
            datacopy.amount = parseFloat(item.amount);
            datacopy.checkNumber = item.checkNumber;
            datacopy.payor = item.payor;
            datacopy.payee = item.payee;
            datacopy.memo = item.memo;
            datacopy.accountNumber = item.accountNumber;

            //I have to shift the date object because the input is UTC but the local display may be local
            //This only modifies the single row in the UI so that the grid updates without a complete refresh of the data
            var utc = item.date.getTime() + item.date.getTimezoneOffset() * 60000;
            datacopy.date = utc;
            node.setData( datacopy );
          }
        })
        .catch(function error() {
          toastr.error('An error ocurred while updating the item');
        });
    }

    function toggleImage() {
      if(vm.checkEditData.displayedImageUrlType === 'front' && vm.checkEditData.backImageUrl) { //Lookup back image
        vm.checkEditData.displayedImageUrl = vm.backImageUrl;
        vm.checkEditData.displayedImageUrlType = 'back';
      } else { //Back to front image
        vm.checkEditData.displayedImageUrl = vm.checkEditData.frontImageUrl;
        vm.checkEditData.displayedImageUrlType = 'front';
      }
    }

    function stopPropagation(e) {
      e.stopPropagation();
    }

    function _loadAccounts() {
      return new Promise(function(resolve, reject) {
        if (vm.accountsLoaded) {
          resolve(vm.accountNumbersMap);
        } else {
          Accounts.findAll({projectId: $state.params.projectId, exclude: [ACCOUNTS.TYPE.ERP], charts: false}, {bypassCache: true}).then(
            function(accounts) {
              vm.accountNumbersMap = {};
              vm.accounts = {};
              accounts.forEach( function(account) {
                vm.accounts[account.id] = account;
                if (!account.number) {
                  // skip if no account number TODO: Is there something better we can do?
                  return;
                }
                var lastFour = account.number.slice(-4);
                if (vm.accountNumbersMap[lastFour]) {
                  vm.accountNumbersMap[lastFour].push(account.id);
                } else {
                  vm.accountNumbersMap[lastFour] = [];
                  vm.accountNumbersMap[lastFour].push(account.id);
                }
              });
              vm.accountsLoaded = true;
              resolve(vm.accountNumbersMap);
            }
          ).catch(
            function(err) {
              reject(err);
            }
          );
        }
      });
    }

    var exportParams = {
      fileName: _getExportName(),
      columnKeys: [],
      processCellCallback: exportCSVFormatCells
    };

    function _getExportName() {
      var title = 'Check-Items-' + vm.status;
      return 'VALID8_' + title + '_' + moment().format('MMYYYY') + '.csv';
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'statementDate' || params.column.colId === 'date') {
          return $filter('dateDisplay')(params.value);
        } else {
          return params.value;
        }
      } else {
        return params.value;
      }
    }

    function exportToCsv() {
      if (vm.status == CHECK_ITEMS.STATUS.UNMATCHED || vm.status == CHECK_ITEMS.STATUS.UNRECONCILED) {
        exportParams.columnKeys = ['date','statementDate','amount','type','checkNumber','payee','payor','memo','statementDescription','accountNumber','fileName','page','txnPage'];
      } else if (vm.status == CHECK_ITEMS.STATUS.RECONCILED ) {
        exportParams.columnKeys = ['date','amount','checkItem.amount','acount.currency','type','checkNo','name','memo','checkItem.type','checkItem.date','checkItem.checkNumber',
          'checkItem.name','checkItem.payee','checkItem.payor','checkItem.memo','account.bank','account.number','account.type','account.name','fileName','page'];
      }
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

  }
})();

(function() {
  'use strict';

  CheckItemReconcileController.$inject = ["$scope", "$state", "$stateParams", "$mdDialog", "toastr", "dateUtils", "tableUtils", "transactionUtils", "Authorization", "RBAC", "CheckItems", "Transactions", "checkItem", "PROJECT_TYPES", "STATEMENTS", "CHECK_ITEMS"];
  angular
    .module('projects')
    .controller('CheckItemReconcileController', CheckItemReconcileController);

  function CheckItemReconcileController(
    $scope,
    $state,
    $stateParams,
    $mdDialog,
    toastr,
    dateUtils,
    tableUtils,
    transactionUtils,
    Authorization,
    RBAC,
    CheckItems,
    Transactions,
    checkItem,
    PROJECT_TYPES,
    STATEMENTS,
    CHECK_ITEMS) {

    var vm = this;
    vm.source = STATEMENTS.SOURCE.CHECKS_PDF;
    vm.checkItem = checkItem;
    vm.itemChildren = [];
    vm.childrenTotal = 0;
    vm.displayedImageUrl = false;
    vm.canEdit = true;
    vm.transactions = [];
    vm.transactionsLoaded = false;

    vm.goToItem = goToItem;
    vm.toFileTab = toFileTab;
    vm.toItemTab = toItemTab;
    vm.toggleImage = toggleImage;
    vm.submitSaveCheckItem = submitSaveCheckItem;
    vm.selectEditCheckItem = selectEditCheckItem;

    activate();

    function activate() {
      fetchTransactions();
      fetchUnmatchedItems();
      vm.status = $state.params.status;
      vm.statusInfo = vm.checkItem.statusInfo;

      vm.type = $state.current.data.projectType;
      vm.topCheckItem = vm.checkItem;
      if(vm.topCheckItem.type === CHECK_ITEMS.TYPE.DEPOSIT && vm.topCheckItem.children) {
        vm.topCheckItem.children.forEach(function (i) {
          if(i.type === CHECK_ITEMS.TYPE.FRONT) {
            vm.itemChildren.push(i);
          }
        });
        _recalculateDepositSlip();
      }

      selectEditCheckItem(vm.topCheckItem);
    }

    function submitSaveCheckItem() {
      CheckItems.update(vm.editCheckItem.id, vm.editCheckItem)
        .then(function success() {
          vm.currentItem = angular.copy(vm.editCheckItem);
          _recalculateDepositSlip();
          toastr.success('Item saved');
        })
        .catch(function error() {
          toastr.success('An error ocurred');
        });
    }

    function selectEditCheckItem(item) {
      vm.currentItem = item;
      vm.canEdit = vm.currentItem.status === CHECK_ITEMS.STATUS.UNMATCHED || vm.currentItem.status === CHECK_ITEMS.STATUS.UNRECONCILED;
      vm.editCheckItem = angular.copy(item);
      dateUtils.formatDates(vm.editCheckItem);
      vm.frontImageUrl = vm.editCheckItem.imageUrl;
      vm.backImageUrl = null;
      if (vm.editCheckItem.type === CHECK_ITEMS.TYPE.FRONT || vm.editCheckItem.type === CHECK_ITEMS.TYPE.TRANSFER) {
        vm.backImageUrl = vm.editCheckItem.children && vm.editCheckItem.children.length > 0 ? vm.editCheckItem.children[0].imageUrl : null;
      }
      vm.displayedImageUrlType = 'front';
      vm.displayedImageUrl = vm.frontImageUrl;
    }

    function toggleImage() {
      if(vm.displayedImageUrlType === 'front' && vm.backImageUrl) { //Lookup back image
        vm.displayedImageUrl = vm.backImageUrl;
        vm.displayedImageUrlType = 'back';
      } else { //Back to front image
        vm.displayedImageUrl = vm.frontImageUrl;
        vm.displayedImageUrlType = 'front';
      }
    }

    function _recalculateDepositSlip() {
      vm.childrenTotal = 0;
      if(vm.topCheckItem.type === CHECK_ITEMS.TYPE.DEPOSIT && vm.topCheckItem.children) {
        vm.topCheckItem.children.forEach(function (i) {
          if(i.type === CHECK_ITEMS.TYPE.FRONT) {
            vm.childrenTotal += i.amount;
          }
        });
      }
    }

    function goToItem(checkItemId){
      $state.go('project.check-item-reconcile', { checkItemId: checkItemId, status: vm.status });
    }

    function toFileTab(status) {
      $state.go('project.documents.statements', {status: status, source: vm.source});
    }

    function toItemTab(status) {
      var state = status === CHECK_ITEMS.STATUS.UNMATCHED ? 'project.check-items' : 'project.check-item-transactions';
      $state.go(state, {status: status}, {reload: true});
    }

    function fetchTransactions() {
      if (vm.checkItem.status !== CHECK_ITEMS.STATUS.UNMATCHED || vm.checkItem.parentId !== null) {
        vm.transactions = [];
        vm.transactionsLoaded = true;
      } else {
        // Set Default sort params
        var $stateParamsClone = Object.assign({}, $stateParams);
        if(!$stateParamsClone.sortModel) {
          $stateParamsClone.sortModel = 'date';
          $stateParamsClone.sortOrder = 'asc';
        }
        $stateParamsClone.transRangeAbs = true;
        $stateParamsClone.transRangeLow = vm.checkItem.amount;
        $stateParamsClone.transRangeHigh = vm.checkItem.amount;
        var pagingParams = tableUtils.formatPagingParams($stateParamsClone, true);
        var params = angular.extend({includeDocs: true, withoutCheckItems: true}, transactionUtils.formatFilterParams($stateParamsClone), pagingParams);
        Transactions.findAllPOST(params, {bypassCache: true}).then(
          function Success(response) {
            vm.transactions = response;
            vm.transactionsLoaded = true;
          }
        );
      }
    }

    function fetchUnmatchedItems() {
      if (vm.checkItem.status !== CHECK_ITEMS.STATUS.UNMATCHED || vm.checkItem.parentId !== null) {
        return [];
      } else {
        // Set Default sort params
        var $stateParamsClone = Object.assign({}, $stateParams);
        if(!$stateParamsClone.sortModel) {
          $stateParamsClone.sortModel = 'date';
          $stateParamsClone.sortOrder = 'asc';
        }
        var pagingParams = tableUtils.formatPagingParams($stateParamsClone);
        var params = angular.extend({projectId: $stateParamsClone.projectId, status: CHECK_ITEMS.STATUS.UNMATCHED, parentId: 'null', $limit: 1}, pagingParams);
        CheckItems.findAll(params, {bypassCache: true}).then(
          function Success(response) {
            vm.unmatchedItems = response;
            vm.unmatchedItemsLoaded = true;
          }
        );
      }
    }
  }
})();

(function (global) {
  "use strict";
    
  /*
     * OK, here is the pattern:
     *  Global factory to return an object that contains methods scoped to the <this> context.
     *  Everything below is a bit ugly, but the point is to allow it to access things from the 
     *  controller without having all of this crap copied from controller to controller.
     *  Most anything with an _preceeding it is bound to the context of the controller.
     *  This should become a service, but ain't nobody got time fo dat.
     *
     *  Update: It turns out Jordan put everything on a single controller.
     *  That means I really didn't need to put any of this in a shared file...
     *  Oh well.
    */
    
  var locals = {
    renderTarget: 'check-item-render-target',
    postFix: '-empty',
    rowExpanded: 475,
    rowContracted: 0,
    templateUrl: 'app/projects/project/check-items/check-item-inline-editor.html',
    rowLoadComplete: 'rowLoadComplete',
    logEnabled: false
  };

  function log() {
    if (locals.logEnabled) {
      //console.log(arguments);
    }
  }

  global.CreateCheckItemInlineEditor = function(context) {
    function init() {
      SHOTGUN.listen(locals.rowLoadComplete, function(o){log("evt/rowLoadComplete:",o);});
    }
    function colSpan(p) {
      return p.data && p.data.id && p.data.id.includes(locals.postFix) ? 16 : 1;
    }
    function _getRowHeight(p){
      return p.data && p.data.id && p.data.id.includes(locals.postFix) ? 0 : this.gridOptions.rowHeight;
    }
    function targetCellRenderer(params) {
      if (params && params.data && params.data.id.includes(locals.postFix)) {
        return '<div id="' + locals.renderTarget + '-' + params.data.id + '" class="check-item-edit-container"></div>';
      }
    }
    function _isRowGroupLoaded(o) {
      for (var i = 0; i < this.rowGroupsLoaded.length; i++) {
        if (this.rowGroupsLoaded[i].id == o.id) {
          return true;
        }
      }
      return false;
    }
    function fetchRenderTarget(o) {
      return locals.renderTarget + '-' + o.data.id + locals.postFix;
    }
    function _renderInlineCheckEditor(checkItem, target) {
      var t = this;
      this.$templateRequest(locals.templateUrl).then(function(template){
        var newScope = t.$scope.$new(true);
        newScope.$ctrl = _.clone(t.$scope.$ctrl);
        newScope.$ctrl.checkEditData = _.cloneDeep(t.$scope.$ctrl.checkEditData);
                
        //(t.$compile(template)(newScope));
        //var elements = angular.element(template);
               
        //this is what it is doing under the covers:
        //var linkFn = t.$compile(template);
        //var elements = linkFn(newScope);
        //$('#'+target).append(elements);

        //this will clone the elements:
        //t.$compile(template)(newScope, function(ele) {
        //    $('#'+target).append(ele); 
        //});
                
        $('#' + target).append(t.$compile(template)(newScope));
      });
    }
    function cleanupInlineCheckEditor(target) {
      $('#' + target).empty();
    }
    function _renderEditor(o) {
      log("_renderEditor:", o, this);
      var t = this;
      if (!o.node) {
        return;
      }
      //every data row has a peer row that is the same id but with '-empty' appened to the back it
      //this becomes the draw target for <this> checks edit functionality
      var nodeid = o.node.id + locals.postFix;
           
      //if we have children, this will open the > to display them
      //if we don't have children, this will at least fail gracefully if the target row is now drawn
      var targetnode = this.gridOptions.api.getRowNode(nodeid);
      if (!targetnode) {
        var ex = this.gridOptions.api.getRowNode(o.node.id);
        ex.setExpanded(true);
        return;
      }

      if (targetnode.rowHeight > locals.rowContracted) {
        targetnode.setRowHeight(locals.rowContracted);
        targetnode.setExpanded(false);
        cleanupInlineCheckEditor( locals.renderTarget + '-' + targetnode.id );
      } else {
        targetnode.setRowHeight(locals.rowExpanded);
        targetnode.setExpanded(true); //this tickle is what actually forces the draw of the shelf
        this.CheckItems.find(o.data.id, {params: {downloadUrl:true, children: true, navigation: true}}).then(function(ci) {
          t.prepareForCheckItemEdit(ci); //calling back out to the controller to set up <stuff> there
          var __r = _.bind(_renderInlineCheckEditor, t);
          __r(ci,fetchRenderTarget(o));
        });
      }
      this.gridOptions.api.onRowHeightChanged();
    }
    function _onRowGroupOpened(o){
      log("onRowGroupOpened:",o);
      //do <schtuff> when the row is closed
      if (o && o.node && !o.node.expanded && o.node.data && o.node.data.top && this.gridOptions.api) {
        this.gridOptions.api.forEachNode(function(node) {
          if (node.rowHeight > locals.rowContracted  && node.id && node.id.includes(locals.postFix)) {
            //if the event node is top level or a child of a top level
            if ( o.node.data.id + locals.postFix == node.data.id || o.node.data.id == node.data.parentId ) {
              node.setRowHeight(locals.rowContracted);
              cleanupInlineCheckEditor( locals.renderTarget + '-' + node.id );
              node.setExpanded(false);
            }
          }
        });
        this.gridOptions.api.onRowHeightChanged();
      }
    }
    function _rowClicked(o) {
      log("rowClicked:", o, this);
      //ignore any row clicks that are for empty rows
      if (!o || !o.data || o.data.id.includes(locals.postFix)){
        return;
      }
      var renderEditor = _.bind(_renderEditor,this);
      var isRowGroupLoaded = _.bind(_isRowGroupLoaded,this);
      if (o.data.top && !isRowGroupLoaded({id:o.data.id})) {
        //I was initialy allowing the shelf to open right here, but the new behavior is a bit better.
        //The user must open the children rows first. The second click on the parent allows editing.
        //Yes, this is something the user must learn, but is a cleaner pattern
        //If we really really must immediately open the shelf, simply uncomment the listen() below.
        //o.node.setExpanded(true); //this tickles the >
        //SHOTGUN.listen('rowLoadComplete', _render);
      } else { //if a child row is clicked, we know all of the child rows are already available
        renderEditor(o);
      }
    }
    function _trackRowGroupsLoaded() {
      var t = this;
      SHOTGUN.listen(locals.rowLoadComplete, function(o){
        t.rowGroupsLoaded.push(o);
      });
    }
    function emit(o) {
      SHOTGUN.fire(locals.rowLoadComplete, o);
    }
    function fetchTargetRowId(s) {
      return s + locals.postFix;
    }

    //boink
    return {    init: init, 
      colSpan: colSpan, 
      targetCellRenderer: targetCellRenderer,
      rowClicked: _.bind(_rowClicked,context),
      getRowHeight: _.bind(_getRowHeight,context),
      fetchRenderTarget: fetchRenderTarget,
      onRowGroupOpened: _.bind(_onRowGroupOpened,context),
      trackRowGroupsLoaded: _.bind(_trackRowGroupsLoaded,context),
      emit: emit,
      fetchTargetRowId: fetchTargetRowId
    };
  };
}(window));

(function() {
  'use strict';

  CheckItemActionsController.$inject = ["toastr", "$mdDialog", "$state", "Categories", "CustomFields", "CheckItems", "CHECK_ITEMS", "MATCH_TYPES", "Matches", "PROJECT_TYPES", "$filter"];
  angular
    .module('projects')
    .component('checkItemActions', {
      templateUrl: 'app/projects/project/check-items/check-item-actions.html',
      bindings: {
        selectedCheckItems: '<',
        gridOptions: '<',
        categories: '<',
        customFields: '<',
        caller: '@',
        onCategoryUpdate: '&',
        onSave: '&',
      },
      controller: CheckItemActionsController
    })
    .controller('CheckItemActionsController', CheckItemActionsController);

  function CheckItemActionsController(toastr, $mdDialog, $state, Categories, CustomFields, CheckItems,
    CHECK_ITEMS, MATCH_TYPES, Matches, PROJECT_TYPES, $filter) {
    var vm = this;
    vm.status = $state.params.status;
    vm.associate = associate;
    vm.disassociate = disassociate;
    vm.batchItems = batchItems;
    vm.findNewMatches = findNewMatches;
    vm.checkForStatementPeriods = checkForStatementPeriods;
    vm.resetMatches = resetMatches;
    vm.exportToCsv = exportToCsv;
    vm.editCategories = editCategories;
    vm.applyCategory = applyCategory;
    vm.isActionsEnabled = isActionsEnabled;

    var exportParams = {
      fileName: _getExportName(),
      columnKeys: [],
      processCellCallback: exportCSVFormatCells
    };

    this.$onInit = function() {
      //...
    };

    function isActionsEnabled() {
      //only enabling this on check-items page for now...
      if ( vm.caller == "check-items" ) {
        return true;
      } else {
        return false;
      }
    }

    function batchItems(action){
      if(action && vm.selectedCheckItems && vm.selectedCheckItems.length >= 0){
        for (var i = 0; i < vm.selectedCheckItems.length; i++) {
          if (!vm.selectedCheckItems[i].top) {
            toastr.error('This action can only be performed on top-level check items');
            return;
          }
        }
        var checkItemIds = vm.selectedCheckItems.map(function(k) {return k.id;});
        CheckItems.batchUpdate($state.params.projectId, checkItemIds, action).then(function Success() {
          $state.reload();
        });
      }
    }

    function disassociate() {
      if (vm.status !== CHECK_ITEMS.STATUS.UNMATCHED) {
        toastr.error('Disassociation may only be done on unmatched check items');
        return;
      }
      if (vm.selectedCheckItems && vm.selectedCheckItems.length > 0) {
        var ids = [];
        var parentId = null;
        for (var i = 0; i < vm.selectedCheckItems.length; i++) {
          if (vm.selectedCheckItems[i].top) {
            toastr.error('Only child check fronts should be selected');
            return;
          }
          // Shouldn't happen but this would break our parent detection logic, and we probably don't want to try disassociating
          // such a row if we find one
          if (!vm.selectedCheckItems[i].parentId || (vm.selectedCheckItems[i].parentId === vm.selectedCheckItems[i].id)) {
            toastr.error('Could not determine parent deposit slip for one or more check items');
            return;
          }
          if (vm.selectedCheckItems[i].type !== CHECK_ITEMS.TYPE.FRONT) {
            toastr.error('Only check fronts may be disassociated');
            return;
          }
          if (parentId === null) {
            parentId = vm.selectedCheckItems[i].parentId;
          } else if (vm.selectedCheckItems[i].parentId !== parentId) {
            toastr.error('All check fronts to disassociate must belong to the same deposit slip');
            return;
          }
          ids.push(vm.selectedCheckItems[i].id);
        }
        if (ids.length <= 0) {
          toastr.error('At least one check front must be selected');
          return;
        }
        CheckItems.disassociate($state.params.projectId, ids).then(function Success() {
          toastr.success('The selected check items have been disassociated');
          $state.reload();
        }).catch(function Error() {
          toastr.error('Failed to disassociate check items');
          $state.reload();
        });
      }
    }

    function associate() {
      if (vm.status !== CHECK_ITEMS.STATUS.UNMATCHED) {
        toastr.error('Association may only be done on unmatched check items');
        return;
      }
      if (vm.selectedCheckItems && vm.selectedCheckItems.length > 0) {
        var deposit = null;
        var fronts = [];
        var frontIds = [];
        for (var i = 0; i < vm.selectedCheckItems.length; i++) {
          if (!vm.selectedCheckItems[i].top) {
            toastr.error('Check items that are already associated with a deposit slip may not be associated');
            return;
          }
          if (vm.selectedCheckItems[i].type === CHECK_ITEMS.TYPE.DEPOSIT) {
            if (deposit !== null) {
              // We already had a deposit slip, so they selected multiple and that is not supported
              toastr.error('Only one deposit slip may be selected at a time for association');
              return;
            }
            deposit = vm.selectedCheckItems[i];
          } else if (vm.selectedCheckItems[i].type === CHECK_ITEMS.TYPE.FRONT) {
            fronts.push(vm.selectedCheckItems[i]);
            frontIds.push(vm.selectedCheckItems[i].id);
          } else {
            toastr.error('Only deposit slips and check fronts may be associated');
            return;
          }
        }
        if (fronts.length < 0) {
          toastr.error('At least one check front must be selected');
          return;
        }
        for (i = 0; i < fronts.length; i++) {
          // If the deposit(=a series of incoming checks) and the front have the same account number, the front is probably
          // an outgoing check and likely shouldn't be associated to this deposit slip
          if (deposit.accountNumber === fronts[i].accountNumber) {
            toastr.error('One or more of the selected checks have the same account number as the deposit slip. This association is likely incorrect');
            return;
          }
        }
        CheckItems.associate($state.params.projectId, deposit.id, frontIds).then(function Success() {
          toastr.success('The selected check items have been associated');
          $state.reload();
        }).catch(function Error() {
          toastr.error('Failed to associate check items');
          $state.reload();
        });
      }
    }

    function resetMatches() {
      if(!confirm('By confirming this action, all check item matches will be removed.')) {
        return;
      }

      Matches.resetMatches($state.params.projectId, MATCH_TYPES.CHECK_ITEMS).then(
        function Success() {
          toastr.success('All check items are now unmatched');
          $state.reload();
        }
      );
    }

    function findNewMatches() {
      Matches.findMatches($state.params.projectId, MATCH_TYPES.CHECK_ITEMS)
        .then(function Success() {
          toastr.success('The system is looking for new matches, please check back in a few minutes...');
        }).catch(function Failure(response) {
          toastr.error(response.data.message);
        });
    }

    function checkForStatementPeriods() {
      CheckItems.statementPeriodCheck($state.params.projectId)
        .then(function Success() {
          toastr.success('The system is checking for statement periods for all check items, please check back in a few minutes...');
        }).catch(function Failure(response) {
          toastr.error(response.data.message);
        });
    }

    function exportToCsv() {
      if (vm.status == CHECK_ITEMS.STATUS.UNMATCHED || vm.status == CHECK_ITEMS.STATUS.UNRECONCILED) {
        exportParams.columnKeys = ['date','statementDate','amount','type','checkNumber','payee','payor','memo','statementDescription','accountNumber','fileName','page','txnPage'];
      } else if (vm.status == CHECK_ITEMS.STATUS.RECONCILED ) {
        exportParams.columnKeys = ['date','amount','checkItem.amount','acount.currency','type','checkNo','name','memo','checkItem.type','checkItem.date','checkItem.checkNumber',
          'checkItem.name','checkItem.payee','checkItem.payor','checkItem.memo','account.bank','account.number','account.type','account.name','fileName','page'];
      }
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function _getExportName() {
      var title = 'Check-Items-' + vm.status;
      return 'VALID8_' + title + '_' + moment().format('MMYYYY') + '.csv';
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'date' || params.column.colId === 'statementDate') {
          return $filter('dateDisplay')(params.value);
        } else {
          return params.value;
        }
      } else {
        return params.value;
      }
    }

    function editCategories(type) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/categories/edit-category-dialog.html',
        controller: 'EditCategoryDialogController',
        controllerAs: '$ctrl',
        locals: {
          categories: vm.categories,
          customFields: vm.customFields,
          columnType: type
        },
        bindToController: true
      }).then(function() {
        vm.onCategoryUpdate();
      });
    }

    function applyCategory() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/categories/apply-category-dialog.html',
        controller: 'ApplyCategoryDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          itemsForEdit: vm.selectedCheckItems,
          visCategories: _.filter(vm.categories, { isSystemCategory: false }),
          customFields: vm.customFields
        }
      }).then(function Success() {
        vm.categories = Categories.findAllByProject($state.params.projectId);
        vm.customFields = CustomFields.findAllByProject($state.params.projectId);
        vm.onSave({ isRefreshRequired: true });
      });
    }

  }
})();

(function() {
  'use strict';

  ManualMatch.$inject = ["$mdDialog"];
  angular
    .module('categorization')
    .component('manualMatch', {
      templateUrl: 'app/projects/project/categories/manual-match.html',
      bindings: {
        selectedTransactions: '<',
        onSave: '&'
      },
      controller: ManualMatch
    });

  function ManualMatch($mdDialog) {
    var vm = this;
    vm.manualMatch = manualMatch;

    function manualMatch() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/categories/manual-match-dialog.html',
        controller: 'ManualMatchDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          transactions: vm.selectedTransactions
        }
      }).then(function Success() {
        vm.onSave({ isRefreshRequired: true });
      });
    }
  }
})();

(function() {
  'use strict';

  ManualMatchDialogController.$inject = ["$mdDialog", "$q", "toastr", "$stateParams", "Transactions", "TRANSACTION_TYPES", "transactions"];
  angular
    .module('categorization')
    .controller('ManualMatchDialogController', ManualMatchDialogController);

  function ManualMatchDialogController(
    $mdDialog,
    $q,
    toastr,
    $stateParams,
    Transactions,
    TRANSACTION_TYPES,
    transactions) {
    var vm = this;

    vm.cancel = $mdDialog.cancel;
    vm.saveMatch = saveMatch;
    vm.message = '';
    vm.valid = false;

    this.$onInit = function() {
      var t1 = transactions[0];
      var t2 = transactions[1];
      if(t1 && t2) {
        if (t1.rowType !== TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION || t2.rowType !== TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
          vm.message = 'Invalid match: Both selected rows must be transactions';
          return;
        }
        if(t1.account.id === t2.account.id) {
          vm.message = 'Invalid match: Transactions belong to the same account';
          return;
        }
        if( parseFloat(t1.amount + t2.amount) !== 0) {
          vm.message = 'Invalid match: Transactions do not add up to 0';
          return;
        }
        vm.valid = true;
        vm.message = 'Are you sure you want to match these 2 transactions?';
      } else {
        vm.message = 'Invalid transactions';
      }
    };

    function saveMatch() {
      var transactionIds = _.map(transactions, 'id');
      if(transactionIds.length <= 0) {
        return;
      }
      
      Transactions.match($stateParams.projectId, transactionIds)
        .then( function Success() {
          toastr.success('Transactions matched successfuly');
          $mdDialog.hide(true);
        })
        .catch( function Failure(response) {
          toastr.error(response.data.message);
          $mdDialog.hide(true);
        });
    }
  }
})();

(function() {
  'use strict';

  ManageColumnsController.$inject = ["$mdDialog", "$state", "Categories", "CustomFields"];
  angular
    .module('categorization')
    .component('manageColumns', {
      templateUrl: 'app/projects/project/categories/manage-columns.html',
      bindings: {
        selectedItems: '<',
        categories: '<',
        customFields: '<',
        onCategoryUpdate: '&',
        onSave: '&',
        selectedTransactions: '<'
      },
      controller: ManageColumnsController
    });

  function ManageColumnsController($mdDialog, $state, Categories, CustomFields) {
    var vm = this;
    vm.editCategories = editCategories;
    vm.applyCategory = applyCategory;
    vm.manualMatch = manualMatch;

    function editCategories(type) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/categories/edit-category-dialog.html',
        controller: 'EditCategoryDialogController',
        controllerAs: '$ctrl',
        locals: {
          categories: vm.categories,
          customFields: vm.customFields,
          columnType: type
        },
        bindToController: true
      }).then(function() {
        vm.onCategoryUpdate();
      });
    }

    function applyCategory() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/categories/apply-category-dialog.html',
        controller: 'ApplyCategoryDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          itemsForEdit: vm.selectedItems,
          visCategories: _.filter(vm.categories, { isSystemCategory: false }),
          customFields: vm.customFields
        }
      }).then(function Success() {
        vm.categories = Categories.findAllByProject($state.params.projectId);
        vm.customFields = CustomFields.findAllByProject($state.params.projectId);
        vm.onSave({ isRefreshRequired: true });
      });
    }

    function manualMatch() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/categories/manual-match-dialog.html',
        controller: 'ManualMatchDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          transactions: vm.selectedTransactions
        }
      }).then(function Success() {
        vm.onSave({ isRefreshRequired: true });
      });
    }

  }
})();

(function() {
  'use strict';

  FinancialActivityReportSectionsController.$inject = ["$mdDialog", "$state", "$timeout", "$stateParams", "Reports", "REPORTS", "messagingService", "transactionUtils"];
  angular
    .module('projects')
    .controller('FinancialActivityReportSectionsController', FinancialActivityReportSectionsController);

  function FinancialActivityReportSectionsController(
    $mdDialog,
    $state,
    $timeout,
    $stateParams,
    Reports,
    REPORTS,
    messagingService,
    transactionUtils) {
    var vm = this;
    vm.sections = {
      accounts: true,
      accountsSummary: true,
      statementsSummary: true,
      statementsDetail: true,
      transfers: true,
      dateGaps: true,
      files: true,
    };
    vm.launchFinancialActivityReport = launchFinancialActivityReport;
    vm.closeDialog = $mdDialog.cancel;

    function launchFinancialActivityReport() {
      var params = transactionUtils.getFilterParams($state.params);
      var report = {
        type: REPORTS.TYPE.DATA_EXPORT,
        projectId: params.projectId,
        query: {},
        sections: vm.sections,
      };
      Reports.create(report).then(function Success() {
        $mdDialog.hide();
        messagingService.setMessage({
          messageText: 'Export started. Check progress in the Files section'
        });
        messagingService.updateMessages();
      }).catch(function Failure() {
        $mdDialog.hide();
        messagingService.setMessage({
          messageType: 'error',
          messageText: 'Export Failure.'
        });
        messagingService.updateMessages();
      });
    }
  }
})();

(function() {
  'use strict';

  ExcelExportController.$inject = ["$state", "$mdDialog", "Authorization", "REPORTS", "Reports", "messagingService", "transactionUtils"];
  angular
    .module('categorization')
    .component('excelExport', {
      templateUrl: 'app/projects/project/categories/excel-exports.html',
      bindings: {
        type: '<',
      },
      controller: ExcelExportController
    });

  function ExcelExportController($state, $mdDialog, Authorization, REPORTS, Reports, messagingService, transactionUtils) {
    var vm = this;
    vm.excelTransactionsExport = excelTransactionsExport;
    vm.excelDetailedTransactionsExport = excelDetailedTransactionsExport;
    vm.excelBalancesExport = excelBalancesExport;
    vm.financialActivityReport = financialActivityReport;

    function excelBalancesExport() {
      _launchReport(REPORTS.TYPE.BALANCES);
    }

    function excelTransactionsExport() {
      _launchReport(REPORTS.TYPE.TRANSACTIONS);
    }

    function excelDetailedTransactionsExport() {
      _launchReport(REPORTS.TYPE.TRANSACTIONS_DETAIL);
    }

    function financialActivityReport() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/categories/financial-activity-report-sections.html',
        controller: 'FinancialActivityReportSectionsController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: { }
      });
    }

    function _launchReport(type) {
      var params = transactionUtils.getFilterParams($state.params);
      var report = {
        type: type,
        projectId: params.projectId,
        query: params
      };
      Reports.create(report).then(function Success() {
        messagingService.setMessage({
          messageText: 'Export started. Check progress in the Files section'
        });
        messagingService.updateMessages();
      }).catch(function Failure() {
        messagingService.setMessage({
          messageType: 'error',
          messageText: 'Export Failure.'
        });
        messagingService.updateMessages();
      });
    }
  }
})();

(function() {
  'use strict';

  EditCategoryDialogController.$inject = ["$q", "$stateParams", "$mdDialog", "$state", "$scope", "categories", "customFields", "Categories", "CategoryLabels", "CustomFields", "columnType"];
  angular
    .module('categorization')
    .controller('EditCategoryDialogController', EditCategoryDialogController);

  function EditCategoryDialogController(
    $q,
    $stateParams,
    $mdDialog,
    $state,
    $scope,
    categories,
    customFields,
    Categories,
    CategoryLabels,
    CustomFields,
    columnType) {
    var vm = this;
    vm.selectedColumnType = columnType;
    vm.closeEditCategories = $mdDialog.cancel;
    vm.addNewCategory = addNewCategory;
    vm.removeCategory = removeCategory;
    vm.setDefaultLabel = setDefaultLabel;
    vm.addCategoryLabel = addCategoryLabel;
    vm.addCustomField = addCustomField;
    vm.removeLabel = removeLabel;
    vm.removeCustomField = removeCustomField;
    vm.updateColumns = updateColumns;
    vm.selectDefaultLabel = true;
    vm.isCustomCategories = isCustomCategories;
    vm.customCategories = angular.copy(categories);
    vm.customFields = angular.copy(customFields);
    vm.labelsToRemove = [];
    vm.customFieldsToRemove = [];

    function addNewCategory(categoryName) {
      var newCategory = createCategory(categoryName);
      vm.showAddCategory = false;
      vm.customCategories.push(newCategory);
      vm.selectedCategory = newCategory;
    }

    function updateColumns() {
      if(vm.selectedColumnType === 'visCategory') {
        if(!vm.selectedCategory.id) {
          Categories.create(_.omit(vm.selectedCategory, 'categoryLabels')).then(
            function Success(data) {
              vm.selectedCategory = angular.extend(vm.selectedCategory, data);
              return _updateCategoryLabels();
            }
          );
        } else {
          _updateCategoryLabels();
        }
      } else {
        _updateCustomFields();
      }
    }

    function _updateCategoryLabels() {
      var promises = [];
      _.forEach(vm.selectedCategory.categoryLabels, function(label) {
        if(!label.id) {
          label.categoryId = vm.selectedCategory.id;
          promises.push(CategoryLabels.create(label));
        } else {
          promises.push(CategoryLabels.update(label.id, label));
        }
      });
      if(vm.labelsToRemove.length > 0) {
        _.forEach(vm.labelsToRemove, function(label) {
          if(label.id) {
            promises.push(CategoryLabels.destroy(label.id));
          }
        });
      }
      return $q.all(promises).then(
        function Success() {
          // Need to update the store with the categoryLabels
          return Categories.refresh(vm.selectedCategory.id);
        }
      ).then(
        function Success() {
          $mdDialog.hide();
          $state.reload();
        }
      );
    }

    function _updateCustomFields() {
      var promises = [];
      for(var i = 0; i < vm.customFields.length; i++) {
        var field = vm.customFields[i];
        field.index = i;
        if(!field.id) {
          promises.push(CustomFields.create(field));
        } else {
          promises.push(CustomFields.update(field.id, field));
        }
      } 
      if(vm.customFieldsToRemove.length > 0) {
        _.forEach(vm.customFieldsToRemove, function(field) {
          if(field.id) {
            promises.push(CustomFields.destroy(field.id));
          }
          
        });
      }
      return $q.all(promises).then(
        function Success() {
          $mdDialog.hide();
          $state.reload();
        }
      );
    }

    function addCategoryLabel(label) {
      vm.selectedCategory.categoryLabels.push(CategoryLabels.createInstance({
        name: label,
        projectId: $stateParams.projectId,
        categoryId: vm.selectedCategory.id
      }));
    }

    function addCustomField(name) {
      vm.customFields.push(CustomFields.createInstance({
        name: name,
        projectId: $stateParams.projectId
      }));
    }

    function removeLabel(labelIndex) {
      var categoryLabels = vm.selectedCategory.categoryLabels;
      vm.labelsToRemove.push(categoryLabels[labelIndex]);
      // reassign default to the first label
      // otherwise just remove it
      if(categoryLabels[labelIndex].isDefault) {
        categoryLabels.splice(labelIndex, 1);
        vm.setDefaultLabel(categoryLabels[0]);
      } else {
        categoryLabels.splice(labelIndex, 1);
      }
      // turn off removal mode if there is only one
      // label left
      if(categoryLabels.length === 1) {
        categoryLabels[0].initRemove = false;
      }
    }

    function removeCustomField(fieldIndex) {
      vm.customFieldsToRemove.push(vm.customFields[fieldIndex]);
      vm.customFields.splice(fieldIndex, 1);
    }

    function createCategory(label) {
      var category = Categories.createInstance({
        projectId: $stateParams.projectId,
        name: label
      });
      category.categoryLabels[0].projectId = $stateParams.projectId;
      return category;
    }

    function setDefaultLabel(newDefaultLabel) {
      _.forEach(vm.selectedCategory.categoryLabels, function(label) {
        label.isDefault = false;
      });
      newDefaultLabel.isDefault = true;
    }

    function removeCategory() {
      Categories.destroy(vm.selectedCategory.id).then(
        function Success() {
          $mdDialog.hide();
          $state.reload();
        }
      );
    }

    function isCustomCategories() {
      return _.filter(vm.customCategories, { isSystemCategory: false }).length;
    }
  }
})();

(function() {
  'use strict';

  CategoryLabels.$inject = ["DS"];
  angular
    .module('projects')
    .factory('CategoryLabels', CategoryLabels);

  function CategoryLabels(DS) {
    var categoryLabels = DS.defineResource({
      name: 'categoryLabels',
      endpoint: 'category-labels',
      idAttribute: 'id',
      defaultValues: {
        isDefault: false
      },
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    categoryLabels.findAllByProject = function(id) {
      return categoryLabels.findAll({ projectId: id });
    };

    categoryLabels.filterByProject = function(id) {
      return categoryLabels.filter({ 'projectId': id });
    };

    return categoryLabels;
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('categorization')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('project.categories', {
        url: '/categories?startDate&endDate&transRangeLow&transRangeHigh&transRangeAbs&accounts&bankAccountTypes&unmatched&categories&keyword&keywordField&pageSize&sortOrder&sortModel&flow&entities&entitiesEnabled&customField&customFieldLabel',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/categories/categories.html',
            controller: 'CategoriesController as $ctrl'
          }
        },
        resolve: {
          customFields: ["$stateParams", "CustomFields", function($stateParams, CustomFields) {
            return CustomFields.findAllByProject($stateParams.projectId);
          }],
          categories: ["$stateParams", "Categories", function($stateParams, Categories) {
            return Categories.findAllByProject($stateParams.projectId);
          }],
          accounts: ["$stateParams", "Accounts", function($stateParams, Accounts) {
            return Accounts.findAllByProject($stateParams.projectId);
          }],
          transactions: ["$stateParams", "Transactions", "transactionUtils", "tableUtils", "CHECK_ITEMS", function($stateParams, Transactions, transactionUtils, tableUtils, CHECK_ITEMS) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            if(!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'date';
              $stateParamsClone.sortOrder = 'asc';
            }
            if(!$stateParamsClone.sourceType) {
              $stateParamsClone.sourceType = 'bank';
            }
            if(!$stateParamsClone.transRangeAbs) {
              $stateParamsClone.transRangeAbs = 'true';
            }
            var pagingParams = tableUtils.formatPagingParams($stateParamsClone, true);
            var params = angular.extend({ downloadUrl: true, includeDocs: true, includeCheckItems: CHECK_ITEMS.STATUS.RECONCILED }, transactionUtils.formatFilterParams($stateParamsClone), pagingParams);
            return Transactions.findAllPOST(params);
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  Categories.$inject = ["DS"];
  angular
    .module('projects')
    .factory('Categories', Categories);

  function Categories(DS) {
    var categories = DS.defineResource({
      name: 'categories',
      endpoint: 'categories',
      idAttribute: 'id',
      defaultValues: {
        isSystemCategory: false,
        categoryLabels: [
          {
            name: 'Unknown',
            isDefault: true
          }
        ]
      },
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    categories.findAllByProject = function(id) {
      return categories.findAll({ projectId: id, '$sort[index]': 1 }, {bypassCache: true});
    };

    categories.filterByProject = function(id) {
      return categories.filter({ projectId: id });
    };

    return categories;
  }
})();

(function() {
  'use strict';

  CategoriesController.$inject = ["$scope", "$state", "Accounts", "transactions", "Categories", "transactionUtils", "Transactions", "CustomFields", "Projects", "dateUtils"];
  angular
    .module('categorization')
    .controller('CategoriesController', CategoriesController);

  function CategoriesController(
    $scope,
    $state,
    Accounts,
    transactions,
    Categories,
    transactionUtils,
    Transactions,
    CustomFields,
    Projects,
    dateUtils) {
    var vm = this,
      filterDataCopy;

    vm.applyFilter = applyFilter;
    vm.transactions = transactions;
    vm.refresh = refresh;

    activate();

    function activate() {
      vm.transMetadata = Transactions.getMetadata();
      vm.categories = Categories.filterByProject($state.params.projectId);
      vm.customFields = CustomFields.filterByProject($state.params.projectId);
      vm.accounts = Accounts.filterByProject($state.params.projectId);
      vm.filterData = transactionUtils.getFilterData($state.params);
      vm.project = Projects.get($state.params.projectId);
      filterDataCopy = angular.copy(vm.filterData);
    }

    function applyFilter() {
      // if the filter params have not been updated
      // don't filter the table
      if(!angular.equals(vm.filterData, filterDataCopy)) {
        var params;
        //Reset filters if there is a change of source
        if(vm.filterData.sourceType !== filterDataCopy.sourceType) {
          params = {
            projectId: $state.params.projectId,
            sourceType: vm.filterData.sourceType
          };
          $state.go('project.categories', params, {inherit:false});
        } else {
          params = dateUtils.formatUrlDates(angular.copy(vm.filterData));
          if(!params.transRangeLow) {
            delete $state.params.transRangeLow;
          }
          if(!params.transRangeHigh) {
            delete $state.params.transRangeHigh;
          }
          params.projectId = $state.params.projectId;
          $state.go('project.categories', params, {inherit: false});
        }
      }
    }

    function refresh() {
      $state.reload();
    }

  }
})();

(function() {
  'use strict';

  CategoriesTransactionTableController.$inject = ["$filter", "$scope", "$state", "$stateParams", "$mdDialog", "tableUtils", "Transactions", "transactionUtils", "Authorization", "Categories", "Projects", "RBAC", "ACCOUNTS", "CHECK_ITEMS", "TRANSACTION_TYPES", "PROJECT_TYPES"];
  angular
    .module('categorization')
    .component('categoriesTransactionTable', {
      templateUrl: 'app/projects/project/categories/categories-transaction-table.html',
      bindings: {
        transactions: '<',
        categories: '<',
        customFields: '<',
        refresh: '&',
        type: '@'
      },
      controller: CategoriesTransactionTableController
    });

  function CategoriesTransactionTableController(
    $filter,
    $scope,
    $state,
    $stateParams,
    $mdDialog,
    tableUtils,
    Transactions,
    transactionUtils,
    Authorization,
    Categories,
    Projects,
    RBAC,
    ACCOUNTS,
    CHECK_ITEMS,
    TRANSACTION_TYPES,
    PROJECT_TYPES) {
    var vm = this;
    var GRID_ID = 'grid-categories-transactions';
    vm.transactionsUpdated = transactionsUpdated;
    vm.selectedTransactions = [];
    vm.selectAll = selectAll;
    vm.expandCollapse = expandCollapse;
    vm.expand = false;
    vm.reloadData = reloadData;
    vm.onCategoryUpdate = onCategoryUpdate;
    vm.project = Projects.get($state.params.projectId);

    this.$onChanges = function(changes) {
      if(changes.categories && vm.gridOptions) {
        vm.gridOptions.api.setColumnDefs(_.concat(vm.columnDefs, transactionUtils.getCategoryColumns(vm.categories)));
      }
    };

    this.$onInit = function() {
      vm.projectId = $state.params.projectId;
      vm.hasPermissions = Authorization.hasProjectAccess(vm.type, vm.projectId, [RBAC.ROLES.ENGAGEMENT_OWNER, RBAC.ROLES.ENGAGEMENT_USER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.actionColumns = [
        {
          headerName: 'Select',
          field: 'in-edit',
          pinned: 'left',
          checkboxSelection: function(params) {
            return params.data && (params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION || params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM);
          },
          width: 70,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          hide: !vm.hasPermissions,
          suppressColumnsToolPanel: true
        },
        {
          headerName: 'Actions',
          width: 70,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          pinned: 'left',
          cellClass: 'links',
          editable: vm.editableTransactions,
          hide: !vm.hasPermissions,
          suppressColumnsToolPanel: !vm.hasPermissions,
          cellRenderer: function(params) {
            if(params.data && params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
              return '<md-icon class="material-icons icon-primary">edit</md-icon>';
            }
          },
          onCellClicked: function(params) {
            if(params.data && params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
              _editTransaction(params);
            }
          }
        }
      ];

      var allColumnDefs = vm.actionColumns
        .concat(transactionUtils.getDefaultTxnColumns($state, vm.project))
        .concat(transactionUtils.getCategoryColumns(vm.categories))
        .concat(transactionUtils.getCustomFieldColumns(vm.customFields));
      
      if(vm.type === PROJECT_TYPES.FORENSIC){
        allColumnDefs.push(transactionUtils.getSupDocColumn(_openSupDocDialog));
      }

      tableUtils.setColumnSort(vm.pagination, allColumnDefs);

      vm.gridOptions = {
        cacheBlockSize: vm.pagination.pageSize,
        columnDefs: allColumnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        angularCompileRows: true,
        treeData: true,
        animateRows: true,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        onSortChanged: vm.reloadData,
        getMainMenuItems: tableUtils.getMainMenuItems,
        rowModelType: 'serverSide',
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onRowSelected: _toggleSelectTransaction,
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange,
        autoGroupColumnDef: {
          suppressMovable: true,
          pinned: 'left',
          width: 50,
          headerName: '',
          sortable: false,
          cellRendererParams: {
            innerRenderer: function() { return ''; }
          }
        },
        isServerSideGroup: function(dataItem) {
          return dataItem.group;
        },
        getServerSideGroupKey: function(dataItem) {
          return dataItem.id;
        }
      };
    };

    function transactionsUpdated(refreshRequired) {
      selectAll();
      if(refreshRequired) {
        $state.reload();
        //vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      } else {
        vm.gridOptions.api.refreshView();
      }
    }

    function selectAll() {
      tableUtils.selectUnselectAll(vm.gridOptions, true);
    }

    function expandCollapse(){
      vm.expand = !vm.expand;
      vm.gridOptions.api.forEachNode(function(node) {
        if (node.group){
          node.setExpanded(vm.expand);
        }
      });
    }

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID);
      vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      if(!tableUtils.getGridState(GRID_ID)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID);
    }

    function reloadData() {
      var sortModel = vm.gridOptions.api.getSortModel();
      if(sortModel.length) {
        vm.pagination.sortModel = sortModel[0].colId;
        vm.pagination.sortOrder = sortModel[0].sort;
      } else {
        vm.pagination.sortModel = 'date';
        vm.pagination.sortOrder = 'asc';
      }
      vm.pagination.skipCount = 0;
      if(vm.type === PROJECT_TYPES.FORENSIC){
        $state.go('project.categories', vm.pagination);
      }
      else{
        $state.go('engagement.data.categories', vm.pagination);
      }
    }

    function onCategoryUpdate() {
      vm.categories = Categories.findAllByProject($state.params.projectId);
    }

    function _openSupDocDialog(transaction) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/transactions/transaction-documents-dialog.html',
        controller: 'TransactionDocumentsController',
        locals: {
          transaction: transaction
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success(shouldReload) {
        if(shouldReload) {
          vm.reloadData();
        } else {
          vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        }
      });
    }

    function _editTransaction(params) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/transactions/edit-transaction-dialog.html',
        controller: 'EditTransactionController',
        escapeToClose: false,
        locals: {
          gridApi: params.api,
          categories: vm.categories,
          customFields: vm.customFields,
          index: params.rowIndex
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success(shouldReload) {
        if(shouldReload) {
          vm.reloadData();
        } else {
          vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        }
      });
    }

    function _toggleSelectTransaction() {
      vm.selectedTransactions = vm.gridOptions.api.getSelectedRows();
      $scope.$applyAsync();
    }

    function _createDatasource() {
      return {
        getRows: function(params) {
          var rows = [];
          if(params.request.groupKeys.length === 0 ) { //Loading more root nodes, need to go to backend
            if(params.request.startRow === 0 && vm.transactions) { //We already have the first page provided by the route...
              rows = transactionUtils.formatTxnRows(vm.transactions);
              params.successCallback(rows, Transactions.getMetadata().transCountFilter);
            } else {
              var $stateParamsClone = Object.assign({}, $stateParams);
              if(!$stateParamsClone.sortModel) {
                vm.pagination.sortModel = 'date';
                vm.pagination.sortOrder = 'asc';
              }
              if(!$stateParamsClone.sourceType) {
                $stateParamsClone.sourceType = 'bank';
              }
              if(!$stateParamsClone.transRangeAbs) {
                $stateParamsClone.transRangeAbs = 'true';
              }

              vm.pagination.skipCount = params.request.startRow;
              var transactionParams = angular.extend({downloadUrl: true, includeCheckItems: CHECK_ITEMS.STATUS.RECONCILED, includeDocs: true},
                transactionUtils.formatFilterParams($stateParamsClone), tableUtils.formatPagingParams(vm.pagination, true));
              Transactions.findAllPOST(transactionParams).then(
                function Success(data) {
                  params.successCallback(transactionUtils.formatTxnRows(data), Transactions.getMetadata().transCountFilter);
                }
              );
            }
          } else {  //Expanding child nodes, already supplied by the backend....
            var txn = params.parentNode.data;
            if(txn) {
              rows = transactionUtils.formatTxnCheckItemRows(txn);
            }
            params.successCallback(rows, rows.length);
          }
        }
      };
    }
  }
})();

(function() {
  'use strict';

  ApplyCategoryDialogController.$inject = ["$mdDialog", "$q", "$stateParams", "transactionUtils", "CheckItems", "Transactions", "TRANSACTION_TYPES", "itemsForEdit"];
  angular
    .module('categorization')
    .controller('ApplyCategoryDialogController', ApplyCategoryDialogController);

  function ApplyCategoryDialogController(
    $mdDialog,
    $q,
    $stateParams,
    transactionUtils,
    CheckItems,
    Transactions,
    TRANSACTION_TYPES,
    itemsForEdit) {
    var vm = this;
    vm.selectedColumnType = 'visCategory';
    vm.itemsForEdit = itemsForEdit;
    vm.cancelCategories = $mdDialog.cancel;
    vm.saveLabels = saveLabels;
    vm.clearSelection = clearSelection;
    vm.selectedField = null;
    vm.fieldLabel = null;

    function saveLabels() {
      var i;
      var itemIds = [];
      var transactionIds = [];
      for (i = 0; i < vm.itemsForEdit.length; i++) {
        if (vm.itemsForEdit[i].rowType && vm.itemsForEdit[i].rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
          transactionIds.push(vm.itemsForEdit[i].id);
        } else if (!vm.itemsForEdit[i].rowType || vm.itemsForEdit[i].rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.CHECK_ITEM) {
          itemIds.push(vm.itemsForEdit[i].id);
        }
      }
      if(itemIds.length <= 0 && transactionIds.length <= 0) {
        return;
      }
      if(vm.selectedColumnType === 'visCategory') {
        var categoryLabelId = vm.selectedLabelId;
        if(categoryLabelId) {
          Transactions.updateCategories($stateParams.projectId, transactionIds, categoryLabelId).then(
            function() {
              CheckItems.updateCategories($stateParams.projectId, itemIds, categoryLabelId).then(
                function Success() {
                  $mdDialog.hide(true);
                }
              );
            }
          );
        }
      } else if (vm.selectedColumnType === 'customField') {
        var customFieldId = vm.selectedField.id;
        if(customFieldId) {
          Transactions.updateCustomFields($stateParams.projectId, transactionIds, customFieldId, vm.fieldLabel).then(
            function() {
              CheckItems.updateCustomFields($stateParams.projectId, itemIds, customFieldId, vm.fieldLabel).then(
                function Success() {
                  $mdDialog.hide(true);
                }
              );
            }
          );
        }
      }
    }

    function clearSelection() {
      vm.selectedLabelId = null;
    }
  }
})();


(function() {
  'use strict';
  
  ReimportRevisionController.$inject = ["$mdDialog", "$state", "toastr", "BulkRevisions", "$timeout", "revision", "action"];
  angular
    .module('projects')
    .controller('ReimportRevisionController', ReimportRevisionController);
  
  function ReimportRevisionController(
    $mdDialog,
    $state,
    toastr,
    BulkRevisions,
    $timeout,
    revision,
    action) {
    var vm = this;
    vm.action = action;
    vm.revision = revision;
    vm.cancel = $mdDialog.cancel;
    vm.confirm = confirm;
  
    function confirm() {
      return _reimportRevision();
    }

  
    function _reimportRevision() {
      if(!vm.revision.id) {
        toastr.error('Error starting revision process');
        return;
      }
      BulkRevisions.import(vm.revision.id, 'import').then(function Success() {
        toastr.success('Revision started');
        $mdDialog.hide();
        $timeout( function(){$state.go($state.current, {}, {reload: true});}, 1000);
      }).catch(function Failure() {
        toastr.error('Error starting revision process Im here');
        $mdDialog.hide();
        $state.go($state.current, {}, {reload: true});
      });
    }
  }
})();
  
(function() {
  'use strict';

  BulkRevisions.$inject = ["DS", "DSHttpAdapter", "BULK_REVISIONS"];
  angular
    .module('projects')
    .factory('BulkRevisions', BulkRevisions);

  function BulkRevisions(DS, DSHttpAdapter, BULK_REVISIONS) {
    var PROCESSING_STATUSES = [
      BULK_REVISIONS.STATUS.UPLOADED,
      BULK_REVISIONS.STATUS.PENDING,
      BULK_REVISIONS.STATUS.IMPORTING,
      BULK_REVISIONS.STATUS.VERIFYING,
      BULK_REVISIONS.STATUS.REVERTING
    ];
    var metadata;
    var bulkRevisions = DS.defineResource({
      name: 'bulkRevisions',
      endpoint: 'bulk-revisions',
      idAttribute: 'id',
      cacheResponse: false,
      deserialize: function(config, res) {
        metadata = res.data.metadata;
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    bulkRevisions.getMetadata = function() {
      return metadata;
    };

    bulkRevisions.isProcessing = function(status) {
      return status ? PROCESSING_STATUSES.indexOf(status) >= 0 : false;
    };

    bulkRevisions.import = function(revisionId, action) {
      return DSHttpAdapter.HTTP({
        method: 'POST',
        url: DSHttpAdapter.defaults.basePath + '/bulk-revision/import',
        params: {revisionId: revisionId, action: action},
        data: {}
      });
    };

    return bulkRevisions;
  }
})();

(function() {
  'use strict';

  BulkRevisionListTableController.$inject = ["$state", "$stateParams", "$mdDialog", "$filter", "toastr", "Authorization", "Documents", "tableUtils", "BulkRevisions", "BULK_REVISIONS"];
  angular
    .module('projects')
    .component('bulkRevisionListTable', {
      templateUrl: 'app/projects/project/bulk-revisions/bulk-revision-list-table.html',
      bindings: {
        bulkRevisions: '<'
      },
      controller: BulkRevisionListTableController
    });

  function BulkRevisionListTableController(
    $state,
    $stateParams,
    $mdDialog,
    $filter,
    toastr,
    Authorization,
    Documents,
    tableUtils,
    BulkRevisions,
    BULK_REVISIONS) {

    var vm = this;
    var GRID_ID = 'grid-bulk-revisions';
    var GRID_VERSION = 2;
    vm.reloadData = reloadData;
    vm.openUpload = openUpload;

    this.$onInit = function() {
      verifyRevisions();
      vm.isV8Admin = Authorization.isV8Admin();
      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.columnDefs = [
        {
          headerName: 'Delete',
          width: 60,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          cellClass: 'links icons',
          cellRenderer: function(params) {
            if(params.data && params.data.status) {
              var disabled = '';
              if(vm.revisionInProgress && !vm.isV8Admin) {
                disabled = 'icon-disabled';
              }
            }
            return '<md-icon class="material-icons icon-primary ' + disabled + '">delete</md-icon>';
          },
          onCellClicked: function(params) {
            if(!vm.revisionInProgress || vm.isV8Admin) {
              _confirmRevision(params.data, 'delete');
            }
          }
        },
        {
          headerName: 'Filename',
          field: 'document.fileName',
          comparator: filenameComparator,
          width: 200,
          suppressMovable: true,
          sortable: false,
          cellRenderer: function(params) {
            return '<a class="file-name" target="_blank" href="' + params.data.downloadUrl + '">' + $filter('filenameDisplay')(params.value) + '</a>';
          }
        },
        {
          headerName: 'Size',
          field: 'document.size',
          width: 100,
          suppressMovable: true,
          sortable: false,
          comparator: sizeComparator,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('fileSizeDisplay')(params.value);
          }
        },
        {
          headerName: 'Status',
          field: 'status',
          width: 120,
          suppressMovable: true,
          sortable: false,
          cellRenderer: function(params) {
            var status = params.value;
            var statusDisplay = BULK_REVISIONS.STATUS_DESCRIPTION[status];
            if(BulkRevisions.isProcessing(status) && status !== BULK_REVISIONS.STATUS.UPLOADED) {
              return '<revision-status-sync status="data.status" revision-id="data.id" reload="$ctrl.reloadData()"></revision-status-sync>';
            } else if (status === BULK_REVISIONS.STATUS.READY && params.data.canRevert && !vm.revisionInProgress) {
              return '<span>' + statusDisplay + '</span><button class="btn btn-grid type="button"><span>Revert</span></button>';
            } else if(status === BULK_REVISIONS.STATUS.UPLOADED){
              return '<span>' + "Pending" + '</span><button class="btn btn-grid btn-success" type="button"><span>Import</span></button>';
            } 
            else {
              return statusDisplay;
            }
          },
          getQuickFilterText: function(params) {
            return BULK_REVISIONS.STATUS_DESCRIPTION[params.value];
          },
          onCellClicked: function(params) {
            if(params.data.canRevert && !vm.revisionInProgress) {
              _confirmRevision(params.data, 'revert');
            } else if( params.data.status === BULK_REVISIONS.STATUS.UPLOADED){
              _reimportUpload(params.data, 'import');
            }
          }
        },
        {
          headerName: 'Job Type',
          field: 'type',
          width: 150,
          suppressMovable: true,
          sortable: false,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return BULK_REVISIONS.TYPE_DESCRIPTION[params.value];
          }
        },
        {
          headerName: 'Revise Date',
          field: 'createdAt',
          width: 120,
          suppressMovable: true,
          sortable: false,
          valueFormatter: function(params) {
            return $filter('dateTimeFilter')(params.value);
          }
        },
        {
          headerName: 'Txns Revised',
          field: 'metrics',
          width: 100,
          suppressMovable: true,
          sortable: false,
          valueFormatter: function(params) {
            if(params.value && params.value.revisedCount) {
              return $filter('number')(params.value.revisedCount);
            }
            return '';
          }
        },
        {
          headerName: 'Notes',
          field: 'description',
          width: 200,
          suppressMovable: true,
          sortable: false
        },
        {
          headerName: 'Errors',
          field: 'errors',
          width: 200,
          suppressMovable: true,
          sortable: false,
          valueFormatter: function(params) {
            if(params.value && params.value.length > 0) {
              return params.value[0];
            }
            return '';
          }
        },
        {
          headerName: 'Upload User',
          field: 'document.uploadUser',
          width: 250,
        },
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        rowData: vm.bulkRevisions,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        getMainMenuItems: tableUtils.getMainMenuItems,
        angularCompileRows: true,
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange
      };
    };

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID, GRID_VERSION);
      if(!tableUtils.getGridState(GRID_ID, GRID_VERSION)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID, GRID_VERSION);
    }

    function reloadData() {
      $state.reload();
    }

    function verifyRevisions() {
      vm.revisionInProgress = false;
      var foundCanRevert = false;
      vm.bulkRevisions.forEach( function(r) {
        if(BulkRevisions.isProcessing(r.status)) {
          vm.revisionInProgress = true;
        }
        if(!foundCanRevert && r.status === BULK_REVISIONS.STATUS.READY) {
          r.canRevert = true;
          foundCanRevert = true;
        } else {
          r.canRevert = false;
        }
      });
    }

    function filenameComparator(file1, file2) {
      if(!file1) {
        return -1;
      }
      if(!file2) {
        return 1;
      }
      var formatted1 = $filter('filenameDisplay')(file1).toLowerCase();
      var formatted2 = $filter('filenameDisplay')(file2).toLowerCase();
      return formatted1 > formatted2 ? 1 : -1;
    }

    function sizeComparator(size1, size2) {
      if(!size1 || isNaN(size1)) {
        return -1;
      }
      if(!size2 || isNaN(size2)) {
        return 1;
      }
      return size1 - size2;
    }


    function openUpload() {
      Documents.getUploadParameters($stateParams.projectId).then(
        function Success(response) {
          $mdDialog.show({
            templateUrl: 'app/projects/project/bulk-revisions/add-bulk-revision.html',
            controller: 'AddBulkRevisionController',
            controllerAs: '$ctrl',
            bindToController: true,
            escapeToClose: false,
            locals: {
              uploadParameters: response.data
            }
          });
        })
        .catch(function Failure(response) {
          toastr.error(response.data.message);
        });
    }

    function _reimportUpload(revision, action){
      $mdDialog.show({
        templateUrl:'app/projects/project/bulk-revisions/reimport-bulk-revision-dialog.html',
        controller:'ReimportRevisionController',
        locals: {
          revision: revision,
          action: action
        },
        controllerAs: '$ctrl',
        bindToController: true
        
      }).then(function Success() {
        if (vm.gridOptions.api) {
          vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        }
      });

    }
    function _confirmRevision(revision, action) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/bulk-revisions/bulk-revision-confirm-dialog.html',
        controller: 'BulkRevisionConfirmController',
        locals: {
          revision: revision,
          action: action
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success() {
        if (vm.gridOptions.api) {
          vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        }
      });
    }
  }
})();

(function() {
  'use strict';

  BulkRevisionConfirmController.$inject = ["$mdDialog", "$state", "toastr", "$stateParams", "BulkRevisions", "revision", "action"];
  angular
    .module('projects')
    .controller('BulkRevisionConfirmController', BulkRevisionConfirmController);

  function BulkRevisionConfirmController(
    $mdDialog,
    $state,
    toastr,
    $stateParams,
    BulkRevisions,
    revision,
    action) {
    var vm = this;
    vm.action = action;
    vm.revision = revision;
    vm.cancel = $mdDialog.cancel;
    vm.confirm = confirm;

    function confirm() {
      if(vm.action === 'delete') {
        _deleteRevision();
      }
      if(vm.action === 'revert') {
        _revertRevision();
      }
    }

    function _deleteRevision() {
      BulkRevisions.destroy(vm.revision.id)
        .then(function Success() {
          toastr.success('Revision file successfully deleted.');
          $mdDialog.hide();
          $state.reload();
        })
        .catch(function Failure() {
          toastr.success('An error ocurred. Cannot delete revision file.');
          $mdDialog.hide();
          $state.reload();
        });
    }

    function _revertRevision() {
      BulkRevisions.import(vm.revision.id, 'revert')
        .then(function Success() {
          toastr.success('Revert process started');
          $mdDialog.hide();
          $state.reload();
        })
        .catch(function Failure() {
          toastr.success('An error ocurred. Cannot revert revision file.');
          $mdDialog.hide();
          $state.reload();
        });
    }
  }
})();

(function() {
  'use strict';

  AddBulkRevisionController.$inject = ["$state", "$stateParams", "$mdDialog", "$timeout", "toastr", "Documents", "Authorization", "Upload", "BulkRevisions", "uploadParameters", "DOCUMENT_TYPES"];
  angular
    .module('projects')
    .controller('AddBulkRevisionController', AddBulkRevisionController);

  function AddBulkRevisionController(
    $state,
    $stateParams,
    $mdDialog,
    $timeout,
    toastr,
    Documents,
    Authorization,
    Upload,
    BulkRevisions,
    uploadParameters,
    DOCUMENT_TYPES) {
    var vm = this;

    vm.uploadFiles = uploadFiles;
    vm.isUploading = isUploading;
    vm.cancelUpload = cancelUpload;
    vm.startRevision = startRevision;
    vm.abortUpload = abortUpload;
    vm.getFileErrorMessage = getFileErrorMessage;

    vm.files = [];
    vm.errorFiles = [];

    activate();

    function activate() {
      vm.files = [];
      vm.errorFiles = [];
      vm.addDocumentTitle = 'Upload Bulk Revision file';
      vm.acceptPattern = 'text/csv';
      vm.ngUploadPattern = '.csv';
      vm.maxSize = '100MB';
      vm.info = 'Select CSV file';
      vm.type = DOCUMENT_TYPES.BULK_REVISION.type;
    }

    function isUploading() {
      return Upload.isUploadInProgress();
    }

    function uploadFiles(files, errorFiles) {
      vm.files = files;
      vm.errorFiles = errorFiles;
      angular.forEach(files, function(file) {
        //Users may upload multiple files with the same name, need to differentiate them when associated with different DB entities.
        var randKey = Math.floor(Math.random() * 10000);
        const uploadData = {
          key: uploadParameters.folder + '/bulk-revisions/' + randKey + '/' + file.name,
          acl: 'private',
          policy: uploadParameters.policy,
          'x-amz-algorithm': uploadParameters['x-amz-algorithm'],
          'x-amz-credential': uploadParameters['x-amz-credential'],
          'x-amz-date': uploadParameters['x-amz-date'],
          'x-amz-signature': uploadParameters.signature,
          'x-amz-security-token': uploadParameters['x-amz-security-token'],
          "Content-Type": file.type != '' ? file.type : 'application/octet-stream',
          filename: file.name,
          file: file
        };
        if (!uploadParameters['x-amz-security-token']) {
          delete uploadData['x-amz-security-token'];
        }
        file.upload = Upload.upload({
          url: uploadParameters.url,
          method: 'POST',
          data: uploadData,
        });

        file.upload.then(function (response) {
          _saveDocumentData(file, response.config.data.key);
        }, function (response) {
          if (response.status > 0) {
            _failure(file, response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      });
    }

    function _saveDocumentData(file, filename) {
      vm.newDocument = {};
      vm.newDocument.fileName = filename;
      vm.newDocument.size = file.size;
      vm.newDocument.projectId = $stateParams.projectId;
      vm.newDocument.uploadDate = moment().toISOString();
      vm.newDocument.uploadUser = Authorization.getUserProfile().email;
      vm.newDocument.type = vm.type;
      vm.newDocument.mimeType = file.type;
      Documents.create(vm.newDocument, {params:{nb:1}}).then(
        function Success(response) {
          _saveBulkRevision(response.id, file);
        })
        .catch(function Failure() {
          _failure(file, 'Upload failed, please contact a system admin...');
        });
    }

    function _saveBulkRevision(docId, file) {
      vm.newRevision = {};
      vm.newRevision.documentId = docId;
      vm.newRevision.description = vm.revisionDescription;
      BulkRevisions.create(vm.newRevision, {params:{nb:1}}).then(
        function Success(response) {
          vm.revisionId = response.id;
          _success(file, 'Revision file uploaded.');
        })
        .catch(function Failure() {
          _failure(file, 'Upload failed, please contact a system admin...');
        });
    }

    function _success(file, messageText) {
      file.successMessage = messageText;
    }

    function _failure(file, messageText) {
      file.errorMessage = messageText;
    }

    function abortUpload() {
      angular.forEach(vm.files, function(file) {
        if(file.upload) {
          file.upload.abort();
        }
      });
    }

    function getFileErrorMessage(file) {
      var message = file.name;
      if(file.errorMessage) {
        return message + ' Error: ' + file.errorMessage;
      } else if (file.$error === 'pattern') {
        return message + ' Error: file extension not accepted';
      } else if (file.$error === 'maxSize') {
        return message + ' Error: file exceeds maximum allowed size';
      } else {
        return message + ' Error';
      }
    }

    function startRevision() {
      if(!vm.revisionId) {
        toastr.error('Error starting revision process');
        return;
      }
      BulkRevisions.import(vm.revisionId, 'import').then(function Success() {
        toastr.success('Revision started');
        $mdDialog.hide();
        $timeout( function(){$state.go($state.current, {}, {reload: true});}, 1000);
      }).catch(function Failure() {
        toastr.error('Error starting revision process');
        $mdDialog.hide();
        $state.go($state.current, {}, {reload: true});
      });
    }

    function cancelUpload() {
      if(vm.revisionId) {
        BulkRevisions.destroy(vm.revisionId)
          .then( function success() {
            $mdDialog.cancel();
          })
          .catch( function fail() {
            toastr.error('Error cancelling csv upload');
            $mdDialog.cancel();
          });
      } else {
        $mdDialog.cancel();
      }
    }
  }
})();

(function() {
  'use strict';

  MoveTransactionsController.$inject = ["$mdDialog", "$timeout", "$scope", "$state", "$stateParams", "$filter", "toastr", "ACCOUNT_PERIODS", "AccountPeriods", "Transactions", "accountPeriod", "transactions"];
  angular
    .module('projects')
    .controller('MoveTransactionsController', MoveTransactionsController);

  function MoveTransactionsController(
    $mdDialog,
    $timeout,
    $scope,
    $state,
    $stateParams,
    $filter,
    toastr,
    ACCOUNT_PERIODS,
    AccountPeriods,
    Transactions,
    accountPeriod,
    transactions) {

    var vm = this;
    vm.accountPeriod = accountPeriod;
    vm.transactions = transactions;
    vm.accountPeriods = [];
    vm.close = close;
    vm.move = move;
    vm.selectedPeriod = null;

    this.$onInit = function() {
      vm.columnDefs = [
        {
          headerName: 'Select',
          field: 'selected',
          checkboxSelection: true,
          width: 70,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true
        },
        {
          headerName: 'Start Date',
          field: 'startDate',
          width: 80,
          suppressMovable: true,
          sortable: false,
          suppressMenu: true,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'End Date',
          field: 'endDate',
          width: 80,
          suppressMovable: true,
          sortable: false,
          suppressMenu: true,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Beg Bal',
          width: 100,
          suppressMovable: true,
          sortable: false,
          field: 'startBalance',
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('currencyDisplayFilter')(params.value, accountPeriod.account.currency);
          },
          cellStyle: {textAlign: "right"}
        },
        {
          headerName: 'Increase',
          width: 100,
          suppressMovable: true,
          sortable: false,
          field: 'inflows',
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('currencyDisplayFilter')(params.value, accountPeriod.account.currency);
          },
          cellStyle: {textAlign: "right"}
        },
        {
          headerName: 'Decrease',
          width: 100,
          suppressMovable: true,
          sortable: false,
          field: 'outflows',
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('currencyDisplayFilter')(params.value, accountPeriod.account.currency);
          },
          cellStyle: {textAlign: "right"}
        },
        {
          headerName: 'End Bal',
          width: 100,
          suppressMovable: true,
          sortable: false,
          field: 'endBalance',
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('currencyDisplayFilter')(params.value, accountPeriod.account.currency);
          },
          cellStyle: {textAlign: "right"}
        }
      ];
      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        rowSelection: 'single',
        rowHeight: 30,
        headerHeight: 25,
        rowData: vm.accountPeriods,
        onGridReady: function(params) { params.api.sizeColumnsToFit(); },
        onSelectionChanged: function() {
          vm.selectedPeriod = vm.gridOptions.api.getSelectedRows()[0];
          $scope.$applyAsync();
        }
      };

      _fetchAccountPeriods();
    };

    function _fetchAccountPeriods() {
      var params = { projectId: $stateParams.projectId, accountId: vm.accountPeriod.accountId, status: ACCOUNT_PERIODS.STATUS.UNRECONCILED };
      AccountPeriods.findAll(params)
        .then( function Success(response) {
          _sortPeriods(response);
          vm.gridOptions.api.setRowData(vm.accountPeriods);
        })
        .catch(function Failure() {
          toastr.error('Failed to fetch account periods');
          vm.error = true;
        });
    }

    function _sortPeriods(periods) {
      var foundIndex = -1;
      for(var p = 0; p < periods.length; p++) {
        if(periods[p].id === vm.accountPeriod.id) {
          foundIndex = p;
          break;
        }
      }
      vm.accountPeriods = [];
      for(var i = 0; i < periods.length; i++) {
        if(foundIndex - i - 1 >= 0) {
          vm.accountPeriods.push(periods[foundIndex - i - 1]);
        }
        if(foundIndex + i + 1 < periods.length) {
          vm.accountPeriods.push(periods[foundIndex + i + 1]);
        }
      }
    }

    function move() {
      if(vm.selectedPeriod && vm.selectedPeriod.id) {
        var accountPeriodId = vm.selectedPeriod.id;
        var transactionIds = _.map(vm.transactions, 'id');
        if(accountPeriodId && transactionIds.length > 0) {
          Transactions.moveTransactions($stateParams.projectId, accountPeriodId, transactionIds).then(function Success() {
            $timeout(function() {
              $mdDialog.cancel();
              $state.reload();
            }, 1000);        
          });
        }
      }
    }

    function close() {
      $mdDialog.cancel();
    }
  }
})();

(function() {
  'use strict';

  EditPeriodTransactionController.$inject = ["$mdDialog", "$state", "$timeout", "$sce", "$scope", "dateUtils", "Transactions", "Projects", "Authorization", "RBAC", "transaction", "accountPeriod"];
  angular
    .module('projects')
    .controller('EditPeriodTransactionController', EditPeriodTransactionController);

  function EditPeriodTransactionController(
    $mdDialog,
    $state,
    $timeout,
    $sce,
    $scope,
    dateUtils,
    Transactions,
    Projects,
    Authorization,
    RBAC,
    transaction,
    accountPeriod) {

    var vm = this;
    vm.accountPeriod = accountPeriod;
    vm.closeEditTransaction = closeEditTransaction;
    vm.transaction = transaction;
    vm.startDate = new Date(accountPeriod.startDate).toISOString().substr(0,10);
    vm.endDate = new Date(accountPeriod.endDate).toISOString().substr(0,10);
    vm.submitSaveTransaction = submitSaveTransaction;
    vm.removeTransaction = removeTransaction;

    vm.clearTransactionMemo = clearTransactionMemo;
    vm.manualEntryMemo = manualEntryMemo;

    activate();

    function activate() {
      vm.editTransaction = angular.copy(transaction);
      vm.editTransaction.date = moment.utc(vm.editTransaction.date).toDate();
      vm.project = Projects.get($state.params.projectId);
      vm.hasPermissions = Authorization.hasProjectAccess(vm.project.type, vm.project.id, [RBAC.ROLES.ENGAGEMENT_OWNER, RBAC.ROLES.ENGAGEMENT_USER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
      resetValues();

      if(vm.editTransaction.page && !isNaN(vm.editTransaction.page)) {
        vm.page = parseInt(vm.editTransaction.page) + 1;
        vm.linkPage = vm.accountPeriod.downloadUrl ? $sce.trustAsHtml('<a target="_blank" href="' + vm.accountPeriod.downloadUrl + '#page=' + vm.page + '">' + vm.page + '</a>') : vm.page;
      } else if ( angular.isUndefined(vm.editTransaction.page) || !vm.editTransaction.page) {
        vm.editTransaction.memo = "REC";
        $scope.$applyAsync();
      } else if (vm.editTransaction.memo === "Manual Entry") {
        vm.checkAdjustment = true;
        vm.checkOCR = false;
      }
    }

    function closeEditTransaction() {
      if(vm.isConfirmRemove) {
        vm.isConfirmRemove = !vm.isConfirmRemove;
      } else {
        $mdDialog.cancel();
      }
    }

    function submitSaveTransaction(form) {
      if(!form.$invalid) {
        // In case the user types a page number, then we need to do -1 because Ocrolus is zero based
        vm.editTransaction.page = !isNaN(vm.editTransaction.page) ? vm.editTransaction.page - 1 : vm.editTransaction.page;
        Transactions.update(vm.editTransaction.id, vm.editTransaction)
          .then(function Success() {
            $mdDialog.hide();
            $state.reload();
          });
      }
    }

    function removeTransaction() {
      Transactions.destroy(vm.transaction.id)
        .then(function Success() {
          $mdDialog.hide(true);
          $timeout( function(){
            $state.reload();
          }, 1000);
        });
    }

    function clearTransactionMemo(){
      vm.checkOCR = true;
      vm.checkAdjustment = false;
      vm.editTransaction.memo = (vm.memo) ? vm.memo : "REC";
    }

    function manualEntryMemo(){
      vm.checkOCR = false;
      vm.checkAdjustment = true;
      vm.editTransaction.memo = "Manual Entry";
    }

    function resetValues() {
      vm.memo = null;
      vm.checkAdjustment = false;
      vm.checkOCR = true;
    }
  }
})();

(function() {
  'use-strict';

  DeleteTransactionsController.$inject = ["$mdDialog", "$timeout", "$state", "$stateParams", "Transactions", "transactions", "accountPeriod"];
  angular
    .module('projects')
    .controller('DeleteTransactionsController', DeleteTransactionsController);

  function DeleteTransactionsController(
    $mdDialog,
    $timeout,
    $state,
    $stateParams,
    Transactions,
    transactions,
    accountPeriod) {
    var vm = this;
    vm.accountPeriod = accountPeriod;
    vm.transactions = transactions;
    vm.close = $mdDialog.cancel;
    vm.confirm = confirm;

    function confirm() {
      var transactionIds = _.map(vm.transactions, 'id');
      if(vm.accountPeriod && vm.accountPeriod.id && transactionIds.length > 0) {
        Transactions.deleteTransactions($stateParams.projectId, vm.accountPeriod.id, transactionIds).then(function Success() {
          $timeout(function() {
            $mdDialog.cancel();
            $state.reload();
          }, 1000);        
        });
      }
    }

  }
})();

(function() {
  'use strict';

  DeleteAccountPeriodsController.$inject = ["$mdDialog", "$state", "$timeout", "$stateParams", "AccountPeriods", "itemsToDelete"];
  angular
    .module('projects')
    .controller('DeleteAccountPeriodsController', DeleteAccountPeriodsController);

  function DeleteAccountPeriodsController(
    $mdDialog,
    $state,
    $timeout,
    $stateParams,
    AccountPeriods,
    itemsToDelete) {
    var vm = this;
    vm.itemsToDelete = itemsToDelete;
    vm.cancel = $mdDialog.cancel;
    vm.deleteAccountPeriods = deleteAccountPeriods;


    this.$onInit = function() {
      setDescriptionCounter();
    };

    function setDescriptionCounter() {
      var counter = (vm.itemsToDelete) ? vm.itemsToDelete.length : 0;
      vm.descriptionCounter = (counter === 1) ? '1 account period' : counter + ' account periods';
    }

    function deleteAccountPeriods() {
      var accountPeriodIds = _.map(itemsToDelete, function (accountPeriod) {
        return accountPeriod.id;
      });

      AccountPeriods.batchUpdate($stateParams.projectId, accountPeriodIds, 'delete').then(
        function Success() {
          $mdDialog.hide();
          $state.reload();
        }
      ).catch(
        function Failure() {
          $mdDialog.show({
            templateUrl: 'app/core/utils/alert-dialog/alert-dialog.html',
            controller: 'AlertDialogController',
            controllerAs: '$ctrl',
            bindToController: true,
            locals: {
              message: 'There was an error deleting the account period(s), please contact a system admin...'
            }
          });
        }
      );
    }
  }
})();

(function() {
  'use strict';

  DeleteAccountPeriodController.$inject = ["$state", "$stateParams", "$mdDialog", "$timeout", "AccountPeriods", "type", "accountPeriod", "PROJECT_TYPES", "ACCOUNT_PERIODS", "toastr"];
  angular
    .module('projects')
    .controller('DeleteAccountPeriodController', DeleteAccountPeriodController);

  function DeleteAccountPeriodController(
    $state,
    $stateParams,
    $mdDialog,
    $timeout,
    AccountPeriods,
    type,
    accountPeriod,
    PROJECT_TYPES,
    ACCOUNT_PERIODS,
    toastr) {

    var vm = this;
    vm.deleteAccountPeriod = deleteAccountPeriod;
    vm.cancel = cancel;
    vm.accountPeriod = accountPeriod;
    vm.type = type;
    vm.defineRoute = defineRoute;

    function deleteAccountPeriod() {
      var accountPeriodCopy = angular.copy(accountPeriod);
      AccountPeriods.destroy(vm.accountPeriod.id).then(function Success(){
        toastr.success('Account Period Deleted');
        $mdDialog.hide();
        $timeout(function () {
          $state.go(defineRoute(), { source: accountPeriodCopy.statement.source, status: accountPeriodCopy.status }, {reload: true});
        }, 1000);
      });
    }

    function defineRoute(){
      if(vm.type === PROJECT_TYPES.AUDIT){
        return 'engagement.account-periods';
      }
      return 'project.account-periods';
    }

    function cancel(){
      $mdDialog.hide();
    }
  }
})();

(function() {
  'use strict';

  AutoReconcileTransactionController.$inject = ["$stateParams", "$mdDialog", "Transactions", "accountPeriod", "variance", "TRANSACTION_TYPES"];
  angular
    .module('projects')
    .controller('AutoReconcileTransactionController', AutoReconcileTransactionController);

  function AutoReconcileTransactionController(
    $stateParams,
    $mdDialog,
    Transactions,
    accountPeriod,
    variance,
    TRANSACTION_TYPES) {

    var vm = this;
    vm.submitSaveTransaction = submitSaveTransaction;

    function submitSaveTransaction() {
      vm.transaction = Transactions.createInstance();
      vm.transaction = _processTransaction(vm.transaction);
      Transactions.create(vm.transaction)
        .then(function Success() {
          $mdDialog.hide();
        });
    }

    function _processTransaction(transaction) {
      transaction.projectId = $stateParams.projectId;
      transaction.accountId = accountPeriod.accountId;
      transaction.statementId = accountPeriod.statementId;
      transaction.accountPeriodId = accountPeriod.id;
      transaction.date = accountPeriod.endDate;
      transaction.memo = 'REC';
      transaction.description = transaction.originalDescription = 'ADJ';
      transaction.amount = transaction.originalAmount = (variance * -1);
      transaction.type = TRANSACTION_TYPES.TYPE.ADJUSTMENT;
      return transaction;
    }
  }
})();

(function() {
  'use-strict';

  AssignAccountPeriodsDialogController.$inject = ["$mdDialog", "source", "allPeriods", "correctPeriods", "overlappingPeriods"];
  angular
    .module('projects')
    .controller('AssignAccountPeriodsDialogController', AssignAccountPeriodsDialogController);

  function AssignAccountPeriodsDialogController(
    $mdDialog,
    source,
    allPeriods,
    correctPeriods,
    overlappingPeriods) {
    var vm = this;
    vm.source = source;
    vm.cancel = $mdDialog.cancel;
    vm.next = next;
    vm.allPeriods = allPeriods;
    vm.correctPeriods = correctPeriods;
    vm.overlappingPeriods = overlappingPeriods;
    vm.selectedGroup = 'correctPeriods';

    function next() {
      var periods = vm[vm.selectedGroup];
      $mdDialog.cancel();
      $mdDialog.show({
        templateUrl: 'app/projects/project/account/assign-account-dialog.html',
        controller: 'AssignAccountDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          source: vm.source,
          itemsToAssign: periods,
          type: 'accountPeriod'
        }
      });
    }

  }
})();

(function() {
  'use strict';

  AddTransactionController.$inject = ["$q", "$stateParams", "$scope", "$state", "$mdDialog", "toastr", "dateUtils", "Transactions", "Accounts", "ACCOUNTS", "TRANSACTION_TYPES", "transaction", "accountPeriod"];
  angular
    .module('projects')
    .controller('AddTransactionController', AddTransactionController);

  function AddTransactionController(
    $q,
    $stateParams,
    $scope,
    $state,
    $mdDialog,
    toastr,
    dateUtils,
    Transactions,
    Accounts,
    ACCOUNTS,
    TRANSACTION_TYPES,
    transaction,
    accountPeriod) {
    var vm = this;
    vm.accountPeriod = accountPeriod;
    vm.transaction = transaction;
    vm.startDate = new Date(accountPeriod.startDate).toISOString().substr(0,10);
    vm.endDate = new Date(accountPeriod.endDate).toISOString().substr(0,10);
    vm.closeEditTransaction = $mdDialog.cancel;

    vm.submitSaveTransaction = submitSaveTransaction;
    vm.saveAndCopy = saveAndCopy;
    vm.clearTransactionMemo = clearTransactionMemo;
    vm.manualEntryMemo = manualEntryMemo;

    activate();

    function activate() {
      dateUtils.formatDates(vm.transaction);
      if(angular.isUndefined(vm.transaction.memoOpt)) {
        vm.transaction.memoOpt = 'ocrMissing';
      }
      if(angular.isUndefined(vm.transaction.memo)){
        vm.transaction.memo = "REC";
      }
    }


    function submitSaveTransaction(form, saveAndCopy) {
      var transactionCopy;
      if(!form.$invalid) {
        vm.transaction = _processTransaction(vm.transaction);
        transactionCopy = vm.transaction;
        Transactions.create(vm.transaction)
          .then(function Success() {
            if(saveAndCopy){
              $state.reload();
              $mdDialog.show({
                templateUrl: 'app/projects/project/account-periods/add-transaction-dialog.html',
                controller: 'AddTransactionController',
                locals: {
                  transaction: transactionCopy,
                  accountPeriod: vm.accountPeriod
                },
                controllerAs: '$ctrl',
                bindToController: true
              });
            }else{
              $state.reload();
              $mdDialog.hide();
            }
            toastr.success('Transaction Added');
          });
      }
    }


    function _processTransaction(transaction) {
      transaction.accountId = vm.accountPeriod.accountId;
      transaction.projectId = vm.accountPeriod.projectId;
      transaction.statementId = vm.accountPeriod.statementId;
      transaction.accountPeriodId = vm.accountPeriod.id;
      transaction.originalDescription = transaction.description;
      transaction.originalAmount = transaction.amount;
      transaction.creditDebit = transaction.amount > 0 ? 'credit' : 'debit';
      transaction.type = transaction.amount >= 0 ? TRANSACTION_TYPES.TYPE.OTHER_CREDIT : TRANSACTION_TYPES.TYPE.OTHER_DEBIT;
      return transaction;
    }

    function saveAndCopy(form){
      if(!form.$invalid){
        submitSaveTransaction(form,true);
      }
    }

    function clearTransactionMemo(){
      vm.transaction.memo = "REC";
    }

    function manualEntryMemo(){
      vm.transaction.memo = "Manual Entry";
    }

  }
})();


(function() {
  'use strict';

  agGrid.LicenseManager.setLicenseKey("CompanyName=Valid8 Financial, Inc.,LicensedApplication=Valid8,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=5,AssetReference=AG-035962,SupportServicesEnd=9_February_2024_[v2]_MTcwNzQzNjgwMDAwMA==a4b6c88b4b252d2a8accecdbb7445056");
  agGrid.initialiseAgGridWithAngular1(angular);
  
  angular.module('core', [
    'ngAnimate',
    'ngAria',
    'auth0.auth0',
    'blockUI',
    'chart.js',
    'ngCookies',
    'angular-jwt',
    'ngMessages',
    'ngMaterial',
    'toastr',
    'ui.router',
    'angulartics',
    'angulartics.google.analytics',
    'js-data',
    'ngFileUpload',
    'restangular',
    'agGrid'
  ]).constant('ENV', window.__V8ENV);

  angular
    .module('v8-frontend', [
      'core',
      'categorization',
      'projects',
      'notifications',
      'legal',
      'matching',
      'admin'
    ]);
})();

(function() {
  'use strict';

  angular
    .module('core')
    .factory('accountPeriodUtils', accountPeriodUtils);

  function accountPeriodUtils() {
    return {
      getVariance: getVariance,
      checkDates: checkDates
    };

    function getVariance(accountPeriod) {
      var startBalance = +accountPeriod.startBalance || 0;
      var endBalance = +accountPeriod.endBalance || 0;
      var inflows = +accountPeriod.inflows || 0;
      var outflows = +accountPeriod.outflows || 0;
      var sum = startBalance + inflows - outflows;
      return +(sum - endBalance).toFixed(2);
    }

    function checkDates(accountPeriod) {
      var startDate = moment(accountPeriod.startDate);
      var endDate = moment(accountPeriod.endDate);
      return startDate.isValid() && endDate.isValid() && startDate.isBefore(endDate) && startDate.isAfter('1970-01-01') && endDate.isBefore('2050-01-01');
    }
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "PROJECT_TYPES", "STATEMENTS"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider, PROJECT_TYPES, STATEMENTS) {
    $stateProvider
      .state('project.account-periods', {
        url: '/account-periods?status&source',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/account-periods/account-periods.html',
            controller: 'AccountPeriodsController as $ctrl'
          }
        },
        data: {
          projectType: PROJECT_TYPES.FORENSIC
        },
        resolve: {
          accountPeriods: ["$stateParams", "AccountPeriods", function($stateParams, AccountPeriods) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            if( !$stateParamsClone.source ) {
              $stateParamsClone.source = STATEMENTS.SOURCE.BANK_PDF;
            }
            var params = { projectId: $stateParamsClone.projectId, downloadUrl: true, $limit: 5000 };
            if($stateParamsClone.status && $stateParamsClone.status !== 'all-items') {
              params.status = $stateParamsClone.status;
            }
            params.source = $stateParamsClone.source;
            return AccountPeriods.findAll(params, {bypassCache: true});
          }]
        }
      })
      .state('project.account-period-reconcile', {
        url: '/account-period-reconcile/:accountPeriodId?pageSize&sortOrder&sortModel&keyword',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/account-periods/account-period-reconcile.html',
            controller: 'AccountPeriodReconcileController as $ctrl'
          }
        },
        data: {
          projectType: PROJECT_TYPES.FORENSIC
        },
        resolve: {
          categories: ["$stateParams", "Categories", function($stateParams, Categories) {
            return Categories.findAllByProject($stateParams.projectId);
          }],
          customFields: ["$stateParams", "CustomFields", function($stateParams, CustomFields) {
            return CustomFields.findAllByProject($stateParams.projectId);
          }],
          transactions: ["$stateParams", "Transactions", "transactionUtils", "tableUtils", "CHECK_ITEMS", function($stateParams, Transactions, transactionUtils, tableUtils, CHECK_ITEMS) {
            // Set Default sort params
            var $stateParamsClone = Object.assign({}, $stateParams);
            if(!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'date';
              $stateParamsClone.sortOrder = 'asc';
            }
            var pagingParams = tableUtils.formatPagingParams($stateParamsClone, true);
            var params = angular.extend({includeDocs: true, includeCheckItems: CHECK_ITEMS.STATUS.RECONCILED}, transactionUtils.formatFilterParams($stateParamsClone), pagingParams);

            return Transactions.findAllPOST(params);
          }],
          accountPeriod: ["$stateParams", "AccountPeriods", function($stateParams, AccountPeriods) {
            return AccountPeriods.find($stateParams.accountPeriodId, {params: {navigation:true}});
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  AccountPeriods.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('projects')
    .factory('AccountPeriods', AccountPeriods);

  function AccountPeriods(DS, DSHttpAdapter) {
    var metadata;
    var accountPeriods = DS.defineResource({
      name: 'accountPeriods',
      endpoint: 'account-periods',
      idAttribute: 'id',
      // TODO once JSData can handle metadata remove this
      cacheResponse: false,
      deserialize: function(config, res) {
        if(res.data.metadata) {
          metadata = res.data.metadata;
        }
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    accountPeriods.getMetadata = function() {
      return metadata;
    };

    accountPeriods.batchUpdate = function(projectId, periodIds, action) {
      var params = {
        projectId: projectId,
        action: action
      };
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/account-periods/batch',
        { accountPeriodIds: periodIds },
        { params: params }
      );
    };

    accountPeriods.assign = function(projectId, periodIds, accountId) {
      var params = {
        action: 'assign',
        projectId: projectId,
        accountId: accountId
      };
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/account-periods/batch',
        { accountPeriodIds: periodIds },
        { params: params }
      );
    };

    return accountPeriods;
  }
})();

(function() {
  'use strict';

  AccountPeriodsController.$inject = ["$state", "STATEMENTS", "accountPeriods", "AccountPeriods"];
  angular
    .module('projects')
    .controller('AccountPeriodsController', AccountPeriodsController);

  function AccountPeriodsController(
    $state,
    STATEMENTS,
    accountPeriods,
    AccountPeriods) {
    var vm = this;
    vm.accountPeriods = accountPeriods;
    vm.title = STATEMENTS.SOURCE_DESCRIPTION[$state.params.source];
    vm.statusInfo = AccountPeriods.getMetadata().statusInfo;
    vm.projectType = $state.current.data.projectType;
  }
})();

(function() {
  'use-strict';

  AccountPeriodsStatusUpdateDialogController.$inject = ["$mdDialog", "$q", "$state", "$stateParams", "AccountPeriods", "periods", "action"];
  angular
    .module('projects')
    .controller('AccountPeriodsStatusUpdateDialogController', AccountPeriodsStatusUpdateDialogController);

  function AccountPeriodsStatusUpdateDialogController(
    $mdDialog,
    $q,
    $state,
    $stateParams,
    AccountPeriods,
    periods,
    action) {
    var vm = this;
    
    vm.periods = periods;
    vm.action = action;
    vm.description = actionToPastParticiple(action);
    vm.save = save;
    vm.cancel = $mdDialog.cancel;

    function save() {
      var accountPeriodIds = _.map(vm.periods, 'id');
      AccountPeriods.batchUpdate($stateParams.projectId, accountPeriodIds, vm.action).then(function Success() {
        $mdDialog.hide(true);
        $state.reload();
      });
    }

    // This is just a simple function to transfer words like "delete", "assign", "unassigned" to
    // their past participle for display in the UI, e.g. "delete"->"deleted", "assign"->"assigned"
    // "unreconcile"->"unreconciled"
    function actionToPastParticiple(action) {
      if (action.slice(-1) == 'e') {
        return action + 'd';
      }
      return action + 'ed';
    }

  }
})();

(function() {
  'use strict';

  AccounPeriodsListTableController.$inject = ["$scope", "$filter", "$state", "$stateParams", "tableUtils", "$mdDialog", "toastr", "Authorization", "Documents", "Projects", "AccountPeriods", "PROJECT_TYPES", "STATEMENTS", "RBAC", "ACCOUNT_PERIODS"];
  angular
    .module('projects')
    .component('accountPeriodsListTable', {
      templateUrl: 'app/projects/project/account-periods/account-periods-list.html',
      bindings: {
        accountPeriods: '<',
        statusInfo: '<',
        type: '@'
      },
      controller: AccounPeriodsListTableController
    });

  function AccounPeriodsListTableController(
    $scope,
    $filter,
    $state,
    $stateParams,
    tableUtils,
    $mdDialog,
    toastr,
    Authorization,
    Documents,
    Projects,
    AccountPeriods,
    PROJECT_TYPES,
    STATEMENTS,
    RBAC,
    ACCOUNT_PERIODS) {

    var vm = this;
    var BASE_GRID_ID = 'grid-account-periods';
    var SUB_GRID_ID = BASE_GRID_ID + '-reconciliation';
    vm.selectedPeriods = [];
    vm.exportToCsv = exportToCsv;
    vm.selectAll = selectAll;
    vm.toFileTab = toFileTab;
    vm.toPeriodTab = toPeriodTab;

    vm.assignAccountPeriods = assignAccountPeriods;
    vm.unassignAccountPeriods = unassignAccountPeriods;
    vm.deleteAccountPeriods = deleteAccountPeriods;
    vm.batchStatusUpdatePeriods = batchStatusUpdatePeriods;

    vm.expandCollapse = expandCollapse;
    vm.expand = true;
    var exportParams = {
      fileName: _getExportName(),
      skipGroups: true,
      columnKeys: ['account.number', 'statement.document.fileName', 'status', 'account.bank', 'account.type', 'account.entity.name', 'startDate', 'endDate', 'prevEBBB', 'dateGap',
        'dataQuality', 'startBalance', 'inflows', 'outflows', 'endBalance' ],
      processCellCallback: exportCSVFormatCells
    };

    this.$onInit = function() {
      vm.hasPermissions = Authorization.hasProjectAccess(vm.type, $state.params.projectId, [RBAC.ROLES.ENGAGEMENT_OWNER, RBAC.ROLES.ENGAGEMENT_USER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
      vm.status = $state.params.status;
      vm.source = $state.params.source;

      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.columnDefs = vm.status === ACCOUNT_PERIODS.STATUS.UNASSIGNED ? _getUnassignedColumns() : _getRecUnreCColumns();

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        rowSelection: 'multiple',
        onRowSelected: _toggleRowSelected,
        defaultColDef: tableUtils.getDefaultColDefs(),
        getMainMenuItems: tableUtils.getMainMenuItems,
        rowData: vm.accountPeriods,
        groupDefaultExpanded: 2,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        groupSelectsChildren: true,
        groupSelectsFiltered: true,
        suppressRowClickSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        groupHideOpenParents: true,
        angularCompileRows: true,
        autoGroupColumnDef:{
          minWidth: 120,
          cellRendererParams: {
            checkbox: vm.hasPermissions,
          }
        },
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange
      };
    };

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, SUB_GRID_ID);
      if(!tableUtils.getGridState(SUB_GRID_ID)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }


    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, SUB_GRID_ID);
    }

    function _getRecUnreCColumns() {
      SUB_GRID_ID = BASE_GRID_ID + '-reconciliation';
      var columns = [
        {
          headerName: 'File',
          field: 'statement.document.fileName',
          width: 50,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          cellRenderer: function(params) {
            if(params.data) {
              var downloadUrl = params.data.downloadUrl;
              var page = params.data.page;
              if(page >= 0 && downloadUrl) {
                //PerfectAudit statement page index is zero based.
                page++;
                downloadUrl = downloadUrl + '#page=' + page;
              }
              return '<a class="file-name" target="_blank" href="' + downloadUrl + '"><md-icon class="material-icons icon-primary">insert_drive_file</md-icon></a>';
            } else {
              return '';
            }
          }
        },
        {
          headerName: 'Select',
          field: 'selected',
          checkboxSelection: function(params) {
            if(params.data && params.data.status === ACCOUNT_PERIODS.STATUS.UNASSIGNED) {
              return false;
            }
            return true;
          },
          width: 70,
          hide: !vm.hasPermissions,
          suppressColumnsToolPanel: !vm.hasPermissions,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true
        },
        {
          headerName: 'Action',
          width: 70,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          cellClass: 'links',
          suppressColumnsToolPanel: !vm.hasPermissions,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            var icon = params.data.status === ACCOUNT_PERIODS.STATUS.UNRECONCILED && vm.hasPermissions ? 'edit' : 'visibility';
            var disabled = params.data.accountId ? '' : 'icon-disabled';
            return '<md-icon class="material-icons icon-primary ' + disabled + '">' + icon + '</md-icon>';
          },
          onCellClicked: function(params) {
            if(params.data.accountId){
              $state.go(_getReconcileState(), {accountPeriodId: params.data.id});
            }
          }
        },
        {
          headerName: 'Status',
          minWidth: 120,
          field: 'status',
          sortable: false,
          hide: vm.status !== 'all',
          suppressColumnsToolPanel: vm.status !== 'all',
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('accountPeriodStatusDisplay')(params.value);
          }
        },
        {
          headerName: 'Filename',
          field: 'statement.document.fileName',
          width: 400,
          hide: true,
          sortable: false,
          cellRenderer: function(params) {
            if(params.data) {
              return '<a class="file-name" target="_blank" href="' + params.data.downloadUrl + '">' + $filter('filenameDisplay')(params.value) + '</a>';
            } else {
              return '';
            }
          }
        },
        {
          headerName: 'Account',
          width: 100,
          field: 'account.number',
          sortable: false,
          rowGroupIndex: 0,
          hide: true,
          suppressColumnsToolPanel: true
        },
        {
          headerName: 'Institution',
          field: 'account.bank',
          width: 200,
          sortable: false,
        },
        {
          headerName: 'Type',
          field: 'account.type',
          minWidth: 80,
          sortable: false,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('accountTypeDisplay')(params.value);
          }
        },
        {
          headerName: 'Entity',
          width: 200,
          field: 'account.entity.name',
          sortable: false,
        }
      ];
      columns = columns.concat(_getMetadataColumns());
      return columns;
    }

    function _getUnassignedColumns() {
      SUB_GRID_ID = BASE_GRID_ID + '-unassigned';
      return [
        {
          headerName: 'Filename',
          field: 'statement.document.fileName',
          width: 400,
          rowGroupIndex: 1,
          hide: true,
          suppressColumnsToolPanel: true,
          sortable: false,
          cellRenderer: function(params) {
            if(params.data) {
              // This will just make the link go to the first page of a given statement but that's OK
              // Given how we group things, this should still correspond to a statement in the group 
              var downloadUrl = params.data.downloadUrl;
              var page = params.data.page;
              if(page >= 0 && downloadUrl) {
                //PerfectAudit statement page index is zero based.
                page++;
                downloadUrl = downloadUrl + '#page=' + page;
              }

              return '<a class="file-name" target="_blank" href="' + downloadUrl + '">' + $filter('filenameDisplay')(params.value) + '</a>';
            } else {
              return '';
            }
          }
        },
        {
          headerName: 'Extracted account info',
          width: 500,
          field: 'extractedAccount',
          sortable: false,
          rowGroupIndex: 0,
          hide: true,
          suppressColumnsToolPanel: true
        },
        {
          headerName: 'Select',
          field: 'selected',
          checkboxSelection: true,
          hide: !vm.hasPermissions,
          suppressColumnsToolPanel: !vm.hasPermissions,
          width: 70,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true
        }
      ].concat(_getMetadataColumns());
    }


    function _getMetadataColumns() {
      return [
        {
          headerName: 'ID',
          field: 'id',
          width: 200,
          hide: true,
        },
        {
          headerName: 'Start Date',
          minWidth: 100,
          field: 'startDate',
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'End Date',
          minWidth: 100,
          field: 'endDate',
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'PrevEB=BB',
          maxWidth: 150,
          colId: 'prevEBBB',
          sortable: false,
          hide: vm.status === ACCOUNT_PERIODS.STATUS.UNASSIGNED,
          suppressColumnsToolPanel: vm.status === ACCOUNT_PERIODS.STATUS.UNASSIGNED,
          valueGetter: function(params) {  //Needed for CSV export
            if(params.node.data) {
              var index = params.node.rowIndex;
              var previous = vm.gridOptions.api.getDisplayedRowAtIndex(index - 1);
              var variance = null;

              if (previous && previous.data && previous.data.accountId && params.node.data.accountId && (previous.data.accountId === params.node.data.accountId)) {
                if(previous.data.endBalance && params.node.data.startBalance) {
                  variance = previous.data.endBalance - params.node.data.startBalance;
                }
              }

              if(variance !== null) {
                return variance === 0 ? 'OK' : Math.abs(variance);
              } else {
                return '-';
              }
            }
          },
          cellRenderer: function(params) {
            if(params.value) {
              if(params.value !== '-') {
                return params.value === 'OK' ? '<md-icon class="material-icons icon-primary check">check</md-icon>' :
                  '<span class="has-error">' + $filter('currencyDisplayFilter')(params.value, 'USD') + '</span>';
              } else {
                return '<md-icon class="material-icons icon-primary start">remove</md-icon>';
              }
            }
          },
          cellStyle: {textAlign: 'center'}
        },
        {
          headerName: 'Date Gap',
          maxWidth: 100,
          colId: 'dateGap',
          sortable: false,
          hide: vm.status === ACCOUNT_PERIODS.STATUS.UNASSIGNED,
          suppressColumnsToolPanel: vm.status === ACCOUNT_PERIODS.STATUS.UNASSIGNED,
          valueGetter: function(params) {  //Needed for CSV export
            if(params.node.data) {
              var index = params.node.rowIndex;
              var previous = vm.gridOptions.api.getDisplayedRowAtIndex(index - 1);
              var variance = null;

              if (previous && previous.data && previous.data.accountId && params.node.data.accountId && (previous.data.accountId === params.node.data.accountId)) {

                if(previous.data.endDate && params.node.data.startDate) {
                  var previousMoment = moment(previous.data.endDate);
                  var currentMoment = moment(params.node.data.startDate);
                  variance = currentMoment.subtract(1, 'days').isSame(previousMoment, 'day');
                }
              }

              if(variance !== null) {
                return variance ? 'OK' : 'X';
              } else {
                return '-';
              }
            }
          },
          cellRenderer: function(params) {
            if(params.value) {
              if(params.value !== '-') {
                return params.value === 'OK' ? '<md-icon class="material-icons icon-primary check">check</md-icon>' : '<md-icon class="material-icons">close</md-icon>';
              } else {
                return '<md-icon class="material-icons icon-primary start">remove</md-icon>';
              }
            }
          },
          cellStyle: {textAlign: 'center'}
        },
        {
          headerName: 'Sums',
          maxWidth: 80,
          field: 'dataQuality',
          sortable: false,
          cellClass: 'icons',
          valueFormatter: function(params) {  //Needed for CSV export
            if (params.value !== 'Okay' && params.node && params.node.data && Array.isArray(params.node.data.messages)) {
              var i = 0;
              for (i = 0; i < params.node.data.messages.length; i++) {
                const message = params.node.data.messages[i];
                if (message === 'Balance check error variance not zero') {
                  return 'X';
                }
              }
            }
            return 'OK';
          },
          cellRenderer: function(params) {
            return params.valueFormatted === 'OK' ? '<md-icon class="material-icons icon-primary check">check</md-icon>' : '<md-icon class="material-icons">close</md-icon>';
          }
        },
        {
          headerName: 'Beg Bal',
          maxWidth: 150,
          field: 'startBalance',
          cellClass: ['grid-amount'],
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return _formatCurrency(params.value, params.data.account);
          },
          cellStyle: {textAlign: "right"}
        },
        {
          headerName: 'Increase',
          maxWidth: 150,
          field: 'inflows',
          cellClass: ['grid-amount'],
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return _formatCurrency(params.value, params.data.account);
          },
          cellStyle: {textAlign: "right"}
        },
        {
          headerName: 'Decrease',
          maxWidth: 150,
          field: 'outflows',
          cellClass: ['grid-amount'],
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return _formatCurrency(params.value, params.data.account);
          },
          cellStyle: {textAlign: "right"}
        },
        {
          headerName: 'End Bal',
          maxWidth: 150,
          field: 'endBalance',
          cellClass: ['grid-amount'],
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return _formatCurrency(params.value, params.data.account);
          },
          cellStyle: {textAlign: "right"}
        }
      ];
    }

    function _formatCurrency(amount, account) {
      var cur = account ? account.currency : '';
      return $filter('currencyDisplayFilter')(amount, cur); 
    }

    function expandCollapse(){
      vm.expand = !vm.expand;
      vm.gridOptions.api.forEachNode(function(node) {
        if (node.group){
          node.setExpanded(vm.expand);
        }
      });
    }

    function exportToCsv() {
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'statement.document.fileName') {
          return $filter('filenameDisplay')(params.value);
        } else if (params.column.colId === 'startDate' || params.column.colId === 'endDate') {
          return $filter('dateDisplay')(params.value);
        } else if (params.column.colId === 'dataQuality') {
          return params.value === 'Okay' ? 'OK' : 'X';
        } else if (params.column.colId === 'account.type') {
          return $filter('accountTypeDisplay')(params.value);
        } else if (params.column.colId === 'status') {
          return $filter('accountPeriodStatusDisplay')(params.value);
        } else {
          return params.value;
        }
      } else {
        return params.value;
      }
    }

    function toFileTab(status) {
      if(vm.status === status) {
        return;
      }
      $state.go(_getStatementsState(), {status: status, source: vm.source});
    }

    function toPeriodTab(status) {
      if(vm.status === status) {
        return;
      }
      $state.go($state.current, { status: status, source: vm.source }, {reload: true});
    }

    function selectAll() {
      var selectedRows = vm.gridOptions.api.getSelectedRows();
      if (selectedRows.length) {
        vm.gridOptions.api.deselectAll();
      } else {
        vm.gridOptions.api.forEachNodeAfterFilter(function(node) {
          node.setSelected(true);
        });
      }
    }

    function deleteAccountPeriods() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account-periods/delete-account-periods-dialog.html',
        controller: 'DeleteAccountPeriodsController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          itemsToDelete: vm.selectedPeriods,
        }
      });
    }

    function unassignAccountPeriods() {
      this.batchStatusUpdatePeriods('unassign');
    }

    function assignAccountPeriods() {
      var overlapCheck = _verifyAccountPeriods();
      if(overlapCheck.overlappingPeriods.length > 0) { //Need an additional step in case of overlaps
        $mdDialog.show({
          templateUrl: 'app/projects/project/account-periods/assign-account-periods-dialog.html',
          controller: 'AssignAccountPeriodsDialogController',
          controllerAs: '$ctrl',
          bindToController: true,
          locals: {
            source: vm.source,
            allPeriods: vm.selectedPeriods,
            correctPeriods: overlapCheck.correctPeriods,
            overlappingPeriods: overlapCheck.overlappingPeriods,
          }
        });
      } else {
        $mdDialog.show({
          templateUrl: 'app/projects/project/account/assign-account-dialog.html',
          controller: 'AssignAccountDialogController',
          controllerAs: '$ctrl',
          bindToController: true,
          locals: {
            source: vm.source,
            type: 'accountPeriod',
            itemsToAssign: vm.selectedPeriods,
          }
        });
      }
    }

    function batchStatusUpdatePeriods(action) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account-periods/account-periods-status-update-dialog.html',
        controller: 'AccountPeriodsStatusUpdateDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          periods: vm.selectedPeriods,
          action: action
        }
      });
    }


    function _verifyAccountPeriods() {
      var overlappingPeriods = [];
      var correctPeriods = [];
      var periods = vm.selectedPeriods;
      //Check periods and classify in overlapping and correct periods.
      //Sort by date first.
      _sortPeriods();
      var isOverlapping = false;
      var nextPeriod = null;
      var currentPeriod = null;
      for(var i = 0; i < periods.length; i++) {
        currentPeriod = periods[i];
        if(periods[i + 1]) {
          nextPeriod = periods[i + 1];
          if(isOverlapping) {
            _addPeriod(currentPeriod, isOverlapping, overlappingPeriods, correctPeriods);
            isOverlapping = _hasOverlap(currentPeriod, nextPeriod);
          } else {
            isOverlapping = _hasOverlap(currentPeriod, nextPeriod);
            _addPeriod(currentPeriod, isOverlapping, overlappingPeriods, correctPeriods);
          }
        } else {
          _addPeriod(currentPeriod, isOverlapping, overlappingPeriods, correctPeriods);
        }
      }
      return {
        overlappingPeriods: overlappingPeriods,
        correctPeriods: correctPeriods
      };
    }

    function _sortPeriods() {
      vm.selectedPeriods.sort(function(a,b) {
        if(a.startDate && b.startDate) {
          return moment(a.startDate).isAfter(moment(b.startDate),'days') ? 1 : 0;
        } else {
          return 0;
        }
      });
    }

    function _hasOverlap(currentPeriod, nextPeriod) {
      if(currentPeriod.endDate && nextPeriod.startDate) {
        return moment(currentPeriod.endDate).isAfter(moment(nextPeriod.startDate),'days');
      } else {
        return false;
      }
    }

    function _addPeriod(period, isOverlapping, overlappingPeriods, correctPeriods) {
      if(isOverlapping) {
        overlappingPeriods.push(period);
      } else {
        correctPeriods.push(period);
      }
    }

    function _getStatementsState() {
      var state = 'project.documents.statements';
      if(vm.type === PROJECT_TYPES.AUDIT) {
        state = 'engagement.statements';
      }
      return state;
    }

    function _getReconcileState(){
      if(vm.type === PROJECT_TYPES.AUDIT){
        return 'engagement.account-period-reconcile';
      }
      return 'project.account-period-reconcile';
    }

    function _toggleRowSelected() {
      vm.selectedPeriods = vm.gridOptions.api.getSelectedRows();
      $scope.$applyAsync();
    }

    function _getExportName() {
      var project = Projects.get($state.params.projectId);
      var name = '';
      if(project) {
        name = project.name;
      }
      return name + '_Statements_' + moment().format('MMYYYY') + '.csv';
    }

  }
})();

(function() {
  'use strict';

  AccountPeriodTransactionListTableController.$inject = ["$state", "$timeout", "$filter", "$scope", "$mdDialog", "tableUtils", "transactionUtils", "Transactions", "Categories", "CustomFields", "Authorization", "Projects", "RBAC", "PROJECT_TYPES", "TRANSACTION_TYPES", "ACCOUNT_PERIODS", "CHECK_ITEMS"];
  angular
    .module('projects')
    .component('accountPeriodTransactionListTable', {
      templateUrl: 'app/projects/project/account-periods/account-period-transaction-list-table.html',
      bindings: {
        transactions: '<',
        accountPeriod:'<',
        editableTransactions: '<',
        canReconcile: '<'
      },
      controller: AccountPeriodTransactionListTableController
    });

  function AccountPeriodTransactionListTableController(
    $state,
    $timeout,
    $filter,
    $scope,
    $mdDialog,
    tableUtils,
    transactionUtils,
    Transactions,
    Categories,
    CustomFields,
    Authorization,
    Projects,
    RBAC,
    PROJECT_TYPES,
    TRANSACTION_TYPES,
    ACCOUNT_PERIODS,
    CHECK_ITEMS) {

    var vm = this;
    var BASE_GRID_ID = 'grid-period-transactions';
    var SUB_GRID_ID = BASE_GRID_ID + '-rec';
    vm.reloadData = reloadData;
    vm.selectAll = selectAll;
    vm.reconcile = reconcile;
    vm.addTransaction = addTransaction;
    vm.moveTransactions = moveTransactions;
    vm.deleteTransactions = deleteTransactions;
    vm.selectedTransactions = [];
    vm.project = Projects.get($state.params.projectId);

    this.$onInit = function() {
      vm.categories = Categories.filterByProject($state.params.projectId);
      vm.customFields = CustomFields.filterByProject($state.params.projectId);
      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.hasPermissions = Authorization.hasProjectAccess(vm.project.type, vm.project.id, [RBAC.ROLES.ENGAGEMENT_OWNER, RBAC.ROLES.ENGAGEMENT_USER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
      SUB_GRID_ID = vm.accountPeriod.status === ACCOUNT_PERIODS.STATUS.UNRECONCILED ? BASE_GRID_ID + '-unrec' : BASE_GRID_ID + '-rec';
      vm.actionColumns = [
        {
          headerName: 'Select',
          field: 'select',
          checkboxSelection: function(params) {
            return params.data && params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION;
          },
          pinned: 'left',
          width: 70,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          hide: !vm.hasPermissions || vm.accountPeriod.status !== ACCOUNT_PERIODS.STATUS.UNRECONCILED,
          suppressColumnsToolPanel: !vm.hasPermissions || vm.accountPeriod.status !== ACCOUNT_PERIODS.STATUS.UNRECONCILED,
        },
        {
          headerName: 'Actions',
          width: 70,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          pinned: 'left',
          cellClass: 'links',
          editable: vm.editableTransactions,
          hide: !vm.editableTransactions || !vm.hasPermissions,
          suppressColumnsToolPanel: !vm.editableTransactions || !vm.hasPermissions,
          cellRenderer: function(params) {
            if(params.data && params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
              return '<md-icon class="material-icons icon-primary">edit</md-icon>';
            }
          },
          onCellClicked: function(params) {
            if(params.data && params.data.rowType === TRANSACTION_TYPES.GRID_ROW_TYPE.TRANSACTION) {
              _editTransaction(params.data);
            }
          }
        }
      ];

      var allColumnDefs = vm.actionColumns
        .concat(transactionUtils.getDefaultTxnColumns($state, vm.project))
        .concat(transactionUtils.getCategoryColumns(vm.categories))
        .concat(transactionUtils.getCustomFieldColumns(vm.customFields));

      if(vm.type === PROJECT_TYPES.FORENSIC){
        allColumnDefs.push(transactionUtils.getSupDocColumn(_openSupDocDialog));
      }

      tableUtils.setColumnSort(vm.pagination, allColumnDefs);

      vm.gridOptions = {
        cacheBlockSize: vm.pagination.pageSize,
        rowSelection: 'multiple',
        onRowSelected: _toggleRowSelected,
        columnDefs: allColumnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        treeData: true,
        angularCompileRows: true,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onSortChanged: vm.reloadData,
        getMainMenuItems: tableUtils.getMainMenuItems,
        rowModelType: 'serverSide',
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange,
        autoGroupColumnDef: {
          suppressMovable: true,
          pinned: 'left',
          width: 50,
          headerName: '',
          sortable: false,
          cellRendererParams: {
            innerRenderer: function() { return ''; }
          }
        },
        isServerSideGroup: function(dataItem) {
          return dataItem.group;
        },
        getServerSideGroupKey: function(dataItem) {
          return dataItem.id;
        }
      };
    };

    function reloadData() {
      var sortModel = vm.gridOptions.api.getSortModel();
      if(sortModel.length) {
        vm.pagination.sortModel = sortModel[0].colId;
        vm.pagination.sortOrder = sortModel[0].sort;
      } else {
        vm.pagination.sortModel = 'date';
        vm.pagination.sortOrder = 'asc';
      }
      vm.pagination.skipCount = 0;
      $state.go($state.current, vm.pagination);
    }

    function reconcile() {
      var accountPeriodId = $state.params.accountPeriodId;
      AccountPeriods.find(accountPeriodId).then(function(accountPeriod) {
        accountPeriod.status = ACCOUNT_PERIODS.STATUS.RECONCILED;
        AccountPeriods.update(accountPeriodId, accountPeriod);
      }).then(function(){
        vm.canReconcile = false;
      });
    }

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, SUB_GRID_ID);
      vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      if(!tableUtils.getGridState(SUB_GRID_ID)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, SUB_GRID_ID);
    }

    function selectAll() {
      tableUtils.selectUnselectAll(vm.gridOptions, true);
    }

    function _createDatasource() {
      return {
        getRows: function(params) {
          var rows = [];
          if(params.request.groupKeys.length === 0 ) { //Loading more root nodes, need to go to backend
            if(params.request.startRow === 0 && vm.transactions) { //We already have the first page provided by the route...
              rows = transactionUtils.formatTxnRows(vm.transactions);
              params.successCallback(rows, Transactions.getMetadata().transCountFilter);
            } else {
              var $stateParamsClone = Object.assign({}, $state.params);
              if(!$stateParamsClone.sortModel) {
                vm.pagination.sortModel = 'date';
                vm.pagination.sortOrder = 'asc';
              }
              if(!$stateParamsClone.sourceType) {
                $stateParamsClone.sourceType = 'bank';
              }

              vm.pagination.skipCount = params.request.startRow;
              var transactionParams = angular.extend({includeDocs: true, includeCheckItems: CHECK_ITEMS.STATUS.RECONCILED},
                transactionUtils.formatFilterParams($stateParamsClone), tableUtils.formatPagingParams(vm.pagination, true));
              Transactions.findAllPOST(transactionParams).then(
                function Success(data) {
                  params.successCallback(transactionUtils.formatTxnRows(data), Transactions.getMetadata().transCountFilter);
                }
              );
            }
          } else {  //Expanding child nodes, already supplied by the backend....
            var txn = params.parentNode.data;
            if(txn) {
              rows = transactionUtils.formatTxnCheckItemRows(txn);
            }
            params.successCallback(rows, rows.length);
          }
        }
      };
    }

    function _openSupDocDialog(transaction) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/transactions/transaction-documents-dialog.html',
        controller: 'TransactionDocumentsController',
        locals: {
          transaction: transaction
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success(shouldReload) {
        if(shouldReload) {
          vm.reloadData();
        } else {
          vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        }
      });
    }

    function _editTransaction(transaction) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account-periods/edit-period-transaction-dialog.html',
        controller: 'EditPeriodTransactionController',
        locals: {
          accountPeriod: vm.accountPeriod,
          transaction: transaction
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success(shouldReload) {
        if(shouldReload) {
          vm.reloadData();
        } else {
          vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        }
      });
    }

    function _toggleRowSelected() {
      vm.selectedTransactions = vm.gridOptions.api.getSelectedRows();
      $scope.$applyAsync();
    }

    function addTransaction() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account-periods/add-transaction-dialog.html',
        controller: 'AddTransactionController',
        locals: {
          accountPeriod: vm.accountPeriod,
          transaction: {}
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success() {
        $state.reload();
      });
    }

    function moveTransactions() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account-periods/move-transactions-dialog.html',
        controller: 'MoveTransactionsController',
        locals: {
          accountPeriod: vm.accountPeriod,
          transactions: vm.selectedTransactions
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success() {
        $state.reload();
      });
    }

    function deleteTransactions() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account-periods/delete-transactions-dialog.html',
        controller: 'DeleteTransactionsController',
        locals: {
          accountPeriod: vm.accountPeriod,
          transactions: vm.selectedTransactions
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success() {
        $state.reload();
      });
    }

  }
})();

(function() {
  'use strict';

  AccountPeriodReconcileController.$inject = ["$scope", "$state", "$mdDialog", "toastr", "dateUtils", "accountPeriodUtils", "Transactions", "Projects", "AccountPeriods", "Authorization", "RBAC", "transactions", "accountPeriod", "PROJECT_TYPES", "ACCOUNT_PERIODS"];
  angular
    .module('projects')
    .controller('AccountPeriodReconcileController', AccountPeriodReconcileController);

  function AccountPeriodReconcileController(
    $scope,
    $state,
    $mdDialog,
    toastr,
    dateUtils,
    accountPeriodUtils,
    Transactions,
    Projects,
    AccountPeriods,
    Authorization,
    RBAC,
    transactions,
    accountPeriod,
    PROJECT_TYPES,
    ACCOUNT_PERIODS) {

    var vm = this;
    vm.transactions = transactions;
    vm.accountPeriod = accountPeriod;
    vm.autoReconcileTransaction = autoReconcileTransaction;
    vm.submitSaveAccountPeriod = submitSaveAccountPeriod;
    vm.unreconcileAccountPeriod = unreconcileAccountPeriod;
    vm.reconcileAccountPeriod = reconcileAccountPeriod;
    vm.viewStatement = viewStatement;
    vm.deleteAccountPeriod = deleteAccountPeriod;
    vm.invertAccountPeriod = invertAccountPeriod;
    vm.goToPeriod = goToPeriod;

    activate();

    function activate() {
      var metadata = Transactions.getMetadata();
      vm.inflows = metadata.transInflowsFilter;
      vm.outflows = metadata.transOutflowsFilter;
      vm.project = Projects.get($state.params.projectId);
      vm.editAccountPeriod = angular.copy(accountPeriod);
      vm.hasPermissions = Authorization.hasProjectAccess(vm.project.type, vm.project.id, [RBAC.ROLES.ENGAGEMENT_OWNER, RBAC.ROLES.ENGAGEMENT_USER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
      vm.canInvertAmounts = Authorization.hasProjectAccess(vm.project.type, vm.project.id, [RBAC.ROLES.ENGAGEMENT_OWNER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
      vm.disableEdit = false;
      vm.canForceReconcile = false;
      vm.canReconcile = false;


      if(vm.accountPeriod) {
        vm.hasAccountPeriod = true;
        vm.accountPeriod.outflows = Math.abs(vm.accountPeriod.outflows);
        vm.isReconciled = vm.accountPeriod.status === ACCOUNT_PERIODS.STATUS.RECONCILED;
        canReconcile();
      } else {
        vm.hasAccountPeriod = false;
        vm.isReconciled = false;
      }

      if(vm.isReconciled) {
        vm.disableEdit = true;
      }

      dateUtils.formatDates(vm.editAccountPeriod);
      vm.validationMessages = [];
      vm.variance = accountPeriodUtils.getVariance(vm.accountPeriod);
      vm.canAutoReconcile = vm.accountPeriod.status === ACCOUNT_PERIODS.STATUS.UNRECONCILED && vm.variance !== 0;

      $('input.form-control')
        .on('blur', changeVariance)
        .on('mousedown', changeVariance);

      vm.type = $state.current.data.projectType;
    }

    function changeVariance() {
      vm.variance = accountPeriodUtils.getVariance(vm.editAccountPeriod);
      vm.canAutoReconcile = vm.accountPeriod.status === ACCOUNT_PERIODS.STATUS.UNRECONCILED && vm.variance !== 0;
      $scope.$apply();
    }

    function autoReconcileTransaction() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account-periods/auto-reconcile-transaction-dialog.html',
        controller: 'AutoReconcileTransactionController',
        locals: {
          accountPeriod: vm.accountPeriod,
          variance: vm.variance
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success() {
        toastr.success('Transaction Added');
        $state.reload();
      });
    }

    function reconcileAccountPeriod(){
      if(checkAccountPeriod()){
        vm.editAccountPeriod.status = ACCOUNT_PERIODS.STATUS.RECONCILED;
        vm.editAccountPeriod.forceReconcile = vm.canForceReconcile;
        AccountPeriods.update(vm.editAccountPeriod.id, vm.editAccountPeriod).then(function Success() {
          $state.reload();
          toastr.success("AccountPeriod Reconciled");
        }).catch(function Error() {
          toastr.error("Error reconciling account period");
        });
      }
    }

    function unreconcileAccountPeriod(){
      if(checkAccountPeriod()){
        vm.editAccountPeriod.status = ACCOUNT_PERIODS.STATUS.UNRECONCILED;
        AccountPeriods.update(vm.editAccountPeriod.id, vm.editAccountPeriod).then(function Success() {
          $state.reload();
          toastr.success("AccountPeriod Unreconciled");
        }).catch(function Error() {
          toastr.error("Error unreconciling account period");
        });
      }
    }


    function submitSaveAccountPeriod() {
      if(checkAccountPeriod()) {
        AccountPeriods.update(vm.editAccountPeriod.id, vm.editAccountPeriod).then(function Success() {
          var metadata = AccountPeriods.getMetadata();
          if(metadata && metadata.errors && metadata.errors.length > 0) {
            for(var i = 0; i < metadata.errors.length; i++) {
              toastr.error(metadata.errors[i]);
            }
            toastr.error('AccountPeriod cannot be reconciled');
          }
          $state.reload();
        }).catch(function Error() {
          toastr.error("Error saving account period");
        });
      }
    }

    function invertAccountPeriod() {
      AccountPeriods.batchUpdate(vm.project.id, [vm.editAccountPeriod.id], 'invert').then(function Success() {
        $state.reload();
        toastr.success("Period and transaction amounts inverted");
      });

    }

    function deleteAccountPeriod() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account-periods/delete-account-period-dialog.html',
        controller: 'DeleteAccountPeriodController',
        locals: {
          accountPeriod: vm.editAccountPeriod,
          type: vm.type
        },
        controllerAs: '$ctrl',
        bindToController: true
      });
    }

    function checkAccountPeriod() {
      if(vm.validationMessages.length > 0) { //If we already have messages this is the second check, so carry on.
        return true;
      }
      var variance = accountPeriodUtils.getVariance(vm.editAccountPeriod);
      if( variance !== 0) {
        vm.validationMessages.push('Account Period data does not add up, please confirm input values.');
      }

      if(!accountPeriodUtils.checkDates(vm.editAccountPeriod)) {
        vm.validationMessages.push('Account Period dates are incorrect, please confirm input values.');
      }
      return vm.validationMessages.length === 0;
    }

    function canReconcile() {
      var varianceZero = accountPeriodUtils.getVariance(vm.accountPeriod) === 0;
      var dataQualityOk = vm.accountPeriod.dataQuality === 'Okay';
      vm.canReconcile = !vm.isReconciled && varianceZero && dataQualityOk;
      vm.canForceReconcile = !vm.isReconciled && varianceZero  && _onlyHasDateRangeError();
    }

    function viewStatement(){
      var link = vm.accountPeriod.downloadUrl;
      var page = vm.accountPeriod.page;
      if(page >= 0 && link) {
        //PerfectAudit statement page index is zero based.
        page++;
        link = link + '#page=' + page;
      }
      window.open(link);
    }

    function goToPeriod(accountPeriodId){
      var state = vm.type === PROJECT_TYPES.AUDIT ? 'engagement.account-period-reconcile' : 'project.account-period-reconcile';
      $state.go(state, {accountPeriodId: accountPeriodId});
    }

    function _onlyHasDateRangeError() {
      var result = false;
      if(vm.accountPeriod && vm.accountPeriod.messages && vm.accountPeriod.messages.length === 1) {
        result = vm.accountPeriod.messages[0] === 'Account period contains transactions outside start-end date range';
      }
      return result;
    }

  }
})();

(function() {
  'use strict';

  AccountPeriodActionsController.$inject = ["toastr", "$mdDialog", "$state", "AccountPeriods", "Authorization"];
  angular
    .module('projects')
    .component('accountPeriodActions', {
      templateUrl: 'app/projects/project/account-periods/account-period-actions.html',
      bindings: {
        selectedAccountPeriods: '<',
        assignAccountPeriods: '&',
        unassignAccountPeriods: '&',
        deleteAccountPeriods: '&',
      },
      controller: AccountPeriodActionsController
    })
    .controller('AccountPeriodActionsController', AccountPeriodActionsController);

  function AccountPeriodActionsController(toastr, $mdDialog, $state, AccountPeriods, Authorization) {
    var vm = this;
    vm.status = $state.params.status;
    vm.isActionsEnabled = isActionsEnabled;

    this.$onInit = function() {
    };

    function isActionsEnabled() {
      return Authorization.isV8Admin();
    }


  }
})();

(function() {
  'use strict';

  SelectAccountController.$inject = ["$mdDialog"];
  angular
    .module('projects')
    .component('selectAccount', {
      templateUrl: 'app/projects/project/account/select-account.html',
      bindings: {
        selectedItems: '<',
        type: '@',
        onSave: '&'
      },
      controller: SelectAccountController
    });

  function SelectAccountController($mdDialog) {
    var vm = this;
    vm.selectAccount = selectAccount;

    function selectAccount() {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account/assign-account-dialog.html',
        controller: 'AssignAccountDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          itemsToAssign: vm.selectedItems,
          type: vm.type
        }
      }).then(function Success(data) {
        vm.onSave({ isRefreshRequired: data });
      });
    }
  }
})();

(function() {
  'use strict';

  EditAccountsController.$inject = ["$scope", "$state", "$stateParams", "messagingService", "accounts", "entities", "project", "PROJECT_TYPES"];
  angular
    .module('projects')
    .controller('EditAccountsController', EditAccountsController);

  function EditAccountsController(
    $scope,
    $state,
    $stateParams,
    messagingService,
    accounts,
    entities,
    project,
    PROJECT_TYPES) {

    var vm = this;
    vm.accounts = accounts;
    vm.entities = entities;
    vm.project = project;

    activate();

    function activate() {
      if (!vm.accounts.length){
        messagingService.setMessage({
          messageType: 'info',
          messageText: 'There are no accounts for this project, please add one or more accounts.'
        });
      }
      if($state.current.data){
        vm.projectType = $state.current.data.projectType;
      } else{
        vm.projectType = PROJECT_TYPES.FORENSIC;
      }
    }
  }
})();

(function() {
  'use strict';

  EditAccountsListTableController.$inject = ["$filter", "$state", "$scope", "$stateParams", "tableUtils", "projectsNavigationService", "$mdDialog", "toastr", "plaidService", "Authorization", "Projects", "Accounts", "RBAC", "ENV", "ACCOUNTS", "CURRENCIES", "PROJECT_TYPES"];
  angular
    .module('projects')
    .component('editAccountsListTable', {
      templateUrl: 'app/projects/project/account/edit-accounts-list-table.html',
      bindings: {
        project: '<',
        accounts: '<',
        entities: '<',
        type: '@'
      },
      controller: EditAccountsListTableController
    });

  function EditAccountsListTableController(
    $filter,
    $state,
    $scope,
    $stateParams,
    tableUtils,
    projectsNavigationService,
    $mdDialog,
    toastr,
    plaidService,
    Authorization,
    Projects,
    Accounts,
    RBAC,
    ENV,
    ACCOUNTS,
    CURRENCIES,
    PROJECT_TYPES) {

    var vm = this;

    vm.addAccountRow = addAccountRow;
    vm.updateAccounts = updateAccounts;

    vm.accountTypes = [
      ACCOUNTS.TYPE.CHECKING,
      ACCOUNTS.TYPE.SAVINGS,
      ACCOUNTS.TYPE.CREDIT_CARD,
      ACCOUNTS.TYPE.BROKERAGE,
      ACCOUNTS.TYPE.MORTGAGE
    ];

    this.$onInit = function() {
      //Initialize plaid
      plaidService.create(_plaidSuccess)
        .then(function Success(plaid) {
          vm.plaidHandler = plaid;
        })
        .catch(function Failure() {
          toastr.error('Error connecting to Plaid');
        });

      vm.hasPermissions = Authorization.hasProjectAccess(vm.type, $state.params.projectId, [RBAC.ROLES.ENGAGEMENT_OWNER, RBAC.ROLES.ENGAGEMENT_USER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
      vm.selectorEntities = [];
      _.forEach(vm.entities, function(e) {
        vm.selectorEntities.push({ name: e.name, id: e.id, projectId: e.projectId });
      });
      vm.selectorEntities.push('Add New');

      var columnDefs = [
        {
          headerName: 'Visible',
          field: 'enabled',
          width: 80,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          editable: false,
          hide: vm.type === PROJECT_TYPES.FORENSIC,
          suppressColumnsToolPanel: vm.type === PROJECT_TYPES.FORENSIC,
          cellRenderer: function() {
            return '<md-checkbox aria-label="visible" ng-model="data.enabled" class="md-custom-background cell-checkbox"></md-checkbox>';
          },
          onCellClicked: function(params) {
            params.data.enabled = !params.data.enabled;
          }
        },
        {
          headerName: 'Entity',
          field: 'entity',
          width: 150,
          valueFormatter: function(params) {
            if(params.value) {
              if(params.value.name) {
                return params.value.name;
              } else if (params.value === 'Add New') {
                return '';
              } else {
                return params.value;
              }
            }
          },
          cellEditorSelector:function (params) {
            if (params.data && ( !params.data.entity || !params.data.entity.id) ) {
              return {component: 'agPopupTextCellEditor'};
            } else {
              return {
                component: 'agRichSelectCellEditor',
                params: {
                  values: vm.selectorEntities,
                  formatValue: function(value) {
                    return value.name ? value.name : value;
                  }
                }
              };
            }
          },
          cellClassRules: {
            'required': function(params) { return !params.value || params.value === '';}
          }
        },
        {
          headerName: 'Institution',
          field: 'bank',
          width: 150
        },
        {
          headerName: 'Currency',
          field: 'currency',
          width: 70,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          cellEditor: 'agRichSelectCellEditor',
          cellEditorParams: function() {
            return {
              values: CURRENCIES.LIST,
              formatValue: function(value) {
                return value + ' ' + CURRENCIES.CODES[value].symbol;
              }
            };
          }
        },
        { headerName: 'Number',
          field: 'number',
          colId: 'number',
          width: 150,
          cellClassRules: {
            'required': function(params) { return !params.value || params.value === '';}
          }
        },
        {
          headerName: 'Name',
          field: 'name',
          width: 200,
          cellClassRules: {
            'required': function(params) { return !params.value || params.value === '';}
          }
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 150
        },
        {
          headerName: 'Source',
          field: 'sourceType',
          width: 100,
          cellEditor: 'agRichSelectCellEditor',
          editable: function(params) {
            return params.data.isEmpty && !params.data.plaidAuthorization;
          },
          valueFormatter: function(params) {
            return ACCOUNTS.SOURCE_TYPE_DESCRIPTION[params.value];
          },
          cellEditorParams: function() {
            return {
              values: [ACCOUNTS.SOURCE_TYPE.FILE_UPLOAD, ACCOUNTS.SOURCE_TYPE.BANK_API],
              formatValue: function(value) {
                return ACCOUNTS.SOURCE_TYPE_DESCRIPTION[value];
              }
            };
          }
        },
        {
          headerName: 'Type',
          field: 'type',
          width: 100,
          cellEditor: 'agRichSelectCellEditor',
          editable: function(params) {
            return params.data.isEmpty && !params.data.plaidAuthorization;
          },
          valueFormatter: function(params) {
            return ACCOUNTS.TYPE_DESCRIPTION[params.value];
          },
          cellEditorParams: function() {
            return {
              values: vm.accountTypes,
              formatValue: function(value) {
                return ACCOUNTS.TYPE_DESCRIPTION[value];
              }
            };
          }
        },
        {
          headerName: 'Integration',
          field: 'sourceType',
          width: 90,
          editable: false,
          cellRenderer: function(params) {
            if(params.data.sourceType === ACCOUNTS.SOURCE_TYPE.FILE_UPLOAD && !params.data.isEmpty) {
              return '<button class="btn btn-inverted btn-authorize authorized">Assigned</button>';
            } else if( params.data.sourceType === ACCOUNTS.SOURCE_TYPE.BANK_API ){
              if( params.data.plaidId || params.data.plaidAuthorization ) {
                return '<button class="btn btn-inverted btn-authorize authorized">Authorized</button>';
              }
              return '<button class="btn btn-inverted btn-authorize">Authorize</button>';
            }
            return '';
          },
          onCellClicked: function(params) {
            if(params.data.sourceType === ACCOUNTS.SOURCE_TYPE.BANK_API && !params.data.plaidId && !params.data.plaidAuthorization) {
              return openPlaid(params.node);
            }
          }
        },
        {
          headerName: 'Delete',
          field: '',
          width: 70,
          editable: false,
          cellRenderer: function() {
            return '<md-icon class="material-icons icon-primary ">delete</md-icon>';
          },
          onCellClicked: function(params) {
            if(!params.data.id) {
              // In this case, we only need delete the row from the table
              return deleteAccountRow(params.data);
            } else {
              return deleteAccount(params.data);
            }
          }
        },
        {
          headerName: '',
          field: 'plaidAuthorization',
          hide: true
        }
      ];

      vm.gridOptions = {
        columnDefs: columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        singleClickEdit: true,
        suppressRowHoverHighlight: true,
        stopEditingWhenGridLosesFocus: true,
        rowData: vm.accounts,
        angularCompileRows: true,
        rowHeight: 30,
        headerHeight: 25,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        getMainMenuItems: tableUtils.getMainMenuItems,
        onGridReady: function(params) { _adjustSize(params); },
        onGridSizeChanged: function(params) { _adjustSize(params); },
        onCellValueChanged: onCellValueChanged
      };
      vm.gridOptions.defaultColDef.editable = true;
      if(!vm.hasPermissions) {
        vm.gridOptions.defaultColDef.editable = false;
      }
    };

    function _adjustSize(params) {
      if(params) {
        params.api.sizeColumnsToFit();
      }
    }

    function onCellValueChanged(params) {
      var colId = params.column.getId();
      if (colId === 'sourceType' && params.data.sourceType === ACCOUNTS.SOURCE_TYPE.FILE_UPLOAD) {
        var updatedData = params.node.data;
        delete updatedData.plaidAuthorization;
        params.node.setData(updatedData);
      }
    }


    function addAccountRow() {
      var newAccount = {
        enabled: true,
        isEmpty: true,
        currency: ENV.defaultCurrency,
        sourceType: ACCOUNTS.SOURCE_TYPE.FILE_UPLOAD,
        type: ACCOUNTS.TYPE.CHECKING,
        projectId: $state.params.projectId,
        entity: vm.entities[0]
      };
      vm.gridOptions.api.updateRowData({add: [newAccount]});
    }

    function deleteAccountRow(row) {
      vm.gridOptions.api.updateRowData({remove: [row]});
    }

    function updateAccounts() {
      var accountsToUpdate = [];
      var unauthorizedAccounts = 0;
      var missingFieldAccounts = 0;
      var newAccounts = 0;
      var updatedAccounts = 0;

      vm.gridOptions.api.forEachNode( function(node) {
        var account = node.data;
        if(!account.id) { //New account
          newAccounts++;
          if (account.sourceType === ACCOUNTS.SOURCE_TYPE.BANK_API && (!account.plaidAuthorization || (account.plaidAuthorization && !account.plaidAuthorization.public_token))) {
            unauthorizedAccounts++;
          }
        }
        if(!account.name || account.name === '' || !account.number || account.number === '' || !account.entity || account.entity === '') {
          missingFieldAccounts++;
        } else {
          if(!account.entity.id) { //New Entity
            account.entityName = account.entity;
          } else {
            account.entityId = account.entity.id;
            updatedAccounts++;
          }
          accountsToUpdate.push(account);
        }
      });

      if(missingFieldAccounts !== 0) {
        toastr.error(missingFieldAccounts + ' accounts are missing required fields. Please fill-in all required fields before updating.');
      }
      if(unauthorizedAccounts !== 0) {
        toastr.error(unauthorizedAccounts + ' BANK API accounts are not authorized. Please authorize with Plaid before updating');
      }

      if(missingFieldAccounts === 0 && unauthorizedAccounts === 0) {
        Accounts.batchAccounts(accountsToUpdate, {projectId: $stateParams.projectId})
          .then( function Success() {
            var successMsg = (newAccounts > 0) ? newAccounts + ' new account' + ((newAccounts !== 1) ? 's were' : 'was') + ' added.</br> ' : '';
            successMsg += (updatedAccounts > 0) ? updatedAccounts + ' account' + ((updatedAccounts !== 1) ? 's were' : 'was') + ' updated.' : '';
            toastr.success(successMsg, {
              allowHtml: true
            });
            if(vm.type === PROJECT_TYPES.AUDIT){
              $state.go('engagement.overview');
            } else {
              $state.go('project.overview');
            }
          })
          .catch(function Failure() {
            toastr.error('The accounts has not been successfully updated.');
          });
      }
    }

    function openPlaid(node) {
      if(vm.plaidHandler) {
        vm.plaidNode = node;
        vm.plaidHandler.open();
      }
    }

    function _plaidSuccess(data) {
      vm.linkedAccount = data;

      var plaidData = {
        public_token: data.public_token,
        account_id: data.account_id
      };
      vm.plaidNode.setDataValue('plaidAuthorization', plaidData);
      vm.plaidNode.setDataValue('sourceType', ACCOUNTS.SOURCE_TYPE.FILE_UPLOAD);
      vm.plaidNode.setDataValue('sourceType', ACCOUNTS.SOURCE_TYPE.BANK_API); //Trick to refresh the cell
      $scope.$applyAsync();
    }

    function deleteAccount(account) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account/delete-account-dialog.html',
        controller: 'DeleteAccountController',
        locals: {
          account: account,
          reload: false,
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success() {
        deleteAccountRow(account);
      });
    }
  }
})();

(function() {
  'use strict';

  DeleteAccountController.$inject = ["$mdDialog", "$state", "toastr", "$stateParams", "Accounts"];
  angular
    .module('projects')
    .controller('DeleteAccountController', DeleteAccountController);

  function DeleteAccountController(
    $mdDialog,
    $state,
    toastr,
    $stateParams,
    Accounts) {
    var vm = this;
    vm.cancel = $mdDialog.cancel;
    vm.deleteAccount = deleteAccount;
    

    function deleteAccount() {
      var accountName = (vm.account.name) ? vm.account.name : 'Account'; 

      Accounts.destroy(vm.account.id)
        .then(function Success() {
          toastr.success(accountName + ' has been successfully deleted.');
          $mdDialog.hide();
          if (vm.reload) {
            $state.reload();
          }
        }).catch(
          function Failure() {
            $mdDialog.show({
              templateUrl: 'app/core/utils/alert-dialog/alert-dialog.html',
              controller: 'AlertDialogController',
              controllerAs: '$ctrl',
              bindToController: true,
              locals: {
                message: 'Error- The Account has Associated Transactions'
              }
            });
          }
        );
    }
  }
})();

(function() {
  'use-strict';

  AssignAccountDialogController.$inject = ["$mdDialog", "$q", "$state", "$stateParams", "Accounts", "AccountPeriods", "Documents", "ACCOUNTS", "DOCUMENT_TYPES", "STATEMENTS", "source", "type", "itemsToAssign"];
  angular
    .module('projects')
    .controller('AssignAccountDialogController', AssignAccountDialogController);

  function AssignAccountDialogController(
    $mdDialog,
    $q,
    $state,
    $stateParams,
    Accounts,
    AccountPeriods,
    Documents,
    ACCOUNTS,
    DOCUMENT_TYPES,
    STATEMENTS,
    source,
    type,
    itemsToAssign) {
    var vm = this;
    if (source === STATEMENTS.SOURCE.BROKERAGE_LOAN_PDF) {
      vm.excludeAccounts = [ACCOUNTS.TYPE.ERP, ACCOUNTS.TYPE.SAVINGS, ACCOUNTS.TYPE.CHECKING, ACCOUNTS.TYPE.CREDIT_CARD];
    } else {
      vm.excludeAccounts = [ACCOUNTS.TYPE.ERP, ACCOUNTS.TYPE.MORTGAGE, ACCOUNTS.TYPE.BROKERAGE];
    }
    vm.itemsToAssign = itemsToAssign;
    vm.cancelUpdate = $mdDialog.cancel;
    vm.assignItems = assignItems;
    vm.clearSelection = clearSelection;

    activate();

    function activate() {
      vm.projectAccounts = [];
      Accounts.findAll({ projectId: $stateParams.projectId, exclude: vm.excludeAccounts, enabled: true }, {bypassCache: true}).then(
        function Success(response) {
          _.forEach(response, function(a) {
            if(a.sourceType === ACCOUNTS.SOURCE_TYPE.FILE_UPLOAD) {
              vm.projectAccounts.push(a);
            }
          });
          vm.accountsLoaded = true;
        })
        .catch(
          function Failure() {
            toastr.error('Error fetching Accounts');
          }
        );
    }

    function assignItems() {
      if(!vm.selectedAccount) {
        return;
      }
      if (type === 'accountPeriod') {
        var accountId = vm.selectedAccount.id;
        var accountPeriodIds = _.map(vm.itemsToAssign, 'id');
        AccountPeriods.assign($stateParams.projectId, accountPeriodIds, accountId)
          .then(
            function Success() {
              $mdDialog.hide(true);
              $state.reload();
            }
          );
      }
    }

    function clearSelection() {
      vm.selectedAccountId = null;
    }

  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "PROJECT_TYPES"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider, PROJECT_TYPES) {
    $stateProvider
      .state('project.accounts', {
        url: '/accounts',
        abstract: true
      })
      .state('project.accounts.accountEdit', {
        url: '/:accountId/edit',
        resolve: {
          account: ["$stateParams", "Accounts", function($stateParams, Accounts) {
            return Accounts.find($stateParams.accountId);
          }],
          entities: ["$stateParams", "Entities", function($stateParams, Entities) {
            return Entities.findAllByProject($stateParams.projectId);
          }]
        },
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/account/edit-account.html',
            controller: 'EditAccountController as $ctrl'
          }
        }
      })
      .state('project.accounts.accountDetail.transaction', {
        url: '/transactions/:transactionId',
        resolve: {
          transaction: ["$stateParams", "Transactions", function($stateParams, Transactions) {
            return Transactions.find($stateParams.transactionId);
          }]
        },
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/transactions/transaction-detail.html',
            controller: 'TransactionDetailController as $ctrl'
          }
        }
      })
      .state('project.accounts.accountsEdit', {
        url: '/edit-accounts?sortModel&sortOrder',
        resolve: {
          accounts: ["$stateParams", "Accounts", "tableUtils", "ACCOUNTS", function($stateParams, Accounts, tableUtils, ACCOUNTS) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            if(!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'entity.name';
              $stateParamsClone.sortOrder = 'asc';
            }
            var pagingParams = tableUtils.formatPagingParams($stateParamsClone);
            var params = angular.extend({ projectId: $stateParamsClone.projectId, exclude: [ACCOUNTS.TYPE.ERP] }, pagingParams);
            return Accounts.findAll(params, {bypassCache: true});
          }],
          entities: ["$stateParams", "Entities", function($stateParams, Entities) {
            return Entities.findAllByProject($stateParams.projectId);
          }]
        },
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/account/edit-accounts.html',
            controller: 'EditAccountsController as $ctrl'
          }
        }
      })
      .state('project.accounts.accountDetail', {
        url: '/:accountId?pageSize&sortOrder&sortModel&keyword&statementId',
        resolve: {
          account: ["$stateParams", "Accounts", function($stateParams, Accounts) {
            return Accounts.find($stateParams.accountId);
          }],
          categories: ["$stateParams", "Categories", function($stateParams, Categories) {
            return Categories.findAllByProject($stateParams.projectId);
          }],
          customFields: ["$stateParams", "CustomFields", function($stateParams, CustomFields) {
            return CustomFields.findAllByProject($stateParams.projectId);
          }],
          transactions: ["$stateParams", "Transactions", "transactionUtils", "tableUtils", "CHECK_ITEMS", function($stateParams, Transactions, transactionUtils, tableUtils, CHECK_ITEMS) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            // Set Default sort params
            if(!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'date';
              $stateParamsClone.sortOrder = 'asc';
            }
            var pagingParams = tableUtils.formatPagingParams($stateParamsClone, true);
            var params = angular.extend({downloadUrl: true, includeCheckItems: CHECK_ITEMS.STATUS.RECONCILED}, transactionUtils.formatFilterParams($stateParamsClone), pagingParams);
            return Transactions.findAllPOST(params);
          }]
        },
        data: {
          projectType: PROJECT_TYPES.FORENSIC
        },
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/account/account-transactions.html',
            controller: 'AccountTransactionsController as $ctrl'
          }
        }
      });
  }
})();

(function() {
  'use strict';

  Accounts.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('projects')
    .factory('Accounts', Accounts);

  function Accounts(DS, DSHttpAdapter) {
    var accounts = DS.defineResource({
      name: 'accounts',
      endpoint: 'accounts',
      idAttribute: 'id',
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    accounts.filterByProject = function(id) {
      return accounts.filter({
        where: {
          'entity.projectId': id
        }
      });
    };

    accounts.findAllByProject = function(id) {
      return accounts.findAll({ projectId: id });
    };

    accounts.batchAccounts = function(accounts, params) {
      //Remove stuff that is not to be updated V8F-1806
      if(!accounts || accounts.length === 0 ) {
        return;
      }

      _.forEach(accounts, function (a) {
        delete a.entity;
        delete a.statusAreaChart;
        delete a.statusBarChart;
        delete a.statusDonutChart;
      });

      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/accounts/batch',
        accounts,
        { params: params }
      );
    };

    return accounts;
  }
})();

(function() {
  'use strict';

  AccountTransactionsController.$inject = ["$state", "$mdDialog", "chartUtils", "Accounts", "transactions", "Transactions", "Projects"];
  angular
    .module('projects')
    .controller('AccountTransactionsController', AccountTransactionsController);

  function AccountTransactionsController(
    $state,
    $mdDialog,
    chartUtils,
    Accounts,
    transactions,
    Transactions,
    Projects) {
    var vm = this;
    vm.transactions = transactions;
    vm.showTransactions = showTransactions;
    activate();

    function activate() {
      vm.projectType = $state.current.data.projectType;
      var metadata = Transactions.getMetadata();
      vm.account = Accounts.get($state.params.accountId);
      vm.stackedBarChart = chartUtils.formatDonutChart(vm.account.statusDonutChart);
      vm.statusBarChart = vm.account.statusBarChart;
      vm.inflows = metadata.transInflowsFilter;
      vm.outflows = metadata.transOutflowsFilter;
      vm.project = Projects.get($state.params.projectId);
    }

    function showTransactions() {
      if (vm.transactions.length > 0) {
        return true;
      }
      return false;
    }
  }
})();

(function() {
  'use strict';

  WorkpaperMetricsController.$inject = ["$mdDialog", "$scope", "$filter", "toastr", "ERP_METRICS", "metrics"];
  angular
    .module('projects')
    .controller('WorkpaperMetricsController', WorkpaperMetricsController);

  function WorkpaperMetricsController(
    $mdDialog,
    $scope,
    $filter,
    toastr,
    ERP_METRICS,
    metrics) {

    var vm = this;
    vm.metrics = metrics;
    vm.exportToCsv = exportToCsv;
    vm.close = close;
    var exportParams = {
      fileName: _getExportName(),
      columnKeys: ['metric', 'value']
    };


    this.$onInit = function() {
      vm.columnDefs = [
        {
          headerName: 'Metric',
          field: 'metric'
        },
        {
          headerName: 'Value',
          field: 'value',
          valueFormatter: function(params) {
            if(typeof params.value === 'string' && params.value.endsWith('Z')) {
              return $filter('dateDisplay')(params.value);
            } 
            return params.value;
          }
        }
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        rowHeight: 30,
        headerHeight: 25,
        rowData: _getMetricsRows(),
        onGridReady: function(params) { params.api.sizeColumnsToFit(); },
      };
    };

    function _getMetricsRows() {
      var metricsArray = [];
      var metrics = vm.metrics.metrics;
      _.forEach(ERP_METRICS.KEY_ORDER, function(k) {
        metricsArray.push( { metric: k, value: metrics[k] });
      });
      return metricsArray;
    }

    function exportToCsv() {
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function _getExportName() {
      return 'Metrics_' + moment().format('MMYYYY') + '.csv';
    }
  
    function close() {
      $mdDialog.cancel();
    }
  }
})();

(function() {
  'use strict';

  WorkpaperListTableController.$inject = ["$state", "$mdDialog", "$filter", "tableUtils", "Reports", "Authorization", "reconciliationUtils", "REPORTS"];
  angular
    .module('projects')
    .component('workpaperListTable', {
      templateUrl: 'app/projects/engagement/workpapers/workpaper-list-table.html',
      bindings: {
        workpapers: '<'
      },
      controller: WorkpaperListTableController
    });

  function WorkpaperListTableController(
    $state,
    $mdDialog,
    $filter,
    tableUtils,
    Reports,
    Authorization,
    reconciliationUtils,
    REPORTS) {

    var vm = this;
    var GRID_ID = 'grid-workpapers';
    vm.reloadData = reloadData;

    this.$onInit = function() {
      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.columnDefs = [
        {
          headerName: 'Download',
          width: 100,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          cellClass: 'links icons',
          cellRenderer: function(params) {
            if(!params.data || !params.data.downloadUrl) {
              return '<md-icon class="material-icons icon-primary icon-disabled">get_app</md-icon>';
            }
            return '<a class="file-name" target="_blank" href="' + params.data.downloadUrl + '"><md-icon class="material-icons icon-primary">get_app</md-icon></a>';
          }
        },
        {
          headerName: 'Delete',
          width: 80,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          hide: !Authorization.isV8Admin(),
          suppressColumnsToolPanel: !Authorization.isV8Admin(),
          cellClass: 'links icons',
          cellRenderer: function() {
            return '<md-icon class="material-icons icon-primary">delete</md-icon>';
          },
          onCellClicked: function(params) {
            return _deleteWorkpaper(params.data);
          }
        },
        {
          headerName: 'Metrics',
          width: 80,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          hide: !Authorization.isV8Admin(),
          suppressColumnsToolPanel: !Authorization.isV8Admin(),
          cellClass: 'links icons',
          cellRenderer: function(params) {
            var disabled = '';
            if(!params.data || params.data.status !== REPORTS.STATUS.READY || !params.data.data.traceMetrics) {
              disabled = 'icon-disabled';
            }
            return '<md-icon class="material-icons icon-primary ' + disabled + ' ">poll</md-icon>';
          },
          onCellClicked: function(params) {
            _openMetricsDialog(params.data.data.traceMetrics);
          }
        },
        {
          headerName: 'Status',
          field: 'status',
          suppressMovable: true,
          width:200,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            return '<report-status-sync status="data.status" report-id="data.id" reload="$ctrl.reloadData()"></report-status-sync>';
          }
        },
        {
          headerName: 'Workpaper ID',
          field: 'name',
          suppressMovable: true,
          width: 400
        },
        {
          headerName: 'Type',
          field: 'type',
          suppressMovable: true,
          width: 130,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return REPORTS.TYPE_DESCRIPTION[params.value];
          }
        },
        {
          headerName: 'Inflow Coverage - CJ',
          field: 'data',
          width: 200,
          sortable: false,
          suppressMovable: true,
          valueFormatter: function(params) {
            var metrics = params.value;
            var coverage = 1;
            if(!metrics.reconciled) {
              //Backward compatibility with old metric...
              coverage = metrics.cjCoverage ? metrics.cjCoverage : reconciliationUtils.getCjInflowCoverage(metrics.reconciliationMetrics);
            }
            return $filter('percentageDisplay')(coverage);
          }
        },
        {
          headerName: 'Inflow Coverage - Bank',
          field: 'data',
          width: 200,
          sortable: false,
          suppressMovable: true,
          valueFormatter: function(params) {
            var metrics = params.value;
            //Backward compatibility with old metric...
            var coverage = metrics.bankCoverage ? metrics.bankCoverage : reconciliationUtils.getBankInflowCoverage(metrics.reconciliationMetrics);
            return $filter('percentageDisplay')(coverage);
          }
        },
        {
          headerName: 'Reconciled',
          width: 100,
          field: 'data.reconciled',
          sortable: false,
          suppressMovable: true,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            var rec = params.value ? '<md-icon class="material-icons icon-primary check">check</md-icon>' : '<md-icon class="material-icons">close</md-icon>';
            return rec;
          }
        },
        {
          headerName: 'Match Date',
          field: 'data.matchDate',
          width: 150,
          sortable: false,
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Period Start',
          field: 'startDate',
          suppressMovable: true,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Period End',
          field: 'endDate',
          suppressMovable: true,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('dateDisplay')(params.value);
          }
        }
      ];

      vm.columnDefs = _setColumnSort(vm.columnDefs);

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        cacheBlockSize: vm.pagination.pageSize,
        angularCompileRows: true,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        onSortChanged: vm.reloadData,
        getMainMenuItems: tableUtils.getMainMenuItems,
        rowModelType: 'serverSide',
        onGridReady: onGridReady,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange
      };
    };

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID);
    }


    function reloadData(opts) {
      if(!vm.gridOptions.api) {
        return;
      }
      if(opts && opts.pageSize) {
        vm.pagination.pageSize = opts.pageSize;
        vm.gridOptions.paginationPageSize = opts.pageSize;
        vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      }
      if(opts && opts.keyword || opts && opts.keyword === '') {
        vm.pagination.keyword = opts.keyword;
      }
      var sortModel = vm.gridOptions.api.getSortModel();
      if(sortModel.length) {
        vm.pagination.sortModel = sortModel[0].colId;
        vm.pagination.sortOrder = sortModel[0].sort;
      } else {
        vm.pagination.sortModel = 'createdAt';
        vm.pagination.sortOrder = 'desc';
      }
      vm.pagination.skipCount = 0;
      $state.go($state.current, vm.pagination, { notify: false });
      vm.gridOptions.api.setServerSideDatasource(_createDatasource());
    }

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID);
      vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      if(!tableUtils.getGridState(GRID_ID)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function _openMetricsDialog(metrics) {
      $mdDialog.show({
        templateUrl: 'app/projects/engagement/workpapers/workpaper-metrics-dialog.html',
        controller: 'WorkpaperMetricsController',
        locals: {
          metrics: metrics
        },
        controllerAs: '$ctrl',
        bindToController: true
      });
    }

    function _setColumnSort(columnDefs) {
      return _.map(columnDefs, function(column) {
        if(column.field === vm.pagination.sortModel || column.colId === vm.pagination.sortModel) {
          column.sort = vm.pagination.sortOrder;
        }
        return column;
      });
    }

    function _deleteWorkpaper(workpaper) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/reports/delete-report-dialog.html',
        controller: 'DeleteReportController',
        locals: {
          report: workpaper
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success(shouldReload) {
        if(shouldReload) {
          vm.reloadData();
        } else if (vm.gridOptions.api) {
          vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        }
      });
    }


    function _createDatasource() {
      return {
        getRows: function(params) {
          // Load resolved reports for sorting/paging
          if(vm.workpapers) {
            params.successCallback(vm.workpapers, Reports.getMetadata().total);
            vm.workpapers = false;
          } else {
            vm.pagination.skipCount = params.request.startRow;
            var workpaperTypes = [REPORTS.TYPE.FINANCIALS, REPORTS.TYPE.REVENUE, REPORTS.TYPE.EXPENSE, REPORTS.TYPE.SUBSEQUENT_AR, REPORTS.TYPE.SAMPLE_BASED];
            var workpaperParams = angular.extend({projectId: $state.params.projectId, type: workpaperTypes}, tableUtils.formatPagingParams(vm.pagination));
            Reports.findAll(workpaperParams).then(
              function Success(data) {
                params.successCallback(data, Reports.getMetadata().total);
              }
            );
          }
        }
      };
    }
  }
})();

(function() {
  'use strict';

  CreateWorkpaperController.$inject = ["$mdDialog", "$state", "$timeout", "toastr", "Reports", "REPORTS", "type"];
  angular
    .module('projects')
    .controller('CreateWorkpaperController', CreateWorkpaperController);

  function CreateWorkpaperController(
    $mdDialog,
    $state,
    $timeout,
    toastr,
    Reports,
    REPORTS,
    type) {

    var vm = this;
    vm.createWorkpaper = createWorkpaper;

    activate();

    function activate() {
      vm.workpaperTitle = REPORTS.TYPE_DESCRIPTION[type];
      vm.workpaper = {
        type: type,
        projectId: $state.params.projectId
      };
    }

    function createWorkpaper(){
      if(vm.workpaper) {
        Reports.create(vm.workpaper)
          .then(function Success(response) {
            toastr.success('Workpaper ' + response.name + ' has been successfully created.');
            $mdDialog.hide();
            $timeout( function(){
              $state.reload();
            }, 1000);
          })
          .catch(function Failure(response) {
            toastr.error(response.data.message);
            $mdDialog.hide();
          });
      }
    }

  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('categorization')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('engagement.transactions', {
        url: '/transactions?startDate&endDate&transRangeLow&transRangeHigh&transRangeAbs&accounts&bankAccountTypes&categories&keyword&keywordField&pageSize&sortOrder&sortModel&flow&sourceType&entities&entitiesEnabled',
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/engagement/transactions/transactions.html',
            controller: 'EngagementTransactionsController as $ctrl'
          }
        },
        // TODO: this route
        resolve: {
          categories: ["$stateParams", "Categories", function($stateParams, Categories) {
            return Categories.findAllByProject($stateParams.projectId);
          }],
          customFields: ["$stateParams", "CustomFields", function($stateParams, CustomFields) {
            return CustomFields.findAllByProject($stateParams.projectId);
          }],
          accounts: ["$stateParams", "Accounts", function($stateParams, Accounts) {
            return Accounts.findAll({ projectId: $stateParams.projectId, enabled: true});
          }],
          transactions: ["$stateParams", "Transactions", "transactionUtils", "tableUtils", function($stateParams, Transactions, transactionUtils, tableUtils) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            if(!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'date';
              $stateParamsClone.sortOrder = 'asc';
            }
            if(!$stateParamsClone.sourceType) {
              $stateParamsClone.sourceType = 'erp';
            }
            if(!$stateParamsClone.transRangeAbs) {
              $stateParamsClone.transRangeAbs = 'true';
            } 
            var pagingParams = tableUtils.formatPagingParams($stateParamsClone, true);
            var params = angular.extend({ downloadUrl: true }, transactionUtils.formatFilterParams($stateParamsClone), pagingParams);
            return Transactions.findAllPOST(params);
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  EngagementTransactionsController.$inject = ["$scope", "$state", "Accounts", "Entities", "transactions", "Categories", "transactionUtils", "Transactions", "Projects", "dateUtils"];
  angular
    .module('categorization')
    .controller('EngagementTransactionsController', EngagementTransactionsController);

  function EngagementTransactionsController(
    $scope,
    $state,
    Accounts,
    Entities,
    transactions,
    Categories,
    transactionUtils,
    Transactions,
    Projects,
    dateUtils) {
    var vm = this,
      filterDataCopy;

    vm.applyFilter = applyFilter;
    vm.transactions = transactions;
    vm.onCategoryUpdate = onCategoryUpdate;
    vm.refresh = refresh;

    activate();

    function activate() {
      vm.transMetadata = Transactions.getMetadata();
      vm.categories = Categories.filterByProject($state.params.projectId);
      vm.accounts = Accounts.filterByProject($state.params.projectId);
      vm.entities = Entities.filterByProject($state.params.projectId);
      vm.filterData = transactionUtils.getFilterData($state.params);
      vm.project = Projects.get($state.params.projectId);
      filterDataCopy = angular.copy(vm.filterData);
    }

    function applyFilter() {
      // if the filter params have not been updated
      // don't filter the table
      if(!angular.equals(vm.filterData, filterDataCopy)) {
        var params;
        //Reset filters if there is a change of source
        params = dateUtils.formatUrlDates(angular.copy(vm.filterData));
        if(!params.transRangeLow) {
          delete $state.params.transRangeLow;
        }
        if(!params.transRangeHigh) {
          delete $state.params.transRangeHigh;
        }
        params.projectId = $state.params.projectId;
        $state.go('engagement.transactions', params, {inherit: false});
      }
    }

    function refresh() {
      $state.reload();
    }

    function onCategoryUpdate() {
      vm.categories = Categories.filterByProject($state.params.projectId);
    }

  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('engagement.trace', {
        url: '/trace',
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/engagement/trace/trace.html',
            controller: 'EngagementTraceController as $ctrl',
          }
        },
      });
  }
})();

(function() {
  'use strict';

  EngagementTraceController.$inject = ["$scope", "$state", "Projects"];
  angular
    .module('projects')
    .controller('EngagementTraceController', EngagementTraceController);

  function EngagementTraceController(
    $scope,
    $state,
    Projects) {
    var vm = this;

    vm.refresh = refresh;

    vm.traceSelectionOptions = {
      dateRangeOptions: [
        {name:"Jan 1, 2020 - Dec 31, 2020",value:1},
        {name:"Jan 1, 2019 - Dec 31, 2019",value:2},
        {name:"Oct 1, 2020 - Dec 31, 2020",value:3},
      ],
      dateRangeSelection: 1,
      groupByOptions: [
        {name:"By Type",value:1},
        {name:"By Customer",value:2},
        {name:"By Item Detail",value:3},
      ],
      groupBySelection: 1,
      subsequentOptions: [
        {name:"In-Period",value:1},
        {name:"In-Period + Subsequent",value:2},
        {name:"Subsequent",value:3},
      ],
      subsequentSelection: 1,
      selectionChanged() {
        activate();
      }
    };

    activate();

    function activate() {
      vm.project = Projects.get($state.params.projectId);
      vm.hasTrace = true;
      if (vm.traceSelectionOptions.groupBySelection === 1) {
        vm.traceData = _getTraceDataByType();
      } else if (vm.traceSelectionOptions.groupBySelection === 2) {
        vm.traceData = _getTraceDataByCustomer();
      } else {
        vm.traceData = _getTraceData();
      }
    }

    function _getTraceData() {
      return {
        "nodes": [
          {
            "name": "Product Revenue",
            "amount": 198979.16,
            "id": 1,
            "type": "source"
          },
          {
            "name": "Invoice #3464, FRB",
            "amount": 60213.36,
            "id": 2,
            "type": "invoice"
          },
          {
            "name": "Pmt #3771, FRB",
            "amount": 11604.47,
            "id": 4,
            "type": "payment"
          },
          {
            "name": "Pmt #4746, FRB",
            "amount": 2315.72,
            "id": 5,
            "type": "payment"
          },
          {
            "name": "Pmt #5068, FRB",
            "amount": 2315.72,
            "id": 6,
            "type": "payment"
          },
          {
            "name": "Pmt #5257, FRB",
            "amount": 2315.72,
            "id": 7,
            "type": "payment"
          },
          {
            "name": "Pmt #4812, FRB",
            "amount": 2315.72,
            "id": 8,
            "type": "payment"
          },
          {
            "name": "Pmt #5053, FRB",
            "amount": 39400,
            "id": 9,
            "type": "payment"
          },
          {
            "name": "Operating Acct (4794)",
            "amount": 219184.35,
            "id": 10,
            "type": "deposit"
          },
          {
            "name": "BofA Checking (4794)",
            "amount": 219184.35,
            "id": 11,
            "type": "evidence"
          },
          {
            "name": "Service Revenue",
            "amount": 79800,
            "id": 12,
            "type": "source"
          },
          {
            "name": "Tax Payable",
            "amount": 22041.45,
            "id": 3,
            "type": "taxOrRevenueDebitSource",
          },
          {
            "name": "Invoice #1842, KwG",
            "amount": 87300,
            "id": 13,
            "type": "invoice"
          },
          {
            "name": "Pmt #2236, KwG",
            "amount": 67000,
            "id": 14,
            "type": "payment"
          },
          {
            "name": "Pmt #3161, KwG",
            "amount": 20300,
            "id": 15,
            "type": "payment"
          },
          {
            "name": "Invoice #4831, National",
            "amount": 19770.6,
            "id": 16,
            "type": "invoice"
          },
          {
            "name": "Pmt #4995, National",
            "amount": 19770.6,
            "id": 17,
            "type": "payment"
          },
          {
            "name": "Product Revenue - Debit",
            "amount": 20242.65,
            "id": 18,
            "type": "taxOrRevenueDebitSource",
          },
          {
            "name": "Discount #5006, FTI ltd",
            "amount": 13842.65,
            "id": 19,
            "type": "discount",
          },
          {
            "name": "Invoice #3590, FTI ltd",
            "amount": 33501.3,
            "id": 20,
            "type": "invoice"
          },
          {
            "name": "Pmt #5007, FTI ltd",
            "amount": 5816,
            "id": 21,
            "type": "payment"
          },
          {
            "name": "Discount #55, FRB",
            "amount": 2400,
            "id": 22,
            "type": "discount",
          },
          {
            "name": "Invoice #4612, FRB",
            "amount": 44200,
            "id": 23,
            "type": "invoice"
          },
          {
            "name": "Discount #59, K Elliott",
            "amount": 4000,
            "id": 24,
            "type": "discount",
          },
          {
            "name": "Invoice #2967, K Elliott",
            "amount": 20278,
            "id": 25,
            "type": "invoice"
          },
          {
            "name": "Pmt #3231, K Elliott",
            "amount": 11887,
            "id": 26,
            "type": "payment"
          },
          {
            "name": "",
            "amount": 0,
            "id": 27,
            "type": "invoice",
            "hide": true,
            "flowStyle": "other",
          },
          {
            "name": "",
            "amount": 0,
            "id": 28,
            "type": "payment",
            "hide": true,
            "flowStyle": "other",
          },
          {
            "name": "Bad Debt",
            "amount": 21657.60,
            "id": 29,
            "type": "badDebt",
          },
        ],
        "links": [
          {
            "source": 1,
            "target": 2,
            "amount": 15000,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "ysccjpdcou",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 7500,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "vikjabwecv",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 10200,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "usrrfwvdzj",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 22950.06,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "xoxciktimq",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 3,
            "target": 2,
            "amount": 946.05,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "tpmmgqieho",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 3,
            "target": 2,
            "amount": 3617.25,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "xeknnfjwwt",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 11604.47,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "jabucuxpqw",
          },
          {
            "source": 2,
            "target": 5,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "gyitdsagxu",
          },
          {
            "source": 2,
            "target": 6,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "hpuhnjbvef",
          },
          {
            "source": 2,
            "target": 7,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "nhcniqbuaj",
          },
          {
            "source": 2,
            "target": 8,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "lohqarnqol",
          },
          {
            "source": 2,
            "target": 9,
            "amount": 10000,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "ewcnjtbavn",
          },
          {
            "source": 4,
            "target": 10,
            "amount": 11604.47,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "nhatdpchay"
          },
          {
            "source": 5,
            "target": 10,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "qxvoswvwzo"
          },
          {
            "source": 6,
            "target": 10,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "wchubikpzg"
          },
          {
            "source": 7,
            "target": 10,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "fczxkptqyd"
          },
          {
            "source": 8,
            "target": 10,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "gpdenhddki"
          },
          {
            "source": 9,
            "target": 10,
            "amount": 10000,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "pzzmbplngz"
          },
          {
            "source": 10,
            "target": 11,
            "amount": 11604.47,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "lyavjkgais",
            "imageURL": "assets/tracedemo/txn9.png",
          },
          {
            "source": 10,
            "target": 11,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "zmqavkhbqw",
            "imageURL": "assets/tracedemo/txn1.png",
          },
          {
            "source": 10,
            "target": 11,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "aicwnphsyk",
            "imageURL": "assets/tracedemo/txn7.png",
          },
          {
            "source": 10,
            "target": 11,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "gjsrgnfjge",
            "imageURL": "assets/tracedemo/txn12.png",
          },
          {
            "source": 10,
            "target": 11,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "tdfsyckdxc",
            "imageURL": "assets/tracedemo/txn13.png",
          },
          {
            "source": 10,
            "target": 11,
            "amount": 10000,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "wmpupcthvj",
            "imageURL": "assets/tracedemo/txn10.png",
          },
          {
            "source": 12,
            "target": 13,
            "amount": 79800,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "whcsdafwyb",
            "imageURL": "assets/tracedemo/dualentry3.png"
          },
          {
            "source": 3,
            "target": 13,
            "amount": 7500,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "gerfiblbwu",
            "imageURL": "assets/tracedemo/dualentry3.png"
          },
          {
            "source": 13,
            "target": 14,
            "amount": 67000,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "zoewltpwtl",
          },
          {
            "source": 13,
            "target": 15,
            "amount": 20300,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "venroxpyhx",
          },
          {
            "source": 14,
            "target": 10,
            "amount": 67000,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "iozmouuzoq"
          },
          {
            "source": 15,
            "target": 10,
            "amount": 20300,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "uttzirhqjz"
          },
          {
            "source": 10,
            "target": 11,
            "amount": 67000,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "vtfacjsfdf",
            "imageURL": "assets/tracedemo/txn6.png",
          },
          {
            "source": 10,
            "target": 11,
            "amount": 20300,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "pvfedxokre",
            "imageURL": "assets/tracedemo/txn11.png",
          },
          {
            "source": 1,
            "target": 27,
            "amount": 55800,
            "sourceType": "source",
            "targetType": "deposit",
            "rtype": "madcexngxz"
          },
          {
            "source": 27,
            "target": 28,
            "amount": 55800,
            "sourceType": "source",
            "targetType": "deposit",
            "rtype": "mbdcexngxz"
          },
          {
            "source": 28,
            "target": 10,
            "amount": 55800,
            "sourceType": "source",
            "targetType": "deposit",
            "rtype": "mcdcexngxz"
          },

          {
            "source": 10,
            "target": 11,
            "amount": 55800,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "amwchfixyy",
            "imageURL": "assets/tracedemo/txn3.png",
          },
          {
            "source": 1,
            "target": 16,
            "amount": 10200,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "blgzojwweh",
            "imageURL": "assets/tracedemo/dualentry1.png",
          },
          {
            "source": 1,
            "target": 16,
            "amount": 7500,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "qdkqkwzntc",
            "imageURL": "assets/tracedemo/dualentry1.png",
          },
          {
            "source": 1,
            "target": 16,
            "amount": 150.6,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "vcrbfzpedi",
            "imageURL": "assets/tracedemo/dualentry1.png",
          },
          {
            "source": 1,
            "target": 16,
            "amount": 1920,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "yhtnlohfvj",
            "imageURL": "assets/tracedemo/dualentry1.png",
          },
          {
            "source": 16,
            "target": 17,
            "amount": 19770.6,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "hsknshskvy",
          },
          {
            "source": 17,
            "target": 10,
            "amount": 10000,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "qyovljexqz"
          },
          {
            "source": 17,
            "target": 29,
            "amount": 9770.6,
            "sourceType": "payment",
            "targetType": "badDebt",
            "rtype": "vzqvljexqa"
          },
          {
            "source": 10,
            "target": 11,
            "amount": 10000,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "huvqymithz",
            "imageURL": "assets/tracedemo/txn8.png",
          },
          {
            "source": 18,
            "target": 19,
            "amount": 13842.65,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "discount",
            "rtype": "fefvtlorei",
            "imageURL": "assets/tracedemo/dualentry5.png",
          },
          {
            "source": 19,
            "target": 20,
            "amount": 13842.65,
            "sourceType": "discount",
            "targetType": "invoice",
            "rtype": "mlxukffmhl",
          },
          {
            "source": 1,
            "target": 20,
            "amount": 17871.5,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "qabolkfial",
            "imageURL": "assets/tracedemo/dualentry6.png",
          },
          {
            "source": 3,
            "target": 20,
            "amount": 1787.15,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "liyvcyxbub",
            "imageURL": "assets/tracedemo/dualentry6.png",
          },
          {
            "source": 20,
            "target": 21,
            "amount": 5816,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "yeyafpbwbd",
          },
          {
            "source": 21,
            "target": 10,
            "amount": 5816,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "clfboorsie"
          },
          {
            "source": 10,
            "target": 11,
            "amount": 5816,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "roarzavtws",
            "imageURL": "assets/tracedemo/txn5.png",
          },
          {
            "source": 18,
            "target": 22,
            "amount": 2400,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "discount",
            "rtype": "kozvyzmoea",
            "imageURL": "assets/tracedemo/dualentry4.png",
          },
          {
            "source": 22,
            "target": 23,
            "amount": 2400,
            "sourceType": "discount",
            "targetType": "invoice",
            "rtype": "qnwlrqauew",
          },
          {
            "source": 3,
            "target": 23,
            "amount": 3800,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "kzdpkrybij",
            "imageURL": "assets/tracedemo/dualentry4.png",
          },
          {
            "source": 1,
            "target": 23,
            "amount": 38000,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "fdkkvoypqy",
            "imageURL": "assets/tracedemo/dualentry4.png",
          },
          {
            "source": 23,
            "target": 9,
            "amount": 29400,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "dsaarofpvi",
          },
          {
            "source": 9,
            "target": 10,
            "amount": 29400,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "akoljgnzar"
          },
          {
            "source": 10,
            "target": 11,
            "amount": 29400,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "hblyrpwlwa",
            "imageURL": "assets/tracedemo/txn4.png",
          },
          {
            "source": 18,
            "target": 24,
            "amount": 4000,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "discount",
            "rtype": "wjdtgtgzaq",
            "imageURL": "assets/tracedemo/dualentry5.png"
          },
          {
            "source": 24,
            "target": 25,
            "amount": 4000,
            "sourceType": "discount",
            "targetType": "invoice",
            "rtype": "hxfmsuplzg",
          },
          {
            "source": 1,
            "target": 25,
            "amount": 10391,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "zhvuegkicj",
            "imageURL": "assets/tracedemo/dualentry5.png"
          },
          {
            "source": 1,
            "target": 25,
            "amount": 1496,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "ldtjfahbws",
            "imageURL": "assets/tracedemo/dualentry5.png",
          },
          {
            "source": 3,
            "target": 25,
            "amount": 4391,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "svdcpkjqqe",
            "imageURL": "assets/tracedemo/dualentry5.png",
          },
          {
            "source": 25,
            "target": 26,
            "amount": 11887,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "lhxtrvkcah",
          },
          {
            "source": 26,
            "target": 29,
            "amount": 11887,
            "sourceType": "payment",
            "targetType": "badDebt",
            "rtype": "pvmdvbroyh"
          },
          {
            "source": 10,
            "target": 11,
            "amount": 11887,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "irfhkfiyho",
            "imageURL": "assets/tracedemo/txn2.png",
          }
        ],
        "metadata": {
          "totalRevenue": "0",
          "totalDeposit": "0",
          "totalVerified": "0",
          "outstandingAR": "0"
        }
      };
    }

    function _getTraceDataByType() {
      return {
        "nodes": [
          {
            "name": "Product Revenue",
            "amount": 198979.16,
            "id": 1,
            "type": "source"
          },
          {
            "name": "Invoice",
            "amount": 265263.26,
            "id": 2,
            "type": "invoice"
          },
          {
            "name": "Pmt",
            "amount": 185040.95,
            "id": 4,
            "type": "payment"
          },
          {
            "name": "Operating Acct (4794)",
            "amount": 219184.35,
            "id": 5,
            "type": "deposit"
          },
          {
            "name": "BofA Checking (4794)",
            "amount": 219184.35,
            "id": 6,
            "type": "evidence"
          },
          {
            "name": "Service Revenue",
            "amount": 79800,
            "id": 7,
            "type": "source"
          },
          {
            "name": "Tax Payable",
            "amount": 22041.45,
            "id": 3,
            "type": "taxOrRevenueDebitSource"
          },
          {
            "name": "Product Revenue - Debit",
            "amount": 20242.65,
            "id": 8,
            "type": "taxOrRevenueDebitSource"
          },
          {
            "name": "Discount",
            "amount": 20242.65,
            "id": 9,
            "type": "discount"
          },
          {
            "name": "",
            "amount": 0,
            "id": 10,
            "type": "invoice",
            "hide": true,
            "flowStyle": "other",
          },
          {
            "name": "",
            "amount": 0,
            "id": 11,
            "type": "payment",
            "hide": true,
            "flowStyle": "other",
          },
          {
            "name": "Bad Debt",
            "amount": 21657.60,
            "id": 12,
            "type": "badDebt",
          }
        ],
        "links": [
          {
            "source": 1,
            "target": 2,
            "amount": 15000,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "opoghwidqj",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 7500,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "txalkkutic",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 10200,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "crarjkhyfs",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 22950.06,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "jblvyvgvuh",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 3,
            "target": 2,
            "amount": 946.05,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "rrpisjtnoc",
            "imageURL": "assets/tracedemo/dualentry2.png",
          },
          {
            "source": 3,
            "target": 2,
            "amount": 3617.25,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "zjzngnymhn",
            "imageURL": "assets/tracedemo/dualentry2.png",
          },
          {
            "source": 2,
            "target": 4,
            "amount": 11604.47,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "qbgtxbqvys"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "bikqlplsof"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "lkrmqzrxgk"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "isucjbvmai"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "bdlpwgvbre"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 10000,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "vkmsggqvjp"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 11604.47,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "mphwmdcpgy"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "ikwbprxnyu"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "lgjjwbrgzd"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "vwfnuwystg"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "dwoawlakiz"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 10000,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "kflpmivtto"
          },
          {
            "source": 5,
            "target": 6,
            "amount": 11604.47,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "jdzylwpkbk",
            "imageURL": "assets/tracedemo/txn9.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "clxhhkjlvu",
            "imageURL": "assets/tracedemo/txn1.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "ezrmvilagx",
            "imageURL": "assets/tracedemo/txn7.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "tvoemvtlxv",
            "imageURL": "assets/tracedemo/txn12.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "ghjhbxvmtc",
            "imageURL": "assets/tracedemo/txn13.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 10000,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "crqprscyfd",
            "imageURL": "assets/tracedemo/txn10.png",
          },
          {
            "source": 7,
            "target": 2,
            "amount": 79800,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "vqdgpfrbgz",
            "imageURL": "assets/tracedemo/dualentry3.png"
          },
          {
            "source": 3,
            "target": 2,
            "amount": 7500,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "ahjuxjktah",
            "imageURL": "assets/tracedemo/dualentry3.png"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 67000,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "glgfibrfvw"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 20300,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "ewcvbblmib"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 67000,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "vagymwoahd"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 20300,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "skgiegrwwj"
          },
          {
            "source": 5,
            "target": 6,
            "amount": 67000,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "cycecsvgeh",
            "imageURL": "assets/tracedemo/txn6.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 20300,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "zmtfknppxf",
            "imageURL": "assets/tracedemo/txn11.png",
          },
          {
            "source": 1,
            "target": 10,
            "amount": 55800,
            "sourceType": "source",
            "targetType": "deposit",
            "rtype": "skyrbrpboy"
          },
          {
            "source": 10,
            "target": 11,
            "amount": 55800,
            "sourceType": "source",
            "targetType": "deposit",
            "type": "skyrbrpaoy",
          },
          {
            "source": 11,
            "target": 5,
            "amount": 55800,
            "sourceType": "source",
            "targetType": "deposit",
            "type": "skyrbrpcoy",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 55800,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "mnmxlzouor",
            "imageURL": "assets/tracedemo/txn3.png",
          },
          {
            "source": 1,
            "target": 2,
            "amount": 10200,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "wavxjynrbc",
            "imageURL": "assets/tracedemo/dualentry1.png",
          },
          {
            "source": 1,
            "target": 2,
            "amount": 7500,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "bsspvvofmh",
            "imageURL": "assets/tracedemo/dualentry1.png",
          },
          {
            "source": 1,
            "target": 2,
            "amount": 150.6,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "dvnncxcoer",
            "imageURL": "assets/tracedemo/dualentry1.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 1920,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "hntrjwkwkq",
            "imageURL": "assets/tracedemo/dualentry1.png",
          },
          {
            "source": 2,
            "target": 4,
            "amount": 19770.6,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "xtnmkznclj"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 10000.0,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "jzrchlbirx"
          },
          {
            "source": 5,
            "target": 6,
            "amount": 10000.0,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "wicwnotgbh",
            "imageURL": "assets/tracedemo/txn8.png",
          },
          {
            "source": 8,
            "target": 9,
            "amount": 13842.65,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "discount",
            "rtype": "wjibnvejgs",
            "imageURL": "assets/tracedemo/dualentry6.png"
          },
          {
            "source": 9,
            "target": 2,
            "amount": 13842.65,
            "sourceType": "discount",
            "targetType": "invoice",
            "rtype": "wfkegsylph"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 17871.5,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "uilwrxrgab",
            "imageURL": "assets/tracedemo/dualentry6.png",
          },
          {
            "source": 3,
            "target": 2,
            "amount": 1787.15,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "pnvbthlrvy",
            "imageURL": "assets/tracedemo/dualentry6.png",
          },
          {
            "source": 2,
            "target": 4,
            "amount": 5816,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "lmpwrcoawm"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 5816,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "xdogzhzfti"
          },
          {
            "source": 5,
            "target": 6,
            "amount": 5816,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "sqfdqegoop",
            "imageURL": "assets/tracedemo/txn5.png",
          },
          {
            "source": 8,
            "target": 9,
            "amount": 2400,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "discount",
            "rtype": "sqbvurglil",
            "imageURL": "assets/tracedemo/dualentry4.png"
          },
          {
            "source": 9,
            "target": 2,
            "amount": 2400,
            "sourceType": "discount",
            "targetType": "invoice",
            "rtype": "mlkxcvobwf"
          },
          {
            "source": 3,
            "target": 2,
            "amount": 3800,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "xbbhncpxoo",
            "imageURL": "assets/tracedemo/dualentry4.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 38000,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "mutdnzyyei",
            "imageURL": "assets/tracedemo/dualentry4.png"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 29400,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "uuxzznvcvr"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 29400,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "wibnsdqnzy"
          },
          {
            "source": 5,
            "target": 6,
            "amount": 29400,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "gpmbkosexz",
            "imageURL": "assets/tracedemo/txn4.png",
          },
          {
            "source": 8,
            "target": 9,
            "amount": 4000,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "discount",
            "rtype": "syudogejgy",
            "imageURL": "assets/tracedemo/dualentry5.png"
          },
          {
            "source": 9,
            "target": 2,
            "amount": 4000,
            "sourceType": "discount",
            "targetType": "invoice",
            "rtype": "nnopqkssfd"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 10391,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "rqodqqbtkk",
            "imageURL": "assets/tracedemo/dualentry5.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 1496,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "bpovodjice",
            "imageURL": "assets/tracedemo/dualentry5.png",
          },
          {
            "source": 3,
            "target": 2,
            "amount": 4391,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "gubtesqybz",
            "imageURL": "assets/tracedemo/dualentry5.png"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 11887,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "rtgrszdhhc"
          },
          {
            "source": 4,
            "target": 12,
            "amount": 9770.80,
            "sourceType": "payment",
            "targetType": "badDebt",
            "rtype": "alqdexpole",
          },
          {
            "source": 4,
            "target": 12,
            "amount": 11887,
            "sourceType": "payment",
            "targetType": "badDebt",
            "rtype": "blqfexpolm"
          },
        ],
        "metadata": {
          "totalRevenue": "0",
          "totalDeposit": "0",
          "totalVerified": "0",
          "outstandingAR": "0"
        }
      };
    }


    function _getTraceDataByCustomer() {
      return {
        "nodes": [
          {
            "name": "Product Revenue",
            "amount": 198979.16,
            "id": 1,
            "type": "source"
          },
          {
            "name": "Invoice, FRB",
            "amount": 104413.36,
            "id": 2,
            "type": "invoice"
          },
          {
            "name": "Pmt, FRB",
            "amount": 60267.35,
            "id": 4,
            "type": "payment"
          },
          {
            "name": "Operating Acct (4794)",
            "amount": 219184.35,
            "id": 5,
            "type": "deposit"
          },
          {
            "name": "BofA Checking (4794)",
            "amount": 219184.35,
            "id": 6,
            "type": "evidence"
          },
          {
            "name": "Service Revenue",
            "amount": 79800,
            "id": 7,
            "type": "source"
          },
          {
            "name": "Tax Payable",
            "amount": 22041.45,
            "id": 3,
            "type": "taxOrRevenueDebitSource"
          },
          {
            "name": "Invoice, KwG",
            "amount": 87300,
            "id": 8,
            "type": "invoice"
          },
          {
            "name": "Pmt, KwG",
            "amount": 87300,
            "id": 9,
            "type": "payment"
          },
          {
            "name": "Invoice, National",
            "amount": 19770.6,
            "id": 10,
            "type": "invoice"
          },
          {
            "name": "Pmt, National",
            "amount": 19770.6,
            "id": 11,
            "type": "payment"
          },
          {
            "name": "Product Revenue - Debit",
            "amount": 20242.65,
            "id": 12,
            "type": "taxOrRevenueDebitSource"
          },
          {
            "name": "Discount, FTI ltd",
            "amount": 13842.65,
            "id": 13,
            "type": "discount"
          },
          {
            "name": "Invoice, FTI ltd",
            "amount": 33501.3,
            "id": 14,
            "type": "invoice"
          },
          {
            "name": "Pmt, FTI ltd",
            "amount": 5816,
            "id": 15,
            "type": "payment"
          },
          {
            "name": "Discount, FRB",
            "amount": 2400,
            "id": 16,
            "type": "discount"
          },
          {
            "name": "Discount, K Elliott",
            "amount": 4000,
            "id": 17,
            "type": "discount"
          },
          {
            "name": "Invoice, K Elliott",
            "amount": 20278,
            "id": 18,
            "type": "invoice"
          },
          {
            "name": "Pmt, K Elliott",
            "amount": 11887,
            "id": 19,
            "type": "payment"
          },
          {
            "name": "",
            "amount": 0,
            "id": 20,
            "type": "invoice",
            "hide": true,
            "flowStyle": "other",
          },
          {
            "name": "",
            "amount": 0,
            "id": 21,
            "type": "payment",
            "hide": true,
            "flowStyle": "other",
          },
          {
            "name": "Bad Debt",
            "amount": 21657.6,
            "id": 22,
            "type": "badDebt",
          },
        ],
        "links": [
          {
            "source": 1,
            "target": 2,
            "amount": 15000,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "axymfotivb",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 7500,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "haarvudsox",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 10200,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "asmxotdrra",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 22950.06,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "iizycjqfob",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 3,
            "target": 2,
            "amount": 946.05,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "ozmntbpizs",
            "imageURL": "assets/tracedemo/dualentry2.png"
          },
          {
            "source": 3,
            "target": 2,
            "amount": 3617.25,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "pttlpapfdh",
            "imageURL": "assets/tracedemo/dualentry2.png",
          },
          {
            "source": 2,
            "target": 4,
            "amount": 11604.47,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "dbhxdvpfxg"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "ucgdqsznbm"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "bcykrpmdhi"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "garxgmkdmq"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 2315.72,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "xdpyvmjwho"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 10000,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "lvoupjlcll"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 11604.47,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "qeqmchjyey"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "jwvpdirilr"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "lgxbezfzre"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "hvsmekeuwm"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 2315.72,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "kpkqwyyqmn"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 10000,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "tnwkpviwsn"
          },
          {
            "source": 5,
            "target": 6,
            "amount": 11604.47,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "adxguabnhs",
            "imageURL": "assets/tracedemo/txn9.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "pdxeqvnhok",
            "imageURL": "assets/tracedemo/txn1.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "uzhvkzxlez",
            "imageURL": "assets/tracedemo/txn7.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "furhwxthyq",
            "imageURL": "assets/tracedemo/txn12.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 2315.72,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "ydblgnktkv",
            "imageURL": "assets/tracedemo/txn13.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 10000,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "hvnipsqpwx",
            "imageURL": "assets/tracedemo/txn10.png",
          },
          {
            "source": 7,
            "target": 8,
            "amount": 79800,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "fjowdqlfxy",
            "imageURL": "assets/tracedemo/dualentry3.png"
          },
          {
            "source": 3,
            "target": 8,
            "amount": 7500,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "icnolifhqc",
            "imageURL": "assets/tracedemo/dualentry3.png"
          },
          {
            "source": 8,
            "target": 9,
            "amount": 67000,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "bmpuuutmhj"
          },
          {
            "source": 8,
            "target": 9,
            "amount": 20300,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "ligmaaxcwa"
          },
          {
            "source": 9,
            "target": 5,
            "amount": 67000,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "ijvqwpinta"
          },
          {
            "source": 9,
            "target": 5,
            "amount": 20300,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "icfzyzettm"
          },
          {
            "source": 5,
            "target": 6,
            "amount": 67000,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "fwaytpngas",
            "imageURL": "assets/tracedemo/txn6.png",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 20300,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "glnaylblut",
            "imageURL": "assets/tracedemo/txn11.png",
          },
          {
            "source": 1,
            "target": 20,
            "amount": 55800,
            "sourceType": "source",
            "targetType": "deposit",
            "rtype": "bhpzvhemxm",
          },
          {
            "source": 20,
            "target": 21,
            "amount": 55800,
            "sourceType": "source",
            "targetType": "deposit",
            "rtype": "ahpzvhemxm",
          },
          {
            "source": 21,
            "target": 5,
            "amount": 55800,
            "sourceType": "source",
            "targetType": "deposit",
            "rtype": "chpzvhemxm",
          },
          {
            "source": 5,
            "target": 6,
            "amount": 55800,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "ubjoviueng",
            "imageURL": "assets/tracedemo/txn3.png",
          },
          {
            "source": 1,
            "target": 10,
            "amount": 10200,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "wkljblcmmo",
            "imageURL": "assets/tracedemo/dualentry1.png"
          },
          {
            "source": 1,
            "target": 10,
            "amount": 7500,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "qcnzepjsnw",
            "imageURL": "assets/tracedemo/dualentry1.png"
          },
          {
            "source": 1,
            "target": 10,
            "amount": 150.6,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "wnyfitdlxf",
            "imageURL": "assets/tracedemo/dualentry1.png",
          },
          {
            "source": 1,
            "target": 10,
            "amount": 1920,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "tytckdgmpj",
            "imageURL": "assets/tracedemo/dualentry1.png"
          },
          {
            "source": 10,
            "target": 11,
            "amount": 19770.6,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "mhdacuxkol"
          },
          {
            "source": 11,
            "target": 5,
            "amount": 10000,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "ogfmttxzan"
          },
          {
            "source": 11,
            "target": 22,
            "amount": 9770.6,
            "sourceType": "payment",
            "targetType": "badDebt",
            "rtype": "omfgtarzan"
          },
          {
            "source": 5,
            "target": 6,
            "amount": 10000,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "mtrmqndubk",
            "imageURL": "assets/tracedemo/txn8.png",
          },
          {
            "source": 12,
            "target": 13,
            "amount": 13842.65,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "discount",
            "rtype": "gpgdduotjp",
            "imageURL": "assets/tracedemo/dualentry6.png",
          },
          {
            "source": 13,
            "target": 14,
            "amount": 13842.65,
            "sourceType": "discount",
            "targetType": "invoice",
            "rtype": "ltptwkhjlt",
          },
          {
            "source": 1,
            "target": 14,
            "amount": 17871.5,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "ehmoonkyux",
            "imageURL": "assets/tracedemo/dualentry6.png",
          },
          {
            "source": 3,
            "target": 14,
            "amount": 1787.15,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "vauanuziqt",
            "imageURL": "assets/tracedemo/dualentry6.png"
          },
          {
            "source": 14,
            "target": 15,
            "amount": 5816,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "vsmmewkuvd"
          },
          {
            "source": 15,
            "target": 5,
            "amount": 5816,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "lsjbgevyty"
          },
          {
            "source": 5,
            "target": 6,
            "amount": 5816,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "dciudnjihn",
            "imageURL": "assets/tracedemo/txn5.png",
          },
          {
            "source": 12,
            "target": 16,
            "amount": 2400,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "discount",
            "rtype": "kypxsrzxjs",
            "imageURL": "assets/tracedemo/dualentry4.png"
          },
          {
            "source": 16,
            "target": 2,
            "amount": 2400,
            "sourceType": "discount",
            "targetType": "invoice",
            "rtype": "pxupzijwxv"
          },
          {
            "source": 3,
            "target": 2,
            "amount": 3800,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "jnmzcrhqsi",
            "imageURL": "assets/tracedemo/dualentry4.png"
          },
          {
            "source": 1,
            "target": 2,
            "amount": 38000,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "imrxcsyubs",
            "imageURL": "assets/tracedemo/dualentry4.png"
          },
          {
            "source": 2,
            "target": 4,
            "amount": 29400,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "hhyvkbimts"
          },
          {
            "source": 4,
            "target": 5,
            "amount": 29400,
            "sourceType": "payment",
            "targetType": "deposit",
            "rtype": "utjeuavvox"
          },
          {
            "source": 5,
            "target": 6,
            "amount": 29400,
            "sourceType": "deposit",
            "targetType": "evidence",
            "rtype": "uqnhkruzhi",
            "imageURL": "assets/tracedemo/txn4.png",
          },
          {
            "source": 12,
            "target": 17,
            "amount": 4000,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "discount",
            "rtype": "wznyklvltt",
            "imageURL": "assets/tracedemo/dualentry5.png"
          },
          {
            "source": 17,
            "target": 18,
            "amount": 4000,
            "sourceType": "discount",
            "targetType": "invoice",
            "rtype": "ohlnrpnrij"
          },
          {
            "source": 1,
            "target": 18,
            "amount": 10391,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "dzudyxmlib",
            "imageURL": "assets/tracedemo/dualentry5.png"
          },
          {
            "source": 1,
            "target": 18,
            "amount": 1496,
            "sourceType": "source",
            "targetType": "invoice",
            "rtype": "cypxgpvoyy",
            "imageURL": "assets/tracedemo/dualentry5.png"
          },
          {
            "source": 3,
            "target": 18,
            "amount": 4391,
            "sourceType": "taxOrRevenueDebitSource",
            "targetType": "invoice",
            "rtype": "cjolzzeobz",
            "imageURL": "assets/tracedemo/dualentry5.png"
          },
          {
            "source": 18,
            "target": 19,
            "amount": 11887,
            "sourceType": "invoice",
            "targetType": "payment",
            "rtype": "cbqzivybug"
          },
          {
            "source": 19,
            "target": 22,
            "amount": 11887,
            "sourceType": "payment",
            "targetType": "badDebt",
            "rtype": "vkypdngzkn"
          },
        ],
        "metadata": {
          "totalRevenue": "0",
          "totalDeposit": "0",
          "totalVerified": "0",
          "outstandingAR": "0"
        }
      };
    }

    function refresh() {
      $state.reload();
    }
  }
})();

(function() {
  'use strict';

  TraceTableController.$inject = ["$filter", "$scope", "$state", "$stateParams", "$mdDialog", "tableUtils", "Authorization", "ErpCjTraces", "ErpGlTraceTransactions", "RBAC", "PROJECT_TYPES"];
  angular
    .module('projects')
    .component('traceTable', {
      templateUrl: 'app/projects/engagement/trace/trace-table.html',
      bindings: {
        refresh: '&',
      },
      controller: TraceTableController
    });

  function TraceTableController(
    $filter,
    $scope,
    $state,
    $stateParams,
    $mdDialog,
    tableUtils,
    Authorization,
    ErpCjTraces,
    ErpGlTraceTransactions,
    RBAC,
    PROJECT_TYPES) {
    var vm = this;
    var GRID_ID = 'grid-trace';
    var GRID_VERSION = 4;
    vm.filter = filter;
    vm.reloadData = reloadData;

    this.$onInit = function() {
      vm.projectId = $state.params.projectId;
      vm.hasPermissions = Authorization.hasProjectAccess(PROJECT_TYPES.AUDIT, vm.projectId, [RBAC.ROLES.ENGAGEMENT_OWNER, RBAC.ROLES.ENGAGEMENT_USER], [RBAC.ROLES.ENGAGEMENT_OWNER]);
      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.filterData = {glTxId: ''};
      if ($state.params.glTxId) {
        vm.filterData.glTxId = $state.params.glTxId;
      }

      vm.actionColumns = [
        {
          headerName: 'Transaction',
          field: 'salesTxn',
          sortable: false,
        },
        {
          headerName: 'Date',
          field: 'date',
          sortable: false,
        },
        {
          headerName: 'Amount',
          field: 'value',
          sortable: false,
        },
        /*
        {
          headerName: 'Apld Value',
          field: 'appliedValue',
        },
        */
        {
          headerName: 'Entry ID',
          field: 'entryId',
          sortable: false,
        },
        /*
        {
          headerName: 'Link-GL',
          field: 'linkGl',
        },
        {
          headerName: 'Link-GLAR',
          field: 'linkGlAr',
        },
        {
          headerName: 'Link-AR',
          field: 'linkAr',
        },
        {
          headerName: 'Bank-ERP',
          field: 'bankErp',
        },
        {
          headerName: 'Txn Src',
          field: 'txnSrc',
        },
        */
        {
          headerName: 'Ledger',
          field: 'type',
          sortable: false,
        },
        {
          headerName: 'Category',
          field: 'category',
          sortable: false,
        },
        {
          headerName: 'Subcategory',
          field: 'subcategory',
          sortable: false,
        },
        {
          headerName: 'Account',
          field: 'account',
          sortable: false,
        },
        {
          headerName: 'Statement',
          field: 'statement',
          sortable: false,
        },
        {
          headerName: 'Line Source',
          field: 'lineSource',
          sortable: false,
        },
        {
          headerName: 'Line Description',
          field: 'lineDescription',
          sortable: false,    
        },
        {
          headerName: 'Header Source',
          field: 'headerSource',
          sortable: false,
        },
        {
          headerName: 'Header Description',
          field: 'headerDescription',
          sortable: false,      
        },
        {
          headerName: 'Customer',
          field: 'customer',
          sortable: false,
        },
        {
          headerName: 'Doc ID',
          field: 'docId',
          sortable: false,
        },
        {
          headerName: 'Cust Doc ID',
          field: 'customerDocId',
          sortable: false,
        },
      ];

      tableUtils.setColumnSort(vm.pagination, vm.actionColumns);

      vm.gridOptions = {
        cacheBlockSize: vm.pagination.pageSize,
        columnDefs: vm.actionColumns,
        defaultColDef: tableUtils.getDefaultColDefs(),
        angularCompileRows: true,
        treeData: true,
        animateRows: true,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        onSortChanged: vm.reloadData,
        getMainMenuItems: tableUtils.getMainMenuItems,
        rowModelType: 'serverSide',
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange,
        autoGroupColumnDef: {
          suppressMovable: true,
          pinned: 'left',
          width: 50,
          headerName: '',
          sortable: false,
          cellRendererParams: {
            innerRenderer: function() { return ''; }
          }
        },
        isServerSideGroup: function(dataItem) {
          return dataItem.group;
        },
        getServerSideGroupKey: function(dataItem) {
          return dataItem.id;
        },
        getRowClass: function(params) {
          if (params && params.data) {
            if (params.data.childType === 'trace' || params.data.rowType === 'trace') {
              return 'ag-row-trace';
            } else if (params.data.childType === 'cashJournal' || params.data.rowType === 'cashJournal') {
              return 'ag-row-cashjournal';
            } else if (params.data.childType === 'associations' || params.data.rowType === 'associatedTxn') {
              return 'ag-row-associatedgl';
            }
          }
        },
      };
    };

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID, GRID_VERSION);
      vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      if(!tableUtils.getGridState(GRID_ID, GRID_VERSION)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID, GRID_VERSION);
    }

    function filter() {
      vm.gridOptions.api.purgeServerSideCache([]);
    }

    function reloadData() {
      var sortModel = vm.gridOptions.api.getSortModel();
      if(sortModel.length) {
        vm.pagination.sortModel = sortModel[0].colId;
        vm.pagination.sortOrder = sortModel[0].sort;
      } else {
        vm.pagination.sortModel = 'date';
        vm.pagination.sortOrder = 'asc';
      }
      vm.pagination.skipCount = 0;
      var params = Object.assign({}, vm.pagination);
      if (vm.filterData && vm.filterData.glTxId) {
        params.glTxId = vm.filterData.glTxId;
      }
      $state.go($state.current, params);
    }

    function _fetchAssociated(associatedItems, id, source) {
      var i;
      if (source === 'GeneralLedger') { 
        for (i = 0; i < associatedItems.glTraceTxns.length; i++) {
          if (associatedItems.glTraceTxns[i].id === id) {
            return associatedItems.glTraceTxns[i];
          }
        }
        // TODO: log that we didn't find it
      } else if (source === 'AccountsReceivable') {
        for (i = 0; i < associatedItems.arTraceTxns.length; i++) {
          if (associatedItems.arTraceTxns[i].id === id) {
            return associatedItems.arTraceTxns[i];
          }
        }
        // TODO: log that we didn't find it
      } else if (source === 'AccountsPayable') {
        for (i = 0; i < associatedItems.apTraceTxns.length; i++) {
          if (associatedItems.apTraceTxns[i].id === id) {
            return associatedItems.apTraceTxns[i];
          }
        }
        // TODO: Log that we didn't find it
      } else {
        // TODO Log this anomaly
      }
      return null;
    }
    
    function _determineType( instr ) {
      if ( instr == "GeneralLedger" ) {
        return "GL";
      } else if ( instr == "AccountsPayable" ) {
        return "AP";
      } else if ( instr == "AccountsReceivable" ) {
        return "AR";
      } else {
        return "?";
      }
    }

    function  _upperFirst( s ) {
      if (typeof s !== 'string') return '?';
      return s.charAt(0).toUpperCase() + s.slice(1);
    }

    function _createDatasource() {
      return {
        getRows: function(params) {
          // Loading new rows
          var row;
          var rows = [];
          if(params.request.groupKeys.length === 0 ) {
            if (!vm.pagination.sortModel) {
              vm.pagination.sortModel = 'id'; // TODO: What should we be sorting by?
              vm.pagination.sortOrder = 'asc';
            }
            vm.pagination.skipCount = params.request.startRow;
            var traceParams = angular.extend({projectId: vm.projectId}, tableUtils.formatPagingParams(vm.pagination));
            if (vm.filterData && vm.filterData.glTxId) {
              traceParams.glTxId = vm.filterData.glTxId;
            }
            ErpCjTraces.findAll(traceParams).then(function(traces) {
              if (!traces) {
                // TODO error handling
              }
              var i, j;
              for (i = 0; i < traces.length; i++) {
                var trace = traces[i];
                var hasGlTraceTxn = false;
                if ( trace.associatedItems && Array.isArray(trace.associatedItems.glTraceTxns) ) {
                  for (j = 0; j < trace.associatedItems.glTraceTxns.length; j++) {
                    var txn = trace.associatedItems.glTraceTxns[j];
                    if (txn.id === trace.glTransactionId) {
                      hasGlTraceTxn = true;
                      row = {
                        id: trace.id,
                        group: true,
                        salesTxn: txn.data.account.categoryName + " : " + txn.data.account.name,
                        value: txn.amount,
                        date: txn.date,
                        entryId: txn.glTxId,
                        category: _upperFirst(txn.data.account.categoryName),
                        subcategory: txn.data.account.categoryTag,
                        account: txn.data.account.name,
                        statement: txn.sheetLabel,
                        lineSource: txn.lineSource,
                        lineDescription: txn.lineDescription,
                        headerSource: txn.headerSource,
                        headerDescription: txn.headerDescription,
                        trace: trace,
                        type: _determineType(trace.source),
                        childType: 'submenu',
                      };
                      rows.push(row);
                      break;
                    }
                  }
                  if (!hasGlTraceTxn) {
                    // Not sure if there's any more we can do here...
                  }
                }
              }
              params.successCallback(rows, ErpCjTraces.getMetadata().total);
            });
          } else if (params.parentNode && params.parentNode.data) {
            // expanding additional rows
            const childType = params.parentNode.data.childType;
            var trace = params.parentNode.data.trace;
            var i = 0;
            if (childType === 'trace') {
              for (i = 0; i < trace.trace.Next.length; i++) {
                const thisTrace = trace.trace.Next[i];
                const thisTraceObj = _fetchAssociated(trace.associatedItems, thisTrace.UUID, thisTrace.Source);
                const hasChildren = Array.isArray(thisTrace.Next) && thisTrace.Next.length > 0;
                row = {
                  id: thisTraceObj.id,
                  salesTxn: _upperFirst(thisTrace.BaseType),
                  entryId: thisTrace.LinkID,
                  group: hasChildren,
                  date: thisTraceObj.date,
                  value: thisTrace.Amount,
                  apldValue: thisTrace.Amount != thisTrace.AppliedAmount ? thisTrace.AppliedAmount : null,
                  category: _upperFirst(thisTraceObj.data.account ? thisTraceObj.data.account.categoryName : ''),
                  subcategory: (thisTraceObj.data.account ? thisTraceObj.data.account.categoryTag : ''),
                  account: (thisTraceObj.data.account ? thisTraceObj.data.account.name : ''),
                  lineSource: thisTraceObj.data.lineSource,
                  statement: thisTraceObj.data.sheetLabel,
                  headerSource: thisTraceObj.data.headerSource,
                  headerDescription: thisTraceObj.data.headerDescription,
                  docId: thisTraceObj.data.docId,
                  customer: (thisTraceObj.data.customer ? thisTraceObj.data.customer.name : ''),
                  customerDocId: (thisTraceObj.data.customer ? thisTraceObj.data.customer.docId : ''),
                  type: _determineType(thisTrace.Source),
                  // This provides context for the child rows to draw correctly
                  trace: {id: trace.id, associatedItems: trace.associatedItems, trace: {Next: trace.trace.Next[i].Next}},
                  childType: 'trace',
                  rowType: 'trace',
                };
                rows.push(row);
              }
              params.successCallback(rows, rows.length);
            } else if(childType === 'cashJournal') {
              const endpoints = trace.trace.Endpoints;
              for (i = 0; i < endpoints.length; i++) {
                for(var j = 0; j < endpoints[i].length; j++) {
                  const endpointObj = _fetchAssociated(trace.associatedItems, endpoints[i][j].UUID, endpoints[i][j].Source);
                  row = {
                    id: endpoints[i][j].UUID,
                    value: endpoints[i][j].Amount,
                    salesTxn: _upperFirst(endpointObj.data.account ? endpointObj.data.account.categoryName + " : " + endpointObj.data.account.name : ''),
                    date: endpointObj.date,
                    entryId: endpointObj.glTxId,
                    type: endpoints[i][j].Source,
                    category: _upperFirst(endpointObj.data.account ? endpointObj.data.account.categoryName : ''),
                    subcategory: (endpointObj.data.account ? endpointObj.data.account.categoryTag : ''),
                    account: (endpointObj.data.account ? endpointObj.data.account.name : ''),
                    lineSource: endpointObj.data.lineSource,
                    lineDescription: endpointObj.data.lineDescription,
                    statement: endpointObj.data.sheetLabel,
                    headerSource: endpointObj.data.headerSource,
                    headerDescription: endpointObj.data.headerDescription,
                    rowType: 'cashJournal',
                  };
                  rows.push(row);
                }
              }
              params.successCallback(rows, rows.length);
            } else if(childType === 'associations') {
              if (trace.trace.Associated && Array.isArray(trace.trace.Associated)) {
                for (i = 0; i < trace.trace.Associated.length; i++) {
                  var txnId = trace.trace.Associated[i];
                  if (txnId !== trace.glTransactionId) {
                    var txn = _fetchAssociated(trace.associatedItems, txnId, "GeneralLedger");
                    row = {
                      id: txn.id,
                      group: false,
                      salesTxn: _upperFirst(txn.data.account.categoryName + " : " + txn.data.account.name),
                      value: txn.amount,
                      date: txn.date,
                      entryId: txn.glTxId,
                      category: _upperFirst(txn.data.account.categoryName),
                      subcategory: txn.data.account.categoryTag,
                      account: txn.data.account.name,
                      statement: txn.sheetLabel,
                      lineSource: txn.lineSource,
                      lineDescription: txn.lineDescription,
                      headerSource: txn.headerSource,
                      headerDescription: txn.headerDescription,
                      trace: trace,
                      type: _determineType(trace.source),
                      rowType: 'associatedTxn',
                    };
                    rows.push(row);
                  }
                }
              }
              params.successCallback(rows, rows.length);
            } else if (childType === 'submenu') {
              // First time opening the row -> fetch the full trace now(bulk traces, fetched with findAll(), don't have all the data)
              var parentId = params.parentNode.data.id;
              ErpCjTraces.find(parentId).then(function(fullTrace) {
                rows.push({id: fullTrace.id + ".associations", salesTxn: 'Associations', group: true, trace: fullTrace, childType: 'associations'});
                rows.push({id: fullTrace.id + ".trace", salesTxn: 'Trace', group: true, trace: fullTrace, childType: 'trace'});
                rows.push({id: fullTrace.id + ".cashJournal", salesTxn: 'Cash Journal', group: true, trace: fullTrace, childType: 'cashJournal'});
                params.successCallback(rows, rows.length);
              });
            }
          }
        }
      };
    }
  }
})();

(function() {
  'use strict';

  ErpGlTraceTransactions.$inject = ["DS"];
  angular
    .module('projects')
    .factory('ErpGlTraceTransactions', ErpGlTraceTransactions);

  function ErpGlTraceTransactions(DS) {
    var metadata;
    var erpGlTraceTransactions = DS.defineResource({
      name: 'erpGlTraceTransactions',
      endpoint: 'erp-gl-trace-transactions',
      idAttribute: 'id',
      cacheResponse: false,
      deserialize: function(config, res) {
        metadata = res.data.metadata;
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    erpGlTraceTransactions.getMetadata = function() {
      return metadata;
    };

    return erpGlTraceTransactions;
  }
})();

(function() {
  'use strict';

  ErpCjTraces.$inject = ["DS"];
  angular
    .module('projects')
    .factory('ErpCjTraces', ErpCjTraces);

  function ErpCjTraces(DS) {
    var metadata;
    var erpCjTraces = DS.defineResource({
      name: 'erpCjTraces',
      endpoint: 'erp-cj-traces',
      idAttribute: 'id',
      cacheResponse: false,
      deserialize: function(config, res) {
        metadata = res.data.metadata;
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    erpCjTraces.getMetadata = function() {
      return metadata;
    };

    return erpCjTraces;
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "PROJECT_TYPES", "STATEMENTS"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider, PROJECT_TYPES, STATEMENTS) {
    $stateProvider
      .state('engagement.statements', {
        url: '/statements?pageSize&sortOrder&sortModel&keyword&statementId&status&source',
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/project/documents/statements/statements.html',
            controller: 'StatementsController as $ctrl'
          }
        },
        data: {
          projectType: PROJECT_TYPES.AUDIT
        },
        resolve: {
          statements: ["$stateParams", "Statements", function($stateParams, Statements) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            // Set Default sort params
            if(!$stateParamsClone.status) {
              $stateParamsClone.status = 'all-files';
            }
            if( !$stateParamsClone.source ) {
              $stateParamsClone.source = STATEMENTS.SOURCE.BANK_PDF;
            }
            if(!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'createdAt';
              $stateParamsClone.sortOrder = 'desc';
            }
            var params = {projectId: $stateParamsClone.projectId, downloadUrl: true, $limit: 5000};
            params.source = $stateParamsClone.source;
            if($stateParamsClone.status !== 'all-files') {
              params.status = $stateParamsClone.status;
            }
            return Statements.findAll(params, {bypassCache: true});
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  Reconciliations.$inject = ["DS", "RECONCILIATIONS"];
  angular
    .module('projects')
    .factory('Reconciliations', Reconciliations);

  function Reconciliations(DS, RECONCILIATIONS) {
    var LOADING_STATUSES = [
      RECONCILIATIONS.STATUS.STARTED,
      RECONCILIATIONS.STATUS.LOADING,
      RECONCILIATIONS.STATUS.MATCHING,
      RECONCILIATIONS.STATUS.IMPORTING
    ];
    var metadata;
    var reconciliations = DS.defineResource({
      name: 'reconciliations',
      endpoint: 'reconciliations',
      idAttribute: 'id',
      cacheResponse: false,
      deserialize: function(config, res) {
        metadata = res.data.metadata;
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    reconciliations.getMetadata = function() {
      return metadata;
    };

    reconciliations.isLoading = function(status) {
      return status ? LOADING_STATUSES.indexOf(status) >= 0 : false;
    };

    return reconciliations;
  }
})();

(function() {
  'use strict';

  ReconciliationsListTableController.$inject = ["$state", "$scope", "$mdDialog", "tableUtils", "toastr", "$filter", "RECONCILIATIONS", "reconciliationUtils"];
  angular
    .module('projects')
    .component('reconciliationsListTable', {
      templateUrl: 'app/projects/engagement/reconciliations/reconciliations-list.html',
      bindings: {
        reconciliations: '<'
      },
      controller: ReconciliationsListTableController
    });

  function ReconciliationsListTableController(
    $state,
    $scope,
    $mdDialog,
    tableUtils,
    toastr,
    $filter,
    RECONCILIATIONS,
    reconciliationUtils){
    var vm = this;

    this.$onInit = function() {
      vm.columnDefs = [
        {
          headerName: 'Match Status',
          field: 'status',
          sortable: false,
          width:200,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            return '<reconciliation-status-sync status="data.status" reconciliation-id="data.id"></reconciliation-status-sync>';
          }
        },
        {
          headerName: 'Inflow Coverage - CJ',
          field: 'data',
          sortable: false,
          suppressMovable: true,
          valueFormatter: function(params) {
            var coverage = params.data.status === RECONCILIATIONS.STATUS.RECONCILED ? 1 : reconciliationUtils.getCjInflowCoverage(params.value);
            return $filter('percentageDisplay')(coverage);
          }
        },
        {
          headerName: 'Inflow Coverage - Bank',
          field: 'data',
          sortable: false,
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('percentageDisplay')(reconciliationUtils.getBankInflowCoverage(params.value));
          }
        },
        {
          headerName: 'Reconciled',
          width: 100,
          field: 'status',
          sortable: false,
          suppressMovable: true,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            var rec = params.value === RECONCILIATIONS.STATUS.RECONCILED ? 
              '<md-icon class="material-icons icon-primary check">check</md-icon>' : '<md-icon class="material-icons">close</md-icon>';
            return rec;
          }
        },
        {
          headerName: 'Match Date',
          field: 'createdAt',
          width: 150,
          sortable: false,
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Period Start',
          field: 'startDate',
          width: 150,
          sortable: false,
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Period End',
          field: 'endDate',
          width: 150,
          sortable: false,
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('dateDisplay')(params.value);
          }
        }
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowData: vm.reconciliations,
        angularCompileRows: true,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        getMainMenuItems: tableUtils.getMainMenuItems,
        onGridReady: function(params) { _adjustSize(params); },
        onGridSizeChanged: function(params) { _adjustSize(params); }
      };
    };

    function _adjustSize(params) {
      params.api.sizeColumnsToFit();
      params.api.setDomLayout('autoHeight');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('projects')
    .factory('reconciliationUtils', reconciliationUtils);

  function reconciliationUtils() {
    return {
      getCjInflowCoverage: getCjInflowCoverage,
      getBankInflowCoverage: getBankInflowCoverage
    };

    function getCjInflowCoverage(metrics) {
      if(!metrics || !metrics.cj || !metrics.cj.all || metrics.cj.all.inflows <= 0) {
        return 0;
      }
      return parseFloat( (metrics.cj.matchedInPeriod.inflows + metrics.cj.matchedNextPeriod.inflows) / metrics.cj.all.inflows);
    }

    function getBankInflowCoverage(metrics) {
      if(!metrics || !metrics.cj || !metrics.bank.all || metrics.bank.all.inflows <= 0) {
        return 0;
      }
      return parseFloat( (metrics.bank.matchedInPeriod.inflows + metrics.bank.matchedNextPeriod.inflows) / metrics.bank.all.inflows);
    }

  }
})();

(function() {
  'use strict';

  CreateReconciliationController.$inject = ["$mdDialog", "$state", "$timeout", "toastr", "Reconciliations"];
  angular
    .module('projects')
    .controller('CreateReconciliationController', CreateReconciliationController);

  function CreateReconciliationController(
    $mdDialog,
    $state,
    $timeout,
    toastr,
    Reconciliations) {

    var vm = this;
    vm.createReconciliation = createReconciliation;

    activate();

    function activate() {
      vm.reconciliation = {
        projectId: $state.params.projectId,
        startDate: null,
        endDate: null
      };
    }

    function createReconciliation(){
      if(vm.reconciliation) {
        var startDate = moment(vm.reconciliation.startDate);
        var endDate = moment(vm.reconciliation.endDate);
        if (startDate.isValid() && endDate.isValid() && startDate.isBefore(endDate) ){
          Reconciliations.create(vm.reconciliation)
            .then(function Success() {
              toastr.success('Matching process started.');
              $mdDialog.hide();
              $timeout( function(){
                $state.reload();
              }, 1000);
            })
            .catch(function Failure(response) {
              toastr.error(response.data.message);
              $mdDialog.hide();
            });
        } else {
          vm.errorMessage = 'Invalid date range';
        }
      }
    }
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('engagement.reconcile', {
        url: '/reconcile?startDate&endDate&transRangeLow&transRangeHigh&transRangeAbs&flow&keyword&pageSize&sortOrder&sortModel&sourceType&cjOnly&reconciled&unmatched&transactionIds&adjustmentId',
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/engagement/reconcile/reconcile.html',
            controller: 'ReconcileController as $ctrl'
          }
        },
        resolve: {
          reconciliations: ["$stateParams", "Reconciliations", function($stateParams, Reconciliations){
            return Reconciliations.findAll({projectId: $stateParams.projectId});
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  ReconcileController.$inject = ["$scope", "$state", "$mdDialog", "RECONCILIATIONS", "reconciliations", "transactionUtils", "tableUtils", "Transactions", "Reconciliations", "Projects", "dateUtils"];
  angular
    .module('projects')
    .controller('ReconcileController', ReconcileController);

  function ReconcileController(
    $scope,
    $state,
    $mdDialog,
    RECONCILIATIONS,
    reconciliations,
    transactionUtils,
    tableUtils,
    Transactions,
    Reconciliations,
    Projects,
    dateUtils) {
    var vm = this,
      filterDataCopy;

    vm.applyFilter = applyFilter;
    vm.openDeleteAdjustmentDialog = openDeleteAdjustmentDialog;
    vm.expandCollapse = expandCollapse;
    vm.showAdjustment = showAdjustment;
    vm.expanded = {
      matching: true,
      adjustment: true
    };

    activate();

    function activate() {
      vm.reconciliation = reconciliations[0];
      vm.reconciliationReady = vm.reconciliation ? !Reconciliations.isLoading(vm.reconciliation.status) : false;
      vm.transactionsLoaded = false;
      vm.isViewAdjustment = $state.params.adjustmentId ? true : false;
      if(vm.reconciliationReady) {
        _fetchTransactions();
        _setReconciliationData();
        vm.isReconciled = vm.reconciliation.status === RECONCILIATIONS.STATUS.RECONCILED;
      }
      vm.entities = [];
      vm.accounts = [];
      vm.project = Projects.get($state.params.projectId);
    }

    function expandCollapse(section){
      vm.expanded[section] = !vm.expanded[section];
    }

    function applyFilter() {
      if(!angular.equals(vm.filterData, filterDataCopy)) {
        var params;
        params = dateUtils.formatUrlDates(angular.copy(vm.filterData));
        params.projectId = $state.params.projectId;
        $state.go('engagement.reconcile', params, {inherit: false});
      }
    }

    function showAdjustment(adjustment) {
      var params;
      params = dateUtils.formatUrlDates(angular.copy(vm.filterData));
      params.projectId = $state.params.projectId;
      params.reconciled = true;
      if(!adjustment) {
        params.adjustmentId = vm.manualAdj.id;
        params.transactionIds = vm.manualAdj.filters.transactionIds;
        params.keyword = "";
        if(!params.transactionIds || params.transactionIds.length < 1) {
          return;
        }
      } else {
        params.adjustmentId = adjustment.id;
        params.transactionIds = "";
        params.keyword = adjustment.filters.keyword;
        params.enableFilters = false;
      }
      $state.go('engagement.reconcile', params, {inherit: false});
    }

    function openDeleteAdjustmentDialog(adjustment) {
      $mdDialog.show({
        templateUrl: 'app/projects/engagement/adjustments/delete-adjustment-dialog.html',
        controller: 'DeleteAdjustmentController',
        locals: {
          adjustment: adjustment
        },
        controllerAs: '$ctrl',
        bindToController: true
      });
    }

    //Cannot load transactions on router because we depend on reconciliation parameters.
    function _fetchTransactions() {
      vm.transactionsLoaded = false;
      var $stateParamsClone = Object.assign({}, $state.params);
      if(!$stateParamsClone.sortModel) {
        $stateParamsClone.sortModel = 'date';
        $stateParamsClone.sortOrder = 'asc';
      }
      $stateParamsClone.sourceType = $stateParamsClone.sourceType || 'erp';
      $stateParamsClone.reconciled = $stateParamsClone.reconciled || 'false';
      $stateParamsClone.unmatched = 'true';  //Only fetch unmatched transactions
      $stateParamsClone.transRangeAbs = $stateParamsClone.transRangeAbs || 'true';
      $stateParamsClone.startDate = $stateParamsClone.startDate || vm.reconciliation.startDate;
      $stateParamsClone.endDate = $stateParamsClone.endDate || vm.reconciliation.endDate;
      $stateParamsClone.cjOnly = 'true';
      $stateParamsClone.minStartDate = vm.reconciliation.startDate;
      $stateParamsClone.maxEndDate = vm.reconciliation.endDate;
      $stateParamsClone.enabledAccounts = 'true';

      var pagingParams = tableUtils.formatPagingParams($stateParamsClone, true);
      var params = angular.extend({ downloadUrl: true }, transactionUtils.formatFilterParams($stateParamsClone), pagingParams);

      Transactions.findAllPOST(params).then(function Success(data) {
        vm.transactions = data;
        vm.transMetadata = Transactions.getMetadata();
        vm.filterData = transactionUtils.getFilterData($stateParamsClone);
        filterDataCopy = angular.copy(vm.filterData);
        vm.transactionsLoaded = true;
      }).catch(function() {
        vm.error = true;
      });
    }

    function _setReconciliationData() {
      vm.adjustments = [];
      var totalAdjInflows = 0;
      var totalAdjOutflows = 0;
      vm.reconciliation.data.cj.subtotal = {};
      vm.reconciliation.data.cj.unAdjustedTotal = {};
      vm.reconciliation.data.cj.adjustedTotal = {};
      vm.reconciliation.data.bank.subtotal = {};
      vm.reconciliation.data.bank.unAdjustedTotal = {};

      vm.reconciliation.data.verifiedVariance = {};
      vm.reconciliation.data.notVerifiedVariance = {};
      vm.reconciliation.data.subtotalVariance = {};
      vm.reconciliation.data.subsequentVariance = {};
      vm.reconciliation.data.unAdjustedVariance = {};
      vm.reconciliation.data.adjustedVariance = {};
      vm.reconciliation.data.adjustedVariancePercentage = {};

      _.forEach(vm.reconciliation.adjustments, function(a) {
        totalAdjInflows += a.result.inflows;
        totalAdjOutflows += a.result.outflows;
        if(a.isDefault) {
          vm.manualAdj = a;
        } else {
          vm.adjustments.push(a);
        }
      });

      vm.reconciliation.data.cj.subtotal.inflows = vm.reconciliation.data.cj.matchedInPeriod.inflows + vm.reconciliation.data.cj.unmatched.inflows;
      vm.reconciliation.data.cj.unAdjustedTotal.inflows = vm.reconciliation.data.cj.subtotal.inflows + vm.reconciliation.data.cj.matchedNextPeriod.inflows;
      vm.reconciliation.data.cj.adjustedTotal.inflows = vm.reconciliation.data.cj.unAdjustedTotal.inflows - totalAdjInflows;

      vm.reconciliation.data.cj.subtotal.outflows = vm.reconciliation.data.cj.matchedInPeriod.outflows + vm.reconciliation.data.cj.unmatched.outflows;
      vm.reconciliation.data.cj.unAdjustedTotal.outflows = vm.reconciliation.data.cj.subtotal.outflows + vm.reconciliation.data.cj.matchedNextPeriod.outflows;
      vm.reconciliation.data.cj.adjustedTotal.outflows = vm.reconciliation.data.cj.unAdjustedTotal.outflows - totalAdjOutflows;

      vm.reconciliation.data.bank.subtotal.inflows = vm.reconciliation.data.bank.matchedInPeriod.inflows + vm.reconciliation.data.bank.unmatched.inflows;
      vm.reconciliation.data.bank.unAdjustedTotal.inflows = vm.reconciliation.data.bank.subtotal.inflows + vm.reconciliation.data.bank.matchedNextPeriod.inflows;

      vm.reconciliation.data.bank.subtotal.outflows = vm.reconciliation.data.bank.matchedInPeriod.outflows + vm.reconciliation.data.bank.unmatched.outflows;
      vm.reconciliation.data.bank.unAdjustedTotal.outflows = vm.reconciliation.data.bank.subtotal.outflows + vm.reconciliation.data.bank.matchedNextPeriod.outflows;

      vm.reconciliation.data.verifiedVariance.inflows = Math.abs(vm.reconciliation.data.cj.matchedInPeriod.inflows - vm.reconciliation.data.bank.matchedInPeriod.inflows);
      vm.reconciliation.data.verifiedVariance.outflows = Math.abs(vm.reconciliation.data.cj.matchedInPeriod.outflows - vm.reconciliation.data.bank.matchedInPeriod.outflows);

      vm.reconciliation.data.notVerifiedVariance.inflows = Math.abs(vm.reconciliation.data.cj.unmatched.inflows - vm.reconciliation.data.bank.unmatched.inflows);
      vm.reconciliation.data.notVerifiedVariance.outflows = Math.abs(vm.reconciliation.data.cj.unmatched.outflows - vm.reconciliation.data.bank.unmatched.outflows);

      vm.reconciliation.data.subtotalVariance.inflows = Math.abs(vm.reconciliation.data.cj.subtotal.inflows - vm.reconciliation.data.bank.subtotal.inflows);
      vm.reconciliation.data.subtotalVariance.outflows = Math.abs(vm.reconciliation.data.cj.subtotal.outflows - vm.reconciliation.data.bank.subtotal.outflows);

      vm.reconciliation.data.subsequentVariance.inflows = Math.abs(vm.reconciliation.data.cj.matchedNextPeriod.inflows - vm.reconciliation.data.bank.matchedNextPeriod.inflows);
      vm.reconciliation.data.subsequentVariance.outflows = Math.abs(vm.reconciliation.data.cj.matchedNextPeriod.outflows - vm.reconciliation.data.bank.matchedNextPeriod.outflows);

      vm.reconciliation.data.unAdjustedVariance.inflows = Math.abs(vm.reconciliation.data.cj.unAdjustedTotal.inflows - vm.reconciliation.data.bank.unAdjustedTotal.inflows);
      vm.reconciliation.data.unAdjustedVariance.outflows = Math.abs(vm.reconciliation.data.cj.unAdjustedTotal.outflows - vm.reconciliation.data.bank.unAdjustedTotal.outflows);

      vm.reconciliation.data.adjustedVariance.inflows = Math.abs(vm.reconciliation.data.cj.adjustedTotal.inflows - vm.reconciliation.data.bank.unAdjustedTotal.inflows);
      vm.reconciliation.data.adjustedVariance.outflows = Math.abs(vm.reconciliation.data.cj.adjustedTotal.outflows - vm.reconciliation.data.bank.unAdjustedTotal.outflows);
    }

  }
})();

(function() {
  'use strict';

  ReconcileTransactionTableController.$inject = ["$filter", "$scope", "$state", "$mdDialog", "toastr", "tableUtils", "Transactions", "Adjustments", "ACCOUNTS", "RECONCILIATIONS", "PROJECT_TYPES", "Reconciliations", "transactionUtils"];
  angular
    .module('projects')
    .component('reconcileTransactionsTable', {
      templateUrl: 'app/projects/engagement/reconcile/reconcile-transactions-table.html',
      bindings: {
        transactions: '<',
        reconciliation: '<',
        manualAdjustment: '<',
        isReadOnly: '='
      },
      controller: ReconcileTransactionTableController
    });

  function ReconcileTransactionTableController(
    $filter,
    $scope,
    $state,
    $mdDialog,
    toastr,
    tableUtils,
    Transactions,
    Adjustments,
    ACCOUNTS,
    RECONCILIATIONS,
    PROJECT_TYPES,
    Reconciliations,
    transactionUtils) {
    var vm = this;

    vm.selectedTransactions = [];
    vm.reloadData = reloadData;
    vm.removeSelected = removeSelected;
    vm.resetResults = resetResults;
    vm.reconcile = reconcile;
    vm.unreconcile = unreconcile;

    this.$onInit = function() {
      vm.pagination = tableUtils.getPagingParams($state.params);
      vm.adjustmentId = $state.params.adjustmentId;
      vm.canAdjust = $state.params.sourceType !== 'bank' && $state.params.sourceType !== 'all' && !vm.isReadOnly;
      vm.columnDefs = [
        {
          headerName: 'Select',
          checkboxSelection: vm.canAdjust,
          pinned: 'left',
          width: 70,
          sortable: false
        },
        {
          headerName: 'Date',
          field: 'date',
          minWidth: 100,
          width: 100,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Amount',
          field: 'amount',
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('currencyDisplayFilter')(params.value, params.data.account.currency);
          },
          cellClass: ['grid-amount'],
          width: 100
        },
        {
          headerName: 'Check #',
          field: 'checkNo',
          width: 100
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 200
        },
        { headerName: 'Name', field: 'name', width: 100 },
        { headerName: 'Memo', field: 'memo', width: 100 },
        {
          headerName: 'Acct Name',
          field: 'account.name',
          width: 100,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            if(params.data.account.type === ACCOUNTS.TYPE.ERP) {
              return params.value;
            }
            if(params.value) {
              return '<a href="#">' + params.value + '</a>';
            }
          },
          onCellClicked: function(params) {
            if(params.value) {
              var route = vm.type === PROJECT_TYPES.FORENSIC ? 'project.account-period-reconcile' : 'engagement.account-period-reconcile';
              $state.go(route, {accountPeriodId: params.data.accountPeriodId});
            }
          }
        },
        {
          headerName: 'Acct Type',
          field: 'account.type',
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('accountTypeDisplay')(params.value);
          },
          width: 100
        },
        {
          headerName: 'Filename',
          field: 'statement.fileName',
          width: 100,
          hide: true,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            if(params.value) {
              return $filter('filenameDisplay')(params.value);
            } else {
              return 'Bank API';
            }
          }
        },
        {
          headerName: 'Page',
          field: 'page',
          width: 60,
          cellStyle: {textAlign: "center"},
          cellRenderer: function(params) {
            if(params.value === null) {
              return 0;
            } else if(params.data) {
              var pageNumber = parseInt(params.value) + 1;   //PerfectAudit statement page index is zero based.
              if(params.data.statement.downloadUrl) {
                var link = params.data.statement.downloadUrl;
                link = link + '#page=' + pageNumber;
                return '<a target="_blank" href="' + link + '">' + pageNumber + '</a>';
              } else {
                return pageNumber;
              }
            }
          }
        }
      ];

      vm.columnDefs = _setColumnSort(vm.columnDefs);
      vm.gridOptions = {
        cacheBlockSize: vm.pagination.pageSize,
        columnDefs: vm.columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        angularCompileRows: true,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onSortChanged: vm.reloadData,
        getMainMenuItems: tableUtils.getMainMenuItems,
        rowModelType: 'serverSide',
        rowSelection: 'multiple',
        onRowSelected: _toggleSelectTransaction,
        onGridReady: onGridReady
      };
    };

    function onGridReady() {
      if(vm.gridOptions.api) {
        vm.gridOptions.api.setServerSideDatasource(_createDatasource());
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function resetResults() {
      $state.go('engagement.reconcile', {projectId: vm.reconciliation.projectId}, {inherit: false});
    }

    function reloadData(opts) {
      if(opts && opts.pageSize) {
        vm.pagination.pageSize = opts.pageSize;
        vm.gridOptions.paginationPageSize = opts.pageSize;
        vm.gridOptions.api.setServerSideDatasource(_createDatasource());
      }
      var sortModel = vm.gridOptions.api.getSortModel();
      if(sortModel.length) {
        vm.pagination.sortModel = sortModel[0].colId;
        vm.pagination.sortOrder = sortModel[0].sort;
      } else {
        vm.pagination.sortModel = 'date';
        vm.pagination.sortOrder = 'asc';
      }
      vm.pagination.skipCount = 0;
      $state.go('engagement.reconcile', vm.pagination, { notify: false });
    }

    function removeSelected() {
      if(vm.selectedTransactions.length > 0) {
        var transactionIds = _.map(vm.selectedTransactions, function(t) { return t.id;});
        Adjustments.update(vm.manualAdjustment.id, {transactionIds: transactionIds})
          .then(function Success() {
            toastr.success("Transactions added to the manual adjustment");
            $state.reload();
          })
          .catch(function error() {
            toastr.success("Error adding transactions to the manual adjustment");
          });
      }
    }

    function reconcile() {
      _updateReconciliation(RECONCILIATIONS.STATUS.RECONCILED);
    }

    function unreconcile() {
      _updateReconciliation(RECONCILIATIONS.STATUS.UNRECONCILED);
    }

    function _updateReconciliation(status) {
      if(vm.reconciliation) {
        vm.reconciliation.status = status;
        Reconciliations.update(vm.reconciliation.id, vm.reconciliation)
          .then(function Success() {
            toastr.success("Reconciliation status updated");
            $state.reload();
          })
          .catch(function error() {
            toastr.success("Error performing reconciliation");
          });
      }
    }

    function _setColumnSort(columnDefs) {
      return _.map(columnDefs, function(column) {
        if(column.field === vm.pagination.sortModel || column.colId === vm.pagination.sortModel) {
          column.sort = vm.pagination.sortOrder;
        }
        return column;
      });
    }

    function _toggleSelectTransaction() {
      vm.selectedTransactions = vm.gridOptions.api.getSelectedRows();
      $scope.$applyAsync();
    }

    function _createDatasource() {
      return {
        getRows: function(params) {
          // Load resolved transactions for initial call
          if(vm.transactions) {
            params.successCallback(vm.transactions, Transactions.getMetadata().transCountFilter);
            vm.transactions = false;
          } else {
            // Fire api call for paging/sorting/filtering
            // Work around for keep selected transactions
            vm.pagination.skipCount = params.request.startRow;
            var $stateParamsClone = Object.assign({}, $state.params);
            //Set default params in case they don't exist for reconciliation
            $stateParamsClone.sourceType = $stateParamsClone.sourceType || 'erp';
            $stateParamsClone.reconciled = $stateParamsClone.reconciled || 'false';
            $stateParamsClone.unmatched = 'true';  //Only fetch unmatched transactions
            $stateParamsClone.cjOnly = 'true';
            $stateParamsClone.transRangeAbs = $stateParamsClone.transRangeAbs || 'true';
            $stateParamsClone.startDate = $stateParamsClone.startDate || vm.reconciliation.startDate;
            $stateParamsClone.endDate = $stateParamsClone.endDate || vm.reconciliation.endDate;
            $stateParamsClone.minStartDate = vm.reconciliation.startDate;
            $stateParamsClone.maxEndDate = vm.reconciliation.endDate;
            $stateParamsClone.enabledAccounts = 'true';
            var transactionParams = angular.extend({downloadUrl: true, includeDocs: true}, transactionUtils.formatFilterParams($stateParamsClone), tableUtils.formatPagingParams(vm.pagination, true));
            Transactions.findAllPOST(transactionParams).then(
              function Success(data) {
                params.successCallback(data, Transactions.getMetadata().transCountFilter);
              }
            );
          }
        }
      };
    }
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "PROJECT_TYPES"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider, PROJECT_TYPES) {
    $stateProvider
      .state('engagement.files', {
        url: '/files',
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/project/files/files.html',
            controller: 'FilesController as $ctrl'
          }
        },
        data: {
          projectType: PROJECT_TYPES.AUDIT
        },
        resolve: {
          reports: ["$stateParams", "tableUtils", "Reports", "REPORTS", function($stateParams, tableUtils, Reports, REPORTS) {
            var p = {
              sortModel: 'createdAt',
              sortOrder: 'desc',
              pageSize: 1000
            };
            var pagingParams = tableUtils.formatPagingParams(p);
            var params = angular.extend({projectId: $stateParams.projectId, type: [REPORTS.TYPE.TRANSACTIONS, REPORTS.TYPE.BALANCES]}, pagingParams);
            return Reports.findAll(params, {bypassCache: true});
          }],
          bulkRevisions: ["$stateParams", "tableUtils", "BulkRevisions", "BULK_REVISIONS", function($stateParams, tableUtils, BulkRevisions, BULK_REVISIONS) {
            var p = {
              sortModel: 'createdAt',
              sortOrder: 'desc',
              pageSize: 1000
            };
            var pagingParams = tableUtils.formatPagingParams(p);
            var params = angular.extend({projectId: $stateParams.projectId, type: BULK_REVISIONS.TYPE.TRANSACTIONS}, pagingParams);
            return BulkRevisions.findAll(params, {bypassCache: true});
          }],
          accounts: ["$stateParams", "Accounts", function($stateParams, Accounts) {
            return Accounts.findAllByProject($stateParams.projectId);
          }],
          entities: ["$stateParams", "Entities", function($stateParams, Entities) {
            return Entities.findAllByProject($stateParams.projectId);
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  ImportExtractController.$inject = ["$mdDialog", "$state", "$stateParams", "toastr", "projectId", "extractId", "ErpExtracts"];
  angular
    .module('projects')
    .controller('ImportExtractController', ImportExtractController);

  function ImportExtractController(
    $mdDialog,
    $state,
    $stateParams,
    toastr,
    projectId,
    extractId,
    ErpExtracts) {
    var vm = this;
    vm.cancel = $mdDialog.cancel;
    vm.importExtract = importExtract;

    function importExtract() {
      ErpExtracts.validisImport(projectId, extractId)
        .then( function Success() {
          toastr.success('Import started');
          $mdDialog.hide();
        })
        .catch( function Failure(response) {
          toastr.error(response.data.message);
        });
    }
  }
})();

(function() {
  'use strict';

  ErpExtracts.$inject = ["DS", "DSHttpAdapter", "$q", "ERP_EXTRACTS"];
  angular
    .module('projects')
    .factory('ErpExtracts', ErpExtracts);

  function ErpExtracts(DS, DSHttpAdapter, $q, ERP_EXTRACTS) {
    var LOADING_STATUSES = [
      ERP_EXTRACTS.STATUS.IMPORTING,
      ERP_EXTRACTS.STATUS.LOADING,
      ERP_EXTRACTS.STATUS.GL_IMPORT,
      ERP_EXTRACTS.STATUS.AR_IMPORT,
      ERP_EXTRACTS.STATUS.AP_IMPORT,
      ERP_EXTRACTS.STATUS.TRACING
    ];
    var metadata;
    var erpExtracts = DS.defineResource({
      name: 'erpExtracts',
      endpoint: 'erp-extracts',
      idAttribute: 'id',
      cacheResponse: false,
      deserialize: function(config, res) {
        metadata = res.data.metadata;
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    erpExtracts.getMetadata = function() {
      return metadata;
    };

    erpExtracts.syncValidisExtracts = function(projectId) {
      return DSHttpAdapter.GET(
        DSHttpAdapter.defaults.basePath + '/erp-extracts/validis/sync',
        { params: {projectId: projectId} }
      ).then(function (res) {
        return res.data.data;
      });
    };

    erpExtracts.validisImport = function(projectId, extractId) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/erp-extracts/validis/sync',
        {},
        { params: {projectId: projectId, uploadId: extractId} }
      );
    };

    erpExtracts.isLoading = function(status) {
      return status ? LOADING_STATUSES.indexOf(status) >= 0 : false;
    };

    return erpExtracts;
  }
})();

(function() {
  'use strict';

  ErpExtractsListTableController.$inject = ["$state", "$scope", "$mdDialog", "tableUtils", "toastr", "$filter", "ERP_EXTRACTS"];
  angular
    .module('projects')
    .component('erpExtractsListTable', {
      templateUrl: 'app/projects/engagement/erp-extracts/erp-extracts-list.html',
      bindings: {
        project: '<',
        extracts: '<',
        importing: '=',
        matching: '='
      },
      controller: ErpExtractsListTableController
    });

  function ErpExtractsListTableController(
    $state,
    $scope,
    $mdDialog,
    tableUtils,
    toastr,
    $filter,
    ERP_EXTRACTS){
    var vm = this;
    var GRID_ID = 'grid-erp-extracts';
    vm.defineHeight = defineHeight;

    function activate(){
      vm.columnDefs = [
        {
          headerName: 'Load/Activate',
          pinned: 'left',
          width: 120,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          cellRenderer: function(params) {
            if(vm.importing) {
              return '';
            }
            var btnTitle = 'Load';
            var btnClass = '';
            if(params.data.active) {
              if(params.data.status === ERP_EXTRACTS.STATUS.READY) {
                btnTitle = 'Active';
                btnClass = 'active';
              } else if (params.data.status === ERP_EXTRACTS.STATUS.ERROR) {
                btnTitle = 'Error';
                btnClass = 'error';
              }
            }
            return '<button class="btn btn-grid ' + btnClass + '" type="button"><span>' + btnTitle + '</span></button>';
          },
          onCellClicked: function(params) {
            if(vm.importing || vm.matching) {
              return;
            }
            return _importExtract(params.data.id);
          }
        },
        {
          headerName: 'Status',
          field: 'status',
          sortable: false,
          suppressMovable: true,
          width:300,
          cellRenderer: function(params) {
            if(!params.data) {
              return '';
            }
            return '<erp-import-status-sync status="data.status" extract-id="data.id"></erp-import-status-sync>';
          }
        },
        {
          headerName: 'System',
          width: 200,
          field: 'erpSystem',
          suppressMovable: true
        },
        {
          headerName: 'Extract Date',
          field: 'integrationData.validis.completionDate',
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Extract Status',
          field: 'integrationData.validis.status',
          suppressMovable: true
        },
        {
          headerName: 'GL Txns',
          field: 'integrationData.importMetadata.glCount',
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('number')(params.value);
          }
        },
        {
          headerName: 'AR Txns',
          field: 'integrationData.importMetadata.arCount',
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('number')(params.value);
          }
        },
        {
          headerName: 'AP Txns',
          field: 'integrationData.importMetadata.apCount',
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('number')(params.value);
          }
        },
        {
          headerName: 'GL Start',
          field: 'integrationData.importMetadata.glStart',
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'GL End',
          field: 'integrationData.importMetadata.glEnd',
          suppressMovable: true,
          valueFormatter: function(params) {
            return $filter('dateDisplay')(params.value);
          }
        }
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowData: vm.extracts,
        angularCompileRows: true,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        getMainMenuItems: tableUtils.getMainMenuItems,
        onGridReady: function(params) {
          tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID);
          _adjustSize(params);
        },
        onGridSizeChanged: function(params) { _adjustSize(params); },
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange
      };
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID);
    }

    function _adjustSize(params) {
      if(!tableUtils.getGridState(GRID_ID)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
      params.api.setDomLayout('autoHeight');
    }

    function _importExtract(extractId) {
      $mdDialog.show({
        templateUrl: 'app/projects/engagement/erp-extracts/import-extract-dialog.html',
        controller: 'ImportExtractController',
        locals: {
          projectId: vm.project.id,
          extractId: extractId
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success() {
        $state.reload();
      });
    }

    function defineHeight(){
      var rows = vm.extracts.length;
      var res = (30 * rows) + 30;
      if(res > 300){
        return "330";
      } else{
        return res.toString();
      }
    }

    this.$onInit = function() {
      activate();
    };
  }
})();

(function() {
  'use strict';

  DeleteAdjustmentController.$inject = ["$mdDialog", "$state", "$timeout", "toastr", "adjustment", "Adjustments"];
  angular
    .module('projects')
    .controller('DeleteAdjustmentController', DeleteAdjustmentController);

  function DeleteAdjustmentController(
    $mdDialog,
    $state,
    $timeout,
    toastr,
    adjustment,
    Adjustments) {

    var vm = this;
    vm.cancel = cancel;
    vm.deleteAdjustment = deleteAdjustment;

    function cancel(){
      $mdDialog.hide();
    }

    function deleteAdjustment(){
      if(vm.adjustment) {
        var projectId = vm.adjustment.projectId;
        Adjustments.destroy(vm.adjustment.id)
          .then(function Success() {
            toastr.success('Adjustment entry deleted.');
            $mdDialog.hide();
            $timeout( function(){
              $state.go('engagement.reconcile', {projectId: projectId}, {inherit: false});
            }, 1000);
          })
          .catch(function Failure(response) {
            toastr.error(response.data.message);
            $mdDialog.hide();
          });
      }
    }
  }
})();

(function() {
  'use strict';

  CreateAdjustmentController.$inject = ["$mdDialog", "$state", "$timeout", "toastr", "filters", "dateUtils", "Adjustments"];
  angular
    .module('projects')
    .controller('CreateAdjustmentController', CreateAdjustmentController);

  function CreateAdjustmentController(
    $mdDialog,
    $state,
    $timeout,
    toastr,
    filters,
    dateUtils,
    Adjustments) {

    var vm = this;
    vm.cancel = cancel;
    vm.createAdjustment = createAdjustment;

    activate();

    function activate() {
      vm.adjustment = {
        projectId: $state.params.projectId
      };
    }

    function cancel(){
      $mdDialog.hide();
    }

    function createAdjustment(){
      if(vm.adjustment) {
        vm.adjustment.filters = dateUtils.formatUrlDates(filters);
        Adjustments.create(vm.adjustment)
          .then(function Success() {
            toastr.success('Adjustment entry created.');
            $mdDialog.hide();
            $timeout( function(){
              $state.go('engagement.reconcile', {projectId: vm.adjustment.projectId}, {inherit: false});
            }, 1000);
          })
          .catch(function Failure(response) {
            toastr.error(response.data.message);
            $mdDialog.hide();
          });
      }
    }
  }
})();

(function() {
  'use strict';

  Adjustments.$inject = ["DS"];
  angular
    .module('projects')
    .factory('Adjustments', Adjustments);

  function Adjustments(DS) {
    var metadata;
    var adjustments = DS.defineResource({
      name: 'adjustments',
      endpoint: 'adjustments',
      idAttribute: 'id',
      cacheResponse: false,
      deserialize: function(config, res) {
        metadata = res.data.metadata;
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    adjustments.getMetadata = function() {
      return metadata;
    };

    return adjustments;
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "PROJECT_TYPES"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider, PROJECT_TYPES) {
    $stateProvider
      .state('engagement.accountDetail', {
        url: '/accounts/:accountId?pageSize&sortOrder&sortModel&keyword&statementId',
        resolve: {
          account: ["$stateParams", "Accounts", function ($stateParams, Accounts) {
            return Accounts.find($stateParams.accountId);
          }],
          categories: ["$stateParams", "Categories", function ($stateParams, Categories) {
            return Categories.findAllByProject($stateParams.projectId);
          }],
          transactions: ["$stateParams", "Transactions", "transactionUtils", "tableUtils", function ($stateParams, Transactions, transactionUtils, tableUtils) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            if (!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'date';
              $stateParamsClone.sortOrder = 'asc';
            }
            var pagingParams = tableUtils.formatPagingParams($stateParamsClone, true);
            var params = angular.extend({}, transactionUtils.formatFilterParams($stateParamsClone), pagingParams);
            return Transactions.findAllPOST(params);
          }]
        },
        data: {
          projectType: PROJECT_TYPES.AUDIT
        },
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/project/account/account-transactions.html', //same template as in Projects
            controller: 'AccountTransactionsController as $ctrl'
          }
        }
      })
      .state('engagement.accountsEdit', {
        url: '/edit-accounts',
        resolve: {
          accounts: ["$stateParams", "Accounts", "ACCOUNTS", function($stateParams, Accounts, ACCOUNTS) {
            return Accounts.findAll({ projectId: $stateParams.projectId, exclude: [ACCOUNTS.TYPE.ERP] }, {bypassCache: true});
          }],
          entities: ["$stateParams", "Entities", function($stateParams, Entities) {
            return Entities.findAllByProject($stateParams.projectId);
          }]
        },
        data: {
          projectType: PROJECT_TYPES.AUDIT
        },
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/project/account/edit-accounts.html',
            controller: 'EditAccountsController as $ctrl'
          }
        }
      });
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "PROJECT_TYPES", "STATEMENTS"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider, PROJECT_TYPES, STATEMENTS) {
    $stateProvider
      .state('engagement.account-periods', {
        url: '/account-periods?status&source',
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/project/account-periods/account-periods.html',
            controller: 'AccountPeriodsController as $ctrl'
          }
        },
        data: {
          projectType: PROJECT_TYPES.AUDIT
        },
        resolve: {
          accountPeriods: ["$stateParams", "AccountPeriods", function($stateParams, AccountPeriods) {
            var params = { projectId: $stateParams.projectId, downloadUrl: true, $limit: 5000 };
            if($stateParams.status && $stateParams.status !== 'all-items') {
              params.status = $stateParams.status;
            }
            if ($stateParams.source) {
              params.source = $stateParams.source;
            } else {
              params.source = STATEMENTS.SOURCE.BANK_PDF;
            }
            return AccountPeriods.findAll(params, {bypassCache: true});
          }]
        }
      })
      .state('engagement.account-period-reconcile', {
        url: '/account-period-reconcile/:accountPeriodId?pageSize&sortOrder&sortModel&keyword&statementId',
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/project/account-periods/account-period-reconcile.html',
            controller: 'AccountPeriodReconcileController as $ctrl'
          }
        },
        data: {
          projectType: PROJECT_TYPES.AUDIT
        },
        resolve: {
          categories: ["$stateParams", "Categories", function($stateParams, Categories) {
            return Categories.findAllByProject($stateParams.projectId);
          }],
          customFields: ["$stateParams", "CustomFields", function($stateParams, CustomFields) {
            return CustomFields.findAllByProject($stateParams.projectId);
          }],
          transactions: ["$stateParams", "Transactions", "transactionUtils", "tableUtils", function($stateParams, Transactions, transactionUtils, tableUtils) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            // Set Default sort params
            if(!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'date';
              $stateParamsClone.sortOrder = 'asc';
            }
            var pagingParams = tableUtils.formatPagingParams($stateParamsClone, true);
            var params = angular.extend({includeDocs: true}, transactionUtils.formatFilterParams($stateParamsClone), pagingParams);
            return Transactions.findAllPOST(params);
          }],
          accountPeriod: ["$stateParams", "AccountPeriods", function($stateParams, AccountPeriods) {
            return AccountPeriods.find($stateParams.accountPeriodId, {params: {navigation:true}});
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  fileUploadModel.$inject = ["$parse"];
  angular
    .module('core')
    .directive('fileUploadModel', fileUploadModel);

  function fileUploadModel($parse) {
    return {
      restrict: 'A',
      link: link
    };

    function link(scope, elem, attrs) {
      var getModel = $parse(attrs.fileUploadModel);
      var setModel = getModel.assign;
      elem.bind('change', function() {
        scope.$apply(function() {
          setModel(scope, elem[0].files);
        });
      });
    }
  }
})();

(function() {
  'use strict';

  directiveCounter.$inject = ["$rootScope"];
  angular
    .module('core')
    .factory('directiveCounter', directiveCounter);

  function directiveCounter($rootScope) {
    var singleStateCount = 0;

    return {
      getSingleStateCount: getSingleStateCount
    };

    function getSingleStateCount() {
      singleStateCount ++;
      $rootScope.$on('$stateChangeStart', function() {
        singleStateCount = 0;
      });
      return singleStateCount;
    }
  }
})();

(function() {
  'use strict';

  angular.module('charts', [
    'core'
  ]);
})();

(function() {
  'use strict';

  TopBarGraphs.$inject = ["DS"];
  angular
    .module('charts')
    .factory('TopBarGraphs', TopBarGraphs);

  function TopBarGraphs(DS) {
    return DS.defineResource({
      name: 'topBarGraph',
      endpoint: 'topBarGraph',
      idAttribute: 'id',
      defaultValues: {
        id: null,
        type: 'topBarGraph',
        attributes: {}
      },
      cacheResponse: false,
      deserialize: function(config, res) {
        return res.data;
      },
      serialize: function(config, data) {
        return {
          data: data
        };
      }
    });
  }
})();

(function() {
  'use strict';

  SankeyTraceGraphs.$inject = ["DS"];
  angular
    .module('charts')
    .factory('SankeyTraceGraphs', SankeyTraceGraphs);

  function SankeyTraceGraphs(DS) {
    return DS.defineResource({
      name: 'sankeyGraph',
      endpoint: 'project/sankeytracegraph',
      idAttribute: 'queryId',
      defaultValues: {
        queryId: null,
        type: 'sankeyTraceGraph',
        attributes: {}
      },
      cacheResponse: false,
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return {
          data: data
        };
      }
    });
  }
})();

(function() {
  'use strict';

  SankeyTraceController.$inject = ["$timeout", "$scope", "$window", "$element"];
  angular
    .module('charts')
    .component('sankeyTraceGraph', {
      template: '<div id="sankey-trace-graph"></div>',
      controller: SankeyTraceController,
      bindings: {
        traceData: '<',
        selectNode: '&',
        sankeyGroup: '<'
      }
    });

  function SankeyTraceController(
    $timeout,
    $scope,
    $window,
    $element) {
    var vm = this,
      $win = angular.element($window),
      $elem = angular.element('#sankey-trace-graph'),
      resize = _.debounce(_updateContainer, 100);

    var cdata;
    var sourceNodes, taxOrRevenueDebitSourceNodes, invoiceNodes, hiddenInvoiceNodes, paymentNodes, hiddenPaymentNodes, depositNodes, evidenceNodes, badDebtNodes;

    var width = $win.width() - 200;
    var height = $win.height() - 100;
    var svg = d3.select($element.get(0)).append('svg').attr('viewBox', `0 0 ${width} ${height}`);
    var popup = d3.select($element.get(0)).append('div').classed('popup',true).attr('id','popup-sankey').style('opacity',0);

    var layout;

    var diagram;
    var margin = { top: 0, left: 150, bottom: 0, right: 50 };
    var link_categories = ["fromTaxOrRevenueDebit", "fromDiscount", "other"];
    var color = d3.scaleOrdinal(["#FFC857","#4A99BB","#C5C4CF"]).domain(link_categories);
    const fmt = d3.format('$,.2f');

    $scope.$on('sideNavToggled', resize);

    this.$onInit = function() {
      vm.reCreate = reCreate;
      $win.bind('resize', function() {
        resize();
      });
      reCreate();
    };

    this.$onChanges = function() {
      reCreate();
    };


    function reCreate() {
      //grouped = vm.sankeyGroup;
      cdata = JSON.parse(JSON.stringify(vm.traceData));
      _prepareNodes();
      _prepareLinks();
      _initLayout();
      _drawGraph();
    }  

    function _prepareLinks() {
      cdata.links.forEach(d => {
        d.value = d.amount;
        if (d.sourceType === 'taxOrRevenueDebitSource' || d.targetType === 'badDebt') {
          d.xtype = 'fromTaxOrRevenueDebit';
        } else if (d.sourceType === 'discount') {
          d.xtype = 'fromDiscount';
        } else {
          d.xtype = 'other';
        }
      });
    }

    function _prepareNodes() {
      var nodes = cdata.nodes;
      sourceNodes = nodes.filter(d => d.type === "source").map(d => d.id);
      taxOrRevenueDebitSourceNodes = nodes.filter(d => d.type === "taxOrRevenueDebitSource").map(d => d.id);
      invoiceNodes = nodes.filter(d => (d.type === "invoice") && !d.hide).map(d => d.id);
      hiddenInvoiceNodes = nodes.filter(d => (d.type === "invoice" && d.hide) || d.type === "discount").map(d => d.id);
      paymentNodes = nodes.filter(d => d.type === "payment" && !d.hide).map(d => d.id);
      hiddenPaymentNodes = nodes.filter(d => d.type === "payment" && d.hide).map(d => d.id);
      depositNodes = nodes.filter(d => d.type === "deposit").map(d => d.id);
      evidenceNodes = nodes.filter(d => d.type === "evidence").map(d => d.id);
      badDebtNodes = nodes.filter(d => d.type === "badDebt").map(d => d.id);
    }

    function _initLayout() {
      var ordering = [ [sourceNodes, taxOrRevenueDebitSourceNodes], [invoiceNodes, hiddenInvoiceNodes], [paymentNodes, hiddenPaymentNodes], [depositNodes, badDebtNodes], [evidenceNodes, []] ]; 
      // layout
      layout = d3.sankey()
        .extent([[margin.left, margin.top],
          [width - margin.left - margin.right, height - margin.top - margin.bottom]])
        //.scale(.000006 / (maxAmount/10000000))
        .scale(null)   
        .nodeWidth(20)
        .sourceId(d => {
          return {
            id: d.source,
            port: d.sourceType
          };
        })
        .targetId(d => {
          return {
            id: d.target,
            port: d.targetType
          };
        })
        .sortPorts((a,b)=> b.amount - a.amount)
        .linkValue(d => d.amount)
        .linkType(d => d.rtype)
        .ordering(ordering);
      // .nodeBackwards(d => !(d.targetType === d.sourceType));

      diagram = d3.sankeyDiagram()
     
        .linkColor(d => color(d.xtype))    
        .linkMinWidth(() => 3)   
        .nodeTitle(d => d.name);
      //.nodeValue(d => fmt(d.amount).replace('G','B') );
      //.nodeValue(d => d.name );        

    }

    // highlight recursively walks either left or right from the selected node or
    // link and highlights all nodes it finds. it does not go left-then-right so
    // only highlights things actually related to the initial node/link it was
    // called on
    function _highlight(d, goRight) {
      if (!d) {
        return;
      }
      var i;
      if (d.target && d.source) {
        d3.selectAll(`#l-${d.source.id}-${d.target.id}-${d.rtype} path`).classed('highlight', true);
      }
      if (goRight) {
        if (d.target) {
          if (d.targetType !== 'deposit') {
            _highlight(d.target, true);
          } else {
            _highlightDepositOrEvidence(d.target, d.amount, true);
          }
        }
        if (d.outgoing && Array.isArray(d.outgoing)) {
          for (i = 0; i < d.outgoing.length; i++) {
            _highlight(d.outgoing[i], true);
          }
        }
      } else {
        if (d.source) {
          if (d.sourceType !== 'deposit') {
            _highlight(d.source, false);
          } else {
            _highlightDepositOrEvidence(d.source, d.amount, false);
          }
        }
        if (d.incoming && Array.isArray(d.incoming)) {
          for (i = 0; i < d.incoming.length; i++) {
            _highlight(d.incoming[i], false);
          }
        }
      }
    }

    // highlightDepositOrEvidence is used so we only highlight 1 deposit or evidence link, following
    // the link of equal value to the link we got there with
    function _highlightDepositOrEvidence(d, prevAmount, goRight) {
      if (!d) {
        return;
      }
      var i;
      if (goRight) {
        if (d.outgoing && Array.isArray(d.outgoing)) {
          for (i = 0; i < d.outgoing.length; i++) {
            if (d.outgoing[i].amount === prevAmount) {
              _highlight(d.outgoing[i], true);
              return;
            }
          }
        }
      } else {
        if (d.incoming && Array.isArray(d.incoming)) {
          for (i = 0; i < d.incoming.length; i++) {
            if (d.incoming[i].amount === prevAmount) {
              _highlight(d.incoming[i], false);
              return;
            }
          }
        }
      }
    }

    function _drawGraph() {
      let layoutd = layout(cdata);      
      let text,w;
      svg.datum(layoutd).call(diagram);      
      svg.selectAll('g.link')
        .attr('id', d => `l-${d.source.id}-${d.target.id}-${d.rtype}`)
        .on('click', function(d) { 
          d.link = true;
          vm.selectNode({ node: d });
          d3.selectAll('g.link path').classed('highlight', false);
          d3.select(this).select('path').classed('highlight', true);
          _highlight(d, false);
          _highlight(d, true);
        })
        .on('mouseover', function(d) {
          d3.select(this).raise().select('path').style('opacity',0.8);    
          var offsetX = d3.event.offsetX;
          text = `${d.source.name} \u2192 ${d.target.name}\n${fmt(d.amount).replace('G','B')}`;

          if (d.imageURL) {
            let widthHeight = '';
            if (d.targetType === 'evidence') {
              widthHeight = 'width="633" height="24"';
              if (offsetX > 300) {
                offsetX -= 300;
              }
            }
            text += `<br><img ${widthHeight} src="${d.imageURL}">`;
          }
          popup.html( text );  
          w = popup.node().getBoundingClientRect().width;            
          popup
            .transition()
            .duration(250)
            .style('opacity',1)
            .style("left", offsetX + "px")
            .style("top", d3.event.offsetY + "px");
        })  
        .on('mouseout', function() {
          d3.select(this).select('path').style('opacity',null);
          popup.transition().duration(250).style('opacity',0);
        });  
      svg.selectAll('g.link title').html(''); // remove predefined titles since we use custom
      svg.selectAll('g.node title').html('');
      svg.selectAll('g.link path').attr('class', d => `${d.xtype} n-${d.source.id} n-${d.target.id}`);
      svg.selectAll('g.node')
        .attr('id', d => `n-${d.id}`)
        .attr('class', function(d) {
          if (d.hide) {
            return `node sankeynode-hidden-otherflow`;
          }
          return `node sankeynode-${d.type}`;
        })
        .on('mouseover', function(d) {
          if (!d.hide) {
            text = `${d.name}\n${fmt(d.amount)}`;
            popup.html( text );
          }
          w = popup.node().getBoundingClientRect().width;            
          popup
            .transition()
            .duration(250)
            .style('opacity',1)
            .style("left", ((d.x0 + d.x1 ) / 2 - w / 2 + 17) + "px")
            .style("top", (10 + (d.y0 + d.y1) / 2) + "px");
        })
        .on('mouseout', function() {
          popup.transition().duration(250).style('opacity',0);
        }) 
        .on('click', d => { 
          d3.selectAll('g.link path').classed('highlight', false);
          d3.selectAll(`g.link path.n-${d.id}`).classed('highlight', true);
          d3.selectAll(`text.node-title`).classed("selected", false);
          d3.select(`#n-${d.id} text.node-title`).classed("selected", true);
          d3.event.stopPropagation();
          vm.selectNode({ node: d });
          _highlight(d, true);
          _highlight(d, false);
        });
      d3.selectAll('rect.node-body')
        .attr("y", d => d.dy < 10 ? "-5" : "0")
        .attr("height", d => d.dy < 10 ? "10" : d.y1 - d.y0);
    
    }

    function _updateContainer() {
      width = $elem.outerWidth();
      // svg.attr('width', '100%');
      // redraw here //
    }
   
    
  }
})();

(function() {
  'use strict';

  SankeyGraphs.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('charts')
    .factory('SankeyGraphs', SankeyGraphs);

  function SankeyGraphs(DS, DSHttpAdapter) {
    var sankeyGraphs = DS.defineResource({
      name: 'sankeyGraph',
      endpoint: 'project/forcegraph',
      idAttribute: 'queryId',
      defaultValues: {
        queryId: null,
        type: 'sankeyGraph',
        attributes: {}
      },
      cacheResponse: false,
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return {
          data: data
        };
      }
    });

    // this is a hack using POST instead of GET to avoid query size limits
    sankeyGraphs.findAllPOST = function(params) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/project/forcegraph',
        params,
        {}
      ).then(function (res) {
        return res.data.data;
      });
    };

    return sankeyGraphs;
  }
})();

(function() {
  'use strict';

  SankeyController.$inject = ["$timeout", "$scope", "$window", "$element"];
  angular
    .module('charts')
    .component('sankeyGraph', {
      template: '<div id="sankey-graph"></div>',
      controller: SankeyController,
      bindings: {
        sankeyData: '<',
        selectNode: '&',
        sankeyGroup: '<'
      }
    });

  function SankeyController(
    $timeout,
    $scope,
    $window,
    $element) {
    var vm = this,
      $win = angular.element($window),
      $elem = angular.element('#sankey-graph'),
      resize = _.debounce(_updateContainer, 100);

    var cdata;

    var width = $win.width() - 200;
    var height = $win.height() - 100;
    var svg = d3.select($element.get(0)).append('svg').attr('viewBox', `0 0 ${width} ${height}`);
    var popup = d3.select($element.get(0)).append('div').classed('popup',true).attr('id','popup-sankey').style('opacity',0);

    var layout;

    var diagram;
    var margin = { top: 0, left: 150, bottom: 0, right: 50 };
    var link_categories = ["s-a", "a-a", "a-u","other"];
    var color = d3.scaleOrdinal(["#00C999","#48BEFF","#9291A2","#aaa"]).domain(link_categories);
    const fmt = d3.format('$.2s');

    var sourcenodes;
    var usenodes;
    var accountnodes;
    var creditnodes;
    var checkingnodes;
    var savingsnodes;
    var brokeragenodes;
    var othernodes;

    $scope.$on('sideNavToggled', resize);

    this.$onInit = function() {
      vm.reCreate = reCreate;
      $win.bind('resize', function() {
        resize();
      });
      reCreate();
    };


    function reCreate() {

      //grouped = vm.sankeyGroup;
      cdata = JSON.parse(JSON.stringify(vm.sankeyData));
      _prepareNodes();
      _prepareLinks();
      _initLayout();
      _drawGraph();

    }  

    function _prepareLinks() {

      cdata.links.forEach(d => {
        if (d.sourceType === 'source' && d.targetType === 'account') {
          d.xtype = 's-a';
        } else if (d.sourceType === 'account' && d.targetType === 'account') {
          d.xtype = 'a-a';
        } else if (d.sourceType === 'account' && d.targetType === 'use') {
          d.xtype = 'a-u';
        } else {
          d.xtype = 'other';
        }  
      });

    }

    function _prepareNodes() {

      var nodes = cdata.nodes;
      nodes.forEach(d => {
        if (d.type === "account") {
          if (d.name.includes("CC")) {
            d.accountType = "credit";
          } else if (d.name.includes("Savings")) {
            d.accountType = "savings";
          } else if (d.name.includes("Checking")) {
            d.accountType = "checking";
          } else if (d.name.includes("Brokerage")) {
            d.accountType = "brokerage";
          } else {
            d.accountType = "other";
          }
        }
      });

      sourcenodes = nodes.sort((a, b) => b.amount - a.amount).filter(d => d.type === "source").map(d => d.id);
      usenodes = nodes.filter(d => d.type === "use").map(d => d.id);
      accountnodes = nodes.filter(d => d.type === "account").map(d => d.id);

      creditnodes = nodes.filter(d => d.accountType === "credit").map(d => d.id);
      checkingnodes = nodes.filter(d => d.accountType === "checking").map(d => d.id);
      savingsnodes = nodes.filter(d => d.accountType === "savings").map(d => d.id);
      brokeragenodes = nodes.filter(d => d.accountType === "brokerage").map(d => d.id);
      othernodes = nodes.filter(d => d.accountType === "other").map(d => d.id);

    }

    function _initLayout() {


      var order = [[sourcenodes]];

      /*if(savingsnodes.length) order.push([savingsnodes]);
      if(checkingnodes.length) order.push([checkingnodes]); 
      if(brokeragenodes.length) order.push([brokeragenodes]);
      if(creditnodes.length) order.push([creditnodes]);
      if(othernodes.length) order.push([othernodes]);
      */
      if(accountnodes.length) order.push([accountnodes]);
      if(usenodes.length) order.push([usenodes]);      
                                            
      // layout
      layout = d3.sankey()
        .extent([[margin.left, margin.top],
          [width - margin.left - margin.right, height - margin.top - margin.bottom]])
        //.scale(.000006 / (maxAmount/10000000))
        .scale(null)   
        .nodeWidth(20)
        .sourceId(d => {
          return {
            id: d.source,
            port: d.sourceType
          };
        })
        .targetId(d => {
          return {
            id: d.target,
            port: d.targetType
          };
        })
        .sortPorts((a,b)=> b.amount - a.amount)
        .rankSets([
          {
            type: "same",
            nodes: sourcenodes
          },
          {
            type: "same",
            nodes: checkingnodes
          },
          {
            type: "same",
            nodes: savingsnodes
          },
          {
            type: "same",
            nodes: creditnodes
          },
          {
            type: "same",
            nodes: brokeragenodes
          },
          {
            type: "same",
            nodes: othernodes
          },
          {
            type: "",
            nodes: usenodes
          }
        ])
        .linkValue(d => d.amount)
        .linkType(d => d.linkType)
        .ordering(order);        
      // .nodeBackwards(d => !(d.targetType === d.sourceType));

      diagram = d3.sankeyDiagram()
     
        .linkColor(d => color(d.xtype))    
        .linkMinWidth(() => 3)   
        .nodeTitle(d => d.name);
      //.nodeValue(d => fmt(d.amount).replace('G','B') );
      //.nodeValue(d => d.name );        

    }

    function _drawGraph() {

      let layoutd = layout(cdata);      
      let text,w;
      svg.datum(layoutd).call(diagram);      
      svg.selectAll('g.link')
        .on('click', function(d) { 
          d.link = true;
          vm.selectNode({ node: d });
          d3.selectAll('g.link path').classed('highlight', false);
          d3.select(this).select('path').classed('highlight', true);
        })
        .on('mouseover', function(d) {
          d3.select(this).raise().select('path').style('opacity',0.8);    
          text = `${d.source.name} \u2192 ${d.target.name}\n${fmt(d.amount).replace('G','B')}`;    
          popup.html( text );  
          w = popup.node().getBoundingClientRect().width;            
          popup
            .transition()
            .duration(250)
            .style('opacity',1)
            .style("left", d3.event.offsetX + "px")
            .style("top", d3.event.offsetY + "px");
        })  
        .on('mouseout', function() {
          d3.select(this).select('path').style('opacity',null);
          popup.transition().duration(250).style('opacity',0);
        });  
      svg.selectAll('g.link title').html(''); // remove predefiened titles since we use custom
      svg.selectAll('g.node title').html('');
      svg.selectAll('g.link path').attr('class', d => `${d.xtype} n-${d.source.id} n-${d.target.id}`);
      svg.selectAll('g.node')
        .attr('id', d => `n-${d.id}`)
        .attr('class', d => `node ${d.type}`)
        .on('mouseover', function(d) {
          if(d.type != 'account') {
            text = d.name;
          }else{   
            text = `<table class="popup-table"><tr><td>Increase:</td><td align=right>${d.inflows}</td><td class="empty">&nbsp;</td><td>Decrease:</td><td align=right>${d.outflows}</td></tr>` +
              `<tr><td>Transfer In:</td><td align=right>${d.transfersIn}</td><td>&nbsp;</td><td>Transfer Out:</td><td align=right>${d.transfersOut}</td></tr></table>`;
          }    
          popup.html( text );
          w = popup.node().getBoundingClientRect().width;            
          popup
            .transition()
            .duration(250)
            .style('opacity',1)
            .style("left", ((d.x0 + d.x1 ) / 2 - w / 2 + 17) + "px")
            .style("top", (10 + (d.y0 + d.y1) / 2) + "px");
        })
        .on('mouseout', function() {
          popup.transition().duration(250).style('opacity',0);
        }) 
        .on('click', d => { 
          d3.selectAll('g.link path').classed('highlight', false);
          d3.selectAll(`g.link path.n-${d.id}`).classed('highlight', true);
          d3.selectAll(`text.node-title`).classed("selected", false);
          d3.select(`#n-${d.id} text.node-title`).classed("selected", true);
          d3.event.stopPropagation();
          vm.selectNode({ node: d });
        });
      d3.selectAll('rect.node-body')
        .attr("y", d => d.dy < 10 ? "-5" : "0")
        .attr("height", d => d.dy < 10 ? "10" : d.y1 - d.y0);
    
    }

    function _updateContainer() {
      width = $elem.outerWidth();
      // svg.attr('width', '100%');
      // redraw here //
    }
   
    
  }
})();

(function() {
  'use strict';

  StackedBarController.$inject = ["$timeout", "$scope", "$window", "$state", "DATE_GROUP_TYPE"];
  angular
    .module('charts')
    .component('rangeChart', {
      template: '<div id="range-chart"></div>',
      transclude: true,
      controller: StackedBarController,
      bindings: {
        rangeData: '=',
        brushRange: '&',
        filterData: '='
      }
    });

  function StackedBarController(
    $timeout,
    $scope,
    $window,
    $state,
    DATE_GROUP_TYPE) {
    var vm = this,
      svg = d3.select('#range-chart').append('svg'),
      $win = angular.element($window),
      $elem = angular.element('#range-chart'),
      resize = _.debounce(_updateContainer, 100),
      height,
      width;

    var dateGroup = $state.params.dateGroup || 'month';

    var color = d3.scaleOrdinal()
      .domain(['inflow', 'outflow'])
      .range(['#4cb660', '#ecebec']);

    $scope.$on('sideNavToggled', resize);

    this.$onInit = function() {
      $win.bind('resize', function() {
        resize();
      });
      _setData();
      _setSize();
    };

    function _updateContainer() {
      width = $elem.outerWidth();
      svg.attr('width', width);
      svg.selectAll('*').remove();
      _drawGraph();
    }

    function _setSize() {
      $timeout(function() {
        height = 130;
        width = $elem.outerWidth();
        svg.attr('height', height + 20);
        svg.attr('width', width);
        _drawGraph();
      }, 0);
    }

    function _drawGraph() {
      var xScaleTime = d3.scaleTime()
        .domain([
          new Date(vm.range[0]),
          new Date(vm.range[1])
        ])
        .rangeRound([0, width]);

      var yScale = d3.scaleLinear()
        .domain([
          d3.min(vm.data[1]),
          d3.max(vm.data[0])
        ])
        .range([height, 0]);

      var xAxis = d3.axisBottom(xScaleTime)
        .tickValues(d3.timeMonth.range(new Date(vm.range[0]), new Date(vm.range[1]), _getFrequency()))
        .tickFormat(function(d) {
          return moment(d).format(DATE_GROUP_TYPE[dateGroup].FORMAT);
        });

      var months = svg.selectAll('.months')
        .data(vm.data)
        .enter()
        .append('g')
        .attr('class', 'months');

      var brush = d3.brushX()
        .extent([[xScaleTime.range()[0], 0], [xScaleTime.range()[1], height]]);

      svg.append('g')
        .attr('class', 'xAxis')
        .attr('transform', 'translate(20, ' + height + ')')
        .attr('fill', 'none')
        .call(xAxis);

      months.selectAll('rect')
        .data(function(d) {
          return d;
        })
        .enter()
        .append('rect')
        .attr('class', 'd3-bar')
        .attr('x', function(d, i) {
          return xScaleTime(moment(vm.range[0]).add(i, DATE_GROUP_TYPE[dateGroup].GROUP_BY).toDate());
        })
        .attr('width', width / vm.data[0].length)
        .attr('y', function(d) {
          return d < 0 ? yScale(0) : yScale(d);
        })
        .attr('height', function(d) {
          return yScale(0) - yScale(Math.abs(d));
        })
        .attr('fill', function(d) {
          return d < 0 ? color('outflow') : color('inflow');
        });

      svg.append('g')
        .attr('class', 'brush')
        .call(brush)
        .call(brush.move, function() {
          if(vm.filterData) {
            var start = xScaleTime(vm.filterData.startDate);
            var end = xScaleTime(vm.filterData.endDate);
            if(Math.floor(start) === 0 && Math.ceil(end) === width) {
              return [0, 0];
            } else {
              return [start, end];
            }
          }
        });

      brush.on('end', function() {
        if(!d3.event.sourceEvent) { return; }
        if(!d3.event.selection) { return; }
        var selectedRange = d3.event.selection.map(xScaleTime.invert),
          dayRange = selectedRange.map(d3.timeDay.round);
        vm.brushRange({ range: dayRange });
      });
    }

    function _getFrequency() {
      return d3.timeMonth.range(new Date(vm.range[0]), new Date(vm.range[1])).length / 8;
    }

    function _setData() {
      vm.data = [vm.rangeData.data[0], vm.rangeData.data[1]];
      vm.range = vm.rangeData.data[2];
    }
  }
})();

(function() {
  'use strict';

  ProgressPlaybackController.$inject = ["$timeout"];
  angular
    .module('charts')
    .component('progressPlayback', {
      template: '<div id="progress-playback"></div>',
      controller: ProgressPlaybackController,
      bindings: {
        isPlaying: '<',
        shouldReset: '<',
        syncTimer: '=',
        filterData: '<'
      }
    });

  function ProgressPlaybackController($timeout) {
    var vm = this,
      svg = d3.select('#progress-playback').append('svg'),
      scrubber = svg.append('rect').attr('class', 'progress-scrubber'),
      scrubberWidth = 5,
      x = d3.scaleTime(),
      $elem = angular.element('#progress-playback'),
      margin = {
        top: 10,
        bottom: 0
      },
      height,
      width,
      resetOnPlay;

    // TODO remove this
    // vm.filterData.startDate = '2016-01-01';
    // vm.filterData.endDate = '2016-07-01';

    this.$onChanges = function(event) {
      // TODO: clean this up;
      if(event.isPlaying && event.isPlaying.currentValue) {
        _startProgressScrubber();
      } else if(event.isPlaying && !event.isPlaying.currentValue && event.isPlaying.previousValue) {
        _pauseProgressScrubber();
      }

      if(event.shouldReset && event.shouldReset.currentValue) {
        _resetProgressScrubber();
      }
    };

    $timeout(function() {
      width = $elem.outerWidth();
      height = 21 - margin.top - margin.bottom;
      _drawGraph();
    }, 1000);

    function _drawGraph() {
      x.domain([new Date(vm.filterData.startDate), new Date(vm.filterData.endDate)])
        .range([0, width]);

      scrubber
        .attr('width', scrubberWidth)
        .attr('height', height);

      svg.attr('width', width);
      svg.attr('height', height + margin.top + margin.bottom);

      svg.append('g')
        .attr('class', 'xAxis-progress xAxis-progress-grid')
        .attr('transform', 'translate(0,' + height + ')')
        .call(d3.axisBottom(x)
          .tickSize(-height)
          .tickFormat(function(d) {
            return moment(d).format('M/YY');
          }))
        .selectAll('text')
        .attr('x', 10);
    }

    function _startProgressScrubber() {
      if(resetOnPlay) {
        _resetProgressScrubber();
      }
      resetOnPlay = false;
      scrubber.transition()
        .duration(vm.syncTimer)
        .ease(d3.easeLinear)
        .attr('width', width)
        .on('end', function() {
          resetOnPlay = true;
        });
    }

    function _pauseProgressScrubber() {
      scrubber.transition()
        .duration(0);
    }

    function _resetProgressScrubber() {
      scrubber.transition()
        .duration(0)
        .attr('width', scrubberWidth);
    }
  }
})();

(function() {
  'use strict';

  ForceGraphs.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('charts')
    .factory('ForceGraphs', ForceGraphs);

  function ForceGraphs(DS, DSHttpAdapter) {
    var forceGraphs = DS.defineResource({
      name: 'forceGraph',
      endpoint: 'project/forcegraph',
      idAttribute: 'queryId',
      defaultValues: {
        queryId: null,
        type: 'forceGraph',
        attributes: {}
      },
      cacheResponse: false,
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return {
          data: data
        };
      }
    });

    // this is a hack using POST instead of GET to avoid query size limits
    forceGraphs.findAllPOST = function(params) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/project/forcegraph',
        params,
        {}
      ).then(function (res) {
        return res.data.data;
      });
    };

    return forceGraphs;
  }
})();

(function() {
  'use strict';

  ForceController.$inject = ["$timeout", "$scope", "$window", "NODE_TYPES"];
  angular
    .module('charts')
    .component('forceGraph', {
      template: '<div id="force-graph"></div><canvas id="force-graph-canvas"></canvas>',
      controller: ForceController,
      bindings: {
        forceData: '<',
        selectNode: '&'
      }
    });

  function ForceController(
    $timeout,
    $scope,
    $window,
    NODE_TYPES) {
    var vm = this,
      svg = d3.select('#force-graph').append('svg'),
      simulation = d3.forceSimulation(),
      $win = angular.element($window),
      $elem = angular.element('#force-graph'),
      resize = _.debounce(_updateContainer, 100),
      height,
      width;

    var $chartWidth = $win.width() - 300;
    var $columnWidth = $chartWidth / 3;
    var $minColumnWidth = 20;
    var $sourceLimit = $columnWidth;
    var $accountLimit = $columnWidth * 2;
    var $totalAccountPixels = 0;
    var $totalSourcePixels = 0;
    var $totalUsePixels = 0;
    var $gray = '#AAA';
    var $lightBlue = '#4BA6E3';
    var $darkBlue = '#213963';
    var $black = '#202020';

    var cnodes;

    $scope.$on('sideNavToggled', resize);

    this.$onInit = function() {
      $win.bind('resize', function() {
        resize();
      });

      _setNodePosition();
      _setSize();
    };

    function _setNodePosition() {

      var leftAlignAccount = false;
      var orderedNodes = [];
      var defaultNodes = [];

      _.map(vm.forceData.nodes, function(node) {
        if(_isNodeAccountOrEntity(node)) {
          node.fx = $chartWidth / 2;
        }else if(_isNodeSource(node)){
          node.fx = $columnWidth / 2;
          if(node.categoryLabelId === "defaultSource") {
            defaultNodes.push(node);
          }
        }else{
          node.fx = $chartWidth - ($columnWidth / 2);
          if(node.categoryLabelId === "defaultUse"){
            defaultNodes.push(node);
          }
        }
        orderedNodes.push(node);
      });

      //Order nodes descending based on sizeFactor attribute
      orderedNodes.sort( function ( a, b ) { return b.sizeFactor - a.sizeFactor; } );
      defaultNodes.sort( function ( a, b ) { return b.sizeFactor - a.sizeFactor; } );

      //Push defaultUse and defaultSource nodes at the end of the array.
      orderedNodes = orderedNodes.concat(defaultNodes);

      cnodes = _.map(orderedNodes,function (node) {
        return node;
      });
      cnodes = _.map(cnodes,function (node) {
        var size;
        if(_isNodeAccountOrEntity(node)) {
          if($totalAccountPixels === 0) {
            node.fy = _getNodeSize(node)  + 40;
          } else {
            size = _getNodeSize(node) + 60;
            node.fx = _organizeAccountNode(leftAlignAccount,size);
            leftAlignAccount = !leftAlignAccount;
            node.fy = $totalAccountPixels + _getNodeSize(node) + 50;
          }
          $totalAccountPixels += _getNodeSize(node) * 2 + 30;
        }else if(_isNodeSource(node)){
          if($totalSourcePixels === 0){
            node.fy = _getNodeSize(node) + 30;
          } else{
            node.fy = $totalSourcePixels + _getNodeSize(node) + 30;
          }
          $totalSourcePixels += _getNodeSize(node)  * 2 + 30;
        }else{
          if($totalUsePixels === 0){
            node.fy = _getNodeSize(node) + 30;
          } else{
            node.fy = $totalUsePixels + _getNodeSize(node) + 30;
          }
          $totalUsePixels += _getNodeSize(node) * 2 + 30;
        }
        return node;
      });
    }

    function _organizeAccountNode(leftAlign, nodeSize){
      var xAxis;
      if(leftAlign){
        xAxis = ($chartWidth / 2) - nodeSize;
        return xAxis;
      }
      xAxis = ($chartWidth / 2) + nodeSize;
      return xAxis;
    }

    function _updateContainer() {
      width = $elem.outerWidth();
      svg.attr('width', '100%');
      simulation
        .force('center', d3.forceCenter(width / 2, height / 2))
        .restart();
    }

    function _setSize() {
      $timeout(function() {
        height = _validHeight();
        width = $elem.outerWidth();
        svg.attr('height', height);
        svg.attr('width', width);
        _drawGraph();
      }, 0);
    }

    function _validHeight() {
      var defaultHeight = 800;
      var biggestTotalPixels = Math.max($totalAccountPixels,$totalSourcePixels, $totalUsePixels);
      if(biggestTotalPixels > defaultHeight){
        return biggestTotalPixels;
      }else {
        return defaultHeight;
      }
    }

    function _getNodeSize(node) {
      var nodeSize = 90 * node.sizeFactor;
      return Math.min(100, Math.round(nodeSize + 10));
    }

    function _isNodeAccountOrEntity(node) {
      return node.type === 'account' || node.type === 'entity';
    }

    function _isNodeSource(node) {
      return node.type === 'source';
    }

    function _drawGraph() {
      simulation
        .velocityDecay(0.4)
        .force('link', d3.forceLink().id(function(d) { return d.id; }).distance(70))
        // TODO: fine tune gravity
        .force('charge', d3.forceManyBody())
        // TODO: find center
        .force('center', d3.forceCenter(width / 2, height / 2))
        // TODO: make sure collide works with diff radius
        .force('collide', d3.forceCollide(function(d) { return _getNodeSize(d) + 15; }).strength(1));

      var color = d3.scaleOrdinal()
        // TODO: this color scale
        .domain([1, 2])
        .range([$darkBlue, $lightBlue]);

      var link = svg.append('g')
        .attr('class', 'links')
        .selectAll('polyline')
        .data(vm.forceData.links)
        .enter().append('path')
        .attr('class', 'link')
        .attr('stroke-width', 3)
        .style('fill', 'none')
        .attr('stroke', function(d) {
          return d.type === 'link' ? $gray : $gray;
        })
        .attr('marker-mid', function(d, i) {
          return 'url(#arrow' + i + ')';
        }).on('click', function(d) {
          //Get the arrow id of the link
          var markerMid = d3.select(this).attr('marker-mid');
          var regex = /#(.*)\)/;
          var arrowId = '#' + markerMid.match(regex)[1];
          d3.selectAll('circle').style('stroke', 'none');
          d3.selectAll('path.link').style('stroke', $gray);
          d3.selectAll('marker').style('fill', $gray);
          d3.select(this).style('stroke', $black);
          d3.select(arrowId).style('fill', $black);
          d.link = true;
          vm.selectNode({ node: d });
        });

      svg.append('defs')
        .selectAll('marker')
        .data(vm.forceData.links)
        .enter().append('marker')
        .attr('id', function(d, i) { return 'arrow' + i; })
        .attr('orient', 'auto')
        .attr('preserveAspectRatio', 'none')
        .attr('viewBox', '-15 -5 30 10')
        .attr('refX', 0)
        .attr('refY', 0)
        .attr('markerWidth', 18)
        .attr('markerHeight', 6)
        .attr('fill', function(d) {
          return d.type === 'link' ? $gray : $gray;
        })
        .append('svg:path')
        .attr("d", "M0,-5L10,0L0,5");

      svg.on('dblclick', function() {
        d3.selectAll('circle').style('stroke', 'none');
        d3.selectAll('path.link').style('stroke', $gray);
        d3.selectAll('marker').style('fill', $gray);
        vm.selectNode(null);
      });

      var node = svg.selectAll('.node')
        .attr('class', 'nodes')
        .data(cnodes)
        .enter().append('g')
        .on('click', function(d) {
          d3.event.stopPropagation();
          d3.selectAll('polyline').style('stroke', $gray);
          d3.selectAll('path.link').style('stroke', $gray);
          d3.selectAll('marker').style('fill', $gray);
          vm.selectNode({ node: d });
        })
        .on('dblclick', releaseNode)
        .call(d3.drag()
          .on('start', dragstarted)
          .on('drag', dragged)
          .on('end', dragended));

      node.append('circle')
        // TODO: match color scheme
        .attr('fill', function(d) {
          var nodeType = d.type || 'endpoint';
          return color(NODE_TYPES[nodeType]);
        })
        .attr('r', function(d) {
          return _getNodeSize(d);
        })
        .on('click', function(d) {
          d3.selectAll('circle').style('stroke', 'none')
            .attr('stroke-width', 2);
          if(_isNodeAccountOrEntity(d)) {
            d3.select(this).style('stroke', $lightBlue);
          }
          else {
            d3.select(this).style('stroke', $darkBlue);
          }

        });

      node.append('text')
        // TODO: label position
        .style('text-anchor', 'middle')
        .attr('dy', function(d) {
          if(_isNodeAccountOrEntity(d)) {
            return -_getNodeSize(d) - 5;
          }
          return _getNodeSize(d) + 12;
        })
        .attr('dx', '0')
        .attr('font-size', '12px')
        .attr('fill', $black)
        .text(function(d) { return d.name; });

      simulation
        .nodes(cnodes)
        .on('tick', ticked);

      simulation
        .force('link')
        .links(vm.forceData.links);

      function ticked() {
        node
          .attr('cx', function(d) {
            // TODO: radius
            var radius = _getNodeSize(d);
            d.x = Math.max(radius, Math.min(width - radius, d.x));
            return d.x;
          })
          .attr('cy', function(d) {
            // TODO: radius
            var radius = _getNodeSize(d);
            d.y = Math.max(radius, Math.min(height - radius, d.y));
            return d.y;
          });

        link.attr('d', function(d) {
          var result;
          if((d.sourceType === 'account' || d.sourceType === 'entity') && (d.targetType === 'account' || d.targetType === 'entity')){
            var dx = d.target.x - d.source.x,
              dy = d.target.y - d.source.y,
              dr = Math.sqrt(dx * dx + dy * dy);
            result = "M" + d.source.x + "," + d.source.y + "A" + dr + "," + dr + " 0 0,1 " + d.target.x + "," + d.target.y;
          } else {
            var midX = Math.trunc((d.source.x + d.target.x) / 2);
            var midY = Math.trunc((d.source.y + d.target.y) / 2);
            result = "M" + d.source.x + "," + d.source.y + "L" + midX + "," + midY + "L" + d.target.x + "," + d.target.y;
          }
          return result;
        });

        node.attr('transform', function(d) { return 'translate(' + d.x + ',' + d.y + ')'; });
      }

      function dragstarted(d) {
        if(!d3.event.active) {
          simulation.alphaTarget(0.3).restart();
        }
        d.fx = d.x;
        d.fy = d.y;
      }

      function dragged(d) {
        var node = d;
        var positionX = d3.event.x;
        var positionY = d3.event.y;
        var nodeSize = _getNodeSize(node);

        if(_isNodeSource(node)) {
          if (positionX > $minColumnWidth && positionX < ($sourceLimit - nodeSize)) {
            node.fx = positionX;
            node.fy = positionY;
          }
        } else if(_isNodeAccountOrEntity(node)) {
          if (positionX > ($sourceLimit + nodeSize) && positionX < ($accountLimit - nodeSize)) {
            node.fx = positionX;
            node.fy = positionY;
          }
        } else {
          if (positionX > ($accountLimit + nodeSize) && positionX < $chartWidth) {
            node.fx = positionX;
            node.fy = positionY;
          }
        }
      }

      function dragended(d) {
        if(!d3.event.active) {
          simulation.alphaTarget(0);
        }
        d.fx = d.x;
        d.fy = d.y;
      }

      function releaseNode(d) {
        d.fx = null;
        d.fy = null;
      }
    }
  }
})();

(function() {
  'use strict';

  ForcePlaybackController.$inject = ["$timeout", "$scope", "blockUI", "blockUIConfig", "NODE_TYPES"];
  angular
    .module('charts')
    .component('forceGraphPlayback', {
      templateUrl: 'app/core/utils/charts/force-graph-playback.html',
      controller: ForcePlaybackController,
      bindings: {
        forceData: '<',
        dataRange: '<',
        filterData: '<'
      }
    });

  function ForcePlaybackController(
    $timeout,
    $scope,
    blockUI,
    blockUIConfig,
    NODE_TYPES) {
    var vm = this,
      keyFrames = [],
      playSpeed = 500,
      shouldReset;

    vm.playing = false;
    vm.resetProgress = false;
    vm.syncTimer = 0;

    // TODO: delete this
    // vm.forceData.nodes = [{
    //         id: 'a',
    //         name: 'Node A',
    //         animation: [1, 0.9, 0.8, 0.7, 0.6, 0.5, 0.4]
    //     }, {
    //         id: 'b',
    //         name: 'Node B',
    //         type: 'account',
    //         animation: [0.3, 0.4, 0.5, 0.6, 0.5, 0.4, 0.3]
    //     }, {
    //         id: 'c',
    //         name: 'Node C',
    //         type: 'account',
    //         animation: [0.1, 0.2, 0.4, 0.5, 0.7, 0.8, 0.1]
    //     }
    // ];
    // vm.forceData.links = [{
    //         source: 'a',
    //         target: 'b',
    //         inVolume: 1,
    //         outVolume: 0
    //     },
    //     {
    //         source: 'b',
    //         target: 'c',
    //         inVolume: 1,
    //         outVolume: 0
    //     },
    //     {
    //         source: 'c',
    //         target: 'a',
    //         inVolume: 1,
    //         outVolume: 1
    //     }
    // ];
    this.$onInit = function() {
      blockUIConfig.message = 'Please wait...';
      blockUI.start();
    };

    $timeout(function() {
      blockUI.stop();
      vm.play = play;
      vm.pause = pause;
      vm.reset = reset;

      var svg = d3.select('#force-graph-playback').append('svg'),
        index = 0,
        $elem = angular.element('#force-graph-playback').parent(),
        height = $elem.outerHeight() - 3,
        width = $elem.outerWidth();

      var color = d3.scaleOrdinal()
        .domain([1, 2])
        .range(['#47B75C', '#B9D9BF']);

      // TODO: clean up
      svg.attr('height', height);
      svg.attr('width', width);

      var simulation = d3.forceSimulation(vm.forceData.nodes)
        .force('charge', d3.forceManyBody().strength(-1000))
        .force('link', d3.forceLink(vm.forceData.links).id(function(d) {
          return d.id;
        }).distance(200))
        .force('x', d3.forceX())
        .force('y', d3.forceY())
        .alphaTarget(1)
        .on('tick', ticked);

      var g = svg.append('g')
          .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')'),
        link = g.append('g')
          .selectAll('polyline'),
        marker = svg.append('defs')
          .selectAll('marker'),
        nodeContainer = g.append('g')
          .selectAll('.nodeContainer'),
        node = nodeContainer.selectAll('circle'),
        label = g.selectAll('text');

      _initGraph();

      function play() {
        keyFrames = [];
        simulation.on('tick', null);
        if(shouldReset) {
          reset();
        }
        vm.playing = true;
        vm.resetProgress = false;
        vm.syncTimer = _getTimerLength();
        bridge.zone.runOutsideAngular(function () {
          vm.forceData.nodes[0].animation.forEach(function(d, i) {
            if (i >= index) {
              keyFrames.push(new d3.timeout(function() {
                index = i;
                _update();
              }, playSpeed * (i - index - 1)));
            }
          });
          keyFrames.push(new d3.timeout(function() {
            stop();
            // Digest to update player controls
            $scope.$digest();
          }, vm.syncTimer));
        });
      }

      function pause() {
        vm.playing = false;
        g.selectAll('circle').transition().duration(0);
        g.selectAll('polyline').transition().duration(0);
        g.selectAll('text').transition().duration(0);
        keyFrames.forEach(function(k) {
          k.stop();
        });
      }

      function stop() {
        pause();
        shouldReset = true;
        // Remove any bound function on tick before adding ticked
        simulation.on('tick', null);
        simulation.on('tick', ticked);
      }

      function reset() {
        stop();
        index = 0;
        vm.resetProgress = true;
        _update(true);
        shouldReset = false;
      }

      function _getTimerLength() {
        var dataLength = vm.forceData.nodes[0].animation.length - 1;
        var numTimeouts = index ? dataLength / index : dataLength;
        return playSpeed * numTimeouts;
      }

      function _setNodePosition() {
        vm.forceData.nodes = _.map(vm.forceData.nodes, function(node) {
          node.fy =  Math.floor(Math.random() * (220 - 100)) + 100;
          node.fy = _isNodeAccountOrEntity(node) ? -node.fy : node.fy;
          return node;
        });
      }

      function _isNodeAccountOrEntity(node) {
        return node.type === 'account' || node.type === 'entity';
      }

      function _getNodeSize(nodeSizeFactor) {
        var nodeSize = 50 * nodeSizeFactor;
        return nodeSize + 10;
      }

      function _getLinkCenter(link, index) {
        var sourceNode = _.find(vm.forceData.nodes, {
            id: link.source.id
          }),
          targetNode = _.find(vm.forceData.nodes, {
            id: link.target.id
          });
        if (sourceNode && targetNode) {
          var sourceNodeSize = _getNodeSize(sourceNode.animation[index]),
            targetNodeSize = _getNodeSize(targetNode.animation[index]),
            sourceTheta = Math.atan2((link.target.y - link.source.y), (link.target.x - link.source.x)),
            targetTheta = Math.atan2((link.target.x - link.source.x), (link.target.y - link.source.y)),
            xStart = Math.cos(sourceTheta) * sourceNodeSize + link.source.x,
            yStart = Math.sin(sourceTheta) * sourceNodeSize + link.source.y,
            xEnd = link.target.x - Math.sin(targetTheta) * targetNodeSize,
            yEnd = link.target.y - Math.cos(targetTheta) * targetNodeSize;
          return (xStart + xEnd) / 2 + ',' + (yStart + yEnd) / 2;
        }
        return (link.source.x + link.target.x) / 2 + ',' + (link.source.y + link.target.y) / 2;
      }

      function _initGraph() {
        // Add swim lane positioning
        _setNodePosition();

        // Draw nodes
        nodeContainer = nodeContainer.data(vm.forceData.nodes);
        node.exit().remove();
        nodeContainer = nodeContainer.enter().append('g');
        label = nodeContainer.append('text')
          .style('text-anchor', 'middle')
          .attr('font-size', '12px')
          .attr('fill', '#2E2E2E')
          .text(function(d) { return d.name; });
        node = nodeContainer.append('circle')
          .attr('fill', function(d) {
            var nodeType = d.type || 'endpoint';
            return color(NODE_TYPES[nodeType]);
          })
          .merge(node);

        // Draw links
        marker = marker.data(vm.forceData.links);
        marker.exit().remove();
        marker = marker.enter()
          .append('marker')
          .attr('id', function(d, i) {
            return 'arrow' + i;
          })
          .attr('orient', 'auto')
          .attr('preserveAspectRatio', 'none')
          .attr('viewBox', '-15 -5 30 10')
          .attr('refX', 0)
          .attr('refY', 0)
          .attr('markerWidth', 18)
          .attr('markerHeight', 6)
          .attr('fill', function(d) {
            return d.type === 'link' ? '#d1d1d1' : '#202020';
          })
          .append('path')
          .attr('d', function(d) {
            if (d.inVolume && d.outVolume) {
              return 'M5, -5L15, 0L5, 5M-5,-5L-15,0L-5,5';
            } else if (d.inVolume) {
              return 'M0, -5L10, 0L0, 5';
            }
            return 'M-5,-5L-15,0L-5,5';
          });

        link = link.data(vm.forceData.links);
        link.exit().remove();
        link = link.enter()
          .append('polyline')
          .attr('stroke-width', 1)
          .attr('stroke', function(d) {
            return d.type === 'link' ? '#d1d1d1' : '#202020';
          })
          .attr('marker-mid', function(d, i) {
            return 'url(#arrow' + i + ')';
          }).merge(link);

        _update(true);
      }

      function _update(hardRestart) {
        // Apply transitions for update
        var transitionTime = hardRestart ? 0 : playSpeed;
        node.transition()
          .duration(transitionTime)
          .ease(d3.easeLinear).attr('r', function(d) {
            return _getNodeSize(d.animation[index]);
          });
        label.transition()
          .duration(transitionTime)
          .ease(d3.easeLinear)
          .attr('dy', function(d) {
            if(_isNodeAccountOrEntity(d)) {
              return d.y - _getNodeSize(d.animation[index]) - 5;
            }
            return d.y + _getNodeSize(d.animation[index]) + 12;
          });
        link.transition()
          .duration(transitionTime)
          .ease(d3.easeLinear)
          .attr('points', function(d) {
            return d.source.x + ',' + d.source.y + ' ' +
              _getLinkCenter(d, index) + ' ' +
              d.target.x + ',' + d.target.y;
          });

        // Update and restart the simulation.
        simulation.alpha(1).restart();
      }

      function ticked() {
        node.attr('cx', function(d) {
          return d.x;
        })
          .attr('cy', function(d) {
            return d.y;
          });
        label.attr('dy', function(d) {
          if(_isNodeAccountOrEntity(d)) {
            return d.y - _getNodeSize(d.animation[index]) - 5;
          }
          return d.y + _getNodeSize(d.animation[index]) + 12;
        })
          .attr('dx', function(d) {
            return d.x;
          });
        link.attr('points', function(d) {
          return d.source.x + ',' + d.source.y + ' ' +
            _getLinkCenter(d, index) + ' ' +
            d.target.x + ',' + d.target.y;
        });
      }
    }, 2000);
  }
})();

(function() {
  'use strict';

  angular
    .module('charts')
    .component('flowsBarChart', {
      templateUrl: 'app/core/utils/charts/flows-chart.html',
      transclude: true,
      controller: FlowsChartController,
      bindings: {
        flowsData: '<',
        nodesData: '<'
      }
    });

  function FlowsChartController() {
    var vm = this,
      svg = d3.select('#flows-stacked-bar-chart').append('svg'),
      height = 650,
      width = 210,
      xScale,
      yScale,
      color;

    this.$onChanges = function() {
      // Check to make sure the graph has been instantiated
      if(xScale) {
        _initDrawGraph();
      }
    };

    this.$onInit = function() {
      // set graph base
      svg
        .attr('height', height)
        .attr('width', width);

      xScale = d3.scaleBand()
        .domain(['flowIn', 'flowOut'])
        .range([0, width])
        .paddingInner(0.05);

      yScale = d3.scaleLinear()
        .range([height, 0])
        .domain([
          0,
          d3.max(_getYScaleDomain(), function(d) {
            return Math.abs(d);
          })
        ]);

      color = d3.scaleOrdinal()
        .domain(['flowIn', 'flowOut'])
        .range(['#d7e98a', '#e7f2b9']);

      // TODO: revise initial graph draw on load
      // to meet specs
      _initDrawGraph();
    };

    function _drawGraph(data) {
      var flow = svg.selectAll('rect')
        .data(data);

      // exit
      flow
        .exit()
        .remove();

      // enter
      flow
        .enter()
        .append('rect')
        .attr('x', function(d) {
          return xScale(d.flow);
        })
        .attr('width', xScale.bandwidth())
        .attr('y', function(d) {
          return yScale(Math.abs(d.value));
        })
        .attr('height', function(d) {
          return height - yScale(Math.abs(d.value));
        })
        .attr('fill', function(d) {
          return color(d.flow);
        });

      // update
      flow
        .transition()
        .duration(500)
        .attr('x', function(d) {
          return xScale(d.flow);
        })
        .attr('width', xScale.bandwidth())
        .attr('y', function(d) {
          return yScale(Math.abs(d.value));
        })
        .attr('height', function(d) {
          return height - yScale(Math.abs(d.value));
        })
        .attr('fill', function(d) {
          return color(d.flow);
        });
    }

    function _initDrawGraph() {
      // use total inflow and outflow for the initial graph
      if(vm.nodesData.metadata) {
        var totalFlow = {
          flowIn: vm.nodesData.metadata.totalsource,
          flowOut: vm.nodesData.metadata.totalUse,
          name: 'Overall Increase/Decrease'
        };
        var graphData = vm.flowsData ? vm.flowsData : totalFlow;
        _drawGraph(_parseFlowsData(graphData));
        _setNodeDisplay(graphData);
      }
    }

    function _getYScaleDomain() {
      // return the range of min outflow and max inflow
      // on each initialization of the graph.
      if(vm.nodesData.nodes.length) {
        return [
          d3.min(_.map(vm.nodesData.nodes, 'flowOut')),
          d3.max(_.map(vm.nodesData.nodes, 'flowIn'))
        ];
      } else {
        return [0, 0];
      }
    }

    function _setNodeDisplay(node) {
      vm.node = {
        name: node.name,
        flowIn: node.flowIn,
        flowOut: node.flowOut,
        net: node.flowIn - Math.abs(node.flowOut)
      };
    }

    function _parseFlowsData(data) {
      return [
        { flow: 'flowIn', value: data.flowIn },
        { flow: 'flowOut', value: data.flowOut }
      ];
    }
  }
})();

(function() {
  'use strict';

  AlertDialogController.$inject = ["$mdDialog"];
  angular
    .module('core')
    .controller('AlertDialogController', AlertDialogController);

  function AlertDialogController($mdDialog) {
    var vm = this;
    vm.closeAlert = $mdDialog.hide;
  }
})();

//Built on top of https://github.com/bcherny/format-as-currency . Needed to customize so a currency symbol parameter could be sent.
(function() {
  'use strict';

  angular
    .module('core')
    .service('formatAsCurrencyUtilities', formatAsCurrencyUtilities)
    .directive('formatAsCurrency', ['$filter', '$locale', 'formatAsCurrencyUtilities', formatAsCurrency]);

  function formatAsCurrencyUtilities() {
    // (haystack: String, needles: Array<String>) => Number
    // eg. ('foo', 'o') => 2
    this.occurrences = function (haystack, needles) {

      if (!angular.isString(haystack)) {
        throw new TypeError ('formatAsCurrencyUtilities#occurrences expects its 1st argument to be a String, but was given ' + haystack);
      }
      if (!angular.isArray(needles)) {
        throw new TypeError ('formatAsCurrencyUtilities#occurrences expects its 2nd argument to be an Array, but was given ' + needles);
      }
      needles.forEach(function (needle, n) {
        if (!angular.isString(needle)) {
          throw new TypeError ('formatAsCurrencyUtilities#occurrences expects needles to be Strings, but needle #' + n + ' is ' + needle);
        }
      });

      return needles
        .map(function (needle) { // get counts
          var _needle = needle.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
          return (haystack.match(new RegExp('[' + _needle + ']', 'g')) || []).length;
        })
        .reduce(function (prev, cur) { // sum counts
          return prev + cur;
        }, 0);
    };

    // (currencyString: String) => Number
    // eg. "$123.00" => 123.00
    this.toFloat = function (currencyString) {
      if (!angular.isString(currencyString)) {
        throw new TypeError ('formatAsCurrencyUtilities#toFloat expects its 1st argument to be a String, but was given ' + currencyString);
      }
      return parseFloat(currencyString.replace(/([؋€$ƒ৳₹P៛¥₡₱£QL﷼₪₸₩₭R₨₮₦KS฿₺₴₫,])+/g, ''), 10);
    };

    // (array: Array) => Array
    // eg. [1,2,2] => [1,2]
    this.uniq = function (array) {
      return array.reduce(function (prev, cur) {
        return prev.indexOf(cur) > -1 ? prev : prev.concat(cur);
      }, []);
    };

    // (a: String, b: String) => Array<String>
    // eg. 123.00, "$123.00" => ["$", ","]
    this.uniqueChars = function (a, b) {
      if (!angular.isString(a)) {
        throw new TypeError ('formatAsCurrencyUtilities#uniqueChars expects its 1st argument to be a String, but was given ' + a);
      }
      if (!angular.isString(b)) {
        throw new TypeError ('formatAsCurrencyUtilities#uniqueChars expects its 2nd argument to be a String, but was given ' + b);
      }

      var chars = a.split('');
      return this.uniq(b.split('').sort().reduce(function (prev, cur) {
        return chars.indexOf(cur) < 0 ? prev.concat(cur) : prev;
      }, []));
    };
  }

  function formatAsCurrency($filter, $locale, formatAsCurrencyUtilities) {
    var util = formatAsCurrencyUtilities;
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, element, attrs, ngModel) {
        var filter = $filter('currency');
        var currency = attrs.currency;

        scope.$watch(function(){
          return scope.$eval(attrs.currencyFilter);
        }, function (f) {
          filter = f ? $filter(f) : $filter('currency');
          triggerRender();
        });

        ngModel.$formatters.push(function (value) {
          return filter(value);
        });

        ngModel.$parsers.push(function (value) {
          // ignore non-numeric characters
          value = value.replace(/[a-zA-Z!?>:;|<@#%^&*)(+\\={}[\]_]/g, '');
          var number = util.toFloat(value).toFixed(2);
          if (ngModel.$validators.currency(number)) {
            var formatted = filter(number, currency);
            var specialCharacters = util.uniqueChars(number, formatted);

            // did we add a comma or currency symbol?
            var specialCharactersCountChange = [value, formatted]
              .map(function (string) {
                return util.occurrences(string, specialCharacters);
              })
              .reduce(function (prev, cur) {
                return cur - prev;
              });

            // compute the new selection range, correcting for
            // formatting introduced by the currency $filter
            var selectonRange = [
              element[0].selectionStart,
              element[0].selectionEnd
            ].map(function (position) {
              return position + specialCharactersCountChange;
            });

            // set the formatted value in the view
            ngModel.$setViewValue(formatted);
            ngModel.$render();

            // set the cursor back to its expected position
            // (since $render resets the cursor the the end)
            element[0].setSelectionRange(selectonRange[0], selectonRange[1]);
          }
          return number;
        });

        ngModel.$validators.currency = function (modelValue) {
          return !isNaN(modelValue);
        };

        // manually trigger the $formatters pipeline
        function triggerRender() {
          ngModel.$setViewValue(ngModel.$formatters.reduce(function (value, fn) {
            return fn(value);
          }, ngModel.$modelValue));
        }
      }
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('core')
    .component('traceInfo', {
      templateUrl: 'app/core/components/trace-info/trace-info.html',
      transclude: true,
      controller: TraceInfoController,
      bindings: {
        traceData: '<',
        traceSelectionData: '<',
      }
    });

  function TraceInfoController() {
    var vm = this;

    vm.revenueDialURL = "assets/tracedemo/dial_revenue.png";
    vm.ARDialURL = "assets/tracedemo/dial_AR.png";
    vm.cashDialURL = "assets/tracedemo/dial_cash.png";
    vm.bankDialURL = "assets/tracedemo/dial_bank.png";

    this.$onInit = function() {
      _initTraceInfo();
    };

    this.$onChanges = function() {
      _initTraceInfo();
    };

    function _initTraceInfo() {
      vm.traceInfo = {};
      vm.traceInfo.totalRevenue = 0;
      vm.traceInfo.totalDeposit = 0;
      vm.traceInfo.totalVerified = 0;
      vm.traceInfo.outstandingAR = 0;
      if(vm.traceData && vm.traceData.metadata) {

        vm.traceInfo.totalRevenue = vm.traceData.metadata.totalRevenue;
        vm.traceInfo.totalDeposit = vm.traceData.metadata.totalDeposit;
        vm.traceInfo.totalVerified = vm.traceData.metadata.totalVerified;
        vm.traceInfo.outstandingAR = vm.traceData.metadata.outstandingAR;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('core')
    .component('tableSearchKeyword', {
      templateUrl: 'app/core/components/table-search-keyword/table-search-keyword.html',
      bindings: {
        keyword: '<',
        applyFilter: '&'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .component('tableFilter', {
      templateUrl: 'app/core/components/table-filter/table-filter.html',
      bindings: {
        gridOptions: '<'
      },
      controller: TableFilterController
    });

  function TableFilterController() {
    var vm = this;
    vm.quickFilter = quickFilter;

    function quickFilter(value) {
      vm.gridOptions.api.setQuickFilter(value);
    }
  }
})();

(function() {
  'use strict';

  SupportingDocumentPreviewController.$inject = ["$filter"];
  angular
    .module('core')
    .component('supportingDocumentPreview', {
      controller: SupportingDocumentPreviewController,
      templateUrl: 'app/core/components/supporting-document-preview/supporting-document-preview.html',
      bindings: {
        documents: '='
      }
    });

  function SupportingDocumentPreviewController($filter) {
    var vm = this;
    vm.previewUrl = vm.documents[0].previewUrl;
    vm.filename = $filter('filenameDisplay')(vm.documents[0].fileName);
    vm.hasMore = vm.documents.length > 1;
  }
})();

(function() {
  'use strict';

  angular
    .module('core')
    .directive('supportingDocumentPreviewPopover', SupportingDocumentPreviewPopover);

  function SupportingDocumentPreviewPopover() {
    var POPOVER_WIDTH = 600;
    var IMG_POPOVER_HEIGHT = 200;
    var FILE_POPOVER_HEIGHT = 30;
    return {
      restrict: 'A',
      scope: {
        previewUrl: '=',
        filename: '='
      },
      link: link
    };

    function link(scope, elem) {
      //Preview URL is set only for images
      var template;
      if(scope.previewUrl) {
        template = getImageTemplate(scope.previewUrl);
      } else { //Display file icon and name.
        template = getFileTemplate(scope.filename);
      }

      elem.bind('mouseenter', function(e) {
        var position = e.target.getBoundingClientRect();
        var height = scope.previewUrl ? IMG_POPOVER_HEIGHT : FILE_POPOVER_HEIGHT;

        var x = position.left - POPOVER_WIDTH * 2;
        var y = position.top - height - 18;
        template.css({
          top: y > 0 ? y : 0,
          left: x > 0 ? x : 0
        });

        angular.element('body').append(template);
      });

      elem.bind('mouseleave', function() {
        template.remove();
      });
    }
  }

  function getImageTemplate(url) {
    return angular.element([
      '<div class="sup-doc-popover">',
      '<img src=' + url +  '></img>',
      '</div>'
    ].join(''));
  }

  function getFileTemplate(filename) {
    return angular.element([
      '<div class="sup-doc-popover">',
      '<div class="file">',
      '<md-icon class="material-icons icon-primary" role="img" aria-label="library_books">library_books</md-icon>',
      '<span>' + filename + '</span>',
      '</div></div>'
    ].join(''));
  }

})();

(function() {
  'use strict';

  StatusBarChartController.$inject = ["$state", "PROJECT_TYPES", "ACCOUNT_PERIODS"];
  angular
    .module('core')
    .component('statusBarChart', {
      controller: StatusBarChartController,
      templateUrl: 'app/core/components/status-bar-chart/status-bar-chart.html',
      bindings: {
        statusBarData: '=',
        accountId: '<',
        projectType: '<'
      }
    });

  function StatusBarChartController(
    $state,
    PROJECT_TYPES,
    ACCOUNT_PERIODS) {
    var vm = this;


    function goToReconciled(period){
      var params = { accountPeriodId: period.id };
      if(period.status === ACCOUNT_PERIODS.STATUS.RECONCILED || period.status === ACCOUNT_PERIODS.STATUS.UNRECONCILED){
        if(vm.projectType === PROJECT_TYPES.FORENSIC){
          $state.go('project.account-period-reconcile', params);
        } else {
          $state.go('engagement.account-period-reconcile', params);
        }
      }
    }

    this.$onInit = function() {
      vm.chart = vm.statusBarData;
      vm.goToReconciled = goToReconciled;

      if (vm.chart && vm.chart.periods !== undefined) {
        vm.chart.periods.forEach(function (period) {
          var width = parseInt((period.sizeFactor * 100)).toFixed(1);
          period.width = (width <= 1 || width.isNaN) ? 1 : width;
        });
      }
    };

  }
})();

(function() {
  'use strict';

  statusBarChartPopover.$inject = ["ACCOUNT_PERIODS"];
  angular
    .module('core')
    .directive('statusBarChartPopover', statusBarChartPopover);

  function statusBarChartPopover(ACCOUNT_PERIODS) {
    var POPOVER_WIDTH = 60;
    var POPOVER_HEIGHT = 85;
    return {
      restrict: 'A',
      scope: {
        description: '=',
        startDate: '=',
        endDate: '=',
        status: '='
      },
      link: link
    };

    function link(scope, elem) {
      var description = scope.description || ACCOUNT_PERIODS.STATUS_DESCRIPTION[scope.status] || 'No data';
      var status = scope.status;
      var start = moment(scope.startDate).format('MM/DD/YY');
      var end = moment(scope.endDate).format('MM/DD/YY');
      var template = angular.element([
        '<div class="bar-popover">',
        '<div class="bar-popover-top">' + start + ' - ' + end + '</div>',
        '<div class="bar-popover-bottom text-capitalize">' + description + '</div>',
        '</div>'
      ].join(''));

      elem.bind('mouseenter', function(e) {
        var position = e.target.getBoundingClientRect();
        var x = (position.left - POPOVER_WIDTH) + (position.width / 2);
        var y = position.top - POPOVER_HEIGHT;

        template.css({
          top: y,
          left: x
        });

        angular.element('body').append(template);
      });

      elem.bind('mouseleave', function() {
        template.remove();
      });

      elem.bind('click', function() {
        if(status === ACCOUNT_PERIODS.STATUS.RECONCILED || status === ACCOUNT_PERIODS.STATUS.UNRECONCILED){
          template.remove();
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('core')
    .component('stackedBarChart', {
      controller: StackedBarChartController,
      templateUrl: 'app/core/components/stacked-bar-chart/stacked-bar-chart.html',
      bindings: {
        stackedBarData: '=',
        audit: '@'
      }
    });

  function StackedBarChartController() {
    var vm = this;
    this.$onInit = function() {
      vm.chart = vm.stackedBarData;
    };
  }
})();

(function() {
  'use strict';

  SourceLinkController.$inject = ["Documents"];
  angular
    .module('core')
    .component('sourceLink', {
      templateUrl: 'app/core/components/source-link/source-link.html',
      bindings: { document: '<' },
      controller: SourceLinkController
    });

  function SourceLinkController(Documents) {
    var vm = this;

    this.$onInit = function() {
      vm.url = null;
      if(vm.document) {
        Documents.getDownloadLink(vm.document.id).then(
          function Success(response) {
            vm.url = response.data.url;
          });
      }
    };
  }
})();

(function() {
  'use strict';

  SideNavController.$inject = ["$mdMedia", "$rootScope"];
  angular
    .module('core')
    .component('sideNav', {
      templateUrl: 'app/core/components/side-nav/side-nav.html',
      controller: SideNavController,
      transclude: true,
      bindings: {
        side: '@',
        collapse: '='
      }
    });

  function SideNavController(
    $mdMedia,
    $rootScope) {
    var vm = this,
      isNavSet;
    vm.toggleOpen = toggleOpen;
    vm.navSideRight = this.side === 'right';

    function toggleOpen() {
      $rootScope.$broadcast('sideNavToggled');
      vm.isNavOpen = isNavSet ? !vm.isNavOpen : !$mdMedia('gt-sm');
      vm.isNavClosed = !vm.isNavOpen;
      isNavSet = true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('core')
    .component('sankeyFilter', {
      templateUrl: 'app/core/components/sankey-filter/sankey-filter.html',
      bindings: {
        hint: '@'
      },
      controller: SankeyFilterController
    });

  function SankeyFilterController() {
    this.searchText = "";

    this.$onInit = function() {
    // console.log("vm:", vm);
    };

  }
})();

(function() {
  'use strict';

  RevisionStatusSyncController.$inject = ["$timeout", "BULK_REVISIONS", "BulkRevisions"];
  angular
    .module('core')
    .component('revisionStatusSync', {
      controller: RevisionStatusSyncController,
      templateUrl: 'app/core/components/revision-status-sync/revision-status-sync.html',
      bindings: {
        revisionId: '=',
        status: '=',
        reload: '&'
      }
    });

  function RevisionStatusSyncController($timeout, BULK_REVISIONS, BulkRevisions) {
    var vm = this;
    vm.revisionInProgress = revisionInProgress;

    this.$onInit = function() {
      vm.statusTitle = BULK_REVISIONS.STATUS_DESCRIPTION[vm.status];
      vm.polling = true;

      if(vm.polling && revisionInProgress()) {
        revisionStatusPolling();
      }
    };

    this.$onDestroy = function() {
      vm.polling = false;
    };

    function revisionInProgress() {
      return BulkRevisions.isProcessing(vm.status);
    }

    function revisionStatusPolling() {
      $timeout(function() { //Poll for revision status
        BulkRevisions.find(vm.revisionId, {params:{nb:1}}).then(
          function(revision) {
            vm.status = revision.status;
            vm.statusTitle = BULK_REVISIONS.STATUS_DESCRIPTION[vm.status];
            if(vm.polling) {
              if(revisionInProgress()) {
                revisionStatusPolling();
              } else {
                vm.reload();
                vm.polling = false;
              }
            }
          });
      }, 5000);
    }
  }

})();

(function() {
  'use strict';

  ReportStatusSyncController.$inject = ["$timeout", "REPORTS", "Reports"];
  angular
    .module('core')
    .component('reportStatusSync', {
      controller: ReportStatusSyncController,
      templateUrl: 'app/core/components/report-status-sync/report-status-sync.html',
      bindings: {
        reportId: '=',
        status: '=',
        reload: '&'
      }
    });

  function ReportStatusSyncController($timeout, REPORTS, Reports) {
    var vm = this;
    vm.reportInProgress = reportInProgress;

    this.$onInit = function() {
      vm.statusTitle = REPORTS.STATUS_DESCRIPTION[vm.status];
      vm.polling = true;

      if(vm.polling && reportInProgress()) {
        reportStatusPolling();
      }
    };

    this.$onDestroy = function() {
      vm.polling = false;
    };

    function reportInProgress() {
      return Reports.isLoading(vm.status);
    }

    function reportStatusPolling() {
      $timeout(function() { //Poll for report status
        Reports.find(vm.reportId, {params:{nb:1}}).then(
          function(report) {
            vm.status = report.status;
            vm.statusTitle = REPORTS.STATUS_DESCRIPTION[vm.status];
            if(vm.polling) {
              if(reportInProgress()) {
                reportStatusPolling();
              } else {
                vm.reload();
                vm.polling = false;
              }
            }
          });
      }, 5000);
    }
  }

})();

(function() {
  'use strict';

  ReconciliationStatusSyncController.$inject = ["$timeout", "$state", "RECONCILIATIONS", "Reconciliations"];
  angular
    .module('core')
    .component('reconciliationStatusSync', {
      controller: ReconciliationStatusSyncController,
      templateUrl: 'app/core/components/reconciliation-status-sync/reconciliation-status-sync.html',
      bindings: {
        reconciliationId: '=',
        status: '=',
      }
    });

  function ReconciliationStatusSyncController($timeout, $state, RECONCILIATIONS, Reconciliations) {
    var vm = this;
    vm.reconciliationInProgress = reconciliationInProgress;

    this.$onInit = function() {
      vm.statusTitle = RECONCILIATIONS.STATUS_DESCRIPTION[vm.status];
      vm.polling = true;

      if(vm.polling && reconciliationInProgress()) {
        reconciliationStatusPolling();
      }
    };

    this.$onDestroy = function() {
      vm.polling = false;
    };

    function reconciliationInProgress() {
      return Reconciliations.isLoading(vm.status);
    }

    function reconciliationStatusPolling() {
      $timeout(function() {
        Reconciliations.find(vm.reconciliationId, {params:{nb:1}}).then(
          function(reconciliation) {
            vm.status = reconciliation.status;
            vm.statusTitle = RECONCILIATIONS.STATUS_DESCRIPTION[vm.status];
            if(vm.polling) {
              if(reconciliationInProgress()) {
                reconciliationStatusPolling();
              } else {
                vm.polling = false;
                $state.go($state.current, {}, {reload: true});
              }
            }
          });
      }, 5000);
    }
  }

})();

(function() {
  'use strict';

  MessageController.$inject = ["messagingService", "$scope"];
  angular
    .module('core')
    .component('messages', {
      controller: MessageController,
      templateUrl: 'app/core/components/messages/messages.html'
    });

  function MessageController(
    messagingService,
    $scope) {
    var vm = this;
    vm.messages = messagingService.getMessages();
    vm.dismissMessage = dismissMessage;

    $scope.$on('updateMessages', function() {
      vm.messages = messagingService.getMessages();
    });

    function dismissMessage(index) {
      vm.messages.splice(index, 1);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('core')
    .component('labels', {
      controller: LabelsController,
      templateUrl: 'app/core/components/labels/labels.html',
      bindings: {
        currentLabels: '='
      }
    });

  function LabelsController() {
    // TODO: remove this code when it is fully deprecated
    var vm = this,
      currentLabels = angular.copy(vm.currentLabels);
    vm.labels = vm.currentLabels;
    vm.saveLabels = saveLabels;

    function saveLabels() {
      // TODO: logic to deal with labels
      currentLabels = _.difference(vm.labels, currentLabels);
    }
  }
})();

(function() {
  'use strict';

  FlowsInfoController.$inject = ["$stateParams"];
  angular
    .module('core')
    .component('flowsInfo', {
      templateUrl: 'app/core/components/flows-info/flows-info.html',
      transclude: true,
      controller: FlowsInfoController,
      bindings: {
        forceData: '<',
        selectedNode: '<'
      }
    });

  function FlowsInfoController($stateParams) {
    var vm = this;

    this.$onInit = function() {
      _initFlowsInfo();
    };

    this.$onChanges = function() {
      _initFlowsInfo();
    };

    function _initFlowsInfo() {
      vm.showTransfers = $stateParams.unmatched !== 'true';
      _resetFlowsInfo();

      if(vm.selectedNode) {
        if (vm.selectedNode.link) {
          _setLinkFlowsInfo();
        } else {
          _setNodeFlowsInfo();
        }
      } else if(vm.forceData.metadata) {
        vm.flowsInfo.totalSource = Number(vm.forceData.metadata.totalSource) + Number(vm.forceData.metadata.totalTransfer);
        vm.flowsInfo.totalSourceCount = Number(vm.forceData.metadata.sourceCount) + Number(vm.forceData.metadata.transferCount);
        vm.flowsInfo.flowIn = Number(vm.forceData.metadata.totalSource);
        vm.flowsInfo.sourceCount = Number(vm.forceData.metadata.sourceCount);
        vm.flowsInfo.totalTransferIn = Number(vm.forceData.metadata.totalTransfer);
        vm.flowsInfo.transferInCount = Number(vm.forceData.metadata.transferCount);
        // totalTransferOut is just total transfers with sign swapped for "uses" column display
        vm.flowsInfo.totalTransferOut = -1 * Number(vm.forceData.metadata.totalTransfer);
        vm.flowsInfo.transferOutCount = Number(vm.forceData.metadata.transferCount);
        vm.flowsInfo.totalUse = -1 * (Number(vm.forceData.metadata.totalUse) + Number(vm.forceData.metadata.totalTransfer));
        vm.flowsInfo.totalUseCount = Number(vm.forceData.metadata.useCount) + Number(vm.forceData.metadata.transferCount);
        vm.flowsInfo.flowOut = Number(vm.forceData.metadata.totalUse) * -1;
        vm.flowsInfo.useCount = Number(vm.forceData.metadata.useCount);
        vm.flowsInfo.net = vm.flowsInfo.totalSource - Math.abs(vm.flowsInfo.totalUse);
        vm.flowsInfo.totalCount = Number(vm.flowsInfo.totalUseCount) + Number(vm.flowsInfo.totalSourceCount);
      }
    }

    function _setNodeFlowsInfo() {

      if (vm.selectedNode.type === 'source') {
        vm.flowsInfo.flowIn = Number(vm.selectedNode.flowOut);
        vm.flowsInfo.sourceCount = Number(vm.selectedNode.count);
        // only outflow totals need to be set
        vm.flowsInfo.totalSource = Number(vm.selectedNode.flowOut);
        vm.flowsInfo.totalSourceCount = Number(vm.selectedNode.count);
      } else if (vm.selectedNode.type === 'account' || vm.selectedNode.type === 'entity') {
        vm.flowsInfo.flowIn = Number(vm.selectedNode.flowIn);
        vm.flowsInfo.flowOut = Number(vm.selectedNode.flowOut) * -1;
        vm.flowsInfo.useCount = Number(vm.selectedNode.useCount);
        vm.flowsInfo.sourceCount = Number(vm.selectedNode.sourceCount);
        vm.flowsInfo.totalTransferIn = Number(vm.selectedNode.transfersIn);
        vm.flowsInfo.transferInCount = Number(vm.selectedNode.transfersInCount);
        vm.flowsInfo.totalTransferOut = -1 * Number(vm.selectedNode.transfersOut);
        vm.flowsInfo.transferOutCount = Number(vm.selectedNode.transfersOutCount);
        // Set totals
        vm.flowsInfo.totalSource = Number(vm.selectedNode.flowIn) + Number(vm.selectedNode.transfersIn);
        vm.flowsInfo.totalSourceCount = Number(vm.selectedNode.sourceCount) + Number(vm.selectedNode.transfersInCount);
        vm.flowsInfo.totalUse = -1 * (Number(vm.selectedNode.flowOut) + Number(vm.selectedNode.transfersOut));
        vm.flowsInfo.totalUseCount = Number(vm.selectedNode.useCount) + Number(vm.selectedNode.transfersOutCount);
        vm.flowsInfo.totalCount = vm.flowsInfo.totalSourceCount + vm.flowsInfo.totalUseCount;
        vm.flowsInfo.net = vm.flowsInfo.totalSource - Math.abs(vm.flowsInfo.totalUse);
      } else if (vm.selectedNode.type === 'use') {
        vm.flowsInfo.flowOut = Number(vm.selectedNode.flowIn) * -1;
        vm.flowsInfo.useCount = Number(vm.selectedNode.count);
        // Set totals
        vm.flowsInfo.totalUse = Number(vm.selectedNode.flowIn) * -1;
        vm.flowsInfo.totalUseCount = Number(vm.selectedNode.count);
      }
    }

    function _setLinkFlowsInfo() {
      if ((vm.selectedNode.sourceType === 'account' || vm.selectedNode.sourceType === 'entity')
        && (vm.selectedNode.targetType === 'account' || vm.selectedNode.targetType === 'entity')) { //Internal transfer arrow
        vm.flowsInfo.totalTransferIn = vm.selectedNode.amount;
        vm.flowsInfo.totalTransferOut = -1 * vm.selectedNode.amount;
        vm.flowsInfo.transferInCount = vm.selectedNode.count;
        vm.flowsInfo.transferOutCount = vm.selectedNode.count;
        // Totals are just transfer numbers, with appropriate signs
        vm.flowsInfo.totalSource = vm.selectedNode.amount;
        vm.flowsInfo.totalSourceCount = vm.selectedNode.count;
        vm.flowsInfo.totalUse = -1 * vm.selectedNode.amount;
        vm.flowsInfo.totalUseCount = vm.selectedNode.count;
      } else if (vm.selectedNode.sourceType === 'account' || vm.selectedNode.sourceType === 'entity') {
        vm.flowsInfo.flowOut = vm.selectedNode.amount * -1;
        vm.flowsInfo.net = vm.selectedNode.amount;
        vm.flowsInfo.useCount = vm.selectedNode.count;
        // Only outflow totals need to be set
        vm.flowsInfo.totalUse = -1 * vm.selectedNode.amount;
        vm.flowsInfo.totalUseCount = vm.selectedNode.count;
        vm.flowsInfo.totalCount = vm.selectedNode.count;
      } else if (vm.selectedNode.targetType === 'account' || vm.selectedNode.targetType === 'entity') {
        vm.flowsInfo.flowIn = vm.selectedNode.amount;
        vm.flowsInfo.net = vm.selectedNode.amount;
        vm.flowsInfo.sourceCount = vm.selectedNode.count;
        // Only inflow totals need to be set
        vm.flowsInfo.totalSource = vm.selectedNode.amount;
        vm.flowsInfo.totalSourceCount = vm.selectedNode.count;
        vm.flowsInfo.totalCount = vm.selectedNode.count;
      }
    }

    function _resetFlowsInfo() {
      vm.flowsInfo = {
        totalSource: 0,
        totalSourceCount: 0,
        flowIn: 0,
        sourceCount: 0,
        net: 0,
        totalTransferIn: 0,
        transferInCount: 0,
        totalTransferOut: 0,
        transferOutCount: 0,
        totalUse: 0,
        totalUseCount: 0,
        flowOut: 0,
        useCount: 0,
        totalCount: 0,
      };
    }
  }
})();

(function() {
  'use strict';

  ErpImportStatusSyncController.$inject = ["$timeout", "$state", "ERP_EXTRACTS", "ErpExtracts"];
  angular
    .module('core')
    .component('erpImportStatusSync', {
      controller: ErpImportStatusSyncController,
      templateUrl: 'app/core/components/erp-import-status-sync/erp-import-status-sync.html',
      bindings: {
        extractId: '=',
        status: '='
      }
    });

  function ErpImportStatusSyncController($timeout, $state, ERP_EXTRACTS, ErpExtracts) {
    var vm = this;
    vm.importInProgress = importInProgress;

    this.$onInit = function() {
      vm.statusTitle = ERP_EXTRACTS.STATUS_DESCRIPTION[vm.status];
      vm.polling = true;

      if(vm.polling && importInProgress()) {
        importStatusPolling();
      }
    };

    this.$onDestroy = function() {
      vm.polling = false;
    };

    function importInProgress() {
      return vm.status !== ERP_EXTRACTS.STATUS.READY && vm.status !== ERP_EXTRACTS.STATUS.ERROR && vm.status !== ERP_EXTRACTS.STATUS.NOT_IMPORTED;
    }

    function importStatusPolling() {
      $timeout(function() { //Poll for import status every 2 seconds.
        ErpExtracts.find(vm.extractId, {params:{nb:1}}).then(
          function(extract) {
            vm.status = extract.status;
            vm.statusTitle = ERP_EXTRACTS.STATUS_DESCRIPTION[vm.status];
            if(vm.polling) {
              if(importInProgress()) {
                importStatusPolling();
              } else {
                vm.polling = false;
                $state.go($state.current, {}, {reload: true});
              }
            }
          });
      }, 5000);
    }
  }

})();

(function() {
  'use strict';

  DialogHeaderController.$inject = ["$mdDialog"];
  angular
    .module('core')
    .component('dialogHeader', {
      templateUrl: 'app/core/components/dialog-header/dialog-header.html',
      bindings: { dialogTitle: '@', hideDefaultClose: '@' },
      controller: DialogHeaderController
    });

  function DialogHeaderController($mdDialog) {
    var vm = this;
    vm.closeDialog = $mdDialog.cancel;
    //vm.hideCloseBtn = vm.hideDefaultClose ? true : false;
    vm.hideCloseBtn = true; //hard setting this for all upload dialogs
  }
})();

(function() {
  'use strict';

  angular
    .module('core')
    .directive('checkImagePreviewPopover', CheckImagePreviewPopover);

  function CheckImagePreviewPopover() {
    var IMG_POPOVER_HEIGHT = 200;
    return {
      restrict: 'A',
      link: link
    };

    function link(scope, elem, attrs) {
      var template = getImageTemplate(attrs.front, attrs.back);
      elem.bind('mouseenter', function(e) {
        var position = e.target.getBoundingClientRect();
        var height = IMG_POPOVER_HEIGHT;
        var x = position.left + 60;
        var y = position.top - height - 18;
        template.css({
          top: y > 0 ? y : 0,
          left: x > 0 ? x : 0
        });
        angular.element('body').append(template);
      });

      elem.bind('mouseleave', function() {
        template.remove();
      });
    }
  }

  function getImageTemplate(frontUrl, backUrl) {
    var template = ['<div class="check-image-popover">'];
    if(frontUrl && frontUrl.startsWith('http')) {
      template.push('<img src=' + frontUrl +  '></img>');
    }
    if(backUrl && backUrl.startsWith('http')) {
      template.push('<img src=' + backUrl +  '></img>');
    }
    template.push('</div>');
    return angular.element(template.join(''));
  }

})();

(function() {
  'use strict';

  angular
    .module('core')
    .component('barChartLegend', {
      controller: BarChartLegendController,
      templateUrl: 'app/core/components/bar-chart-legend/bar-chart-legend.html',
      bindings: {
        chartData: '='
      }
    });

  function BarChartLegendController() {
    var vm = this;
    this.$onInit = function() {
      vm.chart = vm.chartData;
    };
  }
})();

(function() {
  'use strict';

  angular.module('admin', [
    'core',
    'projects'
  ]);
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('admin')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('admin.customer.engagements.users', {
        url: '/:projectId/users',
        resolve: {
          users: ["$stateParams", function($stateParams) {
            var projectUsersFacade = bridge.store.getFacade('projectUsers');
            projectUsersFacade.findProjectUsers_legacySupport($stateParams.projectId);
            return projectUsersFacade
              .allLoadedProjectUsers$_legacySupport_promise();
          }],
          project: ["$stateParams", function($stateParams) {
            var projectsFacade = bridge.store.getFacade('projects');
            projectsFacade.selectProject_legacySupport($stateParams.projectId);

            return projectsFacade.getSelectedLoadedProject$_legacySupport_promise();
          }]
        },
        views: {
          'content@admin': {
            templateUrl: 'app/admin/customers/engagements/engagement-users.html',
            controller: 'EngagementUsersController as $ctrl'
          }
        }
      });
  }
})();

(function() {
  'use strict';

  EngagementUsersController.$inject = ["customer", "project", "users"];
  angular
    .module('admin')
    .controller('EngagementUsersController', EngagementUsersController);

  function EngagementUsersController(
    customer,
    project,
    users) {
    var vm = this;

    activate();

    function activate() {
      vm.users = users;
      vm.customer = customer;
      vm.project = project;
    }
  }
})();

(function() {
  'use strict';

  EngagementUsersListTableController.$inject = ["$scope", "$stateParams", "$filter", "$mdDialog", "tableUtils", "toastr", "RBAC"];
  angular
    .module('admin')
    .component('engagementUsersListTable', {
      templateUrl: 'app/admin/customers/engagements/engagement-users-list-table.html',
      bindings:{
        users: '<'
      },
      controller: EngagementUsersListTableController
    });

  function EngagementUsersListTableController(
    $scope,
    $stateParams,
    $filter,
    $mdDialog,
    tableUtils,
    toastr,
    RBAC) {
    var vm = this;
    vm.projectId = $stateParams.projectId;
    vm.customerId = $stateParams.customerId;
    vm.selectedUsers = [];
    vm.selectAll = selectAll;
    vm.exportToCsv = exportToCsv;
    vm.openAddEngagementUserDialog = openAddEngagementUserDialog;
    vm.engagementUserActionDialog = engagementUserActionDialog;

    var exportParams = {
      fileName: _getExportName(),
      columnKeys: ['email', 'accessPolicies', 'firstName', 'lastName', 'enabled', 'lastActivity'],
      processCellCallback: exportCSVFormatCells
    };


    this.$onInit = function() {
      vm.columnDefs = [
        {
          headerName: 'Select',
          field: 'selected',
          checkboxSelection: function(params) {
            if(params.data) {
              return true;
            }
            return false;
          },
          width: 70,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true
        },
        {
          headerName: 'Email',
          field: 'email',
          width: 200
        },
        {
          headerName: 'Role',
          field: 'accessPolicies',
          width: 100,
          valueFormatter: function(params) {
            return _getRole(params);
          },
          getQuickFilterText: function(params) {
            return _getRole(params);
          }
        },
        {
          headerName: 'First Name',
          field: 'firstName',
          width: 200
        },
        {
          headerName: 'Last Name',
          field: 'lastName',
          width: 200
        },
        {
          headerName: 'Last Activity',
          field: 'lastActivity',
          width: 100,
          valueFormatter: function(params) {
            if(params.value) {
              return $filter('dateTimeFilter')(params.value);
            } else {
              return 'Never';
            }
          }
        }
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowData: vm.users,
        rowHeight: 30,
        headerHeight: 25,
        rowSelection: 'multiple',
        onRowSelected: _toggleRowSelected,
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        enableCellTextSelection: true,
        angularCompileRows: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onGridReady: function(params) {
          params.api.sizeColumnsToFit();
        }
      };
    };

    function _getRole(params) {
      if(params.value) {
        return RBAC.ROLE_DESCRIPTION[Object.keys(params.value)[0]];
      } else {
        return 'error';
      }
    }

    function openAddEngagementUserDialog() {
      var projectUsersFacade = bridge.store.getFacade('projectUsers');

      projectUsersFacade.loadAllUsers_legacySupport(vm.customerId);

      projectUsersFacade.getAllUnassignUsers$_legacySupport({take: 1, differentOfNil: true}).subscribe(function(unassginedCustomerUsers) {
        var unassignedCustomerUsersArray = Object.values(unassginedCustomerUsers);
        $mdDialog.show({
          templateUrl: 'app/admin/customers/engagements/add-engagement-user-dialog.html',
          controller: 'AddEngagementUsersController',
          controllerAs: '$ctrl',
          bindToController: true,
          locals: {
            unassginedCustomerUsers: unassignedCustomerUsersArray,
            projectUsers: vm.users,
            projectId: vm.projectId
          }
        });
      });
    }

    function engagementUserActionDialog(action) {
      $mdDialog.show({
        templateUrl: 'app/admin/customers/engagements/engagement-user-action-dialog.html',
        controller: 'EngagementUserActionDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          users: vm.selectedUsers,
          action: action,
          projectId: vm.projectId
        }
      });
    }

    function selectAll() {
      var selectedRows = vm.gridOptions.api.getSelectedRows();
      if (selectedRows.length) {
        vm.gridOptions.api.deselectAll();
      } else {
        vm.gridOptions.api.forEachNodeAfterFilter(function(node) {
          node.setSelected(true);
        });
      }
    }

    function _toggleRowSelected() {
      vm.selectedUsers = vm.gridOptions.api.getSelectedRows();
      $scope.$applyAsync();
    }

    function exportToCsv() {
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'lastActivity') {
          return $filter('dateTimeFilter')(params.value);
        } else if (params.column.colId === 'accessPolicies') {
          return _getRole(params);
        } else {
          return params.value;
        }
      } else {
        return params.value;
      }
    }

    function _getExportName() {
      return 'VALID8_ENGAGEMENT_USERS' + moment().format('MMYYYY') + '.csv';
    }
  }
})();

(function() {
  'use-strict';

  EngagementUserActionDialogController.$inject = ["$mdDialog", "$q", "$state", "$stateParams", "toastr", "users", "projectId", "action", "RBAC", "Authorization"];
  angular
    .module('admin')
    .controller('EngagementUserActionDialogController', EngagementUserActionDialogController);

  function EngagementUserActionDialogController(
    $mdDialog,
    $q,
    $state,
    $stateParams,
    toastr,
    users,
    projectId,
    action,
    RBAC,
    Authorization) {

    var vm = this;
    var rxjsSubs = [];

    vm.users = users;
    vm.action = action;
    vm.projectId = projectId;
    vm.save = save;
    vm.cancel = $mdDialog.cancel;

    vm.$onDestroy = function () {
      rxjsSubs.forEach(function (sub) {
        sub.complete();
      });
    };

    activate();

    function activate() {
      vm.role = RBAC.ROLES.ENGAGEMENT_USER;
      vm.chooseRole = false;
      if(vm.action === 'assign') {
        vm.chooseRole = true;
      }
    }

    function save() {
      vm.userIds = vm.users.map(function(u) {return u.id;});
      if(vm.userIds.length > 0) {
        var options = { projectId: vm.projectId };
        if(vm.action === 'assign') {
          options.role = vm.role;
        }
        var user = Authorization.getUserProfile();
        if(user) {
          for (var i = 0; i < vm.users.length; i++) {
            //logged user cannot remove himself from engagement...
            var a = vm.users[i];
            if (a.id === user.id && (['unassign'].indexOf(vm.action) >= 0)) {
              toastr.error('You can not remove yourself from an engagement');
              $mdDialog.hide(true);
              return;
            }
          }
        }

        var projectUsersFacade = bridge.store.getFacade('projectUsers');
        switch(vm.action) {
        case 'assign':
          doBatchOperation(
            projectUsersFacade,
            {
              selectorName: 'nextChangeUsersRoleSucceed$_legacySupport',
              message: 'Users role changed'
            },
            {
              actionName: 'changeUsersRole_legacySupport',
              params: [vm.projectId, vm.userIds, options.role]
            },
            {
              selectorName: 'nextChangeUsersRoleFailure$_legacySupport'
            }
          );
          break;
        case 'unassign':
          doBatchOperation(
            projectUsersFacade,
            {
              selectorName: 'nextUnassignProjectUsersSucceed$_legacySupport',
              message: 'Project Users unassigned'
            },
            {
              actionName: 'unassignProjectUsers_legacySupport',
              params: [vm.projectId, vm.userIds]
            },
            {
              selectorName: 'nextUnassignProjectUsersFailure$_legacySupport'
            }
          );
          break;
        }
      }
    }

    function doBatchOperation(facade, success, action, failure) {
      var succSub = facade[success.selectorName]()
        .subscribe(function () {
          toastr.success(success.message);
          $mdDialog.hide(true);
          $state.reload();
        });

      var failureSub = facade[failure.selectorName]()
        .subscribe(function () {
          toastr.error('An error ocurred');
          $mdDialog.hide(true);
        });

      rxjsSubs.push(succSub);
      rxjsSubs.push(failureSub);

      facade[action.actionName].apply(facade, action.params);
    }

  }
})();

(function() {
  'use strict';

  AddEngagementController.$inject = ["$q", "$stateParams", "$scope", "$state", "$timeout", "toastr", "$mdDialog", "Projects", "project", "$window", "customer"];
  angular
    .module('admin')
    .controller('AddEngagementController', AddEngagementController);

  function AddEngagementController(
    $q,
    $stateParams,
    $scope,
    $state,
    $timeout,
    toastr,
    $mdDialog,
    Projects,
    project,
    $window,
    customer) {
    var vm = this;
    var rxjsSubs = [];
    vm.submitSaveEngagement = submitSaveEngagement;
    vm.closeAddEngagement = $mdDialog.cancel;

    vm.$onDestroy = function () {
      rxjsSubs.forEach(function (sub) {
        sub.complete();
      });
    };

    activate();

    function activate() {
      vm.project = project;
      vm.customer = customer;
      vm.isEdit = vm.project.id;
      vm.project.customerId = customer.id;
      vm.project.type = vm.customer.type;
      if (!vm.project.options) {
        vm.project.options = {};
      }
      if (vm.project.type === 'audit') {
        if (!vm.project.options.traceType) {
          vm.project.options.traceType = 'cash_journal_trace';
        }
      } else {
        // These both need to default to true - backend also treats unset as true
        if (vm.project.options.normalizePayor !== false) {
          vm.project.options.normalizePayor = true;
        }
        if (vm.project.options.normalizePayee !== false) {
          vm.project.options.normalizePayee = true;
        }
      }
    }
    function submitSaveEngagement(form) {
      if(!form.$invalid) {
        if(vm.isEdit) {
          _saveProject();
        } else {
          _addProject();
        }
      }
    }

    function _success(message) {
      $timeout(function() {
        $mdDialog.cancel();
        toastr.success(message);
        $window.location.reload();

      
      }, 1000);
    }

    function _failure(message) {
      $mdDialog.cancel();
      toastr.error(message);
    }

    function _addProject() {
      if(vm.project) {
        var projectsFacade = bridge.store.getFacade('projects');
        rxjsSubs = [...rxjsSubs, projectsFacade.nextCreateProjectSuccess$_legacySupport().subscribe(function() {
          _success('Engagement has been successfully created.');
        })];
        rxjsSubs = [...rxjsSubs, projectsFacade.nextCreateProjectFailure$_legacySupport().subscribe(function() {
          _failure('There was an error creating the engagement');
        })];
        
        projectsFacade.createProject_legacySupport(vm.project);
      }
    }

    function _saveProject() {
      if(vm.project) {
        var projectsFacade = bridge.store.getFacade('projects');
        rxjsSubs = [...rxjsSubs, projectsFacade.nextUpdateProjectSuccess$_legacySupport().subscribe(function() {
          _success('Engagement has been successfully updated.');
        })];
        rxjsSubs = [...rxjsSubs, projectsFacade.nextUpdateProjectFailure$_legacySupport().subscribe(function() {
          _failure('There was an error updating the engagement');
        })];

        projectsFacade.updateProject_legacySupport(vm.project.id, vm.project);
      }
    }

  }
})();


(function() {
  'use strict';

  AddEngagementUsersController.$inject = ["$scope", "$state", "$timeout", "$mdDialog", "tableUtils", "toastr", "RBAC", "projectUsers", "unassginedCustomerUsers", "projectId"];
  angular
    .module('admin')
    .controller('AddEngagementUsersController', AddEngagementUsersController);

  function AddEngagementUsersController(
    $scope,
    $state,
    $timeout,
    $mdDialog,
    tableUtils,
    toastr,
    RBAC,
    projectUsers,
    unassginedCustomerUsers,
    projectId) {

    var vm = this;
    vm.close = close;
    vm.selectAll = selectAll;
    vm.selectedUsers = [];
    vm.assignUsers = assignUsers;
    var rxjsSubs = [];

    vm.$onDestroy = function () {
      rxjsSubs.forEach(function (sub) {
        sub.complete();
      });
    };


    this.$onInit = function() {
      vm.role = RBAC.ROLES.ENGAGEMENT_USER;
      vm.unassginedCustomerUsers = unassginedCustomerUsers;
      vm.projectUsers = projectUsers;
      vm.projectId = projectId;
      vm.columnDefs = [
        {
          headerName: 'Select',
          field: 'selected',
          checkboxSelection: function(params) {
            if(params.data) {
              return true;
            }
            return false;
          },
          width: 70,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true
        },
        { headerName: 'Email', field: 'email', width: 200},
        { headerName: 'First Name', field: 'firstName', width: 200},
        { headerName: 'Last Name', field: 'lastName', width: 200}
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        rowHeight: 30,
        headerHeight: 25,
        rowSelection: 'multiple',
        onRowSelected: _toggleRowSelected,
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        enableCellTextSelection: true,
        angularCompileRows: true,
        rowData: vm.unassginedCustomerUsers,
        onGridReady: function(params) { params.api.sizeColumnsToFit(); },
      };
    };

    function assignUsers() {
      vm.selectedIds = vm.selectedUsers.map(function(u) {return u.id;});
      if(vm.selectedIds.length > 0) {
        var options = {
          action: 'assign',
          projectId: vm.projectId,
          role: vm.role
        };
        var projectUsersFacade = bridge.store.getFacade('projectUsers');

        rxjsSubs = [...rxjsSubs, projectUsersFacade.nextChangeUsersRoleSucceed$_legacySupport().subscribe(function() {
          toastr.success("Users assigned to engagement");
          $mdDialog.hide(true);
          $timeout(function() {
            $state.reload();
          }, 1000);
        })];
        rxjsSubs = [...rxjsSubs, projectUsersFacade.nextChangeUsersRoleFailure$_legacySupport().subscribe(function() {
          toastr.error("An error ocurred");
          $mdDialog.hide(true);
        })];

        projectUsersFacade.changeUsersRole_legacySupport(vm.projectId, vm.selectedIds, options.role);

      }
    }

    function close() {
      $mdDialog.cancel();
    }

    function selectAll() {
      tableUtils.selectUnselectAll(vm.gridOptions);
    }

    function _toggleRowSelected() {
      vm.selectedUsers = vm.gridOptions.api.getSelectedRows();
      $scope.$applyAsync();
    }

  }
})();

(function() {
  'use strict';

  projectsNavigationService.$inject = ["$state", "PROJECT_TYPES"];
  angular
    .module('projects')
    .factory('projectsNavigationService', projectsNavigationService);

  function projectsNavigationService($state, PROJECT_TYPES) {
    return {
      goToProjectOverview: goToProjectOverview,
      goToAccountTransactions: goToAccountTransactions,
      goToTransaction: goToTransaction,
      goToAccountEdit: goToAccountEdit,
      goToProjectEdit: goToProjectEdit
    };

    function goToProjectOverview(project) {
      if (project.type === PROJECT_TYPES.AUDIT) {
        $state.go('engagement.overview', { projectId: project.id });
      } else if (project.type === PROJECT_TYPES.FORENSIC) {
        $state.go('project.overview', {projectId: project.id});
      }
    }

    function goToAccountTransactions(account) {
      $state.go('project.accounts.accountDetail', { accountId: account });
    }

    function goToTransaction(transaction) {
      $state.go('project.accounts.accountDetail.transaction', { transactionId: transaction });
    }

    function goToAccountEdit(account) {
      $state.go('project.accounts.accountEdit', { accountId: account });
    }

    function goToProjectEdit(project) {
      if (project.type === PROJECT_TYPES.AUDIT) {
        $state.go('engagement.edit', { projectId: project.id });
      }
      else if (project.type === PROJECT_TYPES.FORENSIC) {
        $state.go('project.edit', { projectId: project.id });
      }
    }

  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('project', {
        url: '/:projectId',
        abstract: true,
        parent: 'projects',
        views: {
          'nav-sub-menu@app': {
            templateUrl: 'app/projects/project/project-menu.html',
            controller: 'ProjectMenuController as $ctrl'
          }
        },
        resolve: {
          project: ["$stateParams", "Projects", function($stateParams, Projects) {
            return Projects.find($stateParams.projectId);
          }]
        }
      })
      .state('project.overview', {
        url: '',
        resolve: {
          accounts: ["$stateParams", "Accounts", "ACCOUNTS", function($stateParams, Accounts, ACCOUNTS) {
            return Accounts.findAll({ projectId: $stateParams.projectId, exclude: [ACCOUNTS.TYPE.ERP], charts: true }, {bypassCache: true});
          }],
          project: ["$stateParams", "Projects", function($stateParams, Projects) {
            return Projects.find($stateParams.projectId, {bypassCache: true});
          }],
          user: function() {
            var coreFacade = bridge.store.getFacade('core');

            return coreFacade.loggedUser$_legacySupport_promise();
          }
        },
        views: {
          'content@projects': {
            templateUrl: 'app/projects/project/project-overview.html',
            controller: 'ProjectOverviewController as $ctrl'
          }
        }
      })
      .state('project.edit', {
        url: '/edit',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/add-project.html',
            controller: 'AddProjectController as $ctrl'
          }
        },
        resolve: {
          project: ["$stateParams", "Projects", function($stateParams, Projects) {
            return Projects.find($stateParams.projectId);
          }],
          user: function() {
            var coreFacade = bridge.store.getFacade('core');

            return coreFacade.loggedUser$_legacySupport_promise();
          }
        }
      });
  }
})();

(function() {
  'use strict';

  ProjectOverviewController.$inject = ["$state", "$stateParams", "toastr", "chartUtils", "accounts", "project"];
  angular
    .module('projects')
    .controller('ProjectOverviewController', ProjectOverviewController);

  function ProjectOverviewController(
    $state,
    $stateParams,
    toastr,
    chartUtils,
    accounts,
    project) {

    var vm = this;

    activate();

    function activate() {
      vm.accounts = accounts;
      vm.project = project;
      vm.chart = chartUtils.formatDonutChart(vm.project.projectDonutChart);
    }
  }
})();

(function() {
  'use strict';

  ProjectMenuController.$inject = ["$state", "ENV", "Authorization", "RBAC", "STATEMENTS", "project"];
  angular
    .module('projects')
    .controller('ProjectMenuController', ProjectMenuController);

  function ProjectMenuController(
    $state,
    ENV,
    Authorization,
    RBAC,
    STATEMENTS,
    project) {
    var vm = this;
    vm.goToLoad = goToLoad;
    activate();

    function activate() {
      vm.checksEnabled = ENV.featureFlags.checks;
      vm.project = project;
      vm.sourceDesc = STATEMENTS.SOURCE_DESCRIPTION;
      vm.hasPermissions = Authorization.hasProjectAccess(vm.project.type, vm.project.id, [], [RBAC.ROLES.ENGAGEMENT_OWNER]);
    }

    function goToLoad(source) {
      switch(source) {
      case STATEMENTS.SOURCE.BANK_PDF:
        $state.go('project.account-periods', { source: source, status: 'all-items' });
        break;
      case STATEMENTS.SOURCE.BROKERAGE_LOAN_PDF:
        $state.go('project.account-periods', { source: source, status: 'all-items' });
        break;
      case STATEMENTS.SOURCE.TXN_CSV:
        $state.go('project.documents.statements', { source: source });
        break;
      case STATEMENTS.SOURCE.CHECKS_PDF:
        $state.go('project.check-items', { status: 'unmatched' });
        break;
      }
    }

  }
})();
(function() {
  'use strict';

  AccountsListTableController.$inject = ["$filter", "$state", "tableUtils", "projectsNavigationService", "$mdDialog", "toastr", "Authorization", "Projects", "PROJECT_TYPES", "RBAC", "REPORTS", "Reports", "messagingService", "transactionUtils"];
  angular
    .module('projects')
    .component('accountsListTable', {
      templateUrl: 'app/projects/project/accounts-list-table.html',
      bindings: {
        accounts: '<',
        type: '@'
      },
      controller: AccountsListTableController
    });
  
  function AccountsListTableController(
    $filter,
    $state,
    tableUtils,
    projectsNavigationService,
    $mdDialog,
    toastr,
    Authorization,
    Projects,
    PROJECT_TYPES,
    RBAC,
    REPORTS, 
    Reports, 
    messagingService,
    transactionUtils) {
    
    var vm = this;
    var GRID_ID = 'grid-accounts';
    var GRID_VERSION = 2;
    vm.refreshingStatus = false;
    vm.exportToCsv = exportToCsv;
    vm.updateMetrics = updateMetrics;
    vm.fixDateGaps = fixDateGaps;
    vm.excelDateGapExport = excelDateGapExport;
    vm.canFixDateGaps = false;

    var exportParams;
    
    this.$onInit = function() {
      exportParams = {
        fileName: _getExportName(),
        columnKeys: ['entity.name', 'name', 'bank', 'number', 'type', 'statusBarChart' ],
        processCellCallback: exportCSVFormatCells
      };

      vm.canFixDateGaps = Authorization.hasProjectAccess(vm.type, $state.params.projectId, [RBAC.ROLES.ENGAGEMENT_OWNER], [RBAC.ROLES.ENGAGEMENT_OWNER]);

      var isProjectAdmin = Authorization.isV8Admin();
      //Set a size for this table.
      if(PROJECT_TYPES.AUDIT === vm.type) {
        vm.tableHeight = vm.accounts.length > 6 ? 200 : 36 * (vm.accounts.length + 1);
      }
      var columnDefs = [
        {
          headerName: 'Delete',
          width: 70,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          pinned: 'left',
          hide: !isProjectAdmin || vm.type === PROJECT_TYPES.AUDIT,
          suppressColumnsToolPanel: !isProjectAdmin,
          cellClass: 'links icons',
          cellRenderer: function() {
            return '<md-icon class="material-icons icon-primary">delete</md-icon>';
          },
          onCellClicked: function(params) {
            return _deleteAccount(params.data);
          }
        },
        {
          headerName: 'View',
          width: 55,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          pinned: 'left',
          cellClass: 'links',
          cellRenderer: function() {
            return '<md-icon class="material-icons icon-primary">visibility</md-icon>';
          },
          onCellClicked: function(params) {
            if(vm.type === PROJECT_TYPES.AUDIT){
              $state.go('engagement.accountDetail', { accountId: params.data.id });
            }
            else {
              projectsNavigationService.goToAccountTransactions(params.data.id);
            }
          }
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 300,
          hide: true,
        },
        {
          headerName: 'Entity',
          field: 'entity.name',
          sort: 'asc',
          width: 300,
          minWidth: vm.type === PROJECT_TYPES.AUDIT ? 200 : 50
        },
        {
          headerName: 'Name',
          field: 'name',
          width: 400,
          minWidth: vm.type === PROJECT_TYPES.AUDIT ? 200 : 50
        },
        {
          headerName: 'Institution',
          field: 'bank',
          hide: vm.type === PROJECT_TYPES.AUDIT,
          suppressColumnsToolPanel: vm.type === PROJECT_TYPES.AUDIT,
          width: 200
        },
        { headerName: 'Account #',
          field: 'number',
          hide: vm.type === PROJECT_TYPES.AUDIT,
          suppressColumnsToolPanel: vm.type === PROJECT_TYPES.AUDIT,
          width: 200
        },
        { 
          headerName: 'Account Type',
          field: 'type',
          width: 200,
          minWidth: 100,
          valueFormatter: function(params) {
            if(!params.data) {
              return '';
            }
            return $filter('accountTypeDisplay')(params.value);
          }
        },
        {
          headerName: 'Status',
          field: 'statusBarChart',
          sortable: false,
          suppressSizeToFit: true,
          width: 800,
          minWidth: vm.type === PROJECT_TYPES.AUDIT ? 800 : 500,
          cellClass: 'status',
          cellRenderer: function() {
            return '<status-bar-chart status-bar-data="data.statusBarChart" account-id="data.id" project-type="$ctrl.type"></status-bar-chart>';
          }
        }
      ];

      vm.gridOptions = {
        columnDefs: columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowData: vm.accounts,
        angularCompileRows: true,
        rowHeight: 30,
        headerHeight: 25,
        suppressCellSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        getMainMenuItems: tableUtils.getMainMenuItems,
        onGridReady: function(params) {
          tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID, GRID_VERSION);
          _adjustSize(params);
        },
        onGridSizeChanged: function(params) { _adjustSize(params); },
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange,
        popupParent: document.querySelector("body")
      };
    };

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID, GRID_VERSION);
    }

    function _adjustSize(params) {
      if(params) {
        if(!tableUtils.getGridState(GRID_ID, GRID_VERSION)) {
          params.api.sizeColumnsToFit();
        }
        if(vm.type === PROJECT_TYPES.FORENSIC) {
          params.api.setDomLayout('autoHeight');
        }
      }
    }

    function exportToCsv() {
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'statusBarChart') {
          if(params.value && params.value.startDate && params.value.endDate) {
            return $filter('dateDisplay')(params.value.startDate) + ' to ' + $filter('dateDisplay')(params.value.endDate);
          }
        } else if (params.column.colId === 'type') {
          return $filter('accountTypeDisplay')(params.value);
        } else {
          return params.value;
        }
      } else {
        return params.value;
      }
    }

    function _getExportName() {
      var project = Projects.get($state.params.projectId);
      var name = '';
      if(project) {
        name = project.name;
      }
      return name + '_Accounts_' + moment().format('MMYYYY') + '.csv';
    }

    function updateMetrics() {
      Projects.updateMetrics($state.params.projectId).then(
        function Success() {
          vm.refreshingStatus = true;
          var options = {
            timeOut: 15000,
            tapToDismiss: false,
            onHidden: function() {
              vm.refreshingStatus = false;
              $state.reload();
            }
          };
          toastr.success('Refreshing project status...', null, options);
        }
      );
    }

    function fixDateGaps() {
      Projects.fixDateGaps($state.params.projectId).then(
        function Success() {
          vm.fixingDateGaps = true;
          var options = {
            timeOut: 30000,
            tapToDismiss: false,
            onHidden: function() {
              vm.fixingDateGaps = false;
              $state.reload();
            }
          };
          toastr.success('Fixing date gaps...', null, options);
        }
      );
    }

    function _deleteAccount(account) {
      $mdDialog.show({
        templateUrl: 'app/projects/project/account/delete-account-dialog.html',
        controller: 'DeleteAccountController',
        locals: {
          account: account,
          reload: true,
        },
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success(shouldReload) {
        if(shouldReload) {
          vm.reloadData();
        } else if (vm.gridOptions.api) {
          vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        }
      });
    }
    
    function excelDateGapExport() {
      _launchReport(REPORTS.TYPE.DATEGAP);
    }

    function _launchReport(type) {
      var params = transactionUtils.getFilterParams($state.params);
      var report = {
        type: type,
        projectId: params.projectId,
        query: params
      };
      Reports.create(report).then(function Success() {
        messagingService.setMessage({
          messageText: 'Export started. Check progress in the Files section'
        });
        messagingService.updateMessages();
      }).catch(function Failure() {
        messagingService.setMessage({
          messageType: 'error',
          messageText: 'Export Failure.'
        });
        messagingService.updateMessages();
      });
    }
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('engagement', {
        url: '/:projectId',
        abstract: true,
        parent: 'engagements',
        views: {
          'nav-sub-menu@app': {
            templateUrl: 'app/projects/engagement/engagement-menu.html',
            controller: 'EngagementMenuController as $ctrl'
          }
        },
        resolve: {
          project: ["$stateParams", "Projects", function($stateParams, Projects) {
            return Projects.find($stateParams.projectId);
          }],
          extracts: ["$stateParams", "ErpExtracts", function($stateParams, ErpExtracts){
            return ErpExtracts.findAll({projectId: $stateParams.projectId});
          }]
        }
      })
      .state('engagement.overview', {
        url: '',
        resolve: {
          extracts: ["$stateParams", "ErpExtracts", function($stateParams, ErpExtracts){
            return ErpExtracts.findAll({projectId: $stateParams.projectId});
          }],
          reconciliations: ["$stateParams", "Reconciliations", function($stateParams, Reconciliations){
            return Reconciliations.findAll({projectId: $stateParams.projectId});
          }],
          accounts: ["$stateParams", "Accounts", "ACCOUNTS", function($stateParams, Accounts, ACCOUNTS) {
            return Accounts.findAll({ projectId: $stateParams.projectId, exclude: [ACCOUNTS.TYPE.ERP], enabled: true, charts: true }, {bypassCache: true});
          }],
          project: ["$stateParams", "Projects", function($stateParams, Projects) {
            return Projects.find($stateParams.projectId, {bypassCache: true});
          }],
          user: function() {
            var coreFacade = bridge.store.getFacade('core');

            return coreFacade.loggedUser$_legacySupport_promise();
          },
          workpapers: ["$stateParams", "Reports", "REPORTS", "tableUtils", function($stateParams, Reports, REPORTS, tableUtils) {
            var $stateParamsClone = Object.assign({}, $stateParams);
            if(!$stateParamsClone.sortModel) {
              $stateParamsClone.sortModel = 'createdAt';
              $stateParamsClone.sortOrder = 'desc';
            }
            var workpaperTypes = [REPORTS.TYPE.FINANCIALS, REPORTS.TYPE.REVENUE, REPORTS.TYPE.EXPENSE, REPORTS.TYPE.SUBSEQUENT_AR, REPORTS.TYPE.SAMPLE_BASED];
            var params = angular.extend({ projectId: $stateParamsClone.projectId, type: workpaperTypes }, tableUtils.formatPagingParams($stateParamsClone));
            return Reports.findAll(params, {bypassCache: true});
          }]
        },
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/engagement/engagement-overview.html',
            controller: 'EngagementOverviewController as $ctrl'
          }
        }
      })
      .state('engagement.edit', {
        url: '/edit',
        views: {
          'content@engagements': {
            templateUrl: 'app/projects/add-project.html',
            controller: 'AddProjectController as $ctrl'
          }
        },
        resolve: {
          project: ["$stateParams", "Projects", function($stateParams, Projects) {
            return Projects.find($stateParams.projectId);
          }],
          user: function() {
            var coreFacade = bridge.store.getFacade('core');

            return coreFacade.loggedUser$_legacySupport_promise();
          }
        }
      });
  }
})();

(function() {
  'use strict';

  EngagementOverviewController.$inject = ["$state", "$scope", "$stateParams", "$mdDialog", "$timeout", "toastr", "Projects", "Reconciliations", "ErpExtracts", "ERP_EXTRACTS", "CHART_STATUS", "REPORTS", "chartUtils", "accounts", "project", "workpapers", "extracts", "reconciliations", "RECONCILIATIONS", "$window"];
  angular
    .module('projects')
    .controller('EngagementOverviewController', EngagementOverviewController);

  function EngagementOverviewController(
    $state,
    $scope,
    $stateParams,
    $mdDialog,
    $timeout,
    toastr,
    Projects,
    Reconciliations,
    ErpExtracts,
    ERP_EXTRACTS,
    CHART_STATUS,
    REPORTS,
    chartUtils,
    accounts,
    project,
    workpapers,
    extracts,
    reconciliations,
    RECONCILIATIONS,
    $window) {
    var vm = this;
    vm.activeErpExtract = null;
    vm.updateMetrics = updateMetrics;
    vm.createWorkpaperDialog = createWorkpaperDialog;
    vm.createReconciliationDialog = createReconciliationDialog;
    vm.refreshingStatus = false;
    if ($window.sessionStorage.getItem("engagementOverview.expanded.erp") === null) {
      $window.sessionStorage.setItem("engagementOverview.expanded.erp", false);
      $window.sessionStorage.setItem("engagementOverview.expanded.bank", false);
      $window.sessionStorage.setItem("engagementOverview.expanded.match", false);
    }
    vm.expanded = {
      erp: $window.sessionStorage.getItem("engagementOverview.expanded.erp") === 'true',
      bank: $window.sessionStorage.getItem("engagementOverview.expanded.bank") === 'true',
      match: $window.sessionStorage.getItem("engagementOverview.expanded.match") === 'true'
    };
    vm.expandCollapse = expandCollapse;
    vm.syncValidisExtracts = syncValidisExtracts;

    activate();

    function activate() {
      vm.activeErpExtract = _.find(extracts, { active: true});
      if(vm.activeErpExtract) {
        vm.extractLoading = vm.activeErpExtract ? ErpExtracts.isLoading(vm.activeErpExtract.status) : false;
        vm.extractError = vm.activeErpExtract.status === ERP_EXTRACTS.STATUS.ERROR;
      }

      vm.accounts = accounts;
      vm.workpapers = workpapers;
      vm.project = project;
      vm.newWorkpaperType = _getNewWorkpaperType(vm.project);
      vm.extracts = extracts;
      vm.reconciliations = reconciliations;
      vm.match = {
        coverage: 0,
        startDate: '',
        endDate: ''
      };

      _checkRunningMatch();
      if(vm.reconciliations && vm.reconciliations.length > 0 && !vm.isMatching) {
        var rec = vm.reconciliations[0];
        if(rec.data.cj) {
          vm.match.coverage = rec.status === RECONCILIATIONS.STATUS.RECONCILED ? 1 : rec.data.cj.coverage;
        }
        vm.match.startDate = rec.startDate;
        vm.match.endDate = rec.endDate;
      }
      vm.chart = chartUtils.formatDonutChart(vm.project.projectDonutChart);
      vm.hasBankData = hasBankData();
    }

    function _getNewWorkpaperType(project) {
      if (project.options) {
        if (project.options.subsARVerification) {
          return REPORTS.TYPE.SUBSEQUENT_AR;
        }
        if (project.options.sampleBasedVerification) {
          return REPORTS.TYPE.SAMPLE_BASED;
        }
      }
      return REPORTS.TYPE.FINANCIALS;
    }

    function expandCollapse(section){
      vm.expanded[section] = !vm.expanded[section];
      $window.sessionStorage.setItem("engagementOverview.expanded." + section, vm.expanded[section]);
    }

    function updateMetrics() {
      Projects.updateMetrics($state.params.projectId).then(
        function Success() {
          vm.refreshingStatus = true;
          var options = {
            timeOut: 10000,
            tapToDismiss: false,
            onHidden: function() {
              vm.refreshingStatus = false;
              $state.reload();
            }
          };
          toastr.success('Refreshing project status...', null, options);
        }
      );
    }

    function createReconciliationDialog(){
      $mdDialog.show({
        templateUrl: 'app/projects/engagement/reconciliations/create-reconciliation-dialog.html',
        controller: 'CreateReconciliationController',
        controllerAs: '$ctrl',
        bindToController: true
      });
    }

    function createWorkpaperDialog(type){
      $mdDialog.show({
        templateUrl: 'app/projects/engagement/workpapers/create-workpaper-dialog.html',
        controller: 'CreateWorkpaperController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          type: type
        }
      });
    }

    function syncValidisExtracts() {
      ErpExtracts.syncValidisExtracts(vm.project.id)
        .then( function() {
          toastr.success('Validis extracts updated');
          $state.reload();
        })
        .catch( function() {
          toastr.success('There was an error fetching Validis extracts.');
          $state.reload();
        });
    }

    function hasBankData(){
      if(vm.project.projectDonutChart){
        var reconciled = vm.project.projectDonutChart.reconciled;
        return reconciled > 0;
      }
      return false;
    }

    function _checkRunningMatch() {
      vm.isMatching = false;
      var reconciliation = reconciliations[0];
      if(reconciliation) {
        vm.isMatching = Reconciliations.isLoading(reconciliation.status);
      }
    }

  }
})();

(function() {
  'use strict';

  EngagementMenuController.$inject = ["$state", "Authorization", "STATEMENTS", "ErpExtracts", "project", "extracts"];
  angular
    .module('projects')
    .controller('EngagementMenuController', EngagementMenuController);

  function EngagementMenuController(
    $state,
    Authorization,
    STATEMENTS,
    ErpExtracts,
    project,
    extracts) {
    var vm = this;
    vm.activeErpExtract = null;
    vm.goToLoad = goToLoad;
    activate();

    function activate() {
      vm.project = project;
      vm.sourceDesc = STATEMENTS.SOURCE_DESCRIPTION;
      vm.isV8Admin = Authorization.isV8Admin();
      vm.activeErpExtract = _.find(extracts, { active: true});
      vm.loading = vm.activeErpExtract ? ErpExtracts.isLoading(vm.activeErpExtract.status) : false;
    }

    function goToLoad(source) {
      switch(source) {
      case STATEMENTS.SOURCE.BANK_PDF:
        $state.go('engagement.account-periods', { source: source, status: 'all-items' });
        break;
      case STATEMENTS.SOURCE.BROKERAGE_LOAN_PDF:
        $state.go('engagement.account-periods', { source: source, status: 'all-items' });
        break;
      case STATEMENTS.SOURCE.TXN_CSV:
        $state.go('engagement.statements', { source: source });
        break;
      }
    }

  }
})();

(function() {
  'use strict';

  tableUtils.$inject = ["ENV", "$filter", "$window"];
  angular
    .module('core')
    .factory('tableUtils', tableUtils);

  function tableUtils(ENV, $filter, $window) {
    var DEFAULT_PAGE_SIZE = ENV.defaultPageSize || 1000;

    return {
      getPagingParams: getPagingParams,
      formatPagingParams: formatPagingParams,
      getFormattedCurrency: getFormattedCurrency,
      getDefaultColDefs: getDefaultColDefs,
      getMainMenuItems: getMainMenuItems,
      getContextMenuItems: getContextMenuItems,
      selectUnselectAll: selectUnselectAll,
      saveGridState: saveGridState,
      setGridState: setGridState,
      getGridState: getGridState,
      setColumnSort: setColumnSort
    };

    function selectUnselectAll(agGridOptions, serverSide) {
      if(!agGridOptions) {
        return;
      }
      var selectedRows = agGridOptions.api.getSelectedRows();
      if (selectedRows.length) {
        agGridOptions.api.deselectAll();
      } else {
        var counter = 0;
        if(serverSide) {
          agGridOptions.api.forEachNode(function(node, index) {
            counter++;
            if(index < DEFAULT_PAGE_SIZE) {
              node.setSelected(true);
            }
          });
        } else {
          agGridOptions.api.forEachNodeAfterFilter(function(node, index) {
            counter++;
            if(index < DEFAULT_PAGE_SIZE) {
              node.setSelected(true);
            }
          });
        }
        if(counter > DEFAULT_PAGE_SIZE) {
          alert(`"Select All" applied to the max limit of ${DEFAULT_PAGE_SIZE} rows`);
        }
      }
    }

    function getPagingParams(stateParams) {
      return {
        sortOrder: stateParams.sortOrder,
        sortModel: stateParams.sortModel,
        keyword: stateParams.keyword,
        pageSize: parseInt(stateParams.pageSize) || DEFAULT_PAGE_SIZE,
        skipCount: parseInt(stateParams.skipCount) || 0
      };
    }

    function formatPagingParams(stateParams, formatForPost = false) {
      var params = {
        keyword: stateParams.keyword,
        $limit: parseInt(stateParams.pageSize) || DEFAULT_PAGE_SIZE,
        $skip: parseInt(stateParams.skipCount) || 0
      };
      if(stateParams.sortOrder && stateParams.sortModel) {
        var sortOrder = stateParams.sortOrder === 'asc' ? 1 : -1;
        if (formatForPost) {
          // Format the parameters for POST body
          var sortObj = {};
          sortObj[stateParams.sortModel] = sortOrder;
          params['$sort'] = sortObj;
        } else {
          // Format the parameters for GET query string
          var sortField = '$sort[' + stateParams.sortModel + ']';
          params[sortField] = sortOrder;
        }
      }
      return params;
    }

    function getFormattedCurrency(value) {
      if(value < 0) {
        return '($' + $filter('number')(-value) + ')';
      }
      return '$' + $filter('number')(value);
    }

    function getDefaultColDefs() {
      return {
        sortable: true,
        resizable: true,
        menuTabs: ['generalMenuTab', 'columnsMenuTab']
      };
    }

    function getContextMenuItems() {
      return ['autoSizeAll', 'resetColumns'];
    }

    function getMainMenuItems(params){
      var finalMenuItem = [];
      var itemsToExclude = "toolPanel";
      params.defaultItems.forEach(function(item) {
        if (itemsToExclude.indexOf(item) < 0) {
          finalMenuItem.push(item);
        }
      });
      return finalMenuItem;
    }

    // These functions save and load the grid/column state in local storage. Previously, we just
    // saved the raw array from getColumnState() but there are some problems in ag-grid, specifically
    // if we add/remove columns and reload that state, we can have issues, so now we save an object
    // with an explicit version. We assume if we load an array, it's version 0 for backwards compatibility,
    // and so that going forward, if we have change columns and we load an array we'll just drop it and
    // recreate to avoid this class of bugs
    function saveGridState(columnApi, gridId, version = 0) {
      var columnState = columnApi.getColumnState();
      var gridState = JSON.stringify({gridState: columnState, version});
      $window.localStorage.setItem(gridId, gridState);
    }

    function getGridState(gridId, version = 0) {
      var gridState = JSON.parse($window.localStorage.getItem(gridId));
      if (!gridState) {
        return gridState;
      }
      if (Array.isArray(gridState)) {
        if (version > 0) {
          return null;
        }
        return gridState;
      }
      if (version !== gridState.version) {
        return null;
      }
      return gridState.gridState;
    }

    function setGridState(columnApi, gridId, version = 0) {
      var columnState = getGridState(gridId, version);
      if (columnState) {
        columnApi.setColumnState(columnState);
      }
    }

    function setColumnSort(pagination, columnDefs) {
      columnDefs.forEach(function(column) {
        if(column.field === pagination.sortModel || column.colId === pagination.sortModel) {
          column.sort = pagination.sortOrder;
        }
      });
    }

  }
})();

(function() {
  'use strict';

  rolesService.$inject = ["DSHttpAdapter"];
  angular
    .module('core')
    .factory('rolesService', rolesService);

  function rolesService(DSHttpAdapter) {
    return {
      addRole: addRole
    };

    function addRole(roleName, userId, projectId) {
      var data = {
        roleName: roleName,
        userId: userId,
        projectId: projectId
      };
      return DSHttpAdapter.HTTP({
        method: 'POST',
        url: DSHttpAdapter.defaults.basePath + '/userRoles',
        data: data
      });
    }
  }
})();

(function() {
  'use script';

  plaidService.$inject = ["DSHttpAdapter", "toastr"];
  angular
    .module('core')
    .service('plaidService', plaidService);

  function plaidService(DSHttpAdapter, toastr) {
    return {
      create: create
    };

    function create(successCallback) {
      return DSHttpAdapter.GET(DSHttpAdapter.defaults.basePath + '/plaid-token')
        .then(function(response) {
          if(!response.data || response.data.error != null) {
            throw new Error('Failed to initialize Plaid');
          }
          return Plaid.create({
            token: response.data.link_token,
            selectAccount: true,
            onSuccess: function(public_token, metadata) {
              successCallback(metadata);
            },
            onExit: function(err) {
              if (err !== null) {
                toastr.error(err.display_message);
              }
            }
          });
        });
    }
  }
})();

(function() {
  'use strict';

  messagingService.$inject = ["$rootScope"];
  angular
    .module('core')
    .factory('messagingService', messagingService);

  function messagingService($rootScope) {
    var messages = [];
    return {
      setMessage: setMessage,
      getMessages: getMessages,
      updateMessages: updateMessages
    };

    function setMessage(message) {
      message = {
        messageType: message.messageType || 'general',
        messageText: message.messageText,
        linkText: message.linkText || null,
        link: message.link || null
      };
      messages.push(message);
    }

    function getMessages() {
      var currentMessages = messages;
      messages = [];
      return currentMessages;
    }

    function updateMessages() {
      $rootScope.$broadcast('updateMessages');
    }
  }
})();

(function() {
  'use strict';

  dateUtils.$inject = ["DATE_FORMATS"];
  angular
    .module('core')
    .factory('dateUtils', dateUtils);

  function dateUtils(DATE_FORMATS) {
    return {
      formatDates: formatDates,
      formatUrlDates: formatUrlDates
    };

    function formatDates(objData) {
      for(var variable in objData) {
        if(objData.hasOwnProperty(variable)) {
          if(typeof objData[variable] === Object) {
            objData[variable] = formatDates(objData[variable]);
          } else if( isNaN(objData[variable]) && moment(objData[variable], moment.ISO_8601, true).isValid()) {
            objData[variable] = moment.utc(objData[variable]).toDate();
            //V8F-1429: Hack to preserve the correct date. No longer needed objData[variable] = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
            //Overriden by V8F-2564
          }
        }
      }
    }

    function formatUrlDates(params) {
      return _.mapValues(params, function(param) {
        if(moment.isDate(param)) {
          param = moment(param).format(DATE_FORMATS.ISO);
        }
        return param;
      });
    }
  }
})();

(function() {
  'use strict';

  chartUtils.$inject = ["CHART_STATUS", "STATEMENTS", "ACCOUNT_PERIODS"];
  angular
    .module('core')
    .factory('chartUtils', chartUtils);

  function chartUtils(CHART_STATUS, STATEMENTS, ACCOUNT_PERIODS) {
    return {
      formatDonutChart: formatDonutChart
    };

    function formatDonutChart(chartData) {
      //Data from backend must match chartData series.
      if(!_.isEmpty(chartData)) {
        var chart = { legends: [], data: []};
        var total = 0;
        _.forEach(CHART_STATUS.SERIES, function(status) {
          if(chartData[status]) {
            total += parseInt(chartData[status]);
          }
        });
        _.forEach(CHART_STATUS.SERIES, function(status) {
          var count = chartData[status];
          chart.legends.push({
            label: STATEMENTS.STATUS_DESCRIPTION[status] || ACCOUNT_PERIODS.STATUS_DESCRIPTION[status],
            percentage: Math.round((count / total) * 100),
            name: status});
          if (count > 0) {
            chart.data.push({
              percentage: Math.round((count / total) * 100),
              count: count,
              name: status});
          } else {
            chart.data.push({
              percentage: 0.0,
              count: 0,
              name: status});
          }
        });
        return chart;
      } else {
        return {};
      }
    }

  }
})();

(function() {
  'use strict';

  transactionTypeDisplay.$inject = ["TRANSACTION_TYPES"];
  angular
    .module('core')
    .filter('transactionTypeDisplay', transactionTypeDisplay);

  function transactionTypeDisplay(TRANSACTION_TYPES) {
    return function(type) {
      return TRANSACTION_TYPES.TYPE_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  statementStatusDisplay.$inject = ["STATEMENTS"];
  angular
    .module('core')
    .filter('statementStatusDisplay', statementStatusDisplay);

  function statementStatusDisplay(STATEMENTS) {
    return function(type) {
      return STATEMENTS.STATUS_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  statementSourceDisplay.$inject = ["STATEMENTS"];
  angular
    .module('core')
    .filter('statementSourceDisplay', statementSourceDisplay);

  function statementSourceDisplay(STATEMENTS) {
    return function(type) {
      return STATEMENTS.SOURCE_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  roleDisplay.$inject = ["RBAC"];
  angular
    .module('core')
    .filter('roleDisplay', roleDisplay);

  function roleDisplay(RBAC) {
    return function(role) {
      return RBAC.ROLE_DESCRIPTION[role] || '';
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('core')
    .filter('percentageDisplay', percentageDisplayFilter);

  function percentageDisplayFilter() {
    return function(amount) {
      if(!amount && amount !== 0) {
        return '';
      }
      return (parseFloat(amount) * 100).toFixed(2) + '%';
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('core')
    .filter('filenameDisplay', filenameDisplay);

  function filenameDisplay() {
    return function(filename) {
      if (filename !== null && angular.isDefined(filename)) {
        if (filename.lastIndexOf('/') >= 0) {
          return filename.substring(filename.lastIndexOf('/') + 1);
        }
        else {
          return filename;
        }
      }
      else {
        return '';
      }

    };
  }
})();

(function() {
  'use strict';

  angular
    .module('core')
    .filter('fileSizeDisplay', fileSizeDisplay);

  function fileSizeDisplay() {
    return function(size) {
      var base, prefixes;
      base = 1000;
      prefixes = ['k','M','G','T','P','E','Z','Y'];
   
      var exp = Math.log(size) / Math.log(base) | 0;
      return (size / Math.pow(base, exp)).toFixed(1) + ' ' +
        ((exp > 0) ? prefixes[exp - 1] + 'B' : 'Bytes');
    };
  }
})();

(function() {
  'use strict';

  dateTimeFilter.$inject = ["DATE_FORMATS"];
  angular
    .module('core')
    .filter('dateTimeFilter', dateTimeFilter);

  function dateTimeFilter(DATE_FORMATS) {
    return function(dateTime) {
      var momentDate = moment(dateTime);
      return momentDate.isValid() ? moment(dateTime).format(DATE_FORMATS.DATE_TIME) : '';
    };
  }

})();

(function() {
  'use strict';

  dateDisplay.$inject = ["DATE_FORMATS"];
  angular
    .module('core')
    .filter('dateDisplay', dateDisplay);

  function dateDisplay(DATE_FORMATS) {
    return function(date) {
      if(moment(date).isValid()) {
        date = moment(date).format(DATE_FORMATS.STANDARD);
      }
      return date;
    };
  }
})();

(function() {
  'use strict';

  customerTypeDisplay.$inject = ["CUSTOMER"];
  angular
    .module('core')
    .filter('customerTypeDisplay', customerTypeDisplay);

  function customerTypeDisplay(CUSTOMER) {
    return function(type) {
      return CUSTOMER.TYPE_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  customerSubtypeDisplay.$inject = ["CUSTOMER"];
  angular
    .module('core')
    .filter('customerSubtypeDisplay', customerSubtypeDisplay);

  function customerSubtypeDisplay(CUSTOMER) {
    return function(type) {
      return CUSTOMER.SUBTYPE_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  customerContractTypeDisplay.$inject = ["CUSTOMER"];
  angular
    .module('core')
    .filter('customerContractTypeDisplay', customerContractTypeDisplay);

  function customerContractTypeDisplay(CUSTOMER) {
    return function(type) {
      return CUSTOMER.CONTRACT_TYPE_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  customerContactTypeDisplay.$inject = ["CUSTOMER"];
  angular
    .module('core')
    .filter('customerContactTypeDisplay', customerContactTypeDisplay);

  function customerContactTypeDisplay(CUSTOMER) {
    return function(type) {
      return CUSTOMER.CONTACT_TYPE_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  currencyInputFilter.$inject = ["$filter", "CURRENCIES"];
  angular
    .module('core')
    .filter('currencyInputFilter', currencyInputFilter);

  function currencyInputFilter($filter, CURRENCIES) {
    return function(amount, currency) {
      var symbol = CURRENCIES.CODES[currency] ? CURRENCIES.CODES[currency].symbol : '';
      return $filter('currency')(amount, symbol, 2);
    };
  }
})();

(function() {
  'use strict';

  currencyDisplayFilter.$inject = ["$filter", "CURRENCIES"];
  angular
    .module('core')
    .filter('currencyDisplayFilter', currencyDisplayFilter);

  function currencyDisplayFilter(
    $filter,
    CURRENCIES) {
    return function(amount, curr) {
      var symbol = CURRENCIES.CODES[curr] ? CURRENCIES.CODES[curr].symbol : '';
      if (typeof amount == 'number') {
        if (amount >= 0) {
          return $filter('currency')(amount, symbol, 2);
        }
        else {
          return '(' + $filter('currency')(Math.abs(amount), symbol, 2) + ')';
        }
      } else {
        return '';      
      }
    };
  }
})();

(function() {
  'use strict';

  checkItemTypeDisplay.$inject = ["CHECK_ITEMS"];
  angular
    .module('core')
    .filter('checkItemTypeDisplay', checkItemTypeDisplay);

  function checkItemTypeDisplay(CHECK_ITEMS) {
    return function(type) {
      return CHECK_ITEMS.TYPE_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  checkItemStatus.$inject = ["CHECK_ITEMS"];
  angular
    .module('core')
    .filter('checkItemStatus', checkItemStatus);

  function checkItemStatus(CHECK_ITEMS) {
    return function(status) {
      return CHECK_ITEMS.STATUS_DESCRIPTION[status];
    };
  }
})();

(function() {
  'use strict';

  bulkRevisionStatusDisplay.$inject = ["BULK_REVISIONS"];
  angular
    .module('core')
    .filter('bulkRevisionStatusDisplay', bulkRevisionStatusDisplay);

  function bulkRevisionStatusDisplay(BULK_REVISIONS) {
    return function(type) {
      return BULK_REVISIONS.STATUS_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  accountTypeDisplay.$inject = ["ACCOUNTS"];
  angular
    .module('core')
    .filter('accountTypeDisplay', accountTypeDisplay);

  function accountTypeDisplay(ACCOUNTS) {
    return function(type) {
      return ACCOUNTS.TYPE_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  accountSelectFilter.$inject = ["ACCOUNTS"];
  angular
    .module('core')
    .filter('accountSelectFilter', accountSelectFilter);

  //For any Account Number Selection, the selectable value should be [Name] + "- " + [last 4 digits of Number]
  //If Number has less than 4 digits, add "x" in front of digits that do exist.
  function accountSelectFilter(ACCOUNTS) {
    return function(account) {
      var ret = '';
      if (account !== null && angular.isDefined(account)) {
        if(account.number) {
          var accountNumber = 'xxxx' + account.number;
          ret = account.name + ' - ' + accountNumber.slice(-4) + ' - ' + ACCOUNTS.TYPE_DESCRIPTION[account.type];
          if ( account.bank !== null && account !== '' ) {
            ret += ' - ' + account.bank;
          }
          return ret;
        } else {
          ret = account.name + ' - ' + ACCOUNTS.TYPE_DESCRIPTION[account.type];
          if ( account.bank !== null && account !== '' ) {
            ret += ' - ' + account.bank;
          }
          return ret;
        }
      } else {
        return ret;
      }
    };
  }
})();

(function() {
  'use strict';

  accountPeriodStatusDisplay.$inject = ["ACCOUNT_PERIODS"];
  angular
    .module('core')
    .filter('accountPeriodStatusDisplay', accountPeriodStatusDisplay);

  function accountPeriodStatusDisplay(ACCOUNT_PERIODS) {
    return function(type) {
      return ACCOUNT_PERIODS.STATUS_DESCRIPTION[type] || '';
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('TRANSACTION_TYPES', {
      TYPE: {
        WITHDRAWAL: 'withdrawal',
        CC_PAYMENT: 'cc_payment',
        DEPOSIT: 'deposit',
        FEES: 'fees',
        ATM_WITHDRAWAL: 'atm_withdrawal',
        OTHER_CREDIT: 'other_credit',
        WIRE: 'wire',
        ACH_TRANSFER: 'ach_transfer',
        CC_TRANSACTION: 'cc_transaction',
        CHECK: 'check',
        INTEREST: 'interest',
        OTHER_DEBIT: 'other_debit',
        ATM_DEPOSIT: 'atm_deposit',
        ADJUSTMENT: 'adjustment',
        POSSIBLE_TRANSFER: 'poss_transfer',
        INTERNAL_TRANSFER: 'transfer'
      },
      TYPE_DESCRIPTION: {
        withdrawal: 'Withdrawal',
        cc_payment: 'CC Payment',
        deposit: 'Deposit',
        fees: ' Fees',
        atm_withdrawal: 'ATM Withdrawal',
        other_credit: 'Other Credit',
        wire: 'Wire',
        ach_transfer: ' ACH Transfer',
        cc_transaction: 'CC Transaction',
        check: 'Check',
        interest: 'Interest',
        other_debit: 'Other Debit',
        atm_deposit: 'ATM Deposit',
        adjustment: 'ADJ',
        poss_transfer: 'Possible Transfer',
        transfer: 'Internal Transfer'
      },
      GRID_ROW_TYPE: {
        TRANSACTION: 'transaction',
        CHECK_ITEM: 'checkItem',
        AGGREGATION: 'aggregation',
        DRAW_TARGET: 'drawtarget'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('STATEMENTS', {
      STATUS: {
        UPLOADED: 'uploaded',
        EXTRACTING: 'extracting',
        REJECTED: 'rejected',
        READY: 'ready'
      },
      STATUS_DESCRIPTION: {
        uploaded: 'Uploaded',
        extracting: 'Extracting',
        rejected: 'Rejected',
        ready: 'Ready'
      },
      SOURCE: {
        BANK_PDF: 'bank_pdf',
        CHECKS_PDF: 'checks_pdf',
        BROKERAGE_LOAN_PDF: 'brokerage_loan_pdf',
        TXN_CSV: 'txn_csv'
      },
      SOURCE_DESCRIPTION: {
        bank_pdf: 'Bank Statements',
        brokerage_loan_pdf: 'Brokerage Statements',
        txn_csv: 'Transaction Lists - Bank',
        checks_pdf: 'Check Images'
      },
      SOURCE_FLOW: {
        bank_pdf: 'bank',
        brokerage_loan_pdf: 'brokerage',
        txn_csv: 'csv',
        checks_pdf: 'checks'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('REPORTS', {
      TYPE: {
        TRANSACTIONS: 'transactions',
        TRANSACTIONS_DETAIL: 'txn_detail',
        BALANCES: 'balances',
        REVENUE: 'revenue',
        FINANCIALS: 'financials',
        EXPENSE: 'expense',
        DATEGAP: 'dategap',
        SUBSEQUENT_AR: 'subsequent_ar',
        SAMPLE_BASED: 'sample_based',
        DATA_EXPORT: 'data_export',
      },
      TYPE_DESCRIPTION: {
        transactions: 'Txn Summary',
        txn_detail: 'Txn Detail',
        balances: 'Balances',
        revenue: 'Revenue',
        financials: 'Financials',
        expense: 'Expense',
        dategap: 'Date Gap',
        subsequent_ar: 'Subsequent AR',
        sample_based: 'Sample-Based',
        data_export: 'Data Export',
      },
      STATUS: {
        STARTED: 'started',
        ASSEMBLING: 'assembling',
        READY: 'ready',
        ERROR: 'error'
      },
      STATUS_DESCRIPTION: {
        started: 'Exporting',
        assembling: 'Assembling',
        ready: 'Complete',
        error: 'Error'
      }
    });
})();


(function() {
  'use strict';

  angular
    .module('core')
    .constant('RECONCILIATIONS', {
      STATUS: {
        STARTED: 'started',
        LOADING: 'loading',
        MATCHING: 'matching',
        IMPORTING: 'importing',
        ERROR: 'error',
        UNRECONCILED: 'unreconciled',
        RECONCILED: 'reconciled'
      },
      STATUS_DESCRIPTION: {
        started: 'Fetching Cash and Bank Txns',
        loading: 'Loading',
        matching: 'Matching',
        importing: 'Tracing',
        error: 'Error',
        unreconciled: 'Complete',
        reconciled: 'Complete'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('RBAC', {
      RESOURCE_TYPE: {
        SYSTEM: 'system',
        CUSTOMER: 'customer',
        PROJECT: 'project'
      },
      ROLES: {
        V8_ADMIN: 'v8_admin',
        V8_ADMIN_READONLY: 'v8_admin_readonly',
        CUSTOMER_ADMIN: 'customer_admin',
        CUSTOMER_USER: 'customer_user',
        ENGAGEMENT_OWNER: 'engagement_owner',
        ENGAGEMENT_USER: 'engagement_user',
      },
      ROLE_DESCRIPTION: {
        v8_admin: 'V8 Admin',
        v8_admin_readonly:' V8 Admin Read Only',
        customer_admin: 'Customer Admin',
        customer_user: 'Customer User',
        engagement_owner: 'Engagement Owner',
        engagement_user: 'Engagement User'
      }
    });
})();


(function() {
  'use strict';

  angular
    .module('core')
    .constant('PROJECT_TYPES', {
      FORENSIC: 'forensic',
      AUDIT: 'audit'
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('NODE_TYPES', {
      source: 2,
      account: 1,
      entity: 1,
      use: 2
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('MATCH_TYPES', {
      BANK_ERP: 'bank_erp',
      INT_TRANS: 'int_trans',
      CHECK_ITEMS: 'checkitems',
      DUP: 'dup'
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('MATCH_STATUSES', {
      FOUND: 'found',
      CONFIRMED: 'confirmed',
      REJECTED: 'rejected'
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('MATCH_QUALITIES', {
      ALL: 'all',
      VERY_LIKELY: 'very_likely',
      PROBABLE: 'probable',
      POSSIBLE: 'possible'
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('MATCH_JOB_STATUS', {
      STARTED: 'started',
      RUNNING: 'running',
      IMPORTING: 'importing',
      COMPLETED: 'completed',
      ERROR: 'error'
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('Chart', Chart);
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('ERP_METRICS', {
      KEY_ORDER: [
        'CJCount',
        'CJTracedCount',
        'CJReconciledCount',
        'CJUnreconciledCount',
        'PostARCount',
        'PostAPCount',
        'CJTracedCountPercent',
        'CJReconciledPercent',
        'CJInflowCount',
        'CJReconciledInflowCount',
        'CJOutflowCount',
        'CJReconciledOutflowCount',
        'CJZeroCount',
        'CJSum',
        'CJTracedSum',
        'CJInflowSum',
        'CJTracedInflowSum',
        'CJReconciledInflowSum',
        'CJOutflowSum',
        'CJReconciledOutflowSum',
        'GLCount',
        'GLTracedCount',
        'GLTracedCountPercent',
        'TraceEndpointCount',
        'TraceEndpointSum',
        'UndepositedFundsCount',
        'DepositDetailMatchCount',
        'UndepositedFundsAccountID',
        'RevCredCount',
        'RevCredTracedCount',
        'RevCredEndpointCount',
        'RevCredEndpointReconciledCount',
        'RevCredSum',
        'RevCredTracedSum',
        'RevCredReconciledSum',
        'RevCredEndpointPercent',
        'RevDebCount',
        'RevDebSum',
        'ReceivableCount',
        'ARClosingBalanceSum',
        'InvoiceCount',
        'PaymentCount',
        'ARGLLinksCount',
        'ARLinksHashCount',
        'AccountCount',
        'CustomerCount',
        'PeriodStartDate',
        'PeriodEndDate'
      ]
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('ERP_EXTRACTS', {
      STATUS: {
        NOT_IMPORTED: 'not_imported',   //Extract exists in Validis, not in V8 yet
        IMPORTING: 'importing',         //Importing extract to V8 - "Fetching ERP Extract"
        TRACING: 'tracing',             //Tracing being done by the ME.
        GL_IMPORT: 'gl_import',         //Importing GL  - "Transforming GL"
        AR_IMPORT: 'ar_import',         //Importing AR  - "Transforming AR"
        AP_IMPORT: 'ap_import',         //Importing AP  - "Transforming AP"
        TRACE_IMPORT: 'trace_import',   //Importing Trace objects
        READY: 'ready',                 //ERP Extract Load Complete
        ERROR: 'error'                  //Error occurred.
      },
      STATUS_DESCRIPTION: {
        not_imported: 'Extract not imported from Validis',
        importing: 'Fetching Extract',
        tracing: 'Tracing',
        gl_import: 'Loading GL',
        ar_import: 'Loading AR',
        ap_import: 'Loading AP',
        trace_import: 'Loading CJ Traces',
        ready: 'Complete',
        error: 'Error'
      },
      PROGRESS: {
        PENDING: 'pending',
        IN_PROGRESS: 'inprogress',
        COMPLETED: 'completed',
        ERROR: 'error'
      },
      STEPS: [
        'importing',
        'tracing',
        'gl_import',
        'ar_import',
        'ap_import',
        'trace_import',
        'ready',
      ]
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('DOCUMENT_TYPES', {
      STATEMENT: {type:'statement', name: 'Statement'},
      OTHER: {type: 'other', name: 'Other'},
      CHECK: {type: 'check', name: 'Check'},
      ERP: {type: 'erp', name: 'ERP Extract'},
      TX_SUP_DOC: {type: 'tx_sup_doc', name: 'Supporting documentation'},
      BULK_REVISION: {type:'bulk_revision', name: 'Bulk revision'}
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('DATE_GROUP_TYPE', {
      'year': {
        'GROUP_BY': 'y',
        'FORMAT': 'M/YY'
      },
      'quarter': {
        'GROUP_BY': 'Q',
        'FORMAT': 'YYYY - qQ'
      },
      'month': {
        'GROUP_BY': 'M',
        'FORMAT': 'M/YY'
      },
      'week': {
        'GROUP_BY': 'w',
        'FORMAT': 'M/YY'
      },
      'day': {
        'GROUP_BY': 'd',
        'FORMAT': 'M/YY'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('DATE_FORMATS', {
      STANDARD: 'MM/DD/YYYY',
      ISO: 'YYYY-MM-DD',
      DATE_TIME: 'MM/DD/YYYY hh:mm A'
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('CUSTOMER', {
      TYPE :{
        FORENSIC: 'forensic',
        AUDIT: 'audit'
      },
      TYPE_DESCRIPTION: {
        forensic: 'Investigations',
        audit: 'Audit'
      },
      SUBTYPE: {
        AUDIT_S: 'audit_s',
        AUDIT_M: 'audit_m',
        AUDIT_L: 'audit_l',
        FORENSIC_NON_CPA: 'forensic_non_cpa',
        FORENSIC_CPA: 'forensic_cpa',
        FORENSIC_GOV: 'forensic_gov'
      },
      SUBTYPE_DESCRIPTION: {
        audit_s: 'Audit - Small CPA Firm',
        audit_m: 'Audit - Medium CPA Firm',
        audit_l: 'Audit - Large CPA Firm',
        forensic_non_cpa: 'Investigations - non-CPA Firm',
        forensic_cpa: 'Investigations - CPA Firm',
        forensic_gov: 'Investigations - Government Agency'
      },
      CONTRACT_TYPE: {
        SUBSCRIPTION: 'subscription',
        CONSUMPTION: 'consumption',
        ENTERPRISE_LICENSE: 'enterprise_license'
      },
      CONTRACT_TYPE_DESCRIPTION: {
        subscription: 'Subscription',
        consumption: 'Consumption',
        enterprise_license: 'Enterprise License'
      },
      CONTACT_TYPE: {
        CONTRACTS: 'contracts',
        BILLING: 'billing',
        OPERATIONS: 'operations'
      },
      CONTACT_TYPE_DESCRIPTION: {
        contracts: 'Contracts',
        billing: 'Billing',
        operations: 'Operations'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('CURRENCIES', {
      LIST: ['USD', 'CAD', 'GBP', 'EUR', 'AFN','ALL','DZD','AOA','XCD','ARS','AMD','AWG','AUD','AZN','BSD','BHD','BDT','BBD','BYR','BZD','XOF','BMD','BTN',
        'INR','BOB','BOV','BAM','BWP','NOK','BRL','BND','BGN','BIF','KHR','XAF','CVE','KYD','CLF','CLP','CNY','COP','COU','KMF','CDF','NZD','CRC','HRK','CUC',
        'CUP','ANG','CZK','DKK','DJF','DOP','EGP','SVC','ERN','ETB','FKP','FJD','XPF','GMD','GEL','GHS','GIP','GTQ','GNF','GYD','HTG','HNL','HKD','HUF','ISK',
        'IDR','XDR','IRR','IQD','ILS','JMD','JPY','JOD','KZT','KES','KPW','KRW','KWD','KGS','LAK','LBP','LSL','ZAR','LRD','LYD','CHF','LTL','MOP','MKD','MGA',
        'MWK','MYR','MVR','MRO','MUR','XUA','MXN','MXV','MDL','MNT','MAD','MZN','MMK','NAD','NPR','NIO','NGN','OMR','PKR','PAB','PGK','PYG','PEN','PHP','PLN',
        'QAR','RON','RUB','RWF','SHP','WST','STD','SAR','RSD','SCR','SLL','SGD','XSU','SBD','SOS','SSP','LKR','SDG','SRD','SZL','SEK','CHE','CHW','SYP','TWD',
        'TJS','TZS','THB','TOP','TTD','TND','TRY','TMT','UGX','UAH','AED','USN','UYI','UYU','UZS','VUV','VEF','VND','YER','ZMW','ZWL'
      ],
      CODES: {
        AFN: { name: 'Afghani', symbol: '؋', code: 'AFN' },
        EUR: { name: 'Euro', symbol: '€', code: 'EUR' },
        ALL: { name: 'Lek', symbol: 'Lek', code: 'ALL' },
        DZD: { name: 'Algerian Dinar', symbol: 'د.ج', code: 'DZD' },
        USD: { name: 'US Dollar', symbol: '$', code: 'USD' },
        AOA: { name: 'Kwanza', symbol: 'Kz', code: 'AOA' },
        XCD: { name: 'East Caribbean Dollar', symbol: '$', code: 'XCD' },
        ARS: { name: 'Argentine Peso', symbol: '$', code: 'ARS' },
        AMD: { name: 'Armenian Dram', symbol: '', code: 'AMD' },
        AWG: { name: 'Aruban Florin', symbol: 'ƒ', code: 'AWG' },
        AUD: { name: 'Australian Dollar', symbol: '$', code: 'AUD' },
        AZN: { name: 'Azerbaijani Manat', symbol: 'ман', code: 'AZN' },
        BSD: { name: 'Bahamian Dollar', symbol: '$', code: 'BSD' },
        BHD: { name: 'Bahraini Dinar', symbol: 'BD', code: 'BHD' },
        BDT: { name: 'Taka', symbol: '৳', code: 'BDT' },
        BBD: { name: 'Barbados Dollar', symbol: '$', code: 'BBD' },
        BYR: { name: 'Belarusian Ruble', symbol: 'p.', code: 'BYR' },
        BZD: { name: 'Belize Dollar', symbol: 'BZ$', code: 'BZD' },
        XOF: { name: 'CFA Franc BCEAO', symbol: 'CFA', code: 'XOF' },
        BMD: { name: 'Bermudian Dollar', symbol: '$', code: 'BMD' },
        BTN: { name: 'Ngultrum', symbol: 'Nu', code: 'BTN' },
        INR: { name: 'Indian Rupee', symbol: '₹', code: 'INR' },
        BOB: { name: 'Boliviano', symbol: '$b', code: 'BOB' },
        BOV: { name: 'Mvdol', symbol: '$b', code: 'BOV' },
        BAM: { name: 'Convertible Mark', symbol: 'KM', code: 'BAM' },
        BWP: { name: 'Pula', symbol: 'P', code: 'BWP' },
        NOK: { name: 'Norwegian Krone', symbol: 'kr', code: 'NOK' },
        BRL: { name: 'Brazilian Real', symbol: 'R$', code: 'BRL' },
        BND: { name: 'Brunei Dollar', symbol: '$', code: 'BND' },
        BGN: { name: 'Bulgarian Lev', symbol: 'лв', code: 'BGN' },
        BIF: { name: 'Burundian Franc', symbol: 'BIF', code: 'BIF' },
        KHR: { name: 'Riel', symbol: '៛', code: 'KHR' },
        XAF: { name: 'CFA Franc BEAC', symbol: '', code: 'XAF' },
        CAD: { name: 'Canadian Dollar', symbol: '$', code: 'CAD' },
        CVE: { name: 'Cabo Verde Escudo', symbol: '$', code: 'CVE' },
        KYD: { name: 'Cayman Islands Dollar', symbol: '$', code: 'KYD' },
        CLF: { name: 'Unidad de Fomento', symbol: '', code: 'CLF' },
        CLP: { name: 'Chilean Peso', symbol: '$', code: 'CLP' },
        CNY: { name: 'Yuan Renminbi', symbol: '¥', code: 'CNY' },
        COP: { name: 'Colombian Peso', symbol: '$', code: 'COP' },
        COU: { name: 'Unidad de Valor Real', symbol: '', code: 'COU' },
        KMF: { name: 'Comoro Franc', symbol: '', code: 'KMF' },
        CDF: { name: 'Congolese Franc', symbol: '', code: 'CDF' },
        NZD: { name: 'New Zealand Dollar', symbol: '$', code: 'NZD' },
        CRC: { name: 'Costa Rican Colon', symbol: '₡', code: 'CRC' },
        HRK: { name: 'Croatian Kuna', symbol: 'kn', code: 'HRK' },
        CUC: { name: 'Peso Convertible', symbol: '', code: 'CUC' },
        CUP: { name: 'Cuban Peso', symbol: '₱', code: 'CUP' },
        ANG: { name: 'Netherlands Antillean Guilder', symbol: 'ƒ', code: 'ANG' },
        CZK: { name: 'Czech Koruna', symbol: 'Kč', code: 'CZK' },
        DKK: { name: 'Danish Krone', symbol: 'kr', code: 'DKK' },
        DJF: { name: 'Djibouti Franc', symbol: '', code: 'DJF' },
        DOP: { name: 'Dominican Peso', symbol: 'RD$', code: 'DOP' },
        EGP: { name: 'Egyptian Pound', symbol: '£', code: 'EGP' },
        SVC: { name: 'El Salvador Colon', symbol: '$', code: 'SVC' },
        ERN: { name: 'Nakfa', symbol: '', code: 'ERN' },
        ETB: { name: 'Ethiopian Birr', symbol: '', code: 'ETB' },
        FKP: { name: 'Falkland Islands Pound', symbol: '£', code: 'FKP' },
        FJD: { name: 'Fiji Dollar', symbol: '$', code: 'FJD' },
        XPF: { name: 'CFP Franc', symbol: '', code: 'XPF' },
        GMD: { name: 'Dalasi', symbol: '', code: 'GMD' },
        GEL: { name: 'Lari', symbol: '', code: 'GEL' },
        GHS: { name: 'Ghan Cedi', symbol: '', code: 'GHS' },
        GIP: { name: 'Gibraltar Pound', symbol: '£', code: 'GIP' },
        GTQ: { name: 'Quetzal', symbol: 'Q', code: 'GTQ' },
        GBP: { name: 'Pound Sterling', symbol: '£', code: 'GBP' },
        GNF: { name: 'Guinean Franc', symbol: '', code: 'GNF' },
        GYD: { name: 'Guyanese Dollar', symbol: '$', code: 'GYD' },
        HTG: { name: 'Gourde', symbol: '', code: 'HTG' },
        HNL: { name: 'Lempira', symbol: 'L', code: 'HNL' },
        HKD: { name: 'Hong Kong Dollar', symbol: '$', code: 'HKD' },
        HUF: { name: 'Forint', symbol: 'Ft', code: 'HUF' },
        ISK: { name: 'Iceland Krona', symbol: 'kr', code: 'ISK' },
        IDR: { name: 'Rupiah', symbol: 'Rp', code: 'IDR' },
        XDR: { name: 'SDR (Special Drawing Right)', symbol: '', code: 'XDR' },
        IRR: { name: 'Iranian Rial', symbol: '﷼', code: 'IRR' },
        IQD: { name: 'Iraqi Dinar', symbol: '', code: 'IQD' },
        ILS: { name: 'New Israeli Sheqel', symbol: '₪', code: 'ILS' },
        JMD: { name: 'Jamaican Dollar', symbol: 'J$', code: 'JMD' },
        JPY: { name: 'Yen', symbol: '¥', code: 'JPY' },
        JOD: { name: 'Jordanian Dinar', symbol: '', code: 'JOD' },
        KZT: { name: 'Tenge', symbol: '₸', code: 'KZT' },
        KES: { name: 'Kenyan Shilling', symbol: '', code: 'KES' },
        KPW: { name: 'North Korean Won', symbol: '₩', code: 'KPW' },
        KRW: { name: 'Won', symbol: '₩', code: 'KRW' },
        KWD: { name: 'Kuwaiti Dinar', symbol: '', code: 'KWD' },
        KGS: { name: 'Som', symbol: 'som', code: 'KGS' },
        LAK: { name: 'Kip', symbol: '₭', code: 'LAK' },
        LBP: { name: 'Lebanese Pound', symbol: 'ل.ل.', code: 'LBP' },
        LSL: { name: 'Loti', symbol: '', code: 'LSL' },
        ZAR: { name: 'South African Rand', symbol: 'R', code: 'ZAR' },
        LRD: { name: 'Liberian Dollar', symbol: '$', code: 'LRD' },
        LYD: { name: 'Libyan Dinar', symbol: '', code: 'LYD' },
        CHF: { name: 'Swiss Franc', symbol: 'CHF', code: 'CHF' },
        LTL: { name: 'Lithuanian Litas', symbol: 'Lt', code: 'LTL' },
        MOP: { name: 'Pataca', symbol: '', code: 'MOP' },
        MKD: { name: 'Denar', symbol: 'ден', code: 'MKD' },
        MGA: { name: 'Malagasy riary', symbol: '', code: 'MGA' },
        MWK: { name: 'Kwacha', symbol: '', code: 'MWK' },
        MYR: { name: 'Malaysian Ringgit', symbol: 'RM', code: 'MYR' },
        MVR: { name: 'Rufiyaa', symbol: '', code: 'MVR' },
        MRO: { name: 'Ouguiya', symbol: '', code: 'MRO' },
        MUR: { name: 'Mauritius Rupee', symbol: '₨', code: 'MUR' },
        XUA: { name: 'ADB Unit of account', symbol: '', code: 'XUA' },
        MXN: { name: 'Mexican Peso', symbol: '$', code: 'MXN' },
        MXV: { name: 'Mexican Unidad de Inversion (UDI)', symbol: '', code: 'MXV' },
        MDL: { name: 'Moldovan Leu', symbol: '', code: 'MDL' },
        MNT: { name: 'Tugrik', symbol: '₮', code: 'MNT' },
        MAD: { name: 'Moroccan Dirham', symbol: '', code: 'MAD' },
        MZN: { name: 'Mozambique Metical', symbol: 'MT', code: 'MZN' },
        MMK: { name: 'Kyat', symbol: '', code: 'MMK' },
        NAD: { name: 'Namibian Dollar', symbol: 'N$', code: 'NAD' },
        NPR: { name: 'Nepalese Rupee', symbol: '₨', code: 'NPR' },
        NIO: { name: 'Cordob Oro', symbol: 'C$', code: 'NIO' },
        NGN: { name: 'Naira', symbol: '₦', code: 'NGN' },
        OMR: { name: 'Rial Omani', symbol: '﷼', code: 'OMR' },
        PKR: { name: 'Pakistan Rupee', symbol: '₨', code: 'PKR' },
        PAB: { name: 'Balboa', symbol: 'B/.', code: 'PAB' },
        PGK: { name: 'Kina', symbol: 'K', code: 'PGK' },
        PYG: { name: 'Guarani', symbol: 'Gs', code: 'PYG' },
        PEN: { name: 'Nuevo Sol', symbol: 'S/', code: 'PEN' },
        PHP: { name: 'Philippine Peso', symbol: '₱', code: 'PHP' },
        PLN: { name: 'Zloty', symbol: 'zł', code: 'PLN' },
        QAR: { name: 'Qatari Rial', symbol: '﷼', code: 'QAR' },
        RON: { name: 'New Romanian Leu', symbol: 'lei', code: 'RON' },
        RUB: { name: 'Russian Ruble', symbol: 'руб', code: 'RUB' },
        RWF: { name: 'Rwandan Franc', symbol: 'R₣', code: 'RWF' },
        SHP: { name: 'Saint Helena Pound', symbol: '£', code: 'SHP' },
        WST: { name: 'Tala', symbol: '$', code: 'WST' },
        STD: { name: 'Dobra', symbol: '', code: 'STD' },
        SAR: { name: 'Saudi Riyal', symbol: '﷼', code: 'SAR' },
        RSD: { name: 'Serbian Dinar', symbol: 'Дин.', code: 'RSD' },
        SCR: { name: 'Seychelles Rupee', symbol: '₨', code: 'SCR' },
        SLL: { name: 'Leone', symbol: 'Le', code: 'SLL' },
        SGD: { name: 'Singapore Dollar', symbol: '$', code: 'SGD' },
        XSU: { name: 'Sucre', symbol: '', code: 'XSU' },
        SBD: { name: 'Solomon Islands Dollar', symbol: '$', code: 'SBD' },
        SOS: { name: 'Somali Shilling', symbol: 'S', code: 'SOS' },
        SSP: { name: 'South Sudanese Pound', symbol: '', code: 'SSP' },
        LKR: { name: 'Sri Lankan Rupee', symbol: '₨', code: 'LKR' },
        SDG: { name: 'Sudanese Pound', symbol: '', code: 'SDG' },
        SRD: { name: 'Surinam Dollar', symbol: '$', code: 'SRD' },
        SZL: { name: 'Lilangeni', symbol: '', code: 'SZL' },
        SEK: { name: 'Swedish Krona', symbol: 'kr', code: 'SEK' },
        CHE: { name: 'WIR Euro', symbol: '', code: 'CHE' },
        CHW: { name: 'WIR Franc', symbol: '', code: 'CHW' },
        SYP: { name: 'Syrian Pound', symbol: '£', code: 'SYP' },
        TWD: { name: 'New Taiwan Dollar', symbol: 'NT$', code: 'TWD' },
        TJS: { name: 'Somoni', symbol: '', code: 'TJS' },
        TZS: { name: 'Tanzanian Shilling', symbol: '', code: 'TZS' },
        THB: { name: 'Baht', symbol: '฿', code: 'THB' },
        TOP: { name: 'Pa’anga', symbol: '', code: 'TOP' },
        TTD: { name: 'Trinidad and Tobago Dollar', symbol: 'TT$', code: 'TTD' },
        TND: { name: 'Tunisian Dinar', symbol: '', code: 'TND' },
        TRY: { name: 'Turkish Lira', symbol: '₺', code: 'TRY' },
        TMT: { name: 'Turkmenistan New Manat', symbol: '', code: 'TMT' },
        UGX: { name: 'Ugandan Shilling', symbol: '', code: 'UGX' },
        UAH: { name: 'Hryvnia', symbol: '₴', code: 'UAH' },
        AED: { name: 'UAE Dirham', symbol: '', code: 'AED' },
        USN: { name: 'US Dollar (Next day)', symbol: '', code: 'USN' },
        UYI: { name: 'Uruguay Peso en Unidades Indexadas (URUIURUI)', symbol: '', code: 'UYI' },
        UYU: { name: 'Peso Uruguayo', symbol: '$U', code: 'UYU' },
        UZS: { name: 'Uzbekistan Sum', symbol: 'som', code: 'UZS' },
        VUV: { name: 'Vatu', symbol: '', code: 'VUV' },
        VEF: { name: 'Bolivar', symbol: 'Bs', code: 'VEF' },
        VND: { name: 'Dong', symbol: '₫', code: 'VND' },
        YER: { name: 'Yemeni Rial', symbol: '﷼', code: 'YER' },
        ZMW: { name: 'Zambian Kwacha', symbol: '', code: 'ZMW' },
        ZWL: { name: 'Zimbabwe Dollar', symbol: '$', code: 'ZWL' }
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('COUNTRIES', {
      LIST: [
        'USA', 'CAN', 'GBR', 'AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS',
        'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI',
        'KHM', 'CMR', 'CPV', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COG', 'COD', 'COK', 'CRI', 'CIV', 'HRV', 'CUB', 'CUW',
        'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF',
        'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT',
        'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK',
        'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MKD', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT',
        'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL',
        'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT',
        'PRI', 'QAT', 'REU', 'ROU', 'RUS', 'RWA', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC',
        'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWZ', 'SWE', 'CHE', 'SYR', 'TWN',
        'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'UMI', 'URY', 'UZB', 'VUT',
        'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE'
      ],
      CODES: {
        AFG: "Afghanistan",
        ALA: "Åland Islands",
        ALB: "Albania",
        DZA: "Algeria",
        ASM: "American Samoa",
        AND: "Andorra",
        AGO: "Angola",
        AIA: "Anguilla",
        ATA: "Antarctica",
        ATG: "Antigua and Barbuda",
        ARG: "Argentina",
        ARM: "Armenia",
        ABW: "Aruba",
        AUS: "Australia",
        AUT: "Austria",
        AZE: "Azerbaijan",
        BHS: "Bahamas",
        BHR: "Bahrain",
        BGD: "Bangladesh",
        BRB: "Barbados",
        BLR: "Belarus",
        BEL: "Belgium",
        BLZ: "Belize",
        BEN: "Benin",
        BMU: "Bermuda",
        BTN: "Bhutan",
        BOL: "Bolivia, Plurinational State of",
        BES: "Bonaire, Sint Eustatius and Saba",
        BIH: "Bosnia and Herzegovina",
        BWA: "Botswana",
        BVT: "Bouvet Island",
        BRA: "Brazil",
        IOT: "British Indian Ocean Territory",
        BRN: "Brunei Darussalam",
        BGR: "Bulgaria",
        BFA: "Burkina Faso",
        BDI: "Burundi",
        KHM: "Cambodia",
        CMR: "Cameroon",
        CAN: "Canada",
        CPV: "Cape Verde",
        CYM: "Cayman Islands",
        CAF: "Central African Republic",
        TCD: "Chad",
        CHL: "Chile",
        CHN: "China",
        CXR: "Christmas Island",
        CCK: "Cocos (Keeling) Islands",
        COL: "Colombia",
        COM: "Comoros",
        COG: "Congo",
        COD: "Congo, the Democratic Republic of the",
        COK: "Cook Islands",
        CRI: "Costa Rica",
        CIV: "Côte d'Ivoire",
        HRV: "Croatia",
        CUB: "Cuba",
        CUW: "Curaçao",
        CYP: "Cyprus",
        CZE: "Czech Republic",
        DNK: "Denmark",
        DJI: "Djibouti",
        DMA: "Dominica",
        DOM: "Dominican Republic",
        ECU: "Ecuador",
        EGY: "Egypt",
        SLV: "El Salvador",
        GNQ: "Equatorial Guinea",
        ERI: "Eritrea",
        EST: "Estonia",
        ETH: "Ethiopia",
        FLK: "Falkland Islands (Malvinas)",
        FRO: "Faroe Islands",
        FJI: "Fiji",
        FIN: "Finland",
        FRA: "France",
        GUF: "French Guiana",
        PYF: "French Polynesia",
        ATF: "French Southern Territories",
        GAB: "Gabon",
        GMB: "Gambia",
        GEO: "Georgia",
        DEU: "Germany",
        GHA: "Ghana",
        GIB: "Gibraltar",
        GRC: "Greece",
        GRL: "Greenland",
        GRD: "Grenada",
        GLP: "Guadeloupe",
        GUM: "Guam",
        GTM: "Guatemala",
        GGY: "Guernsey",
        GIN: "Guinea",
        GNB: "Guinea-Bissau",
        GUY: "Guyana",
        HTI: "Haiti",
        HMD: "Heard Island and McDonald Islands",
        VAT: "Holy See (Vatican City State)",
        HND: "Honduras",
        HKG: "Hong Kong",
        HUN: "Hungary",
        ISL: "Iceland",
        IND: "India",
        IDN: "Indonesia",
        IRN: "Iran, Islamic Republic of",
        IRQ: "Iraq",
        IRL: "Ireland",
        IMN: "Isle of Man",
        ISR: "Israel",
        ITA: "Italy",
        JAM: "Jamaica",
        JPN: "Japan",
        JEY: "Jersey",
        JOR: "Jordan",
        KAZ: "Kazakhstan",
        KEN: "Kenya",
        KIR: "Kiribati",
        PRK: "Korea, Democratic People's Republic of",
        KOR: "Korea, Republic of",
        KWT: "Kuwait",
        KGZ: "Kyrgyzstan",
        LAO: "Lao People's Democratic Republic",
        LVA: "Latvia",
        LBN: "Lebanon",
        LSO: "Lesotho",
        LBR: "Liberia",
        LBY: "Libya",
        LIE: "Liechtenstein",
        LTU: "Lithuania",
        LUX: "Luxembourg",
        MAC: "Macao",
        MKD: "Macedonia, the former Yugoslav Republic of",
        MDG: "Madagascar",
        MWI: "Malawi",
        MYS: "Malaysia",
        MDV: "Maldives",
        MLI: "Mali",
        MLT: "Malta",
        MHL: "Marshall Islands",
        MTQ: "Martinique",
        MRT: "Mauritania",
        MUS: "Mauritius",
        MYT: "Mayotte",
        MEX: "Mexico",
        FSM: "Micronesia, Federated States of",
        MDA: "Moldova, Republic of",
        MCO: "Monaco",
        MNG: "Mongolia",
        MNE: "Montenegro",
        MSR: "Montserrat",
        MAR: "Morocco",
        MOZ: "Mozambique",
        MMR: "Myanmar",
        NAM: "Namibia",
        NRU: "Nauru",
        NPL: "Nepal",
        NLD: "Netherlands",
        NCL: "New Caledonia",
        NZL: "New Zealand",
        NIC: "Nicaragua",
        NER: "Niger",
        NGA: "Nigeria",
        NIU: "Niue",
        NFK: "Norfolk Island",
        MNP: "Northern Mariana Islands",
        NOR: "Norway",
        OMN: "Oman",
        PAK: "Pakistan",
        PLW: "Palau",
        PSE: "Palestinian Territory, Occupied",
        PAN: "Panama",
        PNG: "Papua New Guinea",
        PRY: "Paraguay",
        PER: "Peru",
        PHL: "Philippines",
        PCN: "Pitcairn",
        POL: "Poland",
        PRT: "Portugal",
        PRI: "Puerto Rico",
        QAT: "Qatar",
        REU: "Réunion",
        ROU: "Romania",
        RUS: "Russian Federation",
        RWA: "Rwanda",
        BLM: "Saint Barthélemy",
        SHN: "Saint Helena, Ascension and Tristan da Cunha",
        KNA: "Saint Kitts and Nevis",
        LCA: "Saint Lucia",
        MAF: "Saint Martin (French part)",
        SPM: "Saint Pierre and Miquelon",
        VCT: "Saint Vincent and the Grenadines",
        WSM: "Samoa",
        SMR: "San Marino",
        STP: "Sao Tome and Principe",
        SAU: "Saudi Arabia",
        SEN: "Senegal",
        SRB: "Serbia",
        SYC: "Seychelles",
        SLE: "Sierra Leone",
        SGP: "Singapore",
        SXM: "Sint Maarten (Dutch part)",
        SVK: "Slovakia",
        SVN: "Slovenia",
        SLB: "Solomon Islands",
        SOM: "Somalia",
        ZAF: "South Africa",
        SGS: "South Georgia and the South Sandwich Islands",
        SSD: "South Sudan",
        ESP: "Spain",
        LKA: "Sri Lanka",
        SDN: "Sudan",
        SUR: "Suriname",
        SJM: "Svalbard and Jan Mayen",
        SWZ: "Swaziland",
        SWE: "Sweden",
        CHE: "Switzerland",
        SYR: "Syrian Arab Republic",
        TWN: "Taiwan, Province of China",
        TJK: "Tajikistan",
        TZA: "Tanzania, United Republic of",
        THA: "Thailand",
        TLS: "Timor-Leste",
        TGO: "Togo",
        TKL: "Tokelau",
        TON: "Tonga",
        TTO: "Trinidad and Tobago",
        TUN: "Tunisia",
        TUR: "Turkey",
        TKM: "Turkmenistan",
        TCA: "Turks and Caicos Islands",
        TUV: "Tuvalu",
        UGA: "Uganda",
        UKR: "Ukraine",
        ARE: "United Arab Emirates",
        GBR: "United Kingdom",
        USA: "United States",
        UMI: "United States Minor Outlying Islands",
        URY: "Uruguay",
        UZB: "Uzbekistan",
        VUT: "Vanuatu",
        VEN: "Venezuela, Bolivarian Republic of",
        VNM: "Viet Nam",
        VGB: "Virgin Islands, British",
        VIR: "Virgin Islands, U.S.",
        WLF: "Wallis and Futuna",
        ESH: "Western Sahara",
        YEM: "Yemen",
        ZMB: "Zambia",
        ZWE: "Zimbabwe"
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('CHECK_ITEMS', {
      STATUS: {
        UNMATCHED: 'unmatched',
        UNRECONCILED: 'unreconciled',
        RECONCILED: 'reconciled'
      },
      STATUS_DESCRIPTION: {
        unmatched: 'Unmatched',
        unreconciled: 'Unreconciled',
        reconciled: 'Reconciled'
      },
      TYPE: {
        FRONT: 'front',
        BACK: 'back',
        DEPOSIT: 'deposit',
        CASH: 'cash',
        ADJUSTMENT: 'adjustment',
        TRANSFER: 'transfer',
        TRANSACTION: 'transaction'
      },
      TYPE_DESCRIPTION: {
        front: 'Front',
        back: 'Back',
        deposit: 'Deposit Slip',
        cash: 'Cash',
        adjustment: 'Adjustment',
        transfer: 'Transfer Ticket',
        transaction: 'Transaction'
      },
      MATCHED_TYPE: {
        ITEM: 'Item',
        INCOMING: 'Incoming Check',
        OUTGOING: 'Outgoing Check',
        AGGREGATION: 'Item Total'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('CHART_STATUS', {
      SERIES: ['rejected', 'extracting', 'unassigned', 'unreconciled', 'reconciled'],
      ICON: {
        PENDING: 'none',
        IN_PROGRESS: 'cached',
        COMPLETED: 'done',
        ERROR: 'error'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('BULK_REVISIONS', {
      TYPE: {
        TRANSACTIONS: 'transactions'
      },
      TYPE_DESCRIPTION: {
        transactions: 'Excel Sync = "Transaction"'
      },
      STATUS: {
        UPLOADED: 'uploaded',       //user file uploaded
        VERIFYING: 'verifying',     //user file being verified
        INVALID: 'invalid',         //file has errors, cannot proceed
        IMPORTING: 'importing',     //bulk revision being imported
        REVERTING: 'reverting',     //bulk revision being reverted
        REVERTED: 'reverted',       //Final state, revision reverted to backup
        READY: 'ready',             //Final state, revision imported.
        ERROR: 'error'              //Error ocurred during import/revert
      },
      STATUS_DESCRIPTION: {
        uploaded: 'Uploaded',
        verifying: 'Verifying',
        invalid: 'Invalid',
        importing: 'Importing',
        reverting: 'Reverting',
        reverted: 'Reverted',
        ready: 'Completed',
        error: 'Failed'
      }
    });
})();


(function() {
  'use strict';

  angular
    .module('core')
    .constant('BROWSER_IMAGE_TYPES', ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/x-icon']);
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('ACCOUNTS', {
      SOURCE_TYPE: {
        FILE_UPLOAD: 'file_upload',
        BANK_API: 'bank_api',
        VALIDIS_ERP: 'validis_erp'
      },
      SOURCE_TYPE_DESCRIPTION: {
        file_upload: 'File Upload',
        bank_api: 'API Link',
        validis_erp: 'Validis ERP'
      },
      TYPE: {
        SAVINGS: 'savings',
        BROKERAGE: 'brokerage',
        CREDIT_CARD: 'credit_card',
        CHECKING: 'checking',
        ERP: 'erp',
        MORTGAGE: 'mortgage'
      },
      TYPE_DESCRIPTION: {
        savings: 'Savings',
        brokerage: 'Brokerage',
        credit_card: 'Credit Card',
        checking: 'Checking',
        erp: 'ERP',
        mortgage: 'Mortgage'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('core')
    .constant('ACCOUNT_PERIODS', {
      STATUS: {
        UNASSIGNED: 'unassigned',
        RECONCILED: 'reconciled',
        UNRECONCILED: 'unreconciled'
      },
      STATUS_DESCRIPTION: {
        unassigned: 'Unassigned',
        reconciled: 'Reconciled',
        unreconciled: 'Unreconciled'
      }
    });
})();

(function() {
  'use strict';

  UploadCustomerLogoController.$inject = ["$state", "$stateParams", "$mdDialog", "$timeout", "toastr", "ACCOUNTS", "PROJECT_TYPES", "ACCOUNT_PERIODS", "DOCUMENT_TYPES", "Customers", "Accounts", "Authorization", "Upload", "uploadParameters", "customer"];
  angular
    .module('projects')
    .controller('UploadCustomerLogoController', UploadCustomerLogoController);

  function UploadCustomerLogoController(
    $state,
    $stateParams,
    $mdDialog,
    $timeout,
    toastr,
    ACCOUNTS,
    PROJECT_TYPES,
    ACCOUNT_PERIODS,
    DOCUMENT_TYPES,
    Customers,
    Accounts,
    Authorization,
    Upload,
    uploadParameters,
    customer) {
    var vm = this;
    vm.customer = customer;
    vm.logoFileName = "";

    vm.canSaveLogo = canSaveLogo;
    vm.uploadFiles = uploadFiles;
    vm.isUploading = isUploading;
    vm.cancelUpload = cancelUpload;
    vm.abortUpload = abortUpload;
    vm.getFileErrorMessage = getFileErrorMessage;
    vm.setLogo = setLogo;
    vm.files = [];
    vm.errorFiles = [];

    activate();

    function activate() {
      vm.file = "";
      vm.errorFiles = [];
      vm.acceptPattern = '.jpg,.png,.jpeg';
      vm.ngUploadPattern = '.png,.jpeg,.jpg';
      vm.maxSize = '2MB';
      vm.info = 'Select a png or jpeg logo. Max size 2MB per file.';
    }

    function isUploading() {
      return Upload.isUploadInProgress();
    }

    function canSaveLogo() {
      return vm.logoFileName != "";
    }

    function uploadFiles(files, errorFiles) {
      vm.files = files;
      vm.errorFiles = errorFiles;
      angular.forEach(files, function(file) {
        //Users may upload multiple files with the same name, need to differentiate them when associated with different DB entities.
        var randKey = Math.floor(Math.random() * 10000);
        var fileKey = uploadParameters.folder + '/' + randKey + '-logo';
        if (file.type === 'image/jpeg') {
          fileKey += '.jpeg';
        } else {
          fileKey += '.png';
        }
        const uploadData = {
          key: fileKey,
          acl: 'private',
          policy: uploadParameters.policy,
          'x-amz-algorithm': uploadParameters['x-amz-algorithm'],
          'x-amz-credential': uploadParameters['x-amz-credential'],
          'x-amz-date': uploadParameters['x-amz-date'],
          'x-amz-signature': uploadParameters.signature,
          'x-amz-security-token': uploadParameters['x-amz-security-token'],
          "Content-Type": file.type != '' ? file.type : 'application/octet-stream',
          filename: file.name,
          file: file
        };
        if (!uploadParameters['x-amz-security-token']) {
          delete uploadData['x-amz-security-token'];
        }

        file.upload = Upload.upload({
          url: uploadParameters.url,
          method: 'POST',
          data: uploadData
        });

        file.upload.then(function (response) {
          vm.logoFileName = response.config.data.key;
          _success(file, "Logo successfully uploaded");
        }, function (response) {
          if (response.status > 0) {
            _failure(file, response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      });
    }

    function _success(file, messageText) {
      file.successMessage = messageText;
    }

    function _failure(file, messageText) {
      file.errorMessage = messageText;
      file.progress = 0;
      vm.errorFiles.push(file);
    }

    function abortUpload() {
      angular.forEach(vm.files, function(file) {
        if(file.upload) {
          file.upload.abort();
        }
      });
    }

    function getFileErrorMessage(file) {
      var message = file.name;
      if(file.errorMessage) {
        return message + ' Error: ' + file.errorMessage;
      } else if (file.$error === 'pattern') {
        return message + ' Error: file type unsupported';
      } else if (file.$error === 'maxSize') {
        return message + ' Error: file exceeds maximum allowed size';
      } else {
        return message + ' Error';
      }
    }

    function cancelUpload() {
      $mdDialog.cancel();
    }

    function setLogo() {
      vm.customer.logoFileName = vm.logoFileName;
      Customers.update(vm.customer.id, vm.customer)
        .then(function Success() {
          toastr.success("Customer logo updated");
          $mdDialog.hide();
        })
        .catch(function Failure() {
          toastr.error("Error setting customer logo");
        });
    }
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular.module('admin')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    // Get Migration Flags
    var coreFacade = bridge.store.getFacade('core');
    coreFacade.allActivatedMigrationFeatureFlags$_legacySupport({ take: 1 }) // We need the information only once
      .subscribe(function (enabledMigrationFeatureFlags) {
        $stateProvider
          .state('admin.customer', {
            abstract: true,
            url: '/customer/:customerId',
            resolve: {
              customer: ["$stateParams", function($stateParams) {
                var customerProfileFacade = bridge.store.getFacade('customerProfile');
                customerProfileFacade.init_legacySupport($stateParams.customerId);

                return customerProfileFacade.loadedCustomerProfile$_legacySupport_promise();
              }],
              user: function() {
                var coreFacade = bridge.store.getFacade('core');

                return coreFacade.loggedUser$_legacySupport_promise();
              }
            },
            views: {
              'nav-sub-menu@admin': {
                templateUrl: 'app/admin/customers/customer-menu.html',
                controller: 'CustomerMenuController as $ctrl'
              }
            }
          })
          .state('admin.customer.engagements', {
            url: '/engagements',
            resolve: {
              projects: ["$stateParams", function($stateParams) {
                var projectsFacade = bridge.store.getFacade('projects');
                projectsFacade.findAll_legacySupport($stateParams.customerId, 5000);

                return projectsFacade.allLoadedProjects$_legacySupport_promise();
              }]
            },
            views: {
              'content@admin': {
                templateUrl: 'app/admin/customers/customer-engagements.html',
                controller: 'CustomerEngagementsController as $ctrl'
              }
            }
          })
          .state('admin.customer.users', {
            url: '/users',
            resolve: {
              users: ["$stateParams", function($stateParams) {
                var customerUserFacade = bridge.store.getFacade('customerUser');
                customerUserFacade.init_legacySupport($stateParams.customerId);

                return customerUserFacade
                  .allLoadedCustomerUser$_legacySupport_promise();
              }]
            },
            views: enabledMigrationFeatureFlags.adminCustomer == true ? {} : {
              'content@admin': {
                templateUrl: 'app/admin/customers/customer-users.html',
                controller: 'CustomerUsersController as $ctrl'
              }
            }
          })
          .state('admin.customer.profile', {
            url: '/profile',
            views: {
              'content@admin': {
                templateUrl: 'app/admin/customers/customer-profile.html',
                controller: 'CustomerProfileController as $ctrl'
              }
            }
          });
      });
  }
})();

(function() {
  'use strict';

  CustomersListTableController.$inject = ["$filter", "$state", "$mdDialog", "tableUtils", "toastr", "Authorization", "CUSTOMER"];
  angular
    .module('admin')
    .component('customersListTable', {
      templateUrl: 'app/admin/customers/customers-list-table.html',
      bindings:{
        customers: '<'
      },
      controller: CustomersListTableController
    });

  function CustomersListTableController(
    $filter,
    $state,
    $mdDialog,
    tableUtils,
    toastr,
    Authorization,
    CUSTOMER) {
    var vm = this;
    vm.exportToCsv = exportToCsv;
    vm.openCustomerDialog = openCustomerDialog;

    var exportParams = {
      fileName: _getExportName(),
      columnKeys: ['name', 'type', 'subtype', 'metrics.engagements', 'metrics.lastUpdate', 'metrics.bankTransactions',
        'metrics.glTransactions', 'metrics.totalPages', 'metrics.processingActivity' ],
      processCellCallback: exportCSVFormatCells
    };
    
    this.$onInit = function() {
      vm.columnDefs = [
        {
          headerName: 'Customer',
          field: 'name',
          width: 300,
          cellRenderer: function(params) {
            return '<a href="#">' + params.value + '</a>';
          },
          onCellClicked: function(params) {
            $state.go('admin.customer.engagements', { customerId: params.data.id });
          }
        },
        {
          headerName: 'Type',
          field: 'type',
          width: 200,
          valueFormatter: function(params) {
            return CUSTOMER.TYPE_DESCRIPTION[params.value];
          },
          getQuickFilterText: function(params) {
            return CUSTOMER.TYPE_DESCRIPTION[params.value];
          }
        },
        {
          headerName: 'SubType',
          field: 'subtype',
          width: 200,
          valueFormatter: function(params) {
            return CUSTOMER.SUBTYPE_DESCRIPTION[params.value];
          },
          getQuickFilterText: function(params) {
            return CUSTOMER.SUBTYPE_DESCRIPTION[params.value];
          }
        },
        {
          headerName: 'Engagements',
          field: 'metrics.engagements',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(params.value);
          }
        },
        {
          headerName: 'Last Update',
          field: 'metrics.lastUpdate',
          valueFormatter: function (params) {
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Bank Transactions',
          field: 'metrics.bankTransactions',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(params.value);
          }
        },
        {
          headerName: 'ERP Transactions',
          field: 'metrics.glTransactions',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(_getErpCount(params.data.metrics));
          }
        },
        {
          headerName: 'Pages',
          field: 'metrics.totalPages',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(params.value);
          }
        },
        {
          headerName: 'Processing Activity',
          field: 'metrics.processingActivity',
          cellClass: 'icons links',
          cellRenderer: function(params) {
            return params.value ? '<md-icon class="material-icons icon-primary check">check</md-icon>' : '';
          }
        }
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowData: vm.customers,
        rowHeight: 30,
        suppressCellSelection: true,
        headerHeight: 25,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onGridReady: function(params) {
          params.api.sizeColumnsToFit();
        }
      };
    };

    function openCustomerDialog() {
      $mdDialog.show({
        templateUrl: 'app/admin/customers/add-customer-dialog.html',
        controller: 'AddCustomerController',
        controllerAs: '$ctrl',
        bindToController: true
      }).then(function Success() {});
    }

    function exportToCsv() {
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'type') {
          return CUSTOMER.TYPE_DESCRIPTION[params.value];
        } else if (params.column.colId === 'subtype') {
          return CUSTOMER.SUBTYPE_DESCRIPTION[params.value];
        } else if (params.column.colId === 'lastUpdate'){
          return $filter('dateDisplay')(params.value);
        } else if (params.column.colId === 'metrics.glTransactions') {
          return _getErpCount(params.node.data.metrics);
        } else {
          return params.value;
        }
      } else {
        return params.value;
      }
    }

    function _getExportName() {
      return 'VALID8_CUSTOMERS_' + moment().format('MMYYYY') + '.csv';
    }

    function _getErpCount(metrics) {
      return metrics ? metrics.glTransactions + metrics.arTransactions + metrics.apTransactions : 0;
    }

  }
})();

(function() {
  'use strict';

  Customers.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('admin')
    .factory('Customers', Customers);

  function Customers(DS, DSHttpAdapter) {
    var customers = DS.defineResource({
      name: 'customers',
      endpoint: 'customers',
      idAttribute: 'id',
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    customers.getLogoUploadParameters = function(customerId) {
      return DSHttpAdapter.HTTP({
        method: 'POST',
        url: DSHttpAdapter.defaults.basePath + '/customer-logo/upload',
        params: {customerId: customerId},
        data: {}
      });
    };

    customers.validisSync = function(customerId) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/customer/validis/sync',
        {},
        { params: {customerId: customerId} }
      );
    };

    return customers;
  }
})();

(function() {
  'use strict';

  CustomerUsersController.$inject = ["customer", "users"];
  angular
    .module('admin')
    .controller('CustomerUsersController', CustomerUsersController);

  function CustomerUsersController(
    customer,
    users) {
    var vm = this;

    activate();

    function activate() {
      vm.customer = customer;
      vm.users = users;
    }
  }
})();

(function() {
  'use strict';

  CustomerUsersListTableController.$inject = ["$scope", "$filter", "$stateParams", "$mdDialog", "tableUtils", "toastr", "RBAC"];
  angular
    .module('admin')
    .component('customerUsersListTable', {
      templateUrl: 'app/admin/customers/customer-users-list-table.html',
      bindings:{
        users: '<',
        customer: '<',
      },
      controller: CustomerUsersListTableController
    });

  function CustomerUsersListTableController(
    $scope,
    $filter,
    $stateParams,
    $mdDialog,
    tableUtils,
    toastr,
    RBAC) {
    var vm = this;
    vm.selectedUsers = [];
    vm.customerId = $stateParams.customerId;
    vm.selectAll = selectAll;
    vm.exportToCsv = exportToCsv;
    vm.openCustomerUserDialog = openCustomerUserDialog;
    vm.customerUserActionDialog = customerUserActionDialog;

    var exportParams;
    this.$onInit = function() {
      vm.isSSO = (vm.customer.enterpriseConnection ? true : false);
      exportParams = {
        fileName: _getExportName(),
        columnKeys: ['email', 'accessPolicies', 'firstName', 'lastName', 'enabled', 'lastActivity'],
        processCellCallback: exportCSVFormatCells
      };
      vm.columnDefs = [
        {
          headerName: 'Select',
          field: 'in-edit',
          checkboxSelection: true,
          pinned: 'left',
          width: 70,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true
        },
        {
          headerName: 'Edit',
          width: 55,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          pinned: 'left',
          cellClass: 'icons links',
          cellRenderer: function() {
            return '<md-icon class="material-icons icon-primary">edit</md-icon>';
          },
          onCellClicked: function(params) {
            openCustomerUserDialog(params.data);
          }
        },
        {
          headerName: 'Email',
          field: 'email',
          width: 200
        },
        {
          headerName: 'Role',
          field: 'accessPolicies',
          width: 100,
          valueFormatter: function(params) {
            return _getRole(params);
          },
          getQuickFilterText: function(params) {
            return _getRole(params);
          }
        },
        {
          headerName: 'First Name',
          field: 'firstName',
          width: 200
        },
        {
          headerName: 'Last Name',
          field: 'lastName',
          width: 200
        },
        {
          headerName: 'Enabled',
          field: 'enabled',
          width: 100,
          cellRenderer: function(params) {
            return params.value === true ? '<md-icon class="material-icons icon-primary check">check</md-icon>' : '<md-icon class="material-icons">close</md-icon>';
          }
        },
        {
          headerName: 'Last Activity',
          field: 'lastActivity',
          width: 100,
          valueFormatter: function(params) {
            if(params.value) {
              return $filter('dateTimeFilter')(params.value);
            } else {
              return 'Never';
            }
          }
        }
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowData: vm.users,
        headerHeight: 25,
        rowHeight: 30,
        rowSelection: 'multiple',
        onRowSelected: _toggleRowSelected,
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        enableCellTextSelection: true,
        angularCompileRows: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onGridReady: function(params) {
          params.api.sizeColumnsToFit();
        }
      };
    };

    function _getRole(params) {
      if(params.value) {
        return RBAC.ROLE_DESCRIPTION[Object.keys(params.value)[0]];
      } else {
        return 'error';
      }
    }

    function openCustomerUserDialog(user) {
      if(!user) {
        if (vm.isSSO) {
          toastr.error('users must be created by logging in via SSO');
          return;
        }
        user = {};
      }
      $mdDialog.show({
        templateUrl: 'app/admin/customers/add-customer-user-dialog.html',
        controller: 'AddCustomerUserController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          user: user,
          customerId: vm.customerId,
          isSSO: vm.isSSO,
        }
      }).then(function Success() {});
    }

    function customerUserActionDialog(action) {
      $mdDialog.show({
        templateUrl: 'app/admin/customers/customer-user-action-dialog.html',
        controller: 'CustomerUserActionDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          users: vm.selectedUsers,
          action: action,
          customerId: vm.customerId
        }
      });
    }

    function selectAll() {
      tableUtils.selectUnselectAll(vm.gridOptions);
    }

    function _toggleRowSelected() {
      vm.selectedUsers = vm.gridOptions.api.getSelectedRows();
      $scope.$applyAsync();
    }

    function exportToCsv() {
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'lastActivity') {
          return $filter('dateTimeFilter')(params.value);
        } else if (params.column.colId === 'accessPolicies') {
          return _getRole(params);
        } else {
          return params.value;
        }
      } else {
        return params.value;
      }
    }

    function _getExportName() {
      return 'VALID8_CUSTOMER_USERS' + moment().format('MMYYYY') + '.csv';
    }
  }
})();

(function() {
  'use-strict';

  CustomerUserActionDialogController.$inject = ["$mdDialog", "$q", "$state", "$stateParams", "toastr", "Authorization", "users", "customerId", "action", "RBAC"];
  angular
    .module('admin')
    .controller('CustomerUserActionDialogController', CustomerUserActionDialogController);

  function CustomerUserActionDialogController(
    $mdDialog,
    $q,
    $state,
    $stateParams,
    toastr,
    Authorization,
    users,
    customerId,
    action,
    RBAC) {

    var vm = this;
    var rxjsSubs = [];

    vm.users = users;
    vm.action = action;
    vm.customerId = customerId;
    vm.save = save;
    vm.cancel = $mdDialog.cancel;

    vm.$onDestroy = function () {
      rxjsSubs.forEach(function (sub) {
        sub.complete();
      });
    };

    activate();

    function activate() {
      vm.role = RBAC.ROLES.CUSTOMER_USER;
      vm.chooseRole = false;
      if(vm.action === 'assign') {
        vm.chooseRole = true;
      }
    }

    function save() {
      vm.userIds = [];
      var user = Authorization.getUserProfile();
      if(user) {
        for(var i = 0; i < vm.users.length; i++) {
          //logged user cannot block or remove himself...
          var a = vm.users[i];
          if( a.id === user.id && ( ['block', 'delete', 'assign'].indexOf(vm.action) >= 0)) {
            toastr.error('Logged user cannot block, delete or reassign role himself');
            $mdDialog.hide(true);
            return;
          } else {
            vm.userIds.push(a.id);
          }
        }

        var options = { customerId: vm.customerId };
        if(vm.action === 'assign') {
          options.role = vm.role;
        }

        var customerUserFacade = bridge.store.getFacade('customerUser');

        switch(vm.action) {
        case 'email':
          doBatchOperation(
            customerUserFacade,
            {
              selectorName: 'nextUsersEmailSucceed$_legacySupport',
              message: 'Emails sent'
            },
            {
              actionName: 'sendEmailToUsers_legacySupport',
              params: [vm.customerId, vm.userIds]
            },
            {
              selectorName: 'nextUsersEmailFailure$_legacySupport'
            }
          );
          break;

        case 'block':
          doBatchOperation(
            customerUserFacade,
            {
              selectorName: 'nextBlockUsersSucceed$_legacySupport',
              message: 'Users blocked'
            },
            {
              actionName: 'blockUsers_legacySupport',
              params: [vm.customerId, vm.userIds]
            },
            {
              selectorName: 'nextBlockUsersFailure$_legacySupport'
            }
          );
          break;

        case 'enable':
          doBatchOperation(
            customerUserFacade,
            {
              selectorName: 'nextEnableUsersSucceed$_legacySupport',
              message: 'Users enabled'
            },
            {
              actionName: 'enableUsers_legacySupport',
              params: [vm.customerId, vm.userIds]
            },
            {
              selectorName: 'nextEnableUsersFailure$_legacySupport'
            }
          );
          break;

        case 'assign':
          doBatchOperation(
            customerUserFacade,
            {
              selectorName: 'nextChangeUsersRoleSucceed$_legacySupport',
              message: 'Users role changed'
            },
            {
              actionName: 'changeUsersRole_legacySupport',
              params: [vm.customerId, vm.userIds, options.role]
            },
            {
              selectorName: 'nextChangeUsersRoleFailure$_legacySupport'
            }
          );
          break;

        case 'delete':
          doBatchOperation(
            customerUserFacade,
            {
              selectorName: 'nextDeleteUsersRoleSucceed$_legacySupport',
              message: 'Users deleted'
            },
            {
              actionName: 'deleteUsers_legacySupport',
              params: [vm.customerId, vm.userIds]
            },
            {
              selectorName: 'nextDeleteUsersRoleFailure$_legacySupport'
            }
          );
          break;
        }
      } else { //Should never happen
        toastr.error('Unauthorized');
        $mdDialog.hide(true);
      }

      function doBatchOperation(facade, success, action, failure) {
        var succSub = facade[success.selectorName]()
          .subscribe(function () {
            toastr.success(success.message);
            $mdDialog.hide(true);
            $state.reload();
          });

        var failureSub = facade[failure.selectorName]()
          .subscribe(function () {
            toastr.error('An error ocurred');
            $mdDialog.hide(true);
          });

        rxjsSubs.push(succSub);
        rxjsSubs.push(failureSub);

        facade[action.actionName].apply(facade, action.params);
      }
    }

  }
})();

(function() {
  'use strict';

  CustomerProfileController.$inject = ["$state", "$timeout", "$mdDialog", "toastr", "dateUtils", "Authorization", "CUSTOMER", "customer"];
  angular
    .module('admin')
    .controller('CustomerProfileController', CustomerProfileController);

  function CustomerProfileController(
    $state,
    $timeout,
    $mdDialog,
    toastr,
    dateUtils,
    Authorization,
    CUSTOMER,
    customer) {
    var vm = this;
    var rxjsSubs = [];
    vm.subtypes = Object.keys(CUSTOMER.SUBTYPE_DESCRIPTION);
    vm.contractTypes = Object.keys(CUSTOMER.CONTRACT_TYPE_DESCRIPTION);
    vm.saveCustomerProfile = saveCustomerProfile;
    vm.syncCustomer = syncCustomer;
    vm.uploadLogo = uploadLogo;
    vm.validateTxnLimit = validateTxnLimit;

    vm.auditSubtypes = [
      CUSTOMER.SUBTYPE.AUDIT_S,
      CUSTOMER.SUBTYPE.AUDIT_M,
      CUSTOMER.SUBTYPE.AUDIT_L
    ];
    vm.forensicSubtypes = [
      CUSTOMER.SUBTYPE.FORENSIC_NON_CPA,
      CUSTOMER.SUBTYPE.FORENSIC_CPA,
      CUSTOMER.SUBTYPE.FORENSIC_GOV
    ];

    vm.$onDestroy = function () {
      rxjsSubs.forEach(function (sub) {
        sub.complete();
      });
    };

    activate();

    function activate() {
      vm.isV8Admin = Authorization.isV8Admin();
      vm.customerCopy = angular.extend({}, customer);

      if(vm.customerCopy.type === CUSTOMER.TYPE.AUDIT) {
        vm.isAudit = true;
        vm.subtypes = vm.auditSubtypes;
      } else {
        vm.subtypes = vm.forensicSubtypes;
      }

      if(vm.isV8Admin) {
        if(!vm.customerCopy.contractInfo) {
          vm.customerCopy.contractInfo = {};
          vm.customerCopy.contractInfo.isPilot = false;
        }
        if(!vm.customerCopy.integrationData) {
          vm.customerCopy.integrationData = {};
        }
        dateUtils.formatDates(vm.customerCopy.contractInfo);
      }
      _initContactInfo();
    }

    function validateTxnLimit() {
      if (vm.customerCopy.contractInfo.annualTxnLimit < 0) {
        vm.customerCopy.contractInfo.annualTxnLimit = 0;
      }
    }

    function saveCustomerProfile() {
      if(vm.customerCopy) {
        var customerProfileFacade = bridge.store.getFacade('customerProfile');
        rxjsSubs = [...rxjsSubs, customerProfileFacade.nextUpdateCustomerProfileSucceed$_legacySupport().subscribe(function() {
          $timeout(function() {
            toastr.success("Customer profile saved");
            $state.reload();
          }, 1000);
        })];
        rxjsSubs = [...rxjsSubs, customerProfileFacade.nextUpdateCustomerProfileFailure$_legacySupport().subscribe(function() {
          toastr.error("An error ocurred");
        })];
        var customerProfile = JSON.parse(JSON.stringify(vm.customerCopy));
        customerProfileFacade.updateCustomerProfile_legacySupport(vm.customerCopy.id, customerProfile);
      }
    }

    function syncCustomer() {
      var customerProfileFacade = bridge.store.getFacade('customerProfile');
      rxjsSubs = [...rxjsSubs, customerProfileFacade.nextSyncCustomerSucceed$_legacySupport().subscribe(function() {
        toastr.success("Validis Sync job started...");
      })];
      rxjsSubs = [...rxjsSubs, customerProfileFacade.nextSyncCustomerFailure$_legacySupport().subscribe(function() {
        toastr.error("An error ocurred");
      })];
      customerProfileFacade.syncCustomer_legacySupport(vm.customerCopy.id);
    }

    function _initContactInfo() {
      if(!vm.customerCopy.keyContactInfo || Object.keys(vm.customerCopy.keyContactInfo).length !== 3) {
        vm.customerCopy.keyContactInfo = {};
        vm.customerCopy.keyContactInfo[CUSTOMER.CONTACT_TYPE.CONTRACTS] = {};
        vm.customerCopy.keyContactInfo[CUSTOMER.CONTACT_TYPE.BILLING] = {};
        vm.customerCopy.keyContactInfo[CUSTOMER.CONTACT_TYPE.OPERATIONS] = {};
      }
    }

    function uploadLogo() {
      var customerProfileFacade = bridge.store.getFacade('customerProfile');
      rxjsSubs = [...rxjsSubs, customerProfileFacade.nextUploadCustomerLogoSucceed$_legacySupport().subscribe(function({uploadParameters}) {
        _openUploadDialog(uploadParameters);
      })];
      rxjsSubs = [...rxjsSubs, customerProfileFacade.nextUploadCustomerLogoFailure$_legacySupport().subscribe(function(response) {
        _failure(response.data.message);
      })];
      customerProfileFacade.uploadCustomerLogo_legacySupport(vm.customerCopy.id);
    }

    function _openUploadDialog(uploadParameters) {
      $mdDialog.show({
        templateUrl: 'app/admin/customers/upload-customer-logo.html',
        controller: 'UploadCustomerLogoController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {uploadParameters, customer: vm.customerCopy},
      });
    }

    function _failure(messageText) {
      $mdDialog.show({
        templateUrl: 'app/core/utils/alert-dialog/alert-dialog.html',
        controller: 'AlertDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          message: messageText
        }
      });
    }

  }
})();


(function() {
  'use strict';

  CustomerMenuController.$inject = ["customer"];
  angular
    .module('admin')
    .controller('CustomerMenuController', CustomerMenuController);

  function CustomerMenuController(customer) {
    var vm = this;
    activate();

    function activate() {
      vm.customer = customer;
    }
  }
})();

(function() {
  'use strict';

  CustomerEngagementsController.$inject = ["$state", "$stateParams", "Authorization", "customer", "projects"];
  angular
    .module('admin')
    .controller('CustomerEngagementsController', CustomerEngagementsController);

  function CustomerEngagementsController(
    $state,
    $stateParams,
    Authorization,
    customer,
    projects) {

    var vm = this;

    activate();

    function activate() {
      vm.projects = projects;
      vm.customer = customer;
    }
  }
})();

(function() {
  'use strict';

  CustomerEngagementsListTableController.$inject = ["$filter", "$state", "$mdDialog", "tableUtils", "toastr", "PROJECT_TYPES", "projectsNavigationService"];
  angular
    .module('admin')
    .component('customerEngagementsListTable', {
      templateUrl: 'app/admin/customers/customer-engagements-list-table.html',
      bindings:{
        projects: '<',
        customer: '<'
      },
      controller: CustomerEngagementsListTableController
    });

  function CustomerEngagementsListTableController(
    $filter,
    $state,
    $mdDialog,
    tableUtils,
    toastr,
    PROJECT_TYPES,
    projectsNavigationService) {
    var vm = this;
    vm.exportToCsv = exportToCsv;
    vm.openEngagementDialog = openEngagementDialog;
    var exportParams;
    this.$onInit = function() {
      exportParams  = {
        fileName: _getExportName(),
        columnKeys: ['name', 'description', 'metrics.lastUpdate', 'metrics.startDate', 'metrics.endDate', 'metrics.bankTransactions', 'metrics.glTransactions', 'metrics.accounts', 'metrics.totalPages',
          'metrics.processingActivity' ],
        processCellCallback: exportCSVFormatCells
      };

      vm.type = vm.customer.type;
      vm.columnDefs = [
        {
          headerName: 'Edit',
          width: 55,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          pinned: 'left',
          cellClass: 'icons links',
          cellRenderer: function() {
            return '<md-icon class="material-icons icon-primary">edit</md-icon>';
          },
          onCellClicked: function(params) {
            openEngagementDialog(params.data);
          }
        },
        {
          headerName: 'Users',
          width: 55,
          resizable: false,
          suppressMovable: true,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          pinned: 'left',
          cellClass: 'icons links',
          cellRenderer: function() {
            return '<md-icon class="material-icons icon-primary">account_box</md-icon>';
          },
          onCellClicked: function(params) {
            $state.go('admin.customer.engagements.users', { projectId: params.data.id });
          }
        },
        {
          headerName: 'Name',
          field: 'name',
          width: 400,
          cellRenderer: function(params) {
            return '<a href="#">' + params.value + '</a>';
          },
          onCellClicked: function(params) {
            projectsNavigationService.goToProjectOverview(params.data);
          }
        },
        {
          headerName: 'Description',
          field: 'description',
          width: 200
        },
        {
          headerName: 'Last Update',
          field: 'metrics.lastUpdate',
          sort: 'desc',
          valueFormatter: function(params) {
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Bank Transactions',
          field: 'metrics.bankTransactions',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(params.value);
          }
        },
        { headerName: 'ERP Transactions',
          field: 'metrics.glTransactions',
          hide: vm.type === PROJECT_TYPES.FORENSIC,
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(_getErpCount(params.data.metrics));
          }
        },
        {
          headerName: 'Accounts',
          field: 'metrics.accounts',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(params.value);
          }
        },
        {
          headerName: 'Pages',
          field: 'metrics.totalPages',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(params.value);
          }
        },
        {
          headerName: 'Processing Activity',
          field: 'metrics.processingActivity',
          cellClass: 'icons links',
          cellRenderer: function(params) {
            return params.value ? '<md-icon class="material-icons icon-primary check">check</md-icon>' : '';
          }
        }
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowData: vm.projects,
        rowHeight: 30,
        suppressCellSelection: true,
        rowSelection: 'multiple',
        headerHeight: 25,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onGridReady: function(params) {
          params.api.sizeColumnsToFit();
        }
      };
    };

    function openEngagementDialog(project) {
      if(!project) {
        project = {};
      }
      $mdDialog.show({
        templateUrl: 'app/admin/customers/engagements/add-engagement-dialog.html',
        controller: 'AddEngagementController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          project: project,
          customer: vm.customer
        }
      }).then(function Success() {});
    }

    function _getErpCount(metrics) {
      return metrics ? metrics.glTransactions + metrics.arTransactions + metrics.apTransactions : 0;
    }

    function exportToCsv() {
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'startDate' || params.column.colId === 'endDate' || params.column.colId === 'lastUpdate') {
          return $filter('dateDisplay')(params.value);
        } else if (params.column.colId === 'metrics.glTransactions') {
          return _getErpCount(params.node.data.metrics);
        } else {
          return params.value;
        }
      } else {
        return params.value;
      }
    }

    function _getExportName() {
      return 'VALID8_' + vm.customer.name + '_Engagements_' + moment().format('MMYYYY') + '.csv';
    }
  }
})();

(function() {
  'use strict';

  CustomerContactController.$inject = ["COUNTRIES", "CUSTOMER"];
  angular
    .module('admin')
    .component('customerContact', {
      templateUrl: 'app/admin/customers/customer-contact.html',
      bindings: {
        contactInfo: '<',
        type: '@'
      },
      controller: CustomerContactController
    });

  function CustomerContactController(
    COUNTRIES,
    CUSTOMER) {
    var vm = this;
    vm.toggleCopy = toggleCopy;
    function activate() {
      vm.copyAbove = false;
      vm.contact = vm.contactInfo[vm.type];
      vm.countries = COUNTRIES.LIST;
      if(!vm.contact.location) {
        vm.contact.location = { country: 'USA' };
      }
    }

    function toggleCopy() {
      if(vm.type === CUSTOMER.CONTACT_TYPE.BILLING) {
        _copyContact(vm.contactInfo[CUSTOMER.CONTACT_TYPE.CONTRACTS], vm.contactInfo[vm.type]);
      } else if(vm.type === CUSTOMER.CONTACT_TYPE.OPERATIONS) {
        _copyContact(vm.contactInfo[CUSTOMER.CONTACT_TYPE.BILLING], vm.contactInfo[vm.type]);
      }
    }

    function _copyContact(from, to) {
      if(vm.copyAbove) {
        Object.keys(from).forEach(function(k) {
          to[k] = from[k];
        });
      } else {
        Object.keys(to).forEach(function(k) {
          to[k] = null;
        });
        to.location = { country: 'USA' };
      }
    }

    this.$onInit = function() {
      activate();
    };
  }
})();

(function() {
  'use strict';

  AddCustomerController.$inject = ["$q", "$stateParams", "$scope", "$state", "$mdDialog", "$timeout", "toastr", "CUSTOMER", "Customers"];
  angular
    .module('admin')
    .controller('AddCustomerController', AddCustomerController);

  function AddCustomerController(
    $q,
    $stateParams,
    $scope,
    $state,
    $mdDialog,
    $timeout,
    toastr,
    CUSTOMER,
    Customers) {
    var vm = this;
    vm.setSubtypes = setSubtypes;
    vm.submitSaveCustomer = submitSaveCustomer;
    vm.closeAddCustomer = $mdDialog.cancel;

    vm.auditSubtypes = [
      CUSTOMER.SUBTYPE.AUDIT_S,
      CUSTOMER.SUBTYPE.AUDIT_M,
      CUSTOMER.SUBTYPE.AUDIT_L
    ];
    vm.forensicSubtypes = [
      CUSTOMER.SUBTYPE.FORENSIC_NON_CPA,
      CUSTOMER.SUBTYPE.FORENSIC_CPA,
      CUSTOMER.SUBTYPE.FORENSIC_GOV
    ];
    
    activate();

    function activate() {
      vm.customer = {
        type: CUSTOMER.TYPE.FORENSIC,
        subtype: CUSTOMER.SUBTYPE.FORENSIC_NON_CPA
      };
      setSubtypes();
    }


    function submitSaveCustomer(form) {
      if(!form.$invalid) {
        Customers.create(vm.customer).then(function Success(response) {
          $timeout(function() {
            $mdDialog.cancel();
            $state.go('admin.customer.profile', {customerId: response.id});
          }, 1000);
        }).catch(function Failure() {
          toast.error('An error ocurred');
          $mdDialog.cancel();
        });
      }
    }

    function setSubtypes() {
      vm.subtypes = vm.customer.type === CUSTOMER.TYPE.FORENSIC ? vm.forensicSubtypes : vm.auditSubtypes;
      vm.customer.subtype = vm.subtypes[0];
    }

  }
})();


(function() {
  'use strict';

  AddCustomerUserController.$inject = ["$q", "$stateParams", "$scope", "$state", "$mdDialog", "toastr", "RBAC", "customerId", "user"];
  angular
    .module('admin')
    .controller('AddCustomerUserController', AddCustomerUserController);

  function AddCustomerUserController(
    $q,
    $stateParams,
    $scope,
    $state,
    $mdDialog,
    toastr,
    RBAC,
    customerId,
    user) {

    var vm = this;
    var rxjsSubs = [];
    
    vm.submitSaveCustomerUser = submitSaveCustomerUser;
    vm.closeAddCustomerUser = $mdDialog.cancel;

    vm.$onDestroy = function () {
      rxjsSubs.forEach(function (sub) {
        sub.complete();
      });
    };
    
    activate();

    function activate() {
      vm.role = RBAC.ROLES.CUSTOMER_USER;
      vm.isEdit = user.id;
      vm.user = user;
      vm.customerId = customerId;
      if(vm.isEdit && vm.user.accessPolicies) {
        vm.role = Object.keys(vm.user.accessPolicies)[0];
      }
    }

    function submitSaveCustomerUser(form) {
      if(!form.$invalid) {
        if(vm.isEdit) {
          _saveCustomerUser();
        } else {
          _addCustomerUser();
        }
      }
    }

    function _success(message) {
      $mdDialog.cancel();
      toastr.success(message);
      $state.reload();
    }

    function _failure(message) {
      $mdDialog.cancel();
      toastr.error(message);
    }

    function _addCustomerUser() {
      if(vm.user) {
        vm.user.role = vm.role;

        var customerUserFacade = bridge.store.getFacade('customerUser');

        var succSub = customerUserFacade.nextCreateUserSucceed$_legacySupport()
          .subscribe(function () {
            _success(vm.user.email + ' has been successfully created.');
          });

        var failureSub = customerUserFacade.nextCreateUserFailure$_legacySupport()
          .subscribe(function () {
            _failure('There was an error creating the user');
          });

        rxjsSubs.push(succSub);
        rxjsSubs.push(failureSub);

        customerUserFacade.createUser_legacySupport(vm.customerId, vm.user);
      }
    }

    function _saveCustomerUser() {
      if(vm.user) {
        var customerUserFacade = bridge.store.getFacade('customerUser');

        var succSub = customerUserFacade.nextUpdateUserSucceed$_legacySupport()
          .subscribe(function () {
            _success(vm.user.email + ' has been successfully updated.');
          });

        var failureSub = customerUserFacade.nextUpdateUserFailure$_legacySupport()
          .subscribe(function () {
            _failure('There was an error updating the user');
          });

        rxjsSubs.push(succSub);
        rxjsSubs.push(failureSub);

        customerUserFacade.updateUser_legacySupport(vm.user.id, vm.user);
      }
    }

  }
})();


(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('projects')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('projects', {
        url: 'projects',
        abstract: true,
        parent: 'app',
        views: {
          'main-content@app': {
            templateUrl: 'app/layout/content-sidenav-left.html'
          }
        },
        resolve: {
          user: function() {
            var coreFacade = bridge.store.getFacade('core');

            return coreFacade.loggedUser$_legacySupport_promise();
          }
        }

      })
      .state('engagements', {
        url: 'engagements',
        abstract: true,
        parent: 'app',
        views: {
          'main-content@app': {
            templateUrl: 'app/layout/content-sidenav-left.html'
          }
        },
        resolve: {
          user: function() {
            var coreFacade = bridge.store.getFacade('core');

            return coreFacade.loggedUser$_legacySupport_promise();
          }
        }

      })
      .state('projects.list', {
        url: '',
        resolve: {
          user: function() {
            var coreFacade = bridge.store.getFacade('core');

            return coreFacade.loggedUser$_legacySupport_promise();
          },
          projects: ["user", "Projects", "$q", function(user, Projects, $q) {
            if (user) {
              return Projects.findAll({$limit: 5000}, {bypassCache: true});
            } else {
              return $q.when([]);
            }
          }]
        },
        views: {
          'content@projects': {
            templateUrl: 'app/projects/projects-list.html',
            controller: 'ProjectsListController as $ctrl'
          }
        }
      })
      .state('projects.add', {
        url: '^/add-project',
        views: {
          'content@projects': {
            templateUrl: 'app/projects/add-project.html',
            controller: 'AddProjectController as $ctrl'
          }
        },
        resolve: {
          project: function() {
            return {};
          }
        }
      });
  }

})();

(function() {
  'use strict';

  ProjectsListController.$inject = ["Authorization", "projects"];
  angular
    .module('projects')
    .controller('ProjectsListController', ProjectsListController);

  function ProjectsListController(
    Authorization,
    projects) {
    var vm = this;

    activate();

    function activate() {
      vm.investigationsTitle = 'Engagements';
      vm.projects = projects;
    }
  }
})();

(function() {
  'use strict';

  ProjectsListTableController.$inject = ["$filter", "tableUtils", "projectsNavigationService", "toastr", "Authorization", "PROJECT_TYPES", "RBAC"];
  angular
    .module('projects')
    .component('projectsListTable', {
      templateUrl: 'app/projects/projects-list-table.html',
      bindings:{
        projects: '<',
      },
      controller: ProjectsListTableController
    });

  function ProjectsListTableController(
    $filter,
    tableUtils,
    projectsNavigationService,
    toastr,
    Authorization,
    PROJECT_TYPES,
    RBAC) {
    var vm = this;
    vm.showAudit = false;
    vm.showInvestigations = false;
    var GRID_ID = 'grid-projects';
    var GRID_VERSION = 3;
    vm.exportToCsv = exportToCsv;
    vm.filter = filter;
    var exportParams = {
      fileName: _getExportName(),
      columnKeys: ['name', 'type', 'createdAt', 'metrics.lastUpdate', 'metrics.stmtTransactions', 'deletedStmtTransactions', 'metrics.listTransactions',
        'metrics.glTransactions', 'metrics.checkItems', 'metrics.accounts', 'metrics.statementPages', 'metrics.statementPagesWithoutTxns',
        'metrics.brokeragePages', 'metrics.checkPages', 'metrics.checkPagesWithoutChecks', 'metrics.brokerageAccountPeriods', 'metrics.processingActivity' ],
      processCellCallback: exportCSVFormatCells
    };

    this.$onInit = function() {
      vm.columnDefs = [
        {
          headerName: 'Engagement',
          field: 'name',
          width: 400,
          cellRenderer: function(params) {
     
            var newMarker = moment().diff(moment(params.data.createdAt), 'days') < 15 ? '<md-icon class="material-icons icon-primary">add</md-icon>' : '';
            return '<span>' + newMarker + `<a href="#">` + params.value + '</a>' + '</span>' ;
          },
          onCellClicked: function(params) {
            if(!isReadOnlyAdmin()){
              projectsNavigationService.goToProjectOverview(params.data);
            }
          }
        },
        {
          headerName: 'Type',
          field: 'type',
          width: 150,
          hide: true,
          valueFormatter: function(params) {
            return params && params.value === PROJECT_TYPES.AUDIT ? 'Audit' : 'Investigations';
          },
          getQuickFilterText: function(params) {
            return params && params.value === PROJECT_TYPES.AUDIT ? 'Audit' : 'Investigations';
          }
        },
        {
          headerName: 'Created',
          field: 'createdAt',
          valueFormatter: function(params) {
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Last Update',
          field: 'metrics.lastUpdate',
          sort: 'desc',
          valueFormatter: function(params) {
            return $filter('dateDisplay')(params.value);
          }
        },
        {
          headerName: 'Stmt Txns',
          field: 'metrics.stmtTransactions',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(params.value ? params.value : 0);
          }
        },
        {
          headerName: 'Del Stmt Txns',
          field: 'deletedStmtTransactions',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(params.value ? params.value : 0);
          },
          hide: true,
        },
        {
          headerName: 'List Txns',
          field: 'metrics.listTransactions',
          cellClass: ['grid-amount'],
          hide: true,
          valueFormatter: function (params) {
            return $filter('number')(params.value ? params.value : 0);
          }
        },
        {
          headerName: 'Items',
          field: 'metrics.checkItems',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(_getChecksCount(params.data.metrics));
          }
        },
        {
          headerName: 'ERP Txns',
          field: 'metrics.glTransactions',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(_getErpCount(params.data.metrics));
          }
        },
        {
          headerName: 'Accounts',
          field: 'metrics.accounts',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(params.value ? params.value : 0);
          }
        },
        {
          headerName: 'Stmt Pages',
          field: 'metrics.statementPages',
          cellClass: ['grid-amount'],
          valueFormatter: function (params) {
            return $filter('number')(params.value ? params.value : 0);
          }
        },
        {
          headerName: 'No TXN Pages',
          field: 'metrics.statementPagesWithoutTxns',
          cellClass: ['grid-amount'],
          hide: true,
          valueFormatter: function (params) {
            return $filter('number')(params.value ? params.value : 0);
          },
        },
        {
          headerName: 'Check Image Pages',
          field: 'metrics.checkPages',
          cellClass: ['grid-amount'],
          hide: true,
          valueFormatter: function (params) {
            return $filter('number')(params.value ? params.value : 0);
          }
        },
        {
          headerName: 'No Check Pages',
          field: 'metrics.checkPagesWithoutChecks',
          cellClass: ['grid-amount'],
          hide: true,
          valueFormatter: function(params) {
            return $filter('number')(params.value ? params.value : 0);
          }
        },
        {
          headerName: 'Brok Stmt Pages',
          field: 'metrics.brokeragePages',
          cellClass: ['grid-amount'],
          hide: true,
          valueFormatter: function (params) {
            return $filter('number')(params.value ? params.value : 0);
          }
        },
        {
          headerName: 'Brok Stmts',
          field: 'metrics.brokerageAccountPeriods',
          cellClass: ['grid-amount'],
          hide: true,
          valueFormatter: function (params) {
            return $filter('number')(params.value ? params.value : 0);
          }
        },
        {
          headerName: 'Activity',
          field: 'metrics.processingActivity',
          cellClass: 'icons links',
          cellRenderer: function(params) {
            return params.value ? '<md-icon class="material-icons icon-primary check">check</md-icon>' : '';
          }
        }
      ];

      if(Authorization.isV8Admin()) {
        var customerCol = {
          headerName: 'Customer',
          field: 'customer.name',
          width: 300
        };
        vm.columnDefs.splice(2, 0, customerCol);
        exportParams.columnKeys.splice(2, 0, 'customer.name');
      }
      vm.filteredProjects = vm.projects;
      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowData: vm.filteredProjects,
        rowHeight: 30,
        suppressCellSelection: true,
        headerHeight: 25,
        enableCellTextSelection: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onGridReady: onGridReady,
        onColumnVisible: onColumnChange,
        onColumnResized: onColumnChange
      };
    };

    function onGridReady() {
      tableUtils.setGridState(vm.gridOptions.columnApi, GRID_ID, GRID_VERSION);
      if(!tableUtils.getGridState(GRID_ID, GRID_VERSION)) {
        vm.gridOptions.api.sizeColumnsToFit();
      }
    }

    function onColumnChange(event) {
      tableUtils.saveGridState(event.columnApi, GRID_ID, GRID_VERSION);
    }

    function _getChecksCount(metrics) {
      return metrics && metrics.checkItems ? metrics.checkItems : 0;
    }

    function _getErpCount(metrics) {
      return metrics ? metrics.glTransactions + metrics.arTransactions + metrics.apTransactions : 0;
    }

    function filter() {
      const showAll = (vm.showAudit && vm.showInvestigations) || !(vm.showAudit || vm.showInvestigations);
      const showInvestigations = showAll || vm.showInvestigations;
      const showAudit = showAll || vm.showAudit;
      var i = 0;
      vm.filteredProjects = [];
      for (i = 0; i < vm.projects.length; i++) {
        if ((vm.projects[i].type === 'audit' && showAudit) || (vm.projects[i].type === 'forensic' && showInvestigations)) {
          vm.filteredProjects.push(vm.projects[i]);
        }
      }
      vm.gridOptions.api.setRowData(vm.filteredProjects);
    }

    function exportToCsv() {
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'createdAt' || params.column.colId === 'lastUpdate') {
          return $filter('dateDisplay')(params.value);
        } else if (params.column.colId === 'type') {
          return params && params.value === PROJECT_TYPES.AUDIT ? 'Audit' : 'Investigations';
        } else if (params.column.colId === 'metrics.glTransactions') {
          return _getErpCount(params.node.data.metrics);
        } else if (params.column.colId === 'metrics.processingActivity') {
          return params.value ? "TRUE" : "FALSE";
        } else {
          return params.value ? params.value : 0;
        }
      } else {
        return params.value;
      }
    }

    function _getExportName() {
      return 'VALID8_Engagements_' + moment().format('MMYYYY') + '.csv';
    }

    function isReadOnlyAdmin() {
      return  Authorization.hasRole(RBAC.ROLES.V8_ADMIN_READONLY);
    }
  }
})();

(function() {
  'use strict';

  Projects.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('projects')
    .factory('Projects', Projects);

  function Projects(DS, DSHttpAdapter) {
    var projects = DS.defineResource({
      name: 'projects',
      endpoint: 'projects',
      idAttribute: 'id',
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    projects.updateMetrics = function(projectId) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/project/metrics',
        {},
        { params: {projectId: projectId} }
      );
    };

    projects.fixDateGaps = function(projectId) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/project/date-gap-fix',
        {},
        { params: {projectId: projectId} }
      );
    };

    return projects;
  }
})();

(function() {
  'use strict';

  angular.module('notifications', ['core']);
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('notifications')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('inbox', {
        url: 'inbox',
        parent: 'app',
        views: {
          'main-content@app': {
            templateUrl: 'app/layout/content-sidenav-left.html'
          },
          'side-nav-left@inbox': {
            templateUrl: 'app/layout/nav-list.html'
          },
          'content@inbox': {
            templateUrl: 'app/notifications/inbox.html',
            controller: 'InboxController as $ctrl'
          }
        }
      });
  }
})();

(function() {
  'use strict';

  MessageDialogController.$inject = ["$mdDialog"];
  angular
    .module('notifications')
    .controller('MessageDialogController', MessageDialogController);

  function MessageDialogController($mdDialog) {
    var vm = this;
    vm.closeMessage = $mdDialog.hide;
  }
})();

(function() {
  'use strict';

  InboxController.$inject = ["$mdDialog", "$filter"];
  angular
    .module('notifications')
    .controller('InboxController', InboxController);

  function InboxController(
    $mdDialog,
    $filter) {
    var vm = this;
    vm.viewMessage = viewMessage;
    vm.quickFilter = quickFilter;

    activate();

    function activate() {
      vm.messages = _getMessages();
      var columnDefs = [
        {
          headerName: 'Time',
          field: 'received',
          cellFormatter: function(params) {
            return $filter('date')(params.value);
          }
        },
        { headerName: 'From', field: 'author', sort: 'desc' },
        { headerName: 'Subject', field: 'subject' }
      ];

      vm.gridOptions = {
        columnDefs: columnDefs,
        rowData: vm.messages,
        rowHeight: 48,
        onRowClicked: function(params) {
          vm.viewMessage(params.data.id);
        }
      };
    }

    // TODO replace with message service
    function _getMessages() {
      return [
        {
          id: 1,
          received: '2016-06-07T19:45:23',
          author: 'System Admin',
          subject: 'Document Ingested',
          message: 'Your document has been ingested.',
          read: false
        },
        {
          id: 2,
          received: '2016-06-05T06:45:23',
          author: 'System Admin',
          subject: 'Document Ingested',
          message: 'Your document has been ingested.',
          read: false
        },
        {
          id: 3,
          received: '2016-06-04T23:45:23',
          author: 'System Admin',
          subject: 'Document Ingested',
          message: 'Your document has been ingested.',
          read: true
        },
        {
          id: 4,
          received: '2016-06-04T21:45:23',
          author: 'System Admin',
          subject: 'Document Ingested',
          message: 'Your document has been ingested.',
          read: true
        },
        {
          id: 5,
          received: '2016-05-30T18:45:23',
          author: 'System Admin',
          subject: 'Document Ingested',
          message: 'Your document has been ingested.',
          read: true
        }
      ];
    }

    function quickFilter(value) {
      vm.gridOptions.api.setQuickFilter(value);
    }

    function viewMessage(id) {
      var message = _.find(vm.messages, { id: id });
      message.read = true;
      // TODO send message in background to be set as read
      $mdDialog.show({
        templateUrl: 'app/notifications/message-dialog.html',
        controller: 'MessageDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          message: message
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('legal', [
    'core'
  ]);
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('legal')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('legal', {
        url: '',
        abstract: true,
        parent: 'app',
        views: {
          'main-content@app': {
            templateUrl: 'app/layout/content-sidenav-left.html'
          },
          'side-nav-left@legal': {
            templateUrl: 'app/layout/nav-list.html'
          }
        }
      })
      .state('legal.privacyPolicy', {
        url: 'privacy-policy',
        views: {
          'content@legal': {
            templateUrl: 'app/legal/privacy-policy.html'
          }
        }
      })
      .state('legal.termsOfService', {
        url: 'terms-of-service',
        views: {
          'content@legal': {
            templateUrl: 'app/legal/terms-of-service.html'
          }
        }
      });
  }

})();

(function() {
  'use strict';

  TopNavController.$inject = ["$window", "$state", "ENV", "RBAC", "Authorization"];
  angular
    .module('v8-frontend')
    .controller('TopNavController', TopNavController);

  function TopNavController(
    $window,
    $state,
    ENV,
    RBAC,
    Authorization) {
    var vm = this;
    vm.isLoggedIn = true;
    vm.goToSettings = goToSettings;
    vm.openHelp = openHelp;
    vm.hasAdminSettings = hasAdminSettings;
    vm.isReadOnly = isReadOnly;
    function hasAdminSettings() {
      return Authorization.isV8Admin() || Authorization.hasRole(RBAC.ROLES.CUSTOMER_ADMIN);
    }

    function isReadOnly(){
      return Authorization.isV8AdminReadOnly();
    }
    function openHelp() {
      $window.open(ENV.helpLink, '_blank');
    }

    function goToSettings() {
      if(Authorization.isV8Admin()) {
        $state.go('admin.overview');
      } else {
        var customerIds = Authorization.getResources(RBAC.ROLES.CUSTOMER_ADMIN);
        if(customerIds && customerIds.length === 1) {
          $state.go('admin.customer.engagements', { customerId: customerIds[0] });
        }
      }
    }
  }
})();

(function() {
  'use strict';

  restangularConfig.$inject = ["$log", "Restangular", "ENV"];
  angular
    .module('core')
    .run(restangularConfig);

  function restangularConfig($log, Restangular, ENV) {
    Restangular.setBaseUrl(ENV.apiDomain);
    Restangular.setErrorInterceptor(function(response) {
      $log.error('response error: ', response);
      return false;
    });
    // TODO set this on login
    Restangular.setDefaultHeaders({
      Authorization: 'Token token="166e4fa0125ec2344f5e3b8c7a1fa353"',
      Accept: 'application/json'
    });
  }
})();

(function() {
  'use strict';

  chartConfig.$inject = ["Chart"];
  angular
    .module('core')
    .config(chartConfig);

  function chartConfig(Chart) {
    Chart.defaults.global.colours = [
      '#B6B6B6', // gray
      '#AFDFFF', // light blue
      '#E1F1AB', // light gree
      '#53C06F', // green
      '#FEE401' // yellow
    ];
  }
})();

(function() {
  'use strict';

  blockUIConfig.$inject = ["blockUIConfig"];
  angular
    .module('core')
    .config(blockUIConfig);

  function blockUIConfig(blockUIConfig) {
    blockUIConfig.delay = 0;
    blockUIConfig.templateUrl = 'app/core/blocking-template.html';
    blockUIConfig.requestFilter = function(config) {
      if(config.params && config.params.nb) {
        return false;
      }
      if(config.url.endsWith('s3.amazonaws.com')) { //don't block document upload progress.
        return false;
      }
      var message;
      switch(config.method) {
      case 'GET':
        message = 'Loading';
        break;

      case 'POST':
        // We want to block if this is one of the "filter posts" which use POST to get around GET
        // query string size limitations and will have things like pagination and filtering params
        // embedded within the request
        message = (config.data.transactionIds || config.data["$sort"] || (config.data.transRangeAbs !== undefined)) ? 'Loading' : 'Saving';
        break;

      case 'DELETE':
        message = 'Removing';
        break;

      case 'PUT':
        message = 'Updating';
        break;
      }
      return message;
    };
  }
})();

(function() {
  'use strict';

  Authorization.$inject = ["DS", "RBAC", "PROJECT_TYPES"];
  angular
    .module('core')
    .factory('Authorization', Authorization);

  function Authorization(DS, RBAC, PROJECT_TYPES) {
    var userProfile;

    var authorizationModel = DS.defineResource({
      name: 'authorization',
      endpoint: 'authorization',
      idAttribute: 'id',
      cacheResponse: false,
      serialize: function(config, data) {
        return data;
      }
    });

    authorizationModel.getUserProfile = function() {
      return userProfile;
    };

    authorizationModel.setUserProfile = function(uProfile) {
      userProfile = uProfile;
    };

    authorizationModel.isValidRole = function(role) {
      return role && Object.values(RBAC.ROLES).find(function(r) {return r === role;});
    };

    authorizationModel.isV8Admin = function() {
      return this.hasRole(RBAC.ROLES.V8_ADMIN);
    };
    
    authorizationModel.isV8AdminReadOnly = function(){
      return this.hasRole(RBAC.ROLES.V8_ADMIN_READONLY);
    };

    authorizationModel.hasAccess = function(role, resourceId) {
      return this.isV8Admin() || this.getResources(role).indexOf(resourceId) >= 0;
    };

    authorizationModel.hasRole = function(role) {
      return this.isValidRole(role) && this.getUserProfile() && this.getUserProfile().accessPolicies && this.getUserProfile().accessPolicies[role];
    };

    authorizationModel.getResources = function(role) {
      var result = [];
      if(this.isValidRole(role) && role !== RBAC.ROLES.V8_ADMIN && this.getUserProfile() && this.getUserProfile().accessPolicies && this.getUserProfile().accessPolicies[role]) {
        result = this.getUserProfile().accessPolicies[role].resources;
      }
      return result;
    };

    authorizationModel.hasProjectAccess = function(type, resourceId, auditRoles, forensicRoles) {
      var result = false;
      if(type === PROJECT_TYPES.AUDIT) {
        result = this.hasAccessRoles(auditRoles, resourceId);
      } else if (type === PROJECT_TYPES.FORENSIC) {
        result = this.hasAccessRoles(forensicRoles, resourceId);
      }
      return result;
    };

    authorizationModel.hasAccessRoles = function(roles, resourceId) {
      var result = false;
      for(var i = 0; i < roles.length; i++) {
        if(this.hasAccess(roles[i], resourceId)) {
          result = true;
          break;
        }
      }
      return result;
    };

    return authorizationModel;
  }
})();

(function() {
  'use strict';

  config.$inject = ["$httpProvider"];
  angular
    .module('core')
    .config(config);

  /** @ngInject */
  function config($httpProvider) {

    /** @ngInject */
    $httpProvider.interceptors.push(["$q", "newAuthSevice", function($q, newAuthSevice) {
      return {
        request: function(config) {
          // Do not attach JWT to S3 requests.
          if(config.url.endsWith('s3.amazonaws.com')) {
            delete config.headers.Authorization;
            return config;
          }

          return newAuthSevice.getToken_promise().then(function (token) {
            config.headers.Authorization = 'Bearer ' + token;

            return config;
          });
        },
        responseError: function (response) {
          if (response.status === 401) {
            var coreFacade = bridge.store.getFacade('core');
            coreFacade.logIn_legacySupport();
          }

          return response || $q.when(response);
        }
      };
    }]);
  }
})();

(function() {
  'use strict';

  AdminsListTableController.$inject = ["$filter", "$scope", "$mdDialog", "tableUtils", "toastr"];
  angular
    .module('admin')
    .component('adminsListTable', {
      templateUrl: 'app/admin/admins-list-table.html',
      bindings:{
        admins: '<'
      },
      controller: AdminsListTableController
    });

  function AdminsListTableController(
    $filter,
    $scope,
    $mdDialog,
    tableUtils,
    toastr) {
    var vm = this;
    vm.selectedAdmins = [];
    vm.selectAll = selectAll;
    vm.exportToCsv = exportToCsv;
    vm.openAdminDialog = openAdminDialog;
    vm.adminActionsDialog = adminActionsDialog;

    var exportParams = {
      fileName: _getExportName(),
      columnKeys: ['email', 'firstName', 'lastName', 'enabled', 'lastActivity'],
      processCellCallback: exportCSVFormatCells
    };
    
    this.$onInit = function() {
      vm.columnDefs = [
        {
          headerName: 'Select',
          field: 'in-edit',
          checkboxSelection: true,
          pinned: 'left',
          width: 70,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true
        },
        {
          headerName: 'Edit',
          width: 55,
          suppressMovable: true,
          resizable: false,
          sortable: false,
          suppressSizeToFit: true,
          suppressMenu: true,
          pinned: 'left',
          cellClass: 'icons links',
          cellRenderer: function() {
            return '<md-icon class="material-icons icon-primary">edit</md-icon>';
          },
          onCellClicked: function(params) {
            openAdminDialog(params.data);
          }
        },
        {
          headerName: 'Email',
          field: 'email',
          width: 200
        },
        {
          headerName: 'First Name',
          field: 'firstName',
          width: 200
        },
        {
          headerName: 'Last Name',
          field: 'lastName',
          width: 200
        },
        {
          headerName: 'Enabled',
          field: 'enabled',
          width: 100,
          cellRenderer: function(params) {
            return params.value === true ? '<md-icon class="material-icons icon-primary check">check</md-icon>' : '<md-icon class="material-icons">close</md-icon>';
          }
        },
        {
          headerName: 'ReadOnly',
          field: 'accessPolicies',
          width: 100,
          cellRenderer: function(params) {
            return params.value.hasOwnProperty("v8_admin_readonly") ? '<md-icon class="material-icons icon-primary check">check</md-icon>' : '<md-icon class="material-icons">close</md-icon>';
          }
        },
        {
          headerName: 'Last Activity',
          field: 'lastActivity',
          width: 100,
          valueFormatter: function(params) {
            if(params.value) {
              return $filter('dateTimeFilter')(params.value);
            } else {
              return 'Never';
            }
          }
        }
      ];

      vm.gridOptions = {
        columnDefs: vm.columnDefs,
        defaultColDef: tableUtils.getDefaultColDefs(),
        rowData: vm.admins,
        headerHeight: 25,
        rowHeight: 30,
        rowSelection: 'multiple',
        onRowSelected: _toggleRowSelected,
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        enableCellTextSelection: true,
        angularCompileRows: true,
        getContextMenuItems: tableUtils.getContextMenuItems,
        onGridReady: function(params) {
          params.api.sizeColumnsToFit();
        }
      };
    };

    function openAdminDialog(admin) {
      if(!admin) {
        admin = {};
      }
      $mdDialog.show({
        templateUrl: 'app/admin/add-admin-dialog.html',
        controller: 'AddAdminController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          admin: admin,
        }
      }).then(function Success() {});
    }

    function adminActionsDialog(action) {
      $mdDialog.show({
        templateUrl: 'app/admin/admin-action-dialog.html',
        controller: 'AdminActionsDialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          admins: vm.selectedAdmins,
          action: action
        }
      });
    }

    function selectAll() {
      tableUtils.selectUnselectAll(vm.gridOptions);
    }

    function _toggleRowSelected() {
      vm.selectedAdmins = vm.gridOptions.api.getSelectedRows();
      $scope.$applyAsync();
    }

    function exportToCsv() {
      vm.gridOptions.api.exportDataAsCsv(exportParams);
      toastr.success('CSV file exported');
    }

    function exportCSVFormatCells(params) {
      if (params.column && params.column.colId) {
        if (params.column.colId === 'lastActivity') {
          return $filter('dateTimeFilter')(params.value);
        } else {
          return params.value;
        }
      } else {
        return params.value;
      }
    }

    function _getExportName() {
      return'V8_Admins_' + moment().format('MMYYYY') + '.csv';
    }
  }
})();

(function() {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('admin')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('admin.overview', {
        url: '',
        views: {
          'nav-sub-menu@admin': {
            templateUrl: 'app/admin/admin-menu.html',
            controller: 'AdminMenuController as $ctrl'
          },
          'content@admin': {
            templateUrl: 'app/admin/admin-overview.html',
            controller: 'AdminOverviewController as $ctrl'
          }
        },
        resolve: {
          customers: ["user", "Customers", "$q", function(user, Customers, $q) {
            if(user) {
              return Customers.findAll({$limit: 5000}, {bypassCache: true});
            } else {
              return $q.when([]);
            }
          }]
        }
      })
      .state('admin.v8admins', {
        url: '/v8admins',
        views: {
          'nav-sub-menu@admin': {
            templateUrl: 'app/admin/admin-menu.html',
            controller: 'AdminMenuController as $ctrl'
          },
          'content@admin': {
            templateUrl: 'app/admin/admin-users.html',
            controller: 'AdminUsersController as $ctrl'
          }
        },
        resolve: {
          admins: ["Admins", function(Admins) {
            return Admins.findAll({$limit: 5000}, {bypassCache: true});
          }]
        }
      });
  }
})();

(function() {
  'use strict';

  Admins.$inject = ["DS", "DSHttpAdapter"];
  angular
    .module('admin')
    .factory('Admins', Admins);

  function Admins(DS, DSHttpAdapter) {

    var adminsModel = DS.defineResource({
      name: 'admins',
      endpoint: 'admins',
      idAttribute: 'id',
      cacheResponse: false,
      deserialize: function(config, res) {
        return res.data.data;
      },
      serialize: function(config, data) {
        return data;
      }
    });

    adminsModel.doAdminBatchAction = function(action, adminIds) {
      return DSHttpAdapter.POST(
        DSHttpAdapter.defaults.basePath + '/admins/batch',
        { userIds: adminIds },
        { params: {action: action} }
      );
    };

    return adminsModel;
  }
})();

(function() {
  'use strict';

  AdminUsersController.$inject = ["$state", "$stateParams", "admins"];
  angular
    .module('admin')
    .controller('AdminUsersController', AdminUsersController);

  function AdminUsersController(
    $state,
    $stateParams,
    admins) {

    var vm = this;

    activate();

    function activate() {
      vm.admins = admins;
    }
  }
})();

(function() {
  'use strict';

  AdminOverviewController.$inject = ["$state", "$stateParams", "Authorization", "customers"];
  angular
    .module('admin')
    .controller('AdminOverviewController', AdminOverviewController);

  function AdminOverviewController(
    $state,
    $stateParams,
    Authorization,
    customers) {

    var vm = this;

    activate();

    function activate() {
      vm.isV8Admin = Authorization.isV8Admin();
      vm.customers = customers;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('admin')
    .controller('AdminMenuController', AdminMenuController);

  function AdminMenuController() {
    activate();

    function activate() {
    }
  }
})();

(function() {
  'use-strict';

  AdminActionsDialogController.$inject = ["$mdDialog", "$q", "$state", "$stateParams", "toastr", "Authorization", "Admins", "admins", "action"];
  angular
    .module('admin')
    .controller('AdminActionsDialogController', AdminActionsDialogController);

  function AdminActionsDialogController(
    $mdDialog,
    $q,
    $state,
    $stateParams,
    toastr,
    Authorization,
    Admins,
    admins,
    action) {
    var vm = this;
    
    vm.admins = admins;
    vm.action = action;
    vm.save = save;
    vm.cancel = $mdDialog.cancel;

    function save() {
      vm.adminIds = [];
      var user = Authorization.getUserProfile();
      if(user) {
        for(var i = 0; i < vm.admins.length; i++) {
          //logged user cannot block or remove himself...
          var a = vm.admins[i];
          if( a.id === user.id && (vm.action === 'block' || vm.action === 'delete')) {
            toastr.error('Logged admin cannot block or delete himself');
            $mdDialog.hide(true);
            return;
          } else {
            vm.adminIds.push(a.id);
          }
        }

        Admins.doAdminBatchAction(vm.action, vm.adminIds).then(function Success() {
          toastr.success('Admin tasks running');
          $mdDialog.hide(true);
          $state.reload();
        }).catch(function Failure() {
          toastr.error('An error ocurred');
          $mdDialog.hide(true);
        });
      } else { //Should never happen
        toastr.error('Unauthorized');
        $mdDialog.hide(true);
      }
    }

  }
})();

(function() {
  'use strict';

  AddAdminController.$inject = ["$q", "$stateParams", "$scope", "$state", "toastr", "$mdDialog", "Admins", "admin", "RBAC", "Authorization"];
  angular
    .module('admin')
    .controller('AddAdminController', AddAdminController);

  function AddAdminController(
    $q,
    $stateParams,
    $scope,
    $state,
    toastr,
    $mdDialog,
    Admins,
    admin,
    RBAC,
    Authorization) {
    var vm = this;
    vm.submitSaveAdmin = submitSaveAdmin;
    vm.toggleReadOnly = toggleReadOnly;
    vm.closeAddAdmin = $mdDialog.cancel;
    vm.toggleAdminAccess = false;
    vm.roleV8AdminReadOnly = RBAC.ROLES.V8_ADMIN_READONLY;
    vm.roleV8Admin = RBAC.ROLES.V8_ADMIN;
    vm.isUser = isUser;
    activate();

    function activate() {
      vm.isEdit = admin.id;
      vm.admin = admin;
      vm.Authorization = Authorization;
    }

    function submitSaveAdmin(form) {
      if(!form.$invalid) {
        if(vm.isEdit) {
          _saveAdmin();
        } else {
          _addAdmin();
        }
      }
    }

    function _success(message) {
      $mdDialog.cancel();
      toastr.success(message);
      $state.reload();
    }

    function _failure(message) {
      $mdDialog.cancel();
      toastr.error(message);
    }

    function toggleReadOnly(){
      vm.toggleAdminAccess = !vm.toggleAdminAccess;
    }

    function adminRoleAccess(){
      return  vm.toggleAdminAccess ? vm.roleV8AdminReadOnly : vm.roleV8Admin;
    }

    function isUser(){
      return Authorization.getUserProfile().id === vm.admin.id;
    }

    function _addAdmin() {
      if(vm.admin) {
        vm.admin.role = adminRoleAccess();
        Admins.create(vm.admin)
          .then(function Success() {
            _success(vm.admin.email + ' has been successfully created.');
          })
          .catch(function Failure() {
            _failure('There was an error creating the admin');
          });
      }
    }

    function _saveAdmin() {
      if(vm.admin) {
        vm.admin.role = adminRoleAccess();
        Admins.update(vm.admin.id, vm.admin)
          .then(function Success() {
            _success(vm.admin.email + ' has been successfully updated.');
          })
          .catch(function Failure() {
            _failure('There was an error updating the admin');
          });
      }
    }

  }
})();


(function () {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular
    .module('v8-frontend')
    .config(routerConfig);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('app', {
        url: '/',
        views: {
          '@': {
            templateUrl: 'app/layout/template-w-full-header.html'
          },
          'full-width-header@': {
            templateUrl: 'app/layout/top-nav.html',
            controller: 'TopNavController as $ctrl'
          },
          'nav-sub-menu':{
            template: ''
          }
        },
        resolve: {
          user: function() {
            var coreFacade = bridge.store.getFacade('core');

            return coreFacade.loggedUser$_legacySupport_promise();
          }
        }
      })
      .state('admin', {
        url: '/admin',
        abstract: true,
        views: {
          '@': {
            templateUrl: 'app/layout/template-w-full-header.html'
          },
          'full-width-header@': {
            templateUrl: 'app/layout/top-nav.html',
            controller: 'TopNavController as $ctrl'
          },
          'main-content@admin': {
            templateUrl: 'app/layout/content-sidenav-left.html'
          },
          'nav-sub-menu':{
            template: ''
          }

        },
        resolve: {
          user: function() {
            var coreFacade = bridge.store.getFacade('core');

            return coreFacade.loggedUser$_legacySupport_promise();
          }
        }
      })
      .state('auth', {
        abstract: true,
        views: {
          '@': {
            templateUrl: 'app/layout/template-w-full-header.html'
          },
          'full-width-header@': {
            templateUrl: 'app/layout/top-nav.html'
          }
        }
      })
      .state('auth.logout', {
        url: '/logout',
        onEnter: function () {
          var coreFacade = bridge.store.getFacade('core');
          coreFacade.logOut_legacySupport();
        }
      })
      // TODO: extract to settings module
      .state('settings', {
        url: 'settings',
        parent: 'app'
      })
      // TODO: extract to help module
      .state('help', {
        url: 'help',
        parent: 'app'
      })
      .state('sink', {
        url: '/*path',
        views: {
          '@': {
            template: '<!-- Legacy Route Empty -->'
          },
          'full-width-header@': {
            templateUrl: 'app/layout/top-nav.html',
            controller: 'TopNavController as $ctrl'
          },
          'nav-sub-menu':{
            template: ''
          }

        }
      });
  }

})();

(function() {
  'use strict';

  config.$inject = ["ENV", "$logProvider", "toastrConfig", "DSHttpAdapterProvider", "angularAuth0Provider", "$provide"];
  angular
    .module('v8-frontend')
    .config(config);

  /** @ngInject */
  function config(ENV, $logProvider, toastrConfig, DSHttpAdapterProvider, angularAuth0Provider, $provide) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
    var apiDomain = ENV.apiDomain;
    if(ENV.apiVersion) {
      apiDomain += '/' + ENV.apiVersion;
    }

    angular.extend(DSHttpAdapterProvider.defaults, {
      basePath: apiDomain,
      log: false
    });

    $provide.decorator('$timeout', ['$delegate', TimeoutDecorator]);
    $provide.decorator('DS', ['$delegate', jsDataDecorator]);
  }

  /**
   * This decorator is to patch the setTimeout internal to the $timeout service. It instructs AngularJS
   * to run these tasks outside the Angular Zone. This decorator should catch $http timeouts, and 
   * timeouts from angular-auth0, angular-block-ui, and angular-chart.js as well as source code that is
   * using $timeout. API here: https://docs.angularjs.org/api/ng/service/$timeout
   */
  function TimeoutDecorator($delegate) {
    let _timeout = $delegate;

    $delegate = function timeout(fn, delay, invokeApply) {
      return bridge.zone.runOutsideAngular(() => _timeout(fn, delay, invokeApply));
    };

    $delegate.cancel = _timeout.cancel;

    return $delegate;
  }

  /**
   * This decorator is to patch an issue with `js-data-angular` and Angular dirty detection.
   * The methods in `functionsToWrap` are patched by `js-data-angular` to ensure they are tied
   * into the AngularJS digest cycle. These are the methods with the setInterval and setTimeout
   * expressions that have been preventing bootstrapping from finishing until the Dirty Detection
   * cycle has completed. By running these methods outside of the Angular Zone, Angular won't be
   * blocked by the macrotasks they create.
   */
  function jsDataDecorator($delegate) {
    let functionsToWrap = [
      'compute',
      'digest',
      'eject',
      'inject',
      'defineResource'
    ];
    let originals = {};

    functionsToWrap.forEach((name) => {
      originals[name] = $delegate[name];
      $delegate[name] = (...args) => {
        return bridge.zone.runOutsideAngular(() => originals[name].apply($delegate, args));
      };
    });

    return $delegate;
  }
})();

angular.module('v8-frontend').run(['$templateCache', function($templateCache) {$templateCache.put('app/admin/add-admin-dialog.html','<md-dialog class=dialog-lg aria-label="v8 admin"><dialog-header ng-if=!$ctrl.isEdit dialog-title="Create V8 Admin"></dialog-header><dialog-header ng-if=$ctrl.isEdit dialog-title="Edit V8 Admin"></dialog-header><form class=customer-form flex=flex layout=column name=addAdminForm novalidate><md-dialog-content flex=flex layout=column layout-padding=layout-padding><div class=customer-info flex=flex layout=column><div class=row layout=layout flex=flex><div class=form-group ng-class="{ \'has-error\': addAdminForm.email.$invalid &amp;&amp; addAdminForm.$submitted }"><label>Email:</label> <input class=form-control type=text name=email ng-model=$ctrl.admin.email required></div><div class=form-group><label>First Name:</label> <input class=form-control type=text name=firstName ng-model=$ctrl.admin.firstName></div><div class=form-group><label>Last Name:</label> <input class=form-control type=text name=lastName ng-model=$ctrl.admin.lastName></div></div><div class=row ng-if="$ctrl.Authorization.isV8Admin() &amp;&amp; !$ctrl.isUser()"><div class=form-group layout=layout flex=flex><label>Read Only Access:</label><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label=ReadOnly ng-checked="$ctrl.admin.accessPolicies.hasOwnProperty(\'v8_admin_readonly\')" ng-model=toggleAdminAccess ng-change=$ctrl.toggleReadOnly()></md-checkbox></div></div></div></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.closeAddAdmin()>Cancel</button> <button class="btn btn-primary" analytics-on=click ng-click=$ctrl.submitSaveAdmin(addAdminForm) analytics-event="Save admin" type=submit>Save</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/admin/admin-action-dialog.html','<md-dialog class=dialog-lg aria-label="admin actions"><dialog-header dialog-title="Perform Admin action"></dialog-header><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class=section><label class=control-label>{{ $ctrl.admins.length }} Admins will be affected. Please confirm.</label></div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" ng-click=$ctrl.save() type=submit>Confirm</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/admin/admin-menu.html','<ul class="side-nav-list md-body-1"><li ui-sref-active=active ui-sref=admin.overview>Overview</li><li ui-sref-active=active ui-sref=admin.v8admins>V8 Admins</li></ul>');
$templateCache.put('app/admin/admin-overview.html','<md-content><div class=padding><div><div class=section-md layout=layout layout-align="space-between center"><div class=page-title><h1 class=flush>Customers</h1></div></div></div><customers-list-table customers=$ctrl.customers></customers-list-table></div></md-content><div layout=layout layout-align="center center" ng-if=!$ctrl.isV8Admin><div class="callout empty-section" layout=column layout-align="center center"><div class="section text-larger"><strong>Unauthorized</strong></div></div></div>');
$templateCache.put('app/admin/admin-users.html','<md-content><div class=padding><div><div class=section-md layout=layout layout-align="space-between center"><div class=page-title><h1 class=flush>V8 Admins Management</h1></div></div></div><admins-list-table admins=$ctrl.admins></admins-list-table></div></md-content>');
$templateCache.put('app/admin/admins-list-table.html','<div class="settings section" layout=layout><div class=room-right flex=flex layout=layout layout-align="start center"><table-filter grid-options=$ctrl.gridOptions></table-filter><button class="btn btn-inverted" type=button ng-click=$ctrl.openAdminDialog()><md-tooltip>Create new admin</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>add</md-icon></button> <button class="btn btn-inverted" type=button ng-click=$ctrl.selectAll()><md-tooltip>Select all</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>select_all</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.adminActionsDialog(\'email\')" ng-disabled=!$ctrl.selectedAdmins.length><md-tooltip>Send email</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>email</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.adminActionsDialog(\'enable\')" ng-disabled=!$ctrl.selectedAdmins.length><md-tooltip>Enable admin</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>check</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.adminActionsDialog(\'block\')" ng-disabled=!$ctrl.selectedAdmins.length><md-tooltip>Block admin</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>block</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.adminActionsDialog(\'delete\')" ng-disabled=!$ctrl.selectedAdmins.length><md-tooltip>Delete admin</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>delete</md-icon></button></div><div flex=flex layout=layout layout-align="end center"><button class="btn btn-inverted" type=button ng-click=$ctrl.exportToCsv()><md-tooltip>Export to CSV</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon></button></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/core/blocking-template.html','<div class=block-ui-overlay></div><div class=block-ui-message-container aria-live=assertive aria-atomic=true><div class=block-ui-message ng-class=$_blockUiMessageClass><md-progress-circular md-diameter=40></md-progress-circular><span>{{ state.message }}</span></div></div>');
$templateCache.put('app/layout/content-sidenav-left.html','<div layout=layout ui-view=side-nav-left></div><div flex=flex layout=column ui-view=content></div>');
$templateCache.put('app/layout/nav-list.html','<side-nav collapse=true layout=layout><ul class="side-nav-list md-body-1"><li ui-sref=projects.list>Projects</li></ul><md-divider class=side-nav-flush></md-divider><div ui-view=nav-sub-menu></div></side-nav>');
$templateCache.put('app/layout/template-w-full-header.html','<div flex=flex layout=row ui-view=main-content></div>');
$templateCache.put('app/layout/top-nav.html','<md-toolbar class=md-custom-background layout=row layout-align="space-between center"><div layout=row><a class="links padding" ui-sref=projects.list><img src=assets/images/valid8-logo-white.png alt="Valid8 Logo" height=48px></a><div class=top-menu ui-view=nav-sub-menu></div></div><div class=center-readonly ng-if=$ctrl.isReadOnly()>Read Only Mode</div><div class=right-bar><ul class="side-nav-list md-body-1" ng-if=$ctrl.isLoggedIn><li ng-if=$ctrl.hasAdminSettings() ui-sref-active="{active: \'admin.*.*.*\'}" ng-click=$ctrl.goToSettings()>Admin</li><li ng-click=$ctrl.openHelp()>Help</li><li ui-sref=auth.logout>Logout</li></ul></div></md-toolbar>');
$templateCache.put('app/legal/privacy-policy.html','<md-content><div layout=column layout-padding=layout-padding><h2 class="text-center flush">Privacy Policy</h2><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>1.</div><div flex=flex>General</div></div><div class=section-small layout=layout><div class=tab-indent>1.1</div><div flex=flex>Valid8 Financial, Inc. ("us", "we", or "our") operates the http://valid8.cash website and the Valid8 mobile application (the "Service").</div></div><div class=section-small layout=layout><div class=tab-indent>1.2</div><div flex=flex>This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.</div></div><div class=section-small layout=layout><div class=tab-indent>1.3</div><div flex=flex>We will not use or share your information with anyone except as described in this Privacy Policy.</div></div><div class=section-small layout=layout><div class=tab-indent>1.4</div><div flex=flex>We use your Personal Information for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>2.</div><div flex=flex>Information Collection And Use</div></div><div class=section-small layout=layout><div class=tab-indent>2.1</div><div flex=flex>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your email address ("Personal Information").</div></div><div class=section-small layout=layout><div class=tab-indent>2.2</div><div flex=flex>We collect this information for the purpose of providing the Service, identifying and communicating with you, responding to your requests/inquiries, servicing your purchase orders, and improving our services.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>3.</div><div flex=flex>Log Data</div></div><div class=section-small layout=layout><div class=tab-indent>3.1</div><div flex=flex>We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device ("Log Data").</div></div><div class=section-small layout=layout><div class=tab-indent>3.2</div><div flex=flex>This Log Data may include information such as your computer\'s Internet Protocol ("IP") address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics.</div></div><div class=section-small layout=layout><div class=tab-indent>3.3</div><div flex=flex>When you access the Service by or through a mobile device, this Log Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use and other statistics.</div></div><div class=section-small layout=layout><div class=tab-indent>3.4</div><div flex=flex>In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this type of information in order to increase our Service\'s functionality. These third party service providers have their own privacy policies addressing how they use such information.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>4.</div><div flex=flex>Cookies</div></div><div class=section-small layout=layout><div class=tab-indent>4.1</div><div flex=flex>Cookies are files with a small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and transferred to your device. We use cookies to collect information in order to improve our services for you.</div></div><div class=section-small layout=layout><div class=tab-indent>4.2</div><div flex=flex>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. The Help feature on most browsers provide information on how to accept cookies, disable cookies or to notify you when receiving a new cookie.</div></div><div class=section-small layout=layout><div class=tab-indent>4.3</div><div flex=flex>If you do not accept cookies, you may not be able to use some features of our Service and we recommend that you leave them turned on.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>5.</div><div flex=flex>Do Not Track Disclosure</div></div><div class=section-small layout=layout><div class=tab-indent>5.1</div><div flex=flex>We support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.</div></div><div class=section-small layout=layout><div class=tab-indent>5.2</div><div flex=flex>You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>6.</div><div flex=flex>Service Providers</div></div><div class=section-small layout=layout><div class=tab-indent>6.1</div><div flex=flex>We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services and/or to assist us in analyzing how our Service is used.</div></div><div class=section-small layout=layout><div class=tab-indent>6.2</div><div flex=flex>These third parties have access to your Personal Information only to perform specific tasks on our behalf and are obligated not to disclose or use your information for any other purpose.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>7.</div><div flex=flex>Service Provider \u201CPlaid\u201D</div></div><div class=section-small layout=layout><div class=tab-indent>7.1</div><div flex=flex>Client uses Plaid Technologies, Inc. (\u201CPlaid\u201D) to gather End User\u2019s data from financial institutions. By using our service, you grant Client and Plaid the right, power, and authority to act on your behalf to access and transmit your personal and financial information from the relevant financial institution. You agree to your personal and financial information being transferred, stored, and processed by Plaid in accordance with the Plaid Privacy Policy.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>8.</div><div flex=flex>Communications</div></div><div class=section-small layout=layout><div class=tab-indent>8.1</div><div flex=flex>We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>9.</div><div flex=flex>Compliance With Laws</div></div><div class=section-small layout=layout><div class=tab-indent>9.1</div><div flex=flex>We will disclose your Personal Information where required to do so by law or subpoena or if we believe that such action is necessary to comply with the law and the reasonable requests of law enforcement or to protect the security or integrity of our Service.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>10.</div><div flex=flex>Business Transaction</div></div><div class=section-small layout=layout><div class=tab-indent>10.1</div><div flex=flex>If Valid8 Financial, Inc. is involved in a merger, acquisition or asset sale, your Personal Information may be transferred as a business asset. In such cases, we will provide notice before your Personal Information is transferred and/or becomes subject to a different Privacy Policy.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>11.</div><div flex=flex>Security</div></div><div class=section-small layout=layout><div class=tab-indent>11.1</div><div flex=flex>The security of your Personal Information is important to us, and we strive to implement and maintain reasonable, commercially acceptable security procedures and practices appropriate to the nature of the information we store, in order to protect it from unauthorized access, destruction, use, modification, or disclosure.</div></div><div class=section-small layout=layout><div class=tab-indent>11.2</div><div flex=flex>However, please be aware that no method of transmission over the internet, or method of electronic storage is 100% secure and we are unable to guarantee the absolute security of the Personal Information we have collected from you.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>12.</div><div flex=flex>Links To Other Sites</div></div><div class=section-small layout=layout><div class=tab-indent>12.1</div><div flex=flex>Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party\'s site. We strongly advise you to review the Privacy Policy of every site you visit.</div></div><div class=section-small layout=layout><div class=tab-indent>12.2</div><div flex=flex>We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>13.</div><div flex=flex>Children\'s Privacy</div></div><div class=section-small layout=layout><div class=tab-indent>13.1</div><div flex=flex>Only persons age 18 or older have permission to access our Service. Our Service does not address anyone under the age of 13 ("Children").</div></div><div class=section-small layout=layout><div class=tab-indent>13.1</div><div flex=flex>We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and you learn that your Children have provided us with Personal Information, please contact us. If we become aware that we have collected Personal Information from a children under age 13 without verification of parental consent, we take steps to remove that information from our servers.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>14.</div><div flex=flex>Changes To This Privacy Policy</div></div><div class=section-small layout=layout><div class=tab-indent>14.1</div><div flex=flex>This Privacy Policy is effective as of June 02, 2017 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.</div></div><div class=section-small layout=layout><div class=tab-indent>14.2</div><div flex=flex>We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.</div></div><div class=section-small layout=layout><div class=tab-indent>14.3</div><div flex=flex>If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.</div></div></div><div class=section><div class="section-small text-bold text-upper" layout=layout><div class=tab-indent>15.</div><div flex=flex>Contact Us</div></div><div class=section-small layout=layout><div class=tab-indent>15.1</div><div flex=flex>If you have any questions about this Privacy Policy, please contact us by calling [425-448-2585] or any time by emailing [support@valid8.cash].</div></div></div></div></md-content>');
$templateCache.put('app/legal/terms-of-service.html','<md-content><div layout=column layout-padding=layout-padding><h2 class="text-center flush">Terms Of Service</h2><div class=section><div class="section-small text-bold" layout=layout><div class=tab-indent>1.</div><div flex=flex>SAAS SERVICES AND SUPPORT</div></div><div class=section-small layout=layout><div class=tab-indent>1.1</div><div flex=flex>Subject to the terms of this Agreement, Company will use commercially reasonable efforts to provide Customer the Services in accordance with the Service Level Terms attached hereto as Exhibit B. As part of the registration process, Customer will identify an administrative user name and password for Customer\u2019s Company account. Company reserves the right to refuse registration of, or cancel passwords it deems inappropriate.</div></div><div class=section-small layout=layout><div class=tab-indent>1.2</div><div flex=flex>Subject to the terms hereof, Company will provide Customer with reasonable technical support services in accordance with the terms set forth in Exhibit C.</div></div></div><div class=section><div class="section-small text-bold" layout=layout><div class=tab-indent>2.</div><div flex=flex>RESTRICTIONS AND RESPONSIBILITIES</div></div><div class=section-small layout=layout><div class=tab-indent>2.1</div><div flex=flex>Customer will not, directly or indirectly: reverse engineer, decompile, disassemble or otherwise attempt to discover the source code, object code or underlying structure, ideas, know-how or algorithms relevant to the Services or any software, documentation or data related to the Services (\u201CSoftware\u201D); modify, translate, or create derivative works based on the Services or any Software (except to the extent expressly permitted by Company or authorized within the Services); use the Services or any Software for timesharing or service bureau purposes or otherwise for the benefit of a third; or remove any proprietary notices or labels.</div></div><div class=section-small layout=layout><div class=tab-indent>2.2</div><div flex=flex>Further, Customer may not remove or export from the United States or allow the export or re-export of the Services, Software or anything related thereto, or any direct product thereof in violation of any restrictions, laws or regulations of the United States Department of Commerce, the United States Department of Treasury Office of Foreign Assets Control, or any other United States or foreign agency or authority. As defined in FAR section 2.101, the Software and documentation are \u201Ccommercial items\u201D and according to DFAR section 252.227\x1E7014(a)(1) and (5) are deemed to be \u201Ccommercial computer software\u201D and \u201Ccommercial computer software documentation.\u201D Consistent with DFAR section 227.7202 and FAR section 12.212, any use modification, reproduction, release, performance, display, or disclosure of such commercial software or commercial software documentation by the U.S. Government will be governed solely by the terms of this Agreement and will be prohibited except to the extent expressly permitted by the terms of this Agreement.</div></div><div class=section-small layout=layout><div class=tab-indent>2.3</div><div flex=flex>Customer represents, covenants, and warrants that Customer will use the Services only in compliance with Company\u2019s standard published policies then in effect (the \u201CPolicy\u201D) and all applicable laws and regulations. [Customer hereby agrees to indemnify and hold harmless Company against any damages, losses, liabilities, settlements and expenses (including without limitation costs and attorneys\u2019 fees) in connection with any claim or action that arises from an alleged violation of the foregoing or otherwise from Customer\u2019s use of Services. Although Company has no obligation to monitor Customer\u2019s use of the Services, Company may do so and may prohibit any use of the Services it believes may be (or alleged to be) in violation of the foregoing.</div></div><div class=section-small layout=layout><div class=tab-indent>2.4</div><div flex=flex>Customer shall be responsible for obtaining and maintaining any equipment and ancillary services needed to connect to, access or otherwise use the Services, including, without limitation, modems, hardware, servers, software, operating systems, networking, web servers and the like (collectively, \u201CEquipment\u201D). Customer shall also be responsible for maintaining the security of the Equipment, Customer account, passwords (including but not limited to administrative and user passwords) and files, and for all uses of Customer account or the Equipment with or without Customer\u2019s knowledge or consent.</div></div></div><div class=section><div class="section-small text-bold" layout=layout><div class=tab-indent>3.</div><div flex=flex>CONFIDENTIALITY; PROPRIETARY RIGHTS</div></div><div class=section-small layout=layout><div class=tab-indent>3.1</div><div flex=flex>Each party (the \u201CReceiving Party\u201D) understands that the other party (the \u201CDisclosing Party\u201D) has disclosed or may disclose business, technical or financial information relating to the Disclosing Party\u2019s business (hereinafter referred to as \u201CProprietary Information\u201D of the Disclosing Party). Proprietary Information of Company includes non-public information regarding features, functionality and performance of the Service. Proprietary Information of Customer includes non-public data provided by Customer to Company to enable the provision of the Services (\u201CCustomer Data\u201D). The Receiving Party agrees: (i)\xA0to take reasonable precautions to protect such Proprietary Information, and (ii)\xA0not to use (except in performance of the Services or as otherwise permitted herein) or divulge to any third person any such Proprietary Information. The Disclosing Party agrees that the foregoing shall not apply with respect to any information after five (5) years following the disclosure thereof or any information that the Receiving Party can document (a)\xA0is or becomes generally available to the public, or (b)\xA0was in its possession or known by it prior to receipt from the Disclosing Party, or (c)\xA0was rightfully disclosed to it without restriction by a third party, or (d)\xA0was independently developed without use of any Proprietary Information of the Disclosing Party or (e)\xA0is required to be disclosed by law.</div></div><div class=section-small layout=layout><div class=tab-indent>3.2</div><div flex=flex>Customer shall own all right, title and interest in and to the Customer Data[, as well as any data that is based on or derived from the Customer Data and provided to Customer as part of the Services. Company shall own and retain all right, title and interest in and to (a) the Services and Software, all improvements, enhancements or modifications thereto, (b) any software, applications, inventions or other technology developed in connection with Implementation Services or support, (c) all intellectual property rights related to any of the foregoing, and (d) any derivative data including anonymized data where all personally identifiable information is removed and destroyed.</div></div><div class=section-small layout=layout><div class=tab-indent>3.3</div><div flex=flex>Notwithstanding anything to the contrary, Company shall have the right collect and analyze data and other information relating to the provision, use and performance of various aspects of the Services and related systems and technologies (including, without limitation, information concerning Customer Data and data derived therefrom), and Company will be free (during and after the term hereof) to (i) use such information and data to improve and enhance the Services and for other development, diagnostic and corrective purposes in connection with the Services and other Company offerings, and (ii) disclose such data solely in aggregate or other de-identified form in connection with its business. No rights or licenses are granted except as expressly set forth herein.</div></div></div><div class=section><div class="section-small text-bold" layout=layout><div class=tab-indent>4.</div><div flex=flex>PAYMENT OF FEES</div></div><div class=section-small layout=layout><div class=tab-indent>4.1</div><div flex=flex>Customer will pay Company the then applicable fees described in the Order Form for the Services and Implementation Services in accordance with the terms therein (the \u201CFees\u201D). If Customer\u2019s use of the Services exceeds the Service Capacity set forth on the Order Form or otherwise requires the payment of additional fees (per the terms of this Agreement), Customer shall be billed for such usage and Customer agrees to pay the additional fees in the manner provided herein. Company reserves the right to change the Fees or applicable charges and to institute new charges and Fees at the end of the Initial Service Term or then\x1Ecurrent renewal term, upon thirty\xA0(30) days prior notice to Customer (which may be sent by email). If Customer believes that Company has billed Customer incorrectly, Customer must contact Company no later than 60\xA0days after the closing date on the first billing statement in which the error or problem appeared, in order to receive an adjustment or credit. Inquiries should be directed to Company\u2019s customer support department.</div></div><div class=section-small layout=layout><div class=tab-indent>4.2</div><div flex=flex>Company may choose to bill through an invoice, in which case, full payment for invoices issued in any given month must be received by Company thirty\xA0(30) days after the mailing date of the invoice. Unpaid amounts are subject to a finance charge of 1.5% per month on any outstanding balance, or the maximum permitted by law, whichever is lower, plus all expenses of collection and may result in immediate termination of Service. Customer shall be responsible for all taxes associated with Services other than U.S. taxes based on Company\u2019s net income.</div></div></div><div class=section><div class="section-small text-bold" layout=layout><div class=tab-indent>5.</div><div flex=flex>TERM AND TERMINATION</div></div><div class=section-small layout=layout><div class=tab-indent>5.1</div><div flex=flex>Subject to earlier termination as provided below, this Agreement is for the Initial Service Term as specified in the Order Form, and shall be automatically renewed for additional periods of the same duration as the Initial Service Term (collectively, the \u201CTerm\u201D), unless either party requests termination at least thirty (30) days prior to the end of the then-current term.</div></div><div class=section-small layout=layout><div class=tab-indent>5.2</div><div flex=flex>In addition to any other remedies it may have, either party may also terminate this Agreement upon thirty (30) days\u2019 notice (or without notice in the case of nonpayment), if the other party materially breaches any of the terms or conditions of this Agreement. Customer will pay in full for the Services up to and including the last day on which the Services are provided. Upon any termination, Company will make all Customer Data available to Customer for electronic retrieval for a period of thirty (30) days, but thereafter Company may, but is not obligated to, delete stored Customer Data. All sections of this Agreement which by their nature should survive termination will survive termination, including, without limitation, accrued rights to payment, confidentiality obligations, warranty disclaimers, and limitations of liability.</div></div></div><div class=section><div class="section-small text-bold" layout=layout><div class=tab-indent>6.</div><div flex=flex>WARRANTY AND DISCLAIMER</div></div><div class=section-small layout=layout><div class=tab-indent></div><div flex=flex>Company shall use reasonable efforts consistent with prevailing industry standards to maintain the Services in a manner which minimizes errors and interruptions in the Services and shall perform the Implementation Services in a professional and workmanlike manner. Services may be temporarily unavailable for scheduled maintenance or for unscheduled emergency maintenance, either by Company or by third-party providers, or because of other causes beyond Company\u2019s reasonable control, but Company shall use reasonable efforts to provide advance notice in writing or by e-mail of any scheduled service disruption. However, Company does not warrant that the Services will be uninterrupted or error free; nor does it make any warranty as to the results that may be obtained from use of the Services. EXCEPT AS EXPRESSLY SET FORTH IN THIS SECTION, THE SERVICES AND IMPLEMENTATION SERVICES ARE PROVIDED \u201CAS IS\u201D AND COMPANY DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.</div></div></div><div class=section><div class="section-small text-bold" layout=layout><div class=tab-indent>7.</div><div flex=flex>INDEMNITY</div></div><div class=section-small layout=layout><div class=tab-indent></div><div flex=flex>Company shall hold Customer harmless from liability to third parties resulting from infringement by the Service of any United States patent or any copyright or misappropriation of any trade secret, provided Company is promptly notified of any and all threats, claims and proceedings related thereto and given reasonable assistance and the opportunity to assume sole control over defense and settlement; Company will not be responsible for any settlement it does not approve in writing. The foregoing obligations do not apply with respect to portions or components of the Service (i) not supplied by Company, (ii) made in whole or in part in accordance with Customer specifications, (iii) that are modified after delivery by Company, (iv) combined with other products, processes or materials where the alleged infringement relates to such combination, (v) where Customer continues allegedly infringing activity after being notified thereof or after being informed of modifications that would have avoided the alleged infringement, or (vi) where Customer\u2019s use of the Service is not strictly in accordance with this Agreement. If, due to a claim of infringement, the Services are held by a court of competent jurisdiction to be or are believed by Company to be infringing, Company may, at its option and expense (a) replace or modify the Service to be non-infringing provided that such modification or replacement contains substantially similar features and functionality, (b) obtain for Customer a license to continue using the Service, or (c) if neither of the foregoing is commercially practicable, terminate this Agreement and Customer\u2019s rights hereunder and provide Customer a refund of any prepaid, unused fees for the Service.</div></div></div><div class=section><div class="section-small text-bold" layout=layout><div class=tab-indent>8.</div><div flex=flex>LIMITATION OF LIABILITY</div></div><div class=section-small layout=layout><div class=tab-indent></div><div flex=flex>NOTWITHSTANDING ANYTHING TO THE CONTRARY, EXCEPT FOR BODILY INJURY OF A PERSON, COMPANY AND ITS SUPPLIERS (INCLUDING BUT NOT LIMITED TO ALL EQUIPMENT AND TECHNOLOGY SUPPLIERS), OFFICERS, AFFILIATES, REPRESENTATIVES, CONTRACTORS AND EMPLOYEES SHALL NOT BE RESPONSIBLE OR LIABLE WITH RESPECT TO ANY SUBJECT MATTER OF THIS AGREEMENT OR TERMS AND CONDITIONS RELATED THERETO UNDER ANY CONTRACT, NEGLIGENCE, STRICT LIABILITY OR OTHER THEORY: (A)\xA0FOR ERROR OR INTERRUPTION OF USE OR FOR LOSS OR INACCURACY OR CORRUPTION OF DATA OR COST OF PROCUREMENT OF SUBSTITUTE GOODS, SERVICES OR TECHNOLOGY OR LOSS OF BUSINESS; (B)\xA0FOR ANY INDIRECT, EXEMPLARY, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES; (C)\xA0FOR ANY MATTER BEYOND COMPANY\u2019S REASONABLE CONTROL; OR (D) FOR ANY AMOUNTS THAT, TOGETHER WITH AMOUNTS ASSOCIATED WITH ALL OTHER CLAIMS, EXCEED THE FEES PAID BY CUSTOMER TO COMPANY FOR THE SERVICES UNDER THIS AGREEMENT IN THE 12 MONTHS PRIOR TO THE ACT THAT GAVE RISE TO THE LIABILITY, IN EACH CASE, WHETHER OR NOT COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.</div></div></div><div class=section><div class="section-small text-bold" layout=layout><div class=tab-indent>9.</div><div flex=flex>MISCELLANEOUS</div></div><div class=section-small layout=layout><div class=tab-indent></div><div flex=flex>If any provision of this Agreement is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that this Agreement will otherwise remain in full force and effect and enforceable. This Agreement is not assignable, transferable or sublicensable by Customer except with Company\u2019s prior written consent. Company may transfer and assign any of its rights and obligations under this Agreement without consent. This Agreement is the complete and exclusive statement of the mutual understanding of the parties and supersedes and cancels all previous written and oral agreements, communications and other understandings relating to the subject matter of this Agreement, and that all waivers and modifications must be in a writing signed by both parties, except as otherwise provided herein. No agency, partnership, joint venture, or employment is created as a result of this Agreement and Customer does not have any authority of any kind to bind Company in any respect whatsoever. In any action or proceeding to enforce rights under this Agreement, the prevailing party will be entitled to recover costs and attorneys\u2019 fees. All notices under this Agreement will be in writing and will be deemed to have been duly given when received, if personally delivered; when receipt is electronically confirmed, if transmitted by facsimile or e-mail; the day after it is sent, if sent for next day delivery by recognized overnight delivery service; and upon receipt, if sent by certified or registered mail, return receipt requested. This Agreement shall be governed by the laws of the State of Washington without regard to its conflict of laws provisions. The parties shall work together in good faith to issue at least one mutually agreed upon press release within 90 days of the Effective Date, and Customer otherwise agrees to reasonably cooperate with Company to serve as a reference account upon request.</div></div></div><h2 class="text-center flush">Service Level Terms</h2><div class=section><div class=section-small>The Services shall be available 99.9%, measured monthly, excluding holidays and weekends and scheduled maintenance. If Customer requests maintenance during these hours, any uptime or downtime calculation will exclude periods affected by such maintenance. Further, any downtime resulting from outages of third party connections or utilities or other reasons beyond Company\u2019s control will also be excluded from any such calculation. Customer\'s sole and exclusive remedy, and Company\'s entire liability, in connection with Service availability shall be that for each period of downtime lasting longer than one hour, Company will credit Customer 5% of Service fees for each period of 30 or more consecutive minutes of downtime; provided that no more than one such credit will accrue per day. Downtime shall begin to accrue as soon as Customer (with notice to Company) recognizes that downtime is taking place, and continues until the availability of the Services is restored. In order to receive downtime credit, Customer must notify Company in writing within 24 hours from the time of downtime, and failure to provide such notice will forfeit the right to receive downtime credit. Such credits may not be redeemed for cash and shall not be cumulative beyond a total of credits for one\xA0(1) week of Service Fees in any one\xA0(1) calendar month in any event. Company will only apply a credit to the month in which the incident occurred. Company\u2019s blocking of data communications or other Service in accordance with its policies shall not be deemed to be a failure of Company to provide adequate service levels under this Agreement.</div></div><h2 class="text-center flush">Support Terms</h2><div class=section><div class=section-small>Company will provide Technical Support to Customer via both telephone and electronic mail on weekdays during the hours of 9:00 am through 5:00 pm Pacific time, with the exclusion of Federal Holidays (\u201CSupport Hours\u201D).</div><div class=section-small>Customer may initiate a helpdesk ticket during Support Hours by calling [425-448-2585] or any time by emailing [support@valid8.cash].</div><div class=section-small>Company will use commercially reasonable efforts to respond to all Helpdesk tickets within one (1) business day.</div></div></div></md-content>');
$templateCache.put('app/notifications/inbox.html','<md-content><div layout-padding=layout-padding><h1 class=flush-top>Inbox</h1><div class=section-small layout=layout layout-align=end><div flex=50><input class="form-control room-right" type=text placeholder=Filter ng-model=$ctrl.searchText ng-change=$ctrl.quickFilter($ctrl.searchText)></div></div><div class="table-height-half ag-theme-material" ag-grid=$ctrl.gridOptions></div></div></md-content>');
$templateCache.put('app/notifications/message-dialog.html','<md-dialog class=dialog-lg flex=flex aria-label=message><dialog-header dialog-title="{{ $ctrl.message.received | dateTimeFilter }}"></dialog-header><div flex=flex layout=column layout-padding=layout-padding><div layout=layout><span class=text-larger flex=flex>{{ $ctrl.message.author }}</span><span class=text-larger>{{ $ctrl.message.received | dateTimeFilter }}</span></div><div class=text-larger>{{ $ctrl.message.subject }}</div><md-divider></md-divider><md-content flex=flex>{{ $ctrl.message.message }}</md-content><md-dialog-actions><button class="btn btn-primary" ng-click=$ctrl.closeMessage()>Back To Inbox</button></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/projects/projects-list-table.html','<div class="settings section" layout=row><div style="flex:0 0 125px" layout=layout layout-align="start center"><span><input type=checkbox aria-label=Investigations name=investigations ng-model=$ctrl.showInvestigations ng-change=$ctrl.filter()></span><span class=space-right style="margin-right: 20px">Investigations</span><span> <input type=checkbox aria-label=Audit name=audit ng-model=$ctrl.showAudit ng-change=$ctrl.filter()></span><span class=room-right>Audit</span></div><div flex=50 layout=layout layout-align="start center"><table-filter grid-options=$ctrl.gridOptions></table-filter></div><div flex=flex layout-align="end center"><button class="btn btn-inverted" type=button ng-click=$ctrl.exportToCsv()><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon><span>Export to CSV</span></button></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/projects-list.html','<md-content><div class=padding><div ng-if="$ctrl.projects.length &gt; 0"><div class=section-md layout=layout layout-align="space-between center"><div class=page-title><h1 class=flush>Engagements</h1></div></div><projects-list-table projects=$ctrl.projects></projects-list-table></div></div></md-content><div class=padding ng-if="$ctrl.projects.length === 0" layout=column><div class=section><h1 class=flush>Welcome to VALID8</h1></div><div class=callout layout=column layout-align="center center"><div class="section text-larger">You need to have access to an Engagement to proceed.</div></div></div>');
$templateCache.put('app/admin/customers/add-customer-dialog.html','<md-dialog class=dialog-xxl aria-label=customer><dialog-header dialog-title="Create a customer"></dialog-header><form class=customer-form flex=flex layout=column name=addCustomerForm novalidate><md-dialog-content flex=flex layout=column layout-padding=layout-padding><div class=row layout=layout flex=flex><div class=form-group ng-class="{ \'has-error\': addCustomerForm.name.$invalid &amp;&amp; addCustomerForm.$submitted }"><label>Customer Name:</label> <input class=form-control type=text name=name ng-model=$ctrl.customer.name required></div><div class=form-group><label>Type:</label><md-select class=type-select ng-model=$ctrl.customer.type ng-change=$ctrl.setSubtypes()><md-option value=audit>Audit</md-option><md-option value=forensic>Investigations</md-option></md-select></div><div class=form-group><label>Subtype:</label><md-select class=subtype-select ng-model=$ctrl.customer.subtype><md-option ng-repeat="subtype in $ctrl.subtypes" ng-value=subtype>{{ subtype | customerSubtypeDisplay }}</md-option></md-select></div><div class=form-group ng-class="{ \'has-error\': addCustomerForm.enterpriseConnection.$invalid &amp;&amp; addCustomerForm.$submitted }"><label>SSO Connection:</label> <input class=form-control type=text name=enterpriseConnection ng-model=$ctrl.customer.enterpriseConnection></div></div></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.closeAddCustomer()>Cancel</button> <button class="btn btn-primary" analytics-on=click ng-click=$ctrl.submitSaveCustomer(addCustomerForm) analytics-event="Save customer" type=submit>Save</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/admin/customers/add-customer-user-dialog.html','<md-dialog class=dialog-m aria-label="customer user"><dialog-header ng-if=!$ctrl.isEdit dialog-title="Create customer user"></dialog-header><dialog-header ng-if=$ctrl.isEdit dialog-title="Edit customer user"></dialog-header><form class=customer-form flex=flex layout=column name=addCustomerUserForm novalidate><md-dialog-content flex=flex layout=column layout-padding=layout-padding><div class=customer-info flex=flex layout=column><div class=row layout=layout flex=flex><div class=form-group><label>Role:</label><md-select class=role-select ng-model=$ctrl.role aria-label="select role" disabled><md-option value=customer_user>Customer User</md-option><md-option value=customer_admin>Customer Admin</md-option></md-select></div><div class=form-group ng-class="{ \'has-error\': addCustomerUserForm.email.$invalid &amp;&amp; addCustomerUserForm.$submitted }"><label>Email:</label> <input class=form-control type=text name=email ng-model=$ctrl.user.email required></div></div><div class=row layout=layout flex=flex><div class=form-group><label>First Name:</label> <input class=form-control type=text name=firstName ng-model=$ctrl.user.firstName></div><div class=form-group><label>Last Name:</label> <input class=form-control type=text name=lastName ng-model=$ctrl.user.lastName></div></div></div></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.closeAddCustomerUser()>Cancel</button> <button class="btn btn-primary" analytics-on=click ng-click=$ctrl.submitSaveCustomerUser(addCustomerUserForm) analytics-event="Save customer user" type=submit>Save</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/admin/customers/customer-contact.html','<div class=customer-contact flex=flex layout=column><div flex=flex layout=row><h3 class=flush>{{ $ctrl.type | customerContactTypeDisplay }}</h3><div class=form-group ng-if="$ctrl.type !== \'contracts\'"><label>Same as above:</label><md-checkbox class="md-custom-background cell-checkbox" aria-label="same as above" ng-model=$ctrl.copyAbove ng-change=$ctrl.toggleCopy()></md-checkbox></div></div><div class=config-section flex=flex layout=row><div class=form-group><label>First Name:</label> <input class="form-control input-m" type=text name=firstName ng-disabled=$ctrl.copyAbove ng-model=$ctrl.contact.firstName></div><div class=form-group><label>Last Name:</label> <input class="form-control input-m" type=text name=lastName ng-disabled=$ctrl.copyAbove ng-model=$ctrl.contact.lastName></div><div class=form-group><label>Title:</label> <input class="form-control input-m" type=text name=title ng-disabled=$ctrl.copyAbove ng-model=$ctrl.contact.title></div><div class=form-group><label>Email:</label> <input class=form-control type=text name=email ng-disabled=$ctrl.copyAbove ng-model=$ctrl.contact.email></div><div class=form-group><label>Mobile Phone:</label> <input class="form-control input-m" type=text name=phone ng-disabled=$ctrl.copyAbove ng-model=$ctrl.contact.phone></div></div><div class=config-section flex=flex layout=row><div class=form-group><label>Country:</label><md-select class=profile-select-s aria-label=country ng-model=$ctrl.contact.location.country ng-disabled=$ctrl.copyAbove><md-option ng-repeat="code in $ctrl.countries" ng-value=code>{{ code }}</md-option></md-select></div><div class=form-group><label>State:</label> <input class="form-control input-m" type=text name=state ng-disabled=$ctrl.copyAbove ng-model=$ctrl.contact.location.state></div><div class=form-group><label>City:</label> <input class="form-control input-m" type=text name=city ng-disabled=$ctrl.copyAbove ng-model=$ctrl.contact.location.city></div><div class=form-group><label>Zip:</label> <input class="form-control input-m" type=text name=zip ng-disabled=$ctrl.copyAbove ng-model=$ctrl.contact.location.zip></div><div class=form-group><label>Address:</label> <input class=form-control type=text name=address ng-disabled=$ctrl.copyAbove ng-model=$ctrl.contact.location.address></div></div></div>');
$templateCache.put('app/admin/customers/customer-engagements-list-table.html','<div class="settings section" layout=layout><div flex=50 layout=layout layout-align="start center"><table-filter grid-options=$ctrl.gridOptions></table-filter></div><div flex=flex layout-align=start><button class="btn btn-inverted" type=button ng-click=$ctrl.openEngagementDialog()><md-icon class=icon-primary md-menu-origin=md-menu-origin>add</md-icon><span>New Engagement</span></button> <button class="btn btn-inverted" type=button ng-click=$ctrl.exportToCsv()><md-tooltip>Export to CSV</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon></button></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/admin/customers/customer-engagements.html','<md-content><div class=padding><div><div class=section-md layout=layout layout-align="space-between center"><div class=page-title><h1 class=flush>Engagement Management</h1></div></div></div><customer-engagements-list-table projects=$ctrl.projects customer=$ctrl.customer></customer-engagements-list-table></div></md-content>');
$templateCache.put('app/admin/customers/customer-menu.html','<ul class="side-nav-list md-body-1"><li class="active overview" ui-sref=admin.customer.engagements><span class=legend>Customer</span><span class="project-name truncate">{{ $ctrl.customer.name}}</span></li><li ui-sref-active=active ui-sref=admin.customer.profile>Admin</li><li ui-sref-active=active ui-sref=admin.customer.engagements>Engagements</li><li ui-sref-active=active ui-sref=admin.customer.users>Users</li></ul>');
$templateCache.put('app/admin/customers/customer-profile.html','<md-content><div class=padding><div><div class=section-md flex=flex layout=column><div class=page-title><h1 class=flush>Customer Profile Management</h1></div><form class=customer-profile-form flex=flex layout=column name=editCustomerForm novalidate><div layout=column flex=flex><div class=profile-section layout=column flex=flex><h3 class=flush>Basic settings</h3><div class=config-section flex=flex layout=row><div class=form-group ng-if=$ctrl.isV8Admin ng-class="{ \'has-error\': editCustomerForm.name.$invalid &amp;&amp; editCustomerForm.$submitted }"><label>Name:</label> <input class=form-control type=text name=name ng-model=$ctrl.customerCopy.name required></div><div class=form-group ng-if=$ctrl.isV8Admin><label>Type:</label><md-select class=profile-select aria-label="customer type" ng-model=$ctrl.customerCopy.type disabled><md-option value=audit>Audit</md-option><md-option value=forensic>Investigations</md-option></md-select></div><div class=form-group ng-if=$ctrl.isV8Admin><label>Subtype:</label><md-select class=subtype-select aria-label="customer subtype" ng-model=$ctrl.customerCopy.subtype><md-option ng-repeat="subtype in $ctrl.subtypes" ng-value=subtype>{{ subtype | customerSubtypeDisplay }}</md-option></md-select></div></div><div class=config-section flex=flex layout=row><div class=form-group><label>Default Engagement Role:</label><md-select class=profile-select aria-label="default role" ng-model=$ctrl.customerCopy.defaultProjectRole><md-option value=none>None</md-option><md-option value=engagement_user>Engagement User</md-option><md-option value=engagement_owner>Engagement Owner</md-option></md-select></div><div class=form-group ng-if=$ctrl.isV8Admin><label>Active:</label><md-checkbox class="md-custom-background cell-checkbox" aria-label=active ng-model=$ctrl.customerCopy.enabled></md-checkbox></div><div class=form-group ng-if=$ctrl.isV8Admin><label>Reference:</label><md-checkbox class="md-custom-background cell-checkbox" aria-label=reference ng-model=$ctrl.customerCopy.reference></md-checkbox></div><button class="btn btn-primary" ng-if=$ctrl.isV8Admin ng-click=$ctrl.uploadLogo()>Upload Logo</button></div></div><div class=profile-section layout=column flex=flex><div flex=flex layout=row layout-align="space-between end"><h3 class=flush>Key Contact Information</h3></div><div class=config-section flex=flex layout=column><customer-contact contact-info=$ctrl.customerCopy.keyContactInfo type=contracts></customer-contact><customer-contact contact-info=$ctrl.customerCopy.keyContactInfo type=billing></customer-contact><customer-contact contact-info=$ctrl.customerCopy.keyContactInfo type=operations></customer-contact></div></div><div class=profile-section ng-if=$ctrl.isV8Admin layout=column flex=flex><h3 class=flush>Contract Information</h3><div class=config-section flex=flex layout=row><div class=form-group><label>Pilot Project:</label><md-checkbox class="md-custom-background cell-checkbox" aria-label=pilot ng-model=$ctrl.customerCopy.contractInfo.isPilot></md-checkbox></div><div class=form-group><label>Contract Type:</label><md-select class=profile-select aria-label="contract type" ng-model=$ctrl.customerCopy.contractInfo.type ng-disabled=$ctrl.customerCopy.contractInfo.isPilot><md-option ng-repeat="type in $ctrl.contractTypes" ng-value=type>{{ type | customerContractTypeDisplay }}</md-option></md-select></div><div class=form-group><label>Annual Txn Limit:</label> <input class="text-sm form-control" type=number name=annualTxnLimit ng-change=$ctrl.validateTxnLimit() ng-model=$ctrl.customerCopy.contractInfo.annualTxnLimit></div><div class=form-group><label>Contract Start Date:</label> <input class="date form-control" type=date name=contractStartDate ng-disabled=$ctrl.customerCopy.contractInfo.isPilot ng-model=$ctrl.customerCopy.contractInfo.startDate></div><div class=form-group><label>Contract Renewal Date:</label> <input class="date form-control" type=date name=contractEndDate ng-disabled=$ctrl.customerCopy.contractInfo.isPilot ng-model=$ctrl.customerCopy.contractInfo.endDate></div></div><div class=config-section flex=flex layout=row><div class=form-group><label>Contract Details:</label> <textarea class=form-control name=contractDetails ng-disabled=$ctrl.customerCopy.contractInfo.isPilot ng-model=$ctrl.customerCopy.contractInfo.details></textarea></div></div></div><div class=profile-section ng-if="$ctrl.isV8Admin &amp;&amp; $ctrl.isAudit" layout=column flex=flex><h3 class=flush>Customer Environment Information</h3><div class=config-section flex=flex layout=row><div class=form-group><label>API Key:</label> <input class="text-lg form-control" type=text name=name ng-model=$ctrl.customerCopy.integrationData.apiKey></div><div class=form-group><label>Tenant URL:</label> <input class="text-lg form-control" type=text name=name ng-model=$ctrl.customerCopy.integrationData.environmentUrl></div></div></div><div class=profile-actions layout=layout layout-align="end end" flex=flex><button class="btn btn-primary" analytics-on=click ng-if=$ctrl.isV8Admin ng-click=$ctrl.syncCustomer() ng-show=$ctrl.isAudit ng-disabled="!$ctrl.customerCopy.integrationData.apiKey || !$ctrl.customerCopy.integrationData.environmentUrl" analytics-event="customer validis sync">Sync</button> <button class="btn btn-primary" analytics-on=click analytics-event="Save Customer Profile" ng-click=$ctrl.saveCustomerProfile() type=submit>Save</button></div></div></form></div></div></div></md-content>');
$templateCache.put('app/admin/customers/customer-user-action-dialog.html','<md-dialog class=dialog-m aria-label="user actions"><dialog-header dialog-title="Mass user operation"></dialog-header><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class="section padding" ng-if=$ctrl.chooseRole flex=flex layout=row><div flex=flex><label class="control-label select-label">Choose the new role:</label></div><div flex=flex><md-select class=role-select ng-model=$ctrl.role aria-label="select role"><md-option value=customer_user>Customer User</md-option><md-option value=customer_admin>Customer Admin</md-option></md-select></div></div><div class="section padding"><label class=control-label>{{ $ctrl.users.length }} Users will be affected. Please confirm.</label></div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" ng-click=$ctrl.save() type=submit>Confirm</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/admin/customers/customer-users-list-table.html','<div class="settings section" layout=layout><div class=room-right flex=flex layout=layout layout-align="start center"><table-filter grid-options=$ctrl.gridOptions></table-filter><button class="btn btn-inverted" type=button ng-click=$ctrl.openCustomerUserDialog()><md-tooltip>Create new user</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>add</md-icon></button> <button class="btn btn-inverted" type=button ng-click=$ctrl.selectAll()><md-tooltip>Select all</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>select_all</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.customerUserActionDialog(\'assign\')" ng-disabled=!$ctrl.selectedUsers.length><md-tooltip>Customer Role</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>assignment</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.customerUserActionDialog(\'email\')" ng-disabled=!$ctrl.selectedUsers.length><md-tooltip>Send email</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>email</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.customerUserActionDialog(\'enable\')" ng-disabled=!$ctrl.selectedUsers.length><md-tooltip>Enable user</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>check</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.customerUserActionDialog(\'block\')" ng-disabled=!$ctrl.selectedUsers.length><md-tooltip>Block user</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>block</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.customerUserActionDialog(\'delete\')" ng-disabled=!$ctrl.selectedUsers.length><md-tooltip>Delete users</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>delete</md-icon></button></div><div flex=flex layout=layout layout-align="end center"><button class="btn btn-inverted" type=button ng-click=$ctrl.exportToCsv()><md-tooltip>Export to CSV</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon></button></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/admin/customers/customer-users.html','<md-content><div class=padding><div><div class=section-md layout=layout layout-align="space-between center"><div class=page-title><h1 class=flush>Customer User Management</h1></div></div></div><customer-users-list-table users=$ctrl.users customer=$ctrl.customer></customer-users-list-table></div></md-content>');
$templateCache.put('app/admin/customers/customers-list-table.html','<div class="settings section" layout=layout><div flex=50 layout=layout layout-align="start center"><table-filter grid-options=$ctrl.gridOptions></table-filter></div><div flex=flex layout-align=start><button class="btn btn-inverted" type=button ng-click=$ctrl.openCustomerDialog()><md-icon class=icon-primary md-menu-origin=md-menu-origin>add</md-icon><span>New Customer</span></button> <button class="btn btn-inverted" type=button ng-click=$ctrl.exportToCsv()><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon><span>Export to CSV</span></button></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/admin/customers/upload-customer-logo.html','<md-dialog class=dialog-lg aria-label=upload><dialog-header dialog-title="Upload Customer Logo" hide-default-close=true></dialog-header><md-dialog-content flex=flex><md-content><div class=padding layout=layout flex=flex><div layout=layout flex=flex><div class=form-group layout=column flex=75><h4>{{ $ctrl.info }}</h4></div><div class=form-group layout=column layout-align=end flex=25><button class="btn btn-primary" accept=$ctrl.acceptPattern ng-hide=$ctrl.isUploading() ngf-select="$ctrl.uploadFiles($files, $invalidFiles)" ngf-max-files=1 ngf-pattern=$ctrl.ngUploadPattern ngf-max-size=$ctrl.maxSize>Select File</button></div></div></div><div class=padding layout=layout flex=flex><ul class=progress-bar><li class="progress-row bar-l" ng-repeat="f in $ctrl.files"><div class=progress flex=flex layout=layout ng-show="f.progress &gt;= 0" style=width:{{f.progress}}%><div class=truncate flex=75><span>{{ f.name }}</span></div><div flex=25><span>{{ f.progress + \'%\'}}</span></div></div></li></ul></div><div class=padding layout=layout flex=flex><ul ng-show="$ctrl.errorFiles.length &gt; 0"><li ng-repeat="f in $ctrl.errorFiles">{{ $ctrl.getFileErrorMessage(f) }}</li></ul></div></md-content></md-dialog-content><md-dialog-actions layout=layout><div><button class="btn btn-inverted" type=button ng-disabled=$ctrl.isUploading() ng-click=$ctrl.cancelUpload()>Cancel</button> <button class="btn btn-primary" type=button ng-disabled=!$ctrl.canSaveLogo() ng-click=$ctrl.setLogo()>Update Logo</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/projects/engagement/engagement-menu.html','<ul class="side-nav-list md-body-1"><li class="active overview" ui-sref=engagement.overview><span class=legend>Dashboard</span><span class="project-name truncate">{{ $ctrl.project.name }}</span></li><li ui-sref-active="{active: \'engagement.accountsEdit.*\'}" ui-sref=engagement.accountsEdit ng-disabled=$ctrl.loading>Accounts</li><li class=menu ng-class="{active: (\'engagement.statements\' | includedByState) || (\'engagement.account-periods\' | includedByState)}"><md-menu md-offset="0 68"><md-button class=btn-menu ng-click=$mdMenu.open();>Load</md-button><md-menu-content width=3 ng-mouseleave=$mdMenu.close();><md-menu-item><md-button ng-click="$ctrl.goToLoad(\'bank_pdf\')">{{ $ctrl.sourceDesc[\'bank_pdf\'] }}</md-button></md-menu-item><md-menu-item><md-button ng-click="$ctrl.goToLoad(\'brokerage_loan_pdf\')">{{ $ctrl.sourceDesc[\'brokerage_loan_pdf\'] }}</md-button></md-menu-item><md-menu-item><md-button ng-click="$ctrl.goToLoad(\'txn_csv\')">{{ $ctrl.sourceDesc[\'txn_csv\'] }}</md-button></md-menu-item></md-menu-content></md-menu></li><li ui-sref-active="{active: \'engagement.transactions.*\'}" ui-sref=engagement.transactions ng-disabled=$ctrl.loading>Transactions</li><li ui-sref-active="{active: \'engagement.reconcile.*\'}" ui-sref=engagement.reconcile ng-disabled=$ctrl.loading ng-if=$ctrl.isV8Admin>Reconcile</li><li ui-sref-active=active ui-sref=engagement.files>Files</li><li ui-sref-active=active ui-sref=engagement.trace ng-if=$ctrl.isV8Admin>Trace</li></ul>');
$templateCache.put('app/projects/engagement/engagement-overview.html','<md-content class=overview><div class=section></div><div class=padding><div><div class=section-md layout=row layout-align="start center"><div class=page-title><h2 class=flush><md-icon class=expand-icon md-menu-origin=md-menu-origin ng-if=$ctrl.expanded.erp ng-click="$ctrl.expandCollapse(\'erp\')">remove</md-icon><md-icon class=expand-icon md-menu-origin=md-menu-origin ng-if=!$ctrl.expanded.erp ng-click="$ctrl.expandCollapse(\'erp\')">add</md-icon><span>ERP</span></h2></div><div class=buttons ng-show=$ctrl.expanded.erp><button class="btn btn-inverted" type=button ng-disabled="$ctrl.extractLoading || $ctrl.isMatching" ng-click=$ctrl.syncValidisExtracts()><span>Sync</span></button></div></div><div class=section ng-if="$ctrl.extracts.length &gt; 0" ng-show=$ctrl.expanded.erp><erp-extracts-list-table project=$ctrl.project extracts=$ctrl.extracts importing=$ctrl.extractLoading matching=$ctrl.isMatching></erp-extracts-list-table></div></div><div ng-if=!$ctrl.extractLoading><div class=bank layout=row layout-align="space-between center" ng-if="$ctrl.extracts.length &gt; 0"><div class=page-title><h2 class=flush><md-icon class=expand-icon md-menu-origin=md-menu-origin ng-if=$ctrl.expanded.bank ng-click="$ctrl.expandCollapse(\'bank\')">remove</md-icon><md-icon class=expand-icon md-menu-origin=md-menu-origin ng-if=!$ctrl.expanded.bank ng-click="$ctrl.expandCollapse(\'bank\')">add</md-icon><span>Bank</span></h2></div></div><div ng-if="$ctrl.accounts.length &amp;&amp; $ctrl.extracts.length &gt; 0" ng-show=$ctrl.expanded.bank><div class=bank-chart layout=row layout-align="end center"><div class=engagement-bank-chart-legend><bar-chart-legend chart-data=$ctrl.chart></bar-chart-legend></div><div class=engagement-bank-chart><stacked-bar-chart stacked-bar-data=$ctrl.chart audit=true></stacked-bar-chart></div></div><accounts-list-table accounts=$ctrl.accounts type=audit></accounts-list-table></div></div><div ng-if=!$ctrl.extractLoading><div class="section-md workpapers" layout=layout layout-align="start center" ng-if="$ctrl.extracts.length &gt; 0"><div class=page-title><h2 class=flush><md-icon class=expand-icon md-menu-origin=md-menu-origin ng-if=$ctrl.expanded.match ng-click="$ctrl.expandCollapse(\'match\')">remove</md-icon><md-icon class=expand-icon md-menu-origin=md-menu-origin ng-if=!$ctrl.expanded.match ng-click="$ctrl.expandCollapse(\'match\')">add</md-icon><span>Workpapers</span></h2></div><div class=buttons ng-show=$ctrl.expanded.match><button class="btn btn-inverted" type=button ng-disabled="!$ctrl.hasBankData || $ctrl.isMatching || $ctrl.extractError" ng-click=$ctrl.createReconciliationDialog()><span>Match</span></button></div></div><reconciliations-list-table ng-if="$ctrl.extracts.length &gt; 0" reconciliations=$ctrl.reconciliations ng-show=$ctrl.expanded.match></reconciliations-list-table><div class=section-md layout=layout layout-align="start center" ng-if="$ctrl.extracts.length &gt; 0" ng-show=$ctrl.expanded.match><div layout=layout layout-align="start center"><div class=page-title><h3 class=wp-title>Generate Workpapers</h3></div><div class="buttons wp-generate-buttons"><button class="btn btn-inverted wp-button" type=button ng-disabled="!$ctrl.hasBankData || $ctrl.isMatching" ng-click=$ctrl.createWorkpaperDialog($ctrl.newWorkpaperType)><span>New</span></button></div></div></div><workpaper-list-table ng-if="$ctrl.extracts.length &gt; 0" ng-show=$ctrl.expanded.match workpapers=$ctrl.workpapers></workpaper-list-table><div layout=layout layout-align="center center" ng-if="$ctrl.extracts.length &lt;= 0"><div class="callout empty-section" layout=column layout-align="center center"><div class="section text-larger"><strong>Engagement Created!&nbsp;</strong></div><span>Please start by retrieving and importing an ERP extract.</span><span>Then, upload client bank statements to generate a workpaper.</span></div></div></div></div></md-content>');
$templateCache.put('app/projects/project/accounts-list-table.html','<div class=settings layout=layout><div flex=50 layout=layout layout-align="start center"><div class=padding><h2 class=flush>Accounts</h2></div><table-filter grid-options=$ctrl.gridOptions></table-filter></div><div flex=flex layout-align=start><button class="btn btn-primary" type=button ng-disabled="$ctrl.refreshingStatus || $ctrl.fixingDateGaps" ng-click=$ctrl.updateMetrics()><span>Refresh Status</span></button> <button class="btn btn-primary" type=button ng-if=$ctrl.canFixDateGaps ng-disabled="$ctrl.refreshingStatus || $ctrl.fixingDateGaps" ng-click=$ctrl.fixDateGaps()><span>Fix Date Gaps</span></button><md-menu md-offset="0 45"><button class=action-button ng-click=$mdMenu.open();><md-tooltip>Export File</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon></button><md-menu-content class=check-item-menu-overrides width=3 ng-mouseleave=$mdMenu.close();><md-menu-item><md-button class=cat-option ng-click=$ctrl.exportToCsv()>Export to CSV</md-button></md-menu-item><md-menu-item ng-if="$ctrl.type === \'forensic\'"><md-button class=cat-option ng-click=$ctrl.excelDateGapExport()>Date Gaps to Excel</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=ag-theme-material ag-grid=$ctrl.gridOptions ng-if="$ctrl.type === \'forensic\'"></div><div class=ag-theme-material ag-grid=$ctrl.gridOptions style="height: {{$ctrl.tableHeight}}px;" ng-if="$ctrl.type === \'audit\'"></div>');
$templateCache.put('app/projects/project/project-menu.html','<ul class="side-nav-list md-body-1"><li class="active overview" ui-sref=project.overview><span class=legend>Project</span><span class="project-name truncate">{{ $ctrl.project.name }}</span></li><li ui-sref-active="{active: \'project.accounts.*.*\'}" ui-sref=project.accounts.accountsEdit>Accounts</li><li class=menu ng-class="{active: (\'project.documents.statements\' | includedByState) || (\'project.account-periods\' | includedByState) ||                 (\'project.check-items\' | includedByState) || (\'project.check-item-transactions\' | includedByState) }"><md-menu md-offset="0 68"><md-button class=btn-menu ng-click=$mdMenu.open();>Load</md-button><md-menu-content width=3 ng-mouseleave=$mdMenu.close();><md-menu-item><md-button ng-click="$ctrl.goToLoad(\'bank_pdf\')">{{ $ctrl.sourceDesc[\'bank_pdf\'] }}</md-button></md-menu-item><md-menu-item><md-button ng-click="$ctrl.goToLoad(\'brokerage_loan_pdf\')">{{ $ctrl.sourceDesc[\'brokerage_loan_pdf\'] }}</md-button></md-menu-item><md-menu-item><md-button ng-click="$ctrl.goToLoad(\'txn_csv\')">{{ $ctrl.sourceDesc[\'txn_csv\'] }}</md-button></md-menu-item><md-menu-item ng-if=$ctrl.checksEnabled><md-button ng-click="$ctrl.goToLoad(\'checks_pdf\')">{{ $ctrl.sourceDesc[\'checks_pdf\'] }}</md-button></md-menu-item></md-menu-content></md-menu></li><li ui-sref-active=active ui-sref=project.categories>Transactions</li><li ui-sref-active=active ui-sref=project.matching ng-if=$ctrl.hasPermissions>Transfers</li><li ui-sref-active=active ui-sref=project.flows>Cash Flow</li><li ui-sref-active=active ui-sref=project.files>Files</li></ul>');
$templateCache.put('app/projects/project/project-overview.html','<md-content class=overview><div class=section></div><messages></messages><div class=padding ng-if=$ctrl.chart.data layout=column layout-gt-sm=row ng-cloak=ng-cloak><div class=overview-chart><stacked-bar-chart stacked-bar-data=$ctrl.chart></stacked-bar-chart><bar-chart-legend chart-data=$ctrl.chart></bar-chart-legend></div></div><div class="section padding" layout=layout layout-align="center center" ng-if=!$ctrl.accounts.length><div class="callout empty-section" layout=column layout-align="center center"><div class="section text-larger"><strong>Project Created!&nbsp;</strong><span>Please add accounts to proceed.</span></div><div class=buttons><button class="btn btn-inverted" type=button ui-sref=project.accounts.accountsEdit><md-icon class=icon-primary md-menu-origin=md-menu-origin>add</md-icon>Edit Accounts</button></div></div></div><md-divider ng-if="$ctrl.accounts.length &amp;&amp; $ctrl.isDonutChart"></md-divider><div class=padding ng-if=$ctrl.accounts.length><accounts-list-table accounts=$ctrl.accounts type=forensic></accounts-list-table></div></md-content>');
$templateCache.put('app/admin/customers/engagements/add-engagement-dialog.html','<md-dialog class=dialog-m aria-label=engagement><dialog-header ng-if=!$ctrl.isEdit dialog-title="Create Engagement"></dialog-header><dialog-header ng-if=$ctrl.isEdit dialog-title="Edit Engagement"></dialog-header><form class=customer-form flex=flex layout=column name=addEngagementForm novalidate><md-dialog-content flex=flex layout=column layout-padding=layout-padding><div class=row layout=layout flex=flex><div class=form-group ng-class="{ \'has-error\': addEngagementForm.name.$invalid &amp;&amp; addEngagementForm.$submitted }"><label>Engagement Name:</label> <input class=form-control type=text name=name ng-model=$ctrl.project.name required></div><div class=form-group><label>Description:</label> <input class=form-control type=text name=description ng-model=$ctrl.project.description></div></div><div class=row layout=layout flex=flex ng-if="$ctrl.project.type === \'audit\'"><div class=form-group><label>Sample-based verification:</label><md-checkbox class="md-custom-background cell-checkbox" aria-label="sample based" ng-model=$ctrl.project.options.sampleBasedVerification></md-checkbox></div><div class=form-group><label>GL Period Filter:</label><md-checkbox class="md-custom-background cell-checkbox" aria-label="GL Period" ng-model=$ctrl.project.options.enforceAuditGlPeriod></md-checkbox></div></div><div class=row layout=layout flex=flex ng-if="$ctrl.project.type === \'audit\'"><div class=form-group><label>Subs AR Verification:</label><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label="Subs AR Verification" ng-model=$ctrl.project.options.subsARVerification></md-checkbox></div></div><div class=row layout=layout flex=flex><div class=form-group><label>Enforce Withdrawal First:</label><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label="Withdrawal First" ng-model=$ctrl.project.options.enforceWithdrawalFirst></md-checkbox></div></div><div class=row layout=layout flex=flex ng-if="$ctrl.project.type === \'forensic\'"><div class=form-group><label>Normalize Payor:<md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label="Normalize Payor" ng-model=$ctrl.project.options.normalizePayor></md-checkbox></label></div></div><div class=row layout=layout flex=flex ng-if="$ctrl.project.type === \'forensic\'"><div class=form-group><label>Normalize Payee:<md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label="Normalize Payee" ng-model=$ctrl.project.options.normalizePayee></md-checkbox></label></div></div><div class=row layout=layout flex=flex><div class=form-group><label>Default to Match-Best:</label><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label="Int Transfer Match Best" ng-model=$ctrl.project.options.internalTransferMatchBest></md-checkbox></div></div><div class=row layout=layout flex=flex ng-if="$ctrl.project.type ===\'audit\'"><div class=form-group><label>Type:</label><md-select class=type-select ng-model=$ctrl.project.options.traceType><md-option value=cashjournaltrace>Cash Journal Trace</md-option><md-option value=revenuetrace>Revenue Trace</md-option></md-select></div></div></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.closeAddEngagement()>Cancel</button> <button class="btn btn-primary" analytics-on=click ng-click=$ctrl.submitSaveEngagement(addEngagementForm) analytics-event="Save engagement" type=submit>Save</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/admin/customers/engagements/add-engagement-user-dialog.html','<md-dialog class=dialog-lg aria-label="add users"><dialog-header dialog-title="Add users to engagement"></dialog-header><md-dialog-content layout-padding=layout-padding><md-content><div class=section flex=flex layout=row><div flex=50><label class="control-label select-label">Available users for this customer</label></div><div flex=10><label class="control-label select-label">Role:</label></div><div flex=40><md-select class=role-select ng-model=$ctrl.role aria-label="select role"><md-option value=engagement_user>Engagement User</md-option><md-option value=engagement_owner>Engagement Owner</md-option></md-select></div></div><div class="settings section" layout=layout><div flex=50 layout=layout layout-align="start center"><table-filter grid-options=$ctrl.gridOptions></table-filter><button class="btn btn-inverted" type=button ng-click=$ctrl.selectAll()><md-tooltip>Select all</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>select_all</md-icon></button></div></div><div class="table-height-half ag-theme-material" ag-grid=$ctrl.gridOptions></div></md-content><md-dialog-actions style="min-height: 70px;" layout=layout><div layout=column layout-align="center end"><div><button class="btn btn-inverted" type=button ng-click=$ctrl.close()>Close</button> <button class="btn btn-primary" ng-disabled="$ctrl.selectedUsers.length === 0" analytics-on=click ng-click=$ctrl.assignUsers() analytics-event="add user" type=submit>Add</button></div></div></md-dialog-actions></md-dialog-content></md-dialog>');
$templateCache.put('app/admin/customers/engagements/engagement-user-action-dialog.html','<md-dialog class=dialog-m aria-label="user actions"><dialog-header dialog-title="Engagement users update"></dialog-header><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class="section padding" ng-if=$ctrl.chooseRole flex=flex layout=row><div flex=flex><label class="control-label select-label">Choose the new role:</label></div><div flex=flex><md-select class=role-select ng-model=$ctrl.role aria-label="select role"><md-option value=engagement_user>Engagement User</md-option><md-option value=engagement_owner>Engagement Owner</md-option></md-select></div></div><div class="section padding"><label class=control-label>{{ $ctrl.users.length }} Users will be affected. Please confirm.</label></div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" ng-click=$ctrl.save() type=submit>Confirm</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/admin/customers/engagements/engagement-users-list-table.html','<div class="settings section" layout=layout><div class=room-right flex=flex layout=layout layout-align="start center"><table-filter grid-options=$ctrl.gridOptions></table-filter><button class="btn btn-inverted" type=button ng-click=$ctrl.selectAll()><md-tooltip>Select all</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>select_all</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.engagementUserActionDialog(\'assign\')" ng-disabled=!$ctrl.selectedUsers.length><md-tooltip>Change Role</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>assignment</md-icon></button> <button class="btn btn-inverted" type=button ng-click="$ctrl.engagementUserActionDialog(\'unassign\')" ng-disabled=!$ctrl.selectedUsers.length><md-tooltip>Remove from engagement</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>block</md-icon></button> <button class="btn btn-inverted" type=button ng-click=$ctrl.openAddEngagementUserDialog()><md-tooltip>Add user</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>add</md-icon></button></div><div flex=flex layout=layout layout-align="end center"><button class="btn btn-inverted" type=button ng-click=$ctrl.exportToCsv()><md-tooltip>Export to CSV</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon></button></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/admin/customers/engagements/engagement-users.html','<md-content><div class=padding><div><div class=section-md layout=layout layout-align="space-between center"><div class=page-title><h1 class=flush>{{ $ctrl.project.name }} Users</h1></div></div></div><engagement-users-list-table users=$ctrl.users></engagement-users-list-table></div></md-content>');
$templateCache.put('app/core/components/bar-chart-legend/bar-chart-legend.html','<chart-legend><ul class=bar-legend><li ng-repeat="legend in $ctrl.chart.legends"><span class=stacked-bar-legend-icon ng-class="[legend.name, { \'bar-with-status\': \'{{legend.name}}\' }]"></span><span class=stacked-bar-legend-text>{{ legend.label }}</span></li></ul></chart-legend>');
$templateCache.put('app/core/components/dialog-header/dialog-header.html','<md-toolbar class=md-custom-background layout=layout layout-padding=layout-padding layout-align="space-between center"><h3 class=flush>{{ $ctrl.dialogTitle }}</h3><div class=links ng-if=!$ctrl.hideCloseBtn><md-icon ng-click=$ctrl.closeDialog()>cancel</md-icon></div></md-toolbar>');
$templateCache.put('app/core/components/erp-import-status-sync/erp-import-status-sync.html','<div flex=flex layout=row><span>{{ $ctrl.statusTitle }}</span><div class="loading-icon grid" ng-if=$ctrl.importInProgress()></div></div>');
$templateCache.put('app/core/components/flows-info/flows-info.html','<div layout=layout><div flex=30><h2 class=text-center>Sources</h2><div class=info><h4>Total:</h4><span>{{ $ctrl.flowsInfo.totalSource | currencyDisplayFilter }}</span></div><div class=info><h4>Count:</h4><span>{{ $ctrl.flowsInfo.totalSourceCount }}</span></div><div class=info><br></div><div class=info><h4>Increase:</h4><span>{{ $ctrl.flowsInfo.flowIn | currencyDisplayFilter }}</span></div><div class=info><h4>Increase Count:</h4><span>{{ $ctrl.flowsInfo.sourceCount }}</span></div><div class=info><br></div><div class=info><h4>Transfer:</h4><span>{{ $ctrl.flowsInfo.totalTransferIn | currencyDisplayFilter }}</span></div><div class=info><h4>Transfer Count:</h4><span>{{ $ctrl.flowsInfo.transferInCount }}</span></div></div><div flex=40><h2 class=text-center>Accounts</h2><div class=info><h4>Net Cash Flow:</h4><span>{{ $ctrl.flowsInfo.net | currencyDisplayFilter }}</span></div><div class=info><h4>Total Count:</h4><span>{{ $ctrl.flowsInfo.totalCount }}</span></div></div><div flex=30><h2 class=text-center>Uses</h2><div class=info><h4>Total:</h4><span>{{ $ctrl.flowsInfo.totalUse | currencyDisplayFilter }}</span></div><div class=info><h4>Count:</h4><span>{{ $ctrl.flowsInfo.totalUseCount }}</span></div><div class=info><br></div><div class=info><h4>Decrease:</h4><span>{{ $ctrl.flowsInfo.flowOut | currencyDisplayFilter }}</span></div><div class=info><h4>Decrease Count:</h4><span>{{ $ctrl.flowsInfo.useCount }}</span></div><div class=info><br></div><div class=info><h4>Transfer:</h4><span>{{ $ctrl.flowsInfo.totalTransferOut | currencyDisplayFilter }}</span></div><div class=info><h4>Transfer Count:</h4><span>{{ $ctrl.flowsInfo.transferOutCount }}</span></div></div></div>');
$templateCache.put('app/core/components/labels/labels.html','<div layout-padding=layout-padding layout=column><h3 class=flush>Labels</h3><form layout=column layout-gt-xs=row name=transactionLabels ng-submit=$ctrl.saveLabels()><div flex=flex><md-chips ng-model=$ctrl.labels placeholder="Add labels" secondary-placeholder="+ label"></md-chips></div><div class=text-right flex=nogrow><button class="btn btn-primary" type=sumbit aria-label="Save Labels">save labels</button></div></form></div>');
$templateCache.put('app/core/components/messages/messages.html','<div class=message layout=layout ng-repeat="msg in $ctrl.messages" ng-if=$ctrl.messages.length ng-class="msg.messageType === \'error\' ? \'message-error\': \'message-general\'"><div class="message-cell message-icon" ng-show="msg.messageType !== \'info\'"><!-- TODO: error icon--><md-icon ng-class="{ \'icon-inverted\': msg.messageType === \'error\' }">done</md-icon></div><div class="message-cell message-text text-center">{{ msg.messageText }}</div><div class=message-cell ng-if=msg.link><a class=message-link aria-label="{{ msg.link }}" ui-sref="{{ msg.link }}"><span>{{ msg.linkText }}</span><span><md-icon class=message-link-icon>navigate_next</md-icon></span></a></div><div class="message-cell message-icon text-right"><md-icon class=message-icon-dismiss ng-class="{ \'icon-inverted\': msg.messageType === \'error\' }" ng-click=$ctrl.dismissMessage($index)>close</md-icon></div></div>');
$templateCache.put('app/core/components/reconciliation-status-sync/reconciliation-status-sync.html','<div flex=flex layout=row><span>{{ $ctrl.statusTitle }}</span><div class="loading-icon grid" ng-if=$ctrl.reconciliationInProgress()></div></div>');
$templateCache.put('app/core/components/report-status-sync/report-status-sync.html','<div flex=flex layout=row><span>{{ $ctrl.statusTitle }}</span><div class="loading-icon grid" ng-if=$ctrl.reportInProgress()></div></div>');
$templateCache.put('app/core/components/revision-status-sync/revision-status-sync.html','<div flex=flex layout=row><span>{{ $ctrl.statusTitle }}</span><div class="loading-icon grid" ng-if=$ctrl.revisionInProgress()></div></div>');
$templateCache.put('app/core/components/sankey-filter/sankey-filter.html','<input class="form-control filter" type=text placeholder={{$ctrl.hint}} ng-model=$ctrl.searchText ng-change=$ctrl.quickFilter($ctrl.searchText)>');
$templateCache.put('app/core/components/side-nav/side-nav.html','<div class="side-nav md-whiteframe-1dp" layout=column layout-align=space-between ng-class="{ \'side-nav-open\': $ctrl.isNavOpen, \'side-nav-closed\': $ctrl.isNavClosed, \'side-nav-right\': $ctrl.navSideRight, \'collapse\': $ctrl.collapse }"><!-- full height on this div to satisfy -moz---><div class="side-nav-content full-height"><ng-transclude></ng-transclude></div><div class=side-nav-content layout=layout layout-align="space-between center"><a class="links links-small" ui-sref=legal.privacyPolicy>Privacy Policy</a><span>|</span><a class="links links-small" ui-sref=legal.termsOfService>Terms Of Service</a></div><md-icon class=side-nav-icon ng-click=$ctrl.toggleOpen() ng-if="!$ctrl.navSideRight &amp;&amp; $ctrl.collapse">chevron_right</md-icon><md-icon class=side-nav-icon ng-click=$ctrl.toggleOpen() ng-if="$ctrl.navSideRight &amp;&amp; $ctrl.collapse">chevron_left</md-icon></div>');
$templateCache.put('app/core/components/source-link/source-link.html','<span><a ng-if=$ctrl.url ng-href="{{ $ctrl.url }}" target=_blank rel=noopener>{{ $ctrl.document.fileName | filenameDisplay }}</a><span ng-if=!$ctrl.url>File {{ $ctrl.document.fileName | filenameDisplay }} does not exist.</span></span>');
$templateCache.put('app/core/components/stacked-bar-chart/stacked-bar-chart.html','<chart-container ng-class="{\'stacked-bar-chart\': $ctrl.audit !== \'true\'}" layout=flex><div ng-repeat="data in $ctrl.chart.data" ng-if="data.count &gt; 0" ng-class="[data.name, { \'bar-with-status\': data.name }]" style="flex:{{ data.percentage}};"><div class=stacked-bar-chart-label ng-class="{\'audit\': $ctrl.audit === \'true\'}">{{ data.count}}</div><div class=stacked-bar-chart-label ng-class="{\'audit\': $ctrl.audit === \'true\'}">{{ data.percentage}}%</div></div></chart-container>');
$templateCache.put('app/core/components/status-bar-chart/status-bar-chart.html','<div layout=row ng-if=$ctrl.chart layout-align="center end"><div class=bar-chart-label>{{ $ctrl.chart.startDate | date: \'MM/dd/yy\' }}</div><div class=bar-chart><div class="bar segmented" ng-repeat="period in $ctrl.chart.periods" ng-if="$ctrl.chart.source == \'upload\' &amp;&amp; period.width != 0" ng-class="[period.status, { \'bar-with-status\': period.status }]" ng-style="{ \'width\' : period.width + \'%\' }" ng-click=$ctrl.goToReconciled(period) status-bar-chart-popover=status-bar-chart-popover status=period.status start-date=period.startDate end-date=period.endDate></div><div class=bar ng-repeat="period in $ctrl.chart.periods" ng-if="$ctrl.chart.source == \'bankAPI\' &amp;&amp; period.width != 0" ng-style="{ \'width\' : period.width + \'%\' }" ng-class="[period.status, { \'bar-with-status\': period.status }]" status-bar-chart-popover=status-bar-chart-popover status=period.status description=period.description start-date=period.startDate end-date=period.endDate></div></div><div class=bar-chart-label>{{ $ctrl.chart.endDate | date: \'MM/dd/yy\' }}</div></div>');
$templateCache.put('app/core/components/supporting-document-preview/supporting-document-preview.html','<md-icon class="material-icons icon-primary" supporting-document-preview-popover=supporting-document-preview-popover preview-url=$ctrl.previewUrl filename=$ctrl.filename>visibility</md-icon>');
$templateCache.put('app/core/components/table-filter/table-filter.html','<input class="form-control filter" type=text placeholder=Filter... ng-model=$ctrl.searchText ng-change=$ctrl.quickFilter($ctrl.searchText)>');
$templateCache.put('app/core/components/table-search-keyword/table-search-keyword.html','<div layout=layout layout-align="space-between center"><input class="form-control room-right" type=text placeholder="Filter by keyword" ng-model=$ctrl.keyword> <button class="btn btn-primary" type=button aria-label=Search ng-click="$ctrl.applyFilter({ opts: { keyword: $ctrl.keyword || \'\' } })">Apply</button></div>');
$templateCache.put('app/core/components/trace-info/trace-info.html','<div class=settings layout=layout><div flex=15 layout=layout layout-align="start center"><sankey-filter hint="Filter by Account"></sankey-filter></div><div flex=20 layout=layout layout-align="start center"><sankey-filter hint="Filter by Transaction"></sankey-filter></div><div flex=15 layout=layout layout-align=right><md-select class=flush md-no-ink=md-no-ink aria-label="select date" name=selectedDateRange ng-model=$ctrl.traceSelectionData.dateRangeSelection><md-option ng-repeat="o in $ctrl.traceSelectionData.dateRangeOptions" ng-value=o.value>{{o.name}}</md-option></md-select></div><div flex=10 layout=layout><md-select class=flush md-no-ink=md-no-ink aria-label="select group by" name=selectedGroupBy ng-model=$ctrl.traceSelectionData.groupBySelection ng-change=$ctrl.traceSelectionData.selectionChanged()><md-option ng-repeat="o in $ctrl.traceSelectionData.groupByOptions" ng-value=o.value>{{o.name}}</md-option></md-select></div><div flex=10 layout=layout><md-select class=flush md-no-ink=md-no-ink aria-label="select subsequent" name=selectedSubsequent ng-model=$ctrl.traceSelectionData.subsequentSelection><md-option ng-repeat="o in $ctrl.traceSelectionData.subsequentOptions" ng-value=o.value>{{o.name}}</md-option></md-select></div></div><div layout=layout><div flex=30><img ng-src={{$ctrl.revenueDialURL}}></div><div flex=30><img ng-src={{$ctrl.ARDialURL}}></div><div flex=20><img ng-src={{$ctrl.cashDialURL}}></div><div flex=20><img ng-src={{$ctrl.bankDialURL}}></div></div>');
$templateCache.put('app/core/utils/alert-dialog/alert-dialog.html','<md-dialog class=dialog-sm flex=50 aria-label=alert><md-toolbar class=md-custom-background layout=layout layout-padding=layout-padding layout-align="space-between center"><h2 class=flush><md-icon class=room-right>error</md-icon><span>An error has occurred</span></h2></md-toolbar><div flex=flex layout=column layout-padding=layout-padding><md-content flex=flex><h2>{{ $ctrl.message }}</h2></md-content><md-dialog-actions><button class="btn btn-primary" ng-click=$ctrl.closeAlert()>Okay</button></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/core/utils/charts/flows-chart.html','<!-- TODO: add conditions to these elements--><div class=section-small><h3 class=flush>{{ $ctrl.node.name }}</h3></div><div><span>Net: {{ $ctrl.node.net | currency:undefined:0 }}</span><div class=section-small layout=layout><div flex=50><h4 class=flush>Increase</h4><span class="text-smaller currency-positive">{{ $ctrl.node.flowIn | currency:undefined:0 }}</span></div><div flex=50><h4 class=flush>Decrease</h4><span class="text-smaller currency-negative">{{ $ctrl.node.flowOut | currency:undefined:0 }}</span></div></div><div id=flows-stacked-bar-chart></div></div>');
$templateCache.put('app/core/utils/charts/force-graph-playback.html','<md-content ng-cloak=ng-cloak flex=flex layout=column><div id=force-graph-playback></div></md-content><!-- TODO: these control styles--><div><div layout=layout layout-padding=layout-padding layout-align="center center"><div><md-icon class="icon-primary icon-hover" ng-if=!$ctrl.playing ng-click=$ctrl.play()>play_arrow</md-icon><md-icon class="icon-primary icon-hover" ng-if=$ctrl.playing ng-click=$ctrl.pause()>pause</md-icon><md-icon class="icon-primary icon-hover" ng-click=$ctrl.reset()>replay</md-icon></div><div flex=flex><progress-playback is-playing=$ctrl.playing should-reset=$ctrl.resetProgress sync-timer=$ctrl.syncTimer filter-data=$ctrl.filterData></progress-playback></div></div></div>');
$templateCache.put('app/projects/engagement/adjustments/create-adjustment-dialog.html','<md-dialog class=dialog-lg aria-label=create-adjustment><dialog-header class=section dialog-title="Create an adjustment entry"></dialog-header><form name=createAdjustmentForm ng-submit="createAdjustmentForm.$valid &amp;&amp; $ctrl.createAdjustment()" novalidate><md-dialog-content><div class="section padding">Create an adjustment entry based on the currently applied transaction filters.</div><div class=padding layout=column><div class=form-group layout=row layout-align="start center"><h4 class=flush flex=10>Name:</h4><div layout=column><input class=form-control type=text name=name ng-model=$ctrl.adjustment.name required><div class=form-help-block ng-messages=createAdjustmentForm.$error ng-if=createAdjustmentForm.$submitted><div class=has-error ng-message=required>Provide a name.</div></div></div></div></div></md-dialog-content><md-dialog-actions layout=layout><div><button class="btn btn-inverted room-right" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" type=submit>Save</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/engagement/adjustments/delete-adjustment-dialog.html','<md-dialog class=dialog-lg aria-label=delete-adjustment><dialog-header class=section dialog-title="Delete an adjustment entry"></dialog-header><form name=createAdjustmentForm ng-submit="createAdjustmentForm.$valid &amp;&amp; $ctrl.deleteAdjustment()" novalidate><md-dialog-content><div class="section padding" ng-if=$ctrl.adjustment.isDefault>Are you sure you want to clear all manual adjustments?</div><div class="section padding" ng-if=!$ctrl.adjustment.isDefault>Are you sure you want to delete adjustment "{{ $ctrl.adjustment.name }}"?</div></md-dialog-content><md-dialog-actions layout=layout><div><button class="btn btn-inverted room-right" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" type=submit>Delete</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/engagement/erp-extracts/erp-extracts-list.html','<div class=ag-theme-material ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/engagement/erp-extracts/import-extract-dialog.html','<md-dialog class=dialog-lg><dialog-header dialog-title="Import ERP Extract"></dialog-header><div flex=flex layout=column layout-padding=layout-padding><md-dialog-content flex=flex><div class=section>This will start the ERP extract import process. All ERP data will be reset.</div>Please confirm you wish to continue.</md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted room-right" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" type=button ng-click=$ctrl.importExtract()>Import</button></div></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/projects/engagement/reconcile/reconcile-transactions-table.html','<div class="section settings" layout=layout layout-align="start center"><div flex=flex layout=row layout-align="space-between end"><div flex=flex layout=row layout-align="start start"><button class="btn btn-secondary" type=button ng-click=$ctrl.removeSelected() ng-disabled="!$ctrl.selectedTransactions.length || !$ctrl.canAdjust">Man ADJ</button> <button class="btn btn-primary" type=button ng-click=$ctrl.resetResults() ng-if=$ctrl.adjustmentId>BACK</button></div><div flex=flex><button class="btn btn-inverted" type=button ng-click=$ctrl.unreconcile() ng-disabled="$ctrl.reconciliation.status === \'unreconciled\'">Unreconcile</button> <button class="btn btn-primary" type=button ng-click=$ctrl.reconcile() ng-disabled="$ctrl.reconciliation.status === \'reconciled\'">Reconcile</button></div></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/engagement/reconcile/reconcile.html','<div ng-if="$ctrl.reconciliation &amp;&amp; $ctrl.reconciliationReady" layout=row flex=flex><md-content flex=flex><div class=reconcile-panel flex=flex layout=row><div class=padding flex=flex layout=column><div flex=flex layout=row layout-align="start start"><div class=description-panel layout=column flex=25><div><h3>Use search criteria and manual selection to adjust cash journal to reconcile to banking activity.</h3></div><div><h3>Default Transaction Filter:</h3><ul><li>ERP Transactions from Accounts marked \u201CVisible\u201D in the accounts page.</li><li>From {{ $ctrl.reconciliation.startDate | dateDisplay }} to {{ $ctrl.reconciliation.endDate | dateDisplay }}</li><li>NOT VERIFIED</li></ul></div><div class=warning><span>WARNING:&nbsp;</span>Selecting "Reconcile" will update all NOT VERIFIED Cash Journal entries to VERIFIED.</div><div class=warning><span>NOTE:&nbsp;</span>Verified Bank totals may not match work paper output. The table above does not include Verified Bank transactions matched to a Cash Journal transaction outside of the specified period.</div></div><div class=match-panel layout=column flex=75><table class=rec-metadata><thead><tr><th class=spacer></th><th></th><th colspan=3>INFLOWS</th><td class=spacer></td><th colspan=3>OUTFLOWS</th></tr></thead><tbody><tr><td class=spacer><md-icon class=expand-icon md-menu-origin=md-menu-origin ng-if=$ctrl.expanded.matching ng-click="$ctrl.expandCollapse(\'matching\')">remove</md-icon><md-icon class=expand-icon md-menu-origin=md-menu-origin ng-if=!$ctrl.expanded.matching ng-click="$ctrl.expandCollapse(\'matching\')">add</md-icon></td><td class=bold>In-Period</td><td class="header border-bottom border-right">CJ</td><td class="header border-bottom">BANK</td><td class="header border-bottom">VAR</td><td class=spacer></td><td class="header border-bottom border-right">CJ</td><td class="header border-bottom">BANK</td><td class="header border-bottom">VAR</td></tr><tr class=matching ng-show=$ctrl.expanded.matching><td class=spacer></td><td class=tab>VERIFIED</td><td class="amount border-right">{{ $ctrl.reconciliation.data.cj.matchedInPeriod.inflows | currencyDisplayFilter}}</td><td class=amount>{{ $ctrl.reconciliation.data.bank.matchedInPeriod.inflows | currencyDisplayFilter}}</td><td class=amount>{{ $ctrl.reconciliation.data.verifiedVariance.inflows | currencyDisplayFilter}}</td><td class=spacer></td><td class="amount border-right">{{ $ctrl.reconciliation.data.cj.matchedInPeriod.outflows | currencyDisplayFilter}}</td><td class=amount>{{ $ctrl.reconciliation.data.bank.matchedInPeriod.outflows | currencyDisplayFilter}}</td><td class=amount>{{ $ctrl.reconciliation.data.verifiedVariance.outflows | currencyDisplayFilter}}</td></tr><tr class=matching ng-show=$ctrl.expanded.matching><td class=spacer></td><td class=tab>NOT VERIFIED</td><td class="amount border-bottom border-right">{{ $ctrl.reconciliation.data.cj.unmatched.inflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.bank.unmatched.inflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.notVerifiedVariance.inflows | currencyDisplayFilter}}</td><td class=spacer></td><td class="amount border-bottom border-right">{{ $ctrl.reconciliation.data.cj.unmatched.outflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.bank.unmatched.outflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.notVerifiedVariance.outflows | currencyDisplayFilter}}</td></tr><tr class=matching ng-show=$ctrl.expanded.matching><td class=spacer></td><td class=tab>Subtotal</td><td class="amount border-right">{{ $ctrl.reconciliation.data.cj.subtotal.inflows | currencyDisplayFilter}}</td><td class=amount>{{ $ctrl.reconciliation.data.bank.subtotal.inflows | currencyDisplayFilter}}</td><td class=amount>{{ $ctrl.reconciliation.data.subtotalVariance.inflows | currencyDisplayFilter}}</td><td class=spacer></td><td class="amount border-right">{{ $ctrl.reconciliation.data.cj.subtotal.outflows | currencyDisplayFilter}}</td><td class=amount>{{ $ctrl.reconciliation.data.bank.subtotal.outflows | currencyDisplayFilter}}</td><td class=amount>{{ $ctrl.reconciliation.data.subtotalVariance.outflows | currencyDisplayFilter}}</td></tr><tr class=matching ng-show=$ctrl.expanded.matching><td class=spacer></td><td class=bold>Subsequent</td><td class=border-right></td><td colspan=2></td><td class=spacer></td><td class=border-right></td><td colspan=2></td></tr><tr class=matching ng-show=$ctrl.expanded.matching><td class=spacer></td><td class=tab>VERIFIED</td><td class="amount border-bottom border-right">{{ $ctrl.reconciliation.data.cj.matchedNextPeriod.inflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.bank.matchedNextPeriod.inflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.subsequentVariance.inflows | currencyDisplayFilter}}</td><td class=spacer></td><td class="amount border-bottom border-right">{{ $ctrl.reconciliation.data.cj.matchedNextPeriod.outflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.bank.matchedNextPeriod.outflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.subsequentVariance.outflows | currencyDisplayFilter}}</td></tr><tr class=matching ng-show=$ctrl.expanded.matching><td class=spacer></td><td class=bold>Non-Adjusted Total</td><td class="amount border-bottom border-right">{{ $ctrl.reconciliation.data.cj.unAdjustedTotal.inflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.bank.unAdjustedTotal.inflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.unAdjustedVariance.inflows | currencyDisplayFilter}}</td><td class=spacer></td><td class="amount border-bottom border-right">{{ $ctrl.reconciliation.data.cj.unAdjustedTotal.outflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.bank.unAdjustedTotal.outflows | currencyDisplayFilter}}</td><td class="amount border-bottom">{{ $ctrl.reconciliation.data.unAdjustedVariance.outflows | currencyDisplayFilter}}</td></tr><tr class=matching ng-show=$ctrl.expanded.matching><td class=spacer></td><td></td><td ng-class="{ \'border-right\': $ctrl.expanded.adjustment }"></td><td colspan=2></td><td class=spacer></td><td ng-class="{ \'border-right\': $ctrl.expanded.adjustment }"></td><td colspan=2></td></tr><tr><td class=spacer><md-icon class=expand-icon md-menu-origin=md-menu-origin ng-if=$ctrl.expanded.adjustment ng-click="$ctrl.expandCollapse(\'adjustment\')">remove</md-icon><md-icon class=expand-icon md-menu-origin=md-menu-origin ng-if=!$ctrl.expanded.adjustment ng-click="$ctrl.expandCollapse(\'adjustment\')">add</md-icon></td><td class=bold>ADJUSTMENTS</td><td ng-class="{ \'border-right\': $ctrl.expanded.adjustment }"></td><td colspan=2></td><td class=spacer></td><td ng-class="{ \'border-right\': $ctrl.expanded.adjustment }"></td><td colspan=2></td></tr><tr class=adjustment ng-show=$ctrl.expanded.adjustment><td class=spacer></td><td class=tab><md-icon class="material-icons icon-primary adjustment-icon" ng-if=!$ctrl.isReconciled ng-click=$ctrl.openDeleteAdjustmentDialog($ctrl.manualAdj)>delete</md-icon><a class=adjustment-link ng-click=$ctrl.showAdjustment()>Manual Adjustment</a></td><td class="amount border-right">{{ -1 * $ctrl.manualAdj.result.inflows | currencyDisplayFilter}}</td><td colspan=2></td><td class=spacer></td><td class="amount border-right">{{ -1 * $ctrl.manualAdj.result.outflows | currencyDisplayFilter}}</td><td colspan=2></td></tr><tr class=adjustment ng-repeat="a in $ctrl.adjustments" ng-show=$ctrl.expanded.adjustment><td class=spacer></td><td class=tab><md-icon class="material-icons icon-primary adjustment-icon" ng-if=!$ctrl.isReconciled ng-click=$ctrl.openDeleteAdjustmentDialog(a)>delete</md-icon><a class=adjustment-link ng-click=$ctrl.showAdjustment(a)>{{ a.name }}</a></td><td class="amount border-right">{{ -1 * a.result.inflows | currencyDisplayFilter}}</td><td colspan=2></td><td class=spacer></td><td class="amount border-right">{{ -1 * a.result.outflows | currencyDisplayFilter}}</td><td colspan=2></td></tr><tr class=adjustment ng-show=$ctrl.expanded.adjustment><td class=spacer></td><td class=bold>Adjusted Grand Total</td><td class="amount grand-total border-right">{{ $ctrl.reconciliation.data.cj.adjustedTotal.inflows | currencyDisplayFilter}}</td><td class="amount grand-total">{{ $ctrl.reconciliation.data.bank.unAdjustedTotal.inflows | currencyDisplayFilter}}</td><td class="amount grand-total">{{ $ctrl.reconciliation.data.adjustedVariance.inflows | currencyDisplayFilter}}</td><td class=spacer></td><td class="amount grand-total border-right">{{ $ctrl.reconciliation.data.cj.adjustedTotal.outflows | currencyDisplayFilter}}</td><td class="amount grand-total">{{ $ctrl.reconciliation.data.bank.unAdjustedTotal.outflows | currencyDisplayFilter}}</td><td class="amount grand-total">{{ $ctrl.reconciliation.data.adjustedVariance.outflows | currencyDisplayFilter}}</td></tr></tbody></table></div></div></div></div><md-divider></md-divider><div layout-padding=layout-padding><div flex=flex><reconcile-transactions-table ng-if=$ctrl.transactionsLoaded transactions=$ctrl.transactions reconciliation=$ctrl.reconciliation manual-adjustment=$ctrl.manualAdj selected-node=$ctrl.selectedNode is-read-only="$ctrl.isViewAdjustment || $ctrl.isReconciled" refresh=$ctrl.refresh()></reconcile-transactions-table></div></div></md-content><md-content class="side-nav side-nav-dark"><transaction-filter ng-if=$ctrl.transactionsLoaded filter-data=$ctrl.filterData is-reconcile=true entities=$ctrl.entities accounts=$ctrl.accounts source-type-enabled=true type=audit reconciliation=$ctrl.reconciliation is-read-only=$ctrl.isViewAdjustment apply-filter=$ctrl.applyFilter()></transaction-filter></md-content></div><div class="section padding" ng-if="!$ctrl.reconciliation || !$ctrl.reconciliationReady" layout=layout><div class=callout layout=column layout-align="center center"><div class=text-larger ng-if=!$ctrl.reconciliation>No match data found. Please run a match before attempting to reconcile</div><div class=text-larger ng-if="$ctrl.reconciliation &amp;&amp; !$ctrl.reconciliationReady">Match in progress. Please come back when the match process is completed.</div></div></div>');
$templateCache.put('app/projects/engagement/reconciliations/create-reconciliation-dialog.html','<md-dialog class=dialog-lg aria-label=create-match><dialog-header class=section dialog-title=Match></dialog-header><form name=createReconciliationForm ng-submit="createReconciliationForm.$valid &amp;&amp; $ctrl.createReconciliation()" novalidate><md-dialog-content><div class=padding layout=column><div class=form-group layout=row layout-align="start center" ng-class="{ \'has-error\': createReconciliationForm.startDate.$invalid &amp;&amp; createReconciliationForm.$submitted }"><h4 class=flush flex=20>Start Date:</h4><div layout=column><input class=form-control type=date name=startDate ng-model=$ctrl.reconciliation.startDate ng-model-options="{timezone: \'utc\'}" required><div class=form-help-block ng-messages=createReconciliationForm.startDate.$error ng-if=createReconciliationForm.$submitted><div class=has-error ng-message=required>Provide a Start Date.</div></div></div></div><div class=form-group layout=row layout-align="start center" ng-class="{ \'has-error\': createReconciliationForm.endDate.$invalid &amp;&amp; createReconciliationForm.$submitted }"><h4 class=flush flex=20>End Date:</h4><div layout=column><input class=form-control type=date name=endDate ng-model=$ctrl.reconciliation.endDate ng-model-options="{timezone: \'utc\'}" required><div class=form-help-block ng-messages=createReconciliationForm.endDate.$error ng-if=createReconciliationForm.$submitted><div class=has-error ng-message=required>Provide a End Date.</div></div></div></div><div class="text-error text-bold section-small" ng-if=$ctrl.errorMessage>{{ $ctrl.errorMessage }}</div></div></md-dialog-content><md-dialog-actions layout=layout><div><button class="btn btn-primary" type=submit>Start</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/engagement/reconciliations/reconciliations-list.html','<div class=ag-theme-material ag-grid=$ctrl.gridOptions height=75></div>');
$templateCache.put('app/projects/engagement/trace/trace-table.html','<div class="settings section" layout=layout><div flex=50 layout=layout layout-align="start center"><form name=filterFormTrace ng-submit=$ctrl.filter() novalidate></form><div class=form-group-no-margin><input class="form-control form-group-sml-no-margin" type=text name=filterGlTxId placeholder=GLTXID ng-model=$ctrl.filterData.glTxId></div><div class=form-group-no-margin><button class="btn btn-primary" name=submit type=submit ng-click=$ctrl.filter()>Apply</button></div></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/engagement/trace/trace.html','<div ng-if=$ctrl.hasTrace ng-cloak=ng-cloak layout=row flex=flex><md-content flex=flex><trace-info layout=column layout-padding=layout-padding layout-align="space-between none" trace-data=$ctrl.traceData trace-selection-data=$ctrl.traceSelectionOptions></trace-info><div layout=row><div class=flush-border-right flex=flex layout-padding=layout-padding><sankey-trace-graph trace-data=$ctrl.traceData sankey-group=false select-node=$ctrl.selectNode(node)></sankey-trace-graph></div></div></md-content></div><div class="section padding" ng-if=!$ctrl.hasTrace layout=layout><div class=callout layout=column layout-align="center center"><div class=text-larger>This project\'s trace is not complete yet. Please come back later.</div></div></div>');
$templateCache.put('app/projects/engagement/transactions/transactions.html','<div ng-if=$ctrl.transMetadata.transCount ng-cloak=ng-cloak layout=row flex=flex><md-content flex=flex><div layout-padding=layout-padding><div flex=flex><categories-transaction-table transactions=$ctrl.transactions categories=$ctrl.categories refresh=$ctrl.refresh() type=audit></categories-transaction-table></div></div></md-content><md-content class="side-nav side-nav-dark"><transaction-filter is-read-only=false filter-data=$ctrl.filterData grouping-enabled=true source-type-enabled=true entities=$ctrl.entities accounts=$ctrl.accounts categories=$ctrl.categories custom-fields=$ctrl.customFields apply-filter=$ctrl.applyFilter() type=audit></transaction-filter></md-content></div><div class="section padding" ng-if=!$ctrl.transMetadata.transCount layout=layout><div class=callout layout=column layout-align="center center"><div class=text-larger>This project has no transactions to categorize.</div></div></div>');
$templateCache.put('app/projects/engagement/workpapers/create-workpaper-dialog.html','<md-dialog class=dialog-lg aria-label=categories><dialog-header class=section dialog-title="Create {{$ctrl.workpaperTitle}} Workpaper"></dialog-header><md-dialog-content><div class="section padding">Are you sure you want to generate a workpaper?</div></md-dialog-content><md-dialog-actions layout=layout><div><button class="btn btn-primary" type=submit ng-click=$ctrl.createWorkpaper()>Create</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/projects/engagement/workpapers/workpaper-list-table.html','<div class="table-height-half ag-theme-material" ag-grid=$ctrl.gridOptions height=250></div>');
$templateCache.put('app/projects/engagement/workpapers/workpaper-metrics-dialog.html','<md-dialog class=dialog-lg aria-label="workpaper metrics"><dialog-header dialog-title="Workpaper Metrics"></dialog-header><md-dialog-content layout-padding=layout-padding><md-content><div class="table-height-half ag-theme-material" ag-grid=$ctrl.gridOptions></div></md-content><md-dialog-actions style="min-height: 70px;" layout=layout><div layout=column layout-align="center end"><div><button class="btn btn-inverted" type=button ng-click=$ctrl.exportToCsv()><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon><span>Export to CSV</span></button> <button class="btn btn-inverted" type=button ng-click=$ctrl.close()>Close</button></div></div></md-dialog-actions></md-dialog-content></md-dialog>');
$templateCache.put('app/projects/project/account/account-transactions.html','<md-content><div class="section padding"></div><h1 class="flush padding">Transactions / {{ $ctrl.account.entity.name }} - {{ $ctrl.account.number }}</h1><div class="section padding" ng-if="!$ctrl.hasStatement &amp;&amp; ($ctrl.stackedBarChart.data || $ctrl.statusBarChart.periods)" layout=column ng-cloak=ng-cloak><div class=overview-chart ng-if=$ctrl.stackedBarChart.data><div class=overview-chart-title>Statement OCR Status</div><stacked-bar-chart stacked-bar-data=$ctrl.stackedBarChart></stacked-bar-chart></div><div class=overview-chart ng-if=$ctrl.statusBarChart.periods><div class=overview-chart-title>Account Timeline</div><status-bar-chart status-bar-data=$ctrl.statusBarChart account-id=$ctrl.account.id project-type=$ctrl.projectType></status-bar-chart></div><bar-chart-legend ng-if=$ctrl.stackedBarChart.data chart-data=$ctrl.stackedBarChart></bar-chart-legend></div><div class="section padding" layout=layout ng-if=!$ctrl.showTransactions()><div class=callout layout=column layout-align="center center"><div class="section text-larger">This Account doesn\u2019t have any transactions. You can upload statements or add a bank integration.</div></div></div><div class=padding ng-if=$ctrl.showTransactions()><transaction-list-table transactions=$ctrl.transactions></transaction-list-table></div></md-content>');
$templateCache.put('app/projects/project/account/assign-account-dialog.html','<md-dialog class=dialog-lg aria-label=accounts><dialog-header dialog-title="Assign an account"></dialog-header><form flex=flex layout=column layout-padding=layout-padding name=selectAccountForm ng-hide=!$ctrl.projectAccounts.length ng-submit="selectAccountForm.$valid &amp;&amp; $ctrl.assignItems()" novalidate><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class=section ng-class="{ \'has-error\': selectAccountForm.selectedAccount.$invalid &amp;&amp; selectAccountForm.$submitted }"><label class=control-label>Select the account you wish to assign</label><md-radio-group class=flush name=selectedAccount ng-model=$ctrl.selectedAccount ng-change=$ctrl.clearSelection()><md-radio-button ng-repeat="account in $ctrl.projectAccounts" ng-value="{{ account }}" aria-label={{account}}><span>{{ account | accountSelectFilter }}</span></md-radio-button></md-radio-group></div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.cancelUpdate()>Cancel</button> <button class="btn btn-primary" ng-disabled=!$ctrl.selectedAccount type=submit>Save</button></div></md-dialog-actions></form><form flex=flex layout=column ng-hide=$ctrl.projectAccounts.length novalidate><h2 class=no-account>Please create one or more accounts first.</h2><md-dialog-actions class=padding layout=layout><button class="btn btn-primary" ng-hide=$ctrl.projectAccounts.length type=button ng-click=!$ctrl.cancelUpdate()>Done</button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/project/account/delete-account-dialog.html','<md-dialog class=dialog-lg><dialog-header dialog-title="Delete Account"></dialog-header><div flex=flex layout=column layout-padding=layout-padding><md-dialog-content flex=flex><div class=section></div><p ng-if=$ctrl.account.statusBarChart.periods>Cannot delete the account <strong>{{$ctrl.account.name}} </strong>due to existing <strong>{{$ctrl.account.statusBarChart.periods.length}} account periods.</strong><br>Please delete all account periods before continuing.</p><p ng-if=!$ctrl.account.statusBarChart.periods>You are currently deleting the account <strong>{{$ctrl.account.name}}</strong></p></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted room-right" type=button ng-click=$ctrl.cancel()>{{ $ctrl.account.statusBarChart.periods ? "Close" : "Cancel" }}</button> <button class="btn btn-warn" type=button ng-click=$ctrl.deleteAccount() ng-if=!$ctrl.account.statusBarChart.periods>Delete</button></div></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/projects/project/account/edit-accounts-list-table.html','<div class=settings layout=layout><div flex=50 layout=layout layout-align="start center"><button class="btn btn-primary" type=button ng-if="$ctrl.type === \'forensic\' &amp;&amp; $ctrl.hasPermissions" ng-click=$ctrl.addAccountRow() md-no-ink=md-no-ink aria-label=Next>Add Next Acct</button><table-filter grid-options=$ctrl.gridOptions></table-filter></div><div flex=50 layout=layout layout-align="end center"><button class="btn btn-primary" type=button ng-if=$ctrl.hasPermissions ng-click=$ctrl.updateAccounts() aria-label="update accounts">Update accounts</button></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/account/edit-accounts.html','<md-content><div class="padding section"><messages></messages><edit-accounts-list-table project=$ctrl.project accounts=$ctrl.accounts entities=$ctrl.entities type={{$ctrl.projectType}}></edit-accounts-list-table></div></md-content>');
$templateCache.put('app/projects/project/account/select-account.html','<button class="btn btn-inverted" type=button analytics-on=click ng-click=$ctrl.selectAccount() ng-disabled="!$ctrl.selectedItems.length &amp;&amp; !$ctrl.hasPermmissions"><md-tooltip>Assign Account</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>assignment</md-icon></button>');
$templateCache.put('app/projects/project/account-periods/account-period-actions.html','<md-menu md-offset="0 45"><button class=action-button ng-disabled=!$ctrl.isActionsEnabled() ng-click=$mdMenu.open();>Actions</button><md-menu-content class=check-item-menu-overrides width=3 ng-mouseleave=$mdMenu.close();><md-menu-item><md-button class=cat-option ng-click=$ctrl.deleteAccountPeriods() ng-disabled=!$ctrl.selectedAccountPeriods.length>Delete</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click=$ctrl.assignAccountPeriods() ng-disabled=!$ctrl.selectedAccountPeriods.length>Assign</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click=$ctrl.unassignAccountPeriods() ng-disabled=!$ctrl.selectedAccountPeriods.length>Unassign</md-button></md-menu-item></md-menu-content></md-menu>');
$templateCache.put('app/projects/project/account-periods/account-period-reconcile.html','<toaster-container></toaster-container><md-content><div layout-padding=layout-padding><div class=account-period-reconcile flex=flex layout=layout layout-align="center start"><div class=left><div class="panel summary" flex=flex layout=column><span class=title>Statement Summary:</span><div layout=column flex=flex><div class=row layout=layout flex=flex><div flex=40>Account:</div><div flex=60>{{$ctrl.accountPeriod.account.number}}</div></div><div class=row layout=layout flex=flex><div flex=40>Entity:</div><div flex=60>{{$ctrl.accountPeriod.account.entity.name}}</div></div><div class=row layout=layout flex=flex><div flex=40>Institution:</div><div flex=60>{{$ctrl.accountPeriod.account.bank}}</div></div><div class=row layout=layout flex=flex><div flex=40>Type:</div><div flex=60>{{$ctrl.accountPeriod.account.type | accountTypeDisplay}}</div></div><div class=row layout=layout flex=flex><div flex=40>Pages:</div><div flex=60>{{$ctrl.accountPeriod.statement.pages | number }}</div></div><div class="row space-top" layout=layout flex=flex><div flex=40 layout=layout><label class=strong>Data:</label></div><div class=data-quality flex=60 ng-if="$ctrl.accountPeriod.dataQuality === \'Okay\'"><md-icon class=check>check_circle</md-icon></div><div class=data-quality flex=60 ng-if="$ctrl.accountPeriod.dataQuality !== \'Okay\'"><md-icon class=not-disturb>do_not_disturb_alt</md-icon></div></div><div class=row layout=layout flex=flex><div flex=40><label class=strong>Status:</label></div><div flex=60>{{$ctrl.accountPeriod.status | accountPeriodStatusDisplay}}</div></div></div></div><button class="btn btn-inverted reconcile left-btn" type=button ng-if=$ctrl.hasPermissions ng-click=$ctrl.viewStatement()><span>View Statement</span></button> <button class="btn btn-inverted reconcile left-btn" type=button ng-if=$ctrl.canInvertAmounts ng-click=$ctrl.invertAccountPeriod()><span>Invert all amounts</span></button> <button class="btn btn-warn delete left-btn" type=button ng-if=$ctrl.hasPermissions ng-click=$ctrl.deleteAccountPeriod()><span>Delete Statement Period</span></button></div><div class=center><div class=action-bar layout=row flex=flex><div layout=layout flex=50><button class="btn btn-inverted" type=button ng-disabled=!$ctrl.accountPeriod.navigation.previous ng-click=$ctrl.goToPeriod($ctrl.accountPeriod.navigation.previous)><span>&lt;&lt; Previous Account Period</span></button></div><div layout=layout flex=50><button class="btn btn-inverted" type=button ng-disabled=!$ctrl.accountPeriod.navigation.next ng-click=$ctrl.goToPeriod($ctrl.accountPeriod.navigation.next)><span>Next Account Period &gt;&gt;</span></button></div></div><div class=action-bar layout=row flex=flex><div layout=layout flex=50><button class="btn btn-inverted" type=button ng-disabled=!$ctrl.accountPeriod.navigation.previousUnreconciled ng-click=$ctrl.goToPeriod($ctrl.accountPeriod.navigation.previousUnreconciled)><span>&lt;&lt; Previous Unreconciled</span></button></div><div layout=layout flex=50><button class="btn btn-inverted" type=button ng-disabled=!$ctrl.accountPeriod.navigation.nextUnreconciled ng-click=$ctrl.goToPeriod($ctrl.accountPeriod.navigation.nextUnreconciled)><span>Next Unreconciled &gt;&gt;</span></button></div></div><div class="panel balance"><span class=title>Account Period Amount Summary:</span><form flex=flex layout=column name=editAccountPeriodForm ng-submit="editAccountPeriodForm.$valid &amp;&amp; $ctrl.submitSaveAccountPeriod()" novalidate><div layout=column flex=flex><div layout=layout flex=flex><div class=text-right flex=20></div><div class=text-right flex=40><label class=strong>Date</label></div><div class=text-right flex=40><label class=strong>Amount</label></div></div><div layout=layout flex=flex><div class=text-right flex=20><label class=strong>Beginning</label></div><div class=form-account-period-control flex=40 layout=column layout-align="start end" ng-class="{ \'has-error\': editAccountPeriodForm.startDate.$invalid &amp;&amp; editAccountPeriodForm.$submitted }"><input class=form-control type=date name=startDate ng-disabled="$ctrl.disableEdit || !$ctrl.hasPermissions" ng-model=$ctrl.editAccountPeriod.startDate ng-model-options="{timezone: \'utc\'}"></div><div class=form-account-period-control flex=40 layout=column layout-align="start end" ng-class="{ \'has-error\': editAccountPeriodForm.startBalance.$invalid &amp;&amp; editAccountPeriodForm.$submitted }"><input class=form-control type=text format-as-currency=format-as-currency currency-filter="\'currencyInputFilter\'" name=startBalance ng-model=$ctrl.editAccountPeriod.startBalance ng-disabled="$ctrl.disableEdit || !$ctrl.hasPermissions" required><div class=form-help-block ng-messages=editAccountPeriodForm.startBalance.$error ng-if=editAccountPeriodForm.$submitted><div ng-message=required>Please provide a starting balance.</div></div></div></div><div layout=layout flex=flex><div class=text-right flex=20><label>Increase</label></div><div class=value flex=80 layout=column layout-align="start end">{{ $ctrl.editAccountPeriod.inflows | number:2 }}</div></div><div layout=layout flex=flex><div class=text-right flex=20><label>Decrease</label></div><div class=value flex=80 layout=column layout-align="start end">{{ $ctrl.editAccountPeriod.outflows * -1 | number:2 }}</div></div><div layout=layout flex=flex><div class=text-right flex=20><label class=strong>End</label></div><div class=form-account-period-control flex=40 layout=column layout-align="start end" ng-class="{ \'has-error\': editAccountPeriodForm.endDate.$invalid &amp;&amp; editAccountPeriodForm.$submitted }"><input class=form-control type=date name=endDate ng-disabled="$ctrl.disableEdit || !$ctrl.hasPermissions" ng-model=$ctrl.editAccountPeriod.endDate ng-model-options="{timezone: \'utc\'}"></div><div class=form-account-period-control flex=40 layout=column layout-align="start end" ng-class="{ \'has-error\': editAccountPeriodForm.endBalance.$invalid &amp;&amp; editAccountPeriodForm.$submitted }"><input class=form-control type=text format-as-currency=format-as-currency currency-filter="\'currencyInputFilter\'" ng-model=$ctrl.editAccountPeriod.endBalance ng-disabled="$ctrl.disableEdit || !$ctrl.hasPermissions" required><div class=form-help-block ng-messages=editAccountPeriodForm.endBalance.$error ng-if=editAccountPeriodForm.$submitted><div ng-message=required>Please provide an ending balance.</div></div></div></div><div layout=layout flex=flex><div class=text-right flex=20><label>Variance</label></div><div class=value flex=80 layout=column ng-binding=$ctrl.variance layout-align="start end">{{ $ctrl.variance | number:2 }}</div></div><div layout=layout flex=flex><div flex=80><div class="text-error text-bold section-small" ng-repeat="validation in $ctrl.validationMessages">{{ validation }}</div></div><div flex=20 layout=column layout-align="start end"><button class="btn btn-inverted" analytics-on=click analytics-event="Save Account Period" ng-disabled=$ctrl.disableEdit type=submit ng-if=$ctrl.hasPermissions ng-hide="$ctrl.validationMessages.length &gt; 0">Save</button> <button class="btn btn-inverted" analytics-on=click analytics-event="Save Account Period" type=submit ng-show="$ctrl.validationMessages.length &gt; 0">Confirm</button></div></div></div></form></div><div class=action-bar layout=row flex=flex><div layout=layout flex=50><button class="btn btn-inverted left-btn" ng-if=$ctrl.hasPermissions ng-disabled=!$ctrl.canAutoReconcile ng-click=$ctrl.autoReconcileTransaction() type=button><span>Auto Reconcile</span></button></div><div layout=layout flex=50><button class="btn btn-inverted reconcile" type=button ng-disabled="!$ctrl.canReconcile &amp;&amp; !$ctrl.canForceReconcile" ng-if=$ctrl.hasPermissions ng-hide="($ctrl.accountPeriod.status !== \'unreconciled\')" ng-click=$ctrl.reconcileAccountPeriod()><span ng-if=!$ctrl.canForceReconcile>Reconcile</span><span ng-if=$ctrl.canForceReconcile>Force Reconcile</span></button> <button class="btn btn-inverted reconcile" type=button ng-if=$ctrl.hasPermissions ng-hide="($ctrl.accountPeriod.status === \'unreconciled\')" ng-click=$ctrl.unreconcileAccountPeriod()><span>Unreconcile</span></button></div></div></div><div class=right><div class="panel notes-warnings" flex=flex layout=column><span class=title>Account Period Notes:</span> <textarea ng-model=$ctrl.editAccountPeriod.notes ng-disabled=$ctrl.disableEdit></textarea><span class=title>Account Period Errors and Warnings:</span><ul class=messages><li ng-repeat="m in $ctrl.accountPeriod.messages">{{ m }}</li></ul></div></div></div><div class=padding><account-period-transaction-list-table transactions=$ctrl.transactions editable-transactions=!$ctrl.isReconciled can-reconcile=$ctrl.canReconcile account-period=$ctrl.accountPeriod></account-period-transaction-list-table></div></div></md-content>');
$templateCache.put('app/projects/project/account-periods/account-period-transaction-list-table.html','<messages></messages><div class=settings><button class="btn btn-inverted float-left" id=addTransactionButton ng-click=$ctrl.addTransaction() ng-disabled="$ctrl.accountPeriod.status === \'reconciled\'" ng-if=$ctrl.hasPermissions type=button><md-icon class=icon-primary md-menu-origin=md-menu-origin>add_box</md-icon><span>Add Transaction</span></button> <button class="btn btn-inverted float-left" id=moveTransactionButton ng-click=$ctrl.moveTransactions() ng-disabled="!$ctrl.selectedTransactions.length || $ctrl.accountPeriod.status === \'reconciled\'" ng-if=$ctrl.hasPermissions type=button><md-icon class=icon-primary md-menu-origin=md-menu-origin>arrow_forward</md-icon><span>Move Transactions</span></button> <button class="btn btn-inverted float-left" id=deleteTransactionButton ng-click=$ctrl.deleteTransactions() ng-disabled="!$ctrl.selectedTransactions.length || $ctrl.accountPeriod.status === \'reconciled\'" ng-if=$ctrl.hasPermissions type=button><md-icon class=icon-primary md-menu-origin=md-menu-origin>delete</md-icon><span>Delete transactions</span></button> <button class="btn btn-inverted float-left" ng-disabled="$ctrl.accountPeriod.status === \'reconciled\'" type=button ng-if=$ctrl.hasPermissions ng-click=$ctrl.selectAll()><md-tooltip>Select all</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>select_all</md-icon></button></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/account-periods/account-periods-list.html','<div class=load-bar layout=layout><div class=room-right flex=flex layout=layout layout-align="start start"><div class=statements-menu flex=none layout=layout layout-align="start start"><button class=action-button type=button ng-click=$ctrl.expandCollapse()><md-tooltip>Expand/Collapse</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin ng-if=$ctrl.expand>unfold_less</md-icon><md-icon class=icon-primary md-menu-origin=md-menu-origin ng-if=!$ctrl.expand>unfold_more</md-icon></button> <button class=action-button ng-if="$ctrl.status !== \'all\'" type=button ng-disabled=!$ctrl.hasPermissions ng-click=$ctrl.selectAll($ctrl.status)><md-tooltip>Select all</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>select_all</md-icon></button><load-statement type={{$ctrl.type}} source={{$ctrl.source}}></load-statement><button class=action-button type=button ng-click=$ctrl.exportToCsv()><md-tooltip>Export CSV</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon></button><account-period-actions ng-if=$ctrl.hasPermissions selected-account-periods=$ctrl.selectedPeriods assign-account-periods=$ctrl.assignAccountPeriods() unassign-account-periods=$ctrl.unassignAccountPeriods() delete-account-periods=$ctrl.deleteAccountPeriods()></account-period-actions><div class=chevron-nav layout=row layout-align="start start"><div class=chevron-section><ul><li class=rejected><a ng-click="$ctrl.toFileTab(\'rejected\')"><span>Rejected</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].rejected}}</span></a></li><li class=extracting><a ng-click="$ctrl.toFileTab(\'extracting\')"><span>Extracting</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].extracting}}</span></a></li></ul><div class=all-files flex=flex layout=row layout-align="center center"><a ng-click="$ctrl.toFileTab(\'all-files\')">FILES ({{$ctrl.statusInfo[$ctrl.source].total}})</a></div></div><div class=chevron-section><ul><li class=unassigned ng-if="$ctrl.source !== \'txn_csv\'" ng-class="{ \'active\': $ctrl.status === \'unassigned\' }"><a ng-click="$ctrl.toPeriodTab(\'unassigned\')"><span>Unassigned</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].periods.unassigned}}</span></a></li><li class=unreconciled ng-class="{ \'active\': $ctrl.status === \'unreconciled\' }"><a ng-click="$ctrl.toPeriodTab(\'unreconciled\')"><span>Unreconciled</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].periods.unreconciled}}</span></a></li><li class=reconciled ng-class="{ \'active\': $ctrl.status === \'reconciled\' }"><a ng-click="$ctrl.toPeriodTab(\'reconciled\')"><span>Ready</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].periods.reconciled}}</span></a></li></ul><div class=all-items flex=flex layout=row layout-align="center center" ng-class="{ \'active\': $ctrl.status === \'all-items\' }"><a ng-click="$ctrl.toPeriodTab(\'all-items\')" ng-if="$ctrl.source !== \'checks_pdf\'">ACCOUNT PERIODS ({{$ctrl.statusInfo[$ctrl.source].periods.total}})</a></div></div></div><div class=md-filter flex=flex><table-filter grid-options=$ctrl.gridOptions></table-filter></div><button class="btn btn-inverted load-tool-btn" ng-if="$ctrl.status === \'unassigned\' || $ctrl.status === \'unreconciled\'" type=button analytics-on=click ng-click=$ctrl.assignAccountPeriods() ng-disabled="!$ctrl.selectedPeriods.length &amp;&amp; !$ctrl.hasPermmissions"><md-tooltip>Assign Account Periods</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>assignment</md-icon></button> <button class="btn btn-inverted load-tool-btn" ng-if="$ctrl.source !== \'txn_csv\' &amp;&amp; ($ctrl.status === \'reconciled\' || $ctrl.status === \'unreconciled\' || $ctrl.status === \'all\')" type=button analytics-on=click ng-click="$ctrl.batchStatusUpdatePeriods(\'unassign\')" ng-disabled="!$ctrl.selectedPeriods.length &amp;&amp; !$ctrl.hasPermmissions"><md-tooltip>Unassign Account Periods</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>assignment_returned</md-icon></button> <button class="btn btn-inverted load-tool-btn" ng-if="$ctrl.status === \'reconciled\' || $ctrl.status === \'all\'" type=button analytics-on=click ng-click="$ctrl.batchStatusUpdatePeriods(\'unreconcile\')" ng-disabled="!$ctrl.selectedPeriods.length &amp;&amp; !$ctrl.hasPermmissions"><md-tooltip>Unreconcile Account Periods</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>thumb_down_alt</md-icon></button> <button class="btn btn-inverted load-tool-btn" ng-if="$ctrl.status === \'unreconciled\' || $ctrl.status === \'all\'" type=button analytics-on=click ng-click="$ctrl.batchStatusUpdatePeriods(\'reconcile\')" ng-disabled="!$ctrl.selectedPeriods.length &amp;&amp; !$ctrl.hasPermmissions"><md-tooltip>Reconcile Account Periods</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>thumb_up_alt</md-icon></button></div></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/account-periods/account-periods-status-update-dialog.html','<md-dialog class=dialog-lg aria-label=accounts><dialog-header dialog-title="Account Period update"></dialog-header><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class=section><label class=control-label>{{ $ctrl.periods.length }} Account Periods will be {{ $ctrl.description }}. Please confirm.</label></div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" ng-click=$ctrl.save() type=submit>Confirm</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/projects/project/account-periods/account-periods.html','<md-content><messages></messages><div layout-padding=layout-padding><h2 class=flush>{{ $ctrl.title }}</h2><account-periods-list-table flex=flex account-periods=$ctrl.accountPeriods status-info=$ctrl.statusInfo type={{$ctrl.projectType}}></account-periods-list-table></div></md-content>');
$templateCache.put('app/projects/project/account-periods/add-transaction-dialog.html','<md-dialog class=dialog-lg aria-label=transactions><dialog-header dialog-title="Add Transaction"></dialog-header><form flex=flex layout=column name=addTransactionForm novalidate><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div layout=column flex=flex flex-gt-sm=100 layout-padding=layout-padding><div class=form-group ng-class="{ \'has-error\': addTransactionForm.transactionDescription.$invalid &amp;&amp; addTransactionForm.$submitted }"><label class=control-label>Transaction Description</label> <textarea class=form-control name=transactionDescription ng-model=$ctrl.transaction.description required></textarea><div class=form-help-block ng-messages=addTransactionForm.transactionDescription.$error ng-if=addTransactionForm.$submitted><div ng-message=required>Please provide a Transaction Description.</div></div></div><div class=form-group ng-class="{ \'has-error\': addTransactionForm.transactionDate.$invalid &amp;&amp; addTransactionForm.$submitted }"><label class=control-label>Transaction Date</label> <input class=form-control type=date min={{$ctrl.startDate}} max={{$ctrl.endDate}} name=transactionDate ng-model=$ctrl.transaction.date ng-model-options="{timezone: \'utc\'}" required><div class=form-help-block ng-messages=addTransactionForm.transactionDate.$error ng-if=addTransactionForm.$submitted><div ng-message=required>Please provide a Transaction Date.</div></div></div><div class=form-group ng-class="{ \'has-error\': addTransactionForm.transactionAmount.$invalid &amp;&amp; addTransactionForm.$submitted}"><label class=control-label>Transaction Amount</label> <input class=form-control type=text format-as-currency=format-as-currency currency-filter="\'currencyInputFilter\'" name=transactionAmount ng-model=$ctrl.transaction.amount required><div class=form-help-block ng-messages=addTransactionForm.transactionAmount.$error ng-if=addTransactionForm.$submitted><div ng-message=required>Please provide a Transaction Amount (only numbers allowed).</div></div></div><div class=form-group ng-class="{ \'has-error\': addTransactionForm.transactionPageNumber.$invalid &amp;&amp; addTransactionForm.$submitted}" layout=column layout-padding=layout-padding><label class=control-label>Page Number</label> <label for=OCRMissing><input type=radio id=OCRMissing value=ocrMissing ng-model=$ctrl.transaction.memoOpt ng-change=$ctrl.clearTransactionMemo()><span>OCR Missing</span></label> <label for=ManualEntry><input type=radio id=ManualEntry value=manualEntry ng-model=$ctrl.transaction.memoOpt ng-change=$ctrl.manualEntryMemo()><span>Adjustment to Reconcile</span></label><div><input class=form-control flex=25 name=transactionPageNumber type=text placeholder="Page Number" ng-model=$ctrl.transaction.memo ng-readonly="$ctrl.transaction.memo===\'Manual Entry\'" ng-required="$ctrl.currentAccountStatus===\'upload\'"><div class=form-help-block ng-messages=addTransactionForm.transactionPageNumber.$error ng-if=addTransactionForm.$submitted><div ng-message=required>Please provide a Page Number.</div></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.closeEditTransaction(addTransactionForm)>Cancel</button> <button class="btn btn-primary" name=saveCopy ng-click=$ctrl.saveAndCopy(addTransactionForm) analytics-on=click type=submit>Save &amp; Copy</button> <button class="btn btn-primary" analytics-on=click ng-click=$ctrl.submitSaveTransaction(addTransactionForm) analytics-event="Save Transaction" type=submit>Save</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/project/account-periods/assign-account-periods-dialog.html','<md-dialog class=dialog-lg aria-label=accounts><dialog-header dialog-title="Verify selected account periods"></dialog-header><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class=section ng-if="$ctrl.overlappingPeriods.length &gt; 0"><label class=control-label>You are about to assign duplicate account periods ({{ $ctrl.overlappingPeriods.length}}) to this account.</label> <label class=control-label>How do you want to proceed?</label><md-radio-group class=flush name=selectedGroup ng-model=$ctrl.selectedGroup><md-radio-button ng-value="\'allPeriods\'"><span>Assign all Account Periods ({{$ctrl.allPeriods.length}})</span></md-radio-button><md-radio-button ng-value="\'correctPeriods\'" ng-if="$ctrl.correctPeriods.length &gt; 0"><span>Only assign the non duplicate Account Periods ({{$ctrl.correctPeriods.length}})</span></md-radio-button></md-radio-group></div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" ng-click=$ctrl.next() type=submit>Next</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/projects/project/account-periods/auto-reconcile-transaction-dialog.html','<md-dialog class=dialog-lg aria-label=transactions><dialog-header dialog-title="Auto Reconcile"></dialog-header><form flex=flex layout=column name=autoReconcileForm ng-submit=$ctrl.submitSaveTransaction(autoReconcileForm) novalidate><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class=description>A transaction will be added to this statement in order to reconcile it.</div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-primary" analytics-on=click analytics-event="Save Transaction" type=submit>Auto Reconcile</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/project/account-periods/delete-account-period-dialog.html','<md-dialog class=dialog-lg aria-label=account-periods><dialog-header dialog-title="Delete Account Period"></dialog-header><div flex=flex layout=column><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class=section>Deleting this account period will result in the permanent removal of all transactions associated with it. All transfers within the project will also be removed.</div>Please confirm you wish to continue.</md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted room-right" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" type=button ng-click=$ctrl.deleteAccountPeriod()>Confirm</button></div></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/projects/project/account-periods/delete-account-periods-dialog.html','<md-dialog class=dialog-lg><dialog-header dialog-title="Delete Account Periods"></dialog-header><div flex=flex layout=column layout-padding=layout-padding><md-dialog-content flex=flex><h2>Are you sure you want to delete {{$ctrl.descriptionCounter}}?</h2></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted room-right" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-warn" type=button ng-click=$ctrl.deleteAccountPeriods()>Delete</button></div></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/projects/project/account-periods/delete-transactions-dialog.html','<md-dialog class=dialog-xl aria-label="delete transactions"><dialog-header dialog-title="Delete transactions"></dialog-header><md-dialog-content layout-padding=layout-padding><md-content><div class=section><label class=control-label>Are you sure you want to delete ({{ $ctrl.transactions.length}}) transactions?</label></div></md-content><md-dialog-actions style="min-height: 70px;" layout=layout><div layout=column layout-align="center end"><div><button class="btn btn-inverted" type=button ng-click=$ctrl.close()>Cancel</button> <button class="btn btn-primary" type=button ng-click=$ctrl.confirm()>Confirm</button></div></div></md-dialog-actions></md-dialog-content></md-dialog>');
$templateCache.put('app/projects/project/account-periods/edit-period-transaction-dialog.html','<md-dialog class=dialog-lg aria-label=transactions><dialog-header dialog-title="Edit Transaction"></dialog-header><form flex=flex layout=column name=editTransactionForm ng-submit=$ctrl.submitSaveTransaction(editTransactionForm) novalidate><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div layout=column flex=flex flex-gt-sm=100 layout-padding=layout-padding><div class=form-group ng-class="{ \'has-error\': editTransactionForm.transactionDescription.$invalid &amp;&amp; editTransactionForm.$submitted }"><label class=control-label>Transaction Description</label> <textarea class=form-control name=transactionDescription ng-model=$ctrl.editTransaction.description required></textarea><div class=form-help-block ng-messages=editTransactionForm.transactionDescription.$error ng-if=editTransactionForm.$submitted><div ng-message=required>Please provide a Transaction Description.</div></div></div><div class=form-group ng-class="{ \'has-error\': editTransactionForm.transactionDate.$invalid &amp;&amp; editTransactionForm.$submitted }"><label class=control-label>Transaction Date</label> <input class=form-control type=date min={{$ctrl.startDate}} max={{$ctrl.endDate}} name=transactionDate ng-model=$ctrl.editTransaction.date ng-model-options="{timezone: \'utc\'}" required><div class=form-help-block ng-messages=editTransactionForm.transactionDate.$error ng-if=editTransactionForm.$submitted><div ng-message=required>Please provide a Transaction Date.</div></div></div><div class=form-group ng-class="{ \'has-error\': editTransactionForm.transactionAmount.$invalid &amp;&amp; editTransactionForm.$submitted }"><label class=control-label>Transaction Amount</label> <input class=form-control type=text format-as-currency=format-as-currency currency-filter="\'currencyInputFilter\'" name=transactionAmount ng-model=$ctrl.editTransaction.amount required><div class=form-help-block ng-messages=editTransactionForm.transactionAmount.$error ng-if=editTransactionForm.$submitted><div ng-message=required>Please provide a Transaction Amount (only numbers allowed).</div></div></div><div class=form-group ng-class="{ \'has-error\': editTransactionForm.$submitted}" layout=column layout-padding=layout-padding ng-show="$ctrl.currentAccountStatus===\'file_upload\' &amp;&amp; !$ctrl.page"><label class=control-label>Reconcile Memo</label> <label for=OCRMissing><input type=radio id=OCRMissing value=ocrMissing ng-model=content ng-change=$ctrl.clearTransactionMemo() ng-checked=$ctrl.checkOCR><span>OCR Missing</span></label> <label for=ManualEntry><input type=radio id=ManualEntry value=manualEntry ng-model=content ng-readonly=true ng-change=$ctrl.manualEntryMemo() ng-checked=$ctrl.checkAdjustment ng-hide=$ctrl.memo><span>Adjustment to Reconcile</span></label><div><input class=form-control flex=25 name=transactionPageNumber type=text placeholder=Memo ng-model=$ctrl.editTransaction.memo ng-readonly=true ng-required="$ctrl.currentAccountStatus===\'file_upload\'"></div></div><div class=form-group layout=column layout-padding=layout-padding ng-show=$ctrl.page><label class=control-label>Page Number</label><div flex=25 ng-bind-html=$ctrl.linkPage></div></div></div></md-content></md-dialog-content><md-dialog-actions style="min-height: 70px;" layout=layout ng-class="{ \'dialog-actions-lg\': $ctrl.isConfirmRemove }"><div layout=column layout-align="center end"><div class="text-error text-bold section-small" ng-if=$ctrl.isConfirmRemove>Are you sure you want to remove this transaction?</div><div><button class="btn btn-inverted" type=button ng-click=$ctrl.closeEditTransaction()>Cancel</button> <button class="btn btn-warn" type=button ng-if=$ctrl.hasPermissions ng-click="$ctrl.isConfirmRemove = !$ctrl.isConfirmRemove" ng-hide=$ctrl.isConfirmRemove>Delete</button> <button class="btn btn-warn" type=button ng-if=$ctrl.hasPermissions analytics-on=click analytics-event="Delete Transaction" ng-click=$ctrl.removeTransaction() ng-show=$ctrl.isConfirmRemove>Confirm</button> <button class="btn btn-primary" analytics-on=click analytics-event="Save Transaction" type=submit ng-hide=$ctrl.isConfirmRemove>Save</button></div></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/project/account-periods/move-transactions-dialog.html','<md-dialog class=dialog-xl aria-label="move transactions"><dialog-header dialog-title="Move transactions to another account period"></dialog-header><md-dialog-content layout-padding=layout-padding><md-content><div class="table-height-half ag-theme-material" ag-grid=$ctrl.gridOptions></div></md-content><md-dialog-actions style="min-height: 70px;" layout=layout><div layout=column layout-align="center end"><div><button class="btn btn-inverted" type=button ng-click=$ctrl.close()>Cancel</button> <button class="btn btn-primary" type=button ng-disabled=!$ctrl.selectedPeriod ng-click=$ctrl.move()>Confirm</button></div></div></md-dialog-actions></md-dialog-content></md-dialog>');
$templateCache.put('app/projects/project/bulk-revisions/add-bulk-revision.html','<md-dialog class=dialog-m aria-label=upload><dialog-header dialog-title={{$ctrl.addDocumentTitle}} hide-default-close=true></dialog-header><md-dialog-content flex=flex><md-dialog-content><div class=padding layout=layout flex=flex><div layout=layout layout-align="space-between center" flex=flex><div class=form-group><label>Notes:</label> <input class=form-control type=text name=description ng-model=$ctrl.revisionDescription required></div><div class=form-group><button class="btn btn-primary btn-bulk-upload" accept=$ctrl.acceptPattern ng-disabled="$ctrl.isUploading() || $ctrl.newDocument.fileName" ngf-select="$ctrl.uploadFiles($files, $invalidFiles)" ngf-max-files=1 ngf-pattern=$ctrl.ngUploadPattern ngf-max-size=$ctrl.maxSize>Select a CSV File</button></div></div></div><div class=padding layout=layout flex=flex><ul class=progress-bar><li class="progress-row bar-m" ng-repeat="f in $ctrl.files"><div class=progress flex=flex layout=layout ng-show="f.progress &gt;= 0" style=width:{{f.progress}}%><div class=truncate flex=75><span>{{ f.name }}</span></div><div flex=25><span>{{ f.progress + \'%\'}}</span></div></div></li></ul></div><div class=padding layout=layout flex=flex><ul ng-show="$ctrl.errorFiles.length &gt; 0"><li ng-repeat="f in $ctrl.errorFiles">{{ $ctrl.getFileErrorMessage(f) }}</li></ul></div></md-dialog-content></md-dialog-content><md-dialog-actions layout=layout><div><button class="btn btn-inverted" type=button ng-disabled=$ctrl.isUploading() ng-click=$ctrl.cancelUpload()>Cancel</button> <button class="btn btn-primary" type=button ng-hide=$ctrl.isUploading() ng-disabled=!$ctrl.revisionId ng-click=$ctrl.startRevision()>Start</button> <button class="btn btn-warn" type=button ng-show=$ctrl.isUploading() ng-click=$ctrl.abortUpload()>Abort</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/projects/project/bulk-revisions/bulk-revision-confirm-dialog.html','<md-dialog class=dialog-lg><dialog-header dialog-title="Please confirm"></dialog-header><div flex=flex layout=column layout-padding=layout-padding><md-dialog-content flex=flex><div class=section>Are you sure you want to {{$ctrl.action}} this revision?</div></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted room-right" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-warn" type=button ng-click=$ctrl.confirm()>Confirm</button></div></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/projects/project/bulk-revisions/bulk-revision-list-table.html','<div class=settings layout=layout><div flex=25 layout=layout layout-align="start center"><button class="btn btn-primary" type=button ng-disabled=$ctrl.revisionInProgress ng-click=$ctrl.openUpload()>Excel Sync</button><table-filter grid-options=$ctrl.gridOptions></table-filter></div></div><div class="table-height-half ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/bulk-revisions/reimport-bulk-revision-dialog.html','<md-dialog class=dialog-lg><dialog-header dialog-title="Please confirm"></dialog-header><div flex=flex layout=column layout-padding=layout-padding><md-dialog-content flex=flex><div class=section>Are you sure you want to {{$ctrl.action}} this revision?</div></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted room-right" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-warn" type=button ng-click=$ctrl.confirm()>Confirm</button></div></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/projects/project/categories/apply-category-dialog.html','<md-dialog class=dialog-lg aria-label=categories><dialog-header dialog-title=Categorization></dialog-header><form flex=flex layout=column layout-padding=layout-padding name=applyLabelsForm ng-submit="applyLabelsForm.$valid &amp;&amp; $ctrl.saveLabels()" novalidate><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class="section form-group"><div class=text-larger>Select column type</div><div layout=layout><md-select class="flush transition-medium" flex=flex id=selectedColumnType name=selectedColumnType md-no-ink=md-no-ink ng-model=$ctrl.selectedColumnType required placeholder=Select><md-option ng-value="\'visCategory\'">Data visualization column</md-option><md-option ng-value="\'customField\'">Custom columns</md-option></md-select></div></div><div class=section ng-if="$ctrl.selectedColumnType === \'visCategory\'"><div class=section ng-class="{ \'has-error\': applyLabelsForm.selectedCategory.$invalid &amp;&amp; applyLabelsForm.$submitted }"><label class="control-label text-larger">Select a category</label><md-select class=flush md-no-ink=md-no-ink md-no-asterisk=md-no-asterisk name=selectedCategory ng-model=$ctrl.selectedCategory ng-change=$ctrl.clearSelection() placeholder="Select a Category" required><md-option ng-repeat="category in $ctrl.visCategories" ng-value="{{ category }}"><span>{{ category.name }}</span></md-option></md-select></div><div class=section ng-if=$ctrl.selectedCategory ng-class="{ \'has-error\': applyLabelsForm.selectedLabelId.$invalid &amp;&amp; applyLabelsForm.$submitted }"><label class="control-label text-larger">Select a label</label><md-select class=flush md-no-ink=md-no-ink md-no-asterisk=md-no-asterisk name=selectedLabelId ng-model=$ctrl.selectedLabelId placeholder="Select a Label" required><md-option ng-value="\'\'">Default ({{ ($ctrl.selectedCategory.categoryLabels | filter: { isDefault: true })[0].name }})</md-option><md-option ng-repeat="label in $ctrl.selectedCategory.categoryLabels" value="{{ label.id }}">{{ label.name }}</md-option></md-select></div></div><div class=section ng-if="$ctrl.selectedColumnType === \'customField\'"><div class=section ng-class="{ \'has-error\': applyLabelsForm.selecctedField.$invalid &amp;&amp; applyLabelsForm.$submitted }"><label class="control-label text-larger">Select a custom field</label><md-select class=flush md-no-ink=md-no-ink md-no-asterisk=md-no-asterisk name=selectedCategory ng-model=$ctrl.selectedField placeholder="Select a custom column" required><md-option ng-repeat="field in $ctrl.customFields" ng-value="{{ field }}"><span>{{ field.name }}</span></md-option></md-select></div><div class=section ng-if=$ctrl.selectedField><label class="control-label text-larger">Enter label value (can be empty)</label> <input class=form-control type=text name=fieldLabel ng-model=$ctrl.fieldLabel></div></div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.cancelCategories()>Cancel</button> <button class="btn btn-primary" type=submit>Save</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/project/categories/categories-transaction-table.html','<messages></messages><div class="section settings cat-settings" layout=layout layout-align="space-between center"><div layout=layout flex=50 layout-align="start center"><button class=cat-settings-btn ng-if="$ctrl.hasPermissions &amp;&amp; $ctrl.status !== \'all-items\'" type=button ng-click=$ctrl.expandCollapse()><md-tooltip>Expand Collapse</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>unfold_less</md-icon></button> <button class=cat-settings-btn ng-if=$ctrl.hasPermissions type=button ng-click=$ctrl.selectAll()><md-tooltip>Select all</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>select_all</md-icon></button><excel-export type=$ctrl.type></excel-export><manage-columns ng-if="$ctrl.type === \'forensic\' &amp;&amp; $ctrl.hasPermissions" selected-items=$ctrl.selectedTransactions categories=$ctrl.categories custom-fields=$ctrl.customFields on-category-update=$ctrl.onCategoryUpdate() on-save=$ctrl.transactionsUpdated(isRefreshRequired) selected-transactions=$ctrl.selectedTransactions></manage-columns></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/categories/categories.html','<div ng-if=$ctrl.transMetadata.transCount ng-cloak=ng-cloak layout=row flex=flex><md-content flex=flex><div layout-padding=layout-padding><div flex=flex><categories-transaction-table transactions=$ctrl.transactions custom-fields=$ctrl.customFields categories=$ctrl.categories refresh=$ctrl.refresh() type=forensic></categories-transaction-table></div></div></md-content><md-content class="side-nav side-nav-dark"><transaction-filter is-read-only=false filter-data=$ctrl.filterData grouping-enabled=true source-type-enabled=false entities=$ctrl.entities accounts=$ctrl.accounts categories=$ctrl.categories custom-fields=$ctrl.customFields apply-filter=$ctrl.applyFilter() type=forensic></transaction-filter></md-content></div><div class="section padding" ng-if=!$ctrl.transMetadata.transCount layout=layout><div class=callout layout=column layout-align="center center"><div class=text-larger>This project has no transactions to categorize.</div></div></div>');
$templateCache.put('app/projects/project/categories/edit-category-dialog.html','<md-dialog class=dialog-lg aria-label="custom columns"><dialog-header ng-if="$ctrl.selectedColumnType === \'customColumns\'" dialog-title="Manage Custom Columns"></dialog-header><dialog-header ng-if="$ctrl.selectedColumnType === \'visCategory\'" dialog-title="Manage Data Viz Columns"></dialog-header><form flex=flex layout=column layout-padding=layout-padding name=editColumnsForm ng-submit="editColumnsForm.$valid &amp;&amp; $ctrl.updateColumns()" novalidate><md-dialog-content flex=flex layout-padding=layout-padding><div ng-if="$ctrl.selectedColumnType === \'visCategory\'"><div class="section form-group"><span class=text-bold>Data visualization column (up to 3)</span><span>, used for source/use nodes on cash flow visualization. Requires a default label and limits the quantity of unique labels to 100.</span></div><div class="section form-group" ng-if="$ctrl.isCustomCategories() &amp;&amp; !$ctrl.showAddCategory" ng-class="{ \'has-error\': editColumnsForm.selectedCategory.$invalid &amp;&amp; editColumnsForm.$submitted }"><div class=text-larger>Select a Vis Category</div><div layout=layout><md-select class="flush transition-medium" flex=flex id=selectedCategory name=selectedCategory md-no-ink=md-no-ink ng-model=$ctrl.selectedCategory required placeholder=Select><md-option ng-repeat="scheme in $ctrl.customCategories | filter:{isSystemCategory: false} track by $index" ng-value=scheme>{{ scheme.name }}</md-option><md-option ng-if="$ctrl.customCategories.length &lt; 3" ng-click="$ctrl.showAddCategory = true">Create a new category...</md-option></md-select></div><div class=form-help-block ng-messages=editColumnsForm.selectedCategory.$error ng-if=editColumnsForm.$submitted><div ng-message=required>Please select a category.</div></div></div><div class=section ng-if="!$ctrl.isCustomCategories() || $ctrl.showAddCategory"><div class=section-small ng-if=$ctrl.selectedCategory.categoryLabels.length><div class="section-small text-larger">Current categories</div><ul class=list><li class=list-inline ng-repeat="category in $ctrl.customCategories track by $index"><span class="tag tag-no-hover tag-right">{{ category.name }}</span></li></ul></div><div class="callout form-group" ng-class="{ \'has-error\': editColumnsForm.categoryText.$invalid &amp;&amp; editColumnsForm.$submitted }"><div class=section layout=layout layout-align="start center" ng-if=!$ctrl.selectedCategory.categoryLabels.length><span class=room-right><md-icon class=icon-primary>error</md-icon></span><span>Add a category to begin labeling and organizing transactions.</span></div><div layout=layout><input class="room-right form-control" type=text name=categoryText ng-model=$ctrl.categoryText placeholder="Create a new category..." required> <button class="btn btn-inverted room-right" ng-if=$ctrl.isCustomCategories() type=button ng-click="$ctrl.showAddCategory = false; $ctrl.categoryText = \'\'">Cancel</button> <button class="btn btn-primary" type=button ng-click="$ctrl.addNewCategory($ctrl.categoryText); $ctrl.categoryText = \'\'" ng-disabled=!$ctrl.categoryText>Create</button></div><div class=form-help-block ng-messages=editColumnsForm.categoryText.$error ng-if=editColumnsForm.$submitted><div ng-message=required>Please enter a category.</div></div></div></div><div ng-if="$ctrl.selectedCategory.categoryLabels &amp;&amp; !$ctrl.showAddCategory"><div class="section-small text-larger">Labels for {{ $ctrl.selectedCategory.name }}</div><div class=section-small><ul class=list><li class=section-small ng-repeat="label in $ctrl.selectedCategory.categoryLabels"><div layout=layout><div class="room-right transition-medium" flex="{{ label.initRemove ? 60 : 80 }}"><div class=callout layout=layout layout-align="start center" ng-hide=label.editMode><div flex=flex><span class=space-right>{{ label.name }}</span><span class="text-primary text-hover text-underline" ng-if=!label.isDefault ng-click=$ctrl.setDefaultLabel(label)>set as default</span><span class=text-italics ng-if=label.isDefault>(default)</span></div><md-icon class="icon-primary icon-hover icon-small" ng-hide="label.initRemove || $ctrl.selectedCategory.categoryLabels.length === 1" ng-click="label.initRemove = true">cancel</md-icon></div><input class=form-control ng-show=label.editMode type=text ng-model=label.name></div><button class="btn btn-primary room-right" flex=20 type=button ng-show=label.initRemove ng-click=$ctrl.removeLabel($index)>Remove</button> <button class="btn btn-inverted" flex=20 type=button ng-show=label.initRemove ng-click="label.initRemove = false">Cancel</button> <button class="btn btn-primary" flex=20 type=button ng-hide="label.editMode || label.initRemove" ng-click="label.editMode = true">Edit</button> <button class="btn btn-inverted" flex=20 type=button ng-show=label.editMode ng-click="label.editMode = false">Done</button></div></li></ul><div ng-if="$ctrl.selectedCategory.categoryLabels.length &lt; 100" layout=layout ng-click="$ctrl.initAddLabel = true"><div class=room-right flex=80><input class=form-control type=text ng-model=$ctrl.labelText placeholder="Add another label..."></div><button class="btn btn-primary" flex=20 ng-disabled=!$ctrl.labelText type=button ng-click="$ctrl.addCategoryLabel($ctrl.labelText); $ctrl.labelText = null">Add</button></div></div></div></div><div ng-if="$ctrl.selectedColumnType === \'customField\'"><div class="section form-group"><span class=text-bold>Custom columns (up to 9)</span><span>, default label not required, no limits on unique labels.</span></div><div ng-if=$ctrl.customFields><div class=section-small><ul class=list><li class=section-small ng-repeat="field in $ctrl.customFields"><div layout=layout><div class="room-right transition-medium" flex="{{ field.initRemove ? 60 : 80 }}"><div class=callout layout=layout layout-align="start center" ng-hide=field.editMode><div flex=flex><span class=space-right>{{ field.name }}</span></div><md-icon class="icon-primary icon-hover icon-small" ng-hide="field.initRemove || $ctrl.customFields.length === 1" ng-click="field.initRemove = true">cancel</md-icon></div><input class=form-control ng-show=field.editMode type=text ng-model=field.name></div><button class="btn btn-primary room-right" flex=20 type=button ng-show=field.initRemove ng-click=$ctrl.removeCustomField($index)>Remove</button> <button class="btn btn-inverted" flex=20 type=button ng-show=field.initRemove ng-click="field.initRemove = false">Cancel</button> <button class="btn btn-primary" flex=20 type=button ng-hide="field.editMode || field.initRemove" ng-click="field.editMode = true">Edit</button> <button class="btn btn-inverted" flex=20 type=button ng-show=field.editMode ng-click="field.editMode = false">Done</button></div></li></ul><div ng-if="$ctrl.customFields.length &lt; 9" layout=layout ng-click="$ctrl.initAddLabel = true"><div class=room-right flex=80><input class=form-control type=text ng-model=$ctrl.labelText placeholder="Add another column..."></div><button class="btn btn-primary" flex=20 ng-disabled=!$ctrl.labelText type=button ng-click="$ctrl.addCustomField($ctrl.labelText); $ctrl.labelText = null">Add</button></div></div></div></div></md-dialog-content><md-dialog-actions layout=layout ng-if="$ctrl.selectedColumnType === \'visCategory\'"><div class="text-error text-bold" ng-if=$ctrl.selectedCategory.initRemove>Are you sure you want to remove vis category {{ $ctrl.selectedCategory.name }}</div></md-dialog-actions><md-dialog-actions layout=layout ng-if="$ctrl.selectedColumnType === \'customField\'"><div class="text-error text-bold" ng-if=$ctrl.selectedCustomField.initRemove>Are you sure you want to remove column {{ $ctrl.selectedCustomField.name }}</div></md-dialog-actions><md-dialog-actions layout=layout><button class="btn btn-inverted room-right" type=button ng-hide=$ctrl.selectedCategory.initRemove ng-click=$ctrl.closeEditCategories()>Cancel</button> <button class="btn btn-warn room-right" type=button ng-hide="$ctrl.selectedCategory.initRemove || $ctrl.selectedColumnType === \'customField\'" ng-disabled="!$ctrl.selectedCategory || !$ctrl.selectedCategory.id" ng-click="$ctrl.selectedCategory.initRemove = true">Delete</button> <button class="btn btn-primary" type=submit ng-hide=$ctrl.selectedCategory.initRemove>Save</button> <button class="btn btn-inverted room-right" type=button ng-show=$ctrl.selectedCategory.initRemove ng-click="$ctrl.selectedCategory.initRemove = false">Cancel</button> <button class="btn btn-warn" type=button ng-show=$ctrl.selectedCategory.initRemove ng-click=$ctrl.removeCategory()>Confirm</button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/project/categories/excel-exports.html','<md-menu md-offset="-110 40"><button class=action-button ng-click=$mdMenu.open();><md-tooltip>Export</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon></button><md-menu-content width=3 ng-mouseleave=$mdMenu.close();><md-menu-item><md-button class=cat-option ng-click=$ctrl.excelTransactionsExport()>Summary Txns to Excel</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click=$ctrl.excelDetailedTransactionsExport()>Detail Txns to Excel</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click=$ctrl.excelBalancesExport()>Daily Bals to Excel</md-button></md-menu-item><md-menu-item ng-if="$ctrl.type === \'forensic\'"><md-button class=cat-option ng-click=$ctrl.financialActivityReport()>Financial Activity Report</md-button></md-menu-item></md-menu-content></md-menu>');
$templateCache.put('app/projects/project/categories/financial-activity-report-sections.html','<md-dialog class=dialog-lg><dialog-header dialog-title="Select the sections to include in your Financial Activity Report"></dialog-header><div flex=flex layout=column layout-padding=layout-padding><form class=customer-form flex=flex layout=row name=FARSectionsForm><md-dialog-content flex=flex layout-fill=layout-fill layout=column><div class=row layout=layout layout-padding=layout-padding flex=flex><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label=Accounts ng-model=$ctrl.sections.accounts></md-checkbox><label>Accounts</label></div><div class=row layout=layout layout-padding=layout-padding flex=flex><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label="Account Activity Summary" ng-model=$ctrl.sections.accountsSummary></md-checkbox><label>Account Activity Summary</label></div><div class=row layout=layout layout-padding=layout-padding flex=flex><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label="Statements: Summary" ng-model=$ctrl.sections.statementsSummary></md-checkbox><label>Statements: Summary</label></div><div class=row layout=layout layout-padding=layout-padding flex=flex><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label="Statements: Detail" ng-model=$ctrl.sections.statementsDetail></md-checkbox><label>Statements: Detail</label></div><div class=row layout=layout layout-padding=layout-padding flex=flex><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label=Transfers ng-model=$ctrl.sections.transfers></md-checkbox><label>Transfers</label></div><div class=row layout=layout layout-padding=layout-padding flex=flex><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label="Date Gaps" ng-model=$ctrl.sections.dateGaps></md-checkbox><label>Date Gaps</label></div><div class=row layout=layout layout-padding=layout-padding flex=flex><md-checkbox class="md-custom-background cell-checkbox checkbox-overrides" aria-label=Files ng-model=$ctrl.sections.files></md-checkbox><label>Files</label></div></md-dialog-content></form><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.closeDialog()>Cancel</button> <button class="btn btn-primary" ng-disabled="!$ctrl.sections.files &amp;&amp; !$ctrl.sections.dateGaps &amp;&amp; !$ctrl.sections.transfers &amp;&amp; !$ctrl.sections.statementsDetail &amp;&amp; !$ctrl.sections.statementsSumamry &amp;&amp; !$ctrl.sections.accountsSummary &amp;&amp; !$ctrl.sections.accounts" analytics-on=click ng-click=$ctrl.launchFinancialActivityReport() analytics-event="Generate FAR" type=submit>Generate FAR</button></div></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/projects/project/categories/manage-columns.html','<md-menu md-offset="0 40"><button class=cat-settings-btn ng-click=$mdMenu.open();>Actions</button><md-menu-content width=3 ng-mouseleave=$mdMenu.close();><md-menu-item><md-button class=cat-option ng-click=$ctrl.manualMatch() ng-disabled="$ctrl.selectedItems.length !== 2">Match</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click="$ctrl.editCategories(\'customField\')">Add/Manage Custom Column</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click="$ctrl.editCategories(\'visCategory\')">Add/Manage Data Viz Column</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click=$ctrl.applyCategory() ng-disabled="!$ctrl.selectedItems.length || (!$ctrl.categories.length &amp;&amp; !$ctrl.customFields.length)">Apply Labels</md-button></md-menu-item></md-menu-content></md-menu>');
$templateCache.put('app/projects/project/categories/manual-match-dialog.html','<md-dialog class=dialog-lg aria-label="manual match"><dialog-header dialog-title=Match></dialog-header><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class=section><div class=text-larger>{{ $ctrl.message }}</div></div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" ng-disabled=!$ctrl.valid ng-click=$ctrl.saveMatch()>Confirm</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/projects/project/categories/manual-match.html','<button class=cat-settings-btn type=button analytics-on=click ng-click=$ctrl.manualMatch() ng-disabled="$ctrl.selectedTransactions.length !== 2">Match</button>');
$templateCache.put('app/projects/project/check-items/check-item-actions.html','<md-menu md-offset="0 45"><button class=action-button ng-disabled=!$ctrl.isActionsEnabled() ng-click=$mdMenu.open();>Actions</button><md-menu-content class=check-item-menu-overrides width=3 ng-mouseleave=$mdMenu.close();><md-menu-item><md-button class=cat-option ng-click=$ctrl.findNewMatches()>Match All</md-button></md-menu-item><md-menu-item ng-if="$ctrl.status === \'unmatched\'"><md-button class=cat-option ng-click=$ctrl.checkForStatementPeriods()>Check For Statement Data</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click=$ctrl.resetMatches() ng-disabled="$ctrl.status === \'unmatched\'">Reset All Matches</md-button></md-menu-item><md-menu-item ng-if="$ctrl.status === \'unmatched\'"><md-button class=cat-option ng-click=$ctrl.associate() ng-disabled="$ctrl.selectedCheckItems.length &lt; 2">Associate</md-button></md-menu-item><md-menu-item ng-if="$ctrl.status === \'unmatched\'"><md-button class=cat-option ng-click=$ctrl.disassociate() ng-disabled="$ctrl.selectedCheckItems.length &lt; 1">Disassociate</md-button></md-menu-item><md-menu-item ng-if="$ctrl.status === \'unreconciled\'"><md-button class=cat-option ng-click="$ctrl.batchItems(\'reconcile\')" ng-disabled=!$ctrl.selectedCheckItems.length>Move to Ready</md-button></md-menu-item><md-menu-item ng-if="$ctrl.status === \'reconciled\'"><md-button class=cat-option ng-click="$ctrl.batchItems(\'unreconcile\')" ng-disabled=!$ctrl.selectedCheckItems.length>Move to Review</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click="$ctrl.batchItems(\'unmatch\')" ng-disabled="$ctrl.status !== \'unreconciled\' || !$ctrl.selectedCheckItems.length">Remove Item Match</md-button></md-menu-item><md-menu-item ng-if="$ctrl.status === \'unmatched\'"><md-button class=cat-option ng-click="$ctrl.batchItems(\'delete\')" ng-disabled=!$ctrl.selectedCheckItems.length>Delete Item</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click="$ctrl.editCategories(\'customField\')">Add/Manage Custom Column</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click="$ctrl.editCategories(\'visCategory\')">Add/Manage Data Viz Column</md-button></md-menu-item><md-menu-item><md-button class=cat-option ng-click=$ctrl.applyCategory() ng-disabled="!$ctrl.selectedCheckItems.length || (!$ctrl.categories.length &amp;&amp; !$ctrl.customFields.length)">Apply Labels</md-button></md-menu-item></md-menu-content></md-menu>');
$templateCache.put('app/projects/project/check-items/check-item-inline-editor.html','<div class="main-shelf check-viewer"><div class=center><div class=check-img ng-if=$ctrl.checkEditData.displayedImageUrl><img class=edit-img ng-src={{$ctrl.checkEditData.displayedImageUrl}}><div class=no-img ng-if=!$ctrl.checkEditData.displayedImageUrl></div></div><button class="btn btn-flip-img" analytics-on=click analytics-event="Toggle image" ng-disabled=!$ctrl.checkEditData.backImageUrl ng-click=$ctrl.toggleImage()>{{$ctrl.checkEditData.displayedImageUrlType.toLocaleUpperCase()}}</button><span>No image available</span></div><div class="side check-item-input-container"><form class=form-horizontal name=editCheckItemForm novalidate><div class=check-item-form-group><label>Payor:</label> <input class="form-control inline" ng-disabled=!$ctrl.checkEditData.canEdit id=payor type=text name=payor ng-keydown=$ctrl.stopPropagation($event) ng-model=$ctrl.checkEditData.editCheckItem.payor></div><div class=check-item-form-group><label>Serial:</label> <input class="form-control inline" ng-disabled=!$ctrl.checkEditData.canEdit type=text name=number ng-keydown=$ctrl.stopPropagation($event) ng-model=$ctrl.checkEditData.editCheckItem.checkNumber></div><div class=check-item-form-group><label>Date:</label> <input class="form-control inline" ng-disabled=!$ctrl.checkEditData.canEdit type=date name=date ng-keydown=$ctrl.stopPropagation($event) ng-model=$ctrl.checkEditData.editCheckItem.date ng-model-options="{timezone: \'utc\'}"></div><div class=check-item-form-group><label>Amt:</label> <input class="form-control inline" ng-disabled=!$ctrl.checkEditData.canEditAmount placeholder="Item Amount" type=text format-as-currency=format-as-currency currency-filter="\'currencyInputFilter\'" name=amount ng-keydown=$ctrl.stopPropagation($event) ng-model=$ctrl.checkEditData.editCheckItem.amount></div><div class=check-item-form-group><label>Payee:</label> <input class="form-control inline" ng-disabled=!$ctrl.checkEditData.canEdit type=text name=payee ng-keydown=$ctrl.stopPropagation($event) ng-model=$ctrl.checkEditData.editCheckItem.payee></div><div class=check-item-form-group><label>Memo:</label> <input class="form-control inline" ng-disabled=!$ctrl.checkEditData.canEdit type=text name=memo ng-keydown=$ctrl.stopPropagation($event) ng-model=$ctrl.checkEditData.editCheckItem.memo></div><div class=check-item-form-group><label>Account:</label> <input class="form-control inline" ng-disabled=!$ctrl.checkEditData.canEdit type=text name=accountNumber ng-keydown=$ctrl.stopPropagation($event) ng-model=$ctrl.checkEditData.editCheckItem.accountNumber></div><div class=check-item-form-group><label>&nbsp;</label> <button class="btn btn-primary btn-update" analytics-on=click analytics-event="Save Check Item" ng-if=$ctrl.checkEditData.canEdit ng-click=$ctrl.submitSaveCheckItem($ctrl.checkEditData)>Update</button></div></form></div></div>');
$templateCache.put('app/projects/project/check-items/check-item-reconcile.html','<toaster-container></toaster-container><md-content><div layout-padding=layout-padding><h2 class=flush>Item Images: Edit/Reconcile</h2><div class=statements-menu flex=none layout=layout layout-align="start start"><load-statement type=forensic source={{$ctrl.source}}></load-statement><div class=chevron-nav flex=flex layout=row layout-align="start start"><div class=chevron-section><ul><li class=rejected><a ng-click="$ctrl.toFileTab(\'rejected\')"><span>Rejected</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].rejected}}</span></a></li><li class=extracting><a ng-click="$ctrl.toFileTab(\'extracting\')"><span>Extracting</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].extracting}}</span></a></li></ul><div class=all-files flex=flex layout=row layout-align="center center"><a ng-click="$ctrl.toFileTab(\'all-files\')">FILES ({{$ctrl.statusInfo[$ctrl.source].total}})</a></div></div><div class=chevron-section><ul><li class=unmatched ng-class="{ \'active\': $ctrl.status === \'unmatched\' }"><a ng-click="$ctrl.toItemTab(\'unmatched\')"><span>Unmatched</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].checkItems.unmatched}}</span></a></li></ul><div class=all-check-items flex=flex layout=row layout-align="center center" ng-class="{ \'active\': $ctrl.status === \'unmatched\' }"><a ng-click="$ctrl.toItemTab(\'unmatched\')">ITEMS ({{$ctrl.statusInfo[$ctrl.source].checkItems.unmatched}})</a></div></div><div class=chevron-section><ul><li class=unreconciled ng-class="{ \'active\': $ctrl.status === \'unreconciled\' }"><a ng-click="$ctrl.toItemTab(\'unreconciled\')"><span>Unreconciled</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].checkItems.unreconciled}}</span></a></li><li class=reconciled ng-class="{ \'active\': $ctrl.status === \'reconciled\' }"><a ng-click="$ctrl.toItemTab(\'reconciled\')"><span>Ready</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].checkItems.reconciled}}</span></a></li></ul><div class=all-items flex=flex layout=row layout-align="center center" ng-class="{ \'active\': $ctrl.status === \'all-items\' }"><a ng-click="$ctrl.toItemTab(\'all-items\')">BANK TRANSACTIONS ({{$ctrl.statusInfo[$ctrl.source].checkItems.reconciled + $ctrl.statusInfo[$ctrl.source].checkItems.unreconciled}})</a></div></div></div></div><div class=check-item-reconcile flex=none layout-padding=layout-padding><div class=action-bar flex=flex layout=row layout-align="start start"><h2 class=flush>Check Items Detail</h2><button class="btn btn-flat prev" type=button ng-disabled=!$ctrl.topCheckItem.navigation.previous ng-click=$ctrl.goToItem($ctrl.topCheckItem.navigation.previous)><div class=logo-icon></div><span>Prev</span></button> <button class="btn btn-flat next" type=button ng-disabled=!$ctrl.topCheckItem.navigation.next ng-click=$ctrl.goToItem($ctrl.topCheckItem.navigation.next)><div class=logo-icon></div><span>Next</span></button></div><div flex=flex layout=row layout-align="start start"><div class="main-section children" ng-if="$ctrl.itemChildren.length &gt; 0"><table class=deposit-children><thead><tr><th class=spacer></th><th>Item Type</th><th>Item Date</th><th>Amount</th></tr></thead><tbody><tr><td><div class="expand-icon expanded" ng-if="$ctrl.editCheckItem.id === $ctrl.topCheckItem.id"></div><div class="expand-icon collapsed" ng-if="$ctrl.editCheckItem.id !== $ctrl.topCheckItem.id" ng-click=$ctrl.selectEditCheckItem($ctrl.topCheckItem)></div></td><td>{{ $ctrl.topCheckItem.type | checkItemTypeDisplay }}</td><td>{{ $ctrl.topCheckItem.date | dateDisplay }}</td><td>{{ 0 | currencyDisplayFilter }}</td></tr><tr ng-repeat="child in $ctrl.itemChildren"><td><div class="expand-icon expanded" ng-if="$ctrl.editCheckItem.id === child.id"></div><div class="expand-icon collapsed" ng-if="$ctrl.editCheckItem.id !== child.id" ng-click=$ctrl.selectEditCheckItem(child)></div></td><td>{{ child.type | checkItemTypeDisplay }}</td><td>{{ child.date | dateDisplay }}</td><td>{{ child.amount | currencyDisplayFilter }}</td></tr></tbody><tfoot><tr><td></td><td>TOTAL</td><td></td><td>{{ $ctrl.childrenTotal | currencyDisplayFilter }}</td></tr></tfoot></table></div><div class="main-section check-viewer"><div class=center><div class=check-img ng-if=$ctrl.displayedImageUrl><img class=edit-img src={{$ctrl.displayedImageUrl}}><div class=no-img ng-if=!$ctrl.displayedImageUrl></div></div><button class="btn btn-flip-img" analytics-on=click analytics-event="Toggle image" ng-disabled=!$ctrl.backImageUrl ng-click=$ctrl.toggleImage()>{{$ctrl.displayedImageUrlType.toLocaleUpperCase()}}</button><span>No image available</span></div><div class="side check-item-input-container"><form class=form-horizontal name=editCheckItemForm novalidate><div class=check-item-form-group><label>Payor:</label> <input class="form-control inline" ng-disabled=!$ctrl.canEdit id=payor type=text name=payor ng-model=$ctrl.editCheckItem.payor></div><div class=check-item-form-group><label>Serial:</label> <input class="form-control inline" ng-disabled=!$ctrl.canEdit type=text name=number ng-model=$ctrl.editCheckItem.checkNumber></div><div class=check-item-form-group><label>Date:</label> <input class="form-control inline" ng-disabled=!$ctrl.canEdit type=date name=date ng-model=$ctrl.editCheckItem.date ng-model-options="{timezone: \'utc\'}"></div><div class=check-item-form-group><label>Amt:</label> <input class="form-control inline" ng-disabled=!$ctrl.canEdit placeholder="Item Amount" type=text format-as-currency=format-as-currency currency-filter="\'currencyInputFilter\'" name=amount ng-model=$ctrl.editCheckItem.amount></div><div class=check-item-form-group><label>Payee:</label> <input class="form-control inline" ng-disabled=!$ctrl.canEdit type=text name=payee ng-model=$ctrl.editCheckItem.payee></div><div class=check-item-form-group><label>Memo:</label> <input class="form-control inline" ng-disabled=!$ctrl.canEdit type=text name=memo ng-model=$ctrl.editCheckItem.memo></div><div class=check-item-form-group><label>Account:</label> <input class="form-control inline" ng-disabled=!$ctrl.canEdit type=text name=accountNumber ng-model=$ctrl.editCheckItem.accountNumber></div><div class=check-item-form-group><label>&nbsp;</label> <button class="btn btn-primary btn-update" analytics-on=click analytics-event="Save Check Item" ng-if=$ctrl.canEdit ng-click=$ctrl.submitSaveCheckItem()>Update</button></div></form></div></div></div></div></div></md-content>');
$templateCache.put('app/projects/project/check-items/check-items-list.html','<div class=load-bar layout=layout><div class=room-right flex=flex layout=layout layout-align="start start"><div class=statements-menu flex=none layout=layout layout-align="start start"><button class=action-button ng-if="$ctrl.hasPermissions &amp;&amp; $ctrl.status !== \'all-items\'" type=button ng-click=$ctrl.expandCollapse()><md-tooltip>Expand Collapse</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>unfold_less</md-icon></button> <button class=action-button ng-if="$ctrl.hasPermissions &amp;&amp; $ctrl.status !== \'all-items\'" type=button ng-click=$ctrl.selectAll()><md-tooltip>Select all</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>select_all</md-icon></button><load-statement type={{$ctrl.type}} source={{$ctrl.source}}></load-statement><button class=action-button type=button ng-click=$ctrl.exportToCsv()><md-tooltip>Export CSV</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon></button><check-item-actions ng-if=$ctrl.hasPermissions selected-check-items=$ctrl.selectedCheckItems grid-options=$ctrl.gridOptions categories=$ctrl.categories custom-fields=$ctrl.customFields on-category-update=$ctrl.onCategoryUpdate() on-save=$ctrl.itemsUpdated(isRefreshRequired) caller=check-items></check-item-actions><div class=chevron-nav flex=flex layout=row layout-align="start start"><div class=chevron-section><ul><li class=rejected ng-class="{ \'active\': $ctrl.status === \'rejected\' }"><a ng-click="$ctrl.toFileTab(\'rejected\')"><span>Rejected</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].rejected}}</span></a></li><li class=extracting ng-class="{ \'active\': $ctrl.status === \'extracting\' }"><a ng-click="$ctrl.toFileTab(\'extracting\')"><span>Extracting</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].extracting}}</span></a></li></ul><div class=all-files flex=flex layout=row layout-align="center center" ng-class="{ \'active\': $ctrl.status === \'rejected\' || $ctrl.status === \'extracting\' }"><a ng-click="$ctrl.toFileTab(\'all-files\')">FILES ({{$ctrl.statusInfo[$ctrl.source].total}})</a></div></div><div class=chevron-section><ul><li class=unmatched ng-class="{ \'active\': $ctrl.status === \'unmatched\' }"><a ng-click="$ctrl.toItemTab(\'unmatched\')"><span>Unmatched</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].checkItems.unmatched}}</span></a></li><li class=unreconciled ng-class="{ \'active\': $ctrl.status === \'unreconciled\' }"><a ng-click="$ctrl.toItemTab(\'unreconciled\')"><span>Review</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].checkItems.unreconciled}}</span></a></li></ul><div class=all-check-items flex=flex layout=row layout-align="center center" ng-class="{ \'active\': $ctrl.status === \'unmatched\' || $ctrl.status === \'unreconciled\' }"><a ng-click="$ctrl.toItemTab(\'unmatched\')">ITEMS ({{$ctrl.statusInfo[$ctrl.source].checkItems.unmatched + $ctrl.statusInfo[$ctrl.source].checkItems.unreconciled }})</a></div></div><div class=chevron-section><ul><li class=reconciled ng-class="{ \'active\': $ctrl.status === \'reconciled\' }"><a ng-click="$ctrl.toItemTab(\'reconciled\')"><span>Ready</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].checkItems.reconciled}}</span></a></li></ul><div class=all-check-item-transactions flex=flex layout=row layout-align="center center" ng-class="{ \'active\': $ctrl.status === \'reconciled\'}"><a ng-click="$ctrl.toItemTab(\'reconciled\')" ng-if="$ctrl.source === \'checks_pdf\'">BANK TRANSACTIONS ({{$ctrl.statusInfo[$ctrl.source].checkItems.reconciled }})</a></div></div></div></div></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/check-items/check-items.html','<md-content><messages></messages><div layout-padding=layout-padding><h2 class=flush>{{ $ctrl.title }}</h2><check-items-list-table flex=flex type={{$ctrl.projectType}} match-jobs=$ctrl.matchJobs categories=$ctrl.categories custom-fields=$ctrl.customFields></check-items-list-table></div></md-content>');
$templateCache.put('app/projects/project/documents/add-document.html','<md-dialog class=dialog-lg aria-label=upload><dialog-header dialog-title={{$ctrl.addDocumentTitle}}></dialog-header><md-dialog-content flex=flex><md-content><div class=padding layout=layout flex=flex><div layout=layout flex=flex><div class=form-group layout=column flex=75><h4>{{ $ctrl.info }}</h4></div><div class=form-group layout=column layout-align=end flex=25><button class="btn btn-primary" multiple accept=$ctrl.acceptPattern ng-hide=$ctrl.isUploading() ngf-select="$ctrl.uploadFiles($files, $invalidFiles)" ngf-max-files=100 ngf-pattern=$ctrl.ngUploadPattern ngf-max-size=$ctrl.maxSize>Select Files</button></div></div></div><div class=padding layout=layout flex=flex><ul class=progress-bar><li class="progress-row bar-l" ng-repeat="f in $ctrl.files"><div class=progress flex=flex layout=layout ng-show="f.progress &gt;= 0" style=width:{{f.progress}}%><div class=truncate flex=75><span>{{ f.name }}</span></div><div flex=25><span>{{ f.progress + \'%\'}}</span></div></div></li></ul></div><div class=padding layout=layout flex=flex><ul ng-show="$ctrl.errorFiles.length &gt; 0"><li ng-repeat="f in $ctrl.errorFiles">{{ $ctrl.getFileErrorMessage(f) }}</li></ul></div></md-content></md-dialog-content><md-dialog-actions layout=layout><div><button class="btn btn-primary" type=button ng-hide=$ctrl.isUploading() ng-click=$ctrl.closeUploadDialog()>Done</button> <button class="btn btn-warn" type=button ng-show=$ctrl.isUploading() ng-click=$ctrl.abortUpload()>Abort</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/projects/project/files/files.html','<md-content><messages></messages><div layout-padding=layout-padding><report-list-table flex=flex reports=$ctrl.reports accounts=$ctrl.accounts entities=$ctrl.entities></report-list-table></div><div ng-if=$ctrl.showRevisions layout-padding=layout-padding><bulk-revision-list-table flex=flex bulk-revisions=$ctrl.bulkRevisions></bulk-revision-list-table></div></md-content>');
$templateCache.put('app/projects/project/flows/flows-transactions-table.html','<messages></messages><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/flows/flows.html','<div class=cashflow-viz ng-if=$ctrl.transMetadata.transCount layout=row flex=flex><md-content flex=flex><img class=cashflow-viz-watermark src=assets/images/valid8-logo.png><flows-info layout=column layout-padding=layout-padding layout-align="space-between none" force-data=$ctrl.forceData selected-node=$ctrl.selectedNode></flows-info><force-graph ng-if=!$ctrl.sankeyEnabled force-data=$ctrl.forceData select-node=$ctrl.selectNode(node)></force-graph><div layout=row><div class=flush-border-right ng-if="$ctrl.sankeyEnabled &amp;&amp; !$ctrl.graphIsSankey" flex=flex layout-padding=layout-padding><button class="btn btn-sml btn-primary" ng-click=$ctrl.switchGraphType()>Sankey Graph</button><!-- button.btn.btn-sml.btn-primary(ng-click="$ctrl.openFlowsPlayback()") Play--><force-graph force-data=$ctrl.forceData select-node=$ctrl.selectNode(node)></force-graph></div></div><div ng-if=$ctrl.sankeyEnabled layout=row><div class=flush-border-right ng-if=$ctrl.graphIsSankey flex=flex layout-padding=layout-padding><button class="btn btn-sml btn-primary" ng-click=$ctrl.switchGraphType()>Force Graph</button><div class=flush-border-right><sankey-graph sankey-data=$ctrl.sankeyData sankey-group=false select-node=$ctrl.selectNode(node)></sankey-graph></div></div></div><md-divider></md-divider><div layout-padding=layout-padding><div flex=flex><flows-transactions-table transactions=$ctrl.transactions selected-node=$ctrl.selectedNode categories=$ctrl.categories custom-fields=$ctrl.customFields project=$ctrl.project refresh=$ctrl.refresh()></flows-transactions-table></div></div></md-content><md-content class="side-nav side-nav-dark"><transaction-filter is-read-only=false filter-data=$ctrl.filterData entities=$ctrl.entities accounts=$ctrl.accounts categories=$ctrl.categories custom-fields=$ctrl.customFields grouping-enabled=true source-type-enabled=false apply-filter=$ctrl.filterGraphData() is-cash-flow=true type=forensic></transaction-filter></md-content></div><div class="section padding" ng-if=!$ctrl.transMetadata.transCount layout=layout><div class=callout layout=column layout-align="center center"><div class=text-larger>This project has no transactions to categorize.</div></div></div>');
$templateCache.put('app/projects/project/matching/approve-all-dialog.html','<md-dialog class=dialog-lg aria-label=accounts><dialog-header dialog-title="Approve All"></dialog-header><form class=approve-all flex=flex layout=column layout-padding=layout-padding name=approveAllForm ng-submit="approveAllForm.$valid &amp;&amp; $ctrl.approveAll()" novalidate><md-dialog-content flex=flex layout-padding=layout-padding><md-content><div class=section ng-class="{ \'has-error\': approveAllForm.selectedAccount.$invalid &amp;&amp; approveAllForm.$submitted }"><label class=control-label>Please select the quality matches you would like to approve.</label><div class=quality-check ng-repeat="quality in $ctrl.qualities"><input type=checkbox name=categories aria-label=category ng-click=$ctrl.toggleQualities(quality.description)><span>{{ quality.label }} [{{ quality.counter }}]</span></div></div></md-content></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-primary" type=button ng-disabled=!$ctrl.selectedQualities.length ng-click=$ctrl.approveAll()>Approve All</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/project/matching/matching-table.html','<div class="section status-menu" layout=layout><ul class="sub-menu md-body-1"><li><a class=found ng-click="$ctrl.setStatus(\'found\')"><span>Found</span><span class=rectangle>{{$ctrl.statusInfo[\'found\'].total}}</span></a></li><li><a class=confirmed ng-click="$ctrl.setStatus(\'confirmed\')"><span>Confirmed</span><span class=rectangle>{{$ctrl.statusInfo[\'confirmed\'].total}}</span></a></li><li><a class=rejected ng-click="$ctrl.setStatus(\'rejected\')"><span>Rejected</span><span class=rectangle>{{$ctrl.statusInfo[\'rejected\'].total}}</span></a></li></ul><div class=buttons><button class="btn btn-inverted" type=button ng-click=$ctrl.setApproveAll() ng-disabled=$ctrl.findingMatches ng-hide="($ctrl.status === \'confirmed\')"><md-icon class=icon-primary md-menu-origin=md-menu-origin>check_circle</md-icon><span>Approve All</span></button> <button class="btn btn-inverted" type=button ng-disabled=$ctrl.findingMatches ng-click=$ctrl.findNewMatches()><md-icon class=icon-primary md-menu-origin=md-menu-origin>search</md-icon><span ng-if=$ctrl.findingMatches>Finding matches...</span><span ng-if=!$ctrl.findingMatches>Find New Matches</span></button> <button class="btn btn-inverted" ng-if=$ctrl.isCustomerAdminOrEngagementOwner() type=button ng-disabled=$ctrl.findingMatches ng-click=$ctrl.resetMatches()><md-icon class=icon-primary md-menu-origin=md-menu-origin>find_replace</md-icon><span ng-if=$ctrl.findingMatches>Finding matches...</span><span ng-if=!$ctrl.findingMatches>Reset All Matches</span></button> <button class="btn btn-primary float-right confirm" type=button ng-disabled=$ctrl.findingMatches ng-show=$ctrl.isConfirmMatch ng-click=$ctrl.confirmMatches()>Update</button></div></div><div class=settings layout=layout><div flex=flex layout=layout layout-align="start center"><button class="btn btn-primary float-left" type=button ng-hide="($ctrl.status === \'confirmed\')" ng-click=$ctrl.setApprovePage()>Approve Page</button> <button class="btn btn-primary float-left" ng-hide="($ctrl.status === \'rejected\')" type=button ng-click=$ctrl.setRejectPage()>Reject Page</button></div></div><div class="table-height-full matching-table ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/matching/matching.html','<md-content><div layout-padding=layout-padding><div layout=layout><matching-table flex=flex matches=$ctrl.matches match-jobs=$ctrl.matchJobs></matching-table></div></div></md-content>');
$templateCache.put('app/projects/project/reports/delete-report-dialog.html','<md-dialog class=dialog-lg><dialog-header dialog-title=Delete></dialog-header><div flex=flex layout=column layout-padding=layout-padding><md-dialog-content flex=flex><div class=section>Are you sure you want to delete file <b>{{$ctrl.report.name}}?</b></div></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted room-right" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-warn" type=button ng-click=$ctrl.deleteReport()>Delete</button></div></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/projects/project/reports/report-filters-dialog.html','<md-dialog class="dialog-lg report-filters dialog" aria-label=filters><dialog-header dialog-title="Filter details"></dialog-header><md-dialog-content layout-padding=layout-padding><md-content><div class=section><label class=control-label>{{ $ctrl.dates }}</label></div><div class=section><label class=control-label>Accounts:</label><ul><li ng-repeat="account in $ctrl.filteredAccounts">{{ account | accountSelectFilter }}</li><li ng-if="$ctrl.filteredAccounts.length == 0">(all)</li></ul></div><div class=section><label class=control-label>Entities:</label><ul><li ng-repeat="entity in $ctrl.filteredEntities">{{ entity.name }}</li><li ng-if="$ctrl.filteredEntities.length == 0">(all)</li></ul></div><div class=section><label class=control-label>Transactions:</label><ul><li>Abs: {{ $ctrl.transactionAbs }}</li><li>Min: {{ $ctrl.transactionMin }}</li><li>Max: {{ $ctrl.transactionMax }}</li><li>Flow: {{ $ctrl.transactionFlow }}</li></ul></div></md-content><md-dialog-actions style="min-height: 70px;" layout=layout><div layout=column layout-align="center end"><div><button class="btn btn-inverted" type=button ng-click=$ctrl.close()>Close</button></div></div></md-dialog-actions></md-dialog-content></md-dialog>');
$templateCache.put('app/projects/project/reports/report-list-table.html','<div class=settings layout=layout><div flex=25 layout=layout layout-align="start center"><table-filter grid-options=$ctrl.gridOptions></table-filter></div></div><div class="table-height-half ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/transactions/edit-transaction-dialog.html','<md-dialog class=edit-txn-dialog aria-label=transactions><md-toolbar class=md-custom-background layout=layout layout-padding=layout-padding layout-align="space-between center"><h3 class=flush>Edit Row</h3><div flex=flex layout=row layout-align="end center"><a class="nav-link prev" ng-if=$ctrl.prevNode ng-click=$ctrl.goPrevious()><span>Prev</span><div class=icon></div></a><a class="nav-link next" ng-if=$ctrl.nextNode ng-click=$ctrl.goNext()><span>Next</span><div class=icon></div></a></div></md-toolbar><form ng-submit=$ctrl.updateTransaction() novalidate><md-dialog-content flex=flex layout-padding=layout-padding><md-content><h4>Dark blue fields may be editable based on type</h4><div class=section layout=column flex=flex><div class=row flex=flex layout=row><div class="label no-edit" flex=30><span>DATE</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.date | dateDisplay}}</span></div></div><div class=row flex=flex layout=row><div class="label no-edit" flex=30 layout=row layout-align="space-between center"><div class="expand-icon collapsed" ng-if=!$ctrl.details ng-click=$ctrl.toggleDetails()></div><div class="expand-icon expanded" ng-if=$ctrl.details ng-click=$ctrl.toggleDetails()></div><span>AMOUNT</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.amount | currencyDisplayFilter}}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>CURRENCY</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.account.currency }}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>ACCT-PERIOD</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.accountPeriodId }}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>ACCT-ID</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.accountId }}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>BANK NAME</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.account.bank }}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>ACCT-#</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.account.number }}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>ACCT-TYPE</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.account.type | accountTypeDisplay }}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>ACCT-NAME</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.account.name }}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>ENTITY</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.account.entity.name }}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>FILENAME</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.statement.fileName | filenameDisplay }}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>PAGE-#</span></div><div class=field flex=70><a ng-if=$ctrl.editTransaction.statement.downloadUrl href="{{$ctrl.editTransaction.statement.downloadUrl + \'#page=\' + $ctrl.editTransaction.page}}" target=_blank>{{ $ctrl.editTransaction.page }}</a><span ng-if=!$ctrl.editTransaction.statement.downloadUrl>{{ $ctrl.editTransaction.page }}</span></div></div><div class=row flex=flex layout=row ng-if=$ctrl.details><div class="label no-edit" flex=30><span>TXN ID</span></div><div class=field flex=70><span>{{ $ctrl.editTransaction.id }}</span></div></div></div><div class="section edit" layout=column flex=flex><div class=row flex=flex layout=row><div class="label edit" flex=30><span>TXN KIND</span></div><div class="field edit" flex=70><md-select class=flush md-no-ink=md-no-ink aria-label="select type" name=selectedType ng-disabled=!$ctrl.isTransaction ng-model=$ctrl.editTransaction.type><md-option ng-repeat="type in $ctrl.types" ng-value=type>{{ type | transactionTypeDisplay}}</md-option></md-select></div></div><div class=row flex=flex layout=row><div class="label edit" flex=30><span>DESCRIPTION</span></div><div class="field edit" flex=70><input type=text ng-disabled=!$ctrl.isTransaction id=txn_description_edit ng-model=$ctrl.editTransaction.description></div></div><div class=row flex=flex layout=row><div class="label edit" flex=30><span>CHECK NO</span></div><div class="field edit" flex=70><input type=text ng-disabled=!$ctrl.isTransaction onclick=select() ng-model=$ctrl.editTransaction.checkNo></div></div><div class=row flex=flex layout=row><div class="label edit" flex=30><span>NAME</span></div><div class="field edit" flex=70><input type=text ng-disabled=!$ctrl.isTransaction ng-model=$ctrl.editTransaction.name></div></div><div class=row flex=flex layout=row><div class="label edit" flex=30><span>PAYEE</span></div><div class="field edit" flex=70><input type=text ng-disabled=true ng-model=$ctrl.editTransaction.payee></div></div><div class=row flex=flex layout=row><div class="label edit" flex=30><span>PAYOR</span></div><div class="field edit" flex=70><input type=text ng-disabled=true ng-model=$ctrl.editTransaction.payor></div></div><div class=row flex=flex layout=row><div class="label edit" flex=30><span>MEMO</span></div><div class="field edit" flex=70><input type=text ng-disabled=!$ctrl.isTransaction ng-model=$ctrl.editTransaction.memo></div></div><div class=row flex=flex layout=row ng-repeat="cf in $ctrl.customFields"><div class="label edit" flex=30><span>{{ cf.name | uppercase }}</span></div><div class="field edit" flex=70><input type=text ng-model=$ctrl.nodeFields[cf.id].value></div></div><div class=row flex=flex layout=row ng-repeat="cat in $ctrl.categories"><div class="label edit" flex=30><span>{{ cat.name | uppercase }}</span></div><div class="field edit" flex=70><md-select class=flush md-no-ink=md-no-ink aria-label="select label" ng-model=$ctrl.nodeVizCategories[cat.id] ng-model-options="{ trackBy: \'$value.id\'}"><md-option ng-repeat="label in $ctrl.availableLabels[cat.id]" ng-value=label>{{ label.name }}</md-option></md-select></div></div></div></md-content></md-dialog-content><md-dialog-actions style="min-height: 70px;" layout=layout layout-padding=layout-padding layout-align="space-between center"><button class="btn btn-inverted" type=button ng-click=$ctrl.closeEditTransaction()>Cancel</button> <button class="btn btn-inverted" analytics-on=click analytics-event="Save Transaction" ng-disabled=$ctrl.saving type=submit>Update</button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/projects/project/transactions/transaction-detail.html','<md-content><div layout-padding=layout-padding><h2 class=flush>Transaction Detail /<a ui-sref="project.accounts.accountDetail({accountId: $ctrl.transaction.account.id})"> {{ $ctrl.transaction.account.entity.name }} - {{ $ctrl.transaction.account.number }}</a></h2></div><div layout-padding=layout-padding layout=column layout-gt-xs=row><div flex=flex><h3 class=flush-top>Transaction Data</h3><ul class=info-list><li><div class=info-list-title>Destination Account</div><div class=info-list-callout>{{ $ctrl.transaction.id }}</div></li><li><div class=info-list-title>Destination Entity</div><div class=info-list-callout>{{ $ctrl.transaction.account.entity.name }}</div></li><li><div class=info-list-title>Amount</div><div class=info-list-callout>{{ $ctrl.transaction.amount }}</div></li><li><div class=info-list-title>Balance</div><div class=info-list-callout>{{ $ctrl.transaction.attributes.balance | currency }}</div></li></ul></div><div flex=flex><h3 class=flush-top>Source Data</h3><ul class=info-list><li><div class=info-list-title>Upload File Name</div><div class=info-list-callout ng-if=$ctrl.transaction.statement.document.fileName><source-link file-name="{{ $ctrl.transaction.statement.document.fileName }}"></source-link></div><div class=info-list-callout ng-if=!$ctrl.transaction.statement.document.fileName>Plaid Integration</div></li><li><div class=info-list-title>Uploaded On</div><div class=info-list-callout>{{ $ctrl.transaction.statement.document.uploadDate | dateDisplay }}</div></li><li><div class=info-list-title>Uploaded By</div><div class=info-list-callout>{{ $ctrl.transaction.statement.document.uploadUser }}</div></li><li><div class=info-list-title>Encoded On</div><div class=info-list-callout>{{ $ctrl.transaction.statement.document.encodeDate | dateDisplay }}</div></li><li><div class=info-list-title>Verified On</div><div class=info-list-callout>{{ $ctrl.transaction.sourceData.verified | dateDisplay }}</div></li></ul></div></div><md-divider></md-divider><div layout-padding=layout-padding><h2 class=flush>Related transactions</h2><div>No related transactions available.</div></div><div layout-padding=layout-padding><div><button class="btn btn-primary" type=button ng-click=$ctrl.goBack() aria-label=Okay>Okay</button></div></div></md-content>');
$templateCache.put('app/projects/project/transactions/transaction-documents-dialog.html','<md-dialog class=dialog-xxl aria-label="supporting documentation"><dialog-header dialog-title="Supporting documentation"></dialog-header><md-dialog-content layout-padding=layout-padding><md-content><div class=transaction-documents-detail flex=flex><div class="table-row header" flex=flex><div style="width: 60px">Date</div><div style="width: 80px">Amount</div><div style="width: 60px">Check #</div><div style="width: 120px">Description</div><div style="width: 120px">Acct Name</div><div style="width: 80px">Acct Type</div><div style="width: 120px">Filename</div><div style="width: 20px">Page</div></div><div class=table-row flex=flex><div style="width: 60px">{{ $ctrl.transaction.date }}</div><div style="width: 80px; text-align:right">{{ $ctrl.transaction.amount | currencyDisplayFilter:$ctrl.transaction.account.currency }}</div><div style="width: 60px">{{ $ctrl.transaction.checkNo }}</div><div style="width: 120px">{{ $ctrl.transaction.description }}</div><div style="width: 120px">{{ $ctrl.transaction.account.name }}</div><div style="width: 80px">{{ $ctrl.transaction.account.type | accountTypeDisplay }}</div><div style="width: 120px">{{ $ctrl.transaction.statement.fileName | filenameDisplay }}</div><div style="width: 20px">{{ $ctrl.transaction.page }}</div></div></div><div class=transaction-documents flex=flex><div class=doc flex=flex layout=row layout-align="center center" ng-repeat="doc in $ctrl.documents"><div layout-align="center center" flex=5><md-checkbox class=md-custom-background ng-model=doc.selected aria-label=selected></md-checkbox></div><div class=image ng-if=$ctrl.canPreviewImage(doc.mimeType) layout=row flex=85><img ng-src={{doc.downloadUrl}} height=200 width=600></div><div class=file ng-if=!$ctrl.canPreviewImage(doc.mimeType) layout=row flex=85><div layout-align="start center" flex=5><md-icon class="material-icons icon-primary">library_books</md-icon></div><div class=title layout-align="start center">{{ doc.fileName | filenameDisplay }}</div><div class=title layout-align="start center">{{ doc.size | fileSizeDisplay }}</div></div><a class="btn btn-primary" type=button ng-click=$ctrl.downloadDocument(doc.downloadUrl) flex=10>Download</a></div></div></md-content><md-dialog-actions style="min-height: 70px;" layout=layout ng-class="{ \'dialog-actions-lg\': $ctrl.isConfirmRemove }"><div layout=column layout-align="center end"><div class="text-error text-bold section-small" ng-if=$ctrl.isConfirmRemove>Are you sure you want to remove the selected documents?</div><div><button class="btn btn-inverted" type=button ng-click=$ctrl.close()>Cancel</button> <button class="btn btn-warn" type=button ng-click="$ctrl.isConfirmRemove = !$ctrl.isConfirmRemove" ng-hide=$ctrl.isConfirmRemove>Delete</button> <button class="btn btn-warn" type=button ng-click=$ctrl.removeDocuments() ng-show=$ctrl.isConfirmRemove>Confirm</button> <button class="btn btn-primary" type=button ng-hide=$ctrl.isConfirmRemove ng-click=$ctrl.openDocumentUpload()>Upload</button></div></div></md-dialog-actions></md-dialog-content></md-dialog>');
$templateCache.put('app/projects/project/transactions/transaction-filter.html','<div class=section flex=flex layout=layout><div flex=flex layout=column layout-align="end none"><div class=section><div class="text-placeholder section-small">Transaction Range:</div><div class="dropdown-container dropdown-nolist dropdown-inverted text-center text-bold">{{ $ctrl.transactionMetadata.transRangeFloorFilter | currencyDisplayFilter}} - {{ $ctrl.transactionMetadata.transRangeCeilFilter | currencyDisplayFilter }}</div></div><div layout=row layout-align=space-between><div class=text-placeholder>Transactions:</div><div class=text-wrap>{{ $ctrl.transactionMetadata.transCountFilter }}</div></div><div layout=row layout-align=space-between><div class=text-placeholder>Increase:</div><div class=text-wrap>{{ $ctrl.transactionMetadata.transInflowsFilter | currencyDisplayFilter }}</div></div><div layout=row layout-align=space-between><div class=text-placeholder>Decrease:</div><div class=text-wrap>{{ $ctrl.transactionMetadata.transOutflowsFilter | currencyDisplayFilter }}</div></div><div layout=row layout-align=space-between><div class=text-placeholder>Net Cash Flow:</div><div class=text-wrap>{{ $ctrl.transactionMetadata.transNetCashFlowFilter | currencyDisplayFilter }}</div></div></div></div><md-divider class="section side-nav-flush"></md-divider><form name=filterFormTransactions ng-submit=$ctrl.filter() novalidate><div class="text-placeholder section-small">Date Range:</div><div class=section-small><div class=form-group ng-class="{ \'has-error\': $ctrl.startDateError}"><input class="form-control form-group-sml" ng-if=!$ctrl.isReconcile type=date name=filterStartDate ng-model=$ctrl.filterData.startDate ng-disabled=$ctrl.isReadOnly> <input class="form-control form-group-sml" ng-if=$ctrl.isReconcile type=date min={{$ctrl.filterData.minStartDate}} max={{$ctrl.filterData.maxEndDate}} name=filterStartDate ng-model=$ctrl.filterData.startDate ng-disabled=$ctrl.isReadOnly></div><div class=form-group ng-class="{ \'has-error\': $ctrl.endDateError}"><input class=form-control ng-if=!$ctrl.isReconcile type=date name=filterEndDate ng-model=$ctrl.filterData.endDate ng-disabled=$ctrl.isReadOnly> <input class=form-control ng-if=$ctrl.isReconcile type=date min={{$ctrl.filterData.minStartDate}} max={{$ctrl.filterData.maxEndDate}} name=filterEndDate ng-model=$ctrl.filterData.endDate ng-disabled=$ctrl.isReadOnly></div></div><div class=section-small layout=row layout-align=space-between><div class=text-placeholder>Transaction Size:</div><div class=text-wrap><span class=checkbox-label>ABS</span> <input type=checkbox name=transRangeAbs aria-label="Absolute transaction filter" ng-model=$ctrl.filterData.transRangeAbs ng-disabled=$ctrl.isReadOnly></div></div><div class=form-group><input class=form-control type=text format-as-currency=format-as-currency currency-filter="\'currencyInputFilter\'" name=transRangeFloor ng-model=$ctrl.filterData.transRangeLow ng-disabled=$ctrl.isReadOnly></div><div class=form-group><input class=form-control type=text format-as-currency=format-as-currency currency-filter="\'currencyInputFilter\'" name=transRangeCeil ng-model=$ctrl.filterData.transRangeHigh ng-disabled=$ctrl.isReadOnly></div><div class="text-placeholder section-small" ng-if=$ctrl.sourceTypeEnabled>Source:<div class="dropdown-container dropdown-nolist section" ng-if=$ctrl.sourceTypeEnabled layout=row layout-align=space-between><span><input type=radio aria-label=Bank name=sourceType ng-model=$ctrl.filterData.sourceType value=bank ng-disabled=$ctrl.isReadOnly><span class=space-right>Bank</span></span><span> <input type=radio aria-label=ERP name=sourceType ng-model=$ctrl.filterData.sourceType value=erp ng-disabled=$ctrl.isReadOnly><span class=room-right>ERP</span></span><span> <input type=radio aria-label=All name=sourceType ng-model=$ctrl.filterData.sourceType value=all ng-disabled=$ctrl.isReadOnly><span class=space-right>All</span></span></div></div><div class="text-placeholder section-small">Flow:</div><div class="dropdown-container dropdown-nolist section" layout=row layout-align=space-between><span><input type=radio aria-label=All name=flow ng-model=$ctrl.filterData.flow ng-value=null ng-disabled=$ctrl.isReadOnly><span class=space-right>All</span></span><span> <input type=radio aria-label=Increase name=flow ng-model=$ctrl.filterData.flow value=inflows ng-disabled=$ctrl.isReadOnly><span class=space-right>Increase</span></span><span> <input type=radio aria-label=Decrease name=flow ng-model=$ctrl.filterData.flow value=outflows ng-disabled=$ctrl.isReadOnly><span class=room-right>Decrease</span></span></div><div class="text-placeholder section-small" ng-if=!$ctrl.isReconcile>Filters:</div><div class="dropdown-container section-small" ng-if="$ctrl.filterData.entitiesEnabled &amp;&amp; !$ctrl.isReconcile"><div class=dropdown-header ng-click=$ctrl.toggleEntities()><md-icon ng-if=!$ctrl.showEntities>expand_more</md-icon><md-icon ng-if=$ctrl.showEntities>expand_less</md-icon><span>{{ $ctrl.filterData.entities.length }} of {{ $ctrl.entities.length }} Entities</span></div><div class=dropdown-content ng-if=$ctrl.showEntities><div class=dropdown-nolist>Filter by: <input type=checkbox aria-label=check-all ng-checked="$ctrl.checkSelectAll(\'entities\')" ng-click="$ctrl.selectUnselectAll(\'entities\')"><span>All</span></div><div ng-repeat="entity in $ctrl.entities"><input type=checkbox name=entities aria-label=entity ng-checked="$ctrl.isFilterSelected(\'entities\', entity.id)" ng-click="$ctrl.toggleFilter(\'entities\', entity.id)"><span>{{ entity.name }}</span></div></div></div><div class="dropdown-container section-small" ng-if="!$ctrl.filterData.entitiesEnabled &amp;&amp; !$ctrl.isReconcile"><div class=dropdown-header ng-click=$ctrl.toggleAccounts()><md-icon ng-if=!$ctrl.showAccounts>expand_more</md-icon><md-icon ng-if=$ctrl.showAccounts>expand_less</md-icon><span>{{ $ctrl.filterData.accounts.length }} of {{ $ctrl.accounts.length }} Accounts</span></div><div class=dropdown-content ng-if=$ctrl.showAccounts><div class=dropdown-nolist>Filter by: <input type=checkbox aria-label=check-all ng-checked="$ctrl.checkSelectAll(\'accounts\')" ng-click="$ctrl.selectUnselectAll(\'accounts\')"><span>All</span></div><div ng-repeat="account in $ctrl.accounts"><input type=checkbox name=accounts aria-label=account ng-checked="$ctrl.isFilterSelected(\'accounts\', account.id)" ng-click="$ctrl.toggleFilter(\'accounts\', account.id)"><span>{{ account.name }}</span></div></div></div><div class="dropdown-container section-small" ng-if=!$ctrl.isReconcile><div class=dropdown-header ng-click=$ctrl.toggleBankAccountTypes()><md-icon ng-if=!$ctrl.showBankAccountTypes>expand_more</md-icon><md-icon ng-if=$ctrl.showBankAccountTypes>expand_less</md-icon><span>{{ $ctrl.filterData.bankAccountTypes.length }} of {{ $ctrl.bankAccountTypes.length }} Account Types</span></div><div class=dropdown-content ng-if=$ctrl.showBankAccountTypes><div ng-repeat="type in $ctrl.bankAccountTypes"><input type=checkbox name=bankAccountTypes aria-label="account type" ng-checked="$ctrl.isFilterSelected(\'bankAccountTypes\', type)" ng-click="$ctrl.toggleFilter(\'bankAccountTypes\', type)"><span>{{ type | accountTypeDisplay }}</span></div></div></div><div class="dropdown-container section-small" ng-if="$ctrl.type == \'forensic\'"><div class=dropdown-header ng-click=$ctrl.toggleCategories()><md-icon ng-if=!$ctrl.showCategories>expand_more</md-icon><md-icon ng-if=$ctrl.showCategories>expand_less</md-icon><span class=space-right>{{ $ctrl.filterData.categories.length }}</span><span class=space-right ng-if=$ctrl.selectedCategory>of {{ $ctrl.selectedCategory.categoryLabels.length }}</span><span>Vis Labels</span></div><div class=dropdown-content ng-if=$ctrl.showCategories><md-select class="flush section-small" md-no-ink=md-no-ink ng-model-options="{ trackBy: \'$value.id\'}" ng-model=$ctrl.selectedCategory ng-change=$ctrl.clearCategories() placeholder="Select a Category"><md-option ng-repeat="category in $ctrl.availableCategories" ng-value="{{ category }}">{{ category.name }}</md-option></md-select><div class=dropdown-nolist ng-if=$ctrl.selectedCategory>Filter by: <input type=checkbox aria-label=check-all ng-checked="$ctrl.checkSelectAll(\'categories\')" ng-click="$ctrl.selectUnselectAll(\'categories\')"><span>All</span></div><div ng-repeat="label in $ctrl.selectedCategory.categoryLabels"><input type=checkbox name=categories aria-label=category ng-checked="$ctrl.isFilterSelected(\'categories\', label.id)" ng-click="$ctrl.toggleFilter(\'categories\', label.id)"><span>{{ label.name }}</span></div></div></div><div class="dropdown-container section-small" ng-if="$ctrl.type == \'forensic\' &amp;&amp; !$ctrl.isCashFlow"><div class=dropdown-header ng-click=$ctrl.toggleCustomFields()><md-icon ng-if=!$ctrl.showCustomFields>expand_more</md-icon><md-icon ng-if=$ctrl.showCustomFields>expand_less</md-icon><span>Custom Labels</span></div><div class=dropdown-content ng-if=$ctrl.showCustomFields><md-select class="flush section-small" md-no-ink=md-no-ink ng-model=$ctrl.filterData.customField placeholder="Select Column"><md-option ng-repeat="field in $ctrl.customFields" ng-value=field.id>{{ field.name }}</md-option></md-select><input class=form-control type=text name=customFieldLabel ng-focus="$ctrl.filterData.customFieldLabel = \'\'" ng-model=$ctrl.filterData.customFieldLabel ng-disabled=$ctrl.isReadOnly></div></div><div class="dropdown-container dropdown-nolist section-small" ng-if="$ctrl.groupingEnabled &amp;&amp; $ctrl.isCashFlow"><input type=checkbox name=entitiesEnabled aria-label="Enabled Entities" ng-model=$ctrl.filterData.entitiesEnabled><span>Enable Entities</span></div><div class="dropdown-container dropdown-nolist section-small" ng-if="$ctrl.type === \'forensic\'"><input type=checkbox name=unmatched aria-label="remove transfers" ng-model=$ctrl.filterData.unmatched><span>Remove Transfers</span></div><div class=section-small layout=row layout-align=space-between><div class=text-placeholder>Keyword Search:</div><div class=text-wrap><span class=checkbox-label>Name only:</span> <input type=checkbox name=keywordfield aria-label="keyword name only" ng-checked="$ctrl.filterData.keywordField === \'name\'" ng-click=$ctrl.toggleKeywordNameOnly()></div></div><div class=form-group><input class=form-control type=text name=keywordFilter ng-focus="$ctrl.filterData.keyword = \'\'" ng-model=$ctrl.filterData.keyword ng-disabled=$ctrl.isReadOnly></div><div class=form-group><button class="btn btn-primary" type=submit analytics-on=click ng-hide=$ctrl.isReadOnly analytics-event="Apply Transaction Filter">Apply</button> <button class="btn btn-primary" type=button aria-label="clear filter" ng-hide=$ctrl.isReadOnly ng-click=$ctrl.clearFilter()>Clear</button> <button class="btn btn-primary" type=button aria-label="download image" ng-if=$ctrl.isCashFlow ng-click=$ctrl.downloadImage()>Image</button> <button class="btn btn-secondary" type=button aria-label="create adjustment" ng-if=$ctrl.isReconcile ng-hide=$ctrl.isReadOnly ng-disabled="!$ctrl.canSaveAdjustment || $ctrl.isReadOnly" ng-click=$ctrl.openCreateAdjustmentDialog()>Save ADJ</button></div><div class=section-small><img class=cashflow-viz-watermark src=assets/images/valid8-logo.png></div></form>');
$templateCache.put('app/projects/project/transactions/transaction-list-table.html','<messages></messages><div class=settings><button class="btn btn-primary" ng-disabled=!$ctrl.canReconcile ng-if=$ctrl.statement type=button ng-click=$ctrl.reconcile()>Reconciled</button></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/documents/statements/add-check-files.html','<md-dialog class=dialog-lg aria-label=upload><dialog-header dialog-title="Load Check, Deposit Slip Images" hide-default-close=true></dialog-header><md-dialog-content flex=flex><md-content><div class=padding layout=layout flex=flex><div layout=layout flex=flex><div class=form-group layout=column flex=75><h4>Select a pdf file that contains check images. Check items (front/back checks and deposit slips) will be extracted and matched to banking transactions.</h4></div><div class=form-group layout=column layout-align=end flex=25><button class="btn btn-primary" multiple accept=$ctrl.acceptPattern ng-hide=$ctrl.isUploading() ng-disabled="$ctrl.isBrokerageMortgage &amp;&amp; !$ctrl.selectedAccountId" ngf-select="$ctrl.uploadFiles($files, $invalidFiles)" ngf-max-files=100 ngf-pattern=$ctrl.ngUploadPattern ngf-max-size=$ctrl.maxSize>Select Files</button></div></div></div><div class=padding layout=layout flex=flex><ul class=progress-bar><li class="progress-row bar-l" ng-repeat="f in $ctrl.files"><div class=progress flex=flex layout=layout ng-show="f.progress &gt;= 0" style=width:{{f.progress}}%><div class=truncate flex=75><span>{{ f.name }}</span></div><div flex=25><span>{{ f.progress + \'%\'}}</span></div></div></li></ul></div><div class=padding layout=layout flex=flex><ul ng-show="$ctrl.errorFiles.length &gt; 0"><li ng-repeat="f in $ctrl.errorFiles">{{ $ctrl.getFileErrorMessage(f) }}</li></ul></div></md-content></md-dialog-content><md-dialog-actions layout=layout><div><button class="btn btn-inverted" type=button ng-disabled=$ctrl.isUploading() ng-click=$ctrl.cancelUpload()>Cancel</button> <button class="btn btn-primary" type=button ng-disabled="$ctrl.isUploading() || $ctrl.checkFilesPending() || $ctrl.files.length === 0" ng-click=$ctrl.extractCheckFiles()>Start Upload</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/projects/project/documents/statements/add-csv-statement.html','<md-dialog class="dialog-lg dialog-statement-csv" aria-label=upload><dialog-header dialog-title="Add Transaction List (*.csv)" hide-default-close=true></dialog-header><md-dialog-content flex=flex><md-content><div class=padding layout=layout flex=flex><div class=header layout=layout flex=flex><div class=form-group layout=column flex=50><span>Select a CSV file (UTF-8).</span></div><div class=form-group layout=column layout-align="start start" flex=50><button class="btn btn-primary" accept=$ctrl.acceptPattern ng-hide=$ctrl.isUploading() ngf-select="$ctrl.uploadFiles($files, $invalidFiles)" ngf-pattern=$ctrl.ngUploadPattern ngf-max-size=$ctrl.maxSize>Select File</button></div></div></div><div class=padding><span>Transaction Listings must be uploaded using the Valid8 Transaction List Template. For instructions on this process and to download the template use this <a href={{$ctrl.helpLink}} target=blank>link</a>.</span></div><div class=padding><span>Note, if verification fails, transactions will not be added.</span></div><div class=padding layout=layout flex=flex><ul class=progress-bar><li class="progress-row bar-l" ng-repeat="f in $ctrl.files"><div class=progress flex=flex layout=layout ng-show="f.progress &gt;= 0" style=width:{{f.progress}}%><div class=truncate flex=75><span>{{ f.name }}</span></div><div flex=25><span>{{ f.progress + \'%\'}}</span></div></div></li></ul></div><div class=padding><h4>Please enter the required information</h4></div><div class="padding inputs"><div class=form-group flex=flex layout=layout><label class=text-bold flex=25>Account:</label><md-select ng-model=$ctrl.selectedAccountId flex=60><md-option ng-repeat="acc in $ctrl.accounts" ng-value=acc.id>{{ acc | accountSelectFilter }}</md-option></md-select></div><div class=form-group flex=flex layout=layout><label class=text-bold flex=25>Start Date:</label> <input class=form-control type=date name=startDate ng-model=$ctrl.startDate ng-model-options="{timezone: \'utc\'}" required flex=25></div><div class=form-group flex=flex layout=layout><label class=text-bold flex=25>End Date:</label> <input class=form-control type=date name=endDate ng-model=$ctrl.endDate ng-model-options="{timezone: \'utc\'}" required flex=25></div><div class=form-group flex=flex layout=layout><label class=text-bold flex=25>Beginning Balance:</label> <input class=form-control type=text format-as-currency=format-as-currency currency-filter="\'currencyInputFilter\'" ng-model=$ctrl.startBalance required flex=25></div><div class=form-group flex=flex layout=layout><label class=text-bold flex=25>Ending Balance:</label> <input class=form-control type=text format-as-currency=format-as-currency currency-filter="\'currencyInputFilter\'" ng-model=$ctrl.endBalance required flex=25></div></div><div class=padding layout=layout flex=flex><ul ng-show="$ctrl.errorFiles.length &gt; 0"><li ng-repeat="f in $ctrl.errorFiles">{{ $ctrl.getFileErrorMessage(f) }}</li></ul></div></md-content></md-dialog-content><md-dialog-actions layout=layout><div><button class="btn btn-inverted" type=button ng-disabled=$ctrl.isUploading() ng-click=$ctrl.cancelUpload()>Cancel</button> <button class="btn btn-primary" type=button ng-disabled="$ctrl.isUploading() || $ctrl.files.length === 0 || !$ctrl.validPeriodData()" ng-click=$ctrl.extractStatements()>Start Upload</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/projects/project/documents/statements/add-statements.html','<md-dialog class=dialog-lg aria-label=upload><dialog-header dialog-title="Add Statements" hide-default-close=true></dialog-header><md-dialog-content flex=flex><md-content><div class="section padding" ng-if="$ctrl.isBrokerageMortgage &amp;&amp; $ctrl.accounts.length &lt;= 0"><h4>Please create a mortgage or brokerage account first.</h4></div><div class="section padding" ng-if="$ctrl.isBrokerageMortgage &amp;&amp; $ctrl.accounts.length &gt; 0"><h4>For brokerage or mortgage, an account must be selected first</h4><div><input class=search ng-model=searchText flex=60 placeholder=Filter...><md-select ng-model=$ctrl.selectedAccountId flex=60><md-option ng-repeat="acc in $ctrl.accounts | filter:searchText" ng-value=acc.id>{{ acc | accountSelectFilter }}</md-option></md-select></div></div><div class=padding layout=layout flex=flex><div layout=layout flex=flex><div class=form-group layout=column flex=75><h4>{{ $ctrl.info }}</h4></div><div class=form-group layout=column layout-align=end flex=25><button class="btn btn-primary" multiple accept=$ctrl.acceptPattern ng-hide=$ctrl.isUploading() ng-disabled="$ctrl.isBrokerageMortgage &amp;&amp; !$ctrl.selectedAccountId" ngf-select="$ctrl.uploadFiles($files, $invalidFiles)" ngf-max-files=100 ngf-pattern=$ctrl.ngUploadPattern ngf-max-size=$ctrl.maxSize>Select Files</button></div></div></div><div class=padding layout=layout flex=flex><ul class=progress-bar><li class="progress-row bar-l" ng-repeat="f in $ctrl.files"><div class=progress flex=flex layout=layout ng-show="f.progress &gt;= 0" style=width:{{f.progress}}%><div class=truncate flex=75><span>{{ f.name }}</span></div><div flex=25><span>{{ f.progress + \'%\'}}</span></div></div></li></ul></div><div class=padding layout=layout flex=flex><ul ng-show="$ctrl.errorFiles.length &gt; 0"><li ng-repeat="f in $ctrl.errorFiles">{{ $ctrl.getFileErrorMessage(f) }}</li></ul></div></md-content></md-dialog-content><md-dialog-actions layout=layout><div><button class="btn btn-inverted" type=button ng-disabled=$ctrl.isUploading() ng-click=$ctrl.cancelUpload()>Cancel</button> <button class="btn btn-primary" type=button ng-disabled="$ctrl.isUploading() || $ctrl.statementsPending() || $ctrl.files.length === 0 || ($ctrl.isBrokerageMortgage &amp;&amp; !$ctrl.selectedAccountId)" ng-click=$ctrl.extractStatements()>Start Extraction</button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/projects/project/documents/statements/delete-statements-dialog.html','<md-dialog class=dialog-lg><dialog-header dialog-title="Delete Statements"></dialog-header><div flex=flex layout=column layout-padding=layout-padding><md-dialog-content flex=flex><h2>Are you sure you want to delete {{$ctrl.descriptionCounter}}?</h2></md-dialog-content><md-dialog-actions layout=row><div><button class="btn btn-inverted room-right" type=button ng-click=$ctrl.cancel()>Cancel</button> <button class="btn btn-warn" type=button ng-click=$ctrl.deleteStatements()>Delete</button></div></md-dialog-actions></div></md-dialog>');
$templateCache.put('app/projects/project/documents/statements/load-statement.html','<button class=action-button type=button analytics-on=click ng-disabled=!$ctrl.hasPermissions ng-click=$ctrl.load()><md-tooltip>Upload</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_upload</md-icon></button>');
$templateCache.put('app/projects/project/documents/statements/statements-list.html','<div class=load-bar layout=layout><div class=room-right flex=flex layout=layout layout-align="start start"><div class=statements-menu flex=none layout=layout layout-align="start start"><button class=action-button ng-if=$ctrl.hasPermissions type=button ng-click=$ctrl.expandCollapse()><md-tooltip>Expand/Collapse</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>unfold_less</md-icon></button> <button class=action-button ng-if=$ctrl.hasPermissions type=button ng-click=$ctrl.selectAll()><md-tooltip>Select all</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>select_all</md-icon></button><load-statement type={{$ctrl.type}} source={{$ctrl.source}}></load-statement><button class=action-button type=button ng-click=$ctrl.exportToCsv()><md-tooltip>Export CSV</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>file_download</md-icon></button><check-item-actions ng-if=$ctrl.hasPermissions selected-check-items=$ctrl.selectedCheckItems grid-options=$ctrl.gridOptions categories=$ctrl.categories custom-fields=$ctrl.customFields on-category-update=$ctrl.onCategoryUpdate() on-save=$ctrl.itemsUpdated(isRefreshRequired)></check-item-actions><div class=chevron-nav flex=flex layout=row layout-align="start start"><div class=chevron-section ng-if="$ctrl.source === \'checks_pdf\'"><ul><li class=rejected ng-class="{ \'active\': $ctrl.status === \'rejected\' }"><a ng-click="$ctrl.toFileTab(\'rejected\')"><span>Rejected</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].rejected}}</span></a></li><li class=extracting ng-class="{ \'active\': $ctrl.status === \'extracting\' }"><a ng-click="$ctrl.toFileTab(\'extracting\')"><span>Extracting</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].extracting}}</span></a></li></ul><div class=all-files flex=flex layout=row layout-align="center center" ng-class="{ \'active\': $ctrl.status === \'all-files\' }"><a ng-click="$ctrl.toFileTab(\'all-files\')">FILES ({{$ctrl.statusInfo[$ctrl.source].total}})</a></div></div><div class=chevron-section ng-if="$ctrl.source === \'checks_pdf\'"><ul><li class=unmatched ng-class="{ \'active\': $ctrl.status === \'unmatched\' }"><a ng-click="$ctrl.toItemTab(\'unmatched\')"><span>Unmatched</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].checkItems.unmatched}}</span></a></li><li class=unreconciled ng-class="{ \'active\': $ctrl.status === \'unreconciled\' }"><a ng-click="$ctrl.toItemTab(\'unreconciled\')"><span>Review</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].checkItems.unreconciled}}</span></a></li></ul><div class=all-check-items flex=flex layout=row layout-align="center center" ng-class="{ \'active\': $ctrl.status === \'unmatched\' || $ctrl.status === \'unreconciled\' }"><a ng-click="$ctrl.toItemTab(\'unmatched\')">ITEMS ({{$ctrl.statusInfo[$ctrl.source].checkItems.unmatched + $ctrl.statusInfo[$ctrl.source].checkItems.unreconciled }})</a></div></div><div class=chevron-section ng-if="$ctrl.source === \'checks_pdf\'"><ul><li class=reconciled ng-class="{ \'active\': $ctrl.status === \'reconciled\' }"><a ng-click="$ctrl.toItemTab(\'reconciled\')"><span>Ready</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].checkItems.reconciled}}</span></a></li></ul><div class=all-check-item-transactions flex=flex layout=row layout-align="center center" ng-class="{ \'active\': $ctrl.status === \'reconciled\'}"><a ng-click="$ctrl.toItemTab(\'reconciled\')" ng-if="$ctrl.source === \'checks_pdf\'">BANK TRANSACTIONS ({{$ctrl.statusInfo[$ctrl.source].checkItems.reconciled }})</a></div></div><div class=chevron-section ng-if="$ctrl.source !== \'checks_pdf\'"><ul><li class=rejected ng-class="{ \'active\': $ctrl.status === \'rejected\' }"><a ng-click="$ctrl.toFileTab(\'rejected\')"><span>Rejected</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].rejected}}</span></a></li><li class=extracting ng-class="{ \'active\': $ctrl.status === \'extracting\' }"><a ng-click="$ctrl.toFileTab(\'extracting\')"><span>Extracting</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].extracting}}</span></a></li></ul><div class=all-files flex=flex layout=row layout-align="center center" ng-class="{ \'active\': $ctrl.status === \'all-files\' }"><a ng-click="$ctrl.toFileTab(\'all-files\')">FILES ({{$ctrl.statusInfo[$ctrl.source].total}})</a></div></div><div class=chevron-section ng-if="$ctrl.source !== \'checks_pdf\'"><ul><li class=unassigned ng-if="$ctrl.source !== \'txn_csv\' &amp;&amp; $ctrl.source !== \'checks_pdf\'"><a ng-click="$ctrl.toItemTab(\'unassigned\')"><span>Unassigned</span><span class=rectangle>{{$ctrl.statusInfo[$ctrl.source].periods.unassigned}}</span></a></li><li class=unreconciled><a ng-click="$ctrl.toItemTab(\'unreconciled\')"><span>Unreconciled</span><span class=rectangle ng-if="$ctrl.source !== \'checks_pdf\'">{{$ctrl.statusInfo[$ctrl.source].periods.unreconciled}}</span><span class=rectangle ng-if="$ctrl.source === \'checks_pdf\'">{{$ctrl.statusInfo[$ctrl.source].checkItems.unreconciled}}</span></a></li><li class=reconciled><a ng-click="$ctrl.toItemTab(\'reconciled\')"><span>Ready</span><span class=rectangle ng-if="$ctrl.source !== \'checks_pdf\'">{{$ctrl.statusInfo[$ctrl.source].periods.reconciled}}</span><span class=rectangle ng-if="$ctrl.source === \'checks_pdf\'">{{$ctrl.statusInfo[$ctrl.source].checkItems.reconciled}}</span></a></li></ul><div class=all-items flex=flex layout=row layout-align="center center"><a ng-click="$ctrl.toItemTab(\'all-items\')" ng-if="$ctrl.source !== \'checks_pdf\'">ACCOUNT PERIODS ({{$ctrl.statusInfo[$ctrl.source].periods.total}})</a><a ng-click="$ctrl.toItemTab(\'all-items\')" ng-if="$ctrl.source === \'checks_pdf\'">BANK TRANSACTIONS ({{$ctrl.statusInfo[$ctrl.source].checkItems.reconciled + $ctrl.statusInfo[$ctrl.source].checkItems.unreconciled}})</a></div></div></div></div><div class=md-filter flex=flex><table-filter grid-options=$ctrl.gridOptions></table-filter></div><button class="btn btn-inverted load-tool-btn" ng-if="$ctrl.status == \'rejected\'" type=button ng-disabled="!$ctrl.selectedStatements.length || !$ctrl.hasPermissions" ng-click=$ctrl.deleteStatements()><md-tooltip>Delete</md-tooltip><md-icon class=icon-primary md-menu-origin=md-menu-origin>delete</md-icon></button></div></div><div class="table-height-full ag-theme-material" ag-grid=$ctrl.gridOptions></div>');
$templateCache.put('app/projects/project/documents/statements/statements.html','<md-content><messages></messages><div layout-padding=layout-padding><h2 class=flush>{{ $ctrl.title }}</h2><statements-list-table flex=flex statements=$ctrl.statements status-info=$ctrl.statusInfo type={{$ctrl.projectType}}></statements-list-table></div></md-content>');}]);